/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "uXl7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+HRN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Buffer = __webpack_require__("X3l8").Buffer;
var util = __webpack_require__(1);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "+W7P":
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__("Csua");

var Object_keys = function Object_keys(obj) {
    if (Object.keys) return Object.keys(obj);else {
        var res = [];
        for (var key in obj) {
            res.push(key);
        }return res;
    }
};

var forEach = function forEach(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = function () {
    try {
        Object.defineProperty({}, '_', {});
        return function (obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function (obj, name, value) {
            obj[name] = value;
        };
    }
}();

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function', 'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError', 'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError', 'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape', 'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }

    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';

    document.body.appendChild(iframe);

    var win = iframe.contentWindow;
    var wEval = win.eval,
        wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }

    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });

    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);

    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });

    document.body.removeChild(iframe);

    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if (typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};

/***/ }),

/***/ "+e0g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("3PYz");
var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__("RzOE");
var Signature = __webpack_require__("hkfz");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA)) return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++) {
    hash.update(arguments[i]);
  }return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature) return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

/***/ }),

/***/ "+jDU":
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__("/y0r");
var Buffer = __webpack_require__("X3l8").Buffer;
var MODES = __webpack_require__("BCiZ");
var StreamCipher = __webpack_require__("6hW9");
var Transform = __webpack_require__("z+8S");
var aes = __webpack_require__("BEbT");
var ebtk = __webpack_require__("Cgw8");
var inherits = __webpack_require__("LC74");

function Decipher(mode, key, iv) {
  Transform.call(this);

  this._cache = new Splitter();
  this._last = void 0;
  this._cipher = new aes.AES(key);
  this._prev = Buffer.from(iv);
  this._mode = mode;
  this._autopadding = true;
}

inherits(Decipher, Transform);

Decipher.prototype._update = function (data) {
  this._cache.add(data);
  var chunk;
  var thing;
  var out = [];
  while (chunk = this._cache.get(this._autopadding)) {
    thing = this._mode.decrypt(this, chunk);
    out.push(thing);
  }
  return Buffer.concat(out);
};

Decipher.prototype._final = function () {
  var chunk = this._cache.flush();
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk));
  } else if (chunk) {
    throw new Error('data not multiple of block length');
  }
};

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo;
  return this;
};

function Splitter() {
  this.cache = Buffer.allocUnsafe(0);
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data]);
};

Splitter.prototype.get = function (autoPadding) {
  var out;
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16);
      this.cache = this.cache.slice(16);
      return out;
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16);
      this.cache = this.cache.slice(16);
      return out;
    }
  }

  return null;
};

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache;
};

function unpad(last) {
  var padded = last[15];
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data');
  }
  var i = -1;
  while (++i < padded) {
    if (last[i + (16 - padded)] !== padded) {
      throw new Error('unable to decrypt data');
    }
  }
  if (padded === 16) return;

  return last.slice(0, 16 - padded);
}

function createDecipheriv(suite, password, iv) {
  var config = MODES[suite.toLowerCase()];
  if (!config) throw new TypeError('invalid suite type');

  if (typeof iv === 'string') iv = Buffer.from(iv);
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);

  if (typeof password === 'string') password = Buffer.from(password);
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true);
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true);
  }

  return new Decipher(config.module, password, iv);
}

function createDecipher(suite, password) {
  var config = MODES[suite.toLowerCase()];
  if (!config) throw new TypeError('invalid suite type');

  var keys = ebtk(password, false, config.key, config.iv);
  return createDecipheriv(suite, keys.key, keys.iv);
}

exports.createDecipher = createDecipher;
exports.createDecipheriv = createDecipheriv;

/***/ }),

/***/ "/MLu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cSWu").PassThrough;

/***/ }),

/***/ "/vd3":
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__("GUE9");
exports.pbkdf2Sync = __webpack_require__("Zq1s");

/***/ }),

/***/ "/y0r":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("BEbT");
var Buffer = __webpack_require__("X3l8").Buffer;
var Transform = __webpack_require__("z+8S");
var inherits = __webpack_require__("LC74");
var GHASH = __webpack_require__("UPHp");
var xor = __webpack_require__("H2Pp");
var incr32 = __webpack_require__("4sPJ");

function xorTest(a, b) {
  var out = 0;
  if (a.length !== b.length) out++;

  var len = Math.min(a.length, b.length);
  for (var i = 0; i < len; ++i) {
    out += a[i] ^ b[i];
  }

  return out;
}

function calcIv(self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])]);
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])]);
  }
  var ghash = new GHASH(ck);
  var len = iv.length;
  var toPad = len % 16;
  ghash.update(iv);
  if (toPad) {
    toPad = 16 - toPad;
    ghash.update(Buffer.alloc(toPad, 0));
  }
  ghash.update(Buffer.alloc(8, 0));
  var ivBits = len * 8;
  var tail = Buffer.alloc(8);
  tail.writeUIntBE(ivBits, 0, 8);
  ghash.update(tail);
  self._finID = ghash.state;
  var out = Buffer.from(self._finID);
  incr32(out);
  return out;
}
function StreamCipher(mode, key, iv, decrypt) {
  Transform.call(this);

  var h = Buffer.alloc(4, 0);

  this._cipher = new aes.AES(key);
  var ck = this._cipher.encryptBlock(h);
  this._ghash = new GHASH(ck);
  iv = calcIv(this, iv, ck);

  this._prev = Buffer.from(iv);
  this._cache = Buffer.allocUnsafe(0);
  this._secCache = Buffer.allocUnsafe(0);
  this._decrypt = decrypt;
  this._alen = 0;
  this._len = 0;
  this._mode = mode;

  this._authTag = null;
  this._called = false;
}

inherits(StreamCipher, Transform);

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - this._alen % 16;
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0);
      this._ghash.update(rump);
    }
  }

  this._called = true;
  var out = this._mode.encrypt(this, chunk);
  if (this._decrypt) {
    this._ghash.update(chunk);
  } else {
    this._ghash.update(out);
  }
  this._len += chunk.length;
  return out;
};

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');

  this._authTag = tag;
  this._cipher.scrub();
};

StreamCipher.prototype.getAuthTag = function getAuthTag() {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');

  return this._authTag;
};

StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');

  this._authTag = tag;
};

StreamCipher.prototype.setAAD = function setAAD(buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state');

  this._ghash.update(buf);
  this._alen += buf.length;
};

module.exports = StreamCipher;

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "08Lv":
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val) throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "16On":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null) state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function (elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial) throw err;

  if (!inherited) state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial) return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace) Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

/***/ }),

/***/ "19bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__("KDHK");

exports.certificate = __webpack_require__("lQBd");

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(this.key('version').int(), this.key('modulus').int(), this.key('publicExponent').int(), this.key('privateExponent').int(), this.key('prime1').int(), this.key('prime2').int(), this.key('exponent1').int(), this.key('exponent2').int(), this.key('coefficient').int());
});
exports.RSAPrivateKey = RSAPrivateKey;

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(this.key('modulus').int(), this.key('publicExponent').int());
});
exports.RSAPublicKey = RSAPublicKey;

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
exports.PublicKey = PublicKey;

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p').int(), this.key('q').int(), this.key('g').int()).optional());
});

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(this.key('version').int(), this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters').int())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(this.key('version').int(), this.key('p').int(), this.key('q').int(), this.key('g').int(), this.key('pub_key').int(), this.key('priv_key').int());
});
exports.DSAPrivateKey = DSAPrivateKey;

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int();
});

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(this.key('version').int(), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use(ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
exports.ECPrivateKey = ECPrivateKey;

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  });
});

exports.signature = asn1.define('signature', function () {
  this.seq().obj(this.key('r').int(), this.key('s').int());
});

/***/ }),

/***/ "1lLf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg)) return msg.slice();
  if (!msg) return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = c >> 6 | 192;
          res[p++] = c & 63 | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = c >> 18 | 240;
          res[p++] = c >> 12 & 63 | 128;
          res[p++] = c >> 6 & 63 | 128;
          res[p++] = c & 63 | 128;
        } else {
          res[p++] = c >> 12 | 224;
          res[p++] = c >> 6 & 63 | 128;
          res[p++] = c & 63 | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0) msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2) {
        res.push(parseInt(msg[i] + msg[i + 1], 16));
      }
    }
  } else {
    for (i = 0; i < msg.length; i++) {
      res[i] = msg[i] | 0;
    }
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    res += zero2(msg[i].toString(16));
  }return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little') w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1) return '0' + word;else return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7) return '0' + word;else if (word.length === 6) return '00' + word;else if (word.length === 5) return '000' + word;else if (word.length === 4) return '0000' + word;else if (word.length === 3) return '00000' + word;else if (word.length === 2) return '000000' + word;else if (word.length === 1) return '0000000' + word;else return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = m >>> 16 & 0xff;
      res[k + 2] = m >>> 8 & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = m >>> 16 & 0xff;
      res[k + 1] = m >>> 8 & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return a + b >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = al + bl >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = al + bl >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = lo + bl >>> 0;
  carry += lo < al ? 1 : 0;
  lo = lo + cl >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = lo + dl >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = lo + bl >>> 0;
  carry += lo < al ? 1 : 0;
  lo = lo + cl >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = lo + dl >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = lo + el >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = al << 32 - num | ah >>> num;
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = ah << 32 - num | al >>> num;
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = ah << 32 - num | al >>> num;
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "24Y6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__("tRuz");
var elliptic = __webpack_require__("lZ6o");
var BN = __webpack_require__("geuY");
var inherits = __webpack_require__("LC74");
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA) return num.redNeg();else return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC) return num;else return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red) x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd) y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red) y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd) throw new Error('invalid point');else return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd) x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity()) return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity()) return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity()) return this;

  // Double in extended coordinates
  if (this.curve.extended) return this._extDbl();else return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity()) return p;
  if (p.isInfinity()) return this;

  if (this.curve.extended) return this._extAdd(p);else return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);else return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne) return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t) this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0) return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0) return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0) return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

/***/ }),

/***/ "2JY6":
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs

function checkBuffer(buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string');
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password');
  checkBuffer(salt, 'Salt');

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number');
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations');
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number');
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) {
    /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length');
  }
};

/***/ }),

/***/ "2qEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export setBackend */
/* unused harmony export getBackend */
/* unused harmony export disposeVariables */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return memory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return nextFrame; });
/* unused harmony export environment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return io; });
/* unused harmony export math */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return serialization; });
/* unused harmony export test_util */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return util; });
/* unused harmony export webgl */
/* unused harmony export enableProdMode */
/* unused harmony export AdadeltaOptimizer */
/* unused harmony export AdagradOptimizer */
/* unused harmony export AdamOptimizer */
/* unused harmony export AdamaxOptimizer */
/* unused harmony export MomentumOptimizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Optimizer; });
/* unused harmony export RMSPropOptimizer */
/* unused harmony export SGDOptimizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Tensor; });
/* unused harmony export TensorBuffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return variable; });
/* unused harmony export Variable */
/* unused harmony export Rank */
/* unused harmony export Reduction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENV; });
/* unused harmony export Environment */
/* unused harmony export KernelBackend */
/* unused harmony export DataStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return image_ops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return linalg_ops; });
/* unused harmony export losses */
/* unused harmony export spectral */
/* unused harmony export op */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return batchNormalization2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return batchNormalization3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return batchNormalization4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return batchNormalization; });
/* unused harmony export complex */
/* unused harmony export real */
/* unused harmony export imag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return concat1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return concat2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return concat3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return concat4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return split$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return conv1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return conv2d; });
/* unused harmony export conv3d */
/* unused harmony export conv2dDerFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return depthwiseConv2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return separableConv2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return conv2dTranspose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return matMul; });
/* unused harmony export dot */
/* unused harmony export outerProduct */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return reverse; });
/* unused harmony export reverse1d */
/* unused harmony export reverse2d */
/* unused harmony export reverse3d */
/* unused harmony export reverse4d */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return maxPool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return avgPool; });
/* unused harmony export pool */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return slice1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return slice2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return slice3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return slice4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return acos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return acosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return asin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return asinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return atanh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return clipByValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return cosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return erf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return exp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return expm1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return floor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return log$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return log1p; });
/* unused harmony export logSigmoid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return neg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return reciprocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return round; });
/* unused harmony export rsqrt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return sigmoid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return sinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return softplus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return square; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return step; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return tan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return tanh$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return any; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return argMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return argMin; });
/* unused harmony export logSumExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return mean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return moments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return sum$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return prod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return equal; });
/* unused harmony export equalStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return greater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return greaterEqual; });
/* unused harmony export greaterEqualStrict */
/* unused harmony export greaterStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return less; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return lessEqual; });
/* unused harmony export lessEqualStrict */
/* unused harmony export lessStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return notEqual; });
/* unused harmony export notEqualStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addN; });
/* unused harmony export addStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return div; });
/* unused harmony export divStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return floorDiv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return maximum; });
/* unused harmony export maximumStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return minimum; });
/* unused harmony export minimumStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return mod; });
/* unused harmony export modStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return mul; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return mulStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return pow; });
/* unused harmony export powStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return squaredDifference; });
/* unused harmony export squaredDifferenceStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return sub; });
/* unused harmony export subStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return elu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return leakyRelu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return prelu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return relu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return selu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return logicalAnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return logicalNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return logicalOr; });
/* unused harmony export logicalXor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return where; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return whereAsync; });
/* unused harmony export buffer */
/* unused harmony export toPixels */
/* unused harmony export print */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return batchToSpaceND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return cast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return clone; });
/* unused harmony export cumsum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return depthToSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return expandDims; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return eye; });
/* unused harmony export fromPixels */
/* unused harmony export multinomial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return oneHot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return pad; });
/* unused harmony export pad1d */
/* unused harmony export pad2d */
/* unused harmony export pad3d */
/* unused harmony export pad4d */
/* unused harmony export rand */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return randomNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return randomUniform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return reshape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return spaceToBatchND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return squeeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return stack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return tile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return truncatedNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return unstack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return setdiff1dAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return linspace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return ones$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return scalar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return tensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return tensor1d; });
/* unused harmony export tensor2d */
/* unused harmony export tensor3d */
/* unused harmony export tensor4d */
/* unused harmony export tensor5d */
/* unused harmony export tensor6d */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return zeros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return onesLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return zerosLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return transpose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return softmax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return logSoftmax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return localResponseNormalization; });
/* unused harmony export norm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return gather; });
/* unused harmony export unsortedSegmentSum */
/* unused harmony export basicLSTMCell */
/* unused harmony export multiRNNCell */
/* unused harmony export movingAverage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return stridedSlice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return topk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return scatterND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return fft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return ifft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return rfft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return irfft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return sparseToDense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return gatherND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return train; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return tidy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return keep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return dispose; });
/* unused harmony export time */
/* unused harmony export profile */
/* unused harmony export customGrad */
/* unused harmony export grad */
/* unused harmony export grads */
/* unused harmony export valueAndGrad */
/* unused harmony export valueAndGrads */
/* unused harmony export variableGrads */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
  e.__proto__ = t;
} || function (e, t) {
  for (var n in t) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }
};function __extends(e, t) {
  function n() {
    this.constructor = e;
  }extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}var __assign = Object.assign || function (e) {
  for (var t, n = 1, r = arguments.length; n < r; n++) {
    for (var o in t = arguments[n]) {
      Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
  }return e;
};function __awaiter(e, t, n, r) {
  return new (n || (n = Promise))(function (o, a) {
    function i(e) {
      try {
        u(r.next(e));
      } catch (e) {
        a(e);
      }
    }function s(e) {
      try {
        u(r.throw(e));
      } catch (e) {
        a(e);
      }
    }function u(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(i, s);
    }u((r = r.apply(e, t || [])).next());
  });
}function __generator(e, t) {
  var n,
      r,
      o,
      a,
      i = { label: 0, sent: function sent() {
      if (1 & o[0]) throw o[1];return o[1];
    }, trys: [], ops: [] };return a = { next: s(0), throw: s(1), return: s(2) }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;function s(a) {
    return function (s) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");for (; i;) {
          try {
            if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {case 0:case 1:
                o = a;break;case 4:
                return i.label++, { value: a[1], done: !1 };case 5:
                i.label++, r = a[1], a = [0];continue;case 7:
                a = i.ops.pop(), i.trys.pop();continue;default:
                if (!(o = (o = i.trys).length > 0 && o[o.length - 1]) && (6 === a[0] || 2 === a[0])) {
                  i = 0;continue;
                }if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                  i.label = a[1];break;
                }if (6 === a[0] && i.label < o[1]) {
                  i.label = o[1], o = a;break;
                }if (o && i.label < o[2]) {
                  i.label = o[2], i.ops.push(a);break;
                }o[2] && i.ops.pop(), i.trys.pop();continue;}a = t.call(e, i);
          } catch (e) {
            a = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }if (5 & a[0]) throw a[1];return { value: a[0] ? a[1] : void 0, done: !0 };
      }([a, s]);
    };
  }
}var contexts = {},
    WEBGL_ATTRIBUTES = { alpha: !1, antialias: !1, premultipliedAlpha: !1, preserveDrawingBuffer: !1, depth: !1, stencil: !1, failIfMajorPerformanceCaveat: !0 };function getWebGLContext(e) {
  e in contexts || (document.createElement("canvas").addEventListener("webglcontextlost", function (t) {
    t.preventDefault(), delete contexts[e];
  }, !1), contexts[e] = getWebGLRenderingContext(e));var t = contexts[e];return t.isContextLost() ? (delete contexts[e], getWebGLContext(e)) : (t.disable(t.DEPTH_TEST), t.disable(t.STENCIL_TEST), t.disable(t.BLEND), t.disable(t.DITHER), t.disable(t.POLYGON_OFFSET_FILL), t.disable(t.SAMPLE_COVERAGE), t.enable(t.SCISSOR_TEST), t.enable(t.CULL_FACE), t.cullFace(t.BACK), contexts[e]);
}function getWebGLRenderingContext(e) {
  if (1 !== e && 2 !== e) throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");var t = document.createElement("canvas");return 1 === e ? t.getContext("webgl", WEBGL_ATTRIBUTES) || t.getContext("experimental-webgl", WEBGL_ATTRIBUTES) : t.getContext("webgl2", WEBGL_ATTRIBUTES);
}function isMobile() {
  var e = navigator.userAgent || navigator.vendor || window.opera;return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))
  );
}function shuffle(e) {
  for (var t = e.length, n = 0, r = 0; t > 0;) {
    r = Math.random() * t | 0, n = e[--t], e[t] = e[r], e[r] = n;
  }
}function clamp(e, t, n) {
  return Math.max(e, Math.min(t, n));
}function nearestLargerEven(e) {
  return e % 2 == 0 ? e : e + 1;
}function sum(e) {
  for (var t = 0, n = 0; n < e.length; n++) {
    t += e[n];
  }return t;
}function randUniform(e, t) {
  var n = Math.random();return t * n + (1 - n) * e;
}function distSquared(e, t) {
  for (var n = 0, r = 0; r < e.length; r++) {
    var o = Number(e[r]) - Number(t[r]);n += o * o;
  }return n;
}function assert(e, t) {
  if (!e) throw new Error("string" == typeof t ? t : t());
}function assertShapesMatch(e, t, n) {
  void 0 === n && (n = ""), assert(arraysEqual(e, t), n + " Shapes " + e + " and " + t + " must match");
}function assertNonNull(e) {
  assert(null != e, "The input to the tensor constructor must be a non-null value.");
}function flatten(e, t) {
  if (void 0 === t && (t = []), Array.isArray(e) || isTypedArray(e)) for (var n = 0; n < e.length; ++n) {
    flatten(e[n], t);
  } else t.push(e);return t;
}function sizeFromShape(e) {
  if (0 === e.length) return 1;for (var t = e[0], n = 1; n < e.length; n++) {
    t *= e[n];
  }return t;
}function isScalarShape(e) {
  return 0 === e.length;
}function arraysEqual(e, t) {
  if (e === t) return !0;if (null == e || null == t) return !1;if (e.length !== t.length) return !1;for (var n = 0; n < e.length; n++) {
    if (e[n] !== t[n]) return !1;
  }return !0;
}function isInt(e) {
  return e % 1 == 0;
}function tanh(e) {
  if (null != Math.tanh) return Math.tanh(e);if (e === 1 / 0) return 1;if (e === -1 / 0) return -1;var t = Math.exp(2 * e);return (t - 1) / (t + 1);
}function sizeToSquarishShape(e) {
  for (var t = Math.floor(Math.sqrt(e)); t > 1; --t) {
    if (e % t == 0) return [t, e / t];
  }return [1, e];
}function createShuffledIndices(e) {
  for (var t = new Uint32Array(e), n = 0; n < e; ++n) {
    t[n] = n;
  }return shuffle(t), t;
}function rightPad(e, t) {
  return t <= e.length ? e : e + " ".repeat(t - e.length);
}function repeatedTry(e, t, n) {
  return void 0 === t && (t = function t(e) {
    return 0;
  }), new Promise(function (r, o) {
    var a = 0,
        i = function i() {
      if (e()) r();else {
        var s = t(++a);null != n && a >= n ? o() : setTimeout(i, s);
      }
    };i();
  });
}function inferFromImplicitShape(e, t) {
  for (var n = 1, r = -1, o = 0; o < e.length; ++o) {
    if (e[o] >= 0) n *= e[o];else if (-1 === e[o]) {
      if (-1 !== r) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + r + " and dim " + o);r = o;
    } else if (e[o] < 0) throw Error("Shapes can not be < 0. Found " + e[o] + " at dim " + o);
  }if (-1 === r) {
    if (t > 0 && t !== n) throw Error("Size(" + t + ") must match the product of shape " + e);return e;
  }if (0 === n) throw Error("Cannot infer the missing size in [" + e + "] when there are 0 elements");if (t % n != 0) throw Error("The implicit shape can't be a fractional number. Got " + t + " / " + n);var a = e.slice();return a[r] = t / n, a;
}function parseAxisParam(e, t) {
  var n = t.length;return assert((e = null == e ? t.map(function (e, t) {
    return t;
  }) : [].concat(e)).every(function (e) {
    return e >= -n && e < n;
  }), "All values in axis param must be in range [-" + n + ", " + n + ") but got axis " + e), assert(e.every(function (e) {
    return isInt(e);
  }), "All values in axis param must be integers but got axis " + e), e.map(function (e) {
    return e < 0 ? n + e : e;
  });
}function squeezeShape(e, t) {
  for (var n = [], r = [], o = null == t ? null : parseAxisParam(t, e).sort(), a = 0, i = 0; i < e.length; ++i) {
    if (null != o) {
      if (o[a] === i && 1 !== e[i]) throw new Error("Can't squeeze axis " + i + " since its dim '" + e[i] + "' is not 1");(null == o[a] || o[a] > i) && 1 === e[i] && (n.push(e[i]), r.push(i)), o[a] <= i && a++;
    }1 !== e[i] && (n.push(e[i]), r.push(i));
  }return { newShape: n, keptDims: r };
}function getTypedArrayFromDType(e, t) {
  var n = null;if (null == e || "float32" === e) n = new Float32Array(t);else if ("int32" === e) n = new Int32Array(t);else {
    if ("bool" !== e) throw new Error("Unknown data type " + e);n = new Uint8Array(t);
  }return n;
}function getArrayFromDType(e, t) {
  var n = null;if (null == e || "float32" === e) n = new Float32Array(t);else if ("int32" === e) n = new Int32Array(t);else if ("bool" === e) n = new Uint8Array(t);else {
    if ("string" !== e) throw new Error("Unknown data type " + e);n = new Array(t);
  }return n;
}function checkComputationForErrors(e, t, n) {
  if ("float32" === t) for (var r = 0; r < e.length; r++) {
    var o = e[r];if (isNaN(o) || !isFinite(o)) throw Error("The result of the '" + n + "' is " + o + ".");
  }
}function checkConversionForErrors(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];if (isNaN(r) || !isFinite(r)) throw Error("A tensor of type " + t + " being uploaded contains " + r + ".");
  }
}function hasEncodingLoss(e, t) {
  return "complex64" !== t && ("float32" !== t || "complex64" === e) && ("int32" !== t || "float32" === e || "complex64" === e) && ("bool" !== t || "bool" !== e);
}function isTypedArray(e) {
  return e instanceof Float32Array || e instanceof Int32Array || e instanceof Uint8Array;
}function bytesPerElement(e) {
  if ("float32" === e || "int32" === e) return 4;if ("complex64" === e) return 8;if ("bool" === e) return 1;throw new Error("Unknown dtype " + e);
}function bytesFromStringArray(e) {
  if (null == e) return 0;var t = 0;return e.forEach(function (e) {
    return t += 2 * e.length;
  }), t;
}function isString(e) {
  return "string" == typeof e || e instanceof String;
}function isBoolean(e) {
  return "boolean" == typeof e;
}function isNumber(e) {
  return "number" == typeof e;
}function inferDtype(e) {
  return e instanceof Array ? inferDtype(e[0]) : e instanceof Float32Array ? "float32" : e instanceof Int32Array || e instanceof Uint8Array ? "int32" : isNumber(e) ? "float32" : isString(e) ? "string" : isBoolean(e) ? "bool" : "float32";
}function isFunction(e) {
  return !!(e && e.constructor && e.call && e.apply);
}function nearestDivisor(e, t) {
  for (var n = t; n < e; ++n) {
    if (e % n == 0) return n;
  }return e;
}function computeStrides(e) {
  var t = e.length;if (t < 2) return [];var n = new Array(t - 1);n[t - 2] = e[t - 1];for (var r = t - 3; r >= 0; --r) {
    n[r] = n[r + 1] * e[r + 1];
  }return n;
}function toTypedArray(e, t, n) {
  if ("string" === t) throw new Error("Cannot convert a string[] to a TypedArray");if (Array.isArray(e) && (e = flatten(e)), n && checkConversionForErrors(e, t), noConversionNeeded(e, t)) return e;if (null == t || "float32" === t || "complex64" === t) return new Float32Array(e);if ("int32" === t) return new Int32Array(e);if ("bool" === t) {
    for (var r = new Uint8Array(e.length), o = 0; o < r.length; ++o) {
      0 !== Math.round(e[o]) && (r[o] = 1);
    }return r;
  }throw new Error("Unknown data type " + t);
}function noConversionNeeded(e, t) {
  return e instanceof Float32Array && "float32" === t || e instanceof Int32Array && "int32" === t || e instanceof Uint8Array && "bool" === t;
}function makeOnesTypedArray(e, t) {
  for (var n = makeZerosTypedArray(e, t), r = 0; r < n.length; r++) {
    n[r] = 1;
  }return n;
}function makeZerosTypedArray(e, t) {
  if (null == t || "float32" === t || "complex64" === t) return new Float32Array(e);if ("int32" === t) return new Int32Array(e);if ("bool" === t) return new Uint8Array(e);throw new Error("Unknown data type " + t);
}function now() {
  if ("undefined" != typeof performance) return performance.now();if ("undefined" != typeof process) {
    var e = process.hrtime();return 1e3 * e[0] + e[1] / 1e6;
  }throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js");
}var util = Object.freeze({ shuffle: shuffle, clamp: clamp, nearestLargerEven: nearestLargerEven, sum: sum, randUniform: randUniform, distSquared: distSquared, assert: assert, assertShapesMatch: assertShapesMatch, assertNonNull: assertNonNull, flatten: flatten, sizeFromShape: sizeFromShape, isScalarShape: isScalarShape, arraysEqual: arraysEqual, isInt: isInt, tanh: tanh, sizeToSquarishShape: sizeToSquarishShape, createShuffledIndices: createShuffledIndices, rightPad: rightPad, repeatedTry: repeatedTry, inferFromImplicitShape: inferFromImplicitShape, parseAxisParam: parseAxisParam, squeezeShape: squeezeShape, getTypedArrayFromDType: getTypedArrayFromDType, getArrayFromDType: getArrayFromDType, checkComputationForErrors: checkComputationForErrors, checkConversionForErrors: checkConversionForErrors, hasEncodingLoss: hasEncodingLoss, isTypedArray: isTypedArray, bytesPerElement: bytesPerElement, bytesFromStringArray: bytesFromStringArray, isString: isString, isBoolean: isBoolean, isNumber: isNumber, inferDtype: inferDtype, isFunction: isFunction, nearestDivisor: nearestDivisor, computeStrides: computeStrides, toTypedArray: toTypedArray, makeOnesTypedArray: makeOnesTypedArray, makeZerosTypedArray: makeZerosTypedArray, now: now }),
    Profiler = function () {
  function e(e, t) {
    this.backendTimer = e, this.logger = t, null == t && (this.logger = new Logger());
  }return e.prototype.profileKernel = function (e, t) {
    var n,
        r = this,
        o = this.backendTimer.time(function () {
      n = t();
    });return (Array.isArray(n) ? n : [n]).forEach(function (t) {
      var n = t.dataSync();checkComputationForErrors(n, t.dtype, e), o.then(function (o) {
        var a = "";null != o.getExtraProfileInfo && (a = o.getExtraProfileInfo()), r.logger.logKernelProfile(e, t, n, o.kernelMs, a);
      });
    }), n;
  }, e;
}(),
    Logger = function () {
  function e() {}return e.prototype.logKernelProfile = function (e, t, n, r, o) {
    var a = rightPad(r + "ms", 9),
        i = rightPad(e, 25),
        s = t.rank,
        u = t.size,
        l = rightPad(t.shape.toString(), 14);console.log("%c" + i + "\t%c" + a + "\t%c" + s + "D " + l + "\t%c" + u + "\t%c" + o, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green");
  }, e;
}(),
    FORMAT_LIMIT_NUM_VALS = 20,
    FORMAT_NUM_FIRST_LAST_VALS = 3,
    FORMAT_NUM_SIG_DIGITS = 7;function tensorToString(e, t, n, r) {
  var o = computeStrides(t),
      a = computeMaxSizePerColumn(e, t, n, o),
      i = t.length,
      s = subTensorToString(e, t, n, o, a),
      u = ["Tensor"];return r && (u.push("  dtype: " + n), u.push("  rank: " + i), u.push("  shape: [" + t + "]"), u.push("  values:")), u.push(s.map(function (e) {
    return "    " + e;
  }).join("\n")), u.join("\n");
}function computeMaxSizePerColumn(e, t, n, r) {
  var o = sizeFromShape(t),
      a = r[r.length - 1],
      i = new Array(a).fill(0),
      s = t.length,
      u = "complex64" === n ? createComplexTuples(e) : e;if (s > 1) for (var l = 0; l < o / a; l++) {
    for (var c = l * a, p = 0; p < a; p++) {
      i[p] = Math.max(i[p], valToString(u[c + p], 0).length);
    }
  }return i;
}function valToString(e, t) {
  return rightPad(Array.isArray(e) ? parseFloat(e[0].toFixed(FORMAT_NUM_SIG_DIGITS)) + " + " + parseFloat(e[1].toFixed(FORMAT_NUM_SIG_DIGITS)) + "j" : isString(e) ? "'" + e + "'" : parseFloat(e.toFixed(FORMAT_NUM_SIG_DIGITS)).toString(), t);
}function subTensorToString(e, t, n, r, o, a) {
  void 0 === a && (a = !0);var i = "complex64" === n ? 2 : 1,
      s = t[0],
      u = t.length;if (0 === u) return "complex64" === n ? [valToString(createComplexTuples(e)[0], 0)] : [e[0].toString()];if (1 === u) {
    if (s > FORMAT_LIMIT_NUM_VALS) {
      var l = FORMAT_NUM_FIRST_LAST_VALS * i,
          c = Array.from(e.slice(0, l)),
          p = Array.from(e.slice(s - FORMAT_NUM_FIRST_LAST_VALS * i, s));return "complex64" === n && (c = createComplexTuples(c), p = createComplexTuples(p)), ["[" + c.map(function (e, t) {
        return valToString(e, o[t]);
      }).join(", ") + ", ..., " + p.map(function (e, t) {
        return valToString(e, o[s - FORMAT_NUM_FIRST_LAST_VALS + t]);
      }).join(", ") + "]"];
    }return ["[" + ("complex64" === n ? createComplexTuples(e) : Array.from(e)).map(function (e, t) {
      return valToString(e, o[t]);
    }).join(", ") + "]"];
  }var d = t.slice(1),
      h = r.slice(1),
      f = r[0] * i,
      m = [];if (s > FORMAT_LIMIT_NUM_VALS) {
    for (var g = 0; g < FORMAT_NUM_FIRST_LAST_VALS; g++) {
      var v = (y = g * f) + f;m.push.apply(m, subTensorToString(e.slice(y, v), d, n, h, o, !1));
    }m.push("...");for (g = s - FORMAT_NUM_FIRST_LAST_VALS; g < s; g++) {
      v = (y = g * f) + f;m.push.apply(m, subTensorToString(e.slice(y, v), d, n, h, o, g === s - 1));
    }
  } else for (g = 0; g < s; g++) {
    var y;v = (y = g * f) + f;m.push.apply(m, subTensorToString(e.slice(y, v), d, n, h, o, g === s - 1));
  }var x = 2 === u ? "," : "";m[0] = "[" + m[0] + x;for (g = 1; g < m.length - 1; g++) {
    m[g] = " " + m[g] + x;
  }var T = ",\n";for (g = 2; g < u; g++) {
    T += "\n";
  }return m[m.length - 1] = " " + m[m.length - 1] + "]" + (a ? "" : T), m;
}function createComplexTuples(e) {
  for (var t = [], n = 0; n < e.length; n += 2) {
    t.push([e[n], e[n + 1]]);
  }return t;
}var TensorBuffer = function () {
  function e(e, t, n) {
    if (this.dtype = t, this.shape = e.slice(), this.size = sizeFromShape(e), null != n) {
      var r = n.length;assert(r === this.size, "Length of values '" + r + "' does not match the size inferred by the shape '" + this.size + "'.");
    }if ("complex64" === t) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");this.values = n || getArrayFromDType(t, sizeFromShape(this.shape)), this.strides = computeStrides(e);
  }return e.prototype.set = function (e) {
    for (var t = [], n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }0 === t.length && (t = [0]), assert(t.length === this.rank, "The number of provided coordinates (" + t.length + ") must match the rank (" + this.rank + ")");var r = this.locToIndex(t);this.values[r] = e;
  }, e.prototype.get = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }0 === e.length && (e = [0]);for (var n = e[e.length - 1], r = 0; r < e.length - 1; ++r) {
      n += this.strides[r] * e[r];
    }return this.values[n];
  }, e.prototype.locToIndex = function (e) {
    if (0 === this.rank) return 0;if (1 === this.rank) return e[0];for (var t = e[e.length - 1], n = 0; n < e.length - 1; ++n) {
      t += this.strides[n] * e[n];
    }return t;
  }, e.prototype.indexToLoc = function (e) {
    if (0 === this.rank) return [];if (1 === this.rank) return [e];for (var t = new Array(this.shape.length), n = 0; n < t.length - 1; ++n) {
      t[n] = Math.floor(e / this.strides[n]), e -= t[n] * this.strides[n];
    }return t[t.length - 1] = e, t;
  }, Object.defineProperty(e.prototype, "rank", { get: function get() {
      return this.shape.length;
    }, enumerable: !0, configurable: !0 }), e.prototype.toTensor = function () {
    return Tensor.make(this.shape, { values: this.values }, this.dtype);
  }, e;
}(),
    trackerFn = null,
    opHandler = null;function setTensorTracker(e) {
  trackerFn = e;
}function setOpHandler(e) {
  opHandler = e;
}var Tensor = function () {
  function e(e, t, n, r) {
    this.isDisposedInternal = !1, this.shape = e.slice(), this.dtype = t || "float32", this.size = sizeFromShape(e), this.strides = computeStrides(e), this.dataId = null != r ? r : {}, this.id = trackerFn().nextTensorId(), this.rankType = this.rank < 5 ? this.rank.toString() : "higher", trackerFn().registerTensor(this), null != n && trackerFn().write(this.dataId, n);
  }return e.make = function (t, n, r) {
    return new e(t, r, n.values, n.dataId);
  }, e.prototype.flatten = function () {
    return this.throwIfDisposed(), this.as1D();
  }, e.prototype.asScalar = function () {
    return this.throwIfDisposed(), assert(1 === this.size, "The array must have only 1 element."), this.reshape([]);
  }, e.prototype.as1D = function () {
    return this.throwIfDisposed(), this.reshape([this.size]);
  }, e.prototype.as2D = function (e, t) {
    return this.throwIfDisposed(), this.reshape([e, t]);
  }, e.prototype.as3D = function (e, t, n) {
    return this.throwIfDisposed(), this.reshape([e, t, n]);
  }, e.prototype.as4D = function (e, t, n, r) {
    return this.throwIfDisposed(), this.reshape([e, t, n, r]);
  }, e.prototype.as5D = function (e, t, n, r, o) {
    return this.throwIfDisposed(), this.reshape([e, t, n, r, o]);
  }, e.prototype.asType = function (e) {
    return this.throwIfDisposed(), opHandler.cast(this, e);
  }, Object.defineProperty(e.prototype, "rank", { get: function get() {
      return this.shape.length;
    }, enumerable: !0, configurable: !0 }), e.prototype.get = function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }assert(e.length === this.rank, "Number of coordinates in get() must match the rank of the tensor"), assert("complex64" !== this.dtype, "Tensor.get() is not supported for complex64 tensors yet."), this.throwIfDisposed(), 0 === e.length && (e = [0]);for (var n = e[e.length - 1], r = 0; r < e.length - 1; ++r) {
      n += this.strides[r] * e[r];
    }return this.dataSync()[n];
  }, e.prototype.buffer = function () {
    return opHandler.buffer(this.shape, this.dtype, this.dataSync());
  }, e.prototype.data = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return this.throwIfDisposed(), [2, trackerFn().read(this.dataId)];
      });
    });
  }, e.prototype.dataSync = function () {
    return this.throwIfDisposed(), trackerFn().readSync(this.dataId);
  }, e.prototype.dispose = function () {
    this.isDisposed || (trackerFn().disposeTensor(this), this.isDisposedInternal = !0);
  }, Object.defineProperty(e.prototype, "isDisposed", { get: function get() {
      return this.isDisposedInternal;
    }, enumerable: !0, configurable: !0 }), e.prototype.throwIfDisposed = function () {
    if (this.isDisposed) throw new Error("Tensor is disposed.");
  }, e.prototype.toFloat = function () {
    return this.asType("float32");
  }, e.prototype.toInt = function () {
    return this.asType("int32");
  }, e.prototype.toBool = function () {
    return this.asType("bool");
  }, e.prototype.print = function (e) {
    return void 0 === e && (e = !1), opHandler.print(this, e);
  }, e.prototype.reshape = function (e) {
    return this.throwIfDisposed(), opHandler.reshape(this, e);
  }, e.prototype.reshapeAs = function (e) {
    return this.throwIfDisposed(), this.reshape(e.shape);
  }, e.prototype.expandDims = function (e) {
    return void 0 === e && (e = 0), opHandler.expandDims(this, e);
  }, e.prototype.cumsum = function (e, t, n) {
    return void 0 === e && (e = 0), void 0 === t && (t = !1), void 0 === n && (n = !1), opHandler.cumsum(this, e, t, n);
  }, e.prototype.squeeze = function (e) {
    return this.throwIfDisposed(), opHandler.squeeze(this, e);
  }, e.prototype.clone = function () {
    return this.throwIfDisposed(), opHandler.clone(this);
  }, e.prototype.toString = function (e) {
    return void 0 === e && (e = !1), tensorToString(this.dataSync(), this.shape, this.dtype, e);
  }, e.prototype.tile = function (e) {
    return this.throwIfDisposed(), opHandler.tile(this, e);
  }, e.prototype.gather = function (e, t) {
    return void 0 === t && (t = 0), this.throwIfDisposed(), opHandler.gather(this, e, t);
  }, e.prototype.matMul = function (e, t, n) {
    return void 0 === t && (t = !1), void 0 === n && (n = !1), this.throwIfDisposed(), opHandler.matMul(this, e, t, n);
  }, e.prototype.dot = function (e) {
    return this.throwIfDisposed(), opHandler.dot(this, e);
  }, e.prototype.norm = function (e, t, n) {
    return void 0 === e && (e = "euclidean"), void 0 === t && (t = null), void 0 === n && (n = !1), this.throwIfDisposed(), opHandler.norm(this, e, t, n);
  }, e.prototype.slice = function (e, t) {
    return this.throwIfDisposed(), opHandler.slice(this, e, t);
  }, e.prototype.reverse = function (e) {
    return this.throwIfDisposed(), opHandler.reverse(this, e);
  }, e.prototype.concat = function (t, n) {
    return void 0 === n && (n = 0), this.throwIfDisposed(), t instanceof e && (t = [t]), opHandler.concat([this].concat(t), n);
  }, e.prototype.split = function (e, t) {
    return void 0 === t && (t = 0), this.throwIfDisposed(), opHandler.split(this, e, t);
  }, e.prototype.stack = function (e, t) {
    return void 0 === t && (t = 0), opHandler.stack([this, e], t);
  }, e.prototype.unstack = function (e, t) {
    return void 0 === t && (t = 0), opHandler.unstack(this, t);
  }, e.prototype.pad = function (e, t) {
    return void 0 === t && (t = 0), opHandler.pad(this, e, t);
  }, e.prototype.batchNormalization = function (e, t, n, r, o) {
    return void 0 === n && (n = .001), this.throwIfDisposed(), opHandler.batchNormalization(this, e, t, n, r, o);
  }, e.prototype.all = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.all(this, e, t);
  }, e.prototype.any = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.any(this, e, t);
  }, e.prototype.logSumExp = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.logSumExp(this, e, t);
  }, e.prototype.sum = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.sum(this, e, t);
  }, e.prototype.prod = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.prod(this, e, t);
  }, e.prototype.mean = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.mean(this, e, t);
  }, e.prototype.min = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.min(this, e, t);
  }, e.prototype.max = function (e, t) {
    return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.max(this, e, t);
  }, e.prototype.argMin = function (e) {
    return void 0 === e && (e = null), this.throwIfDisposed(), opHandler.argMin(this, e);
  }, e.prototype.argMax = function (e) {
    return void 0 === e && (e = null), this.throwIfDisposed(), opHandler.argMax(this, e);
  }, e.prototype.cast = function (e) {
    return this.throwIfDisposed(), opHandler.cast(this, e);
  }, e.prototype.add = function (e) {
    return this.throwIfDisposed(), opHandler.add(this, e);
  }, e.prototype.addStrict = function (e) {
    return this.throwIfDisposed(), opHandler.addStrict(this, e);
  }, e.prototype.atan2 = function (e) {
    return this.throwIfDisposed(), opHandler.atan2(this, e);
  }, e.prototype.sub = function (e) {
    return this.throwIfDisposed(), opHandler.sub(this, e);
  }, e.prototype.subStrict = function (e) {
    return this.throwIfDisposed(), opHandler.subStrict(this, e);
  }, e.prototype.pow = function (e) {
    return this.throwIfDisposed(), opHandler.pow(this, e);
  }, e.prototype.powStrict = function (e) {
    return this.throwIfDisposed(), opHandler.powStrict(this, e);
  }, e.prototype.mul = function (e) {
    return this.throwIfDisposed(), opHandler.mul(this, e);
  }, e.prototype.mulStrict = function (e) {
    return this.throwIfDisposed(), opHandler.mulStrict(this, e);
  }, e.prototype.div = function (e) {
    return this.throwIfDisposed(), opHandler.div(this, e);
  }, e.prototype.floorDiv = function (e) {
    return this.throwIfDisposed(), opHandler.floorDiv(this, e);
  }, e.prototype.divStrict = function (e) {
    return this.throwIfDisposed(), opHandler.divStrict(this, e);
  }, e.prototype.minimum = function (e) {
    return this.throwIfDisposed(), opHandler.minimum(this, e);
  }, e.prototype.minimumStrict = function (e) {
    return this.throwIfDisposed(), opHandler.minimumStrict(this, e);
  }, e.prototype.maximum = function (e) {
    return this.throwIfDisposed(), opHandler.maximum(this, e);
  }, e.prototype.maximumStrict = function (e) {
    return this.throwIfDisposed(), opHandler.maximumStrict(this, e);
  }, e.prototype.mod = function (e) {
    return this.throwIfDisposed(), opHandler.mod(this, e);
  }, e.prototype.modStrict = function (e) {
    return this.throwIfDisposed(), opHandler.modStrict(this, e);
  }, e.prototype.squaredDifference = function (e) {
    return this.throwIfDisposed(), opHandler.squaredDifference(this, e);
  }, e.prototype.squaredDifferenceStrict = function (e) {
    return this.throwIfDisposed(), opHandler.squaredDifferenceStrict(this, e);
  }, e.prototype.transpose = function (e) {
    return this.throwIfDisposed(), opHandler.transpose(this, e);
  }, e.prototype.notEqual = function (e) {
    return this.throwIfDisposed(), opHandler.notEqual(this, e);
  }, e.prototype.notEqualStrict = function (e) {
    return this.throwIfDisposed(), opHandler.notEqualStrict(this, e);
  }, e.prototype.less = function (e) {
    return this.throwIfDisposed(), opHandler.less(this, e);
  }, e.prototype.lessStrict = function (e) {
    return this.throwIfDisposed(), opHandler.lessStrict(this, e);
  }, e.prototype.equal = function (e) {
    return this.throwIfDisposed(), opHandler.equal(this, e);
  }, e.prototype.equalStrict = function (e) {
    return this.throwIfDisposed(), opHandler.equalStrict(this, e);
  }, e.prototype.lessEqual = function (e) {
    return this.throwIfDisposed(), opHandler.lessEqual(this, e);
  }, e.prototype.lessEqualStrict = function (e) {
    return this.throwIfDisposed(), opHandler.lessEqualStrict(this, e);
  }, e.prototype.greater = function (e) {
    return this.throwIfDisposed(), opHandler.greater(this, e);
  }, e.prototype.greaterStrict = function (e) {
    return this.throwIfDisposed(), opHandler.greaterStrict(this, e);
  }, e.prototype.greaterEqual = function (e) {
    return this.throwIfDisposed(), opHandler.greaterEqual(this, e);
  }, e.prototype.greaterEqualStrict = function (e) {
    return this.throwIfDisposed(), opHandler.greaterEqualStrict(this, e);
  }, e.prototype.logicalAnd = function (e) {
    return this.throwIfDisposed(), opHandler.logicalAnd(this, e);
  }, e.prototype.logicalOr = function (e) {
    return this.throwIfDisposed(), opHandler.logicalOr(this, e);
  }, e.prototype.logicalNot = function () {
    return this.throwIfDisposed(), opHandler.logicalNot(this);
  }, e.prototype.logicalXor = function (e) {
    return this.throwIfDisposed(), opHandler.logicalXor(this, e);
  }, e.prototype.where = function (e, t) {
    return this.throwIfDisposed(), opHandler.where(e, this, t);
  }, e.prototype.neg = function () {
    return this.throwIfDisposed(), opHandler.neg(this);
  }, e.prototype.ceil = function () {
    return this.throwIfDisposed(), opHandler.ceil(this);
  }, e.prototype.floor = function () {
    return this.throwIfDisposed(), opHandler.floor(this);
  }, e.prototype.sign = function () {
    return this.throwIfDisposed(), opHandler.sign(this);
  }, e.prototype.exp = function () {
    return this.throwIfDisposed(), opHandler.exp(this);
  }, e.prototype.expm1 = function () {
    return this.throwIfDisposed(), opHandler.expm1(this);
  }, e.prototype.log = function () {
    return this.throwIfDisposed(), opHandler.log(this);
  }, e.prototype.log1p = function () {
    return this.throwIfDisposed(), opHandler.log1p(this);
  }, e.prototype.sqrt = function () {
    return this.throwIfDisposed(), opHandler.sqrt(this);
  }, e.prototype.rsqrt = function () {
    return this.throwIfDisposed(), opHandler.rsqrt(this);
  }, e.prototype.square = function () {
    return this.throwIfDisposed(), opHandler.square(this);
  }, e.prototype.reciprocal = function () {
    return this.throwIfDisposed(), opHandler.reciprocal(this);
  }, e.prototype.abs = function () {
    return this.throwIfDisposed(), opHandler.abs(this);
  }, e.prototype.clipByValue = function (e, t) {
    return this.throwIfDisposed(), opHandler.clipByValue(this, e, t);
  }, e.prototype.relu = function () {
    return this.throwIfDisposed(), opHandler.relu(this);
  }, e.prototype.elu = function () {
    return this.throwIfDisposed(), opHandler.elu(this);
  }, e.prototype.selu = function () {
    return this.throwIfDisposed(), opHandler.selu(this);
  }, e.prototype.leakyRelu = function (e) {
    return void 0 === e && (e = .2), this.throwIfDisposed(), opHandler.leakyRelu(this, e);
  }, e.prototype.prelu = function (e) {
    return this.throwIfDisposed(), opHandler.prelu(this, e);
  }, e.prototype.sigmoid = function () {
    return this.throwIfDisposed(), opHandler.sigmoid(this);
  }, e.prototype.logSigmoid = function () {
    return this.throwIfDisposed(), opHandler.logSigmoid(this);
  }, e.prototype.softplus = function () {
    return this.throwIfDisposed(), opHandler.softplus(this);
  }, e.prototype.zerosLike = function () {
    return this.throwIfDisposed(), opHandler.zerosLike(this);
  }, e.prototype.onesLike = function () {
    return this.throwIfDisposed(), opHandler.onesLike(this);
  }, e.prototype.sin = function () {
    return this.throwIfDisposed(), opHandler.sin(this);
  }, e.prototype.cos = function () {
    return this.throwIfDisposed(), opHandler.cos(this);
  }, e.prototype.tan = function () {
    return this.throwIfDisposed(), opHandler.tan(this);
  }, e.prototype.asin = function () {
    return this.throwIfDisposed(), opHandler.asin(this);
  }, e.prototype.acos = function () {
    return this.throwIfDisposed(), opHandler.acos(this);
  }, e.prototype.atan = function () {
    return this.throwIfDisposed(), opHandler.atan(this);
  }, e.prototype.sinh = function () {
    return this.throwIfDisposed(), opHandler.sinh(this);
  }, e.prototype.cosh = function () {
    return this.throwIfDisposed(), opHandler.cosh(this);
  }, e.prototype.tanh = function () {
    return this.throwIfDisposed(), opHandler.tanh(this);
  }, e.prototype.asinh = function () {
    return this.throwIfDisposed(), opHandler.asinh(this);
  }, e.prototype.acosh = function () {
    return this.throwIfDisposed(), opHandler.acosh(this);
  }, e.prototype.atanh = function () {
    return this.throwIfDisposed(), opHandler.atanh(this);
  }, e.prototype.erf = function () {
    return this.throwIfDisposed(), opHandler.erf(this);
  }, e.prototype.round = function () {
    return this.throwIfDisposed(), opHandler.round(this);
  }, e.prototype.step = function (e) {
    return void 0 === e && (e = 0), this.throwIfDisposed(), opHandler.step(this, e);
  }, e.prototype.softmax = function (e) {
    return void 0 === e && (e = -1), this.throwIfDisposed(), opHandler.softmax(this, e);
  }, e.prototype.logSoftmax = function (e) {
    return void 0 === e && (e = -1), this.throwIfDisposed(), opHandler.logSoftmax(this, e);
  }, e.prototype.resizeBilinear = function (e, t) {
    return void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.image.resizeBilinear(this, e, t);
  }, e.prototype.resizeNearestNeighbor = function (e, t) {
    return void 0 === t && (t = !1), this.throwIfDisposed(), opHandler.image.resizeNearestNeighbor(this, e, t);
  }, e.prototype.conv1d = function (e, t, n, r, o, a) {
    return void 0 === r && (r = "NWC"), void 0 === o && (o = 1), this.throwIfDisposed(), opHandler.conv1d(this, e, t, n, r, o, a);
  }, e.prototype.conv2d = function (e, t, n, r, o, a) {
    return void 0 === r && (r = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), opHandler.conv2d(this, e, t, n, r, o, a);
  }, e.prototype.conv2dTranspose = function (e, t, n, r, o) {
    return this.throwIfDisposed(), opHandler.conv2dTranspose(this, e, t, n, r, o);
  }, e.prototype.depthwiseConv2D = function (e, t, n, r, o, a) {
    return void 0 === r && (r = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), opHandler.depthwiseConv2d(this, e, t, n, r, o, a);
  }, e.prototype.separableConv2d = function (e, t, n, r, o, a) {
    return void 0 === o && (o = [1, 1]), void 0 === a && (a = "NHWC"), this.throwIfDisposed(), opHandler.separableConv2d(this, e, t, n, r, o, a);
  }, e.prototype.avgPool = function (e, t, n, r) {
    return this.throwIfDisposed(), opHandler.avgPool(this, e, t, n, r);
  }, e.prototype.maxPool = function (e, t, n, r) {
    return this.throwIfDisposed(), opHandler.maxPool(this, e, t, n, r);
  }, e.prototype.localResponseNormalization = function (e, t, n, r) {
    return void 0 === e && (e = 5), void 0 === t && (t = 1), void 0 === n && (n = 1), void 0 === r && (r = .5), opHandler.localResponseNormalization(this, e, t, n, r);
  }, e.prototype.pool = function (e, t, n, r, o) {
    return this.throwIfDisposed(), opHandler.pool(this, e, t, n, r, o);
  }, e.prototype.variable = function (e, t, n) {
    return void 0 === e && (e = !0), this.throwIfDisposed(), Variable.variable(this, e, t, n);
  }, e.prototype.unsortedSegmentSum = function (e, t) {
    return this.throwIfDisposed(), opHandler.unsortedSegmentSum(this, e, t);
  }, e.prototype.batchToSpaceND = function (e, t) {
    return this.throwIfDisposed(), opHandler.batchToSpaceND(this, e, t);
  }, e.prototype.spaceToBatchND = function (e, t) {
    return this.throwIfDisposed(), opHandler.spaceToBatchND(this, e, t);
  }, e.prototype.topk = function (e, t) {
    return void 0 === e && (e = 1), void 0 === t && (t = !0), this.throwIfDisposed(), opHandler.topk(this, e, t);
  }, e.prototype.stridedSlice = function (e, t, n, r, o, a, i, s) {
    return void 0 === r && (r = 0), void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), this.throwIfDisposed(), opHandler.stridedSlice(this, e, t, n, r, o, a, i, s);
  }, e.prototype.depthToSpace = function (e, t) {
    return this.throwIfDisposed(), opHandler.depthToSpace(this, e, t);
  }, e.prototype.fft = function () {
    return this.throwIfDisposed(), opHandler.spectral.fft(this);
  }, e.prototype.ifft = function () {
    return this.throwIfDisposed(), opHandler.spectral.ifft(this);
  }, e.prototype.rfft = function () {
    return this.throwIfDisposed(), opHandler.spectral.rfft(this);
  }, e.prototype.irfft = function () {
    return this.throwIfDisposed(), opHandler.spectral.irfft(this);
  }, e;
}();Object.defineProperty(Tensor, Symbol.hasInstance, { value: function value(e) {
    return !!e && null != e.dataId && null != e.shape && null != e.dtype;
  } });var Variable = function (e) {
  function t(t, n, r) {
    void 0 === n && (n = !0);var o = e.call(this, t.shape, t.dtype, null, t.dataId) || this;o.trainable = n, o.name = r, null == o.name && (o.name = trackerFn().nextVariableId().toString());try {
      trackerFn().registerVariable(o);
    } catch (e) {
      throw trackerFn().disposeTensor(o), e;
    }return o;
  }return __extends(t, e), t.variable = function (e, n, r, o) {
    return void 0 === n && (n = !0), null != o && o !== e.dtype && (e = e.asType(o)), new t(e, n, r);
  }, t.prototype.assign = function (e) {
    if (e.dtype !== this.dtype) throw new Error("dtype of the new value (" + e.dtype + ") and previous value (" + this.dtype + ") must match");if (!arraysEqual(e.shape, this.shape)) throw new Error("shape of the new value (" + e.shape + ") and previous value (" + this.shape + ") must match");trackerFn().disposeTensor(this), this.dataId = e.dataId, trackerFn().registerTensor(this);
  }, t;
}(Tensor);Object.defineProperty(Variable, Symbol.hasInstance, { value: function value(e) {
    return e instanceof Tensor && null != e.assign && e.assign instanceof Function;
  } });var Rank,
    UpcastInt32AndMap,
    UpcastBoolAndMap,
    UpcastFloat32AndMap,
    UpcastComplex64AndMap,
    variable = Variable.variable;function getFilteredNodesXToY(e, t, n) {
  for (var r = {}, o = {}, a = 0; a < t.length; a++) {
    r[t[a].id] = !0;
  }for (a = 0; a < e.length; a++) {
    var i = (f = e[a]).inputs;for (var s in i) {
      for (var u = i[s], l = !1, c = 0; c < t.length; c++) {
        if (r[u.id]) {
          f.outputs.forEach(function (e) {
            return r[e.id] = !0;
          }), l = !0, o[f.id] = !0;break;
        }
      }if (l) break;
    }
  }var p = {};p[n.id] = !0;var d = {};for (a = e.length - 1; a >= 0; a--) {
    for (i = (f = e[a]).inputs, c = 0; c < f.outputs.length; c++) {
      if (p[f.outputs[c].id]) {
        for (var s in i) {
          p[i[s].id] = !0, d[f.id] = !0;
        }break;
      }
    }
  }var h = [];for (a = 0; a < e.length; a++) {
    var f;if (o[(f = e[a]).id] && d[f.id]) {
      var m = {};for (var s in f.inputs) {
        var g = f.inputs[s];r[g.id] && (m[s] = g);
      }var v = _extends({}, f);v.inputs = m, v.outputs = f.outputs, h.push(v);
    }
  }return h;
}function backpropagateGradients(e, t) {
  for (var n = function n(_n) {
    var r = t[_n],
        o = [];if (r.outputs.forEach(function (t) {
      var n = e[t.id];if (null != n) o.push(n);else {
        var r = Tensor.make(t.shape, { values: makeZerosTypedArray(t.size, t.dtype) }, t.dtype);o.push(r);
      }
    }), null == r.gradient) throw new Error("Cannot compute gradient: gradient function not found for " + r.name + ".");var a = r.gradient(1 === r.outputs.length ? o[0] : o);for (var i in r.inputs) {
      if (!(i in a)) throw new Error("Cannot backprop through input " + i + ". Available gradients found: " + Object.keys(a) + ".");var s = a[i]();if ("float32" !== s.dtype) throw new Error("Error in gradient for op " + r.name + ". The gradient of input " + i + " must have 'float32' dtype, but has '" + s.dtype + "'");var u = r.inputs[i];if (!arraysEqual(s.shape, u.shape)) throw new Error("Error in gradient for op " + r.name + ". The gradient of input '" + i + "' has shape '" + s.shape + "', which does not match the shape of the input '" + u.shape + "'");if (null == e[u.id]) e[u.id] = s;else {
        var l = e[u.id];e[u.id] = l.add(s), l.dispose();
      }
    }
  }, r = t.length - 1; r >= 0; r--) {
    n(r);
  }
}!function (e) {
  e.R0 = "R0", e.R1 = "R1", e.R2 = "R2", e.R3 = "R3", e.R4 = "R4", e.R5 = "R5", e.R6 = "R6";
}(Rank || (Rank = {})), function (e) {
  e.float32 = "float32", e.int32 = "int32", e.bool = "int32", e.complex64 = "complex64";
}(UpcastInt32AndMap || (UpcastInt32AndMap = {})), function (e) {
  e.float32 = "float32", e.int32 = "int32", e.bool = "bool", e.complex64 = "complex64";
}(UpcastBoolAndMap || (UpcastBoolAndMap = {})), function (e) {
  e.float32 = "float32", e.int32 = "float32", e.bool = "float32", e.complex64 = "complex64";
}(UpcastFloat32AndMap || (UpcastFloat32AndMap = {})), function (e) {
  e.float32 = "complex64", e.int32 = "complex64", e.bool = "complex64", e.complex64 = "complex64";
}(UpcastComplex64AndMap || (UpcastComplex64AndMap = {}));var upcastTypeMap = { float32: UpcastFloat32AndMap, int32: UpcastInt32AndMap, bool: UpcastBoolAndMap, complex64: UpcastComplex64AndMap };function upcastType(e, t) {
  if ("string" === e || "string" === t) {
    if ("string" === e && "string" === t) return "string";throw new Error("Can not upcast " + e + " with " + t);
  }return upcastTypeMap[e][t];
}function sumOutType(e) {
  return upcastType(e, "int32");
}function makeTypesMatch(e, t) {
  if (e.dtype === t.dtype) return [e, t];var n = upcastType(e.dtype, t.dtype);return [e.cast(n), t.cast(n)];
}function assertTypesMatch(e, t) {
  assert(e.dtype === t.dtype, "The dtypes of the first(" + e.dtype + ") and second(" + t.dtype + ") input must match");
}function isTensorInList(e, t) {
  for (var n = 0; n < t.length; n++) {
    if (t[n].id === e.id) return !0;
  }return !1;
}function getTensorsInContainer(e) {
  var t = [];return walkTensorContainer(e, t, new Set()), t;
}function walkTensorContainer(e, t, n) {
  if (null != e) if (e instanceof Tensor) t.push(e);else if (isIterable(e)) {
    var r = e;for (var o in r) {
      var a = r[o];n.has(a) || (n.add(a), walkTensorContainer(a, t, n));
    }
  }
}function isIterable(e) {
  return Array.isArray(e) || "object" == typeof e;
}var Type,
    Engine = function () {
  function e(e, t, n) {
    this.backend = e, this.safeMode = t, this.debugMode = n, this.registeredVariables = {}, this.nextTapeNodeId = 0, this.numBytes = 0, this.numTensors = 0, this.numStringTensors = 0, this.numDataBuffers = 0, this.profiling = !1, this.gradientScopeCount = 0, this.customGradientDepth = 0, this.scopeStack = [], this.keepTensors = new Set(), this.tensorInfo = new WeakMap(), this.profiler = new Profiler(e), this.activeProfile = { newBytes: 0, newTensors: 0, peakBytes: 0, kernels: [], result: null };
  }return e.prototype.moveData = function (e) {
    this.write(e, this.readSync(e));
  }, e.prototype.tidy = function (e, t, n) {
    var r = this;void 0 === n && (n = !1);var o,
        a = null;if (null == t) {
      if ("function" != typeof e) throw new Error("Please provide a function to tidy()");t = e;
    } else {
      if ("string" != typeof e && !(e instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");if ("function" != typeof t) throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");a = e;
    }return this.scopedRun(function () {
      return r.startScope(a, n);
    }, function () {
      return r.endScope(o, n);
    }, function () {
      return (o = t()) instanceof Promise && console.error("Cannot return a Promise inside of tidy."), o;
    });
  }, e.prototype.scopedRun = function (e, t, n) {
    e();try {
      var r = n();return t(), r;
    } catch (e) {
      throw t(), e;
    }
  }, e.prototype.nextTensorId = function () {
    return e.nextTensorId++;
  }, e.prototype.nextVariableId = function () {
    return e.nextVariableId++;
  }, e.prototype.runKernel = function (e, t, n) {
    var r,
        o = this,
        a = [],
        i = function i(e) {
      return a.push(e), e;
    },
        s = this.activeScope.name,
        u = this.numBytes,
        l = this.numTensors;if (this.scopedRun(function () {
      return o.customGradientDepth++;
    }, function () {
      return o.customGradientDepth--;
    }, function () {
      r = o.debugMode() ? o.profiler.profileKernel(s, function () {
        return e(o.backend, i);
      }) : e(o.backend, i);
    }), this.shouldRecord()) {
      var c = { id: this.nextTapeNodeId++, name: s, inputs: t, outputs: Array.isArray(r) ? r : [r] };null != n && (c.gradient = function (e) {
        return n(e, a);
      }), this.activeTape.push(c);
    }return this.profiling && this.activeProfile.kernels.push({ name: s, bytesAdded: this.numBytes - u, totalBytesSnapshot: this.numBytes, tensorsAdded: this.numTensors - l, totalTensorsSnapshot: this.numTensors, inputShapes: Object.keys(t).map(function (e) {
        return t[e].shape;
      }), outputShape: Array.isArray(r) ? r.map(function (e) {
        return e.shape;
      }) : r.shape }), r;
  }, e.prototype.registerTensor = function (e) {
    var t = this.tensorInfo.has(e.dataId) ? this.tensorInfo.get(e.dataId).refCount : 0;if (this.numTensors++, "string" === e.dtype && this.numStringTensors++, 0 === t) {
      this.numDataBuffers++;var n = 0;"complex64" !== e.dtype && "string" !== e.dtype && (n = sizeFromShape(e.shape) * bytesPerElement(e.dtype)), this.tensorInfo.set(e.dataId, { backend: this.backend, dtype: e.dtype, shape: e.shape, bytes: n, refCount: 0 }), this.numBytes += n, this.backend.register(e.dataId, e.shape, e.dtype);
    }this.tensorInfo.get(e.dataId).refCount++, e instanceof Variable || this.track(e);
  }, e.prototype.registerVariable = function (e) {
    if (null != this.registeredVariables[e.name]) throw new Error("Variable with name " + e.name + " was already registered");this.registeredVariables[e.name] = e;
  }, e.prototype.disposeTensor = function (e) {
    if (this.tensorInfo.has(e.dataId)) {
      this.keepTensors.has(e.id) && this.keepTensors.delete(e.id), this.numTensors--, "string" === e.dtype && this.numStringTensors--;var t = this.tensorInfo.get(e.dataId);t.refCount <= 1 ? ("complex64" !== e.dtype && (this.numBytes -= t.bytes), this.numDataBuffers--, t.backend.disposeData(e.dataId), this.tensorInfo.delete(e.dataId)) : this.tensorInfo.get(e.dataId).refCount--;
    }
  }, e.prototype.disposeVariables = function () {
    for (var e in this.registeredVariables) {
      var t = this.registeredVariables[e];this.disposeTensor(t), delete this.registeredVariables[e];
    }
  }, e.prototype.memory = function () {
    var e = this.backend.memory();return e.numTensors = this.numTensors, e.numDataBuffers = this.numDataBuffers, e.numBytes = this.numBytes, this.numStringTensors > 0 && (e.unreliable = !0, null == e.reasons && (e.reasons = []), e.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)")), e;
  }, e.prototype.profile = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n;return __generator(this, function (r) {
        return this.profiling = !0, t = this.numBytes, n = this.numTensors, this.activeProfile.kernels = [], this.activeProfile.result = e(), this.profiling = !1, this.activeProfile.peakBytes = Math.max.apply(Math, this.activeProfile.kernels.map(function (e) {
          return e.totalBytesSnapshot;
        })), this.activeProfile.newBytes = this.numBytes - t, this.activeProfile.newTensors = this.numTensors - n, [2, this.activeProfile];
      });
    });
  }, e.prototype.shouldRecord = function () {
    return null != this.activeTape && 0 === this.customGradientDepth;
  }, e.prototype.addTapeNode = function (e, t, n) {
    var r = {};e.forEach(function (e, t) {
      r[t] = e;
    });var o = { id: this.nextTapeNodeId++, name: this.activeScope.name, inputs: r, outputs: [t], gradient: function gradient(e) {
        var t = {};return n(e).forEach(function (e, n) {
          t[n] = function () {
            return e;
          };
        }), t;
      } };this.activeTape.push(o);
  }, e.prototype.keep = function (e) {
    if (1 === this.scopeStack.length && this.safeMode) throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {...}) to avoid memory leaks.");return this.keepTensors.add(e.id), e;
  }, e.prototype.startScope = function (e, t) {
    void 0 === t && (t = !1), t && 0 === this.gradientScopeCount && (this.activeTape = []), t && this.gradientScopeCount++;var n = { track: [], name: "unnamed scope" };e && (n.name = e), this.scopeStack.push(n), this.activeScope = n;
  }, e.prototype.endScope = function (e, t) {
    var n = this;void 0 === t && (t = !1), t && (this.gradientScopeCount--, 0 === this.gradientScopeCount && (this.activeTape = null));var r = new Set(this.keepTensors),
        o = getTensorsInContainer(e);o.forEach(function (e) {
      return r.add(e.id);
    });for (var a = 0; a < this.activeScope.track.length; a++) {
      var i = this.activeScope.track[a];r.has(i.id) || (null != this.activeTape ? o.push(i) : i.dispose());
    }var s = this.scopeStack.pop();this.activeScope = 0 === this.scopeStack.length ? null : this.scopeStack[this.scopeStack.length - 1], o.forEach(function (e) {
      !n.keepTensors.has(e.id) && isTensorInList(e, s.track) && n.track(e);
    });
  }, e.prototype.gradients = function (e, t, n, r) {
    var o = this;if (void 0 === r && (r = !1), assert(t.length > 0, "gradients() received an empty list of xs."), null != n && "float32" !== n.dtype) throw new Error("dy must have 'float32' dtype, but has '" + n.dtype + "'");return this.tidy("gradients", function () {
      var a = e();assert(a instanceof Tensor, "The result y returned by f() must be a tensor.");var i = getFilteredNodesXToY(o.activeTape, t, a);if (!r && 0 === i.length && t.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");var s = {};return s[a.id] = null == n ? ones(a.shape) : n, backpropagateGradients(s, i), { value: a, grads: t.map(function (e) {
          return s[e.id];
        }) };
    }, !0);
  }, e.prototype.customGrad = function (e) {
    var t = this;return assert(isFunction(e), "The f passed in customGrad(f) must be a function."), function () {
      for (var n, r, o = [], a = 0; a < arguments.length; a++) {
        o[a] = arguments[a];
      }if (assert(o.every(function (e) {
        return e instanceof Tensor;
      }), "The args passed in customGrad(f)(x1, x2,...) must all be tensors"), t.scopedRun(function () {
        return t.customGradientDepth++;
      }, function () {
        return t.customGradientDepth--;
      }, function () {
        r = t.tidy(e.name, function () {
          var t = e.apply(void 0, o),
              r = t.value,
              a = t.gradFunc;return assert(r instanceof Tensor, "The function f passed in customGrad(f) must return an object where `obj.value` is a tensor"), assert(isFunction(a), "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function."), n = a, r;
        }, !0);
      }), t.shouldRecord()) {
        t.addTapeNode(o, r, function (e) {
          var t = n(e),
              r = Array.isArray(t) ? t : [t];return assert(r.length === o.length, "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...)."), assert(r.every(function (e) {
            return e instanceof Tensor;
          }), "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors."), r;
        });
      }return r;
    };
  }, e.prototype.write = function (e, t) {
    var n = this.tensorInfo.get(e);if ("string" === n.dtype) {
      var r = bytesFromStringArray(t);this.numBytes += r - n.bytes, n.bytes = r;
    }this.backend !== n.backend && (n.backend.disposeData(e), n.backend = this.backend, this.backend.register(e, n.shape, n.dtype)), this.backend.write(e, t);
  }, e.prototype.readSync = function (e) {
    return this.tensorInfo.get(e).backend.readSync(e);
  }, e.prototype.read = function (e) {
    return this.tensorInfo.get(e).backend.read(e);
  }, e.prototype.fromPixels = function (e, t) {
    return this.backend.fromPixels(e, t);
  }, e.prototype.time = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n;return __generator(this, function (r) {
        switch (r.label) {case 0:
            return t = now(), [4, this.backend.time(e)];case 1:
            return (n = r.sent()).wallMs = now() - t, [2, n];}
      });
    });
  }, e.prototype.track = function (e) {
    if (1 === this.scopeStack.length && this.safeMode) throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {op();...}); to avoid memory leaks.");return null != this.activeScope && this.activeScope.track.push(e), e;
  }, e.nextTensorId = 0, e.nextVariableId = 0, e;
}();function ones(e) {
  var t = makeOnesTypedArray(sizeFromShape(e), "float32");return Tensor.make(e, { values: t });
}!function (e) {
  e[e.NUMBER = 0] = "NUMBER", e[e.BOOLEAN = 1] = "BOOLEAN", e[e.STRING = 2] = "STRING";
}(Type || (Type = {}));var MAX_TEXTURE_SIZE,
    MAX_TEXTURES_IN_SHADER,
    URL_PROPERTIES = [{ name: "DEBUG", type: Type.BOOLEAN }, { name: "IS_BROWSER", type: Type.BOOLEAN }, { name: "WEBGL_LAZILY_UNPACK", type: Type.BOOLEAN }, { name: "WEBGL_CPU_FORWARD", type: Type.BOOLEAN }, { name: "WEBGL_PACK", type: Type.BOOLEAN }, { name: "WEBGL_PACK_BATCHNORMALIZATION", type: Type.BOOLEAN }, { name: "WEBGL_PACK_CLIP", type: Type.BOOLEAN }, { name: "WEBGL_PACK_DEPTHWISECONV", type: Type.BOOLEAN }, { name: "WEBGL_PACK_BINARY_OPERATIONS", type: Type.BOOLEAN }, { name: "WEBGL_CONV_IM2COL", type: Type.BOOLEAN }, { name: "WEBGL_MAX_TEXTURE_SIZE", type: Type.NUMBER }, { name: "WEBGL_NUM_MB_BEFORE_PAGING", type: Type.NUMBER }, { name: "WEBGL_MAX_TEXTURES_IN_SHADER", type: Type.NUMBER }, { name: "WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION", type: Type.NUMBER }, { name: "WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE", type: Type.BOOLEAN }, { name: "WEBGL_VERSION", type: Type.NUMBER }, { name: "WEBGL_RENDER_FLOAT32_ENABLED", type: Type.BOOLEAN }, { name: "WEBGL_DOWNLOAD_FLOAT_ENABLED", type: Type.BOOLEAN }, { name: "WEBGL_FENCE_API_ENABLED", type: Type.BOOLEAN }, { name: "WEBGL_SIZE_UPLOAD_UNIFORM", type: Type.NUMBER }, { name: "BACKEND", type: Type.STRING }, { name: "EPSILON", type: Type.NUMBER }, { name: "PROD", type: Type.BOOLEAN }, { name: "TENSORLIKE_CHECK_SHAPE_CONSISTENCY", type: Type.BOOLEAN }];function isWebGLVersionEnabled(e) {
  try {
    if (null != getWebGLContext(e)) return !0;
  } catch (e) {
    return !1;
  }return !1;
}function getWebGLMaxTextureSize(e) {
  if (null == MAX_TEXTURE_SIZE) {
    var t = getWebGLContext(e);MAX_TEXTURE_SIZE = t.getParameter(t.MAX_TEXTURE_SIZE);
  }return MAX_TEXTURE_SIZE;
}function getMaxTexturesInShader(e) {
  if (null == MAX_TEXTURES_IN_SHADER) {
    var t = getWebGLContext(e);MAX_TEXTURES_IN_SHADER = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
  }return Math.min(16, MAX_TEXTURES_IN_SHADER);
}function getWebGLDisjointQueryTimerVersion(e) {
  if (0 === e) return 0;var t = getWebGLContext(e);return hasExtension(t, "EXT_disjoint_timer_query_webgl2") && 2 === e ? 2 : hasExtension(t, "EXT_disjoint_timer_query") ? 1 : 0;
}function isRenderToFloatTextureEnabled(e) {
  if (0 === e) return !1;var t = getWebGLContext(e);if (1 === e) {
    if (!hasExtension(t, "OES_texture_float")) return !1;
  } else if (!hasExtension(t, "EXT_color_buffer_float")) return !1;return createFloatTextureAndBindToFramebuffer(t, e);
}function isDownloadFloatTextureEnabled(e) {
  if (0 === e) return !1;var t = getWebGLContext(e);if (1 === e) {
    if (!hasExtension(t, "OES_texture_float")) return !1;if (!hasExtension(t, "WEBGL_color_buffer_float")) return !1;
  } else if (!hasExtension(t, "EXT_color_buffer_float")) return !1;return createFloatTextureAndBindToFramebuffer(t, e);
}function isWebGLFenceEnabled(e) {
  return 2 === e && null != getWebGLContext(e).fenceSync;
}function isChrome() {
  return "undefined" != typeof navigator && null != navigator && null != navigator.userAgent && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}var TENSORFLOWJS_FLAGS_PREFIX = "tfjsflags";function getFeaturesFromURL() {
  var e = {};if ("undefined" == typeof window || void 0 === window.location || void 0 === window.location.search) return e;var t = getQueryParams(window.location.search);if (TENSORFLOWJS_FLAGS_PREFIX in t) {
    var n = {};t[TENSORFLOWJS_FLAGS_PREFIX].split(",").forEach(function (e) {
      var t = e.split(":"),
          r = t[0],
          o = t[1];n[r] = o;
    }), URL_PROPERTIES.forEach(function (t) {
      t.name in n && (console.log("Setting feature override from URL " + t.name + ": " + n[t.name]), t.type === Type.NUMBER ? e[t.name] = +n[t.name] : t.type === Type.BOOLEAN ? e[t.name] = "true" === n[t.name] : t.type === Type.STRING ? e[t.name] = n[t.name] : console.warn("Unknown URL param: " + t.name + "."));
    });
  }return e;
}function hasExtension(e, t) {
  return null != e.getExtension(t);
}function createFloatTextureAndBindToFramebuffer(e, t) {
  var n = e.createFramebuffer(),
      r = e.createTexture();e.bindTexture(e.TEXTURE_2D, r);var o = 2 === t ? e.RGBA32F : e.RGBA;e.texImage2D(e.TEXTURE_2D, 0, o, 1, 1, 0, e.RGBA, e.FLOAT, null), e.bindFramebuffer(e.FRAMEBUFFER, n), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, r, 0);var a = e.checkFramebufferStatus(e.FRAMEBUFFER) === e.FRAMEBUFFER_COMPLETE;return e.bindTexture(e.TEXTURE_2D, null), e.bindFramebuffer(e.FRAMEBUFFER, null), e.deleteTexture(r), e.deleteFramebuffer(n), a;
}function getQueryParams(e) {
  var t = {};return e.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, function (e) {
    for (var n = [], r = 1; r < arguments.length; r++) {
      n[r - 1] = arguments[r];
    }return decodeParam(t, n[0], n[1]), n.join("=");
  }), t;
}function decodeParam(e, t, n) {
  e[decodeURIComponent(t)] = decodeURIComponent(n || "");
}var BEFORE_PAGING_CONSTANT = 600;function getNumMBBeforePaging() {
  return window.screen.height * window.screen.width * window.devicePixelRatio * BEFORE_PAGING_CONSTANT / 1024;
}var EPSILON_FLOAT16 = 1e-4,
    TEST_EPSILON_FLOAT16 = .1,
    EPSILON_FLOAT32 = 1e-7,
    TEST_EPSILON_FLOAT32 = .001,
    Environment = function () {
  function e(e) {
    this.features = {}, this.registry = {}, null != e && (this.features = e), this.get("DEBUG") && console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
  }return e.setBackend = function (e, t) {
    if (void 0 === t && (t = !1), !(e in ENV.registry)) throw new Error("Backend name '" + e + "' not found in registry");ENV.engine.backend = ENV.findBackend(e), ENV.backendName = e;
  }, e.getBackend = function () {
    return ENV.initEngine(), ENV.backendName;
  }, e.disposeVariables = function () {
    ENV.engine.disposeVariables();
  }, e.memory = function () {
    return ENV.engine.memory();
  }, e.profile = function (e) {
    return ENV.engine.profile(e);
  }, e.tidy = function (e, t) {
    return ENV.engine.tidy(e, t);
  }, e.dispose = function (e) {
    getTensorsInContainer(e).forEach(function (e) {
      return e.dispose();
    });
  }, e.keep = function (e) {
    return ENV.engine.keep(e);
  }, e.time = function (e) {
    return ENV.engine.time(e);
  }, e.prototype.get = function (e) {
    return e in this.features ? this.features[e] : (this.features[e] = this.evaluateFeature(e), this.features[e]);
  }, e.prototype.getFeatures = function () {
    return this.features;
  }, e.prototype.set = function (e, t) {
    this.features[e] = t;
  }, e.prototype.getBestBackendName = function () {
    var e = this;if (0 === Object.keys(this.registry).length) throw new Error("No backend found in registry.");return Object.keys(this.registry).map(function (t) {
      return { name: t, entry: e.registry[t] };
    }).sort(function (e, t) {
      return t.entry.priority - e.entry.priority;
    })[0].name;
  }, e.prototype.evaluateFeature = function (e) {
    if ("DEBUG" === e) return !1;if ("IS_BROWSER" === e) return "undefined" != typeof window;if ("IS_NODE" === e) return "undefined" != typeof process && void 0 !== process.versions && void 0 !== process.versions.node;if ("IS_CHROME" === e) return isChrome();if ("WEBGL_CPU_FORWARD" === e) return !0;if ("WEBGL_PACK" === e) return !1;if ("WEBGL_PACK_BATCHNORMALIZATION" === e) return this.get("WEBGL_PACK");if ("WEBGL_PACK_CLIP" === e) return this.get("WEBGL_PACK");if ("WEBGL_PACK_DEPTHWISECONV" === e) return this.get("WEBGL_PACK");if ("WEBGL_PACK_BINARY_OPERATIONS" === e) return this.get("WEBGL_PACK");if ("WEBGL_LAZILY_UNPACK" === e) return this.get("WEBGL_PACK");if ("WEBGL_CONV_IM2COL" === e) return this.get("WEBGL_PACK");if ("WEBGL_NUM_MB_BEFORE_PAGING" === e) return this.get("PROD") || !this.get("IS_BROWSER") ? Number.POSITIVE_INFINITY : getNumMBBeforePaging();if ("WEBGL_MAX_TEXTURE_SIZE" === e) return getWebGLMaxTextureSize(this.get("WEBGL_VERSION"));if ("WEBGL_MAX_TEXTURES_IN_SHADER" === e) return getMaxTexturesInShader(this.get("WEBGL_VERSION"));if ("IS_TEST" === e) return !1;if ("BACKEND" === e) return this.getBestBackendName();if ("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION" === e) {
      var t = this.get("WEBGL_VERSION");return 0 === t ? 0 : getWebGLDisjointQueryTimerVersion(t);
    }if ("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE" === e) return this.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && !isMobile();if ("HAS_WEBGL" === e) return this.get("WEBGL_VERSION") > 0;if ("WEBGL_VERSION" === e) return isWebGLVersionEnabled(2) ? 2 : isWebGLVersionEnabled(1) ? 1 : 0;if ("WEBGL_RENDER_FLOAT32_ENABLED" === e) return isRenderToFloatTextureEnabled(this.get("WEBGL_VERSION"));if ("WEBGL_DOWNLOAD_FLOAT_ENABLED" === e) return isDownloadFloatTextureEnabled(this.get("WEBGL_VERSION"));if ("WEBGL_FENCE_API_ENABLED" === e) return isWebGLFenceEnabled(this.get("WEBGL_VERSION"));if ("WEBGL_SIZE_UPLOAD_UNIFORM" === e) return this.get("WEBGL_RENDER_FLOAT32_ENABLED") ? 4 : 0;if ("TEST_EPSILON" === e) return 32 === this.backend.floatPrecision() ? TEST_EPSILON_FLOAT32 : TEST_EPSILON_FLOAT16;if ("EPSILON" === e) return 32 === this.backend.floatPrecision() ? EPSILON_FLOAT32 : EPSILON_FLOAT16;if ("PROD" === e) return !1;if ("TENSORLIKE_CHECK_SHAPE_CONSISTENCY" === e) return !this.get("PROD");throw new Error("Unknown feature " + e + ".");
  }, e.prototype.setFeatures = function (e) {
    this.features = _extends({}, e);
  }, e.prototype.reset = function () {
    this.features = getFeaturesFromURL(), null != this.globalEngine && (this.globalEngine = null);
  }, Object.defineProperty(e.prototype, "backend", { get: function get() {
      return this.engine.backend;
    }, enumerable: !0, configurable: !0 }), e.prototype.findBackend = function (e) {
    return e in this.registry ? this.registry[e].backend : null;
  }, e.prototype.registerBackend = function (e, t, n, r) {
    var o = this;if (void 0 === n && (n = 1), e in this.registry) return console.warn(e + " backend was already registered. Reusing existing backend"), null != r && r(function () {
      return o.engine;
    }), !1;try {
      var a = t();return a.setDataMover({ moveData: function moveData(e) {
          return o.engine.moveData(e);
        } }), this.registry[e] = { backend: a, priority: n }, !0;
    } catch (t) {
      return console.warn("Registration of backend " + e + " failed"), console.warn(t.stack || t.message), !1;
    }
  }, e.prototype.removeBackend = function (e) {
    if (!(e in this.registry)) throw new Error(e + " backend not found in registry");this.registry[e].backend.dispose(), delete this.registry[e];
  }, Object.defineProperty(e.prototype, "engine", { get: function get() {
      return this.initEngine(), this.globalEngine;
    }, enumerable: !0, configurable: !0 }), e.prototype.initEngine = function () {
    var e = this;if (null == this.globalEngine) {
      this.backendName = this.get("BACKEND");var t = this.findBackend(this.backendName);this.globalEngine = new Engine(t, !1, function () {
        return e.get("DEBUG");
      });
    }
  }, e;
}();function getGlobalNamespace() {
  var e;if ("undefined" != typeof window) e = window;else {
    if ("undefined" == typeof process) throw new Error("Could not find a global object");e = process;
  }return e;
}function getOrMakeEnvironment() {
  var e = getGlobalNamespace();return null == e.ENV && (e.ENV = new Environment(getFeaturesFromURL()), setTensorTracker(function () {
    return e.ENV.engine;
  })), e.ENV;
}function enableProdMode() {
  ENV.set("PROD", !0);
}var ENV = getOrMakeEnvironment(),
    environment = Object.freeze({ EPSILON_FLOAT16: EPSILON_FLOAT16, EPSILON_FLOAT32: EPSILON_FLOAT32, Environment: Environment, enableProdMode: enableProdMode, ENV: ENV });function grad(e) {
  return assert(isFunction(e), "The f passed in grad(f) must be a function"), function (t, n) {
    return assert(t instanceof Tensor, "The x passed in grad(f)(x) must be a tensor"), assert(null == n || n instanceof Tensor, "The dy passed in grad(f)(x, dy) must be a tensor"), ENV.engine.tidy(function () {
      var r = ENV.engine.gradients(function () {
        return e(t);
      }, [t], n),
          o = r.value,
          a = r.grads;return null != n && assertShapesMatch(o.shape, n.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)"), checkGrads(a), a[0];
    });
  };
}function grads(e) {
  return assert(isFunction(e), "The f passed in grads(f) must be a function"), function (t, n) {
    return assert(Array.isArray(t) && t.every(function (e) {
      return e instanceof Tensor;
    }), "The args passed in grads(f)(args) must be an array of tensors"), assert(null == n || n instanceof Tensor, "The dy passed in grads(f)(args, dy) must be a tensor"), ENV.engine.tidy(function () {
      var r = ENV.engine.gradients(function () {
        return e.apply(void 0, t);
      }, t, n),
          o = r.value,
          a = r.grads;return null != n && assertShapesMatch(o.shape, n.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), checkGrads(a), a;
    });
  };
}function valueAndGrad(e) {
  return assert(isFunction(e), "The f passed in valueAndGrad(f) must be a function"), function (t, n) {
    assert(t instanceof Tensor, "The x passed in valueAndGrad(f)(x) must be a tensor"), assert(null == n || n instanceof Tensor, "The dy passed in valueAndGrad(f)(x, dy) must be a tensor");var r = ENV.engine.gradients(function () {
      return e(t);
    }, [t], n),
        o = r.grads,
        a = r.value;return checkGrads(o), { grad: o[0], value: a };
  };
}function valueAndGrads(e) {
  return assert(isFunction(e), "The f passed in valueAndGrads(f) must be a function"), function (t, n) {
    assert(Array.isArray(t) && t.every(function (e) {
      return e instanceof Tensor;
    }), "The args passed in valueAndGrads(f)(args) must be array of tensors"), assert(null == n || n instanceof Tensor, "The dy passed in valueAndGrads(f)(args, dy) must be a tensor");var r = ENV.engine.gradients(function () {
      return e.apply(void 0, t);
    }, t, n);return null != n && assertShapesMatch(r.value.shape, n.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), checkGrads(r.grads), r;
  };
}function variableGrads(e, t) {
  if (assert(isFunction(e), "The f passed in variableGrads(f) must be a function"), assert(null == t || Array.isArray(t) && t.every(function (e) {
    return e instanceof Variable;
  }), "The varList passed in variableGrads(f, varList) must be an array of variables"), null == t) for (var n in t = [], ENV.engine.registeredVariables) {
    t.push(ENV.engine.registeredVariables[n]);
  }var r = t.length;assert((t = t.filter(function (e) {
    return e.trainable;
  })).length > 0, "variableGrads() expects at least one of the input variables to be trainable, but none of the " + r + " variables is trainable.");var o = ENV.engine.gradients(e, t, null, !0),
      a = o.value,
      i = o.grads;assert(i.some(function (e) {
    return null != e;
  }), "Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize()."), assert(0 === a.rank, "The f passed in variableGrads(f) must return a scalar, but it returned a rank-" + a.rank + " tensor");var s = {};return t.forEach(function (e, t) {
    null != i[t] && (s[e.name] = i[t]);
  }), { value: a, grads: s };
}function customGrad(e) {
  return ENV.engine.customGrad(e);
}function checkGrads(e) {
  if (e.filter(function (e) {
    return null == e;
  }).length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that\n    the f you passed encloses all operations that lead from x to y.");
}var tidy = Environment.tidy,
    keep = Environment.keep,
    dispose = Environment.dispose,
    time = Environment.time,
    profile = Environment.profile;function warn() {
  for (var e = [], t = 0; t < arguments.length; t++) {
    e[t] = arguments[t];
  }ENV.get("IS_TEST") || console.warn.apply(console, e);
}function getReshaped(e, t, n, r) {
  void 0 === r && (r = !0);var o = [];if (r) (o = o.concat(t.slice(0))).push(e[0] / n), o = o.concat(e.slice(1));else {
    o = o.concat(e[0]);for (var a = t.length, i = 0; i < a; ++i) {
      o = o.concat([e[i + 1] / t[i], t[i]]);
    }o = o.concat(e.slice(a + 1));
  }return o;
}function getPermuted(e, t, n) {
  void 0 === n && (n = !0);var r = [];if (n) {
    r.push(t);for (var o = t + 1; o < e; ++o) {
      o <= 2 * t ? (r.push(o), r.push(o - (t + 1))) : r.push(o);
    }
  } else {
    var a = [],
        i = [];for (o = 1; o < e; ++o) {
      o >= 2 * t + 1 || o % 2 == 1 ? i.push(o) : a.push(o);
    }r.push.apply(r, a), r.push(0), r.push.apply(r, i);
  }return r;
}function getReshapedPermuted(e, t, n, r) {
  void 0 === r && (r = !0);var o = [];r ? o.push(e[0] / n) : o.push(e[0] * n);for (var a = 1; a < e.length; ++a) {
    a <= t.length ? r ? o.push(t[a - 1] * e[a]) : o.push(e[a] / t[a - 1]) : o.push(e[a]);
  }return o;
}function getSliceBeginCoords(e, t) {
  for (var n = [0], r = 0; r < t; ++r) {
    n.push(e[r][0]);
  }return n;
}function getSliceSize(e, t, n) {
  for (var r = e.slice(0, 1), o = 0; o < n; ++o) {
    r.push(e[o + 1] - t[o][0] - t[o][1]);
  }return r;
}function axesAreInnerMostDims(e, t) {
  for (var n = 0; n < e.length; ++n) {
    if (e[e.length - n - 1] !== t - 1 - n) return !1;
  }return !0;
}function combineLocations(e, t, n) {
  for (var r = e.length + t.length, o = [], a = 0, i = 0, s = 0; s < r; s++) {
    -1 === n.indexOf(s) ? o.push(e[a++]) : o.push(t[i++]);
  }return o;
}function computeOutAndReduceShapes(e, t) {
  for (var n = [], r = e.length, o = 0; o < r; o++) {
    -1 === t.indexOf(o) && n.push(e[o]);
  }return [n, t.map(function (t) {
    return e[t];
  })];
}function expandShapeToKeepDim(e, t) {
  return combineLocations(e, t.map(function (e) {
    return 1;
  }), t);
}function assertAxesAreInnerMostDims(e, t, n) {
  assert(axesAreInnerMostDims(t, n), e + " supports only inner-most axes for now. Got axes " + t + " and rank-" + n + " input.");
}function getAxesPermutation(e, t) {
  if (axesAreInnerMostDims(e, t)) return null;for (var n = [], r = 0; r < t; ++r) {
    -1 === e.indexOf(r) && n.push(r);
  }return e.forEach(function (e) {
    return n.push(e);
  }), n;
}function getUndoAxesPermutation(e) {
  return e.map(function (e, t) {
    return [t, e];
  }).sort(function (e, t) {
    return e[1] - t[1];
  }).map(function (e) {
    return e[0];
  });
}function getInnerMostAxes(e, t) {
  for (var n = [], r = t - e; r < t; ++r) {
    n.push(r);
  }return n;
}function getBroadcastDims(e, t) {
  for (var n = e.length, r = [], o = 0; o < n; o++) {
    var a = n - 1 - o,
        i = e[a] || 1;(t[t.length - 1 - o] || 1) > 1 && 1 === i && r.unshift(a);
  }return r;
}function getReductionAxes(e, t) {
  for (var n = [], r = 0; r < t.length; r++) {
    var o = e[e.length - r - 1],
        a = t.length - r - 1,
        i = t[a];(null == o || 1 === o && i > 1) && n.unshift(a);
  }return n;
}function assertAndGetBroadcastShape(e, t) {
  for (var n = [], r = Math.max(e.length, t.length), o = 0; o < r; o++) {
    var a = e[e.length - o - 1];null == a && (a = 1);var i = t[t.length - o - 1];if (null == i && (i = 1), 1 === a) n.unshift(i);else if (1 === i) n.unshift(a);else {
      if (a !== i) throw Error("Operands could not be broadcast together with shapes " + e + " and " + t + ".");n.unshift(a);
    }
  }return n;
}function assertParamsConsistent(e, t) {
  var n = e[0].length;e.forEach(function (e, t) {
    assert(e.length === n, "Error in concat" + n + "D: rank of tensors[" + t + "] must be the same as the rank of the rest (" + n + ")");
  }), assert(t >= 0 && t < n, "Error in concat" + n + "D: axis must be between 0 and " + (n - 1) + ".");var r = e[0];e.forEach(function (e, o) {
    for (var a = 0; a < n; a++) {
      assert(a === t || e[a] === r[a], "Error in concat" + n + "D: Shape of tensors[" + o + "] (" + e + ") does not match the shape of the rest (" + r + ") along the non-concatenated axis " + o + ".");
    }
  });
}function computeOutShape(e, t) {
  for (var n = e[0].slice(), r = 1; r < e.length; r++) {
    n[t] += e[r][t];
  }return n;
}function prepareAndValidate(e, t) {
  if (e.rank < 1) throw new Error("tf.gatherND() expects the input to be rank 1 or higher, but the rank was " + e.rank + ".");if (t.rank < 1) throw new Error("tf.gatherND() expects the indices to be rank 1 or higher, but the rank was " + t.rank + ".");if ("int32" !== t.dtype) throw new Error("tf.gatherND() expects the indices to be int32 type, but the dtype was " + t.dtype + ".");if (t.shape[t.rank - 1] > e.rank) throw new Error("index innermost dimension length must be <= tensor rank; saw: " + t.shape[t.rank - 1] + " vs. " + e.rank);if (0 === e.size) throw new Error("Requested more than 0 entries, but input is empty. Input shape: " + e.shape + ".");for (var n = t.shape, r = n[n.length - 1], o = 1, a = 0; a < n.length - 1; ++a) {
    o *= n[a];
  }var i = e.shape,
      s = n.slice();s.pop();var u = 1;for (a = r; a < e.rank; ++a) {
    u *= i[a], s.push(i[a]);
  }var l = computeStrides(e.shape).map(function (e) {
    return e / u;
  }).concat([1]).slice(0, r);return [s, o, u, l];
}var PARALLELIZE_THRESHOLD = 30;function computeOptimalWindowSize(e) {
  return e <= PARALLELIZE_THRESHOLD ? e : nearestDivisor(e, Math.floor(Math.sqrt(e)));
}function validateUpdateShape(e, t, n) {
  var r = t.rank > 1 ? t.shape[t.rank - 1] : 1,
      o = t.rank > 1 ? t.rank - 1 : 1,
      a = "Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: " + n.shape + ", indices.shape: " + t.shape + ", shape: " + e + ", sliceDim: " + r + ", and batchDim: " + o + ".";if (n.rank < o) throw new Error(a + " update.rank < " + o + ". ");if (e.length < r + (n.rank - o)) throw new Error(a + " Output shape length < " + (r + (n.rank - o)));if (n.rank !== o + e.length - r) throw new Error(a + " update.rank != " + (o + e.length - r));for (var i = 0; i < o; ++i) {
    if (n.shape[i] !== t.shape[i]) throw new Error(a + " updates.shape[" + i + "] (" + n.shape[i] + ") != indices.shape[" + i + "] (" + t.shape[i] + ").");
  }for (i = 0; i < n.rank - o; ++i) {
    if (n.shape[i + o] !== e[i + r]) throw new Error(a + " updates.shape[" + (i + o) + "] (" + n.shape[i + o] + ") != shape[" + (i + o) + "] (" + e[i + o] + ")");
  }
}function validateInput(e, t, n) {
  if (t.rank < 1) throw new Error("tf.scatterND() expects the indices to be rank 1 or higher, but the rank was " + t.rank + ".");if (e.rank < 1) throw new Error("tf.scatterND() expects the updates to be rank 1 or higher, but the rank was " + e.rank + ".");if ("int32" !== t.dtype) throw new Error("The dtype of 'indices' should be int32, but got dtype: " + t.dtype);if (n.length < 1) throw new Error("Output rank must be greater or equal to 1, but got shape: " + n);if (0 === n.length) {
    if (0 === t.size) throw new Error("Indices specified for empty output. indices shape: " + t.shape);if (0 === e.size) throw new Error("Updates specified for empty output. updates shape: " + e.shape);
  }validateUpdateShape(n, t, e);
}function calculateShapes(e, t, n) {
  for (var r = t.rank > 1 ? t.shape[t.rank - 1] : 1, o = n.length, a = 1, i = r; i < o; ++i) {
    a *= n[i];
  }var s = r < 1 ? 1 : r;return { sliceRank: r, numUpdates: t.size / s, sliceSize: a, strides: computeStrides(n.slice(0, r)).concat([1]), outputSize: sizeFromShape(n) };
}function segOpComputeOptimalWindowSize(e, t) {
  var n,
      r = !1;for (e <= PARALLELIZE_THRESHOLD ? (n = e, r = !0) : n = nearestDivisor(e, Math.floor(Math.sqrt(e))); !r;) {
    if (n > t || n === e) {
      r = !0;break;
    }n = nearestDivisor(e, n + 1);
  }return n;
}function computeOutShape$1(e, t, n) {
  for (var r = [], o = e.length, a = 0; a < o; a++) {
    a !== t ? r.push(e[a]) : r.push(n);
  }return r;
}function assertParamsValid(e, t, n) {
  assert(e.rank === t.length, "Error in slice" + e.rank + "D: Length of begin " + t + " must match the rank of the array (" + e.rank + ")."), assert(e.rank === n.length, "Error in slice" + e.rank + "D: Length of size " + n + " must match the rank of the array (" + e.rank + ").");for (var r = 0; r < e.rank; ++r) {
    assert(t[r] + n[r] <= e.shape[r], "Error in slice" + e.rank + "D: begin[" + r + "] + size[" + r + "] (" + (t[r] + n[r]) + ") would overflow input.shape[" + r + "] (" + e.shape[r] + ")");
  }
}function getStridedSlicedInfo(e, t, n, r, o, a, i, s, u) {
  if (void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), void 0 === u && (u = 0), 0 !== i) throw new Error("ellipsis mask is not yet supported");if (0 !== s) throw new Error("new axis mask is not yet supported");for (var l = [], c = [], p = [], d = 0; d < e.length; d++) {
    l[d] = startForAxis(o, t, r, e, d), c[d] = stopForAxis(a, n, r, e, d), u & 1 << d && (c[d] = l[d] + 1, p.push(d));
  }var h = new Array(e.length).fill(0);return h = h.map(function (e, t) {
    for (var n = 0, o = l[t]; !(r[t] > 0 ? o >= c[t] : o <= c[t]); o += r[t]) {
      n += 1;
    }return n;
  }), [l, h, p];
}function startForAxis(e, t, n, r, o) {
  var a = t[o];e & 1 << o && (a = n[o] > 0 ? Number.MIN_SAFE_INTEGER : Number.MAX_SAFE_INTEGER);var i = r[o];return a < 0 && (a += i), a = clamp(0, a, i - 1);
}function stopForAxis(e, t, n, r, o) {
  var a = t[o];e & 1 << o && (a = n[o] > 0 ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER);var i = r[o];return a < 0 && (a += i), a = n[o] > 0 ? clamp(0, a, i) : clamp(-1, a, i - 1);
}function isSliceContinous(e, t, n) {
  for (var r = n.length, o = 0; o < n.length; o++) {
    if (n[o] > 1) {
      r = o;break;
    }
  }for (o = r + 1; o < n.length; o++) {
    if (t[o] > 0 || n[o] !== e[o]) return !1;
  }return !0;
}function computeFlatOffset(e, t) {
  for (var n = e.length > 0 ? e[e.length - 1] : 1, r = 0; r < e.length - 1; r++) {
    n += e[r] * t[r];
  }return n;
}function inferShape(e) {
  var t = e;if (isTypedArray(e)) return [e.length];if (!Array.isArray(e)) return [];for (var n = []; t instanceof Array || isTypedArray(t);) {
    n.push(t.length), t = t[0];
  }return e instanceof Array && ENV.get("TENSORLIKE_CHECK_SHAPE_CONSISTENCY") && deepAssertShapeConsistency(e, n, []), n;
}function deepAssertShapeConsistency(e, t, n) {
  if (n = n || [], e instanceof Array || isTypedArray(e)) {
    assert(t.length > 0, function () {
      return "Element arr[" + n.join("][") + "] should be a primitive, but is an array of " + e.length + " elements";
    }), assert(e.length === t[0], function () {
      return "Element arr[" + n.join("][") + "] should have " + t[0] + " elements, but has " + e.length + " elements";
    });for (var r = t.slice(1), o = 0; o < e.length; ++o) {
      deepAssertShapeConsistency(e[o], r, n.concat(o));
    }
  } else assert(0 === t.length, function () {
    return "Element arr[" + n.join("][") + "] is a primitive, but should be an array/TypedArray of " + t[0] + " elements";
  });
}function assertDtype(e, t, n, r) {
  if (null != e && ("numeric" !== e && e !== t || "numeric" === e && "string" === t)) throw new Error("Argument '" + n + "' passed to '" + r + "' must be " + e + " tensor, but got " + t + " tensor");
}function convertToTensor(e, t, n, r) {
  if (void 0 === r && (r = "numeric"), e instanceof Tensor) return assertDtype(r, e.dtype, t, n), e;var o = inferDtype(e);if ("string" !== o && ["bool", "int32", "float32"].indexOf(r) >= 0 && (o = r), assertDtype(r, o, t, n), !isTypedArray(e) && !Array.isArray(e) && "number" != typeof e && "boolean" != typeof e && "string" != typeof e) throw new Error("Argument '" + t + "' passed to '" + n + "' must be a Tensor or TensorLike, but got '" + e.constructor.name + "'");var a = inferShape(e);isTypedArray(e) || Array.isArray(e) || (e = [e]);var i = "string" !== o ? toTypedArray(e, o, ENV.get("DEBUG")) : flatten(e);return Tensor.make(a, { values: i }, o);
}function convertToTensorArray(e, t, n) {
  if (!Array.isArray(e)) throw new Error("Argument " + t + " passed to " + n + " must be a `Tensor[]` or `TensorLike[]`");return e.map(function (e, r) {
    return convertToTensor(e, t + "[" + r + "]", n);
  });
}function op(e) {
  var t = Object.keys(e);if (1 !== t.length) throw new Error("Please provide an object with a single key (operation name) mapping to a function. Got an object with " + t.length + " keys.");var n = t[0],
      r = e[n];n.endsWith("_") && (n = n.substring(0, n.length - 1));var o = function o() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }ENV.engine.startScope(n);try {
      var o = r.apply(void 0, e);return o instanceof Promise && console.error("Cannot return a Promise inside of tidy."), ENV.engine.endScope(o), o;
    } catch (e) {
      throw ENV.engine.endScope(null), e;
    }
  };return Object.defineProperty(o, "name", { value: n, configurable: !0 }), o;
}function softmax_(e, t) {
  void 0 === t && (t = -1);var n = convertToTensor(e, "logits", "softmax");if (-1 === t && (t = n.rank - 1), t !== n.rank - 1) throw Error("Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and dim was " + t);return customGrad(function (e) {
    var n = e.logSumExp([t], !0),
        r = e.toFloat().sub(n).exp();return { value: r, gradFunc: function gradFunc(e) {
        var n = e.mul(r);return n.sub(n.sum([t], !0).mul(r));
      } };
  })(n);
}function logSoftmax_(e, t) {
  void 0 === t && (t = -1);var n = convertToTensor(e, "logits", "logSoftmax");if (-1 === t && (t = n.rank - 1), t !== n.rank - 1) throw Error("Log Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and axis was " + t);return customGrad(function (e) {
    var n = e.max(t, !0),
        r = e.sub(n),
        o = r.toFloat().sub(r.exp().sum(t, !0).log());return { value: o, gradFunc: function gradFunc(e) {
        var n = o.exp();return e.sub(e.sum(t, !0).mul(n));
      } };
  })(n);
}var softmax = op({ softmax_: softmax_ }),
    logSoftmax = op({ logSoftmax_: logSoftmax_ });function complex_(e, t) {
  var n = convertToTensor(e, "real", "complex"),
      r = convertToTensor(t, "imag", "complex");return assertShapesMatch(n.shape, r.shape, "real and imag shapes, " + n.shape + " and " + r.shape + ", must match in call to tf.complex()."), ENV.engine.runKernel(function (e) {
    return e.complex(n, r);
  }, { $real: n, $imag: r });
}function real_(e) {
  var t = convertToTensor(e, "input", "real");return ENV.engine.runKernel(function (e) {
    return e.real(t);
  }, { $input: t });
}function imag_(e) {
  var t = convertToTensor(e, "input", "imag");return ENV.engine.runKernel(function (e) {
    return e.imag(t);
  }, { $input: t });
}var complex = op({ complex_: complex_ }),
    real = op({ real_: real_ }),
    imag = op({ imag_: imag_ });function tensor(e, t, n) {
  if (null == n && (n = inferDtype(e)), "complex64" === n) throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");if (!isTypedArray(e) && !Array.isArray(e) && "number" != typeof e && "boolean" != typeof e && "string" != typeof e) throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");var r = inferShape(e);if (null != t) {
    var o = sizeFromShape(t),
        a = sizeFromShape(r);assert(o === a, function () {
      return "Based on the provided shape, [" + t + "], the tensor should have " + o + " values but has " + a;
    });for (var i = 0; i < r.length; ++i) {
      var s = r[i],
          u = i !== r.length - 1 || s !== sizeFromShape(t.slice(i));assert(r[i] === t[i] || !u, function () {
        return "Error creating a new Tensor. Inferred shape (" + r + ") does not match the provided shape (" + t + "). ";
      });
    }
  }return isTypedArray(e) || Array.isArray(e) || (e = [e]), t = t || r, e = "string" !== n ? toTypedArray(e, n, ENV.get("DEBUG")) : flatten(e), Tensor.make(t, { values: e }, n);
}function scalar(e, t) {
  if ((isTypedArray(e) || Array.isArray(e)) && "complex64" !== t) throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");return tensor(e, [], t);
}function tensor1d(e, t) {
  assertNonNull(e);var n = inferShape(e);if (1 !== n.length) throw new Error("tensor1d() requires values to be a flat/TypedArray");return tensor(e, n, t);
}function tensor2d(e, t, n) {
  if (assertNonNull(e), null != t && 2 !== t.length) throw new Error("tensor2d() requires shape to have two numbers");var r = inferShape(e);if (2 !== r.length && 1 !== r.length) throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");if (1 === r.length && null == t) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");return tensor(e, t = t || r, n);
}function tensor3d(e, t, n) {
  if (assertNonNull(e), null != t && 3 !== t.length) throw new Error("tensor3d() requires shape to have three numbers");var r = inferShape(e);if (3 !== r.length && 1 !== r.length) throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");if (1 === r.length && null == t) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");return tensor(e, t = t || r, n);
}function tensor4d(e, t, n) {
  if (assertNonNull(e), null != t && 4 !== t.length) throw new Error("tensor4d() requires shape to have four numbers");var r = inferShape(e);if (4 !== r.length && 1 !== r.length) throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");if (1 === r.length && null == t) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");return tensor(e, t = t || r, n);
}function tensor5d(e, t, n) {
  if (assertNonNull(e), null != t && 5 !== t.length) throw new Error("tensor5d() requires shape to have five numbers");var r = inferShape(e);if (5 !== r.length && 1 !== r.length) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");if (1 === r.length && null == t) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");return tensor(e, t = t || r, n);
}function tensor6d(e, t, n) {
  if (assertNonNull(e), null != t && 6 !== t.length) throw new Error("tensor6d() requires shape to have six numbers");var r = inferShape(e);if (6 !== r.length && 1 !== r.length) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");if (1 === r.length && null == t) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");return tensor(e, t = t || r, n);
}function ones$1(e, t) {
  if (void 0 === t && (t = "float32"), "complex64" === t) {
    var n = ones$1(e, "float32"),
        r = ones$1(e, "float32");return complex(n, r);
  }var o = makeOnesTypedArray(sizeFromShape(e), t);return Tensor.make(e, { values: o }, t);
}function zeros(e, t) {
  if (void 0 === t && (t = "float32"), "complex64" === t) {
    var n = zeros(e, "float32"),
        r = zeros(e, "float32");return complex(n, r);
  }var o = makeZerosTypedArray(sizeFromShape(e), t);return Tensor.make(e, { values: o }, t);
}function fill(e, t, n) {
  var r = getArrayFromDType(n = n || inferDtype(t), sizeFromShape(e));return r.fill(t), Tensor.make(e, { values: r }, n);
}function onesLike_(e) {
  var t = convertToTensor(e, "x", "onesLike");return ones$1(t.shape, t.dtype);
}function zerosLike_(e) {
  var t = convertToTensor(e, "x", "zerosLike");return zeros(t.shape, t.dtype);
}function linspace(e, t, n) {
  if (0 === n) throw new Error("Cannot request zero samples");var r = (t - e) / (n - 1),
      o = makeZerosTypedArray(n, "float32");o[0] = e;for (var a = 1; a < o.length; a++) {
    o[a] = o[a - 1] + r;
  }return tensor1d(o, "float32");
}function range(e, t, n, r) {
  if (void 0 === n && (n = 1), void 0 === r && (r = "float32"), 0 === n) throw new Error("Cannot have a step of zero");if (e === t || e < t && n < 0 || t < e && n > 1) return zeros([0], r);var o = makeZerosTypedArray(Math.abs(Math.ceil((t - e) / n)), r);t < e && 1 === n && (n = -1), o[0] = e;for (var a = 1; a < o.length; a++) {
    o[a] = o[a - 1] + n;
  }return tensor1d(o, r);
}var onesLike = op({ onesLike_: onesLike_ }),
    zerosLike = op({ zerosLike_: zerosLike_ }),
    DataStorage = function () {
  function e(e) {
    this.dataMover = e, this.data = new WeakMap();
  }return e.prototype.get = function (e) {
    return this.data.has(e) || this.dataMover.moveData(e), this.data.get(e);
  }, e.prototype.set = function (e, t) {
    this.data.set(e, t);
  }, e.prototype.has = function (e) {
    return this.data.has(e);
  }, e.prototype.delete = function (e) {
    return this.data.delete(e);
  }, e;
}(),
    KernelBackend = function () {
  function e() {}return e.prototype.time = function (e) {
    throw new Error("Not yet implemented.");
  }, e.prototype.read = function (e) {
    throw new Error("Not yet implemented.");
  }, e.prototype.readSync = function (e) {
    throw new Error("Not yet implemented.");
  }, e.prototype.disposeData = function (e) {
    throw new Error("Not yet implemented.");
  }, e.prototype.write = function (e, t) {
    throw new Error("Not yet implemented.");
  }, e.prototype.fromPixels = function (e, t) {
    throw new Error("Not yet implemented.");
  }, e.prototype.register = function (e, t, n) {
    throw new Error("Not yet implemented.");
  }, e.prototype.memory = function () {
    throw new Error("Not yet implemented.");
  }, e.prototype.floatPrecision = function () {
    throw new Error("Not yet implemented");
  }, e.prototype.batchMatMul = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.slice = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.stridedSlice = function (e, t, n, r, o, a, i, s, u) {
    throw new Error("Not yet implemented");
  }, e.prototype.unstack = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.reverse = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.concat = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.neg = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.add = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.addN = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.subtract = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.multiply = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.realDivide = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.floorDiv = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.sum = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.prod = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.unsortedSegmentSum = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.argMin = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.argMax = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.equal = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.notEqual = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.less = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.lessEqual = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.greater = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.greaterEqual = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.logicalNot = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.logicalAnd = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.logicalOr = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.where = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.select = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.topk = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.min = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.minimum = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.mod = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.max = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.maximum = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.all = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.any = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.squaredDifference = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.ceil = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.floor = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.round = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.sign = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.pow = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.exp = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.expm1 = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.log = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.log1p = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.sqrt = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.rsqrt = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.square = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.reciprocal = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.relu = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.prelu = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.elu = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.eluDer = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.selu = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.int = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.clip = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.abs = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.complexAbs = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.sigmoid = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.softplus = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.sin = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.cos = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.tan = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.asin = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.acos = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.atan = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.atan2 = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.sinh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.cosh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.tanh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.asinh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.acosh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.atanh = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.erf = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.step = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv2d = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv2dDerInput = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv2dDerFilter = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.depthwiseConv2D = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv3d = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv3dDerInput = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.conv3dDerFilter = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.maxPool = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.avgPool = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.avgPoolBackprop = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.reshape = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.cast = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.tile = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.pad = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.transpose = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.gather = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.gatherND = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.scatterND = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.batchToSpaceND = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.spaceToBatchND = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.resizeBilinear = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.batchNormalization = function (e, t, n, r, o, a) {
    throw new Error("Not yet implemented");
  }, e.prototype.localResponseNormalization4D = function (e, t, n, r, o) {
    throw new Error("Not yet implemented");
  }, e.prototype.LRNGrad = function (e, t, n, r, o, a, i) {
    throw new Error("Not yet implemented");
  }, e.prototype.multinomial = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.oneHot = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.cumsum = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.nonMaxSuppression = function (e, t, n, r, o) {
    throw new Error("Not yet implemented");
  }, e.prototype.fft = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.ifft = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.complex = function (e, t) {
    throw new Error("Not yet implemented");
  }, e.prototype.real = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.imag = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.cropAndResize = function (e, t, n, r, o, a) {
    throw new Error("Not yet implemented");
  }, e.prototype.depthToSpace = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.split = function (e, t, n) {
    throw new Error("Not yet implemented");
  }, e.prototype.sparseToDense = function (e, t, n, r) {
    throw new Error("Not yet implemented");
  }, e.prototype.setDataMover = function (e) {
    throw new Error("Not yet implemented");
  }, e.prototype.dispose = function () {
    throw new Error("Not yet implemented");
  }, e;
}();function castTensor(e, t, n) {
  if ("complex64" === t) {
    if ("complex64" === e.dtype) return e.clone();var r = zeros(e.shape),
        o = e.toFloat(),
        a = n.complex(o, r);return r.dispose(), o.dispose(), a;
  }if (!hasEncodingLoss(e.dtype, t)) return Tensor.make(e.shape, { dataId: e.dataId }, t);if ("complex64" === e.dtype) {
    var i = n.real(e);a = i.cast(t);return i.dispose(), a;
  }if ("int32" === t) return n.int(e);if ("bool" === t) {
    var s = scalar(0, e.dtype);a = n.notEqual(e, s);return s.dispose(), a;
  }throw new Error("Error in Cast: unknown dtype argument (" + t + ")");
}function reshapeTensor(e, t) {
  return Tensor.make(t, { dataId: e.dataId }, e.dtype);
}function mergeRealAndImagArrays(e, t) {
  if (e.length !== t.length) throw new Error("Cannot merge real and imag arrays of different lengths. real:" + e.length + ", imag: " + t.length + ".");for (var n = new Float32Array(2 * e.length), r = 0; r < n.length; r += 2) {
    n[r] = e[r / 2], n[r + 1] = t[r / 2];
  }return n;
}function splitRealAndImagArrays(e) {
  for (var t = new Float32Array(e.length / 2), n = new Float32Array(e.length / 2), r = 0; r < e.length; r += 2) {
    t[r / 2] = e[r], n[r / 2] = e[r + 1];
  }return { real: t, imag: n };
}function complexWithEvenIndex(e) {
  for (var t = Math.ceil(e.length / 4), n = new Float32Array(t), r = new Float32Array(t), o = 0; o < e.length; o += 4) {
    n[Math.floor(o / 4)] = e[o], r[Math.floor(o / 4)] = e[o + 1];
  }return { real: n, imag: r };
}function complexWithOddIndex(e) {
  for (var t = Math.floor(e.length / 4), n = new Float32Array(t), r = new Float32Array(t), o = 2; o < e.length; o += 4) {
    n[Math.floor(o / 4)] = e[o], r[Math.floor(o / 4)] = e[o + 1];
  }return { real: n, imag: r };
}function getComplexWithIndex(e, t) {
  return { real: e[2 * t], imag: e[2 * t + 1] };
}function assignToTypedArray(e, t, n, r) {
  e[2 * r] = t, e[2 * r + 1] = n;
}function exponents(e, t) {
  for (var n = new Float32Array(e / 2), r = new Float32Array(e / 2), o = 0; o < Math.ceil(e / 2); o++) {
    var a = (t ? 2 : -2) * Math.PI * (o / e);n[o] = Math.cos(a), r[o] = Math.sin(a);
  }return { real: n, imag: r };
}function exponent(e, t, n) {
  var r = (n ? 2 : -2) * Math.PI * (e / t);return { real: Math.cos(r), imag: Math.sin(r) };
}function nonMaxSuppressionImpl(e, t, n, r, o) {
  for (var a = Array.from(t).map(function (e, t) {
    return { score: e, boxIndex: t };
  }).filter(function (e) {
    return e.score > o;
  }).sort(function (e, t) {
    return t.score - e.score;
  }), i = [], s = 0; s < a.length; s++) {
    var u = a[s],
        l = u.score,
        c = u.boxIndex;if (l < o) break;for (var p = !1, d = i.length - 1; d >= 0; --d) {
      if (intersectionOverUnion(e, c, i[d]) >= r) {
        p = !0;break;
      }
    }if (!p && (i.push(c), i.length >= n)) break;
  }return tensor1d(i, "int32");
}function intersectionOverUnion(e, t, n) {
  var r = e.subarray(4 * t, 4 * t + 4),
      o = e.subarray(4 * n, 4 * n + 4),
      a = Math.min(r[0], r[2]),
      i = Math.min(r[1], r[3]),
      s = Math.max(r[0], r[2]),
      u = Math.max(r[1], r[3]),
      l = Math.min(o[0], o[2]),
      c = Math.min(o[1], o[3]),
      p = Math.max(o[0], o[2]),
      d = Math.max(o[1], o[3]),
      h = (s - a) * (u - i),
      f = (p - l) * (d - c);if (h <= 0 || f <= 0) return 0;var m = Math.max(a, l),
      g = Math.max(i, c),
      v = Math.min(s, p),
      y = Math.min(u, d),
      x = Math.max(v - m, 0) * Math.max(y - g, 0);return x / (h + f - x);
}function split(e, t, n) {
  var r = new Array(e.rank).fill(0),
      o = e.shape.slice();return t.map(function (t) {
    o[n] = t;var a = e.slice(r, o);return r[n] += t, a;
  });
}function topkImpl(e, t, n, r, o) {
  for (var a = t[t.length - 1], i = [e.length / a, a], s = i[0], u = i[1], l = getTypedArrayFromDType(n, s * r), c = getTypedArrayFromDType("int32", s * r), p = 0; p < s; p++) {
    for (var d = p * u, h = e.subarray(d, d + u), f = [], m = 0; m < h.length; m++) {
      f.push({ value: h[m], index: m });
    }f.sort(function (e, t) {
      return t.value - e.value;
    });var g = p * r,
        v = l.subarray(g, g + r),
        y = c.subarray(g, g + r);for (m = 0; m < r; m++) {
      v[m] = f[m].value, y[m] = f[m].index;
    }
  }var x = t.slice();return x[x.length - 1] = r, [tensor(l, x, n), tensor(c, x, "int32")];
}var ArgMinMaxProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["A"];var r = e.windowSize,
        o = e.batchSize,
        a = e.inSize,
        i = Math.ceil(a / r);n || this.variableNames.push("bestIndicesA"), this.outputShape = [o, i];var s = "max" === t ? ">" : "<",
        u = n ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + r + ";\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < " + r + "; i++) {\n          int inIdx = " + u + ";\n          float candidate = getA(batch, inIdx);\n          if (candidate " + s + " bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    ";
  };
}(),
    AvgPool2DBackpropProgram = function () {
  return function (e) {
    this.variableNames = ["dy"], this.outputShape = e.inShape;var t = e.filterHeight,
        n = e.filterWidth,
        r = e.strideHeight,
        o = e.strideWidth,
        a = e.dilationHeight,
        i = e.dilationWidth,
        s = e.effectiveFilterHeight,
        u = e.effectiveFilterWidth,
        l = s - 1 - e.padInfo.top,
        c = u - 1 - e.padInfo.left,
        p = 1 / (t * n);this.userCode = "\n      const ivec2 pads = ivec2(" + l + ", " + c + ");\n      const float avgMultiplier = float(" + p + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + s + ";\n            wR += " + a + ") {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + u + ";\n            wC+= " + i + ") {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    BatchNormProgram = function () {
  return function (e, t, n, r, o, a) {
    this.outputShape = [], this.variableNames = ["x", "mean", "variance"], assertAndGetBroadcastShape(e, t), assertAndGetBroadcastShape(e, n);var i = "0.0";null != r && (assertAndGetBroadcastShape(e, r), this.variableNames.push("offset"), i = "getOffsetAtOutCoords()");var s = "1.0";null != o && (assertAndGetBroadcastShape(e, o), this.variableNames.push("scale"), s = "getScaleAtOutCoords()"), this.outputShape = e, this.userCode = "\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = " + i + ";\n        float scale = " + s + ";\n        float inv = scale * inversesqrt(variance + float(" + a + "));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    ";
  };
}(),
    BatchNormPackedProgram = function () {
  return function (e, t, n, r, o, a) {
    this.usesPackedTextures = !0, this.variableNames = ["x", "mean", "variance"], assertAndGetBroadcastShape(e, t), assertAndGetBroadcastShape(e, n);var i = "vec4(0.0)";null != r && (assertAndGetBroadcastShape(e, r), this.variableNames.push("offset"), i = "getOffsetAtOutCoords()");var s = "vec4(1.0)";null != o && (assertAndGetBroadcastShape(e, o), this.variableNames.push("scale"), s = "getScaleAtOutCoords()"), this.outputShape = e, this.userCode = "\n      void main() {\n        vec4 offset = " + i + ";\n        vec4 scale = " + s + ";\n\n        vec4 x = getXAtOutCoords();\n        vec4 mean = getMeanAtOutCoords();\n        vec4 variance = getVarianceAtOutCoords();\n\n        vec4 inv = scale * inversesqrt(variance + vec4(" + a + "));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    ";
  };
}(),
    COMPLEX_MULTIPLY = { REAL: "return areal * breal - aimag * bimag;", IMAG: "return areal * bimag + aimag * breal;" },
    BinaryOpComplexProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["AReal", "AImag", "BReal", "BImag"], this.outputShape = assertAndGetBroadcastShape(t, n), this.userCode = "\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        " + e + "\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    ";
  };
}(),
    CHECK_NAN_SNIPPET = "\n  if (isNaN(a)) return a;\n  if (isNaN(b)) return b;\n",
    ADD = "return a + b;",
    SUB = "return a - b;",
    MUL = "return a * b;",
    DIV = "if (a == b) return 1.0;\n  return a / b;",
    INT_DIV = "\n  float resultSign = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  int result = ia / ib;\n  int amodb = ia - ib * result;\n\n  if (resultSign < 0.0 && amodb != 0) {\n    result -= 1;\n  }\n  return float(result);\n",
    POW = "\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nreturn (round(mod(b, 2.0)) != 1) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n",
    SQUARED_DIFFERENCE = "return (a - b) * (a - b);",
    EQUAL = "return float(a == b);",
    NOT_EQUAL = "return float(a != b);",
    LESS = "return float(a < b);",
    LESS_EQUAL = "return float(a <= b);",
    GREATER = "return float(a > b);",
    GREATER_EQUAL = "return float(a >= b);",
    LOGICAL_AND = "return float(a >= 1.0 && b >= 1.0);",
    LOGICAL_OR = "return float(a >= 1.0 || b >= 1.0);",
    MAX = CHECK_NAN_SNIPPET + "\n  return max(a, b);\n",
    MIN = CHECK_NAN_SNIPPET + "\n  return min(a, b);\n",
    MOD = "if (b == 0.0) return NAN;\n  return mod(a, b);",
    ATAN2 = CHECK_NAN_SNIPPET + "\n  return atan(a, b);\n",
    ELU_DER = "return (b >= 1.0) ? a : a * (b + 1.0);",
    PRELU = "return (a < 0.) ? b * a : a;",
    BinaryOpProgram = function () {
  function e(e, t, n) {
    this.variableNames = ["A", "B"], this.outputShape = assertAndGetBroadcastShape(t, n), this.userCode = "\n      uniform float NAN;\n      float binaryOperation(float a, float b) {\n        " + e + "\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function () {
    var e = this;return function (t, n) {
      null == e.startLoc && (e.startLoc = t.getUniformLocationNoThrow(n, "NAN"), null == e.startLoc) || t.gl.uniform1f(e.startLoc, NaN);
    };
  }, e;
}(),
    PACKED_DIV = "\n  vec4 one = vec4(equal(a, b));\n  return one + (vec4(1.0) - one) * a / b;\n",
    PACKED_INT_DIV = "\n  vec4 resultSign = sign(a) * sign(b);\n  ivec4 ia = round(a);\n  ivec4 ib = round(b);\n  ivec4 result = ia / ib;\n  ivec4 amodb = ia - ib * result;\n  \n  // Vectorize INT_DIV\n  // if (resultSign < 0.0 && amodb != 0) result -= 1;\n  // return float(result);\n  return vec4(result -\n     ivec4(lessThan(resultSign, vec4(0.0))) * ivec4(notEqual(amodb, ivec4(0))));\n",
    PACKED_POW = "\n  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.\n  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));\n  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);\n  vec4 result = multiplier * pow(abs(a), b);\n\n  vec4 isNaN = vec4(lessThan(a, vec4(0.0))) * vec4(lessThan(floor(b), b));\n  result.r = isNaN.r == 1.0 ? NAN : result.r;\n  result.g = isNaN.g == 1.0 ? NAN : result.g;\n  result.b = isNaN.b == 1.0 ? NAN : result.b;\n  result.a = isNaN.a == 1.0 ? NAN : result.a;\n  \n  return result;\n",
    BinaryOpPackedProgram = function () {
  function e(e, t, n) {
    this.variableNames = ["A", "B"], this.supportsBroadcasting = !0, this.usesPackedTextures = !0, this.outputShape = assertAndGetBroadcastShape(t, n), this.userCode = "\n      uniform float NAN;\n      vec4 binaryOperation(vec4 a, vec4 b) {\n        " + e + "\n      }\n\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function () {
    var e = this;return function (t, n) {
      null == e.startLoc && (e.startLoc = t.getUniformLocationNoThrow(n, "NAN"), null == e.startLoc) || t.gl.uniform1f(e.startLoc, NaN);
    };
  }, e;
}(),
    ClipProgram = function () {
  function e(e) {
    this.variableNames = ["A"], this.outputShape = e, this.userCode = "\n      uniform float min;\n      uniform float max;\n\n      void main() {\n        float value = getAAtOutCoords();\n        if (isNaN(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, min, max));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function (e, t) {
    var n = this;return function (r, o) {
      null == n.minLoc && (n.minLoc = r.getUniformLocationNoThrow(o, "min"), n.maxLoc = r.getUniformLocationNoThrow(o, "max")), r.gl.uniform1f(n.minLoc, e), r.gl.uniform1f(n.maxLoc, t);
    };
  }, e;
}(),
    ClipPackedProgram = function () {
  function e(e) {
    this.variableNames = ["A"], this.usesPackedTextures = !0, this.outputShape = e, this.userCode = "\n      uniform float min;\n      uniform float max;\n\n      void main() {\n        vec4 value = getAAtOutCoords();\n\n        if (hasNaN(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, vec4(min), vec4(max)));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function (e, t) {
    var n = this;return function (r, o) {
      null == n.minLoc && (n.minLoc = r.getUniformLocationNoThrow(o, "min"), n.maxLoc = r.getUniformLocationNoThrow(o, "max")), r.gl.uniform1f(n.minLoc, e), r.gl.uniform1f(n.maxLoc, t);
    };
  }, e;
}(),
    ComplexAbsProgram = function () {
  return function (e) {
    this.variableNames = ["real", "imag"], this.outputShape = e, this.userCode = "\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    ";
  };
}(),
    ConcatProgram = function () {
  return function (e) {
    this.outputShape = [], this.outputShape = computeOutShape(e, 1), this.variableNames = e.map(function (e, t) {
      return "T" + t;
    });var t = new Array(e.length - 1);t[0] = e[0][1];for (var n = 1; n < t.length; n++) {
      t[n] = t[n - 1] + e[n][1];
    }var r = ["if (yC < " + t[0] + ") setOutput(getT0(yR, yC));"];for (n = 1; n < t.length; n++) {
      var o = t[n - 1];r.push("else if (yC < " + t[n] + ") setOutput(getT" + n + "(yR, yC-" + o + "));");
    }var a = t.length,
        i = t[t.length - 1];r.push("else setOutput(getT" + a + "(yR, yC-" + i + "));"), this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        " + r.join("\n        ") + "\n      }\n    ";
  };
}(),
    Conv2DDerFilterProgram = function () {
  return function (e) {
    this.variableNames = ["x", "dy"], this.outputShape = e.filterShape;var t = e.strideHeight,
        n = e.strideWidth,
        r = e.padInfo.top,
        o = e.padInfo.left;this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + e.batchSize + "; b++) {\n          for (int yR = 0; yR < " + e.outHeight + "; yR++) {\n            int xR = wR + yR * " + t + " - " + r + ";\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + e.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + o + ";\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    Conv2DDerInputProgram = function () {
  return function (e) {
    this.variableNames = ["dy", "W"], this.outputShape = e.inShape;var t = e.filterHeight,
        n = e.filterWidth,
        r = e.strideHeight,
        o = e.strideWidth,
        a = t - 1 - e.padInfo.top,
        i = n - 1 - e.padInfo.left;this.userCode = "\n      const ivec2 pads = ivec2(" + a + ", " + i + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + t + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + t + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            for (int d2 = 0; d2 < " + e.outChannels + "; d2++) {\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, d2);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    Conv3DDerFilterProgram = function () {
  return function (e) {
    this.variableNames = ["x", "dy"], this.outputShape = e.filterShape;var t = e.strideDepth,
        n = e.strideHeight,
        r = e.strideWidth,
        o = e.padInfo.front,
        a = e.padInfo.top,
        i = e.padInfo.left;this.userCode = "\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int wF = coords.x;\n        int wR = coords.y;\n        int wC = coords.z;\n        int d1 = coords.w;\n        int d2 = coords.u;\n\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + e.batchSize + "; b++) {\n          for (int yF = 0; yF < " + e.outDepth + "; yF++) {\n            int xF = wF + yF * " + t + " - " + o + ";\n\n            if (xF < 0 || xF >= " + e.inDepth + ") {\n              continue;\n            }\n\n            for (int yR = 0; yR < " + e.outHeight + "; yR++) {\n              int xR = wR + yR * " + n + " - " + a + ";\n\n              if (xR < 0 || xR >= " + e.inHeight + ") {\n                continue;\n              }\n\n              for (int yC = 0; yC < " + e.outWidth + "; yC++) {\n                int xC = wC + yC * " + r + " - " + i + ";\n\n                if (xC < 0 || xC >= " + e.inWidth + ") {\n                  continue;\n                }\n\n                float dyValue = getDy(b, yF, yR, yC, d2);\n                float xValue = getX(b, xF, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    Conv3DDerInputProgram = function () {
  return function (e) {
    this.variableNames = ["dy", "W"], this.outputShape = e.inShape;var t = e.filterDepth,
        n = e.filterHeight,
        r = e.filterWidth,
        o = e.strideDepth,
        a = e.strideHeight,
        i = e.strideWidth,
        s = t - 1 - e.padInfo.front,
        u = n - 1 - e.padInfo.top,
        l = r - 1 - e.padInfo.left;this.userCode = "\n      const ivec3 pads = ivec3(" + s + ", " + u + ", " + l + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.u;\n\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyFCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + t + "; wF++) {\n          float dyF = float(dyFCorner + wF) / " + o + ".0;\n\n          if (dyF < 0.0 || dyF >= " + e.outDepth + ".0 || fract(dyF) > 0.0) {\n            continue;\n          }\n          int idyF = int(dyF);\n\n          int wFPerm = " + t + " - 1 - wF;\n\n          for (int wR = 0; wR < " + n + "; wR++) {\n            float dyR = float(dyRCorner + wR) / " + a + ".0;\n\n            if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 ||\n              fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            int wRPerm = " + n + " - 1 - wR;\n\n            for (int wC = 0; wC < " + r + "; wC++) {\n              float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n              if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              int wCPerm = " + r + " - 1 - wC;\n\n              for (int d2 = 0; d2 < " + e.outChannels + "; d2++) {\n                float xValue = getDy(batch, idyF, idyR, idyC, d2);\n                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    DepthwiseConv2DDerFilterProgram = function () {
  return function (e) {
    this.variableNames = ["x", "dy"], this.outputShape = e.filterShape;var t = e.strideHeight,
        n = e.strideWidth,
        r = e.padInfo.top,
        o = e.padInfo.left,
        a = e.outChannels / e.inChannels;this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * " + a + " + dm;\n\n        float dotProd = 0.0;\n\n        // TODO: Vec4 over the batch size\n        for (int b = 0; b < " + e.batchSize + "; b++) {\n          for (int yR = 0; yR < " + e.outHeight + "; yR++) {\n            int xR = wR + yR * " + t + " - " + r + ";\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + e.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + o + ";\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    DepthwiseConv2DDerInputProgram = function () {
  return function (e) {
    this.variableNames = ["dy", "W"], this.outputShape = e.inShape;var t = e.filterHeight,
        n = e.filterWidth,
        r = e.strideHeight,
        o = e.strideWidth,
        a = t - 1 - e.padInfo.top,
        i = n - 1 - e.padInfo.left,
        s = e.outChannels / e.inChannels;this.userCode = "\n      const ivec2 pads = ivec2(" + a + ", " + i + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < " + t + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + t + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            // TODO: Vec4 over the channelMul\n            for (int dm = 0; dm < " + s + "; dm++) {\n              int d2 = d1 * " + s + " + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    Conv2DProgram = function () {
  return function (e) {
    this.variableNames = ["x", "W"], this.outputShape = e.outShape;var t = e.padInfo.top,
        n = e.padInfo.left,
        r = e.strideHeight,
        o = e.strideWidth,
        a = e.dilationHeight,
        i = e.dilationWidth,
        s = e.filterHeight,
        u = e.filterWidth,
        l = 4 * Math.floor(e.inChannels / 4),
        c = e.inChannels % 4;this.userCode = "\n      const ivec2 strides = ivec2(" + r + ", " + o + ");\n      const ivec2 pads = ivec2(" + t + ", " + n + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + s + "; wR++) {\n          int xR = xRCorner + wR * " + a + ";\n\n          if (xR < 0 || xR >= " + e.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + u + "; wC++) {\n            int xC = xCCorner + wC * " + i + ";\n\n            if (xC < 0 || xC >= " + e.inWidth + ") {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < " + l + "; d1 += 4) {\n              vec4 xValues = vec4(\n                getX(batch, xR, xC, d1),\n                getX(batch, xR, xC, d1 + 1),\n                getX(batch, xR, xC, d1 + 2),\n                getX(batch, xR, xC, d1 + 3)\n              );\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              dotProd += dot(xValues, wValues);\n            }\n\n            if (" + (1 === c) + ") {\n              dotProd +=\n                getX(batch, xR, xC, " + l + ") *\n                getW(wR, wC, " + l + ", d2);\n            } else if (" + (2 === c) + ") {\n              vec2 xValues = vec2(\n                getX(batch, xR, xC, " + l + "),\n                getX(batch, xR, xC, " + l + " + 1)\n              );\n              vec2 wValues = vec2(\n                getW(wR, wC, " + l + ", d2),\n                getW(wR, wC, " + l + " + 1, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            } else if (" + (3 === c) + ") {\n              vec3 xValues = vec3(\n                getX(batch, xR, xC, " + l + "),\n                getX(batch, xR, xC, " + l + " + 1),\n                getX(batch, xR, xC, " + l + " + 2)\n              );\n              vec3 wValues = vec3(\n                getW(wR, wC, " + l + ", d2),\n                getW(wR, wC, " + l + " + 1, d2),\n                getW(wR, wC, " + l + " + 2, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    Conv3DProgram = function () {
  return function (e) {
    this.variableNames = ["x", "W"], this.outputShape = e.outShape;var t = e.padInfo.front,
        n = e.padInfo.top,
        r = e.padInfo.left,
        o = e.strideDepth,
        a = e.strideHeight,
        i = e.strideWidth,
        s = e.dilationDepth,
        u = e.dilationHeight,
        l = e.dilationWidth,
        c = e.filterDepth,
        p = e.filterHeight,
        d = e.filterWidth,
        h = 4 * Math.floor(e.inChannels / 4),
        f = e.inChannels % 4;this.userCode = "\n      const ivec3 strides = ivec3(" + o + ", " + a + ", " + i + ");\n      const ivec3 pads = ivec3(" + t + ", " + n + ", " + r + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d2 = coords.u;\n\n        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xFCorner = xFRCCorner.x;\n        int xRCorner = xFRCCorner.y;\n        int xCCorner = xFRCCorner.z;\n\n        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get\n        // y(yF, yR, yC, d2). ? = to be determined. : = across all\n        // values in that axis.\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + c + "; wF++) {\n          int xF = xFCorner + wF * " + s + ";\n\n          if (xF < 0 || xF >= " + e.inDepth + ") {\n            continue;\n          }\n\n          for (int wR = 0; wR < " + p + "; wR++) {\n            int xR = xRCorner + wR * " + u + ";\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + d + "; wC++) {\n              int xC = xCCorner + wC * " + l + ";\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              for (int d1 = 0; d1 < " + h + "; d1 += 4) {\n                vec4 xValues = vec4(\n                  getX(batch, xF, xR, xC, d1),\n                  getX(batch, xF, xR, xC, d1 + 1),\n                  getX(batch, xF, xR, xC, d1 + 2),\n                  getX(batch, xF, xR, xC, d1 + 3)\n                );\n                vec4 wValues = vec4(\n                  getW(wF, wR, wC, d1, d2),\n                  getW(wF, wR, wC, d1 + 1, d2),\n                  getW(wF, wR, wC, d1 + 2, d2),\n                  getW(wF, wR, wC, d1 + 3, d2)\n                );\n\n                dotProd += dot(xValues, wValues);\n              }\n\n              if (" + (1 === f) + ") {\n                dotProd +=\n                  getX(batch, xF, xR, xC, " + h + ") *\n                  getW(wF, wR, wC, " + h + ", d2);\n              } else if (" + (2 === f) + ") {\n                vec2 xValues = vec2(\n                  getX(batch, xF, xR, xC, " + h + "),\n                  getX(batch, xF, xR, xC, " + h + " + 1)\n                );\n                vec2 wValues = vec2(\n                  getW(wF, wR, wC, " + h + ", d2),\n                  getW(wF, wR, wC, " + h + " + 1, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else if (" + (3 === f) + ") {\n                vec3 xValues = vec3(\n                  getX(batch, xF, xR, xC, " + h + "),\n                  getX(batch, xF, xR, xC, " + h + " + 1),\n                  getX(batch, xF, xR, xC, " + h + " + 2)\n                );\n                vec3 wValues = vec3(\n                  getW(wF, wR, wC, " + h + ", d2),\n                  getW(wF, wR, wC, " + h + " + 1, d2),\n                  getW(wF, wR, wC, " + h + " + 2, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    DepthwiseConv2DProgram = function () {
  return function (e) {
    this.variableNames = ["x", "W"], this.outputShape = e.outShape;var t = e.inHeight,
        n = e.inWidth,
        r = e.padInfo.top,
        o = e.padInfo.left,
        a = e.strideHeight,
        i = e.strideWidth,
        s = e.dilationHeight,
        u = e.dilationWidth,
        l = e.filterHeight,
        c = e.filterWidth,
        p = e.outChannels / e.inChannels;this.userCode = "\n      const ivec2 strides = ivec2(" + a + ", " + i + ");\n      const ivec2 pads = ivec2(" + r + ", " + o + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / " + p + ";\n        int q = d2 - d1 * " + p + ";\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TODO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < " + l + "; wR++) {\n          int xR = xRCorner + wR * " + s + ";\n\n          if (xR < 0 || xR >= " + t + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + c + "; wC++) {\n            int xC = xCCorner + wC * " + u + ";\n\n            if (xC < 0 || xC >= " + n + ") {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    DepthwiseConvPacked2DProgram = function () {
  return function (e) {
    this.variableNames = ["x", "W"], this.usesPackedTextures = !0, this.outputShape = e.outShape;for (var t = e.inHeight, n = e.inWidth, r = e.padInfo.top, o = e.padInfo.left, a = e.strideHeight, i = e.strideWidth, s = e.filterHeight, u = e.filterWidth, l = Math.ceil((u + 1) / 2), c = "int xR; int xC;", p = 0; p < s; p++) {
      for (var d = -o; d < 2 * l; d++) {
        c += "vec4 " + xTexelName(p, d) + " = vec4(0.);";
      }for (d = 0; d < u; d++) {
        c += "\n          vec4 wR" + p + "C" + d + " = vec4(0.);\n          vec4 xR" + p + "C" + d + " = vec4(0.);";
      }
    }for (p = 0; p < s; p++) {
      for (d = 0; d < l; d++) {
        var h = 2 * d,
            f = 2 * d + o;c += "\n          xR = xRCorner + " + p + ";\n          xC = xCCorner + " + f + ";\n\n          if(xR >= 0 && xR < " + t + " && xC >= 0 && xC < " + n + ") {\n            " + xTexelName(p, f) + " = getX(batch, xR, xC, d1);\n          }", 0 === o ? h < u && d === l - 1 && (i > 1 && (c += "\n                vec4 " + xTexelName(p, f + 2) + " = vec4(0.);\n\n                if(xR >= 0 && xR < " + t + " && xC + 2 < " + n + ") {\n                  " + xTexelName(p, f + 2) + " = getX(batch, xR, xC + 2, d1);\n                }"), c += "\n              xR" + p + "C" + f + " = " + constructTexel(p, f, i, o) + ";\n            ") : 0 === d && (c += "\n            if(xR >= 0 && xR < " + t + " && xC - 2 >= 0) {\n              " + xTexelName(p, f - 2) + " = getX(batch, xR, xC - 2, d1);\n            }"), h > 0 && (c += "xR" + p + "C" + (f - 2) + " =\n            " + constructTexel(p, f - 2, i, o) + ";"), f - 1 >= 0 && f - 1 < u && (c += "xR" + p + "C" + (f - 1) + " =\n              " + constructTexel(p, f - 1, i, o) + ";"), h < u && (c += "\n            vec4 wTexel" + p + "C" + h + " = getW(" + p + ", " + h + ", d1, q);\n            wR" + p + "C" + h + " = vec4(wTexel" + p + "C" + h + ".xz, wTexel" + p + "C" + h + ".xz);\n          ", h + 1 < u && (c += "\n              vec4 wTexelR" + p + "C" + (h + 1) + " = getW(" + p + ", " + (h + 1) + ", d1, q);\n              wR" + p + "C" + (h + 1) + " =\n                vec4(wTexelR" + p + "C" + (h + 1) + ".xz, wTexelR" + p + "C" + (h + 1) + ".xz);"));
      }
    }for (p = 0; p < s; p++) {
      for (d = 0; d < u; d++) {
        c += "result += xR" + p + "C" + d + " * wR" + p + "C" + d + ";";
      }
    }this.userCode = "\n      const ivec2 strides = ivec2(" + a + ", " + i + ");\n      const ivec2 pads = ivec2(" + r + ", " + o + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2;\n        int q = 0;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        vec4 result = vec4(0.);\n\n        " + c + "\n\n        setOutput(result);\n      }\n    ";
  };
}();function xTexelName(e, t) {
  return "xTexelR" + e + "C" + (t < 0 ? "minus" + Math.abs(t).toString() : t);
}function constructTexel(e, t, n, r) {
  return 1 === n ? r % 2 == t % 2 ? xTexelName(e, t) : "vec4(" + xTexelName(e, t - 1) + ".zw, " + xTexelName(e, t + 1) + ".xy)" : r % 2 == t % 2 ? "vec4(" + xTexelName(e, t) + ".xy, " + xTexelName(e, t + 2) + ".xy)" : "vec4(" + xTexelName(e, t - 1) + ".zw, " + xTexelName(e, t + 1) + ".zw)";
}var TextureUsage,
    PhysicalTextureType,
    CropAndResizeProgram = function () {
  return function (e, t, n, r, o) {
    this.variableNames = ["Image", "Boxes", "BoxInd"], this.outputShape = [];var a = e[0],
        i = e[1],
        s = e[2],
        u = e[3],
        l = t[0],
        c = n[0],
        p = n[1];this.outputShape = [l, c, p, u];var d = "bilinear" === r ? 1 : 0,
        h = [i - 1 + ".0", s - 1 + ".0"],
        f = h[0],
        m = h[1],
        g = c > 1 ? ["" + (i - 1) / (c - 1), "(y2-y1) * height_ratio", "y1*" + f + " + float(y)*(height_scale)"] : ["0.0", "0.0", "0.5 * (y1+y2) * " + f],
        v = g[0],
        y = g[1],
        x = g[2],
        T = p > 1 ? ["" + (s - 1) / (p - 1), "(x2-x1) * width_ratio", "x1*" + m + " + float(x)*(width_scale)"] : ["0.0", "0.0", "0.5 * (x1+x2) * " + m],
        w = T[0],
        E = T[1],
        S = T[2];this.userCode = "\n      const float height_ratio = float(" + v + ");\n      const float width_ratio = float(" + w + ");\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= " + a + ") {\n          return;\n        }\n\n        float height_scale = " + y + ";\n        float width_scale = " + E + ";\n\n        float in_y = " + x + ";\n        if( in_y < 0.0 || in_y > " + f + " ) {\n          setOutput(float(" + o + "));\n          return;\n        }\n        float in_x = " + S + ";\n        if( in_x < 0.0 || in_x > " + m + " ) {\n          setOutput(float(" + o + "));\n          return;\n        }\n\n        vec2 sourceFracIndexRC = vec2(in_y,in_x);\n        if(" + d + " == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n          ivec2 sourceCeilRC = ivec2(ceil(sourceFracIndexRC));\n\n          float topLeft = getImage(b, sourceFloorRC.x, sourceFloorRC.y, d);\n          float bottomLeft = getImage(b, sourceCeilRC.x, sourceFloorRC.y, d);\n          float topRight = getImage(b, sourceFloorRC.x, sourceCeilRC.y, d);\n          float bottomRight = getImage(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n          vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n          float top = topLeft + (topRight - topLeft) * fracRC.y;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n          float newValue = top + (bottom - top) * fracRC.x;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestRC = ivec2(floor(\n            sourceFracIndexRC + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestRC.x, sourceNearestRC.y, d);\n          setOutput(newValue);\n        }\n      }\n    ";
  };
}();function getGlslDifferences() {
  var e, t, n, r, o, a, i, s;return 2 === ENV.get("WEBGL_VERSION") ? (e = "#version 300 es", t = "in", n = "out", r = "in", o = "texture", a = "outputColor", i = "out vec4 outputColor;", s = "\n      #define round(value) newRound(value)\n      int newRound(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 newRound(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    ") : (e = "", t = "attribute", n = "varying", r = "varying", o = "texture2D", a = "gl_FragColor", i = "", s = "\n      int round(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 round(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    "), { version: e, attribute: t, varyingVs: n, varyingFs: r, texture2D: o, output: a, defineOutput: i, defineRound: s };
}function getLogicalCoordinatesFromFlatIndex(e, t, n) {
  void 0 === n && (n = "index");var r = computeStrides(t);return r.map(function (t, o) {
    return "int " + e[o] + " = " + n + " / " + t + "; " + (o === r.length - 1 ? "int " + e[o + 1] + " = " + n + " - " + e[o] + " * " + t : "index -= " + e[o] + " * " + t) + ";";
  }).join("");
}function buildVec(e) {
  return 1 === e.length ? "" + e[0] : "vec" + e.length + "(" + e.join(",") + ")";
}function dotify(e, t) {
  if (e.length !== t.length) throw new Error("Vectors to be dotted must be of the same length -got " + e.length + " and " + t.length);for (var n = [], r = Math.floor(e.length / 4), o = e.length % 4, a = 0; a < r; a++) {
    var i = e.slice(4 * a, 4 * a + 4),
        s = t.slice(4 * a, 4 * a + 4);n.push(buildVec(i) + ", " + buildVec(s));
  }if (0 !== o) {
    i = e.slice(4 * r), s = t.slice(4 * r);1 === i.length && (i = i.map(function (e) {
      return "float(" + e + ")";
    }), s = s.map(function (e) {
      return "float(" + e + ")";
    })), n.push(buildVec(i) + ", " + buildVec(s));
  }return n.map(function (e, t) {
    return "dot(" + e + ")";
  }).join("+");
}function getUnpackedMatrixTextureShapeWidthHeight(e, t) {
  return [t, e];
}function getUnpackedArraySizeFromMatrixSize(e, t) {
  return e * t;
}function getMatrixSizeFromUnpackedArraySize(e, t) {
  if (e % t != 0) throw new Error("unpackedSize (" + e + ") must be a multiple of " + t);return e / t;
}function encodeMatrixToUnpackedArray(e, t, n) {
  var r = getUnpackedArraySizeFromMatrixSize(e.length, n);if (t.length < r) throw new Error("unpackedArray length (" + t.length + ") must be >= " + r);for (var o = 0, a = 0; a < e.length; ++a) {
    t[o] = e[a], o += n;
  }
}function decodeMatrixFromUnpackedArray(e, t, n) {
  var r = getMatrixSizeFromUnpackedArraySize(e.length, n);if (t.length < r) throw new Error("matrix length (" + t.length + ") must be >= " + r);for (var o = 0, a = 0; a < e.length; a += n) {
    t[o++] = e[a];
  }
}function getPackedMatrixTextureShapeWidthHeight(e, t) {
  return [Math.max(1, Math.ceil(t / 2)), Math.max(1, Math.ceil(e / 2))];
}function getPackedRGBAArraySizeFromMatrixShape(e, t) {
  var n = getPackedMatrixTextureShapeWidthHeight(e, t);return n[0] * n[1] * 4;
}function encodeMatrixToPackedRGBA(e, t, n, r, o) {
  for (var a = r % 2 == 1, i = n % 2 == 1, s = Math.floor(r / 2), u = Math.floor(n / 2), l = Math.ceil(r / 2), c = l * Math.ceil(n / 2), p = nearestLargerEven(n) * nearestLargerEven(r), d = 0; d < t; d++) {
    for (var h = d * n * r, f = d * p, m = a ? 4 : 0, g = r, v = f, y = 0; y < u; ++y) {
      for (var x = 2 * y * r, T = 0; T < s; ++T) {
        var w = h + x + 2 * T;o[v] = e[w], o[v + 1] = e[w + 1], o[v + 2] = e[w + g], o[v + 3] = e[w + g + 1], v += 4;
      }v += m;
    }if (a) {
      w = h + r - 1, v = f + 4 * (l - 1);var E = 2 * r;for (m = 4 * l, y = 0; y < u; ++y) {
        o[v] = e[w], o[v + 2] = e[w + r], w += E, v += m;
      }
    }if (i) {
      for (w = h + (n - 1) * r, v = f + 4 * (c - l), T = 0; T < s; ++T) {
        o[v++] = e[w++], o[v++] = e[w++], v += 2;
      }a && i && (o[f + p - 4] = e[w]);
    }
  }return o;
}function decodeMatrixFromPackedRGBA(e, t, n, r, o) {
  var a = n * r;if (o.length < a) throw new Error("matrix length (" + o.length + ") must be >= " + a);for (var i = r % 2 == 1, s = n % 2 == 1, u = Math.floor(r / 2), l = Math.floor(n / 2), c = Math.ceil(r / 2), p = c * Math.ceil(n / 2), d = nearestLargerEven(n) * nearestLargerEven(r), h = 0; h < t; h++) {
    for (var f = h * n * r, m = h * d, g = i ? 4 : 0, v = r + (i ? 1 : 0), y = m, x = f, T = f + r, w = 0; w < l; ++w) {
      for (var E = 0; E < u; ++E) {
        o[x++] = e[y++], o[x++] = e[y++], o[T++] = e[y++], o[T++] = e[y++];
      }y += g, x += v, T += v;
    }if (i) {
      y = m + 4 * (c - 1);var S = f + r - 1;for (g = 4 * c, v = 2 * r, w = 0; w < l; ++w) {
        o[S] = e[y], o[S + r] = e[y + 2], y += g, S += v;
      }
    }if (s) {
      for (y = m + 4 * (p - c), S = f + (n - 1) * r, E = 0; E < u; ++E) {
        o[S++] = e[y++], o[S++] = e[y++], y += 2;
      }i && (o[f + n * r - 1] = e[y]);
    }
  }return o;
}function makeShader(e, t, n, r) {
  var o = [];e.forEach(function (e) {
    var t = sizeFromShape(e.shapeInfo.logicalShape);e.shapeInfo.isUniform ? o.push("uniform float " + e.name + (t > 1 ? "[" + t + "]" : "") + ";") : (o.push("uniform sampler2D " + e.name + ";"), o.push("uniform int offset" + e.name + ";"));
  });var a,
      i,
      s = o.join("\n"),
      u = e.map(function (e) {
    return getInputSamplingSnippet(e, t, r);
  }).join("\n"),
      l = t.texShape,
      c = getGlslDifferences(),
      p = getFloatTextureSampleSnippet(c),
      d = getShaderPrefix(c);return t.isPacked ? (a = getPackedOutputSamplingSnippet(t.logicalShape, l), i = getFloatTextureSetRGBASnippet(c)) : (a = getOutputSamplingSnippet(t.logicalShape, l), i = getFloatTextureSetRSnippet(c)), r && (d += SHADER_PACKED_PREFIX), [d, p, i, s, a, u, n].join("\n");
}function getSamplerFromInInfo(e) {
  var t = e.shapeInfo.logicalShape;switch (t.length) {case 0:
      return getSamplerScalar(e);case 1:
      return getSampler1D(e);case 2:
      return getSampler2D(e);case 3:
      return getSampler3D(e);case 4:
      return getSampler4D(e);case 5:
      return getSampler5D(e);case 6:
      return getSampler6D(e);default:
      throw new Error(t.length + "-D input sampling is not yet supported");}
}function getPackedSamplerFromInInfo(e) {
  var t = e.shapeInfo.logicalShape;switch (t.length) {case 0:
      return getPackedSamplerScalar(e);case 1:
      return getPackedSampler1D(e);case 2:
      return getPackedSampler2D(e);case 3:
      return getPackedSampler3D(e);case 4:
      return getPackedSampler4D(e);default:
      throw new Error("Packed " + t.length + "-D input sampling is not yet supported");}
}function getInputSamplingSnippet(e, t, n) {
  void 0 === n && (n = !1);var r = "";r += n ? getPackedSamplerFromInInfo(e) : getSamplerFromInInfo(e);var o = e.shapeInfo.logicalShape,
      a = t.logicalShape;return o.length <= a.length && (n ? 0 === getBroadcastDims(o, a).length && (r += getPackedSamplerAtOutputCoords(e, t)) : r += getSamplerAtOutputCoords(e, t)), r;
}function getPackedOutputSamplingSnippet(e, t) {
  switch (e.length) {case 0:
      return getOutputScalarCoords();case 1:
      return getOutputPacked1DCoords(e, t);case 2:
      return getOutputPacked2DCoords(e, t);case 3:
      return getOutputPacked3DCoords(e, t);case 4:
      return getOutputPacked4DCoords(e, t);default:
      throw new Error(e.length + "-D packed output coordinate fetching is not yet supported");}
}function getOutputSamplingSnippet(e, t) {
  switch (e.length) {case 0:
      return getOutputScalarCoords();case 1:
      return getOutput1DCoords(e, t);case 2:
      return getOutput2DCoords(e, t);case 3:
      return getOutput3DCoords(e, t);case 4:
      return getOutput4DCoords(e, t);case 5:
      return getOutput5DCoords(e, t);case 6:
      return getOutput6DCoords(e, t);default:
      throw new Error(e.length + "-D output sampling is not yet supported");}
}function getFloatTextureSampleSnippet(e) {
  return "\n    float sampleTexture(sampler2D textureSampler, vec2 uv) {\n      return " + e.texture2D + "(textureSampler, uv).r;\n    }\n  ";
}function getFloatTextureSetRSnippet(e) {
  return "\n    void setOutput(float val) {\n      " + e.output + " = vec4(val, 0, 0, 0);\n    }\n  ";
}function getFloatTextureSetRGBASnippet(e) {
  return "\n    void setOutput(vec4 val) {\n      " + e.output + " = val;\n    }\n  ";
}function getShaderPrefix(e) {
  var t = "";return t = ENV.get("PROD") ? "\n      bool isNaN(float val) {\n        return false;\n      }\n\n      bool hasNaN(vec4 values) {\n        return false;\n      }\n    " : "\n      bool isNaN(float val) {\n        return (val < 1.0 || 0.0 < val || val == 0.0) ? false : true;\n      }\n\n      bool hasNaN(vec4 values) {\n        return any(bvec4(\n          isNaN(values.x),\n          isNaN(values.y),\n          isNaN(values.z),\n          isNaN(values.w)\n        ));\n      }\n    ", e.version + "\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    " + e.varyingFs + " vec2 resultUV;\n    " + e.defineOutput + "\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    " + t + "\n\n    float getNaN(vec4 values) {\n      return dot(vec4(1), values);\n    }\n\n    " + e.defineRound + "\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    //Based on the work of Dave Hoskins\n    //https://www.shadertoy.com/view/4djSRW\n    #define HASHSCALE1 443.8975\n    float random(float seed){\n      vec2 p = resultUV * seed;\n      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n      p3 += dot(p3, p3.yzx + 19.19);\n      return fract((p3.x + p3.y) * p3.z);\n    }\n\n    " + SAMPLE_1D_SNIPPET + "\n    " + SAMPLE_2D_SNIPPET + "\n    " + SAMPLE_3D_SNIPPET + "\n    " + SAMPLE_4D_SNIPPET + "\n    " + SAMPLE_5D_SNIPPET + "\n    " + SAMPLE_6D_SNIPPET + "\n  ";
}!function (e) {
  e[e.RENDER = 0] = "RENDER", e[e.UPLOAD = 1] = "UPLOAD", e[e.PIXELS = 2] = "PIXELS", e[e.DOWNLOAD = 3] = "DOWNLOAD";
}(TextureUsage || (TextureUsage = {})), function (e) {
  e[e.UNPACKED_FLOAT16 = 0] = "UNPACKED_FLOAT16", e[e.UNPACKED_FLOAT32 = 1] = "UNPACKED_FLOAT32", e[e.PACKED_4X1_UNSIGNED_BYTE = 2] = "PACKED_4X1_UNSIGNED_BYTE", e[e.PACKED_2X2_FLOAT32 = 3] = "PACKED_2X2_FLOAT32", e[e.PACKED_2X2_FLOAT16 = 4] = "PACKED_2X2_FLOAT16";
}(PhysicalTextureType || (PhysicalTextureType = {}));var SAMPLE_1D_SNIPPET = "\nvec2 uvFromFlat(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SAMPLE_2D_SNIPPET = "\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SAMPLE_3D_SNIPPET = "\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SAMPLE_4D_SNIPPET = "\nvec2 packedUVfrom4D(int texNumR, int texNumC, int texelsInBatch2,\n    int texelsInBatch, int texelsInLogicalRow, int b2, int b,\n    int row, int col) {\n  int index = b2 * texelsInBatch2 + b * texelsInBatch +\n    (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SAMPLE_5D_SNIPPET = "\nvec2 UVfrom5D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int row, int col, int depth,\n    int depth2, int depth3) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 +\n              depth * stride2 + depth2 * stride3 + depth3;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SAMPLE_6D_SNIPPET = "\nvec2 UVfrom6D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int stride4,\n    int row, int col, int depth, int depth2, int depth3, int depth4) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth * stride2 + depth2 *\n    stride3 + depth3 * stride4 + depth4;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
    SHADER_PACKED_PREFIX = "\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";function getOutputScalarCoords() {
  return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
}function getOutputPacked1DCoords(e, t) {
  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)];return 1 === n[0] ? "\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * " + n[1] + ".0);\n      }\n    " : 1 === n[1] ? "\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * " + n[0] + ".0);\n      }\n    " : "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      return resTexRC.x * " + n[1] + " + resTexRC.y;\n    }\n  ";
}function getOutput1DCoords(e, t) {
  return 1 === t[0] ? "\n      int getOutputCoords() {\n        return int(resultUV.x * " + t[1] + ".0);\n      }\n    " : 1 === t[1] ? "\n      int getOutputCoords() {\n        return int(resultUV.y * " + t[0] + ".0);\n      }\n    " : "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      return resTexRC.x * " + t[1] + " + resTexRC.y;\n    }\n  ";
}function getOutputPacked3DCoords(e, t) {
  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)],
      r = Math.ceil(e[2] / 2),
      o = r * Math.ceil(e[1] / 2);return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n\n      int b = index / " + o + ";\n      index -= b * " + o + ";\n\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec3(b, r, c);\n    }\n  ";
}function getOutput3DCoords(e, t) {
  var n = getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], e);return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      " + n + "\n      return ivec3(r, c, d);\n    }\n  ";
}function getOutputPacked4DCoords(e, t) {
  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)],
      r = Math.ceil(e[3] / 2),
      o = r * Math.ceil(e[2] / 2),
      a = o * e[1];return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n\n      int b2 = index / " + a + ";\n      index -= b2 * " + a + ";\n\n      int b = index / " + o + ";\n      index -= b * " + o + ";\n\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec4(b2, b, r, c);\n    }\n  ";
}function getOutput4DCoords(e, t) {
  var n = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2"], e);return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      " + n + "\n      return ivec4(r, c, d, d2);\n    }\n  ";
}function getOutput5DCoords(e, t) {
  var n = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2", "d3"], e);return "\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(" + t[0] + ",\n                             " + t[1] + "));\n\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  ";
}function getOutput6DCoords(e, t) {
  var n = getLogicalCoordinatesFromFlatIndex(["r", "c", "d", "d2", "d3", "d4"], e);return "\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  ";
}function getOutputPacked2DCoords(e, t) {
  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)];if (arraysEqual(e, t)) return "\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(" + n[0] + ", " + n[1] + "));\n      }\n    ";var r = Math.ceil(e[1] / 2);return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec2(r, c);\n    }\n  ";
}function getOutput2DCoords(e, t) {
  return arraysEqual(e, t) ? "\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(" + t[0] + ", " + t[1] + "));\n      }\n    " : 1 === e[1] ? "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + t[0] + ", " + t[1] + "));\n        int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    " : 1 === e[0] ? "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + t[0] + ", " + t[1] + "));\n        int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n        return ivec2(0, index);\n      }\n    " : "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      int r = index / " + e[1] + ";\n      int c = index - r * " + e[1] + ";\n      return ivec2(r, c);\n    }\n  ";
}function getFlatOffsetUniformName(e) {
  return "offset" + e;
}function getPackedSamplerScalar(e) {
  var t = e.name;return "\n    vec4 " + ("get" + t.charAt(0).toUpperCase() + t.slice(1)) + "() {\n      return " + getGlslDifferences().texture2D + "(" + t + ", halfCR);\n    }\n  ";
}function getSamplerScalar(e) {
  var t = e.name,
      n = "get" + t.charAt(0).toUpperCase() + t.slice(1);if (e.shapeInfo.isUniform) return "float " + n + "() {return " + t + ";}";var r = e.shapeInfo.texShape,
      o = r[0],
      a = r[1];if (1 === o && 1 === a) return "\n      float " + n + "() {\n        return sampleTexture(" + t + ", halfCR);\n      }\n    ";var i = e.shapeInfo.texShape;return "\n    float " + n + "() {\n      vec2 uv = uvFromFlat(" + i[0] + ", " + i[1] + ", " + getFlatOffsetUniformName(t) + ");\n      return sampleTexture(" + t + ", uv);\n    }\n  ";
}function getPackedSampler1D(e) {
  var t = e.name,
      n = "get" + t.charAt(0).toUpperCase() + t.slice(1),
      r = e.shapeInfo.texShape,
      o = [Math.ceil(r[0] / 2), Math.ceil(r[1] / 2)],
      a = getGlslDifferences();return "\n    vec4 " + n + "(int index) {\n      vec2 uv = packedUVfrom1D(\n        " + o[0] + ", " + o[1] + ", index);\n      return " + a.texture2D + "(" + t + ", uv);\n    }\n  ";
}function getSampler1D(e) {
  var t = e.name,
      n = "get" + t.charAt(0).toUpperCase() + t.slice(1);if (e.shapeInfo.isUniform) return "\n      float " + n + "(int index) {\n        " + getUniformSampler(e) + "\n      }\n    ";var r = e.shapeInfo.texShape,
      o = r[0],
      a = r[1];if (1 === a && 1 === o) return "\n      float " + n + "(int index) {\n        return sampleTexture(" + t + ", halfCR);\n      }\n    ";var i = getFlatOffsetUniformName(t);return 1 === a ? "\n      float " + n + "(int index) {\n        vec2 uv = vec2(0.5, (float(index + " + i + ") + 0.5) / " + o + ".0);\n        return sampleTexture(" + t + ", uv);\n      }\n    " : 1 === o ? "\n      float " + n + "(int index) {\n        vec2 uv = vec2((float(index + " + i + ") + 0.5) / " + a + ".0, 0.5);\n        return sampleTexture(" + t + ", uv);\n      }\n    " : "\n    float " + n + "(int index) {\n      vec2 uv = uvFromFlat(" + o + ", " + a + ", index + " + i + ");\n      return sampleTexture(" + t + ", uv);\n    }\n  ";
}function getPackedSampler2D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = e.shapeInfo.texShape,
      a = o[0],
      i = o[1],
      s = getGlslDifferences();if (null != o && arraysEqual(t, o)) return "\n      vec4 " + r + "(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(" + i + ".0, " + a + ".0);\n\n        return " + s.texture2D + "(" + n + ", uv);\n      }\n    ";var u = [Math.ceil(o[0] / 2), Math.ceil(o[1] / 2)];return "\n    vec4 " + r + "(int row, int col) {\n      vec2 uv = packedUVfrom2D(" + Math.ceil(t[1] / 2) + ", " + u[0] + ", " + u[1] + ", row, col);\n      return " + s.texture2D + "(" + n + ", uv);\n    }\n  ";
}function getSampler2D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = e.shapeInfo.texShape;if (null != o && arraysEqual(t, o)) {
    var a = o[0];return "\n    float " + r + "(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(" + o[1] + ".0, " + a + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
  }var i = squeezeShape(t),
      s = i.newShape,
      u = i.keptDims,
      l = s;if (l.length < t.length) {
    return "\n      " + getSamplerFromInInfo(squeezeInputInfo(e, l)) + "\n      float " + r + "(int row, int col) {\n        return " + r + "(" + getSqueezedParams(["row", "col"], u) + ");\n      }\n    ";
  }if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col) {\n        int index = round(dot(vec2(row, col), vec2(" + t[1] + ", 1)));\n        " + getUniformSampler(e) + "\n      }\n    ";var c = o[0],
      p = o[1],
      d = getFlatOffsetUniformName(n);return 1 === p ? "\n    float " + r + "(int row, int col) {\n      float index = dot(vec3(row, col, " + d + "), vec3(" + t[1] + ", 1, 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / " + c + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : 1 === c ? "\n    float " + r + "(int row, int col) {\n      float index = dot(vec3(row, col, " + d + "), vec3(" + t[1] + ", 1, 1));\n      vec2 uv = vec2((index + 0.5) / " + p + ".0, 0.5);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : "\n  float " + r + "(int row, int col) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * " + t[1] + " + col + " + d + ";\n    vec2 uv = uvFromFlat(" + c + ", " + p + ", index);\n    return sampleTexture(" + n + ", uv);\n  }\n";
}function getPackedSampler3D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = e.shapeInfo.texShape,
      a = [Math.ceil(o[0] / 2), Math.ceil(o[1] / 2)];if (1 === t[0]) {
    return "\n        " + getPackedSamplerFromInInfo(squeezeInputInfo(e, t.slice(1))) + "\n        vec4 " + r + "(int b, int row, int col) {\n          return " + r + "(" + getSqueezedParams(["b", "row", "col"], [1, 2]) + ");\n        }\n      ";
  }var i = a[0],
      s = a[1],
      u = Math.ceil(t[2] / 2);return "\n    vec4 " + r + "(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        " + i + ", " + s + ", " + u * Math.ceil(t[1] / 2) + ", " + u + ", b, row, col);\n      return " + getGlslDifferences().texture2D + "(" + n + ", uv);\n    }\n  ";
}function getSampler3D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = t[1] * t[2],
      a = t[2],
      i = squeezeShape(t),
      s = i.newShape,
      u = i.keptDims,
      l = s;if (l.length < t.length) {
    return "\n        " + getSamplerFromInInfo(squeezeInputInfo(e, l)) + "\n        float " + r + "(int row, int col, int depth) {\n          return " + r + "(" + getSqueezedParams(["row", "col", "depth"], u) + ");\n        }\n      ";
  }if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth) {\n        int index = round(dot(vec3(row, col, depth),\n                          vec3(" + o + ", " + a + ", 1)));\n        " + getUniformSampler(e) + "\n      }\n    ";var c = e.shapeInfo.texShape,
      p = c[0],
      d = c[1],
      h = e.shapeInfo.flatOffset;return d === o && null == h ? "\n        float " + r + "(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(" + a + ", 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(" + d + ".0, " + p + ".0);\n          return sampleTexture(" + n + ", uv);\n        }\n      " : d === a && null == h ? "\n    float " + r + "(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(" + t[1] + ", 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + d + ".0, " + p + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : "\n      float " + r + "(int row, int col, int depth) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * " + o + " + col * " + a + " + depth + " + getFlatOffsetUniformName(n) + ";\n        vec2 uv = uvFromFlat(" + p + ", " + d + ", index);\n        return sampleTexture(" + n + ", uv);\n      }\n  ";
}function getPackedSampler4D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = e.shapeInfo.texShape,
      a = [Math.ceil(o[0] / 2), Math.ceil(o[1] / 2)],
      i = a[0],
      s = a[1],
      u = Math.ceil(t[3] / 2),
      l = u * Math.ceil(t[2] / 2);return "\n    vec4 " + r + "(int b2, int b, int row, int col) {\n      vec2 uv = packedUVfrom4D(\n        " + i + ", " + s + ", " + l * t[1] + ",\n        " + l + ", " + u + ", b2, b, row, col);\n      return " + getGlslDifferences().texture2D + "(" + n + ", uv);\n    }\n  ";
}function getSampler4D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = t[3],
      a = t[2] * o,
      i = t[1] * a,
      s = squeezeShape(t),
      u = s.newShape,
      l = s.keptDims;if (u.length < t.length) {
    return "\n      " + getSamplerFromInInfo(squeezeInputInfo(e, u)) + "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        return " + r + "(" + getSqueezedParams(["row", "col", "depth", "depth2"], l) + ");\n      }\n    ";
  }if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        int index = round(dot(vec4(row, col, depth, depth2),\n                          vec4(" + i + ", " + a + ", " + o + ", 1)));\n        " + getUniformSampler(e) + "\n      }\n    ";var c = e.shapeInfo.flatOffset,
      p = e.shapeInfo.texShape,
      d = p[0],
      h = p[1];return h === i && null == c ? "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(" + a + ", " + o + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + h + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : h === o && null == c ? "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(" + t[1] * t[2] + ", " + t[2] + ", 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + h + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + i + " + col * " + a + " +\n          depth * " + o + " + depth2;\n      vec2 uv = uvFromFlat(" + d + ", " + h + ", index + " + getFlatOffsetUniformName(n) + ");\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
}function getSampler5D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = t[4],
      a = t[3] * o,
      i = t[2] * a,
      s = t[1] * i,
      u = squeezeShape(t),
      l = u.newShape,
      c = u.keptDims;if (l.length < t.length) {
    return "\n      " + getSamplerFromInInfo(squeezeInputInfo(e, l)) + "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        return " + r + "(" + getSqueezedParams(["row", "col", "depth", "depth2", "depth3"], c) + ");\n      }\n    ";
  }if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + s + ", " + i + ", " + a + ", " + o + ")) +\n          depth3;\n        " + getUniformSampler(e) + "\n      }\n    ";var p = e.shapeInfo.flatOffset,
      d = e.shapeInfo.texShape,
      h = d[0],
      f = d[1];return f === s && null == p ? "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n                         vec4(" + i + ", " + a + ", " + o + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + f + ".0, " + h + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : f === o && null == p ? "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + t[1] * t[2] * t[3] + ",\n               " + t[2] * t[3] + ", " + t[3] + ", 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + f + ".0, " + h + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + s + " + col * " + i + " + depth * " + a + " +\n          depth2 * " + o + " + depth3 + " + getFlatOffsetUniformName(n) + ";\n      vec2 uv = uvFromFlat(" + h + ", " + f + ", index);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
}function getSampler6D(e) {
  var t = e.shapeInfo.logicalShape,
      n = e.name,
      r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
      o = squeezeShape(t),
      a = o.newShape,
      i = o.keptDims;if (a.length < t.length) {
    return "\n      " + getSamplerFromInInfo(squeezeInputInfo(e, a)) + "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return " + r + "(" + getSqueezedParams(["row", "col", "depth", "depth2", "depth3", "depth4"], i) + ");\n      }\n    ";
  }var s = t[5],
      u = t[4] * s,
      l = t[3] * u,
      c = t[2] * l,
      p = t[1] * c;if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        int index = round(dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + p + ", " + c + ", " + l + ", " + u + ")) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(" + s + ", 1)));\n        " + getUniformSampler(e) + "\n      }\n    ";var d = e.shapeInfo.flatOffset,
      h = e.shapeInfo.texShape,
      f = h[0],
      m = h[1];return m === p && null == d ? "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n          vec4(" + c + ", " + l + ", " + u + ", " + s + ")) +\n               float(depth4);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + m + ".0, " + f + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : m === s && null == d ? "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(vec4(row, col, depth, depth2),\n          vec4(" + t[1] * t[2] * t[3] * t[4] + ",\n               " + t[2] * t[3] * t[4] + ",\n               " + t[3] * t[4] + ",\n               " + t[4] + ")) + float(depth3);\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + m + ".0, " + f + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + p + " + col * " + c + " + depth * " + l + " +\n          depth2 * " + u + " + depth3 * " + s + " + depth4 + " + getFlatOffsetUniformName(n) + ";\n      vec2 uv = uvFromFlat(" + f + ", " + m + ", index);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
}function getUniformSampler(e) {
  var t = e.name,
      n = sizeFromShape(e.shapeInfo.logicalShape);return 1 === n ? "return " + t + ";" : "\n    for (int i = 0; i < " + n + "; i++) {\n      if (i == index) {\n        return " + t + "[i];\n      }\n    }\n  ";
}function getPackedSamplerAtOutputCoords(e, t) {
  var n = e.name,
      r = "get" + (n.charAt(0).toUpperCase() + n.slice(1)) + "AtOutCoords",
      o = t.texShape,
      a = getPackedMatrixTextureShapeWidthHeight(o[1], o[0]).slice(),
      i = e.shapeInfo.logicalShape,
      s = t.logicalShape,
      u = getBroadcastDims(i, s),
      l = i.length,
      c = s.length;if (u.length) throw Error("Packed broadcast sampling is not implemented yet.");var p = e.shapeInfo.texShape,
      d = getPackedMatrixTextureShapeWidthHeight(p[1], p[0]).slice(),
      h = getGlslDifferences();if (arraysEqual(p, o) && sizeFromShape(i) === sizeFromShape(s)) return "\n      vec4 " + r + "() {\n        return " + h.texture2D + "(" + n + ", resultUV);\n      }\n    ";var f = "return " + h.texture2D + "(" + n + ", uv)";return 1 === l && c > 1 ? f = "\n      vec4 values = " + h.texture2D + "(" + n + ", uv);\n      return vec4(values.xy, values.xy);\n    " : 0 === l && c > 0 && (f = 1 === c ? "\n        vec4 values = " + h.texture2D + "(" + n + ", uv);\n        return vec4(values.x, values.x, 0., 0.);\n      " : "\n        vec4 values = " + h.texture2D + "(" + n + ", uv);\n        return vec4(values.x);\n      "), "\n  vec4 " + r + "() {\n    ivec2 resTexRC = ivec2(resultUV.yx *\n                           vec2(" + a[0] + ", " + a[1] + "));\n    int index = resTexRC.x * " + a[1] + " + resTexRC.y;\n\n    int texR = index / " + d[1] + ";\n    int texC = index - texR * " + d[1] + ";\n    vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + d[1] + ", " + d[0] + ");\n\n    " + f + ";\n  }\n";
}function getSamplerAtOutputCoords(e, t) {
  var n = e.name,
      r = n.charAt(0).toUpperCase() + n.slice(1),
      o = "get" + r + "AtOutCoords",
      a = t.texShape,
      i = e.shapeInfo.texShape;if (!e.shapeInfo.isUniform && null == e.shapeInfo.flatOffset && arraysEqual(i, a)) return "\n      float " + o + "() {\n        return sampleTexture(" + n + ", resultUV);\n      }\n    ";var s = e.shapeInfo.logicalShape.length,
      u = t.logicalShape.length,
      l = getCoordsDataType(u),
      c = getBroadcastDims(e.shapeInfo.logicalShape, t.logicalShape),
      p = u - s,
      d = ["x", "y", "z", "w", "u", "v"];return "\n    float " + o + "() {\n      " + l + " coords = getOutputCoords();\n      " + (0 === s ? "" : u < 2 && c.length >= 1 ? "coords = 0;" : c.map(function (e) {
    return "coords." + d[e + p] + " = 0;";
  }).join("\n")) + "\n      return get" + r + "(" + (u < 2 && s > 0 ? "coords" : e.shapeInfo.logicalShape.map(function (e, t) {
    return "coords." + d[t + p];
  }).join(", ")) + ");\n    }\n  ";
}function getCoordsDataType(e) {
  if (e <= 1) return "int";if (2 === e) return "ivec2";if (3 === e) return "ivec3";if (4 === e) return "ivec4";if (5 === e) return "ivec5";if (6 === e) return "ivec6";throw Error("GPU for rank " + e + " is not yet supported");
}function squeezeInputInfo(e, t) {
  var n = JSON.parse(JSON.stringify(e));return n.shapeInfo.logicalShape = t, n;
}function getSqueezedParams(e, t) {
  return t.map(function (t) {
    return e[t];
  }).join(", ");
}var CumSumProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["x"], this.outputShape = e;var r = e.length,
        o = e[e.length - 1],
        a = n ? "<" : ">";this.userCode = "\n      int getIndex(int i) {\n        " + (n ? "return " + o + " -i - 1;" : "return i;") + "\n      }\n\n      void main() {\n        " + getCoordsDataType(r) + " coords = getOutputCoords();\n        int end = " + getFinalCoord(r, "coords") + ";\n        float val = 0.0;\n        for (int i = " + o + " - 1; i >= 0; i -= 1) {\n          int idx = getIndex(i);\n          if (idx " + a + " end) {\n            continue;\n          }\n          if (idx == end && " + t + ") {\n            continue;\n          }\n          " + getFinalCoord(r, "coords") + " = idx;\n          val += getX(" + getCoords(r, "coords") + ");\n        }\n        setOutput(val);\n      }\n    ";
  };
}();function getCoords(e, t) {
  if (1 === e) return "" + t;if (2 === e) return t + ".x, " + t + ".y";if (3 === e) return t + ".x, " + t + ".y, " + t + ".z";if (4 === e) return t + ".x, " + t + ".y, " + t + ".z, " + t + ".w";throw Error("Cumulative sum for rank " + e + " is not yet supported");
}function getFinalCoord(e, t) {
  if (1 === e) return "" + t;if (2 === e) return t + ".y";if (3 === e) return t + ".z";if (4 === e) return t + ".w";throw Error("Cumulative sum for rank " + e + " is not yet supported");
}var DepthToSpaceProgram = function () {
  function e(e, t, n) {
    this.variableNames = ["x"], this.outputShape = [], this.outputShape = e, this.blockSize = t, this.dataFormat = n, this.userCode = "\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = " + this.getHeightCoordString() + ";\n      int w = " + this.getWidthCoordString() + ";\n      int d = " + this.getDepthCoordString() + ";\n\n      int in_h = h / " + t + ";\n      int offset_h = imod(h, " + t + ");\n      int in_w = w / " + t + ";\n      int offset_w = imod(w, " + t + ");\n      int offset_d = (offset_h * " + t + " + offset_w) *\n        " + this.getOutputDepthSize() + ";\n      int in_d = d + offset_d;\n\n      float result = " + this.getInputSamplingString() + ";\n      setOutput(result);\n    }\n  ";
  }return e.prototype.getHeightCoordString = function () {
    return "NHWC" === this.dataFormat ? "coords[1]" : "coords[2]";
  }, e.prototype.getWidthCoordString = function () {
    return "NHWC" === this.dataFormat ? "coords[2]" : "coords[3]";
  }, e.prototype.getDepthCoordString = function () {
    return "NHWC" === this.dataFormat ? "coords[3]" : "coords[1]";
  }, e.prototype.getOutputDepthSize = function () {
    return "NHWC" === this.dataFormat ? this.outputShape[3] : this.outputShape[1];
  }, e.prototype.getInputSamplingString = function () {
    return "NHWC" === this.dataFormat ? "getX(b, in_h, in_w, in_d)" : "getX(b, in_d, in_h, in_w)";
  }, e;
}(),
    EncodeFloatProgram = function () {
  return function (e) {
    this.variableNames = ["A"];var t = getGlslDifferences();this.outputShape = e, this.userCode = "\n      const float FLOAT_MAX = 1.70141184e38;\n      const float FLOAT_MIN = 1.17549435e-38;\n\n      lowp vec4 encode_float(highp float v) {\n        if (isNaN(v)) {\n          return vec4(255, 255, 255, 255);\n        }\n\n        highp float av = abs(v);\n\n        if(av < FLOAT_MIN) {\n          return vec4(0.0, 0.0, 0.0, 0.0);\n        } else if(v > FLOAT_MAX) {\n          return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n        } else if(v < -FLOAT_MAX) {\n          return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n        }\n\n        highp vec4 c = vec4(0,0,0,0);\n\n        highp float e = floor(log2(av));\n        highp float m = exp2(fract(log2(av))) - 1.0;\n\n        c[2] = floor(128.0 * m);\n        m -= c[2] / 128.0;\n        c[1] = floor(32768.0 * m);\n        m -= c[1] / 32768.0;\n        c[0] = floor(8388608.0 * m);\n\n        highp float ebias = e + 127.0;\n        c[3] = floor(ebias / 2.0);\n        ebias -= c[3] * 2.0;\n        c[2] += floor(ebias) * 128.0;\n\n        c[3] += 128.0 * step(0.0, -v);\n\n        return c / 255.0;\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        " + t.output + " = encode_float(x);\n      }\n    ";
  };
}(),
    COMPLEX_FFT = { REAL: "return real * expR - imag * expI;", IMAG: "return real * expI + imag * expR;" },
    FFTProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["real", "imag"];var r = t[1];this.outputShape = t;var o = n ? "2.0 * " + Math.PI : "-2.0 * " + Math.PI,
        a = n ? r + ".0" : "1.0";this.userCode = "\n      const float exponentMultiplier = " + o + ";\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        " + e + "\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(" + r + ");\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < " + r + "; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / " + a + ";\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    ";
  };
}(),
    FromPixelsProgram = function () {
  return function (e) {
    this.variableNames = ["A"];var t = getGlslDifferences(),
        n = e[0],
        r = e[1];this.outputShape = e, this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + r + ".0, " + n + ".0);\n\n        vec4 values = " + t.texture2D + "(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    ";
  };
}(),
    GatherProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["A", "indices"];var r = e.slice();r[n] = t, this.outputShape = r, this.rank = r.length;var o = getCoordsDataType(this.rank),
        a = getSourceCoords(e, n);this.userCode = "\n      void main() {\n        " + o + " resRC = getOutputCoords();\n        setOutput(getA(" + a + "));\n      }\n    ";
  };
}();function getSourceCoords(e, t) {
  var n = e.length;if (n > 4) throw Error("Gather for rank " + n + " is not yet supported");if (1 === n) return "int(getIndices(resRC))";for (var r = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"], o = [], a = 0; a < e.length; a++) {
    a === t ? o.push("int(getIndices(" + r[a] + "))") : o.push("" + r[a]);
  }return o.join();
}var GatherNDProgram = function () {
  return function (e, t, n) {
    this.sliceDim = e, this.strides = t, this.variableNames = ["x", "indices"], this.outputShape = n;var r = getCoordsDataType(t.length),
        o = getCoordsDataType(n.length),
        a = this.sliceDim > 1 ? "strides[j]" : "strides";this.userCode = "\n        " + r + " strides = " + r + "(" + this.strides + ");\n         void main() {\n          " + o + " coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < " + this.sliceDim + "; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * " + a + ";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      ";
  };
}();function callAndCheck(e, t) {
  var n = t();return checkWebGLError(e), n;
}var webGLDebugErrorCheckingEnabled = !1;function enableDebugWebGLErrorChecking(e) {
  webGLDebugErrorCheckingEnabled = e;
}function checkWebGLError(e) {
  if (webGLDebugErrorCheckingEnabled) {
    var t = e.getError();if (t !== e.NO_ERROR) throw new Error("WebGL Error: " + getWebGLErrorMessage(e, t));
  }
}var MIN_FLOAT16 = 5.96e-8,
    MAX_FLOAT16 = 65504;function canBeRepresented(e) {
  return !!(ENV.get("WEBGL_RENDER_FLOAT32_ENABLED") || 0 === e || MIN_FLOAT16 < Math.abs(e) && Math.abs(e) < MAX_FLOAT16);
}function getWebGLErrorMessage(e, t) {
  switch (t) {case e.NO_ERROR:
      return "NO_ERROR";case e.INVALID_ENUM:
      return "INVALID_ENUM";case e.INVALID_VALUE:
      return "INVALID_VALUE";case e.INVALID_OPERATION:
      return "INVALID_OPERATION";case e.INVALID_FRAMEBUFFER_OPERATION:
      return "INVALID_FRAMEBUFFER_OPERATION";case e.OUT_OF_MEMORY:
      return "OUT_OF_MEMORY";case e.CONTEXT_LOST_WEBGL:
      return "CONTEXT_LOST_WEBGL";default:
      return "Unknown error code " + t;}
}function getExtensionOrThrow(e, t) {
  return throwIfNull(e, function () {
    return e.getExtension(t);
  }, 'Extension "' + t + '" not supported on this browser.');
}function createVertexShader(e, t) {
  var n = throwIfNull(e, function () {
    return e.createShader(e.VERTEX_SHADER);
  }, "Unable to create vertex WebGLShader.");if (callAndCheck(e, function () {
    return e.shaderSource(n, t);
  }), callAndCheck(e, function () {
    return e.compileShader(n);
  }), !1 === e.getShaderParameter(n, e.COMPILE_STATUS)) throw console.log(e.getShaderInfoLog(n)), new Error("Failed to compile vertex shader.");return n;
}function createFragmentShader(e, t) {
  var n = throwIfNull(e, function () {
    return e.createShader(e.FRAGMENT_SHADER);
  }, "Unable to create fragment WebGLShader.");if (callAndCheck(e, function () {
    return e.shaderSource(n, t);
  }), callAndCheck(e, function () {
    return e.compileShader(n);
  }), !1 === e.getShaderParameter(n, e.COMPILE_STATUS)) throw logShaderSourceAndInfoLog(t, e.getShaderInfoLog(n)), new Error("Failed to compile fragment shader.");return n;
}var lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;function logShaderSourceAndInfoLog(e, t) {
  var n = lineNumberRegex.exec(t);if (null == n) return console.log("Couldn't parse line number in error: " + t), void console.log(e);for (var r = +n[1], o = e.split("\n"), a = o.length.toString().length + 2, i = o.map(function (e, t) {
    return rightPad((t + 1).toString(), a) + e;
  }), s = 0, u = 0; u < i.length; u++) {
    s = Math.max(i[u].length, s);
  }var l = i.slice(0, r - 1),
      c = i.slice(r - 1, r),
      p = i.slice(r);console.log(l.join("\n")), console.log(t.split("\n")[0]), console.log("%c " + rightPad(c[0], s), "border:1px solid red; background-color:#e3d2d2; color:#a61717"), console.log(p.join("\n"));
}function createProgram(e) {
  return throwIfNull(e, function () {
    return e.createProgram();
  }, "Unable to create WebGLProgram.");
}function linkProgram(e, t) {
  if (callAndCheck(e, function () {
    return e.linkProgram(t);
  }), !1 === e.getProgramParameter(t, e.LINK_STATUS)) throw console.log(e.getProgramInfoLog(t)), new Error("Failed to link vertex and fragment shaders.");
}function validateProgram(e, t) {
  if (callAndCheck(e, function () {
    return e.validateProgram(t);
  }), !1 === e.getProgramParameter(t, e.VALIDATE_STATUS)) throw console.log(e.getProgramInfoLog(t)), new Error("Shader program validation failed.");
}function createStaticVertexBuffer(e, t) {
  var n = throwIfNull(e, function () {
    return e.createBuffer();
  }, "Unable to create WebGLBuffer");return callAndCheck(e, function () {
    return e.bindBuffer(e.ARRAY_BUFFER, n);
  }), callAndCheck(e, function () {
    return e.bufferData(e.ARRAY_BUFFER, t, e.STATIC_DRAW);
  }), n;
}function createStaticIndexBuffer(e, t) {
  var n = throwIfNull(e, function () {
    return e.createBuffer();
  }, "Unable to create WebGLBuffer");return callAndCheck(e, function () {
    return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, n);
  }), callAndCheck(e, function () {
    return e.bufferData(e.ELEMENT_ARRAY_BUFFER, t, e.STATIC_DRAW);
  }), n;
}function getNumChannels() {
  return 2 === ENV.get("WEBGL_VERSION") ? 1 : 4;
}function createTexture(e) {
  return throwIfNull(e, function () {
    return e.createTexture();
  }, "Unable to create WebGLTexture.");
}function validateTextureSize(e, t) {
  var n = ENV.get("WEBGL_MAX_TEXTURE_SIZE");if (e <= 0 || t <= 0) {
    var r = "[" + e + "x" + t + "]";throw new Error("Requested texture size " + r + " is invalid.");
  }if (e > n || t > n) {
    r = "[" + e + "x" + t + "]";throw new Error("Requested texture size " + r + " greater than WebGL maximum on this browser / GPU " + ("[" + n + "x" + n + "]") + ".");
  }
}function createFramebuffer(e) {
  return throwIfNull(e, function () {
    return e.createFramebuffer();
  }, "Unable to create WebGLFramebuffer.");
}function bindVertexBufferToProgramAttribute(e, t, n, r, o, a, i) {
  var s = e.getAttribLocation(t, n);return -1 !== s && (callAndCheck(e, function () {
    return e.bindBuffer(e.ARRAY_BUFFER, r);
  }), callAndCheck(e, function () {
    return e.vertexAttribPointer(s, o, e.FLOAT, !1, a, i);
  }), callAndCheck(e, function () {
    return e.enableVertexAttribArray(s);
  }), !0);
}function bindTextureUnit(e, t, n) {
  validateTextureUnit(e, n), callAndCheck(e, function () {
    return e.activeTexture(e.TEXTURE0 + n);
  }), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, t);
  });
}function unbindTextureUnit(e, t) {
  validateTextureUnit(e, t), callAndCheck(e, function () {
    return e.activeTexture(e.TEXTURE0 + t);
  }), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, null);
  });
}function getProgramUniformLocationOrThrow(e, t, n) {
  return throwIfNull(e, function () {
    return e.getUniformLocation(t, n);
  }, 'uniform "' + n + '" not present in program.');
}function getProgramUniformLocation(e, t, n) {
  return e.getUniformLocation(t, n);
}function bindTextureToProgramUniformSampler(e, t, n, r, o) {
  callAndCheck(e, function () {
    return bindTextureUnit(e, n, o);
  }), callAndCheck(e, function () {
    return e.uniform1i(r, o);
  });
}function bindCanvasToFramebuffer(e) {
  callAndCheck(e, function () {
    return e.bindFramebuffer(e.FRAMEBUFFER, null);
  }), callAndCheck(e, function () {
    return e.viewport(0, 0, e.canvas.width, e.canvas.height);
  }), callAndCheck(e, function () {
    return e.scissor(0, 0, e.canvas.width, e.canvas.height);
  });
}function bindColorTextureToFramebuffer(e, t, n) {
  callAndCheck(e, function () {
    return e.bindFramebuffer(e.FRAMEBUFFER, n);
  }), callAndCheck(e, function () {
    return e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
  });
}function unbindColorTextureFromFramebuffer(e, t) {
  callAndCheck(e, function () {
    return e.bindFramebuffer(e.FRAMEBUFFER, t);
  }), callAndCheck(e, function () {
    return e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, null, 0);
  });
}function validateFramebuffer(e) {
  var t = e.checkFramebufferStatus(e.FRAMEBUFFER);if (t !== e.FRAMEBUFFER_COMPLETE) throw new Error("Error binding framebuffer: " + getFramebufferErrorMessage(e, t));
}function getFramebufferErrorMessage(e, t) {
  switch (t) {case e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
      return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
      return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
      return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";case e.FRAMEBUFFER_UNSUPPORTED:
      return "FRAMEBUFFER_UNSUPPORTED";default:
      return "unknown error " + t;}
}function throwIfNull(e, t, n) {
  var r = callAndCheck(e, function () {
    return t();
  });if (null == r) throw new Error(n);return r;
}function validateTextureUnit(e, t) {
  var n = e.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1,
      r = t + e.TEXTURE0;if (r < e.TEXTURE0 || r > n) throw new Error("textureUnit must be in " + ("[gl.TEXTURE0, gl.TEXTURE" + n + "]") + ".");
}function getBatchDim(e, t) {
  return void 0 === t && (t = 2), sizeFromShape(e.slice(0, e.length - t));
}function getRowsCols(e) {
  if (0 === e.length) throw Error("Cannot get rows and columns of an empty shape array.");return [e.length > 1 ? e[e.length - 2] : 1, e[e.length - 1]];
}function getTextureShapeFromLogicalShape(e, t) {
  var n;void 0 === t && (t = !1);var r = ENV.get("WEBGL_MAX_TEXTURE_SIZE");if (t && (r *= 2, 1 === (e = e.map(function (t, n) {
    return n >= e.length - 2 ? nearestLargerEven(e[n]) : e[n];
  })).length && (e = [2, e[0]])), 2 !== e.length) {
    var o = squeezeShape(e);e = o.newShape;
  }var a = sizeFromShape(e);if (e.length <= 1 && a <= r) return [1, a];if (2 === e.length && e[0] <= r && e[1] <= r) return e;if (3 === e.length && e[0] * e[1] <= r && e[2] <= r) return [e[0] * e[1], e[2]];if (3 === e.length && e[0] <= r && e[1] * e[2] <= r) return [e[0], e[1] * e[2]];if (4 === e.length && e[0] * e[1] * e[2] <= r && e[3] <= r) return [e[0] * e[1] * e[2], e[3]];if (4 === e.length && e[0] <= r && e[1] * e[2] * e[3] <= r) return [e[0], e[1] * e[2] * e[3]];if (t) {
    var i = getBatchDim(e),
        s = 2,
        u = 2;return e.length && (s = (n = getRowsCols(e))[0], u = n[1]), sizeToSquarishShape(a = i * (s / 2) * (u / 2)).map(function (e) {
      return 2 * e;
    });
  }return sizeToSquarishShape(a);
}function isEven(e) {
  return e % 2 == 0;
}function isReshapeFree(e, t) {
  if (arraysEqual(e = e.slice(-2), t = t.slice(-2))) return !0;if (!e.length || !t.length) return !0;if (0 === e[0] || 0 === e[1] || 0 === t[0] || 0 === t[1]) return !0;if (e.length !== t.length) {
    var n = e.slice(-1)[0],
        r = t.slice(-1)[0];if (n === r) return !0;if (isEven(n) && isEven(r) && (1 === e[0] || 1 === t[0])) return !0;
  }return e[1] === t[1] && isEven(e[0]) && isEven(t[0]);
}var webgl_util = Object.freeze({ callAndCheck: callAndCheck, enableDebugWebGLErrorChecking: enableDebugWebGLErrorChecking, checkWebGLError: checkWebGLError, canBeRepresented: canBeRepresented, getWebGLErrorMessage: getWebGLErrorMessage, getExtensionOrThrow: getExtensionOrThrow, createVertexShader: createVertexShader, createFragmentShader: createFragmentShader, createProgram: createProgram, linkProgram: linkProgram, validateProgram: validateProgram, createStaticVertexBuffer: createStaticVertexBuffer, createStaticIndexBuffer: createStaticIndexBuffer, getNumChannels: getNumChannels, createTexture: createTexture, validateTextureSize: validateTextureSize, createFramebuffer: createFramebuffer, bindVertexBufferToProgramAttribute: bindVertexBufferToProgramAttribute, bindTextureUnit: bindTextureUnit, unbindTextureUnit: unbindTextureUnit, getProgramUniformLocationOrThrow: getProgramUniformLocationOrThrow, getProgramUniformLocation: getProgramUniformLocation, bindTextureToProgramUniformSampler: bindTextureToProgramUniformSampler, bindCanvasToFramebuffer: bindCanvasToFramebuffer, bindColorTextureToFramebuffer: bindColorTextureToFramebuffer, unbindColorTextureFromFramebuffer: unbindColorTextureFromFramebuffer, validateFramebuffer: validateFramebuffer, getFramebufferErrorMessage: getFramebufferErrorMessage, getBatchDim: getBatchDim, getRowsCols: getRowsCols, getTextureShapeFromLogicalShape: getTextureShapeFromLogicalShape, isReshapeFree: isReshapeFree });function createVertexShader$1(e) {
  var t = getGlslDifferences();return createVertexShader(e, t.version + "\n    precision highp float;\n    " + t.attribute + " vec3 clipSpacePos;\n    " + t.attribute + " vec2 uv;\n    " + t.varyingVs + " vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }");
}function createVertexBuffer(e) {
  return createStaticVertexBuffer(e, new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]));
}function createIndexBuffer(e) {
  return createStaticIndexBuffer(e, new Uint16Array([0, 1, 2, 2, 1, 3]));
}function getTextureConfig(e, t) {
  var n,
      r,
      o,
      a,
      i,
      s,
      u,
      l = e;return 2 === ENV.get("WEBGL_VERSION") ? (n = l.R32F, r = l.R16F, o = l.RGBA32F, a = l.RED, i = 4, s = 1, u = l.HALF_FLOAT) : (n = e.RGBA, r = e.RGBA, o = l.RGBA, a = e.RGBA, i = 4, s = 4, u = null != t ? t.HALF_FLOAT_OES : null), { internalFormatFloat: n, internalFormatHalfFloat: r, internalFormatPackedFloat: o, textureFormatFloat: a, downloadTextureFormat: e.RGBA, downloadUnpackNumChannels: i, defaultNumChannels: s, textureTypeHalfFloat: u };
}function createAndConfigureTexture(e, t, n, r, o, a) {
  validateTextureSize(t, n);var i = createTexture(e),
      s = e.TEXTURE_2D;return callAndCheck(e, function () {
    return e.bindTexture(s, i);
  }), callAndCheck(e, function () {
    return e.texParameteri(s, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
  }), callAndCheck(e, function () {
    return e.texParameteri(s, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
  }), callAndCheck(e, function () {
    return e.texParameteri(s, e.TEXTURE_MIN_FILTER, e.NEAREST);
  }), callAndCheck(e, function () {
    return e.texParameteri(s, e.TEXTURE_MAG_FILTER, e.NEAREST);
  }), callAndCheck(e, function () {
    return e.texImage2D(s, 0, r, t, n, 0, o, a, null);
  }), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, null);
  }), i;
}function createFloat32MatrixTexture(e, t, n, r) {
  var o = getUnpackedMatrixTextureShapeWidthHeight(t, n);return createAndConfigureTexture(e, o[0], o[1], r.internalFormatFloat, r.textureFormatFloat, e.FLOAT);
}function createFloat16MatrixTexture(e, t, n, r) {
  var o = getUnpackedMatrixTextureShapeWidthHeight(t, n);return createAndConfigureTexture(e, o[0], o[1], r.internalFormatFloat, r.textureFormatFloat, r.textureTypeHalfFloat);
}function createUnsignedBytesMatrixTexture(e, t, n, r) {
  var o = getUnpackedMatrixTextureShapeWidthHeight(t, n);return createAndConfigureTexture(e, o[0], o[1], e.RGBA, e.RGBA, e.UNSIGNED_BYTE);
}function createPackedMatrixTexture(e, t, n, r) {
  var o = getPackedMatrixTextureShapeWidthHeight(t, n);return createAndConfigureTexture(e, o[0], o[1], r.internalFormatPackedFloat, e.RGBA, e.FLOAT);
}function createFloat16PackedMatrixTexture(e, t, n, r) {
  var o = getPackedMatrixTextureShapeWidthHeight(t, n);return createAndConfigureTexture(e, o[0], o[1], r.internalFormatHalfFloat, e.RGBA, r.textureTypeHalfFloat);
}function bindVertexProgramAttributeStreams(e, t, n) {
  return callAndCheck(e, function () {
    return e.bindBuffer(e.ARRAY_BUFFER, n);
  }), bindVertexBufferToProgramAttribute(e, t, "clipSpacePos", n, 3, 20, 0) && bindVertexBufferToProgramAttribute(e, t, "uv", n, 2, 20, 12);
}function uploadPixelDataToTexture(e, t, n) {
  callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, t);
  }), callAndCheck(e, function () {
    return e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, n);
  }), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, null);
  });
}function uploadDataToTexture(e, t, n, r, o, a) {
  validateTextureSize(n, r), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, t);
  }), callAndCheck(e, function () {
    return e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, n, r, a, e.FLOAT, o);
  }), callAndCheck(e, function () {
    return e.bindTexture(e.TEXTURE_2D, null);
  });
}function uploadMatrixToTexture(e, t, n, r, o, a, i) {
  var s,
      u = getUnpackedMatrixTextureShapeWidthHeight(n, r),
      l = u[0],
      c = u[1];1 === i.defaultNumChannels ? s = o : encodeMatrixToUnpackedArray(o, s = new Float32Array(getUnpackedArraySizeFromMatrixSize(o.length, a)), a), uploadDataToTexture(e, t, l, c, s, i.textureFormatFloat);
}function uploadMatrixToPackedTexture(e, t, n, r, o, a, i, s, u) {
  var l = getPackedMatrixTextureShapeWidthHeight(a, i),
      c = l[0],
      p = l[1],
      d = new Float32Array(getPackedRGBAArraySizeFromMatrixShape(a, i));encodeMatrixToPackedRGBA(s, n, r, o, d), uploadDataToTexture(e, t, c, p, d, e.RGBA);
}function maybeCreateBufferFromOutputTexture(e, t, n, r, o) {
  var a = t;if (2 === ENV.get("WEBGL_VERSION")) {
    var i = e,
        s = i.createBuffer();callAndCheck(e, function () {
      return e.bindBuffer(i.PIXEL_PACK_BUFFER, s);
    });var u = 4 * getUnpackedArraySizeFromMatrixSize(n * r, o.downloadUnpackNumChannels);callAndCheck(e, function () {
      return e.bufferData(i.PIXEL_PACK_BUFFER, u, i.STREAM_READ);
    }), callAndCheck(e, function () {
      return i.readPixels(0, 0, r, n, e.RGBA, e.FLOAT, 0);
    }), callAndCheck(e, function () {
      return e.bindBuffer(i.PIXEL_PACK_BUFFER, null);
    }), a = s;
  }return a;
}function downloadFloat32MatrixFromBuffer(e, t, n, r, o) {
  var a = e,
      i = new Float32Array(getUnpackedArraySizeFromMatrixSize(n * r, o.downloadUnpackNumChannels));a.bindBuffer(a.PIXEL_PACK_BUFFER, t), a.getBufferSubData(a.PIXEL_PACK_BUFFER, 0, i), a.bindBuffer(a.PIXEL_PACK_BUFFER, null);var s = new Float32Array(n * r);return decodeMatrixFromUnpackedArray(i, s, o.downloadUnpackNumChannels), s;
}function downloadFloat32MatrixFromOutputTexture(e, t, n, r) {
  var o = getUnpackedMatrixTextureShapeWidthHeight(t, n),
      a = o[0],
      i = o[1],
      s = new Float32Array(getUnpackedArraySizeFromMatrixSize(t * n, r.downloadUnpackNumChannels));callAndCheck(e, function () {
    return e.readPixels(0, 0, a, i, r.downloadTextureFormat, e.FLOAT, s);
  });var u = new Float32Array(t * n);return decodeMatrixFromUnpackedArray(s, u, r.downloadUnpackNumChannels), u;
}function downloadByteEncodedFloatMatrixFromOutputTexture(e, t, n, r) {
  var o = getUnpackedMatrixTextureShapeWidthHeight(t, n),
      a = o[0],
      i = o[1],
      s = new Uint8Array(getUnpackedArraySizeFromMatrixSize(t * n, 4));return callAndCheck(e, function () {
    return e.readPixels(0, 0, a, i, r.downloadTextureFormat, e.UNSIGNED_BYTE, s);
  }), new Float32Array(s.buffer);
}function downloadPackedMatrixFromBuffer(e, t, n, r, o, a, i, s) {
  var u = e,
      l = new Float32Array(getPackedRGBAArraySizeFromMatrixShape(a, i));u.bindBuffer(u.PIXEL_PACK_BUFFER, t), u.getBufferSubData(u.PIXEL_PACK_BUFFER, 0, l), u.bindBuffer(u.PIXEL_PACK_BUFFER, null);var c = new Float32Array(sizeFromShape([n, r, o]));return decodeMatrixFromPackedRGBA(l, n, r, o, c), c;
}function downloadMatrixFromPackedOutputTexture(e, t, n, r, o, a, i) {
  var s = getPackedMatrixTextureShapeWidthHeight(o, a),
      u = s[0],
      l = s[1],
      c = new Float32Array(getPackedRGBAArraySizeFromMatrixShape(o, a));callAndCheck(e, function () {
    return e.readPixels(0, 0, u, l, e.RGBA, e.FLOAT, c);
  });var p = new Float32Array(sizeFromShape([t, n, r]));return decodeMatrixFromPackedRGBA(c, t, n, r, p);
}var gpgpu_util = Object.freeze({ createVertexShader: createVertexShader$1, createVertexBuffer: createVertexBuffer, createIndexBuffer: createIndexBuffer, getTextureConfig: getTextureConfig, createFloat32MatrixTexture: createFloat32MatrixTexture, createFloat16MatrixTexture: createFloat16MatrixTexture, createUnsignedBytesMatrixTexture: createUnsignedBytesMatrixTexture, createPackedMatrixTexture: createPackedMatrixTexture, createFloat16PackedMatrixTexture: createFloat16PackedMatrixTexture, bindVertexProgramAttributeStreams: bindVertexProgramAttributeStreams, uploadPixelDataToTexture: uploadPixelDataToTexture, uploadMatrixToTexture: uploadMatrixToTexture, uploadMatrixToPackedTexture: uploadMatrixToPackedTexture, maybeCreateBufferFromOutputTexture: maybeCreateBufferFromOutputTexture, downloadFloat32MatrixFromBuffer: downloadFloat32MatrixFromBuffer, downloadFloat32MatrixFromOutputTexture: downloadFloat32MatrixFromOutputTexture, downloadByteEncodedFloatMatrixFromOutputTexture: downloadByteEncodedFloatMatrixFromOutputTexture, downloadPackedMatrixFromBuffer: downloadPackedMatrixFromBuffer, downloadMatrixFromPackedOutputTexture: downloadMatrixFromPackedOutputTexture }),
    GPGPUContext = function () {
  function e(e) {
    this.outputTexture = null, this.program = null, this.disposed = !1, this.autoDebugValidate = !1, this.vertexAttrsAreBound = !1, this.itemsToPoll = [], this.gl = null != e ? e : getWebGLContext(ENV.get("WEBGL_VERSION")), 1 === ENV.get("WEBGL_VERSION") ? (this.textureFloatExtension = getExtensionOrThrow(this.gl, "OES_texture_float"), this.colorBufferFloatExtension = this.gl.getExtension("WEBGL_color_buffer_float"), ENV.get("WEBGL_RENDER_FLOAT32_ENABLED") || (this.textureHalfFloatExtension = getExtensionOrThrow(this.gl, "OES_texture_half_float"), this.colorBufferHalfFloatExtension = this.gl.getExtension("EXT_color_buffer_half_float"))) : this.colorBufferFloatExtension = getExtensionOrThrow(this.gl, "EXT_color_buffer_float"), this.vertexBuffer = createVertexBuffer(this.gl), this.indexBuffer = createIndexBuffer(this.gl), this.framebuffer = createFramebuffer(this.gl), this.textureConfig = getTextureConfig(this.gl, this.textureHalfFloatExtension);
  }return e.prototype.dispose = function () {
    var e = this;if (!this.disposed) {
      null != this.program && console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."), null != this.outputTexture && console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");var t = this.gl;callAndCheck(t, function () {
        return t.finish();
      }), callAndCheck(t, function () {
        return t.bindFramebuffer(t.FRAMEBUFFER, null);
      }), callAndCheck(t, function () {
        return t.deleteFramebuffer(e.framebuffer);
      }), callAndCheck(t, function () {
        return t.bindBuffer(t.ARRAY_BUFFER, null);
      }), callAndCheck(t, function () {
        return t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, null);
      }), callAndCheck(t, function () {
        return t.deleteBuffer(e.indexBuffer);
      }), this.disposed = !0;
    }
  }, e.prototype.enableAutomaticDebugValidation = function (e) {
    this.autoDebugValidate = e, enableDebugWebGLErrorChecking(e);
  }, e.prototype.createFloat32MatrixTexture = function (e, t) {
    return this.throwIfDisposed(), createFloat32MatrixTexture(this.gl, e, t, this.textureConfig);
  }, e.prototype.createFloat16MatrixTexture = function (e, t) {
    return this.throwIfDisposed(), createFloat16MatrixTexture(this.gl, e, t, this.textureConfig);
  }, e.prototype.createUnsignedBytesMatrixTexture = function (e, t) {
    return this.throwIfDisposed(), createUnsignedBytesMatrixTexture(this.gl, e, t, this.textureConfig);
  }, e.prototype.uploadPixelDataToTexture = function (e, t) {
    this.throwIfDisposed(), uploadPixelDataToTexture(this.gl, e, t);
  }, e.prototype.createFloat16PackedMatrixTexture = function (e, t) {
    return this.throwIfDisposed(), createFloat16PackedMatrixTexture(this.gl, e, t, this.textureConfig);
  }, e.prototype.createPackedMatrixTexture = function (e, t) {
    return this.throwIfDisposed(), createPackedMatrixTexture(this.gl, e, t, this.textureConfig);
  }, e.prototype.deleteMatrixTexture = function (e) {
    var t = this;this.throwIfDisposed(), this.outputTexture === e && (unbindColorTextureFromFramebuffer(this.gl, this.framebuffer), this.outputTexture = null), callAndCheck(this.gl, function () {
      return t.gl.deleteTexture(e);
    });
  }, e.prototype.uploadMatrixToTexture = function (e, t, n, r) {
    this.throwIfDisposed();var o = getNumChannels();return uploadMatrixToTexture(this.gl, e, t, n, r, o, this.textureConfig);
  }, e.prototype.uploadMatrixToPackedTexture = function (e, t, n, r, o, a, i) {
    return this.throwIfDisposed(), uploadMatrixToPackedTexture(this.gl, e, t, n, r, o, a, i, this.textureConfig);
  }, e.prototype.downloadFloat32MatrixFromOutputTexture = function (e, t, n) {
    var r = this;return this.downloadMatrixDriver(e, function () {
      return downloadFloat32MatrixFromOutputTexture(r.gl, t, n, r.textureConfig);
    });
  }, e.prototype.downloadByteEncodedFloatMatrixFromOutputTexture = function (e, t, n) {
    var r = this;return this.downloadMatrixDriver(e, function () {
      return downloadByteEncodedFloatMatrixFromOutputTexture(r.gl, t, n, r.textureConfig);
    });
  }, e.prototype.downloadPackedMatrixFromBuffer = function (e, t, n, r, o, a) {
    return downloadPackedMatrixFromBuffer(this.gl, e, t, n, r, o, a, this.textureConfig);
  }, e.prototype.downloadFloat32MatrixFromBuffer = function (e, t, n) {
    return downloadFloat32MatrixFromBuffer(this.gl, e, t, n, this.textureConfig);
  }, e.prototype.maybeCreateBufferFromTexture = function (e, t, n) {
    this.bindTextureToFrameBuffer(e);var r = maybeCreateBufferFromOutputTexture(this.gl, e, t, n, this.textureConfig);return this.unbindTextureToFrameBuffer(), r;
  }, e.prototype.createAndWaitForFence = function () {
    var e = this.createFence(this.gl);return this.pollFence(e);
  }, e.prototype.createFence = function (e) {
    var t,
        n,
        r = this;if (ENV.get("WEBGL_FENCE_API_ENABLED")) {
      var o = e,
          a = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0);e.flush(), n = function n() {
        var e = o.clientWaitSync(a, 0, 0);return e === o.ALREADY_SIGNALED || e === o.CONDITION_SATISFIED;
      }, t = a;
    } else ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (t = this.beginQuery(), this.endQuery(), n = function n() {
      return r.isQueryAvailable(t, ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
    }) : n = function n() {
      return !0;
    };return { query: t, isFencePassed: n };
  }, e.prototype.downloadMatrixFromPackedTexture = function (e, t, n, r, o, a) {
    var i = this;return this.downloadMatrixDriver(e, function () {
      return downloadMatrixFromPackedOutputTexture(i.gl, t, n, r, o, a, i.textureConfig);
    });
  }, e.prototype.createProgram = function (e) {
    this.throwIfDisposed();var t = this.gl,
        n = createFragmentShader(t, e),
        r = createVertexShader$1(t),
        o = createProgram(t);return callAndCheck(t, function () {
      return t.attachShader(o, r);
    }), callAndCheck(t, function () {
      return t.attachShader(o, n);
    }), linkProgram(t, o), this.autoDebugValidate && validateProgram(t, o), this.vertexAttrsAreBound || (this.setProgram(o), this.vertexAttrsAreBound = bindVertexProgramAttributeStreams(t, this.program, this.vertexBuffer)), o;
  }, e.prototype.deleteProgram = function (e) {
    var t = this;this.throwIfDisposed(), e === this.program && (this.program = null), null != e && callAndCheck(this.gl, function () {
      return t.gl.deleteProgram(e);
    });
  }, e.prototype.setProgram = function (e) {
    var t = this;this.throwIfDisposed(), this.program = e, null != this.program && this.autoDebugValidate && validateProgram(this.gl, this.program), callAndCheck(this.gl, function () {
      return t.gl.useProgram(e);
    });
  }, e.prototype.getUniformLocation = function (e, t, n) {
    return void 0 === n && (n = !0), this.throwIfDisposed(), n ? getProgramUniformLocationOrThrow(this.gl, e, t) : getProgramUniformLocation(this.gl, e, t);
  }, e.prototype.getAttributeLocation = function (e, t) {
    var n = this;return this.throwIfDisposed(), callAndCheck(this.gl, function () {
      return n.gl.getAttribLocation(e, t);
    });
  }, e.prototype.getUniformLocationNoThrow = function (e, t) {
    return this.throwIfDisposed(), this.gl.getUniformLocation(e, t);
  }, e.prototype.setInputMatrixTexture = function (e, t, n) {
    this.throwIfDisposed(), this.throwIfNoProgram(), bindTextureToProgramUniformSampler(this.gl, this.program, e, t, n);
  }, e.prototype.setOutputMatrixTexture = function (e, t, n) {
    this.setOutputMatrixTextureDriver(e, n, t);
  }, e.prototype.setOutputPackedMatrixTexture = function (e, t, n) {
    this.throwIfDisposed();var r = getPackedMatrixTextureShapeWidthHeight(t, n),
        o = r[0],
        a = r[1];this.setOutputMatrixTextureDriver(e, o, a);
  }, e.prototype.setOutputMatrixWriteRegion = function (e, t, n, r) {
    this.setOutputMatrixWriteRegionDriver(n, e, r, t);
  }, e.prototype.setOutputPackedMatrixWriteRegion = function (e, t, n, r) {
    throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
  }, e.prototype.debugValidate = function () {
    null != this.program && validateProgram(this.gl, this.program), validateFramebuffer(this.gl);
  }, e.prototype.executeProgram = function () {
    this.throwIfDisposed(), this.throwIfNoProgram();var e = this.gl;this.autoDebugValidate && this.debugValidate(), callAndCheck(e, function () {
      return e.drawElements(e.TRIANGLES, 6, e.UNSIGNED_SHORT, 0);
    });
  }, e.prototype.blockUntilAllProgramsCompleted = function () {
    var e = this;this.throwIfDisposed(), callAndCheck(this.gl, function () {
      return e.gl.finish();
    });
  }, e.prototype.getQueryTimerExtension = function () {
    return null == this.disjointQueryTimerExtension && (this.disjointQueryTimerExtension = getExtensionOrThrow(this.gl, 2 === ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query")), this.disjointQueryTimerExtension;
  }, e.prototype.getQueryTimerExtensionWebGL2 = function () {
    return this.getQueryTimerExtension();
  }, e.prototype.getQueryTimerExtensionWebGL1 = function () {
    return this.getQueryTimerExtension();
  }, e.prototype.beginQuery = function () {
    if (2 === ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
      var e = this.gl,
          t = this.getQueryTimerExtensionWebGL2(),
          n = e.createQuery();return e.beginQuery(t.TIME_ELAPSED_EXT, n), n;
    }var r = this.getQueryTimerExtensionWebGL1(),
        o = r.createQueryEXT();return r.beginQueryEXT(r.TIME_ELAPSED_EXT, o), o;
  }, e.prototype.endQuery = function () {
    if (2 !== ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
      var e = this.getQueryTimerExtensionWebGL1();e.endQueryEXT(e.TIME_ELAPSED_EXT);
    } else {
      var t = this.gl,
          n = this.getQueryTimerExtensionWebGL2();t.endQuery(n.TIME_ELAPSED_EXT);
    }
  }, e.prototype.waitForQueryAndGetTime = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return [4, repeatedTry(function () {
              return t.disposed || t.isQueryAvailable(e, ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
            })];case 1:
            return n.sent(), [2, this.getQueryTime(e, ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))];}
      });
    });
  }, e.prototype.getQueryTime = function (e, t) {
    if (0 === t) return null;if (2 === t) {
      var n = this.gl;return n.getQueryParameter(e, n.QUERY_RESULT) / 1e6;
    }var r = this.getQueryTimerExtensionWebGL1();return r.getQueryObjectEXT(e, r.QUERY_RESULT_EXT) / 1e6;
  }, e.prototype.isQueryAvailable = function (e, t) {
    if (0 === t) return !0;if (2 === t) {
      var n = this.gl,
          r = this.getQueryTimerExtensionWebGL2(),
          o = n.getQueryParameter(e, n.QUERY_RESULT_AVAILABLE);return null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), o && !this.disjoint;
    }o = (r = this.getQueryTimerExtensionWebGL1()).getQueryObjectEXT(e, r.QUERY_RESULT_AVAILABLE_EXT);return null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), o && !this.disjoint;
  }, e.prototype.pollFence = function (e) {
    var t = this;return new Promise(function (n) {
      t.addItemToPoll(function () {
        return e.isFencePassed();
      }, function () {
        return n();
      });
    });
  }, e.prototype.pollItems = function () {
    for (var e = binSearchLastTrue(this.itemsToPoll.map(function (e) {
      return e.isDoneFn;
    })), t = 0; t <= e; ++t) {
      (0, this.itemsToPoll[t].resolveFn)();
    }this.itemsToPoll = this.itemsToPoll.slice(e + 1);
  }, e.prototype.addItemToPoll = function (e, t) {
    var n = this;this.itemsToPoll.push({ isDoneFn: e, resolveFn: t }), this.itemsToPoll.length > 1 || repeatedTry(function () {
      return n.pollItems(), 0 === n.itemsToPoll.length;
    });
  }, e.prototype.bindTextureToFrameBuffer = function (e) {
    this.throwIfDisposed(), bindColorTextureToFramebuffer(this.gl, e, this.framebuffer), this.autoDebugValidate && validateFramebuffer(this.gl);
  }, e.prototype.unbindTextureToFrameBuffer = function () {
    null != this.outputTexture ? (bindColorTextureToFramebuffer(this.gl, this.outputTexture, this.framebuffer), this.autoDebugValidate && validateFramebuffer(this.gl)) : unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
  }, e.prototype.downloadMatrixDriver = function (e, t) {
    this.bindTextureToFrameBuffer(e);var n = t();return this.unbindTextureToFrameBuffer(), n;
  }, e.prototype.setOutputMatrixTextureDriver = function (e, t, n) {
    this.throwIfDisposed();var r = this.gl;bindColorTextureToFramebuffer(r, e, this.framebuffer), this.autoDebugValidate && validateFramebuffer(r), this.outputTexture = e, callAndCheck(r, function () {
      return r.viewport(0, 0, t, n);
    }), callAndCheck(r, function () {
      return r.scissor(0, 0, t, n);
    });
  }, e.prototype.setOutputMatrixWriteRegionDriver = function (e, t, n, r) {
    var o = this;this.throwIfDisposed(), callAndCheck(this.gl, function () {
      return o.gl.scissor(e, t, n, r);
    });
  }, e.prototype.throwIfDisposed = function () {
    if (this.disposed) throw new Error("Attempted to use disposed GPGPUContext.");
  }, e.prototype.throwIfNoProgram = function () {
    if (null == this.program) throw new Error("No GPU program is currently set.");
  }, e;
}();function binSearchLastTrue(e) {
  for (var t = 0, n = e.length - 1, r = -1; t <= n;) {
    var o = t + n >> 1;e[o]() ? (r = o, t = o + 1) : n = o - 1;
  }return r;
}function compileProgram(e, t, n, r) {
  for (var o = t.userCode, a = n.map(function (e, n) {
    var r = { logicalShape: e.shape, texShape: e.isUniform ? null : e.texData.texShape, isUniform: e.isUniform, isPacked: !e.isUniform && e.texData.isPacked, flatOffset: null };return null != e.texData && null != e.texData.slice && e.texData.slice.flatOffset > 0 && (r.flatOffset = e.texData.slice.flatOffset), { name: t.variableNames[n], shapeInfo: r };
  }), i = a.map(function (e) {
    return e.shapeInfo;
  }), s = { logicalShape: r.shape, texShape: r.texData.texShape, isUniform: !1, isPacked: r.texData.isPacked, flatOffset: null }, u = makeShader(a, s, o, t.usesPackedTextures), l = e.createProgram(u), c = {}, p = 0; p < t.variableNames.length; p++) {
    var d = t.variableNames[p];c[d] = e.getUniformLocation(l, d, !1), c["offset" + d] = e.getUniformLocation(l, "offset" + d, !1);
  }return { program: t, source: u, webGLProgram: l, uniformLocations: c, gpgpu: e, inShapeInfos: i, outShapeInfo: s };
}function validateBinaryAndProgram(e, t) {
  if (e.length !== t.length) throw Error("Binary was compiled with " + e.length + " inputs, but was executed with " + t.length + " inputs");e.forEach(function (e, n) {
    var r = e.logicalShape,
        o = t[n],
        a = o.shape;if (!arraysEqual(r, a)) throw Error("Binary was compiled with different shapes than the current args. Shapes " + r + " and " + a + " must match");if (!e.isUniform || !o.isUniform) {
      var i = e.texShape,
          s = o.isUniform ? null : o.texData.texShape;if (!arraysEqual(i, s)) throw Error("Binary was compiled with different texture shapes than the current args. Shape " + i + " and " + s + " must match");
    }
  });
}function runProgram(e, t, n, r) {
  validateBinaryAndProgram(e.inShapeInfos, t), validateBinaryAndProgram([e.outShapeInfo], [n]);var o = n.texData.texture,
      a = n.texData.texShape,
      i = e.gpgpu;n.texData.isPacked ? i.setOutputPackedMatrixTexture(o, a[0], a[1]) : i.setOutputMatrixTexture(o, a[0], a[1]), i.setProgram(e.webGLProgram), t.forEach(function (t, n) {
    var r = e.program.variableNames[n],
        o = e.uniformLocations[r],
        a = e.uniformLocations["offset" + r];if (null != o) if (t.isUniform) {
      if (1 === sizeFromShape(t.shape)) i.gl.uniform1f(o, t.uniformValues[0]);else {
        var s = t.uniformValues;s instanceof Float32Array || (s = new Float32Array(s)), i.gl.uniform1fv(o, s);
      }
    } else null != t.texData.slice && null != a && i.gl.uniform1i(a, t.texData.slice.flatOffset), i.setInputMatrixTexture(t.texData.texture, o, n);
  }), null != r && r(i, e.webGLProgram), i.executeProgram();
}function makeShaderKey(e, t, n) {
  var r = "";t.concat(n).forEach(function (e) {
    var t = null != e.texData && null != e.texData.slice && e.texData.slice.flatOffset > 0,
        n = e.isUniform ? "uniform" : e.texData.texShape;r += e.shape + "_" + n + "_" + t;
  });var o = e.userCode,
      a = e.constructor.name;return a += "_" + r + "_" + o;
}var Im2ColProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["A"], this.outputShape = e;var r = n.filterWidth,
        o = n.inChannels,
        a = n.strideWidth,
        i = n.strideHeight,
        s = n.padInfo,
        u = n.outWidth,
        l = n.dilationWidth,
        c = n.dilationHeight,
        p = s.left,
        d = s.top,
        h = o * r,
        f = getGlslDifferences();this.userCode = "\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            int blockIndex = rc.y + col;\n            int pos = rc.x + row;\n\n            if(blockIndex >= " + e[1] + " || pos >= " + e[0] + ") continue;\n\n            int offsetY = int(blockIndex / (" + u + ")) * " + i + " - " + d + ";\n            int d0 = offsetY + " + c + " * (pos / " + h + ");\n\n            if(d0 >= " + t[0] + " || d0 < 0) continue;\n\n            int offsetX = int(mod(float(blockIndex), " + u + ".) * " + a + ". - " + p + ".);\n            int d1 = offsetX + " + l + " * (int(mod(float(pos), " + h + ".) / " + o + ".));\n\n            if(d1 >= " + t[1] + " || d1 < 0) continue;\n\n            result[row * 2 + col] = getA(d0, d1, int(mod(float(pos), " + o + ".)));\n          }\n        }\n\n        " + f.output + " = result;\n      }\n    ";
  };
}(),
    LRNProgram = function () {
  return function (e, t, n, r, o) {
    this.variableNames = ["x"], this.outputShape = [];var a,
        i = t,
        s = e[3] - 1;this.outputShape = e;var u = "float(" + n + ") + float(" + r + ") * sum";a = .5 === o ? "inversesqrt(" + u + ")" : 1 === o ? "1.0/(" + u + ")" : "exp(log(" + u + ") * float(-" + o + "));", this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -" + i + "; j <= " + i + "; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  " + s + ") {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * " + a + ";\n        setOutput(val);\n      }\n    ";
  };
}(),
    LRNGradProgram = function () {
  return function (e, t, n, r, o) {
    this.variableNames = ["inputImage", "outputImage", "dy"], this.outputShape = [], this.outputShape = e, this.depth = e[3], this.depthRadius = t, this.bias = n, this.alpha = r, this.beta = o, this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < " + this.depth + "; ++d) {\n          int depthBegin = int(max(0.0, float(d - " + t + ")));\n          int depthEnd = int(min(float(" + this.depth + "),\n              float(d + " + t + " + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = " + this.depth + ";\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(" + r + ") * norm + float(" + n + ");\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(" + r + ")\n                * float(" + o + ")\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * " + o + ");\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    ";
  };
}(),
    MaxPool2DBackpropProgram = function () {
  return function (e) {
    this.variableNames = ["dy", "maxPos"], this.outputShape = e.inShape;var t = e.strideHeight,
        n = e.strideWidth,
        r = e.dilationHeight,
        o = e.effectiveFilterHeight,
        a = e.effectiveFilterWidth,
        i = o - 1 - e.padInfo.top,
        s = a - 1 - e.padInfo.left,
        u = o * a - 1;this.userCode = "\n      const ivec2 pads = ivec2(" + i + ", " + s + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + o + ";\n          wR += " + r + ") {\n          float dyR = float(dyRCorner + wR) / " + t + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + a + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + n + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = " + u + " - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * " + a + " + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
  };
}(),
    MatMulProgram = function () {
  return function (e, t, n, r) {
    void 0 === n && (n = !1), void 0 === r && (r = !1), this.variableNames = ["matrixA", "matrixB"];var o = e[0],
        a = n ? e[2] : e[1],
        i = r ? t[1] : t[2],
        s = n ? e[1] : e[2];this.outputShape = [o, a, i];var u = function u(e, t) {
      return n ? "batch, " + t + " + " + e + ", aRow" : "batch, aRow, " + t + " + " + e;
    },
        l = function l(e, t) {
      return r ? "batch, bCol, " + t + " + " + e : "batch, " + t + " + " + e + ", bCol";
    },
        c = 4 * Math.floor(s / 4),
        p = s % 4;this.userCode = " float dotARowBCol(int batch, int aRow, int bCol) {\n      float result = 0.0;\n      for (int i = 0; i < " + c + "; i += 4) {\n        vec4 a = vec4(\n          getMatrixA(" + u(0, "i") + "),\n          getMatrixA(" + u(1, "i") + "),\n          getMatrixA(" + u(2, "i") + "),\n          getMatrixA(" + u(3, "i") + ")\n        );\n        vec4 b = vec4(\n          getMatrixB(" + l(0, "i") + "),\n          getMatrixB(" + l(1, "i") + "),\n          getMatrixB(" + l(2, "i") + "),\n          getMatrixB(" + l(3, "i") + ")\n        );\n\n        result += dot(a, b);\n      }\n\n      if (" + (1 === p) + ") {\n        result += getMatrixA(" + u(0, c) + ") *\n          getMatrixB(" + l(0, c) + ");\n      } else if (" + (2 === p) + ") {\n        vec2 a = vec2(\n          getMatrixA(" + u(0, c) + "),\n          getMatrixA(" + u(1, c) + ")\n        );\n        vec2 b = vec2(\n          getMatrixB(" + l(0, c) + "),\n          getMatrixB(" + l(1, c) + ")\n        );\n        result += dot(a, b);\n      } else if (" + (3 === p) + ") {\n        vec3 a = vec3(\n          getMatrixA(" + u(0, c) + "),\n          getMatrixA(" + u(1, c) + "),\n          getMatrixA(" + u(2, c) + ")\n        );\n        vec3 b = vec3(\n          getMatrixB(" + l(0, c) + "),\n          getMatrixB(" + l(1, c) + "),\n          getMatrixB(" + l(2, c) + ")\n        );\n        result += dot(a, b);\n      }\n\n      return result;\n    }\n\n    void main() {\n      ivec3 resBRC = getOutputCoords();\n      setOutput(dotARowBCol(resBRC.x, resBRC.y, resBRC.z));\n    }\n    ";
  };
}(),
    MatMulPackedProgram = function () {
  return function (e, t, n, r, o) {
    void 0 === r && (r = !1), void 0 === o && (o = !1), this.variableNames = ["matrixA", "matrixB"], this.usesPackedTextures = !0, this.outputShape = n;var a = r ? e[0] : e[1],
        i = Math.ceil(a / 2),
        s = r ? "i * 2, rc.x" : "rc.x, i * 2",
        u = o ? "rc.y, i * 2" : "i * 2, rc.y",
        l = r ? ["a.xxyy", "a.zzww"] : ["a.xxzz", "a.yyww"],
        c = o ? ["b.xzxz", "b.ywyw"] : ["b.xyxy", "b.zwzw"];this.userCode = "\n      const float sharedDimension = " + i + ".0;\n\n      vec4 dot2x2ARowBCol(ivec2 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < " + i + "; i++) {\n          vec4 a = getMatrixA(" + s + ");\n          vec4 b = getMatrixB(" + u + ");\n\n          result += (" + l[0] + " * " + c[0] + ") + (" + l[1] + " * " + c[1] + ");\n        }\n        return result;\n      }\n\n      void main() {\n        ivec2 rc = getOutputCoords();\n        setOutput(dot2x2ARowBCol(rc));\n      }\n    ";
  };
}(),
    MultinomialProgram = function () {
  function e(e, t, n) {
    this.variableNames = ["probs"], this.outputShape = [e, n], this.userCode = "\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < " + (t - 1) + "; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(" + (t - 1) + "));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function (e) {
    var t = this;return function (n, r) {
      null == t.seedLoc && (t.seedLoc = n.getUniformLocation(r, "seed")), n.gl.uniform1f(t.seedLoc, e);
    };
  }, e;
}(),
    OneHotProgram = function () {
  return function (e, t, n, r) {
    this.variableNames = ["indices"], this.outputShape = [e, t], this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(" + r + "), float(" + n + "),\n                      float(index == coords.y)));\n      }\n    ";
  };
}();function getVecChannels(e, t) {
  return ["x", "y", "z", "w", "u", "v"].slice(0, t).map(function (t) {
    return e + "." + t;
  });
}function getChannels(e, t) {
  return 1 === t ? [e] : getVecChannels(e, t);
}function getSourceCoords$1(e, t) {
  if (1 === e) return "rc";for (var n = "", r = 0; r < e; r++) {
    n += t[r], r < e - 1 && (n += ",");
  }return n;
}var PackProgram = function () {
  return function (e) {
    this.variableNames = ["A"], this.isPackShader = !0, this.outputShape = e;var t = e.length;if (0 === t) this.userCode = "\n        void main() {\n          setOutput(vec4(getA(), 0., 0., 0.));\n        }\n      ";else {
      var n = getChannels("rc", t),
          r = getCoordsDataType(t),
          o = getOutOfBoundsCondition(t, e, n),
          a = getSetup(t, e[e.length - 1], e[e.length - 2], n),
          i = getOutput(e, n);this.userCode = "\n        void main() {\n          " + r + " rc = getOutputCoords();\n\n          if(" + o + ") {\n            setOutput(vec4(0));\n          } else {\n            " + a + "\n\n            setOutput(vec4(" + i + "));\n          }\n        }\n      ";
    }
  };
}();function getSourceCoordsArr(e, t) {
  for (var n = [], r = 0; r <= 1; r++) {
    for (var o = 0; o <= 1; o++) {
      for (var a = (0 === r ? "r" : "rp1") + ", " + (0 === o ? "c" : "cp1"), i = 2; i < e; i++) {
        a = t[t.length - 1 - i] + "," + a;
      }n.push(a);
    }
  }return n;
}function getOutOfBoundsCondition(e, t, n) {
  if (1 === e) return "rc > " + t[0];for (var r = "", o = e - 2; o < e; o++) {
    r += n[o] + " >= " + t[o], o < e - 1 && (r += "||");
  }return r;
}function getSetup(e, t, n, r) {
  if (1 === e) return "";var o = r.slice(-2);return "\n    int r = " + o[0] + ";\n    int c = " + o[1] + ";\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= " + t + ";\n    bool rEdge = rp1 >= " + n + ";\n  ";
}function getOutput(e, t) {
  var n = e.length,
      r = getSourceCoordsArr(n, t);return 1 === n ? "getA(rc),\n            rc + 1 >= " + e[0] + " ? 0. : getA(rc + 1),\n            0, 0" : "getA(" + r[0] + "),\n          cEdge ? 0. : getA(" + r[1] + "),\n          rEdge ? 0. : getA(" + r[2] + "),\n          rEdge || cEdge ? 0. : getA(" + r[3] + ")";
}var PadProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["x"], this.outputShape = t.map(function (t, n) {
      return t[0] + e[n] + t[1];
    });var r = e.length,
        o = getCoordsDataType(r),
        a = t.map(function (e) {
      return e[0];
    }).join(","),
        i = t.map(function (t, n) {
      return t[0] + e[n];
    }).join(","),
        s = ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, r);this.userCode = 1 !== r ? "\n      " + o + " start = " + o + "(" + a + ");\n      " + o + " end = " + o + "(" + i + ");\n\n      void main() {\n        " + o + " outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float(" + n + "));\n        } else {\n          " + o + " coords = outC - start;\n          setOutput(getX(" + s + "));\n        }\n      }\n    " : "\n        int start = " + a + ";\n        int end = " + i + ";\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float(" + n + "));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      ";
  };
}(),
    Pool2DProgram = function () {
  return function (e, t, n) {
    if (this.variableNames = ["x"], "avg" === t && n) throw new Error("Cannot compute positions for average pool.");var r = e.filterWidth,
        o = e.strideHeight,
        a = e.strideWidth,
        i = e.dilationHeight,
        s = e.dilationWidth,
        u = e.effectiveFilterHeight,
        l = e.effectiveFilterWidth,
        c = e.padInfo.top,
        p = e.padInfo.left;this.outputShape = e.outShape;var d = "avg" === t,
        h = "0.0";if (d || (h = "-1.0 / 1e-20"), n) this.userCode = "\n        const ivec2 strides = ivec2(" + o + ", " + a + ");\n        const ivec2 pads = ivec2(" + c + ", " + p + ");\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < " + u + ";\n              wR += " + i + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + l + ";\n                wC += " + s + ") {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value >= currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = wR * " + l + " + wC;\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";else {
      var f = t + "(" + t + "(" + t + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";"avg" === t && (f = "avgValue / count");var m = 4 * Math.floor(r / 4),
          g = r % 4,
          v = "\n      if (" + d + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    ";this.userCode = "\n      const ivec2 strides = ivec2(" + o + ", " + a + ");\n      const ivec2 pads = ivec2(" + c + ", " + p + ");\n      const float initializationValue = " + h + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= " + e.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + h + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < " + u + ";\n            wR += " + i + ") {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= " + e.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + m + "; wC += 4) {\n            int xC = xCCorner + wC * " + s + ";\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              getValue(batch, xR, xC + 3 * " + s + ", d)\n            );\n\n            " + v + "\n          }\n\n          int xC = xCCorner + " + m + ";\n          if (" + (1 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            " + v + "\n          } else if (" + (2 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              initializationValue,\n              initializationValue\n            );\n\n            " + v + "\n          } else if (" + (3 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              initializationValue\n            );\n\n            " + v + "\n          }\n        }\n        setOutput(" + f + ");\n      }\n    ";
    }
  };
}(),
    ReduceProgram = function () {
  return function (e, t) {
    this.variableNames = ["x"];var n = e.windowSize,
        r = e.batchSize,
        o = e.inSize,
        a = Math.ceil(o / n);this.outputShape = [r, a];var i = "0.0",
        s = "";"prod" === t ? i = "1.0" : "min" === t ? (i = "1.0 / 1e-20", s = "min") : "max" === t && (i = "-1.0 / 1e-20", s = "max");var u = t + "(" + t + "(" + t + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";"sum" === t ? u = "sumValue" : "prod" === t ? u = "prodValue" : "all" === t ? u = "allValue" : "any" === t && (u = "anyValue");var l = 4 * Math.floor(n / 4),
        c = n % 4,
        p = "\n      if (" + ("sum" === t) + ") {\n        sumValue += dot(values, ones);\n      } else if (" + ("prod" === t) + ") {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = " + s + "(values, minMaxValue);\n      }\n    ",
        d = "vec4";"all" === t ? (i = "1.0", p = "\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ", d = "bvec4") : "any" === t && (i = "0.0", p = "\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ", d = "bvec4");var h = "";o % n > 0 && (h = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return initializationValue;\n        }\n      "), this.userCode = "\n      const float initializationValue = " + i + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        " + h + "\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + n + ";\n\n        vec4 minMaxValue = vec4(" + i + ");\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < " + l + "; i += 4) {\n          int inIdx = inOffset + i;\n          " + d + " values = " + d + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          " + p + "\n        }\n\n        int inIdx = inOffset + " + l + ";\n        if (" + (1 === c) + ") {\n          " + d + " values = " + d + "(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          " + p + "\n        } else if (" + (2 === c) + ") {\n          " + d + " values = " + d + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          " + p + "\n        } else if (" + (3 === c) + ") {\n          " + d + " values = " + d + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          " + p + "\n        }\n        setOutput(" + u + ");\n      }\n    ";
  };
}(),
    ReshapePackedProgram = function () {
  return function (e, t) {
    this.variableNames = ["A"], this.usesPackedTextures = !0, this.outputShape = e;for (var n = "", r = 0; r < 4; r++) {
      var o = "thisRC = rc;";r % 2 == 1 && (o += "thisRC.z += 1;"), r > 1 && (o += "thisRC.y += 1;"), n += "\n        " + o + "\n        " + (r > 0 ? "if(thisRC.y < rows && thisRC.z < cols){" : "") + "\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[" + r + "] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        " + (r > 0 ? "}" : "") + "\n      ";
    }this.userCode = "\n      " + getReshapedInputCoords(t) + "\n      " + getFlatIndex(e) + "\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = " + e[1] + ";\n        int cols = " + e[2] + ";\n\n        " + n + "\n\n        setOutput(result);\n      }\n    ";
  };
}();function getFlatIndex(e) {
  return "\n    int getFlatIndex(ivec3 coords) {\n      return round(" + dotify(["coords.x", "coords.y", "coords.z"], computeStrides(e).map(function (e) {
    return e.toString();
  }).concat(["1."])) + ");\n    }\n  ";
}function getReshapedInputCoords(e) {
  return "\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      " + getLogicalCoordinatesFromFlatIndex(["r", "c", "d"], e) + "\n      return ivec3(r, c, d);\n    }\n  ";
}var ResizeBilinearBackpropProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["dy"], this.outputShape = [], this.outputShape = t.shape;var r = t.shape,
        o = r[1],
        a = r[2],
        i = e.shape,
        s = i[1],
        u = i[2],
        l = [n && s > 1 ? o - 1 : o, n && u > 1 ? a - 1 : a],
        c = [n && s > 1 ? s - 1 : s, n && u > 1 ? u - 1 : u],
        p = l[0] / c[0],
        d = l[1] / c[1],
        h = 1 / p,
        f = 1 / d,
        m = 2 * Math.ceil(h) + 2,
        g = 2 * Math.ceil(f) + 2;this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + p + ");\n        const float widthScale = float(" + d + ");\n\n        const float invHeightScale = float(" + h + ");\n        const float invWidthScale = float(" + f + ");\n\n        const int winHeight = int(" + m + ");\n        const int winWidth = int(" + g + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + u + ") {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), " + (o - 1) + ".0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), " + (a - 1) + ".0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
  };
}(),
    ResizeBilinearProgram = function () {
  return function (e, t, n, r) {
    this.variableNames = ["A"], this.outputShape = [];var o = e[0],
        a = e[1],
        i = e[2],
        s = e[3];this.outputShape = [o, t, n, s];var u = [r && t > 1 ? a - 1 : a, r && n > 1 ? i - 1 : i],
        l = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n];this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + u[0] / l[0] + ",\n          " + u[1] / l[1] + ");\n      const vec2 inputShapeRC = vec2(" + a + ".0, " + i + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    ";
  };
}(),
    ResizeNearestNeigborBackpropProgram = function () {
  return function (e, t, n) {
    this.variableNames = ["dy"], this.outputShape = [], this.outputShape = t.shape;var r = t.shape,
        o = r[1],
        a = r[2],
        i = e.shape,
        s = i[1],
        u = i[2],
        l = [n && s > 1 ? o - 1 : o, n && u > 1 ? a - 1 : a],
        c = [n && s > 1 ? s - 1 : s, n && u > 1 ? u - 1 : u],
        p = l[0] / c[0],
        d = l[1] / c[1],
        h = 1 / p,
        f = 1 / d,
        m = 2 * Math.ceil(h) + 2,
        g = 2 * Math.ceil(f) + 2;this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + p + ");\n        const float widthScale = float(" + d + ");\n\n        const float invHeightScale = float(" + h + ");\n        const float invWidthScale = float(" + f + ");\n\n        const int winHeight = int(" + m + ");\n        const int winWidth = int(" + g + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + u + ") {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(" + l[0] + ") *\n                (float(dyR) / float(" + c[0] + "));\n\n            float sourceFracCol =\n                float(" + l[1] + ") *\n                  (float(dyC) / float(" + c[1] + "));\n\n            int sourceNearestRow = int(min(\n                float(int(" + o + ") - 1),\n                " + n + " ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(" + a + ") - 1),\n                " + n + " ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
  };
}(),
    ResizeNearestNeighborProgram = function () {
  return function (e, t, n, r) {
    this.variableNames = ["A"], this.outputShape = [];var o = e[0],
        a = e[1],
        i = e[2],
        s = e[3];this.outputShape = [o, t, n, s];var u = [r && t > 1 ? a - 1 : a, r && n > 1 ? i - 1 : i],
        l = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n],
        c = r ? "0.5" : "0.0";this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + u[0] / l[0] + ",\n          " + u[1] / l[1] + ");\n      const vec2 inputShapeRC = vec2(" + a + ".0, " + i + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + " + c + ")));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    ";
  };
}(),
    ReverseProgram = function () {
  return function (e, t) {
    this.variableNames = ["x"];var n = e.length;if (n > 4) throw new Error("WebGL backend: Reverse of rank-" + n + " tensor is not yet supported");if (this.outputShape = e, 1 !== n) {
      var r = e.map(function (n, r) {
        return function (n) {
          return -1 !== t.indexOf(n) && 1 !== e[n] ? e[n] + " - coords[" + n + "] - 1" : "coords[" + n + "]";
        }(r);
      }).join(","),
          o = getCoordsDataType(n);this.userCode = "\n      void main() {\n        " + o + " coords = getOutputCoords();\n        setOutput(getX(" + r + "));\n      }\n    ";
    } else this.userCode = "\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(" + e[0] + " - coord - 1));\n        }\n      ";
  };
}(),
    ScatterProgram = function () {
  return function (e, t, n, r, o, a, i) {
    void 0 === i && (i = !0), this.variableNames = ["updates", "indices", "defaultValue"], this.outputShape = a;var s = getCoordsDataType(o.length),
        u = getCoordsDataType(a.length),
        l = "";1 === n ? l = "i" : 2 === n && (l = "i, j");var c = "getIndices(" + l + ")",
        p = "";1 === r ? p = "i" : 2 === r && (p = "i, coords[1]");var d = "getUpdates(" + p + ")",
        h = t > 1 ? "strides[j]" : "strides";this.userCode = "\n        " + s + " strides = " + s + "(" + o + ");\n\n        void main() {\n          " + u + " coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < " + e + "; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < " + t + "; j++) {\n              int index = round(" + c + ");\n              flattenedIndex += index * " + h + ";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += " + d + ";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      ";
  };
}(),
    SegmentOpProgram = function () {
  return function (e, t) {
    this.variableNames = ["x", "segmentIds"];var n = e.windowSize,
        r = e.batchSize,
        o = e.inSize,
        a = e.numSegments,
        i = a * Math.ceil(o / n);this.outputShape = [r, i];var s = 4 * Math.floor(n / 4),
        u = n % 4,
        l = "\n        sumValue += dot(values, segFilter);\n    ",
        c = "";o % n > 0 && (c = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return initializationValue;\n        }\n      ");var p = "";o % n > 0 && (p = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return -1.0;\n        }\n      "), this.userCode = "\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        " + c + "\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        " + p + "\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          " + a + ")) * float(" + n + "));\n        int currentSeg = int(mod(float(outIdx), float(" + a + ")));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < " + s + "; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          " + l + "\n        }\n\n        int inIdx = inOffset + " + s + ";\n        if (" + (1 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          " + l + "\n        } else if (" + (2 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          " + l + "\n        } else if (" + (3 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          " + l + "\n        }\n        setOutput(sumValue);\n      }\n    ";
  };
}(),
    SelectProgram = function () {
  return function (e, t, n) {
    var r, o;if (this.variableNames = ["c", "a", "b"], this.outputShape = t, n > 4) throw Error("Where for rank " + n + " is not yet supported");if (1 === n) o = "resRC", r = "resRC";else {
      for (var a = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"], i = [], s = [], u = 0; u < t.length; u++) {
        s.push("" + a[u]), u < e && i.push("" + a[u]);
      }r = i.join(), o = s.join();
    }var l = getCoordsDataType(n);this.userCode = "\n      void main() {\n        " + l + " resRC = getOutputCoords();\n        float cVal = getC(" + r + ");\n        if (cVal >= 1.0) {\n          setOutput(getA(" + o + "));\n        } else {\n          setOutput(getB(" + o + "));\n        }\n      }\n    ";
  };
}(),
    SliceProgram = function () {
  function e(e) {
    this.variableNames = ["source"], this.outputShape = e, this.rank = e.length;var t,
        n = getCoordsDataType(this.rank),
        r = "uniform int start[" + this.rank + "];",
        o = getCoords$1(this.rank);t = "\n        " + n + " sourceLoc;\n        " + n + " coords = getOutputCoords();\n        " + e.map(function (e, t) {
      return "sourceLoc." + coords[t] + " = start[" + t + "] + coords." + coords[t] + ";";
    }).join("\n") + "\n      ", this.userCode = "\n      " + r + "\n      void main() {\n        " + t + "\n        setOutput(getSource(" + o + "));\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function (e) {
    var t = this;if (e.length !== this.rank) throw Error("The rank (" + this.rank + ") of the program must match the length of start (" + e.length + ")");return function (n, r) {
      null == t.startLoc && (t.startLoc = n.getUniformLocationNoThrow(r, "start"), null == t.startLoc) || n.gl.uniform1iv(t.startLoc, e);
    };
  }, e;
}(),
    coords = ["x", "y", "z", "w", "u", "v"];function getCoords$1(e) {
  if (1 === e) return "sourceLoc";if (e <= 6) return coords.slice(0, e).map(function (e) {
    return "sourceLoc." + e;
  }).join(",");throw Error("Slicing for rank " + e + " is not yet supported");
}var StridedSliceProgram = function () {
  return function (e, t, n, r) {
    this.variableNames = ["x"];var o = n.filter(function (e, t) {
      return -1 === r.indexOf(t);
    });this.outputShape = o;var a = n.length,
        i = getCoordsDataType(n.length),
        s = getCoordsDataType(o.length),
        u = "";if (1 === a) u = "coords * strides + begin";else {
      var l = 0;u = n.map(function (e, t) {
        return -1 === r.indexOf(t) ? (l++, 1 === o.length ? "coords * strides[" + t + "] + begin[" + t + "]" : "coords[" + (l - 1) + "] * strides[" + t + "] + begin[" + t + "]") : "begin[" + t + "]";
      }).join(",");
    }this.userCode = "\n      " + i + " begin = " + i + "(" + e + ");\n      " + i + " strides = " + i + "(" + t + ");\n\n      void main() {\n        " + s + " coords = getOutputCoords();\n        setOutput(getX(" + u + "));\n      }\n    ";
  };
}(),
    TextureManager = function () {
  function e(e) {
    this.gpgpu = e, this.numUsedTextures = 0, this.numFreeTextures = 0, this.freeTextures = {}, this.logEnabled = !1, this.usedTextures = {};
  }return e.prototype.acquireTexture = function (e, t, n) {
    var r,
        o = getPhysicalFromLogicalTextureType(t, n),
        a = getKeyFromTextureShape(e, o, n);if (a in this.freeTextures || (this.freeTextures[a] = []), a in this.usedTextures || (this.usedTextures[a] = []), this.freeTextures[a].length > 0) {
      this.numFreeTextures--, this.numUsedTextures++, this.log();var i = this.freeTextures[a].shift();return this.usedTextures[a].push(i), i;
    }return this.numUsedTextures++, this.log(), o === PhysicalTextureType.PACKED_2X2_FLOAT32 ? r = this.gpgpu.createPackedMatrixTexture(e[0], e[1]) : o === PhysicalTextureType.PACKED_2X2_FLOAT16 ? r = this.gpgpu.createFloat16PackedMatrixTexture(e[0], e[1]) : o === PhysicalTextureType.UNPACKED_FLOAT32 ? r = this.gpgpu.createFloat32MatrixTexture(e[0], e[1]) : o === PhysicalTextureType.UNPACKED_FLOAT16 ? r = this.gpgpu.createFloat16MatrixTexture(e[0], e[1]) : o === PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE && (r = this.gpgpu.createUnsignedBytesMatrixTexture(e[0], e[1])), this.usedTextures[a].push(r), r;
  }, e.prototype.releaseTexture = function (e, t, n, r) {
    if (null != this.freeTextures) {
      var o = getKeyFromTextureShape(t, getPhysicalFromLogicalTextureType(n, r), r);o in this.freeTextures || (this.freeTextures[o] = []), this.freeTextures[o].push(e), this.numFreeTextures++, this.numUsedTextures--;var a = this.usedTextures[o],
          i = a.indexOf(e);if (i < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");a.splice(i, 1), this.log();
    }
  }, e.prototype.log = function () {
    if (this.logEnabled) {
      var e = this.numFreeTextures + this.numUsedTextures;console.log("Free/Used", this.numFreeTextures + " / " + this.numUsedTextures, "(" + e + ")");
    }
  }, e.prototype.getNumUsedTextures = function () {
    return this.numUsedTextures;
  }, e.prototype.getNumFreeTextures = function () {
    return this.numFreeTextures;
  }, e.prototype.dispose = function () {
    var e = this;if (null != this.freeTextures) {
      for (var t in this.freeTextures) {
        this.freeTextures[t].forEach(function (t) {
          e.gpgpu.deleteMatrixTexture(t);
        });
      }for (var t in this.usedTextures) {
        this.usedTextures[t].forEach(function (t) {
          e.gpgpu.deleteMatrixTexture(t);
        });
      }this.freeTextures = null, this.usedTextures = null, this.numUsedTextures = 0, this.numFreeTextures = 0;
    }
  }, e;
}();function getPhysicalFromLogicalTextureType(e, t) {
  if (e === TextureUsage.UPLOAD) return t ? PhysicalTextureType.PACKED_2X2_FLOAT32 : PhysicalTextureType.UNPACKED_FLOAT32;if (e === TextureUsage.RENDER || null == e) return t ? ENV.get("WEBGL_RENDER_FLOAT32_ENABLED") ? PhysicalTextureType.PACKED_2X2_FLOAT32 : PhysicalTextureType.PACKED_2X2_FLOAT16 : ENV.get("WEBGL_RENDER_FLOAT32_ENABLED") ? PhysicalTextureType.UNPACKED_FLOAT32 : PhysicalTextureType.UNPACKED_FLOAT16;if (e === TextureUsage.DOWNLOAD || e === TextureUsage.PIXELS) return PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE;throw new Error("Unknown logical texture type " + e);
}function getKeyFromTextureShape(e, t, n) {
  return e[0] + "_" + e[1] + "_" + t + "_" + n;
}var TileProgram = function () {
  return function (e, t) {
    this.variableNames = ["A"];for (var n = new Array(e.length), r = 0; r < n.length; r++) {
      n[r] = e[r] * t[r];
    }this.outputShape = n, this.rank = n.length;var o = getCoordsDataType(this.rank),
        a = getSourceCoords$2(e);this.userCode = "\n      void main() {\n        " + o + " resRC = getOutputCoords();\n        setOutput(getA(" + a + "));\n      }\n    ";
  };
}();function getSourceCoords$2(e) {
  var t = e.length;if (t > 5) throw Error("Tile for rank " + t + " is not yet supported");if (1 === t) return "imod(resRC, " + e[0] + ")";for (var n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u"], r = [], o = 0; o < e.length; o++) {
    r.push("imod(" + n[o] + ", " + e[o] + ")");
  }return r.join();
}var TransposeProgram = function () {
  return function (e, t) {
    this.variableNames = ["A"];for (var n = new Array(e.length), r = 0; r < n.length; r++) {
      n[r] = e[t[r]];
    }this.outputShape = n, this.rank = n.length;var o = getCoordsDataType(this.rank),
        a = getSwitchedCoords(t);this.userCode = "\n    void main() {\n      " + o + " resRC = getOutputCoords();\n      setOutput(getA(" + a + "));\n    }\n    ";
  };
}();function getSwitchedCoords(e) {
  var t = e.length;if (t > 6) throw Error("Transpose for rank " + t + " is not yet supported");for (var n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u", "resRC.v"], r = new Array(t), o = 0; o < e.length; o++) {
    r[e[o]] = n[o];
  }return r.join();
}var ERF_P = .3275911,
    ERF_A1 = .254829592,
    ERF_A2 = -.284496736,
    ERF_A3 = 1.421413741,
    ERF_A4 = -1.453152027,
    ERF_A5 = 1.061405429,
    SELU_SCALEALPHA = 1.7580993408473768,
    SELU_SCALE = 1.0507009873554805,
    UnaryOpProgram = function () {
  function e(e, t) {
    this.variableNames = ["A"], this.outputShape = e, this.userCode = "\n      uniform float NAN;\n      float unaryOperation(float x) {\n        " + t + "\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
  }return e.prototype.getCustomSetupFunc = function () {
    var e = this;return function (t, n) {
      null == e.startLoc && (e.startLoc = t.getUniformLocationNoThrow(n, "NAN"), null == e.startLoc) || t.gl.uniform1f(e.startLoc, NaN);
    };
  }, e;
}(),
    CHECK_NAN_SNIPPET$1 = "if (isNaN(x)) return x;",
    ABS = "return abs(x);",
    RELU = CHECK_NAN_SNIPPET$1 + "\n  return (x < 0.0) ? 0.0 : x;\n",
    ELU = "return (x >= 0.0) ? x : (exp(x) - 1.0);",
    SELU = "\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = " + SELU_SCALEALPHA + ";\n  float scale = " + SELU_SCALE + ";\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n";function STEP(e) {
  return void 0 === e && (e = 0), CHECK_NAN_SNIPPET$1 + "\n    return x > 0.0 ? 1.0 : float(" + e + ");\n  ";
}var NEG = "return -x;",
    CEIL = "return ceil(x);",
    FLOOR = "return floor(x);",
    SIGN = "\n  if (isNaN(x)) { return 0.0; }\n  return sign(x);\n",
    ROUND = "\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n",
    EXP = "return exp(x);",
    EXPM1 = "return exp(x) - 1.0;",
    LOG = "if (x < 0.0) return NAN;\n  return log(x);",
    LOG1P = "return log(1.0 + x);",
    SQRT = "return sqrt(x);",
    RSQRT = "return inversesqrt(x);",
    SIGMOID = "return 1.0 / (1.0 + exp(-1.0 * x));",
    SOFTPLUS = "\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n",
    SIN = CHECK_NAN_SNIPPET$1 + "\n  return sin(x);\n",
    COS = CHECK_NAN_SNIPPET$1 + "\n  return cos(x);\n",
    TAN = "return tan(x);",
    ASIN = "return asin(x);",
    ACOS = "return acos(x);",
    ATAN = CHECK_NAN_SNIPPET$1 + "\n  return atan(x);\n",
    SINH = "\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n",
    COSH = "\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n",
    TANH = "\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n",
    ASINH = "return log(x + sqrt(x * x + 1.0));",
    ACOSH = CHECK_NAN_SNIPPET$1 + "\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));",
    ATANH = CHECK_NAN_SNIPPET$1 + "\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;",
    ERF = '\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = ' + ERF_P + ";\n  float a1 = " + ERF_A1 + ";\n  float a2 = " + ERF_A2 + ";\n  float a3 = " + ERF_A3 + ";\n  float a4 = " + ERF_A4 + ";\n  float a5 = " + ERF_A5 + ";\n\n  float t = 1.0 / (1.0 + p * x);\n  return 1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x);\n",
    SQUARE = "return x * x;",
    RECIPROCAL = "return 1.0 / x;",
    LOGICAL_NOT = "return float(!(x >= 1.0));",
    TO_INT = "return float(int(x));",
    CLONE = "return x;",
    UnpackProgram = function () {
  return function (e) {
    this.variableNames = ["A"], this.usesPackedTextures = !0, this.outputShape = e;var t = e.length,
        n = getChannels("rc", t),
        r = getCoordsDataType(t),
        o = getSourceCoords$1(t, n),
        a = n.slice(-2),
        i = t <= 1 ? "rc" : "vec2(" + a.join(",") + ")";this.userCode = "\n      void main() {\n        " + r + " rc = getOutputCoords();\n        vec4 packedInput = getA(" + o + ");\n\n        setOutput(getChannel(packedInput, " + i + "));\n      }\n    ";
  };
}();function concat1d_(e) {
  return concat(e, 0);
}function concat2d_(e, t) {
  return concat(e, t);
}function concat3d_(e, t) {
  return concat(e, t);
}function concat4d_(e, t) {
  return concat(e, t);
}function concat_(e, t) {
  void 0 === t && (t = 0), assert(e.length >= 1, "Pass at least one tensor to concat");var n = convertToTensorArray(e, "tensors", "concat");t = parseAxisParam(t, n[0].shape)[0];var r = computeOutShape(n.map(function (e) {
    return e.shape;
  }), t);if (0 === sizeFromShape(r)) return tensor([], r);if (1 === (n = n.filter(function (e) {
    return e.size > 0;
  })).length) return n[0];var o = n.map(function (e) {
    return e.shape;
  });assertParamsConsistent(o, t);var a = n;return ENV.engine.runKernel(function (e) {
    return e.concat(n, t);
  }, a, function (e) {
    var n = o.map(function (e) {
      return e[t];
    });return split$1(e, n, t).map(function (e) {
      return function () {
        return e;
      };
    });
  });
}function split_(e, t, n) {
  void 0 === n && (n = 0);var r,
      o = convertToTensor(e, "x", "split");n = parseAxisParam(n, o.shape)[0], "number" == typeof t ? (assert(o.shape[n] % t == 0, "Number of splits must evenly divide the axis."), r = new Array(t).fill(o.shape[n] / t)) : (assert(o.shape[n] === t.reduce(function (e, t) {
    return e + t;
  }), "The sum of sizes must match the size of the axis dimension."), r = t);return ENV.engine.runKernel(function (e) {
    return e.split(o, r, n);
  }, { $x: o }, function (e) {
    return { $x: function $x() {
        return concat(e, n);
      } };
  });
}var concat = op({ concat_: concat_ }),
    concat1d = op({ concat1d_: concat1d_ }),
    concat2d = op({ concat2d_: concat2d_ }),
    concat3d = op({ concat3d_: concat3d_ }),
    concat4d = op({ concat4d_: concat4d_ }),
    split$1 = op({ split_: split_ }),
    commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};function createCommonjsModule(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}var alea = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.c = e.c, t.s0 = e.s0, t.s1 = e.s1, t.s2 = e.s2, t;
    }function o(e, t) {
      var n = new function (e) {
        var t,
            n = this,
            r = (t = 4022871197, function (e) {
          e = e.toString();for (var n = 0; n < e.length; n++) {
            var r = .02519603282416938 * (t += e.charCodeAt(n));r -= t = r >>> 0, t = (r *= t) >>> 0, t += 4294967296 * (r -= t);
          }return 2.3283064365386963e-10 * (t >>> 0);
        });n.next = function () {
          var e = 2091639 * n.s0 + 2.3283064365386963e-10 * n.c;return n.s0 = n.s1, n.s1 = n.s2, n.s2 = e - (n.c = 0 | e);
        }, n.c = 1, n.s0 = r(" "), n.s1 = r(" "), n.s2 = r(" "), n.s0 -= r(e), n.s0 < 0 && (n.s0 += 1), n.s1 -= r(e), n.s1 < 0 && (n.s1 += 1), n.s2 -= r(e), n.s2 < 0 && (n.s2 += 1), r = null;
      }(e),
          o = t && t.state,
          a = n.next;return a.int32 = function () {
        return 4294967296 * n.next() | 0;
      }, a.double = function () {
        return a() + 1.1102230246251565e-16 * (2097152 * a() | 0);
      }, a.quick = a, o && ("object" == typeof o && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.alea = o;
  }(0, e, !1);
}),
    xor128 = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.x = e.x, t.y = e.y, t.z = e.z, t.w = e.w, t;
    }function o(e, t) {
      var n = new function (e) {
        var t = this,
            n = "";t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.next = function () {
          var e = t.x ^ t.x << 11;return t.x = t.y, t.y = t.z, t.z = t.w, t.w ^= t.w >>> 19 ^ e ^ e >>> 8;
        }, e === (0 | e) ? t.x = e : n += e;for (var r = 0; r < n.length + 64; r++) {
          t.x ^= 0 | n.charCodeAt(r), t.next();
        }
      }(e),
          o = t && t.state,
          a = function a() {
        return (n.next() >>> 0) / 4294967296;
      };return a.double = function () {
        do {
          var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e);return e;
      }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.xor128 = o;
  }(0, e, !1);
}),
    xorwow = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.x = e.x, t.y = e.y, t.z = e.z, t.w = e.w, t.v = e.v, t.d = e.d, t;
    }function o(e, t) {
      var n = new function (e) {
        var t = this,
            n = "";t.next = function () {
          var e = t.x ^ t.x >>> 2;return t.x = t.y, t.y = t.z, t.z = t.w, t.w = t.v, (t.d = t.d + 362437 | 0) + (t.v = t.v ^ t.v << 4 ^ e ^ e << 1) | 0;
        }, t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.v = 0, e === (0 | e) ? t.x = e : n += e;for (var r = 0; r < n.length + 64; r++) {
          t.x ^= 0 | n.charCodeAt(r), r == n.length && (t.d = t.x << 10 ^ t.x >>> 4), t.next();
        }
      }(e),
          o = t && t.state,
          a = function a() {
        return (n.next() >>> 0) / 4294967296;
      };return a.double = function () {
        do {
          var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e);return e;
      }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.xorwow = o;
  }(0, e, !1);
}),
    xorshift7 = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.x = e.x.slice(), t.i = e.i, t;
    }function o(e, t) {
      null == e && (e = +new Date());var n = new function (e) {
        var t = this;t.next = function () {
          var e,
              n,
              r = t.x,
              o = t.i;return e = r[o], n = (e ^= e >>> 7) ^ e << 24, n ^= (e = r[o + 1 & 7]) ^ e >>> 10, n ^= (e = r[o + 3 & 7]) ^ e >>> 3, n ^= (e = r[o + 4 & 7]) ^ e << 7, e = r[o + 7 & 7], n ^= (e ^= e << 13) ^ e << 9, r[o] = n, t.i = o + 1 & 7, n;
        }, function (e, t) {
          var n,
              r = [];if (t === (0 | t)) r[0] = t;else for (t = "" + t, n = 0; n < t.length; ++n) {
            r[7 & n] = r[7 & n] << 15 ^ t.charCodeAt(n) + r[n + 1 & 7] << 13;
          }for (; r.length < 8;) {
            r.push(0);
          }for (n = 0; n < 8 && 0 === r[n]; ++n) {}for (8 == n ? r[7] = -1 : r[n], e.x = r, e.i = 0, n = 256; n > 0; --n) {
            e.next();
          }
        }(t, e);
      }(e),
          o = t && t.state,
          a = function a() {
        return (n.next() >>> 0) / 4294967296;
      };return a.double = function () {
        do {
          var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e);return e;
      }, a.int32 = n.next, a.quick = a, o && (o.x && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.xorshift7 = o;
  }(0, e, !1);
}),
    xor4096 = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.i = e.i, t.w = e.w, t.X = e.X.slice(), t;
    }function o(e, t) {
      null == e && (e = +new Date());var n = new function (e) {
        var t = this;t.next = function () {
          var e,
              n,
              r = t.w,
              o = t.X,
              a = t.i;return t.w = r = r + 1640531527 | 0, n = o[a + 34 & 127], e = o[a = a + 1 & 127], n ^= n << 13, e ^= e << 17, n ^= n >>> 15, e ^= e >>> 12, n = o[a] = n ^ e, t.i = a, n + (r ^ r >>> 16) | 0;
        }, function (e, t) {
          var n,
              r,
              o,
              a,
              i,
              s = [],
              u = 128;for (t === (0 | t) ? (r = t, t = null) : (t += "\0", r = 0, u = Math.max(u, t.length)), o = 0, a = -32; a < u; ++a) {
            t && (r ^= t.charCodeAt((a + 32) % t.length)), 0 === a && (i = r), r ^= r << 10, r ^= r >>> 15, r ^= r << 4, r ^= r >>> 13, a >= 0 && (i = i + 1640531527 | 0, o = 0 == (n = s[127 & a] ^= r + i) ? o + 1 : 0);
          }for (o >= 128 && (s[127 & (t && t.length || 0)] = -1), o = 127, a = 512; a > 0; --a) {
            r = s[o + 34 & 127], n = s[o = o + 1 & 127], r ^= r << 13, n ^= n << 17, r ^= r >>> 15, n ^= n >>> 12, s[o] = r ^ n;
          }e.w = i, e.X = s, e.i = o;
        }(t, e);
      }(e),
          o = t && t.state,
          a = function a() {
        return (n.next() >>> 0) / 4294967296;
      };return a.double = function () {
        do {
          var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e);return e;
      }, a.int32 = n.next, a.quick = a, o && (o.X && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.xor4096 = o;
  }(0, e, !1);
}),
    tychei = createCommonjsModule(function (e) {
  !function (e, t, n) {
    function r(e, t) {
      return t.a = e.a, t.b = e.b, t.c = e.c, t.d = e.d, t;
    }function o(e, t) {
      var n = new function (e) {
        var t = this,
            n = "";t.next = function () {
          var e = t.b,
              n = t.c,
              r = t.d,
              o = t.a;return e = e << 25 ^ e >>> 7 ^ n, n = n - r | 0, r = r << 24 ^ r >>> 8 ^ o, o = o - e | 0, t.b = e = e << 20 ^ e >>> 12 ^ n, t.c = n = n - r | 0, t.d = r << 16 ^ n >>> 16 ^ o, t.a = o - e | 0;
        }, t.a = 0, t.b = 0, t.c = -1640531527, t.d = 1367130551, e === Math.floor(e) ? (t.a = e / 4294967296 | 0, t.b = 0 | e) : n += e;for (var r = 0; r < n.length + 20; r++) {
          t.b ^= 0 | n.charCodeAt(r), t.next();
        }
      }(e),
          o = t && t.state,
          a = function a() {
        return (n.next() >>> 0) / 4294967296;
      };return a.double = function () {
        do {
          var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e);return e;
      }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && r(o, n), a.state = function () {
        return r(n, {});
      }), a;
    }t && t.exports ? t.exports = o : n && n.amd ? n(function () {
      return o;
    }) : this.tychei = o;
  }(0, e, !1);
}),
    seedrandom = createCommonjsModule(function (e) {
  !function (t, n) {
    var r,
        o = this,
        a = 256,
        i = 6,
        s = "random",
        u = n.pow(a, i),
        l = n.pow(2, 52),
        c = 2 * l,
        p = a - 1;function d(e, d, g) {
      var v = [],
          y = f(function e(t, n) {
        var r,
            o = [],
            a = typeof t;if (n && "object" == a) for (r in t) {
          try {
            o.push(e(t[r], n - 1));
          } catch (e) {}
        }return o.length ? o : "string" == a ? t : t + "\0";
      }((d = 1 == d ? { entropy: !0 } : d || {}).entropy ? [e, m(t)] : null == e ? function () {
        try {
          var e;return r && (e = r.randomBytes) ? e = e(a) : (e = new Uint8Array(a), (o.crypto || o.msCrypto).getRandomValues(e)), m(e);
        } catch (e) {
          var n = o.navigator,
              i = n && n.plugins;return [+new Date(), o, i, o.screen, m(t)];
        }
      }() : e, 3), v),
          x = new function (e) {
        var t,
            n = e.length,
            r = this,
            o = 0,
            i = r.i = r.j = 0,
            s = r.S = [];n || (e = [n++]);for (; o < a;) {
          s[o] = o++;
        }for (o = 0; o < a; o++) {
          s[o] = s[i = p & i + e[o % n] + (t = s[o])], s[i] = t;
        }(r.g = function (e) {
          for (var t, n = 0, o = r.i, i = r.j, s = r.S; e--;) {
            t = s[o = p & o + 1], n = n * a + s[p & (s[o] = s[i = p & i + t]) + (s[i] = t)];
          }return r.i = o, r.j = i, n;
        })(a);
      }(v),
          T = function T() {
        for (var e = x.g(i), t = u, n = 0; e < l;) {
          e = (e + n) * a, t *= a, n = x.g(1);
        }for (; e >= c;) {
          e /= 2, t /= 2, n >>>= 1;
        }return (e + n) / t;
      };return T.int32 = function () {
        return 0 | x.g(4);
      }, T.quick = function () {
        return x.g(4) / 4294967296;
      }, T.double = T, f(m(x.S), t), (d.pass || g || function (e, t, r, o) {
        return o && (o.S && h(o, x), e.state = function () {
          return h(x, {});
        }), r ? (n[s] = e, t) : e;
      })(T, y, "global" in d ? d.global : this == n, d.state);
    }function h(e, t) {
      return t.i = e.i, t.j = e.j, t.S = e.S.slice(), t;
    }function f(e, t) {
      for (var n, r = e + "", o = 0; o < r.length;) {
        t[p & o] = p & (n ^= 19 * t[p & o]) + r.charCodeAt(o++);
      }return m(t);
    }function m(e) {
      return String.fromCharCode.apply(0, e);
    }if (n["seed" + s] = d, f(n.random(), t), e.exports) {
      e.exports = d;try {
        r = __webpack_require__("VI/i");
      } catch (e) {}
    } else 0;
  }([], Math);
});seedrandom.alea = alea, seedrandom.xor128 = xor128, seedrandom.xorwow = xorwow, seedrandom.xorshift7 = xorshift7, seedrandom.xor4096 = xor4096, seedrandom.tychei = tychei;var seedrandom$1 = seedrandom,
    seedrandom_1 = seedrandom$1.alea,
    MPRandGauss = function () {
  function e(e, t, n, r, o) {
    this.mean = e, this.stdDev = t, this.dtype = n, this.nextVal = NaN, this.truncated = r, this.truncated && (this.upper = this.mean + 2 * this.stdDev, this.lower = this.mean - 2 * this.stdDev);var a = o || Math.random();this.random = seedrandom_1(a.toString());
  }return e.prototype.nextValue = function () {
    if (!isNaN(this.nextVal)) {
      var e = this.nextVal;return this.nextVal = NaN, e;
    }for (var t, n, r = !1; !r;) {
      var o = void 0,
          a = void 0,
          i = void 0;do {
        i = (o = 2 * this.random() - 1) * o + (a = 2 * this.random() - 1) * a;
      } while (i >= 1 || 0 === i);var s = Math.sqrt(-2 * Math.log(i) / i);t = this.mean + this.stdDev * o * s, n = this.mean + this.stdDev * a * s, this.truncated && !this.isValidTruncated(t) || (r = !0);
    }return this.truncated && !this.isValidTruncated(n) || (this.nextVal = this.convertValue(n)), this.convertValue(t);
  }, e.prototype.convertValue = function (e) {
    return null == this.dtype || "float32" === this.dtype ? e : Math.round(e);
  }, e.prototype.isValidTruncated = function (e) {
    return e <= this.upper && e >= this.lower;
  }, e;
}();function clone_(e) {
  var t = convertToTensor(e, "x", "clone", null);return ENV.engine.runKernel(function (e) {
    return Tensor.make(t.shape, { dataId: t.dataId }, t.dtype);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.toFloat();
      } };
  });
}function eye_(e, t, n, r) {
  void 0 === r && (r = "float32"), null == t && (t = e);for (var o = buffer([e, t], r), a = e <= t ? e : t, i = 0; i < a; ++i) {
    o.set(1, i, i);
  }var s = o.toTensor().as2D(e, t);if (null == n) return s;if (1 === n.length) return tile(expandDims(s, 0), [n[0], 1, 1]);if (2 === n.length) return tile(expandDims(expandDims(s, 0), 0), [n[0], n[1], 1, 1]);if (3 === n.length) return tile(expandDims(expandDims(expandDims(s, 0), 0), 0), [n[0], n[1], n[2], 1, 1]);throw new Error("eye() currently supports only 1D and 2D batchShapes, but received " + n.length + "D.");
}function randomNormal_(e, t, n, r, o) {
  if (void 0 === t && (t = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);for (var a = new MPRandGauss(t, n, r, !1, o), i = buffer(e, r), s = 0; s < i.values.length; s++) {
    i.values[s] = a.nextValue();
  }return i.toTensor();
}function truncatedNormal_(e, t, n, r, o) {
  if (void 0 === t && (t = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);for (var a = new MPRandGauss(t, n, r, !0, o), i = buffer(e, r), s = 0; s < i.values.length; s++) {
    i.values[s] = a.nextValue();
  }return i.toTensor();
}function randomUniform_(e, t, n, r) {
  void 0 === t && (t = 0), void 0 === n && (n = 1), void 0 === r && (r = "float32");for (var o = buffer(e, r), a = 0; a < o.values.length; a++) {
    o.values[a] = randUniform(t, n);
  }return o.toTensor();
}function rand_(e, t, n) {
  var r = sizeFromShape(e),
      o = null;if (null == n || "float32" === n) o = new Float32Array(r);else if ("int32" === n) o = new Int32Array(r);else {
    if ("bool" !== n) throw new Error("Unknown data type " + n);o = new Uint8Array(r);
  }for (var a = 0; a < r; a++) {
    o[a] = t();
  }return Tensor.make(e, { values: o }, n);
}function multinomial_(e, t, n, r) {
  void 0 === r && (r = !1);var o = convertToTensor(e, "logits", "multinomial"),
      a = o.size,
      i = o.rank;if (a < 2) throw new Error("Error in multinomial: you need at least 2 outcomes, but got " + a + ".");if (i > 2) throw new Error("Rank of probabilities must be 1 or 2, but is " + i);n = n || Math.random();var s = 1 === i ? o.as2D(1, -1) : o,
      u = ENV.engine.runKernel(function (e) {
    return e.multinomial(s, r, t, n);
  }, { logits2D: s });return 1 === i ? u.as1D() : u;
}function oneHot_(e, t, n, r) {
  if (void 0 === n && (n = 1), void 0 === r && (r = 0), t < 2) throw new Error("Error in oneHot: depth must be >=2, but it is " + t);var o = convertToTensor(e, "indices", "oneHot", "int32"),
      a = o.shape.concat([t]);o = o.flatten();return ENV.engine.runKernel(function (e) {
    return e.oneHot(o, t, n, r);
  }, { $indices: o }, function (e) {
    return { $indices: function $indices() {
        return zeros(o.shape, "float32");
      } };
  }).reshape(a);
}function fromPixels_(e, t) {
  if (void 0 === t && (t = 3), t > 4) throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");return ENV.engine.fromPixels(e, t);
}function toPixels(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, r, o, a, i, s, u, l, c, p, d, h, f, m, g, v, y, x, T, w;return __generator(this, function (E) {
      switch (E.label) {case 0:
          if (n = convertToTensor(e, "img", "toPixels"), e instanceof Tensor || (n = n.toInt()), 2 !== n.rank && 3 !== n.rank) throw new Error("toPixels only supports rank 2 or 3 tensors, got rank " + n.rank + ".");if (r = n.shape.slice(0, 2), o = r[0], a = r[1], (i = 2 === n.rank ? 1 : n.shape[2]) > 4 || 2 === i) throw new Error("toPixels only supports depth of size 1, 3 or 4 but got " + i);return s = n.min(), u = n.max(), [4, s.data()];case 1:
          return l = E.sent()[0], [4, u.data()];case 2:
          if (c = E.sent()[0], s.dispose(), u.dispose(), "float32" === n.dtype) {
            if (l < 0 || c > 1) throw new Error("Tensor values for a float32 Tensor must be in the range [0 - 1] but got range [" + l + " - " + c + "].");
          } else {
            if ("int32" !== n.dtype) throw new Error("Unsupported type for toPixels: " + n.dtype + ". Please use float32 or int32 tensors.");if (l < 0 || c > 255) throw new Error("Tensor values for a int32 Tensor must be in the range [0 - 255] but got range [" + l + " - " + c + "].");
          }return [4, n.data()];case 3:
          for (p = E.sent(), d = "float32" === n.dtype ? 255 : 1, h = new Uint8ClampedArray(a * o * 4), f = 0; f < o * a; ++f) {
            m = void 0, g = void 0, v = void 0, y = void 0, 1 === i ? (m = p[f] * d, g = p[f] * d, v = p[f] * d, y = 255) : 3 === i ? (m = p[3 * f] * d, g = p[3 * f + 1] * d, v = p[3 * f + 2] * d, y = 255) : 4 === i && (m = p[4 * f] * d, g = p[4 * f + 1] * d, v = p[4 * f + 2] * d, y = p[4 * f + 3] * d), h[(x = 4 * f) + 0] = Math.round(m), h[x + 1] = Math.round(g), h[x + 2] = Math.round(v), h[x + 3] = Math.round(y);
          }return null != t && (t.width = a, t.height = o, T = t.getContext("2d"), w = new ImageData(h, a, o), T.putImageData(w, 0, 0)), n !== e && n.dispose(), [2, h];}
    });
  });
}function reshape_(e, t) {
  var n = convertToTensor(e, "x", "reshape", null);t = inferFromImplicitShape(t, n.size), assert(n.size === sizeFromShape(t), "new shape and old shape must have the same number of elements.");return ENV.engine.runKernel(function (e) {
    return e.reshape(n, t);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return e.reshape(n.shape);
      } };
  });
}function squeeze_(e, t) {
  var n = convertToTensor(e, "x", "squeeze");return reshape(n, squeezeShape(n.shape, t).newShape);
}function cast_(e, t) {
  var n = convertToTensor(e, "x", "cast");return ENV.engine.runKernel(function (e) {
    return e.cast(n, t);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return e.clone();
      } };
  });
}function tile_(e, t) {
  var n = convertToTensor(e, "x", "tile");assert(n.rank === t.length, "Error in transpose: rank of input " + n.rank + " must match length of reps " + t + ".");return ENV.engine.runKernel(function (e) {
    return e.tile(n, t);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        var r = zerosLike(n);if (1 === n.rank) for (var o = 0; o < t[0]; ++o) {
          r = r.add(e.slice([o * n.shape[0]], [n.shape[0]]));
        } else if (2 === n.rank) for (o = 0; o < t[0]; ++o) {
          for (var a = 0; a < t[1]; ++a) {
            r = r.add(e.slice([o * n.shape[0], a * n.shape[1]], [n.shape[0], n.shape[1]]));
          }
        } else if (3 === n.rank) for (o = 0; o < t[0]; ++o) {
          for (a = 0; a < t[1]; ++a) {
            for (var i = 0; i < t[2]; ++i) {
              r = r.add(e.slice([o * n.shape[0], a * n.shape[1], i * n.shape[2]], [n.shape[0], n.shape[1], n.shape[2]]));
            }
          }
        } else {
          if (4 !== n.rank) throw new Error("Gradient for tile operation is not implemented for rank-" + n.rank + " tensors yet.");for (o = 0; o < t[0]; ++o) {
            for (a = 0; a < t[1]; ++a) {
              for (i = 0; i < t[2]; ++i) {
                for (var s = 0; s < t[3]; ++s) {
                  r = r.add(e.slice([o * n.shape[0], a * n.shape[1], i * n.shape[2], s * n.shape[3]], [n.shape[0], n.shape[1], n.shape[2], n.shape[3]]));
                }
              }
            }
          }
        }return r;
      } };
  });
}function pad1d_(e, t, n) {
  return void 0 === n && (n = 0), assert(2 === t.length, "Invalid number of paddings. Must be length of 2."), pad(e, [t], n);
}function pad2d_(e, t, n) {
  return void 0 === n && (n = 0), assert(2 === t.length && 2 === t[0].length && 2 === t[1].length, "Invalid number of paddings. Must be length of 2 each."), pad(e, t, n);
}function pad3d_(e, t, n) {
  return void 0 === n && (n = 0), assert(3 === t.length && 2 === t[0].length && 2 === t[1].length && 2 === t[2].length, "Invalid number of paddings. Must be length of 2 each."), pad(e, t, n);
}function pad4d_(e, t, n) {
  return void 0 === n && (n = 0), assert(4 === t.length && 2 === t[0].length && 2 === t[1].length && 2 === t[2].length && 2 === t[3].length, "Invalid number of paddings. Must be length of 2 each."), pad(e, t, n);
}function pad_(e, t, n) {
  void 0 === n && (n = 0);var r = convertToTensor(e, "x", "pad");if (0 === r.rank) throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");var o = t.map(function (e) {
    return e[0];
  });return ENV.engine.runKernel(function (e) {
    return e.pad(r, t, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        return e.slice(o, r.shape);
      } };
  });
}function stack_(e, t) {
  void 0 === t && (t = 0);var n = convertToTensorArray(e, "tensors", "stack");if (assert(n.length >= 1, "Pass at least one tensor to tf.stack"), 1 === n.length) return n[0].expandDims(t);var r = n[0].rank,
      o = n[0].shape,
      a = n[0].dtype;assert(t <= r, "Axis must be <= rank of the tensor"), n.forEach(function (e) {
    assertShapesMatch(o, e.shape, "All tensors passed to stack must have matching shapes");
  }), n.forEach(function (e) {
    assert(a === e.dtype, "All tensors passed to stack must have matching dtypes");
  });var i = n.map(function (e) {
    return e.expandDims(t);
  });return concat(i, t);
}function batchToSpaceND_(e, t, n) {
  var r = convertToTensor(e, "x", "batchToSpaceND"),
      o = t.reduce(function (e, t) {
    return e * t;
  });assert(r.rank >= 1 + t.length, "input rank is " + r.rank + " but should be > than blockShape.length " + t.length), assert(n.length === t.length, "crops.length is " + n.length + " but should be equal to blockShape.length  " + t.length), assert(r.shape[0] % o == 0, "input tensor batch is " + r.shape[0] + " but is not divisible by the product of the elements of blockShape " + t.join(" * ") + " === " + o);return ENV.engine.runKernel(function (e) {
    return e.batchToSpaceND(r, t, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        return e.spaceToBatchND(t, n);
      } };
  });
}function spaceToBatchND_(e, t, n) {
  var r = convertToTensor(e, "x", "spaceToBatchND");assert(r.rank >= 1 + t.length, "input rank " + r.rank + " should be > than [blockShape] " + t.length), assert(n.length === t.length, "paddings.shape[0] " + n.length + " must be equal to [blockShape] " + t.length), assert(r.shape.reduce(function (e, r, o) {
    return o > 0 && o <= t.length ? e && (r + n[o - 1][0] + n[o - 1][1]) % t[o - 1] == 0 : e;
  }, !0), "input spatial dimensions " + r.shape.slice(1) + " with paddings " + n.toString() + " must be divisible by blockShapes " + t.toString());return ENV.engine.runKernel(function (e) {
    return e.spaceToBatchND(r, t, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        return e.batchToSpaceND(t, n);
      } };
  });
}function unstack_(e, t) {
  void 0 === t && (t = 0), t = t || 0;var n = convertToTensor(e, "x", "unstack");return ENV.engine.runKernel(function (e) {
    return e.unstack(n, t);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return stack(e, t);
      } };
  });
}function cumsum_(e, t, n, r) {
  void 0 === t && (t = 0), void 0 === n && (n = !1), void 0 === r && (r = !1);var o = convertToTensor(e, "x", "cumsum"),
      a = getAxesPermutation([t |= 0], o.rank),
      i = o;null != a && (i = o.transpose(a));var s = getInnerMostAxes(1, o.rank)[0],
      u = ENV.engine.runKernel(function (e) {
    return e.cumsum(i, s, n, r);
  }, { permutedX: i }, function (e) {
    return { permutedX: function permutedX() {
        return e.cumsum(t, n, !r);
      } };
  });return null != a && (u = u.transpose(a)), u;
}function expandDims_(e, t) {
  void 0 === t && (t = 0);var n = convertToTensor(e, "x", "expandDims");assert(t <= n.rank, "Axis must be <= rank of the tensor");var r = n.shape.slice();return t < 0 && (assert(-(n.rank + 1) <= t, "Axis must be in the interval [" + -(n.rank + 1) + ", " + n.rank + "]"), t = n.rank + t + 1), r.splice(t, 0, 1), reshape(n, r);
}function depthToSpace_(e, t, n) {
  void 0 === n && (n = "NHWC");var r = convertToTensor(e, "x", "depthToSpace"),
      o = "NHWC" === n ? r.shape[1] : r.shape[2],
      a = "NHWC" === n ? r.shape[2] : r.shape[3],
      i = "NHWC" === n ? r.shape[3] : r.shape[1];return assert(o * t >= 0, "Negative dimension size caused by overflow when multiplying\n      " + o + " and " + t + "  for depthToSpace with input shape\n      " + r.shape), assert(a * t >= 0, "Negative dimension size caused by overflow when multiplying\n      " + a + " and " + t + " for depthToSpace with input shape\n          " + r.shape), assert(i % (t * t) == 0, "Dimension size must be evenly divisible by " + t * t + " but is " + i + " for depthToSpace with input shape " + r.shape), ENV.engine.runKernel(function (e) {
    return e.depthToSpace(r, t, n);
  }, { $x: r });
}function setdiff1dAsync_(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, r, o, a, i, s, u, l, c, p;return __generator(this, function (d) {
      switch (d.label) {case 0:
          return n = convertToTensor(e, "x", "setdiff1d"), r = convertToTensor(t, "y", "setdiff1d"), assert(n.dtype === r.dtype, "x and y should have the same dtype, but got x (" + n.dtype + ") and y (" + r.dtype + ")."), assert(1 === n.rank, "x should be 1D tensor, but got x (" + n.shape + ")."), assert(1 === r.rank, "y should be 1D tensor, but got y (" + r.shape + ")."), [4, n.data()];case 1:
          return o = d.sent(), [4, r.data()];case 2:
          for (a = d.sent(), i = new Set(a), s = 0, c = 0; c < o.length; c++) {
            i.has(o[c]) || s++;
          }for (u = new TensorBuffer([s], n.dtype), l = new TensorBuffer([s], "int32"), c = 0, p = 0; c < o.length; c++) {
            i.has(o[c]) || (u.values[p] = o[c], l.values[p] = c, p++);
          }return [2, [u.toTensor(), l.toTensor()]];}
    });
  });
}function buffer(e, t, n) {
  return void 0 === t && (t = "float32"), new TensorBuffer(e, t = t || "float32", n);
}function print(e, t) {
  void 0 === t && (t = !1), console.log(e.toString(t));
}var batchToSpaceND = op({ batchToSpaceND_: batchToSpaceND_ }),
    cast = op({ cast_: cast_ }),
    clone = op({ clone_: clone_ }),
    cumsum = op({ cumsum_: cumsum_ }),
    depthToSpace = op({ depthToSpace_: depthToSpace_ }),
    expandDims = op({ expandDims_: expandDims_ }),
    eye = op({ eye_: eye_ }),
    fromPixels = op({ fromPixels_: fromPixels_ }),
    multinomial = op({ multinomial_: multinomial_ }),
    oneHot = op({ oneHot_: oneHot_ }),
    pad = op({ pad_: pad_ }),
    pad1d = op({ pad1d_: pad1d_ }),
    pad2d = op({ pad2d_: pad2d_ }),
    pad3d = op({ pad3d_: pad3d_ }),
    pad4d = op({ pad4d_: pad4d_ }),
    rand = op({ rand_: rand_ }),
    randomNormal = op({ randomNormal_: randomNormal_ }),
    randomUniform = op({ randomUniform_: randomUniform_ }),
    reshape = op({ reshape_: reshape_ }),
    spaceToBatchND = op({ spaceToBatchND_: spaceToBatchND_ }),
    squeeze = op({ squeeze_: squeeze_ }),
    stack = op({ stack_: stack_ }),
    tile = op({ tile_: tile_ }),
    truncatedNormal = op({ truncatedNormal_: truncatedNormal_ }),
    unstack = op({ unstack_: unstack_ }),
    setdiff1dAsync = setdiff1dAsync_;function whereImpl(e, t) {
  for (var n = [], r = 0; r < t.length; r++) {
    t[r] && n.push(r);
  }var o = buffer(e, "int32"),
      a = buffer([n.length, e.length], "int32");for (r = 0; r < n.length; r++) {
    var i = o.indexToLoc(n[r]),
        s = r * e.length;a.values.set(i, s);
  }return a.toTensor();
}var CPU_HANDOFF_SIZE_THRESHOLD = 10,
    MATMUL_SHARED_DIM_THRESHOLD = 1e3,
    MathBackendWebGL = function () {
  function e(e, t) {
    if (void 0 === t && (t = !0), this.gpgpu = e, this.delayedStorage = t, this.pendingRead = new WeakMap(), this.pendingDisposal = new WeakSet(), this.dataRefCount = new WeakMap(), this.lruDataGPU = [], this.numBytesInGPU = 0, this.uploadWaitMs = 0, this.downloadWaitMs = 0, this.binaryCache = {}, this.disposed = !1, ENV.get("WEBGL_VERSION") < 1) throw new Error("WebGL is not supported on this device");if (null == e) {
      var n = getWebGLContext(ENV.get("WEBGL_VERSION"));this.gpgpu = new GPGPUContext(n), this.canvas = n.canvas, this.gpgpuCreatedLocally = !0;
    } else this.gpgpuCreatedLocally = !1, this.canvas = e.gl.canvas;this.textureManager = new TextureManager(this.gpgpu);
  }return e.prototype.register = function (e, t, n) {
    if (this.texData.has(e)) throw new Error("Data buffer is already registered");this.texData.set(e, { shape: t, dtype: n });
  }, e.prototype.setDataMover = function (e) {
    this.texData = new DataStorage(e);
  }, e.prototype.fromPixels = function (e, t) {
    if (null == e) throw new Error("pixels passed to tf.fromPixels() can not be null");var n = [e.height, e.width],
        r = [e.height, e.width, t];if (!(e instanceof HTMLVideoElement || e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof ImageData)) throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was " + e.constructor.name);if (e instanceof HTMLVideoElement) {
      if (null == this.fromPixels2DContext) {
        if (!ENV.get("IS_BROWSER")) throw new Error("Can't read pixels from HTMLImageElement outside the browser.");if ("complete" !== document.readyState) throw new Error("The DOM is not ready yet. Please call tf.fromPixels() once the DOM is ready. One way to do that is to add an event listener for `DOMContentLoaded` on the document object");this.fromPixels2DContext = document.createElement("canvas").getContext("2d");
      }this.fromPixels2DContext.canvas.width = e.width, this.fromPixels2DContext.canvas.height = e.height, this.fromPixels2DContext.drawImage(e, 0, 0, e.width, e.height), e = this.fromPixels2DContext.canvas;
    }var o = this.makeTensorHandle(n, "int32");this.texData.get(o.dataId).usage = TextureUsage.PIXELS, this.gpgpu.uploadPixelDataToTexture(this.getTexture(o.dataId), e);var a = new FromPixelsProgram(r),
        i = this.compileAndRun(a, [o]);return this.disposeData(o.dataId), i;
  }, e.prototype.makeTensorHandle = function (e, t) {
    var n = {};return this.register(n, e, t), { dataId: n, shape: e, dtype: t };
  }, e.prototype.write = function (e, t) {
    if (null == t) throw new Error("MathBackendWebGL.write(): values can not be null");if (ENV.get("DEBUG")) for (var n = 0; n < t.length; n++) {
      var r = t[n];if (!canBeRepresented(r)) throw Error("The value " + r + " cannot be represented on this device.");
    }var o = this.texData.get(e),
        a = o.texture,
        i = o.texShape,
        s = o.usage,
        u = o.dtype,
        l = o.isPacked;if ("complex64" === u) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");null != a && (this.releaseTexture(e, a, i, s, l), o.texture = null, o.texShape = null), o.usage = TextureUsage.UPLOAD, o.values = t, this.delayedStorage || this.uploadToGPU(e);
  }, e.prototype.readSync = function (e) {
    var t = this.texData.get(e),
        n = t.values,
        r = t.dtype,
        o = t.complexTensors,
        a = t.slice,
        i = t.shape;if (null != a) {
      var s = new UnaryOpProgram(i, CLONE),
          u = this.compileAndRun(s, [{ dataId: e, shape: i, dtype: r }]);return this.readSync(u.dataId);
    }if (null != n) return this.convertAndCacheOnCPU(e);if ("string" === r) return n;var l,
        c,
        p = null != this.activeTimers;(p && (l = performance.now()), "complex64" === r) ? c = mergeRealAndImagArrays(o.real.dataSync(), o.imag.dataSync()) : c = this.getValuesFromTexture(e);return p && (this.downloadWaitMs += performance.now() - l), this.convertAndCacheOnCPU(e, c);
  }, e.prototype.read = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o, a, i, s, u, l, c, p, d, h, f, m, g, v, y, x, T, w, E;return __generator(this, function (S) {
        switch (S.label) {case 0:
            if (this.pendingRead.has(e)) return r = this.pendingRead.get(e), [2, new Promise(function (e) {
              return r.push(e);
            })];if (o = this.texData.get(e), a = o.texture, i = o.values, s = o.texShape, u = o.isPacked, l = o.shape, c = o.slice, p = o.dtype, null != c) return d = new UnaryOpProgram(l, CLONE), h = this.compileAndRun(d, [{ dataId: e, shape: l, dtype: p }]), [2, this.read(h.dataId)];if (null != i) return [2, this.convertAndCacheOnCPU(e)];if (this.pendingRead.set(e, []), !ENV.get("WEBGL_DOWNLOAD_FLOAT_ENABLED") && 2 === ENV.get("WEBGL_VERSION")) throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");return f = s[1], m = s[0], u && (t = getPackedMatrixTextureShapeWidthHeight(s[0], s[1]), f = t[0], m = t[1]), g = this.gpgpu.maybeCreateBufferFromTexture(a, m, f), [4, this.gpgpu.createAndWaitForFence()];case 1:
            return S.sent(), g instanceof WebGLTexture ? v = this.getValuesFromTexture(e) : u ? (y = getBatchDim(l), x = 1, T = 1, l.length && (n = getRowsCols(l), x = n[0], T = n[1]), v = this.gpgpu.downloadPackedMatrixFromBuffer(g, y, x, T, s[0], s[1])) : v = this.gpgpu.downloadFloat32MatrixFromBuffer(g, s[0], s[1]), w = this.convertAndCacheOnCPU(e, v), E = this.pendingRead.get(e), this.pendingRead.delete(e), E.forEach(function (e) {
              return e(w);
            }), this.pendingDisposal.has(e) && (this.pendingDisposal.delete(e), this.disposeData(e)), [2, w];}
      });
    });
  }, e.prototype.getValuesFromTexture = function (e) {
    var t,
        n = this.texData.get(e),
        r = n.shape,
        o = n.dtype,
        a = n.texture,
        i = n.texShape;if (ENV.get("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
      if (this.texData.get(e).isPacked) {
        var s = getBatchDim(r),
            u = 1,
            l = 1;return r.length && (u = (t = getRowsCols(r))[0], l = t[1]), this.gpgpu.downloadMatrixFromPackedTexture(a, s, u, l, i[0], i[1]);
      }return this.gpgpu.downloadFloat32MatrixFromOutputTexture(a, i[0], i[1]);
    }var c = this.makeTensorHandle(r, "float32");c.size = sizeFromShape(r), this.texData.get(c.dataId).usage = TextureUsage.DOWNLOAD;var p = new EncodeFloatProgram(r);this.compileAndRun(p, [{ shape: r, dtype: o, dataId: e }], c, null, !1);var d = this.texData.get(c.dataId),
        h = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(d.texture, d.texShape[0], d.texShape[1]);return this.disposeData(c.dataId), h;
  }, e.prototype.time = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o, a, i, s;return __generator(this, function (u) {
        switch (u.label) {case 0:
            return t = this.activeTimers, n = [], r = !1, null == this.programTimersStack ? (this.programTimersStack = n, r = !0) : this.activeTimers.push(n), this.activeTimers = n, e(), o = flatten(this.activeTimers.map(function (e) {
              return e.query;
            })).filter(function (e) {
              return null != e;
            }), a = flatten(this.activeTimers.map(function (e) {
              return e.name;
            })).filter(function (e) {
              return null != e;
            }), this.activeTimers = t, r && (this.programTimersStack = null), [4, Promise.all(o)];case 1:
            return i = u.sent(), s = { uploadWaitMs: this.uploadWaitMs, downloadWaitMs: this.downloadWaitMs, kernelMs: sum(i), getExtraProfileInfo: function getExtraProfileInfo() {
                return i.map(function (e, t) {
                  return { name: a[t], ms: e };
                }).map(function (e) {
                  return e.name + ": " + e.ms;
                }).join(", ");
              }, wallMs: null }, this.uploadWaitMs = 0, this.downloadWaitMs = 0, [2, s];}
      });
    });
  }, e.prototype.memory = function () {
    return { unreliable: !1, numBytesInGPU: this.numBytesInGPU };
  }, e.prototype.startTimer = function () {
    return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? this.gpgpu.beginQuery() : { startMs: performance.now(), endMs: null };
  }, e.prototype.endTimer = function (e) {
    return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (this.gpgpu.endQuery(), e) : (e.endMs = performance.now(), e);
  }, e.prototype.getQueryTime = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (n) {
        return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? [2, this.gpgpu.waitForQueryAndGetTime(e)] : [2, (t = e).endMs - t.startMs];
      });
    });
  }, e.prototype.disposeData = function (e) {
    if (!this.pendingDisposal.has(e)) if (this.pendingRead.has(e)) this.pendingDisposal.add(e);else if (this.texData.has(e)) {
      var t = this.texData.get(e),
          n = t.texture,
          r = t.texShape,
          o = t.usage,
          a = t.complexTensors,
          i = t.isPacked,
          s = t.slice;if (null != n) {
        var u = s && s.origDataId || e,
            l = this.dataRefCount.get(u);l > 1 ? this.dataRefCount.set(u, l - 1) : (this.dataRefCount.delete(u), this.releaseTexture(e, n, r, o, i), this.texData.delete(e));
      }null != a && (a.real.dispose(), a.imag.dispose());
    }
  }, e.prototype.getTexture = function (e) {
    return this.uploadToGPU(e), this.texData.get(e).texture;
  }, e.prototype.getCPUBackend = function () {
    return ENV.get("WEBGL_CPU_FORWARD") ? (null == this.cpuBackend && (this.cpuBackend = ENV.findBackend("cpu")), this.cpuBackend) : null;
  }, e.prototype.shouldExecuteOnCPU = function (e, t) {
    var n = this;return void 0 === t && (t = CPU_HANDOFF_SIZE_THRESHOLD), null != this.getCPUBackend() && e.every(function (e) {
      return null == n.texData.get(e.dataId).texture && e.size < t;
    });
  }, e.prototype.getGPGPUContext = function () {
    return this.gpgpu;
  }, e.prototype.getCanvas = function () {
    return this.canvas;
  }, e.prototype.complex = function (e, t) {
    var n = this.makeOutputArray(e.shape, "complex64");return this.texData.get(n.dataId).complexTensors = { real: ENV.engine.keep(e.clone()), imag: ENV.engine.keep(t.clone()) }, n;
  }, e.prototype.real = function (e) {
    return this.texData.get(e.dataId).complexTensors.real.clone();
  }, e.prototype.imag = function (e) {
    return this.texData.get(e.dataId).complexTensors.imag.clone();
  }, e.prototype.slice = function (e, t, n) {
    if (this.shouldExecuteOnCPU([e])) return this.cpuBackend.slice(e, t, n);var r = this.texData.get(e.dataId).isPacked,
        o = isSliceContinous(e.shape, t, n);if (r || !o) {
      var a = new SliceProgram(n),
          i = a.getCustomSetupFunc(t);return this.compileAndRun(a, [e], null, i);
    }return this.uploadToGPU(e.dataId), this.shallowSlice(e, t, n);
  }, e.prototype.shallowSlice = function (e, t, n) {
    var r = this.texData.get(e.dataId),
        o = Tensor.make(n, {}, r.dtype),
        a = this.texData.get(o.dataId);_extends(a, r), a.shape = n;var i = computeFlatOffset(t, e.strides);r.slice && (i += r.slice.flatOffset), a.slice = { flatOffset: i, origDataId: r.slice && r.slice.origDataId || e.dataId };var s = this.dataRefCount.get(a.slice.origDataId) || 1;return this.dataRefCount.set(a.slice.origDataId, s + 1), o;
  }, e.prototype.stridedSlice = function (e, t, n, r, o, a, i, s, u) {
    if (this.shouldExecuteOnCPU([e])) return this.cpuBackend.stridedSlice(e, t, n, r, o, a, i, s, u);var l = getStridedSlicedInfo(e.shape, t, n, r, o, a, i, s, u),
        c = l[0],
        p = l[1],
        d = l[2],
        h = p.filter(function (e, t) {
      return -1 === d.indexOf(t);
    });if (h.some(function (e) {
      return 0 === e;
    })) return tensor([], h);var f = new StridedSliceProgram(c, r, p, d);return this.compileAndRun(f, [e]);
  }, e.prototype.reverse = function (e, t) {
    var n = new ReverseProgram(e.shape, t);return this.compileAndRun(n, [e]);
  }, e.prototype.concat = function (e, t) {
    if (this.shouldExecuteOnCPU(e)) return this.cpuBackend.concat(e, t);if (1 === e.length) return e[0];if (e.length > ENV.get("WEBGL_MAX_TEXTURES_IN_SHADER")) {
      var n = Math.floor(e.length / 2),
          r = this.concat(e.slice(0, n), t),
          o = this.concat(e.slice(n), t);return this.concat([r, o], t);
    }var a = computeOutShape(e.map(function (e) {
      return e.shape;
    }), t),
        i = e.map(function (e) {
      return e.as2D(-1, sizeFromShape(e.shape.slice(t)));
    }),
        s = new ConcatProgram(i.map(function (e) {
      return e.shape;
    }));return this.compileAndRun(s, i).reshape(a);
  }, e.prototype.neg = function (e) {
    var t = new UnaryOpProgram(e.shape, NEG);return this.compileAndRun(t, [e]);
  }, e.prototype.batchMatMul = function (e, t, n, r) {
    var o = n ? e.shape[2] : e.shape[1],
        a = r ? t.shape[1] : t.shape[2],
        i = n ? e.shape[1] : e.shape[2],
        s = e.shape[0];if ((1 === o || 1 === a) && i > MATMUL_SHARED_DIM_THRESHOLD) {
      n && (e = e.transpose([0, 2, 1])), r && (t = t.transpose([0, 2, 1]));var u = 1 === a ? e : e.as3D(s, i, 1),
          l = 1 === a ? 2 : 1,
          c = 1 === a ? t.as3D(s, 1, i) : t;return this.multiply(u, c).sum(l, !0);
    }var p = upcastType(e.dtype, t.dtype);if (1 === s) {
      var d = e.as2D(e.shape[1], e.shape[2]),
          h = t.as2D(t.shape[1], t.shape[2]),
          f = new MatMulPackedProgram(d.shape, h.shape, [o, a], n, r),
          m = this.makePackedTensor(f.outputShape, p),
          g = this.compileAndRun(f, [d, h], m);return g.reshape([1, g.shape[0], g.shape[1]]);
    }f = new MatMulProgram(e.shape, t.shape, n, r), m = this.makeOutputArray(f.outputShape, p);return this.compileAndRun(f, [e, t], m);
  }, e.prototype.multiply = function (e, t) {
    if ("complex64" === e.dtype) {
      var n = this.texData.get(e.dataId),
          r = this.texData.get(t.dataId),
          o = new BinaryOpComplexProgram(COMPLEX_MULTIPLY.REAL, e.shape, t.shape),
          a = new BinaryOpComplexProgram(COMPLEX_MULTIPLY.IMAG, e.shape, t.shape),
          i = [this.makeComplexComponentTensorHandle(e, n.complexTensors.real), this.makeComplexComponentTensorHandle(e, n.complexTensors.imag), this.makeComplexComponentTensorHandle(t, r.complexTensors.real), this.makeComplexComponentTensorHandle(t, r.complexTensors.imag)],
          s = this.compileAndRun(o, i),
          u = this.compileAndRun(a, i),
          l = this.complex(s, u);return s.dispose(), u.dispose(), l;
    }if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.multiply(e, t);if (this.usePackedBinaryOp(e, t)) return this.packedBinaryOp(e, t, MUL, e.dtype);var c = new BinaryOpProgram(MUL, e.shape, t.shape),
        p = this.makeOutputArray(c.outputShape, e.dtype);return this.compileAndRun(c, [e, t], p);
  }, e.prototype.batchNormalization = function (e, t, n, r, o, a) {
    var i = [e, t, n],
        s = null;null != a && (s = a.shape, i.push(a));var u = null;if (null != o && (u = o.shape, i.push(o)), ENV.get("WEBGL_PACK_BATCHNORMALIZATION")) {
      var l = new BatchNormPackedProgram(e.shape, t.shape, n.shape, s, u, r);return this.compileAndRun(l, i);
    }var c = new BatchNormProgram(e.shape, t.shape, n.shape, s, u, r);return this.compileAndRun(c, i);
  }, e.prototype.localResponseNormalization4D = function (e, t, n, r, o) {
    var a = new LRNProgram(e.shape, t, n, r, o);return this.compileAndRun(a, [e]);
  }, e.prototype.LRNGrad = function (e, t, n, r, o, a, i) {
    var s = new LRNGradProgram(t.shape, r, o, a, i);return this.compileAndRun(s, [t, n, e]);
  }, e.prototype.tile = function (e, t) {
    var n = new TileProgram(e.shape, t);return this.compileAndRun(n, [e]);
  }, e.prototype.pad = function (e, t, n) {
    var r = new PadProgram(e.shape, t, n);return this.compileAndRun(r, [e]);
  }, e.prototype.transpose = function (e, t) {
    var n = new TransposeProgram(e.shape, t);return this.compileAndRun(n, [e]);
  }, e.prototype.gather = function (e, t, n) {
    var r = new GatherProgram(e.shape, t.size, n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.batchToSpaceND = function (e, t, n) {
    assert(e.rank <= 4, "batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");var r = t.reduce(function (e, t) {
      return e * t;
    }),
        o = getReshaped(e.shape, t, r),
        a = getPermuted(o.length, t.length),
        i = getReshapedPermuted(e.shape, t, r),
        s = getSliceBeginCoords(n, t.length),
        u = getSliceSize(i, n, t.length);return e.reshape(o).transpose(a).reshape(i).slice(s, u);
  }, e.prototype.spaceToBatchND = function (e, t, n) {
    assert(e.rank <= 4, "spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");var r = t.reduce(function (e, t) {
      return e * t;
    }),
        o = [[0, 0]];o.push.apply(o, n);for (var a = 1 + t.length; a < e.shape.length; ++a) {
      o.push([0, 0]);
    }var i = e.pad(o),
        s = getReshaped(i.shape, t, r, !1),
        u = getPermuted(s.length, t.length, !1),
        l = getReshapedPermuted(i.shape, t, r, !1);return i.reshape(s).transpose(u).reshape(l);
  }, e.prototype.reduce = function (e, t, n) {
    var r = e.shape[0],
        o = e.shape[1],
        a = computeOptimalWindowSize(o),
        i = new ReduceProgram({ windowSize: a, inSize: o, batchSize: r }, t),
        s = i.outputShape,
        u = s[0],
        l = s[1],
        c = this.makeOutputArray([u, l], n);return this.compileAndRun(i, [e], c), 1 === c.shape[1] ? c : this.reduce(c, t, n);
  }, e.prototype.argReduce = function (e, t, n) {
    void 0 === n && (n = null);var r = e.shape[0],
        o = e.shape[1];null != n && (r = n.shape[0], o = n.shape[1]);var a = computeOptimalWindowSize(o),
        i = new ArgMinMaxProgram({ windowSize: a, inSize: o, batchSize: r }, t, null == n),
        s = i.outputShape,
        u = s[0],
        l = s[1],
        c = this.makeOutputArray([u, l], "int32"),
        p = [e];return null != n && p.push(n), this.compileAndRun(i, p, c), 1 === c.shape[1] ? c : this.argReduce(e, t, c);
  }, e.prototype.sum = function (e, t) {
    assertAxesAreInnerMostDims("sum", t, e.rank);var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o),
        i = sumOutType(e.dtype);return this.reduce(a, "sum", i).reshape(r);
  }, e.prototype.prod = function (e, t) {
    var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o),
        i = sumOutType(e.dtype);return this.reduce(a, "prod", i).reshape(r);
  }, e.prototype.unsortedSegmentSum = function (e, t, n) {
    var r = 0,
        o = getAxesPermutation([r], e.rank),
        a = e;null != o && (a = e.transpose(o), r = getInnerMostAxes(1, e.rank)[0]);var i = computeOutShape$1(a.shape, r, n),
        s = sizeFromShape([a.shape[r]]),
        u = a.as2D(-1, s),
        l = sumOutType(e.dtype),
        c = this.segOpCompute(u, "unsortedSegmentSum", t, l, n).reshape(i);return null != o && (c = c.transpose(getUndoAxesPermutation(o))), c;
  }, e.prototype.segOpCompute = function (e, t, n, r, o) {
    var a = e.shape[0],
        i = e.shape[1],
        s = segOpComputeOptimalWindowSize(i, o),
        u = new SegmentOpProgram({ windowSize: s, inSize: i, batchSize: a, numSegments: o }, t),
        l = u.outputShape,
        c = l[0],
        p = l[1],
        d = this.makeOutputArray([c, p], r);return this.compileAndRun(u, [e, n], d), d.shape[1] === o ? d : (n = range(0, o).tile([i / s]), this.segOpCompute(d, t, n, r, o));
  }, e.prototype.argMin = function (e, t) {
    var n = [t];assertAxesAreInnerMostDims("argMin", n, e.rank);var r = computeOutAndReduceShapes(e.shape, n),
        o = r[0],
        a = sizeFromShape(r[1]),
        i = e.as2D(-1, a);return this.argReduce(i, "min").reshape(o);
  }, e.prototype.argMax = function (e, t) {
    var n = [t];assertAxesAreInnerMostDims("argMax", n, e.rank);var r = computeOutAndReduceShapes(e.shape, n),
        o = r[0],
        a = sizeFromShape(r[1]),
        i = e.as2D(-1, a);return this.argReduce(i, "max").reshape(o);
  }, e.prototype.cumsum = function (e, t, n, r) {
    if (t !== e.rank - 1) throw new Error("WebGL cumsum shader expects an inner-most axis=" + (e.rank - 1) + " but got axis=" + t);var o = new CumSumProgram(e.shape, n, r);return this.compileAndRun(o, [e]);
  }, e.prototype.equal = function (e, t) {
    var n = new BinaryOpProgram(EQUAL, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.notEqual = function (e, t) {
    var n = new BinaryOpProgram(NOT_EQUAL, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.less = function (e, t) {
    if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.less(e, t);var n = new BinaryOpProgram(LESS, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.lessEqual = function (e, t) {
    var n = new BinaryOpProgram(LESS_EQUAL, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.greater = function (e, t) {
    if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.greater(e, t);var n = new BinaryOpProgram(GREATER, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.greaterEqual = function (e, t) {
    var n = new BinaryOpProgram(GREATER_EQUAL, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.logicalNot = function (e) {
    var t = new UnaryOpProgram(e.shape, LOGICAL_NOT);return this.compileAndRun(t, [e]);
  }, e.prototype.logicalAnd = function (e, t) {
    var n = new BinaryOpProgram(LOGICAL_AND, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.logicalOr = function (e, t) {
    var n = new BinaryOpProgram(LOGICAL_OR, e.shape, t.shape),
        r = this.makeOutputArray(n.outputShape, "bool");return this.compileAndRun(n, [e, t], r);
  }, e.prototype.select = function (e, t, n) {
    var r = new SelectProgram(e.rank, t.shape, t.rank),
        o = this.makeOutputArray(r.outputShape, upcastType(t.dtype, n.dtype));return this.compileAndRun(r, [e, t, n], o);
  }, e.prototype.where = function (e) {
    warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");var t = e.dataSync();return whereImpl(e.shape, t);
  }, e.prototype.topk = function (e, t, n) {
    return topkImpl(e.dataSync(), e.shape, e.dtype, t, n);
  }, e.prototype.min = function (e, t) {
    assertAxesAreInnerMostDims("min", t, e.rank);var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o);return this.reduce(a, "min", a.dtype).reshape(r);
  }, e.prototype.minimum = function (e, t) {
    if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.minimum(e, t);var n = new BinaryOpProgram(MIN, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.mod = function (e, t) {
    var n = new BinaryOpProgram(MOD, e.shape, t.shape),
        r = n.getCustomSetupFunc();return this.compileAndRun(n, [e, t], null, r);
  }, e.prototype.max = function (e, t) {
    assertAxesAreInnerMostDims("max", t, e.rank);var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o);return this.reduce(a, "max", a.dtype).reshape(r);
  }, e.prototype.maximum = function (e, t) {
    if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.maximum(e, t);var n = new BinaryOpProgram(MAX, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.all = function (e, t) {
    assertAxesAreInnerMostDims("all", t, e.rank);var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o);return this.reduce(a, "all", a.dtype).reshape(r);
  }, e.prototype.any = function (e, t) {
    assertAxesAreInnerMostDims("any", t, e.rank);var n = computeOutAndReduceShapes(e.shape, t),
        r = n[0],
        o = sizeFromShape(n[1]),
        a = e.as2D(-1, o);return this.reduce(a, "any", a.dtype).reshape(r);
  }, e.prototype.squaredDifference = function (e, t) {
    var n = new BinaryOpProgram(SQUARED_DIFFERENCE, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.realDivide = function (e, t) {
    var n = DIV;if (this.usePackedBinaryOp(e, t)) return this.packedBinaryOp(e, t, PACKED_DIV, "float32");var r = new BinaryOpProgram(n, e.shape, t.shape),
        o = this.makeOutputArray(r.outputShape, "float32");return this.compileAndRun(r, [e, t], o);
  }, e.prototype.floorDiv = function (e, t) {
    var n = INT_DIV;if (this.usePackedBinaryOp(e, t)) return this.packedBinaryOp(e, t, PACKED_INT_DIV, "int32");var r = new BinaryOpProgram(n, e.shape, t.shape),
        o = this.makeOutputArray(r.outputShape, "int32");return this.compileAndRun(r, [e, t], o);
  }, e.prototype.add = function (e, t) {
    if ("complex64" === e.dtype && "complex64" === t.dtype) return this.complexSeparableBinaryOp(e, t, ADD);var n = upcastType(e.dtype, t.dtype);if (this.usePackedBinaryOp(e, t)) return this.packedBinaryOp(e, t, ADD, n);var r = new BinaryOpProgram(ADD, e.shape, t.shape),
        o = this.makeOutputArray(r.outputShape, n);return this.compileAndRun(r, [e, t], o);
  }, e.prototype.usePackedBinaryOp = function (e, t) {
    if (!ENV.get("WEBGL_PACK_BINARY_OPERATIONS")) return !1;var n = assertAndGetBroadcastShape(e.shape, t.shape);return !(n.length > 4) && !getBroadcastDims(e.shape, n).length && !getBroadcastDims(t.shape, n).length;
  }, e.prototype.packedBinaryOp = function (e, t, n, r) {
    var o = new BinaryOpPackedProgram(n, e.shape, t.shape),
        a = this.makePackedTensor(o.outputShape, r);return this.compileAndRun(o, [e, t], a);
  }, e.prototype.complexSeparableBinaryOp = function (e, t, n) {
    var r = this,
        o = this.texData.get(e.dataId),
        a = this.texData.get(t.dataId),
        i = [[o.complexTensors.real, a.complexTensors.real], [o.complexTensors.imag, a.complexTensors.imag]].map(function (o) {
      var a = o[0],
          i = o[1],
          s = new BinaryOpProgram(n, e.shape, t.shape),
          u = r.makeOutputArray(s.outputShape, upcastType(a.dtype, i.dtype)),
          l = r.makeComplexComponentTensorHandle(e, a),
          c = r.makeComplexComponentTensorHandle(t, i);return r.compileAndRun(s, [l, c], u);
    }),
        s = i[0],
        u = i[1],
        l = this.complex(s, u);return s.dispose(), u.dispose(), l;
  }, e.prototype.makeComplexComponentTensorHandle = function (e, t) {
    return { dataId: t.dataId, dtype: t.dtype, shape: e.shape };
  }, e.prototype.addN = function (e) {
    for (var t = e[0], n = 1; n < e.length; n++) {
      t = this.add(t, e[n]);
    }return t;
  }, e.prototype.subtract = function (e, t) {
    if ("complex64" === e.dtype && "complex64" === t.dtype) return this.complexSeparableBinaryOp(e, t, SUB);if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.subtract(e, t);var n = upcastType(e.dtype, t.dtype);if (this.usePackedBinaryOp(e, t)) return this.packedBinaryOp(e, t, SUB, e.dtype);var r = new BinaryOpProgram(SUB, e.shape, t.shape),
        o = this.makeOutputArray(r.outputShape, n);return this.compileAndRun(r, [e, t], o);
  }, e.prototype.pow = function (e, t) {
    var n = this.usePackedBinaryOp(e, t),
        r = n ? new BinaryOpPackedProgram(PACKED_POW, e.shape, t.shape) : new BinaryOpProgram(POW, e.shape, t.shape),
        o = upcastType(e.dtype, t.dtype),
        a = n ? this.makePackedTensor(r.outputShape, o) : this.makeOutputArray(r.outputShape, o),
        i = r.getCustomSetupFunc();return this.compileAndRun(r, [e, t], a, i);
  }, e.prototype.ceil = function (e) {
    var t = new UnaryOpProgram(e.shape, CEIL);return this.compileAndRun(t, [e]);
  }, e.prototype.floor = function (e) {
    var t = new UnaryOpProgram(e.shape, FLOOR);return this.compileAndRun(t, [e]);
  }, e.prototype.sign = function (e) {
    var t = new UnaryOpProgram(e.shape, SIGN);return this.compileAndRun(t, [e]);
  }, e.prototype.round = function (e) {
    var t = new UnaryOpProgram(e.shape, ROUND);return this.compileAndRun(t, [e]);
  }, e.prototype.exp = function (e) {
    var t = new UnaryOpProgram(e.shape, EXP);return this.compileAndRun(t, [e]);
  }, e.prototype.expm1 = function (e) {
    var t = new UnaryOpProgram(e.shape, EXPM1);return this.compileAndRun(t, [e]);
  }, e.prototype.log = function (e) {
    var t = new UnaryOpProgram(e.shape, LOG),
        n = t.getCustomSetupFunc();return this.compileAndRun(t, [e], null, n);
  }, e.prototype.log1p = function (e) {
    var t = new UnaryOpProgram(e.shape, LOG1P);return this.compileAndRun(t, [e]);
  }, e.prototype.sqrt = function (e) {
    var t = new UnaryOpProgram(e.shape, SQRT);return this.compileAndRun(t, [e]);
  }, e.prototype.rsqrt = function (e) {
    var t = new UnaryOpProgram(e.shape, RSQRT);return this.compileAndRun(t, [e]);
  }, e.prototype.square = function (e) {
    var t = new UnaryOpProgram(e.shape, SQUARE);return this.compileAndRun(t, [e]);
  }, e.prototype.reciprocal = function (e) {
    var t = new UnaryOpProgram(e.shape, RECIPROCAL);return this.compileAndRun(t, [e]);
  }, e.prototype.relu = function (e) {
    var t = new UnaryOpProgram(e.shape, RELU);return this.compileAndRun(t, [e]);
  }, e.prototype.prelu = function (e, t) {
    var n = new BinaryOpProgram(PRELU, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.elu = function (e) {
    var t = new UnaryOpProgram(e.shape, ELU);return this.compileAndRun(t, [e]);
  }, e.prototype.eluDer = function (e, t) {
    var n = new BinaryOpProgram(ELU_DER, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.selu = function (e) {
    var t = new UnaryOpProgram(e.shape, SELU);return this.compileAndRun(t, [e]);
  }, e.prototype.int = function (e) {
    var t = new UnaryOpProgram(e.shape, TO_INT),
        n = this.makeOutputArray(t.outputShape, "int32");return this.compileAndRun(t, [e], n);
  }, e.prototype.clip = function (e, t, n) {
    var r,
        o = (r = ENV.get("WEBGL_PACK_CLIP") ? new ClipPackedProgram(e.shape) : new ClipProgram(e.shape)).getCustomSetupFunc(t, n);return this.compileAndRun(r, [e], null, o);
  }, e.prototype.abs = function (e) {
    var t = new UnaryOpProgram(e.shape, ABS);return this.compileAndRun(t, [e]);
  }, e.prototype.complexAbs = function (e) {
    var t = this.texData.get(e.dataId),
        n = new ComplexAbsProgram(e.shape),
        r = [this.makeComplexComponentTensorHandle(e, t.complexTensors.real), this.makeComplexComponentTensorHandle(e, t.complexTensors.imag)];return this.compileAndRun(n, r);
  }, e.prototype.sigmoid = function (e) {
    var t = new UnaryOpProgram(e.shape, SIGMOID);return this.compileAndRun(t, [e]);
  }, e.prototype.softplus = function (e) {
    var t = new UnaryOpProgram(e.shape, SOFTPLUS);return this.compileAndRun(t, [e]);
  }, e.prototype.sin = function (e) {
    var t = new UnaryOpProgram(e.shape, SIN);return this.compileAndRun(t, [e]);
  }, e.prototype.cos = function (e) {
    var t = new UnaryOpProgram(e.shape, COS);return this.compileAndRun(t, [e]);
  }, e.prototype.tan = function (e) {
    var t = new UnaryOpProgram(e.shape, TAN);return this.compileAndRun(t, [e]);
  }, e.prototype.asin = function (e) {
    var t = new UnaryOpProgram(e.shape, ASIN);return this.compileAndRun(t, [e]);
  }, e.prototype.acos = function (e) {
    var t = new UnaryOpProgram(e.shape, ACOS);return this.compileAndRun(t, [e]);
  }, e.prototype.atan = function (e) {
    var t = new UnaryOpProgram(e.shape, ATAN);return this.compileAndRun(t, [e]);
  }, e.prototype.atan2 = function (e, t) {
    var n = new BinaryOpProgram(ATAN2, e.shape, t.shape);return this.compileAndRun(n, [e, t]);
  }, e.prototype.sinh = function (e) {
    var t = new UnaryOpProgram(e.shape, SINH);return this.compileAndRun(t, [e]);
  }, e.prototype.cosh = function (e) {
    var t = new UnaryOpProgram(e.shape, COSH);return this.compileAndRun(t, [e]);
  }, e.prototype.tanh = function (e) {
    var t = new UnaryOpProgram(e.shape, TANH);return this.compileAndRun(t, [e]);
  }, e.prototype.asinh = function (e) {
    var t = new UnaryOpProgram(e.shape, ASINH);return this.compileAndRun(t, [e]);
  }, e.prototype.acosh = function (e) {
    var t = new UnaryOpProgram(e.shape, ACOSH),
        n = t.getCustomSetupFunc();return this.compileAndRun(t, [e], null, n);
  }, e.prototype.atanh = function (e) {
    var t = new UnaryOpProgram(e.shape, ATANH),
        n = t.getCustomSetupFunc();return this.compileAndRun(t, [e], null, n);
  }, e.prototype.erf = function (e) {
    var t = new UnaryOpProgram(e.shape, ERF);return this.compileAndRun(t, [e]);
  }, e.prototype.step = function (e, t) {
    var n = new UnaryOpProgram(e.shape, STEP(t));return this.compileAndRun(n, [e]);
  }, e.prototype.conv2dWithIm2Row = function (e, t, n) {
    var r = n.filterWidth,
        o = n.filterHeight,
        a = n.inChannels,
        i = n.outWidth,
        s = n.outHeight,
        u = r * o * a,
        l = s * i,
        c = [u, l],
        p = e.squeeze([0]),
        d = t.reshape([u, -1]),
        h = new Im2ColProgram(c, p.shape, n),
        f = this.compileAndRun(h, [p]),
        m = new MatMulPackedProgram(f.shape, d.shape, [l, n.outChannels], !0, !1);return this.compileAndRun(m, [f, d]).reshape([1, s, i, n.outChannels]);
  }, e.prototype.conv2d = function (e, t, n) {
    if (ENV.get("WEBGL_CONV_IM2COL") && 1 === e.shape[0]) return this.conv2dWithIm2Row(e, t, n);var r = new Conv2DProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.conv2dDerInput = function (e, t, n) {
    var r = new Conv2DDerInputProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.conv2dDerFilter = function (e, t, n) {
    var r = new Conv2DDerFilterProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.depthwiseConv2D = function (e, t, n) {
    var r;return ENV.get("WEBGL_PACK_DEPTHWISECONV") && 1 === n.dilationWidth && 1 === n.dilationHeight && n.padInfo.left <= 1 && n.strideWidth <= 2 && n.outChannels / n.inChannels == 1 ? (r = new DepthwiseConvPacked2DProgram(n), this.compileAndRun(r, [e, t], this.makePackedTensor(n.outShape, e.dtype))) : (r = new DepthwiseConv2DProgram(n), this.compileAndRun(r, [e, t]));
  }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
    var r = new DepthwiseConv2DDerInputProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
    var r = new DepthwiseConv2DDerFilterProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.conv3d = function (e, t, n) {
    var r = new Conv3DProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.conv3dDerInput = function (e, t, n) {
    var r = new Conv3DDerInputProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.conv3dDerFilter = function (e, t, n) {
    var r = new Conv3DDerFilterProgram(n);return this.compileAndRun(r, [e, t]);
  }, e.prototype.maxPool = function (e, t) {
    var n = new Pool2DProgram(t, "max", !1),
        r = this.makeOutputArray(n.outputShape, e.dtype);return this.compileAndRun(n, [e], r);
  }, e.prototype.avgPool = function (e, t) {
    var n = new Pool2DProgram(t, "avg", !1),
        r = this.makeOutputArray(n.outputShape, "float32");return this.compileAndRun(n, [e], r);
  }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
    var o = new Pool2DProgram(r, "max", !0),
        a = this.compileAndRun(o, [t]),
        i = new MaxPool2DBackpropProgram(r),
        s = this.makeOutputArray(i.outputShape, t.dtype),
        u = this.compileAndRun(i, [e, a], s);return a.dispose(), u;
  }, e.prototype.avgPoolBackprop = function (e, t, n) {
    var r = new AvgPool2DBackpropProgram(n),
        o = this.makeOutputArray(r.outputShape, t.dtype);return this.compileAndRun(r, [e], o);
  }, e.prototype.cast = function (e, t) {
    return castTensor(e, t, this);
  }, e.prototype.unstack = function (e, t) {
    for (var n = e.shape[t], r = new Array(e.rank - 1), o = 0, a = 0; a < e.rank; a++) {
      a !== t && (r[o++] = e.shape[a]);
    }var i = new Array(e.rank).fill(0),
        s = e.shape.slice();s[t] = 1;var u = new Array(n);for (a = 0; a < u.length; a++) {
      i[t] = a, u[a] = this.slice(e, i, s).reshape(r);
    }return u;
  }, e.prototype.reshape = function (e, t) {
    return this.texData.get(e.dataId).isPacked && !isReshapeFree(e.shape, t) ? this.packedReshape(e, t) : reshapeTensor(e, t);
  }, e.prototype.resizeBilinear = function (e, t, n, r) {
    var o = new ResizeBilinearProgram(e.shape, t, n, r);return this.compileAndRun(o, [e]);
  }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
    var r = new ResizeBilinearBackpropProgram(e, t, n);return this.compileAndRun(r, [e]);
  }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
    var o = new ResizeNearestNeighborProgram(e.shape, t, n, r);return this.compileAndRun(o, [e]);
  }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
    var r = new ResizeNearestNeigborBackpropProgram(e, t, n);return this.compileAndRun(r, [e]);
  }, e.prototype.multinomial = function (e, t, n, r) {
    var o = t ? e : softmax(e),
        a = o.shape[0],
        i = o.shape[1],
        s = new MultinomialProgram(a, i, n),
        u = this.makeOutputArray(s.outputShape, "int32"),
        l = s.getCustomSetupFunc(r);return this.compileAndRun(s, [o], u, l);
  }, e.prototype.oneHot = function (e, t, n, r) {
    var o = new OneHotProgram(e.size, t, n, r);return this.compileAndRun(o, [e]);
  }, e.prototype.nonMaxSuppression = function (e, t, n, r, o) {
    return warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead"), nonMaxSuppressionImpl(e.dataSync(), t.dataSync(), n, r, o);
  }, e.prototype.cropAndResize = function (e, t, n, r, o, a) {
    var i = new CropAndResizeProgram(e.shape, t.shape, r, o, a);return this.compileAndRun(i, [e, t, n]);
  }, e.prototype.depthToSpace = function (e, t, n) {
    assert(t > 1, "blockSize should be > 1 for depthToSpace, but was: " + t);var r = e.shape[0],
        o = ("NHWC" === n ? e.shape[1] : e.shape[2]) * t,
        a = ("NHWC" === n ? e.shape[2] : e.shape[3]) * t,
        i = ("NHWC" === n ? e.shape[3] : e.shape[1]) / (t * t),
        s = new DepthToSpaceProgram("NHWC" === n ? [r, o, a, i] : [r, i, o, a], t, n);return this.compileAndRun(s, [e]);
  }, e.prototype.split = function (e, t, n) {
    return split(e, t, n);
  }, e.prototype.scatterND = function (e, t, n) {
    var r = calculateShapes(t, e, n),
        o = r.sliceRank,
        a = r.numUpdates,
        i = r.sliceSize,
        s = r.strides,
        u = r.outputSize,
        l = [u / i, i],
        c = e.reshape([a, o]),
        p = t.reshape([a, i]);if (0 === u) return reshapeTensor(tensor([]), n);var d = scalar(0),
        h = new ScatterProgram(a, o, c.rank, p.rank, s, l);return this.compileAndRun(h, [p, c, d]).reshape(n);
  }, e.prototype.sparseToDense = function (e, t, n, r) {
    var o = calculateShapes(t, e, n),
        a = o.sliceRank,
        i = o.numUpdates,
        s = o.strides,
        u = o.outputSize,
        l = new ScatterProgram(i, a, e.rank, t.rank, s, [u, 1], !1);return this.compileAndRun(l, [t, e, r]).reshape(n);
  }, e.prototype.fft = function (e) {
    return this.fftImpl(e, !1);
  }, e.prototype.ifft = function (e) {
    return this.fftImpl(e, !0);
  }, e.prototype.fftImpl = function (e, t) {
    var n = this.texData.get(e.dataId),
        r = new FFTProgram(COMPLEX_FFT.REAL, e.shape, t),
        o = new FFTProgram(COMPLEX_FFT.IMAG, e.shape, t),
        a = [this.makeComplexComponentTensorHandle(e, n.complexTensors.real), this.makeComplexComponentTensorHandle(e, n.complexTensors.imag)],
        i = this.compileAndRun(r, a),
        s = this.compileAndRun(o, a),
        u = this.complex(i, s).as2D(e.shape[0], e.shape[1]);return i.dispose(), s.dispose(), u;
  }, e.prototype.gatherND = function (e, t) {
    var n = t.shape,
        r = n[n.length - 1],
        o = prepareAndValidate(e, t),
        a = o[0],
        i = o[1],
        s = o[2],
        u = o[3],
        l = t.reshape([i, r]),
        c = e.reshape([e.size / s, s]),
        p = new GatherNDProgram(r, u, [i, s]);return this.compileAndRun(p, [c, l]).reshape(a);
  }, e.prototype.makeOutputArray = function (e, t) {
    return Tensor.make(e, {}, t);
  }, e.prototype.makePackedTensor = function (e, t) {
    var n = Tensor.make(e, {}, t);return this.texData.get(n.dataId).isPacked = !0, n;
  }, e.prototype.unpackTensor = function (e) {
    var t = new UnpackProgram(e.shape);return this.compileAndRun(t, [e], Tensor.make(t.outputShape, {}, e.dtype));
  }, e.prototype.packedReshape = function (e, t) {
    var n = e.reshape([getBatchDim(e.shape)].concat(getRowsCols(e.shape))),
        r = [getBatchDim(t)].concat(getRowsCols(t)),
        o = new ReshapePackedProgram(r, n.shape);return this.compileAndRun(o, [n]).reshape(t);
  }, e.prototype.compileAndRun = function (e, t, n, r, o) {
    var a = this;if (void 0 === o && (o = !0), null == n && (n = e.usesPackedTextures ? this.makePackedTensor(e.outputShape, t[0].dtype) : this.makeOutputArray(e.outputShape, t[0].dtype)), 0 === n.size) return this.texData.get(n.dataId).values = getTypedArrayFromDType(n.dtype, 0), n;var i = t.map(function (t) {
      if ("complex64" === t.dtype) throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");var n = a.texData.get(t.dataId);if (null == n.texture) {
        if (!e.usesPackedTextures && sizeFromShape(t.shape) <= ENV.get("WEBGL_SIZE_UPLOAD_UNIFORM")) return { shape: t.shape, texData: null, isUniform: !0, uniformValues: a.readSync(t.dataId) };e.usesPackedTextures && (n.isPacked = !0, n.shape = t.shape);
      } else if (!!n.isPacked != !!e.usesPackedTextures) {
        var r = void 0,
            o = void 0;n.isPacked ? (r = new UnpackProgram(t.shape), o = a.compileAndRun(r, [t], Tensor.make(r.outputShape, {}, t.dtype))) : (r = new PackProgram(t.shape), o = a.compileAndRun(r, [t], a.makePackedTensor(t.shape, t.dtype))), n = a.texData.get(o.dataId), t = o;
      } else if (n.isPacked && !isReshapeFree(n.shape, t.shape)) {
        a.delayedStorage = !1;var i = t.dataSync();a.delayedStorage = !0, t = Tensor.make(t.shape, { values: i }, t.dtype), (n = a.texData.get(t.dataId)).isPacked = !0;
      }return a.uploadToGPU(t.dataId), { shape: t.shape, texData: n, isUniform: !1 };
    });this.uploadToGPU(n.dataId);var s,
        u = { shape: n.shape, texData: this.texData.get(n.dataId), isUniform: !1 },
        l = makeShaderKey(e, i, u),
        c = this.getAndSaveBinary(l, function () {
      return compileProgram(a.gpgpu, e, i, u);
    }),
        p = null != this.activeTimers;p && (s = this.startTimer()), runProgram(c, i, u, r);var d = 1024 * ENV.get("WEBGL_NUM_MB_BEFORE_PAGING");if (o && this.numBytesInGPU > d) for (var h = this.numBytesInGPU - d; h > 0 && this.lruDataGPU.length > 0;) {
      var f = this.lruDataGPU.shift(),
          m = this.texData.get(f),
          g = m.shape,
          v = m.dtype;h -= this.computeBytes(g, v), this.read(f);
    }return p && (s = this.endTimer(s), this.activeTimers.push({ name: e.constructor.name, query: this.getQueryTime(s) })), ENV.get("WEBGL_LAZILY_UNPACK") || !this.texData.get(n.dataId).isPacked || e.isPackShader ? n : this.unpackTensor(n);
  }, e.prototype.getAndSaveBinary = function (e, t) {
    return e in this.binaryCache || (this.binaryCache[e] = t()), this.binaryCache[e];
  }, e.prototype.getTextureManager = function () {
    return this.textureManager;
  }, e.prototype.dispose = function () {
    if (!this.disposed) {
      for (var e in this.binaryCache) {
        this.gpgpu.deleteProgram(this.binaryCache[e].webGLProgram);
      }this.textureManager.dispose(), this.canvas.remove(), null != this.fromPixels2DContext && this.fromPixels2DContext.canvas.remove(), this.gpgpuCreatedLocally && this.gpgpu.dispose(), this.disposed = !0;
    }
  }, e.prototype.floatPrecision = function () {
    var e = this;return tidy(function () {
      var t = ENV.get("DEBUG");ENV.set("DEBUG", !1);var n = e.abs(scalar(1e-8)).get();return ENV.set("DEBUG", t), n > 0 ? 32 : 16;
    });
  }, e.prototype.uploadToGPU = function (e) {
    var t,
        n = this.texData.get(e),
        r = n.shape,
        o = n.values,
        a = n.texture,
        i = n.usage,
        s = n.isPacked;if (null == a) {
      var u,
          l = null != this.activeTimers;l && (u = performance.now());var c = getTextureShapeFromLogicalShape(r, s);n.texShape = c;var p = this.acquireTexture(e, c, i, s);if (n.texture = p, null != o) {
        if (s) {
          var d = getBatchDim(r),
              h = 1,
              f = 1;r.length && (h = (t = getRowsCols(r))[0], f = t[1]), this.gpgpu.uploadMatrixToPackedTexture(p, d, h, f, c[0], c[1], typedArrayToFloat32(o));
        } else this.gpgpu.uploadMatrixToTexture(p, c[0], c[1], typedArrayToFloat32(o));n.values = null, l && (this.uploadWaitMs += performance.now() - u);
      }
    } else {
      ENV.get("WEBGL_NUM_MB_BEFORE_PAGING") < Number.POSITIVE_INFINITY && this.lruDataGPU.indexOf(e) >= 0 && (this.lruDataGPU.splice(this.lruDataGPU.indexOf(e), 1), this.lruDataGPU.push(e));
    }
  }, e.prototype.convertAndCacheOnCPU = function (e, t) {
    var n = this.delayedStorage,
        r = this.texData.get(e),
        o = r.texture,
        a = r.texShape,
        i = r.dtype,
        s = r.usage,
        u = r.isPacked;return n && null != o && (this.releaseTexture(e, o, a, s, u), r.texture = null, r.texShape = null, r.isPacked = !1), r.usage = TextureUsage.UPLOAD, null != t && (r.values = float32ToTypedArray(t, i)), r.values;
  }, e.prototype.releaseTexture = function (e, t, n, r, o) {
    var a = this.texData.get(e),
        i = a.shape,
        s = a.dtype;if (ENV.get("WEBGL_NUM_MB_BEFORE_PAGING") < Number.POSITIVE_INFINITY) {
      var u = this.lruDataGPU.indexOf(e);u >= 0 && this.lruDataGPU.splice(u, 1);
    }this.numBytesInGPU -= this.computeBytes(i, s), this.textureManager.releaseTexture(t, n, r, o);
  }, e.prototype.acquireTexture = function (e, t, n, r) {
    var o = this.texData.get(e),
        a = o.shape,
        i = o.dtype;return ENV.get("WEBGL_NUM_MB_BEFORE_PAGING") < Number.POSITIVE_INFINITY && this.lruDataGPU.push(e), this.numBytesInGPU += this.computeBytes(a, i), this.textureManager.acquireTexture(t, n, r);
  }, e.prototype.computeBytes = function (e, t) {
    return sizeFromShape(e) * bytesPerElement(t);
  }, e;
}();function float32ToTypedArray(e, t) {
  if ("float32" === t || "complex64" === t) return e;if ("int32" === t || "bool" === t) {
    for (var n = "int32" === t ? new Int32Array(e.length) : new Uint8Array(e.length), r = 0; r < n.length; ++r) {
      n[r] = Math.round(e[r]);
    }return n;
  }throw new Error("Unknown dtype " + t);
}function typedArrayToFloat32(e) {
  return e instanceof Float32Array ? e : new Float32Array(e);
}function neg_(e) {
  var t = convertToTensor(e, "x", "neg");return ENV.engine.runKernel(function (e) {
    return e.neg(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.neg();
      } };
  });
}function ceil_(e) {
  var t = convertToTensor(e, "x", "ceil");return ENV.engine.runKernel(function (e) {
    return e.ceil(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return zerosLike(e);
      } };
  });
}function floor_(e) {
  var t = convertToTensor(e, "x", "floor");return ENV.engine.runKernel(function (e) {
    return e.floor(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return zerosLike(e);
      } };
  });
}function sign_(e) {
  var t = convertToTensor(e, "x", "sign");return ENV.engine.runKernel(function (e) {
    return e.sign(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return zerosLike(e);
      } };
  });
}function round_(e) {
  var t = convertToTensor(e, "x", "round");return ENV.engine.runKernel(function (e) {
    return e.round(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return zerosLike(e);
      } };
  });
}function exp_(e) {
  var t = convertToTensor(e, "x", "exp");return ENV.engine.runKernel(function (e, n) {
    return n(e.exp(t));
  }, { $x: t }, function (e, t) {
    var n = t[0];return { $x: function $x() {
        return e.mulStrict(n);
      } };
  });
}function expm1_(e) {
  var t = convertToTensor(e, "x", "expm1");return ENV.engine.runKernel(function (e) {
    return e.expm1(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mulStrict(t.exp());
      } };
  });
}function log_(e) {
  var t = convertToTensor(e, "x", "log");return ENV.engine.runKernel(function (e) {
    return e.log(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(t.toFloat());
      } };
  });
}function log1p_(e) {
  var t = convertToTensor(e, "x", "log1p");return ENV.engine.runKernel(function (e) {
    return e.log1p(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.div(t.add(1));
      } };
  });
}function sqrt_(e) {
  var t = convertToTensor(e, "x", "sqrt");return ENV.engine.runKernel(function (e) {
    return e.sqrt(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.div(t.toFloat().sqrt().mul(2));
      } };
  });
}function rsqrt_(e) {
  var t = convertToTensor(e, "x", "rsqrt");return ENV.engine.runKernel(function (e) {
    return e.rsqrt(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.div(t.pow(1.5).mul(2)).neg();
      } };
  });
}function square_(e) {
  var t = convertToTensor(e, "x", "square");return ENV.engine.runKernel(function (e) {
    return e.square(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mul(t.toFloat().mul(2));
      } };
  });
}function reciprocal_(e) {
  var t = convertToTensor(e, "x", "reciprocal");return ENV.engine.runKernel(function (e) {
    return e.reciprocal(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(t.square().neg());
      } };
  });
}function abs_(e) {
  var t = convertToTensor(e, "x", "abs");if ("complex64" === t.dtype) return ENV.engine.runKernel(function (e) {
    return e.complexAbs(t);
  }, { $x: t });return ENV.engine.runKernel(function (e) {
    return e.abs(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mulStrict(t.toFloat().step(-1));
      } };
  });
}function clipByValue_(e, t, n) {
  var r = convertToTensor(e, "x", "clipByValue");assert(t <= n, "Error in clip: min (" + t + ") must be less than or equal to max (" + n + ").");return ENV.engine.runKernel(function (e) {
    return e.clip(r, t, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        return e.where(r.greaterEqual(t).logicalAnd(r.lessEqual(n)), zerosLike(e));
      } };
  });
}function sigmoid_(e) {
  var t = convertToTensor(e, "x", "sigmoid");return ENV.engine.runKernel(function (e, n) {
    return n(e.sigmoid(t));
  }, { $x: t }, function (e, t) {
    var n = t[0];return { $x: function $x() {
        return e.mul(n.mul(scalar(1).sub(n)));
      } };
  });
}function logSigmoid_(e) {
  var t = convertToTensor(e, "x", "logSigmoid");return ENV.engine.runKernel(function (e) {
    return e.softplus(t.neg()).neg();
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mulStrict(t.neg().sigmoid());
      } };
  });
}function softplus_(e) {
  var t = convertToTensor(e, "x", "softplus");return ENV.engine.runKernel(function (e) {
    return e.softplus(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mulStrict(t.sigmoid());
      } };
  });
}function sin_(e) {
  var t = convertToTensor(e, "x", "sin");return ENV.engine.runKernel(function (e) {
    return e.sin(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return t.toFloat().cos().mulStrict(e);
      } };
  });
}function cos_(e) {
  var t = convertToTensor(e, "x", "cos");return ENV.engine.runKernel(function (e) {
    return e.cos(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return t.toFloat().sin().neg().mulStrict(e);
      } };
  });
}function tan_(e) {
  var t = convertToTensor(e, "x", "tan");return ENV.engine.runKernel(function (e) {
    return e.tan(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(t.cos().square());
      } };
  });
}function asin_(e) {
  var t = convertToTensor(e, "x", "asin");return ENV.engine.runKernel(function (e) {
    return e.asin(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(scalar(1).sub(t.toFloat().square()).sqrt());
      } };
  });
}function acos_(e) {
  var t = convertToTensor(e, "x", "acos");return ENV.engine.runKernel(function (e) {
    return e.acos(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(scalar(1).sub(t.toFloat().square()).sqrt()).neg();
      } };
  });
}function atan_(e) {
  var t = convertToTensor(e, "x", "atan");return ENV.engine.runKernel(function (e) {
    return e.atan(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.div(t.toFloat().square().add(1));
      } };
  });
}function sinh_(e) {
  var t = convertToTensor(e, "x", "sinh");return ENV.engine.runKernel(function (e) {
    return e.sinh(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return t.toFloat().cosh().mulStrict(e);
      } };
  });
}function cosh_(e) {
  var t = convertToTensor(e, "x", "cosh");return ENV.engine.runKernel(function (e) {
    return e.cosh(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return t.toFloat().sinh().mulStrict(e);
      } };
  });
}function tanh_(e) {
  var t = convertToTensor(e, "x", "tanh");return ENV.engine.runKernel(function (e, n) {
    return n(e.tanh(t));
  }, { $x: t }, function (e, t) {
    var n = t[0];return { $x: function $x() {
        return scalar(1).sub(n.square()).mulStrict(e);
      } };
  });
}function asinh_(e) {
  var t = convertToTensor(e, "x", "asinh");return ENV.engine.runKernel(function (e) {
    return e.asinh(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(scalar(1).add(t.toFloat().square()).sqrt());
      } };
  });
}function acosh_(e) {
  var t = convertToTensor(e, "x", "acosh");return ENV.engine.runKernel(function (e) {
    return e.acosh(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.divStrict(t.toFloat().square().sub(1).sqrt());
      } };
  });
}function atanh_(e) {
  var t = convertToTensor(e, "x", "atanh");return ENV.engine.runKernel(function (e) {
    return e.atanh(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.div(scalar(1).sub(t.toFloat().square()));
      } };
  });
}function erf_(e) {
  var t = convertToTensor(e, "x", "erf");assert("int32" === t.dtype || "float32" === t.dtype, "Input dtype must be `int32` or `float32`."), "int32" === t.dtype && (t = t.toFloat());return ENV.engine.runKernel(function (e) {
    return e.erf(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        return e.mul(t.square().neg().exp().mul(2 / Math.sqrt(Math.PI)));
      } };
  });
}function step_(e, t) {
  void 0 === t && (t = 0);var n = convertToTensor(e, "x", "step");return ENV.engine.runKernel(function (e) {
    return e.step(n, t);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return zerosLike(e);
      } };
  });
}ENV.get("IS_BROWSER") && ENV.registerBackend("webgl", function () {
  return new MathBackendWebGL();
}, 2, setTensorTracker);var abs = op({ abs_: abs_ }),
    acos = op({ acos_: acos_ }),
    acosh = op({ acosh_: acosh_ }),
    asin = op({ asin_: asin_ }),
    asinh = op({ asinh_: asinh_ }),
    atan = op({ atan_: atan_ }),
    atanh = op({ atanh_: atanh_ }),
    ceil = op({ ceil_: ceil_ }),
    clipByValue = op({ clipByValue_: clipByValue_ }),
    cos = op({ cos_: cos_ }),
    cosh = op({ cosh_: cosh_ }),
    erf = op({ erf_: erf_ }),
    exp = op({ exp_: exp_ }),
    expm1 = op({ expm1_: expm1_ }),
    floor = op({ floor_: floor_ }),
    log$1 = op({ log_: log_ }),
    log1p = op({ log1p_: log1p_ }),
    logSigmoid = op({ logSigmoid_: logSigmoid_ }),
    neg = op({ neg_: neg_ }),
    reciprocal = op({ reciprocal_: reciprocal_ }),
    round = op({ round_: round_ }),
    rsqrt = op({ rsqrt_: rsqrt_ }),
    sigmoid = op({ sigmoid_: sigmoid_ }),
    sign = op({ sign_: sign_ }),
    sin = op({ sin_: sin_ }),
    sinh = op({ sinh_: sinh_ }),
    softplus = op({ softplus_: softplus_ }),
    sqrt = op({ sqrt_: sqrt_ }),
    square = op({ square_: square_ }),
    step = op({ step_: step_ }),
    tan = op({ tan_: tan_ }),
    tanh$1 = op({ tanh_: tanh_ });function batchNormalization2d_(e, t, n, r, o, a) {
  void 0 === r && (r = .001);var i,
      s,
      u = convertToTensor(e, "x", "batchNormalization"),
      l = convertToTensor(t, "mean", "batchNormalization"),
      c = convertToTensor(n, "variance", "batchNormalization");return null != o && (i = convertToTensor(o, "scale", "batchNormalization")), null != a && (s = convertToTensor(a, "offset", "batchNormalization")), assert(2 === u.rank, "Error in batchNormalization3D: x must be rank 3 but got rank " + u.rank + "."), assert(2 === l.rank || 1 === l.rank, "Error in batchNormalization2D: mean must be rank 2 or rank 1 but got rank " + l.rank + "."), assert(2 === c.rank || 1 === c.rank, "Error in batchNormalization2D: variance must be rank 2 or rank 1 but got rank " + c.rank + "."), null != i && assert(2 === i.rank || 1 === i.rank, "Error in batchNormalization2D: scale must be rank 2 or rank 1 but got rank " + i.rank + "."), null != s && assert(2 === s.rank || 1 === s.rank, "Error in batchNormalization2D: offset must be rank 2 or rank 1 but got rank " + s.rank + "."), batchNormalization(u, l, c, r, i, s);
}function batchNormalization3d_(e, t, n, r, o, a) {
  void 0 === r && (r = .001);var i,
      s,
      u = convertToTensor(e, "x", "batchNormalization"),
      l = convertToTensor(t, "mean", "batchNormalization"),
      c = convertToTensor(n, "variance", "batchNormalization");return null != o && (i = convertToTensor(o, "scale", "batchNormalization")), null != a && (s = convertToTensor(a, "offset", "batchNormalization")), assert(3 === u.rank, "Error in batchNormalization3D: x must be rank 3 but got rank " + u.rank + "."), assert(3 === l.rank || 1 === l.rank, "Error in batchNormalization3D: mean must be rank 3 or rank 1 but got rank " + l.rank + "."), assert(3 === c.rank || 1 === c.rank, "Error in batchNormalization3D: variance must be rank 3 or rank 1 but got rank " + c.rank + "."), null != i && assert(3 === i.rank || 1 === i.rank, "Error in batchNormalization3D: scale must be rank 3 or rank 1 but got rank " + i.rank + "."), null != s && assert(3 === s.rank || 1 === s.rank, "Error in batchNormalization3D: offset must be rank 3 or rank 1 but got rank " + s.rank + "."), batchNormalization(u, l, c, r, i, s);
}function batchNormalization4d_(e, t, n, r, o, a) {
  void 0 === r && (r = .001);var i,
      s,
      u = convertToTensor(e, "x", "batchNormalization"),
      l = convertToTensor(t, "mean", "batchNormalization"),
      c = convertToTensor(n, "variance", "batchNormalization");return null != o && (i = convertToTensor(o, "scale", "batchNormalization")), null != a && (s = convertToTensor(a, "offset", "batchNormalization")), assert(4 === u.rank, "Error in batchNormalization4D: x must be rank 4 but got rank " + u.rank + "."), assert(4 === l.rank || 1 === l.rank, "Error in batchNormalization4D: mean must be rank 4 or rank 1 but got rank " + l.rank + "."), assert(4 === c.rank || 1 === c.rank, "Error in batchNormalization4D: variance must be rank 4 or rank 1 but got rank " + c.rank + "."), null != i && assert(4 === i.rank || 1 === i.rank, "Error in batchNormalization4D: scale must be rank 4 or rank 1 but got rank " + i.rank + "."), null != s && assert(4 === s.rank || 1 === s.rank, "Error in batchNormalization4D: offset must be rank 4 or rank 1 but got rank " + s.rank + "."), batchNormalization(u, l, c, r, i, s);
}function batchNormalization_(e, t, n, r, o, a) {
  void 0 === r && (r = .001);var i,
      s,
      u,
      l = convertToTensor(e, "x", "batchNormalization"),
      c = convertToTensor(t, "mean", "batchNormalization"),
      p = convertToTensor(n, "variance", "batchNormalization");null != o && (i = convertToTensor(o, "scale", "batchNormalization")), null != a && (s = convertToTensor(a, "offset", "batchNormalization")), assert(c.rank === p.rank, "Batch normalization gradient requires mean and variance to have equal ranks."), assert(null == s || c.rank === s.rank, "Batch normalization gradient requires mean and offset to have equal ranks."), assert(null == i || c.rank === i.rank, "Batch normalization gradient requires mean and scale to have equal ranks."), u = 0 === l.rank || 1 === l.rank ? l.as4D(1, 1, 1, l.size) : 2 === l.rank ? l.as4D(1, 1, l.shape[0], l.shape[1]) : 3 === l.rank ? l.as4D(1, l.shape[0], l.shape[1], l.shape[2]) : l;return ENV.engine.runKernel(function (e) {
    return e.batchNormalization(u, batchnormReshape4D(c), batchnormReshape4D(p), r, batchnormReshape4D(i), batchnormReshape4D(s));
  }, { $x: l, $mean: c, $variance: p, $scale: i, $offset: s }, function (e) {
    var t = null == i ? scalar(1) : i,
        n = getReductionAxes(c.shape, u.shape),
        o = [];if (1 === c.rank) {
      for (var a = 0; a < u.shape.length - 1; ++a) {
        o.push(u.shape[a]);
      }o.push(1);
    }var s = l.sub(c),
        d = e.mul(t),
        h = rsqrt(p.add(scalar(r))),
        f = h.mul(h).mul(h).mul(scalar(-.5));return { $x: function $x() {
        return 1 === c.rank ? e.mul(tile(h.as4D(1, 1, 1, c.shape[0]), o)).mul(t).reshape(l.shape) : e.mul(h).mul(t).reshape(l.shape);
      }, $mean: function $mean() {
        var e = h.mul(scalar(-1)).mul(d);return 1 === c.rank && (e = e.sum(n)), e.reshape(c.shape);
      }, $variance: function $variance() {
        var e = f.mul(s).mul(d);return 1 === c.rank && (e = e.sum(n)), e.reshape(c.shape);
      }, $scale: function $scale() {
        var t = s.mul(h),
            r = e.mul(t);return 1 === c.rank && (r = r.sum(n)), r.reshape(c.shape);
      }, $offset: function $offset() {
        var t = e;return 1 === c.rank && (t = t.sum(n)), t.reshape(c.shape);
      } };
  }).reshape(l.shape);
}function batchnormReshape4D(e) {
  return null == e ? null : 0 === e.rank ? e.as1D() : 1 === e.rank ? e : 2 === e.rank ? e.as4D(1, 1, e.shape[0], e.shape[1]) : 3 === e.rank ? e.as4D(1, e.shape[0], e.shape[1], e.shape[2]) : e;
}var batchNormalization2d = op({ batchNormalization2d_: batchNormalization2d_ }),
    batchNormalization3d = op({ batchNormalization3d_: batchNormalization3d_ }),
    batchNormalization4d = op({ batchNormalization4d_: batchNormalization4d_ }),
    batchNormalization = op({ batchNormalization_: batchNormalization_ });function computePool2DInfo(e, t, n, r, o, a, i) {
  void 0 === i && (i = "channelsLast");var s,
      u = parseTupleParam(t),
      l = u[0],
      c = u[1];if ("channelsLast" === i) s = [l, c, e[3], e[3]];else {
    if ("channelsFirst" !== i) throw new Error("Unknown dataFormat " + i);s = [l, c, e[1], e[1]];
  }return computeConv2DInfo(e, s, n, r, o, a, !1, i);
}function computeConv2DInfo(e, t, n, r, o, a, i, s) {
  void 0 === i && (i = !1), void 0 === s && (s = "channelsLast");var u = [-1, -1, -1, -1],
      l = u[0],
      c = u[1],
      p = u[2],
      d = u[3];if ("channelsLast" === s) l = e[0], c = e[1], p = e[2], d = e[3];else {
    if ("channelsFirst" !== s) throw new Error("Unknown dataFormat " + s);l = e[0], d = e[1], c = e[2], p = e[3];
  }var h,
      f = t[0],
      m = t[1],
      g = t[3],
      v = parseTupleParam(n),
      y = v[0],
      x = v[1],
      T = parseTupleParam(r),
      w = T[0],
      E = T[1],
      S = getEffectiveFilterSize(f, w),
      b = getEffectiveFilterSize(m, E),
      C = getPadAndOutInfo(o, c, p, y, x, S, b, a),
      A = C.padInfo,
      _ = C.outHeight,
      N = C.outWidth,
      R = i ? g * d : g;return "channelsFirst" === s ? h = [l, R, _, N] : "channelsLast" === s && (h = [l, _, N, R]), { batchSize: l, dataFormat: s, inHeight: c, inWidth: p, inChannels: d, outHeight: _, outWidth: N, outChannels: R, padInfo: A, strideHeight: y, strideWidth: x, filterHeight: f, filterWidth: m, effectiveFilterHeight: S, effectiveFilterWidth: b, dilationHeight: w, dilationWidth: E, inShape: e, outShape: h, filterShape: t };
}function computeConv3DInfo(e, t, n, r, o, a, i) {
  void 0 === a && (a = !1), void 0 === i && (i = "channelsLast");var s = [-1, -1, -1, -1, -1],
      u = s[0],
      l = s[1],
      c = s[2],
      p = s[3],
      d = s[4];if ("channelsLast" === i) u = e[0], l = e[1], c = e[2], p = e[3], d = e[4];else {
    if ("channelsFirst" !== i) throw new Error("Unknown dataFormat " + i);u = e[0], d = e[1], l = e[2], c = e[3], p = e[4];
  }var h,
      f = t[0],
      m = t[1],
      g = t[2],
      v = t[4],
      y = parse3TupleParam(n),
      x = y[0],
      T = y[1],
      w = y[2],
      E = parse3TupleParam(r),
      S = E[0],
      b = E[1],
      C = E[2],
      A = get3DPadAndOutInfo(o, l, c, p, x, T, w, getEffectiveFilterSize(f, S), getEffectiveFilterSize(m, b), getEffectiveFilterSize(g, C)),
      _ = A.padInfo,
      N = A.outDepth,
      R = A.outHeight,
      I = A.outWidth,
      k = a ? v * d : v;return "channelsFirst" === i ? h = [u, k, N, R, I] : "channelsLast" === i && (h = [u, N, R, I, k]), { batchSize: u, dataFormat: i, inDepth: l, inHeight: c, inWidth: p, inChannels: d, outDepth: N, outHeight: R, outWidth: I, outChannels: k, padInfo: _, strideDepth: x, strideHeight: T, strideWidth: w, filterDepth: f, filterHeight: m, filterWidth: g, dilationDepth: S, dilationHeight: b, dilationWidth: C, inShape: e, outShape: h, filterShape: t };
}function computeOutputShape3D(e, t, n, r, o, a) {
  null == o && (o = computeDefaultPad(e, t, r));var i = e[0],
      s = e[1],
      u = conditionalRound((i - t + 2 * o) / r + 1, a);assert(isInt(u), "The output # of rows (" + u + ") must be an integer. Change the stride and/or zero pad parameters");var l = conditionalRound((s - t + 2 * o) / r + 1, a);return assert(isInt(l), "The output # of columns (" + l + ") must be an integer. Change the stride and/or zero pad parameters"), [u, l, n];
}function computeDefaultPad(e, t, n, r) {
  void 0 === r && (r = 1);var o = getEffectiveFilterSize(t, r);return Math.floor((e[0] * (n - 1) - n + o) / 2);
}function parseTupleParam(e) {
  return "number" == typeof e ? [e, e] : e;
}function parse3TupleParam(e) {
  return "number" == typeof e ? [e, e, e] : e;
}function getEffectiveFilterSize(e, t) {
  return t <= 1 ? e : e + (e - 1) * (t - 1);
}function getPadAndOutInfo(e, t, n, r, o, a, i, s) {
  var u, l, c;if ("number" == typeof e) {
    u = { top: e, bottom: e, left: e, right: e, type: 0 === e ? "VALID" : "NUMBER" };var p = computeOutputShape3D([t, n, 1], a, 1, r, e, s);l = p[0], c = p[1];
  } else if ("same" === e) {
    var d = ((l = Math.ceil(t / r)) - 1) * r + a - t,
        h = ((c = Math.ceil(n / o)) - 1) * o + i - n,
        f = Math.floor(d / 2),
        m = d - f,
        g = Math.floor(h / 2);u = { top: f, bottom: m, left: g, right: h - g, type: "SAME" };
  } else {
    if ("valid" !== e) throw Error("Unknown padding parameter: " + e);u = { top: 0, bottom: 0, left: 0, right: 0, type: "VALID" }, l = Math.ceil((t - a + 1) / r), c = Math.ceil((n - i + 1) / o);
  }return { padInfo: u, outHeight: l, outWidth: c };
}function get3DPadAndOutInfo(e, t, n, r, o, a, i, s, u, l) {
  var c, p, d, h;if ("same" === e) {
    var f = ((p = Math.ceil(t / o)) - 1) * o + s - t,
        m = ((d = Math.ceil(n / a)) - 1) * a + u - n,
        g = ((h = Math.ceil(r / i)) - 1) * i + l - r,
        v = Math.floor(f / 2),
        y = f - v,
        x = Math.floor(m / 2),
        T = m - x,
        w = Math.floor(g / 2);c = { top: x, bottom: T, left: w, right: g - w, front: v, back: y, type: "SAME" };
  } else {
    if ("valid" !== e) throw Error("Unknown padding parameter: " + e);c = { top: 0, bottom: 0, left: 0, right: 0, front: 0, back: 0, type: "VALID" }, p = Math.ceil((t - s + 1) / o), d = Math.ceil((n - u + 1) / a), h = Math.ceil((r - l + 1) / i);
  }return { padInfo: c, outDepth: p, outHeight: d, outWidth: h };
}function conditionalRound(e, t) {
  if (!t) return e;switch (t) {case "round":
      return Math.round(e);case "ceil":
      return Math.ceil(e);case "floor":
      return Math.floor(e);default:
      throw new Error("Unknown roundingMode " + t);}
}function tupleValuesAreOne(e) {
  var t = parseTupleParam(e),
      n = t[0],
      r = t[1];return 1 === n && 1 === r;
}function eitherStridesOrDilationsAreOne(e, t) {
  return tupleValuesAreOne(e) || tupleValuesAreOne(t);
}function matMul_(e, t, n, r) {
  var o;void 0 === n && (n = !1), void 0 === r && (r = !1);var a = convertToTensor(e, "a", "matMul"),
      i = convertToTensor(t, "b", "matMul");a = (o = makeTypesMatch(a, i))[0], i = o[1];var s = n ? a.shape[a.rank - 2] : a.shape[a.rank - 1],
      u = r ? i.shape[i.rank - 1] : i.shape[i.rank - 2],
      l = n ? a.shape[a.rank - 1] : a.shape[a.rank - 2],
      c = r ? i.shape[i.rank - 2] : i.shape[i.rank - 1],
      p = a.shape.slice(0, -2),
      d = i.shape.slice(0, -2),
      h = sizeFromShape(p),
      f = sizeFromShape(d);assert(a.rank >= 2 && i.rank >= 2 && a.rank === i.rank, "Error in matMul: inputs must have the same rank of at least 2, got ranks " + a.rank + " and " + i.rank + "."), assert(arraysEqual(p, d), "Error in matMul: outer dimensions (" + p + ") and (" + d + ") of Tensors with shapes " + a.shape + " and " + i.shape + " must match."), assert(s === u, "Error in matMul: inner shapes (" + s + ") and (" + u + ") of Tensors with shapes " + a.shape + " and " + i.shape + " and transposeA=" + n + " and transposeB=" + r + " must match.");var m = a.shape.slice(0, -2).concat([l, c]),
      g = n ? a.as3D(h, s, l) : a.as3D(h, l, s),
      v = r ? i.as3D(f, c, u) : i.as3D(f, u, c);return ENV.engine.runKernel(function (e) {
    return e.batchMatMul(g, v, n, r);
  }, { $a: g, $b: v }, function (e) {
    return n || r ? !n && r ? { $a: function $a() {
        return e.matMul(v, !1, !1);
      }, $b: function $b() {
        return e.matMul(g, !0, !1);
      } } : n && !r ? { $a: function $a() {
        return v.matMul(e, !1, !0);
      }, $b: function $b() {
        return g.matMul(e, !1, !1);
      } } : { $a: function $a() {
        return v.matMul(e, !0, !0);
      }, $b: function $b() {
        return e.matMul(g, !0, !0);
      } } : { $a: function $a() {
        return e.matMul(v, !1, !0);
      }, $b: function $b() {
        return g.matMul(e, !0, !1);
      } };
  }).reshape(m);
}function outerProduct_(e, t) {
  var n = convertToTensor(e, "v1", "outerProduct"),
      r = convertToTensor(t, "v2", "outerProduct");return assert(1 === n.rank && 1 === r.rank, "Error in outerProduct: inputs must be rank 1, but got ranks " + n.rank + " and " + r.rank + "."), n.as2D(-1, 1).matMul(r.as2D(1, -1));
}function dot_(e, t) {
  var n = convertToTensor(e, "t1", "dot"),
      r = convertToTensor(t, "t2", "dot");assert(!(1 !== n.rank && 2 !== n.rank || 1 !== r.rank && 2 !== r.rank), "Error in dot: inputs must all be rank 1 or 2, but got ranks " + n.rank + " and " + r.rank + ".");var o = 1 === n.rank ? n.size : n.shape[1],
      a = 1 === r.rank ? r.size : r.shape[0];return assert(o === a, "Error in dot: inner dimensions of inputs must match, but got " + o + " and " + a + "."), 1 === n.rank && 1 === r.rank ? n.as2D(1, -1).matMul(r.as2D(-1, 1)).asScalar() : 1 === n.rank && 2 === r.rank ? n.as2D(1, -1).matMul(r.as2D(r.shape[0], r.shape[1])).as1D() : 2 === n.rank && 1 === r.rank ? n.matMul(r.as2D(-1, 1)).as1D() : n.matMul(r.as2D(r.shape[0], r.shape[1]));
}var matMul = op({ matMul_: matMul_ }),
    dot = op({ dot_: dot_ }),
    outerProduct = op({ outerProduct_: outerProduct_ });function conv1d_(e, t, n, r, o, a, i) {
  void 0 === o && (o = "NWC"), void 0 === a && (a = 1);var s = convertToTensor(e, "x", "conv1d"),
      u = convertToTensor(t, "filter", "conv1d"),
      l = s,
      c = !1;2 === s.rank && (c = !0, l = s.as3D(1, s.shape[0], s.shape[1])), assert(3 === l.rank, "Error in conv1d: input must be rank 3, but got rank " + l.rank + "."), assert(3 === u.rank, "Error in conv1d: filter must be rank 3, but got rank " + u.rank + "."), null != i && assert(isInt(r), "Error in conv1d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + "."), assert(l.shape[2] === u.shape[1], "Error in conv1d: depth of input (" + l.shape[2] + ") must match input depth for filter " + u.shape[1] + "."), assert(eitherStridesOrDilationsAreOne(n, a), "Error in conv1D: Either stride or dilation must be 1. Got stride " + n + " and dilation '" + a + "'"), assert("NWC" === o, "Error in conv1d: got dataFormat of " + o + " but only NWC is currently supported.");var p = u.as4D(1, u.shape[0], u.shape[1], u.shape[2]),
      d = l.as4D(l.shape[0], 1, l.shape[1], l.shape[2]),
      h = conv2d(d, p, [1, n], r, "NHWC", [1, a], i);return c ? h.as2D(h.shape[2], h.shape[3]) : h.as3D(h.shape[0], h.shape[2], h.shape[3]);
}function conv2d_(e, t, n, r, o, a, i) {
  void 0 === o && (o = "NHWC"), void 0 === a && (a = [1, 1]);var s = convertToTensor(e, "x", "conv2d"),
      u = convertToTensor(t, "filter", "conv2d"),
      l = s,
      c = !1;3 === s.rank && (c = !0, l = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), assert(4 === l.rank, "Error in conv2d: input must be rank 4, but got rank " + l.rank + "."), assert(4 === u.rank, "Error in conv2d: filter must be rank 4, but got rank " + u.rank + "."), null != i && assert(isInt(r), "Error in conv2d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + "."), assert(l.shape[3] === u.shape[2], "Error in conv2d: depth of input (" + l.shape[3] + ") must match input depth for filter " + u.shape[2] + "."), assert(eitherStridesOrDilationsAreOne(n, a), "Error in conv2D: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'"), assert("NHWC" === o, "Error in conv2d: got dataFormat of " + o + " but only NHWC is currently supported.");var p,
      d = computeConv2DInfo(l.shape, u.shape, n, a, r, i);if (1 !== d.filterHeight || 1 !== d.filterWidth || 1 !== d.dilationHeight || 1 !== d.dilationWidth || 1 !== d.strideHeight || 1 !== d.strideWidth || "SAME" !== d.padInfo.type && "VALID" !== d.padInfo.type) {
    p = ENV.engine.runKernel(function (e) {
      return e.conv2d(l, u, d);
    }, { x: l, $filter: u }, function (e) {
      return assert(tupleValuesAreOne(a), "Error in gradient of conv2D: dilation rates greater than 1 are notyet supported in gradients. Got dilations '" + a + "'"), { x: function x() {
          return conv2dDerInput_(l.shape, e, u, n, r);
        }, $filter: function $filter() {
          return conv2dDerFilter_(l, e, u.shape, n, r);
        } };
    });
  } else {
    var h = l.reshape([-1, d.inChannels]),
        f = u.reshape([d.inChannels, d.outChannels]);p = matMul(h, f).reshape(d.outShape);
  }return c ? p.as3D(p.shape[1], p.shape[2], p.shape[3]) : p;
}function conv2dDerInput_(e, t, n, r, o, a) {
  assert(e.length === t.rank, "Length of inShape (" + e.length + ") and rank of dy (" + t.rank + ") must match");var i = e,
      s = t,
      u = !1;3 === t.rank && (u = !0, s = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]), i = [1, e[0], e[1], e[2]]);var l = i[3],
      c = s.shape[3];assert(4 === i.length, "Error in conv2dDerInput: inShape must be length 4, but got length " + i.length + "."), assert(4 === s.rank, "Error in conv2dDerInput: dy must be rank 4, but got rank " + s.rank), assert(4 === n.rank, "Error in conv2dDerInput: filter must be rank 4, but got rank " + n.rank), assert(l === n.shape[2], "Error in conv2dDerInput: depth of input (" + l + ") must match input depth for filter " + n.shape[2] + "."), assert(c === n.shape[3], "Error in conv2dDerInput: depth of output (" + c + ") must match output depth for filter " + n.shape[3] + "."), null != a && assert(isInt(o), "Error in conv2dDerInput: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".");var p = computeConv2DInfo(i, n.shape, r, 1, o, a),
      d = ENV.engine.runKernel(function (e) {
    return e.conv2dDerInput(s, n, p);
  }, { dy4D: s, filter: n }, function (e) {
    return { dy4D: function dy4D() {
        return conv2d(e, n, r, o, "NHWC", 1, a);
      }, filter: function filter() {
        return conv2dDerFilter(e, s, n.shape, r, o, a);
      } };
  });return u ? d.as3D(d.shape[1], d.shape[2], d.shape[3]) : d;
}function conv2dDerFilter_(e, t, n, r, o, a) {
  var i = e;3 === e.rank && (i = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]));var s = t;3 === s.rank && (s = t.as4D(1, t.shape[0], t.shape[1], t.shape[2])), assert(4 === i.rank, "Error in conv2dDerFilter: input must be rank 4, but got shape " + i.shape + "."), assert(4 === s.rank, "Error in conv2dDerFilter: dy must be rank 4, but got shape " + s.shape + "."), assert(4 === n.length, "Error in conv2dDerFilter: filterShape must be length 4, but got " + n + "."), assert(i.shape[3] === n[2], "Error in conv2dDerFilter: depth of input " + i.shape[3] + ") must match input depth in filter (" + n[2] + "."), assert(s.shape[3] === n[3], "Error in conv2dDerFilter: depth of dy (" + s.shape[3] + ") must match output depth for filter (" + n[3] + ")."), null != a && assert(isInt(o), "Error in conv2dDerFilter: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".");var u = computeConv2DInfo(i.shape, n, r, 1, o, a);return ENV.engine.runKernel(function (e) {
    return e.conv2dDerFilter(i, s, u);
  }, { x4D: i, dy4D: s });
}function conv2dTranspose_(e, t, n, r, o, a) {
  return conv2dDerInput_(n, convertToTensor(e, "x", "conv2dTranspose"), convertToTensor(t, "filter", "conv2dTranspose"), r, o, a);
}function depthwiseConv2d_(e, t, n, r, o, a, i) {
  void 0 === o && (o = "NHWC"), void 0 === a && (a = [1, 1]);var s = convertToTensor(e, "x", "depthwiseConv2d"),
      u = convertToTensor(t, "filter", "depthwiseConv2d"),
      l = s,
      c = !1;3 === s.rank && (c = !0, l = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), assert(4 === l.rank, "Error in depthwiseConv2d: input must be rank 4, but got rank " + l.rank + "."), assert(4 === u.rank, "Error in depthwiseConv2d: filter must be rank 4, but got rank " + u.rank + "."), assert(l.shape[3] === u.shape[2], "Error in depthwiseConv2d: number of input channels (" + l.shape[3] + ") must match the inChannels dimension in filter " + u.shape[2] + "."), null == a && (a = [1, 1]), assert(eitherStridesOrDilationsAreOne(n, a), "Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'"), null != i && assert(isInt(r), "Error in depthwiseConv2d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + ".");var p = computeConv2DInfo(l.shape, u.shape, n, a, r, i, !0),
      d = ENV.engine.runKernel(function (e) {
    return e.depthwiseConv2D(l, u, p);
  }, { x: l, $filter: u }, function (e) {
    return assert(tupleValuesAreOne(a), "Error in gradient of depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '" + a + "'"), { x: function x() {
        return depthwiseConv2dDerInput(l.shape, e, u, p);
      }, $filter: function $filter() {
        return depthwiseConv2dDerFilter(l, e, u.shape, p);
      } };
  });return c ? d.as3D(d.shape[1], d.shape[2], d.shape[3]) : d;
}function separableConv2d_(e, t, n, r, o, a, i) {
  void 0 === a && (a = [1, 1]), void 0 === i && (i = "NHWC");var s = convertToTensor(e, "x", "separableConv2d"),
      u = convertToTensor(t, "depthwiseFilter", "separableConv2d"),
      l = convertToTensor(n, "pointwiseFilter", "separableConv2d"),
      c = s,
      p = !1;if (3 === s.rank && (p = !0, c = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), "NCHW" === i) throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");assert(4 === c.rank, "Error in separableConv2d: input must be rank 4, but got rank " + c.rank + "."), assert(4 === u.rank, "Error in separableConv2d: depthwise filter must be rank 4, but got rank " + u.rank + "."), assert(4 === l.rank, "Error in separableConv2d: pointwise filter must be rank 4, but got rank " + u.rank + "."), assert(1 === l.shape[0], "Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got " + l.shape[0] + "."), assert(1 === l.shape[1], "Error in separableConv2d: the second dimension of pointwise filter  must be 1, but got " + l.shape[1] + ".");var d = u.shape[2],
      h = u.shape[3];assert(l.shape[2] === d * h, "Error in separableConv2d: the third dimension of pointwise filter must be " + d * h + ", but got " + l.shape[2] + ".");var f = depthwiseConv2d(c, u, r, o, i, a),
      m = conv2d(f, l, 1, "valid", i);return p ? m.as3D(m.shape[1], m.shape[2], m.shape[3]) : m;
}function parseTupleParam$1(e) {
  return "number" == typeof e ? [e, e, e] : 2 === e.length ? [e[0], e[1], 1] : e;
}function tupleValuesAreOne$1(e) {
  var t = parseTupleParam$1(e),
      n = t[0],
      r = t[1],
      o = t[2];return 1 === n && 1 === r && 1 === o;
}function eitherStridesOrDilationsAreOne$1(e, t) {
  return tupleValuesAreOne$1(e) || tupleValuesAreOne$1(t);
}function depthwiseConv2dDerInput(e, t, n, r) {
  var o = t,
      a = !1;3 === t.rank && (a = !0, o = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]));var i = ENV.engine.runKernel(function (e) {
    return e.depthwiseConv2DDerInput(o, n, r);
  }, { dy4D: o });return a ? i.as3D(i.shape[1], i.shape[2], i.shape[3]) : i;
}function depthwiseConv2dDerFilter(e, t, n, r) {
  var o = e;3 === e.rank && (o = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]));var a = t;return 3 === a.rank && (a = t.as4D(1, t.shape[0], t.shape[1], t.shape[2])), ENV.engine.runKernel(function (e) {
    return e.depthwiseConv2DDerFilter(o, a, r);
  }, { x4D: o, dy4D: a });
}function conv3d_(e, t, n, r, o, a) {
  void 0 === o && (o = "NHWC"), void 0 === a && (a = [1, 1, 1]);var i = convertToTensor(e, "x", "conv3d"),
      s = convertToTensor(t, "filter", "conv3d"),
      u = i,
      l = !1;4 === i.rank && (l = !0, u = i.as5D(1, i.shape[0], i.shape[1], i.shape[2], i.shape[3])), assert(5 === u.rank, "Error in conv3d: input must be rank 5, but got rank " + u.rank + "."), assert(5 === s.rank, "Error in conv3d: filter must be rank 5, but got rank " + s.rank + "."), assert(u.shape[4] === s.shape[3], "Error in conv3d: depth of input (" + u.shape[4] + ") must match input depth for filter " + s.shape[3] + "."), assert(eitherStridesOrDilationsAreOne$1(n, a), "Error in conv3D: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'"), assert("NHWC" === o, "Error in conv3d: got dataFormat of " + o + " but only NHWC is currently supported.");var c = computeConv3DInfo(u.shape, s.shape, n, a, r),
      p = ENV.engine.runKernel(function (e) {
    return e.conv3d(u, s, c);
  }, { x: u, $filter: s }, function (e) {
    return assert(tupleValuesAreOne$1(a), "Error in gradient of conv3D: dilation rates greater than 1 are notyet supported in gradients. Got dilations '" + a + "'"), { x: function x() {
        return conv3dDerInput_(u.shape, e, s, n, r);
      }, $filter: function $filter() {
        return conv3dDerFilter_(u, e, s.shape, n, r);
      } };
  });return l ? p.as4D(p.shape[1], p.shape[2], p.shape[3], p.shape[4]) : p;
}function conv3dDerInput_(e, t, n, r, o) {
  assert(e.length === t.rank, "Length of inShape (" + e.length + ") and rank of dy (" + t.rank + ") must match");var a = e,
      i = t,
      s = !1;4 === t.rank && (s = !0, i = t.as5D(1, t.shape[0], t.shape[1], t.shape[2], t.shape[3]), a = [1, e[0], e[1], e[2], e[3]]);var u = a[4],
      l = i.shape[4];assert(5 === a.length, "Error in conv3dDerInput: inShape must be length 5, but got length " + a.length + "."), assert(5 === i.rank, "Error in conv3dDerInput: dy must be rank 5, but got rank " + i.rank), assert(5 === n.rank, "Error in conv3dDerInput: filter must be rank 5, but got rank " + n.rank), assert(u === n.shape[3], "Error in conv3dDerInput: depth of input (" + u + ") must match input depth for filter " + n.shape[3] + "."), assert(l === n.shape[4], "Error in conv3dDerInput: depth of output (" + l + ") must match output depth for filter " + n.shape[4] + ".");var c = computeConv3DInfo(a, n.shape, r, 1, o),
      p = ENV.engine.runKernel(function (e) {
    return e.conv3dDerInput(i, n, c);
  }, { dy5D: i });return s ? p.as4D(p.shape[1], p.shape[2], p.shape[3], p.shape[4]) : p;
}function conv3dDerFilter_(e, t, n, r, o) {
  var a = e;4 === e.rank && (a = e.as5D(1, e.shape[0], e.shape[1], e.shape[2], e.shape[3]));var i = t;4 === i.rank && (i = t.as5D(1, t.shape[0], t.shape[1], t.shape[2], t.shape[3])), assert(5 === a.rank, "Error in conv3dDerFilter: input must be rank 5, but got shape " + a.shape + "."), assert(5 === i.rank, "Error in conv3dDerFilter: dy must be rank 5, but got shape " + i.shape + "."), assert(5 === n.length, "Error in conv3dDerFilter: filterShape must be length 5, but got " + n + "."), assert(a.shape[4] === n[3], "Error in conv3dDerFilter: depth of input " + a.shape[4] + ") must match input depth in filter (" + n[3] + "."), assert(i.shape[4] === n[4], "Error in conv3dDerFilter: depth of dy (" + i.shape[4] + ") must match output depth for filter (" + n[4] + ").");var s = computeConv3DInfo(a.shape, n, r, 1, o);return ENV.engine.runKernel(function (e) {
    return e.conv3dDerFilter(a, i, s);
  }, { x5D: a, dy5D: i });
}var conv1d = op({ conv1d_: conv1d_ }),
    conv2d = op({ conv2d_: conv2d_ }),
    conv3d = op({ conv3d_: conv3d_ }),
    conv2dDerFilter = op({ conv2dDerFilter_: conv2dDerFilter_ }),
    depthwiseConv2d = op({ depthwiseConv2d_: depthwiseConv2d_ }),
    separableConv2d = op({ separableConv2d_: separableConv2d_ }),
    conv2dTranspose = op({ conv2dTranspose_: conv2dTranspose_ });function reverse1d_(e) {
  var t = convertToTensor(e, "x", "reverse");return assert(1 === t.rank, "Error in reverse1D: x must be rank 1 but got\n             rank " + t.rank + "."), reverse(t, 0);
}function reverse2d_(e, t) {
  var n = convertToTensor(e, "x", "reverse");return assert(2 === n.rank, "Error in reverse2D: x must be rank 2 but got\n             rank " + n.rank + "."), reverse(n, t);
}function reverse3d_(e, t) {
  var n = convertToTensor(e, "x", "reverse");return assert(3 === n.rank, "Error in reverse3D: x must be rank 3 but got\n             rank " + n.rank + "."), reverse(n, t);
}function reverse4d_(e, t) {
  var n = convertToTensor(e, "x", "reverse");return assert(4 === n.rank, "Error in reverse4D: x must be rank 4 but got\n             rank " + n.rank + "."), reverse(n, t);
}function reverse_(e, t) {
  var n = convertToTensor(e, "x", "reverse");if (0 === n.rank) return n.clone();var r = parseAxisParam(t, n.shape);return ENV.engine.runKernel(function (e) {
    return e.reverse(n, r);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return e.reverse(r);
      } };
  }).reshapeAs(n);
}var reverse = op({ reverse_: reverse_ }),
    reverse1d = op({ reverse1d_: reverse1d_ }),
    reverse2d = op({ reverse2d_: reverse2d_ }),
    reverse3d = op({ reverse3d_: reverse3d_ }),
    reverse4d = op({ reverse4d_: reverse4d_ });function maxPoolImpl_(e, t, n, r, o, a) {
  var i = convertToTensor(e, "x", "maxPool"),
      s = i,
      u = !1;3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), null == r && (r = [1, 1]), assert(4 === s.rank, "Error in maxPool: input must be rank 4 but got rank " + s.rank + "."), assert(eitherStridesOrDilationsAreOne(n, r), "Error in maxPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'"), null != a && assert(isInt(o), "Error in maxPool: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".");var l = computePool2DInfo(s.shape, t, n, r, o, a),
      c = ENV.engine.runKernel(function (e, t) {
    return t(e.maxPool(s, l));
  }, { x: s }, function (e, a) {
    var i = a[0];return { x: function x() {
        return maxPoolBackprop(e, s, i, t, n, r, o);
      } };
  });return u ? c.as3D(c.shape[1], c.shape[2], c.shape[3]) : c;
}function maxPool_(e, t, n, r, o) {
  return maxPoolImpl_(e, t, n, 1, r, o);
}function avgPoolImpl_(e, t, n, r, o, a) {
  var i = convertToTensor(e, "x", "avgPool", "float32");null == r && (r = [1, 1]), assert(eitherStridesOrDilationsAreOne(n, r), "Error in avgPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'");var s = i,
      u = !1;3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), assert(4 === s.rank, "Error in avgPool: x must be rank 4 but got rank " + s.rank + "."), null != a && assert(isInt(o), "Error in avgPool: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".");var l = computePool2DInfo(s.shape, t, n, r, o, a),
      c = ENV.engine.runKernel(function (e) {
    return e.avgPool(s, l);
  }, { x: s }, function (e) {
    return { x: function x() {
        return avgPoolBackprop(e, s, t, n, r, o);
      } };
  });return c = c.cast(i.dtype), u ? c.as3D(c.shape[1], c.shape[2], c.shape[3]) : c;
}function avgPool_(e, t, n, r, o) {
  return avgPoolImpl_(e, t, n, 1, r, o);
}function pool_(e, t, n, r, o, a) {
  null == o && (o = [1, 1]), null == a && (a = 1), 0 === r && (r = "valid");var i = convertToTensor(e, "x", "maxPool"),
      s = i,
      u = !1;3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), assert(eitherStridesOrDilationsAreOne(a, o), "Error in pool: Either strides or dilations must be 1. Got strides " + a + " and dilations '" + o + "'");var l,
      c = computePool2DInfo(s.shape, t, a, o, r),
      p = [c.dilationHeight, c.dilationWidth];l = "same" === r ? withSpaceToBatchBasePaddings([c.filterHeight, c.filterWidth], p) : [[0, 0], [0, 0]];var d = 1 === p[0] && 1 === p[1],
      h = requiredSpaceToBatchPaddings([c.inHeight, c.inWidth], p, l),
      f = h[0],
      m = h[1],
      g = d ? r : "valid",
      v = d ? s : spaceToBatchND(s, p, f),
      y = ("avg" === n ? function () {
    return avgPoolImpl_(v, t, a, 1, g);
  } : function () {
    return maxPoolImpl_(v, t, a, 1, g);
  })(),
      x = d ? y : batchToSpaceND(y, p, m);return u ? x.as3D(x.shape[1], x.shape[2], x.shape[3]) : x;
}function maxPoolBackprop(e, t, n, r, o, a, i, s) {
  var u = convertToTensor(e, "dy", "maxPoolBackprop"),
      l = convertToTensor(t, "input", "maxPoolBackprop"),
      c = convertToTensor(n, "output", "maxPoolBackprop");assert(l.rank === u.rank, "Rank of input (" + l.rank + ") does not match rank of dy (" + u.rank + ")"), null == a && (a = [1, 1]), assert(eitherStridesOrDilationsAreOne(o, a), "Error in maxPoolBackProp: Either strides or dilations must be 1. Got strides " + o + " and dilations '" + a + "'"), assert(4 === u.rank, "Error in maxPoolBackprop: dy must be rank 4 but got rank " + u.rank + "."), assert(4 === l.rank, "Error in maxPoolBackprop: input must be rank 4 but got rank " + l.rank + "."), null != s && assert(isInt(i), "Error in maxPoolBackprop: pad must be an integer when using, dimRoundingMode " + s + " but got pad " + i + ".");var p = computePool2DInfo(l.shape, r, o, a, i, s);return ENV.engine.runKernel(function (e) {
    return e.maxPoolBackprop(u, l, c, p);
  }, { $dy: u, $input: l });
}function avgPoolBackprop(e, t, n, r, o, a) {
  var i = convertToTensor(e, "dy", "avgPoolBackprop"),
      s = convertToTensor(t, "input", "avgPoolBackprop");assert(s.rank === i.rank, "Rank of input (" + s.rank + ") does not match rank of dy (" + i.rank + ")"), null == o && (o = [1, 1]), assert(eitherStridesOrDilationsAreOne(r, o), "Error in avgPoolBackprop: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + o + "'");var u = s,
      l = i,
      c = !1;3 === s.rank && (c = !0, u = s.as4D(1, s.shape[0], s.shape[1], s.shape[2]), l = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), assert(4 === l.rank, "Error in avgPoolBackprop: dy must be rank 4 but got rank " + l.rank + "."), assert(4 === u.rank, "Error in avgPoolBackprop: input must be rank 4 but got rank " + u.rank + ".");var p = computePool2DInfo(u.shape, n, r, o, a),
      d = ENV.engine.runKernel(function (e) {
    return e.avgPoolBackprop(l, u, p);
  }, { dy4D: l, input4D: u });return c ? d.as3D(d.shape[1], d.shape[2], d.shape[3]) : d;
}function requiredSpaceToBatchPaddings(e, t, n) {
  var r = n.map(function (e) {
    return e[0];
  }),
      o = n.map(function (e) {
    return e[1];
  }),
      a = e.concat(r, o),
      i = t.map(function (e, t) {
    return (e - a[t] % e) % e;
  }),
      s = o.map(function (e, t) {
    return e + i[t];
  });return [t.map(function (e, t) {
    return [r[t], s[t]];
  }), t.map(function (e, t) {
    return [0, i[t]];
  })];
}function withSpaceToBatchBasePaddings(e, t) {
  var n = e.map(function (e, n) {
    return e + (e - 1) * (t[n] - 1);
  }).map(function (e) {
    return e - 1;
  }),
      r = n.map(function (e) {
    return Math.floor(e / 2);
  }),
      o = n.map(function (e, t) {
    return e - r[t];
  });return n.map(function (e, t) {
    return [r[t], o[t]];
  });
}var maxPool = op({ maxPool_: maxPool_ }),
    avgPool = op({ avgPool_: avgPool_ }),
    pool = op({ pool_: pool_ });function slice1d_(e, t, n) {
  var r = convertToTensor(e, "x", "slice1d");return assert(1 === r.rank, "slice1d expects a rank-1 tensor, but got a rank-" + r.rank + " tensor"), slice(r, [t], [n]);
}function slice2d_(e, t, n) {
  var r = convertToTensor(e, "x", "slice2d");return assert(2 === r.rank, "slice2d expects a rank-2 tensor, but got a rank-" + r.rank + " tensor"), slice(r, t, n);
}function slice3d_(e, t, n) {
  var r = convertToTensor(e, "x", "slice3d");return assert(3 === r.rank, "slice3d expects a rank-3 tensor, but got a rank-" + r.rank + " tensor"), slice(r, t, n);
}function slice4d_(e, t, n) {
  var r = convertToTensor(e, "x", "slice4d");return assert(4 === r.rank, "slice4d expects a rank-4 tensor, but got a rank-" + r.rank + " tensor"), slice(r, t, n);
}function slice_(e, t, n) {
  var r,
      o,
      a = convertToTensor(e, "x", "slice");if (0 === a.rank) throw new Error("Slicing scalar is not possible");r = "number" == typeof t ? [t].concat(new Array(a.rank - 1).fill(0)) : t.length < a.rank ? t.concat(new Array(a.rank - t.length).fill(0)) : t.slice(), o = (o = null == n ? new Array(a.rank).fill(-1) : "number" == typeof n ? [n].concat(new Array(a.rank - 1).fill(-1)) : n.length < a.rank ? n.concat(new Array(a.rank - n.length).fill(-1)) : n).map(function (e, t) {
    return e >= 0 ? e : (assert(-1 === e, "Bad value in size"), a.shape[t] - r[t]);
  }), assertParamsValid(a, r, o);var i = a.shape;return ENV.engine.runKernel(function (e) {
    return e.slice(a, r, o);
  }, { $x: a }, function (e) {
    for (var t = [], n = 0; n < e.rank; n++) {
      t.push([r[n], i[n] - r[n] - o[n]]);
    }return { $x: function $x() {
        return e.pad(t);
      } };
  });
}var slice = op({ slice_: slice_ }),
    slice1d = op({ slice1d_: slice1d_ }),
    slice2d = op({ slice2d_: slice2d_ }),
    slice3d = op({ slice3d_: slice3d_ }),
    slice4d = op({ slice4d_: slice4d_ });function logSumExp_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "logSumExp"),
      o = parseAxisParam(t, r.shape),
      a = r.max(o, !0),
      i = r.sub(a).exp().sum(o).log(),
      s = a.reshape(i.shape).add(i);if (n) {
    var u = expandShapeToKeepDim(s.shape, o);return s.reshape(u);
  }return s;
}function sum_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "sum");"bool" === r.dtype && (r = r.toInt());var o = parseAxisParam(t, r.shape);return customGrad(function (e) {
    var t = getAxesPermutation(o, e.rank),
        r = o,
        a = e;null != t && (a = e.transpose(t), r = getInnerMostAxes(r.length, e.rank));var i = ENV.engine.runKernel(function (e) {
      return e.sum(a, r);
    }, { permutedX: a });if (n) {
      var s = expandShapeToKeepDim(i.shape, o);i = i.reshape(s);
    }return { value: i, gradFunc: function gradFunc(t) {
        var n = e.shape.slice();return o.forEach(function (e) {
          n[e] = 1;
        }), t.reshape(n).mul(ones$1(e.shape, "float32"));
      } };
  })(r);
}function prod_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "prod");"bool" === r.dtype && (r = r.toInt());var o = parseAxisParam(t, r.shape),
      a = getAxesPermutation(o, r.rank),
      i = o,
      s = r;null != a && (s = r.transpose(a), i = getInnerMostAxes(i.length, r.rank));var u = ENV.engine.runKernel(function (e) {
    return e.prod(s, i);
  }, { permutedX: s });if (n) {
    var l = expandShapeToKeepDim(u.shape, o);u = u.reshape(l);
  }return u;
}function mean_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "mean"),
      o = parseAxisParam(t, r.shape),
      a = sizeFromShape(computeOutAndReduceShapes(r.shape, o)[1]);return customGrad(function (e) {
    var r = scalar(a);return { value: (r.dtype === e.dtype ? e : e.cast(r.dtype)).div(r).sum(t, n), gradFunc: function gradFunc(t) {
        var n = e.shape.slice();return o.forEach(function (e) {
          n[e] = 1;
        }), t.reshape(n).mul(ones$1(e.shape, "float32")).div(r);
      } };
  })(r);
}function gradForMinAndMax(e, t, n, r, o) {
  var a = t[0];return a.rank < n.rank && (a = a.reshape(expandShapeToKeepDim(a.shape, r))), e.rank < n.rank && (e = e.reshape(expandShapeToKeepDim(e.shape, r))), { $x: function $x() {
      var t = e.mul(n.equal(a).cast(e.dtype));return null == o ? t : t.transpose(o);
    } };
}function min_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "min"),
      o = r,
      a = parseAxisParam(t, r.shape),
      i = a,
      s = getAxesPermutation(i, r.rank);null != s && (r = r.transpose(s), i = getInnerMostAxes(i.length, r.rank));var u = ENV.engine.runKernel(function (e, t) {
    return t(e.min(r, i));
  }, { $x: r }, function (e, t) {
    return gradForMinAndMax(e, t, o, a, s);
  });if (n) {
    var l = expandShapeToKeepDim(u.shape, a);u = u.reshape(l);
  }return u;
}function max_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "max"),
      o = r,
      a = parseAxisParam(t, r.shape),
      i = a,
      s = getAxesPermutation(i, r.rank);null != s && (r = r.transpose(s), i = getInnerMostAxes(i.length, r.rank));var u = ENV.engine.runKernel(function (e, t) {
    return t(e.max(r, i));
  }, { $x: r }, function (e, t) {
    return gradForMinAndMax(e, t, o, a, s);
  });if (n) {
    var l = expandShapeToKeepDim(u.shape, a);u = u.reshape(l);
  }return u;
}function argMin_(e, t) {
  void 0 === t && (t = 0);var n = convertToTensor(e, "x", "argMin");null == t && (t = 0);var r = parseAxisParam(t, n.shape),
      o = getAxesPermutation(r, n.rank);null != o && (n = n.transpose(o), r = getInnerMostAxes(r.length, n.rank));return ENV.engine.runKernel(function (e) {
    return e.argMin(n, r[0]);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return zerosLike(n);
      } };
  });
}function argMax_(e, t) {
  void 0 === t && (t = 0);var n = convertToTensor(e, "x", "argMax");null == t && (t = 0);var r = parseAxisParam(t, n.shape),
      o = getAxesPermutation(r, n.rank);null != o && (n = n.transpose(o), r = getInnerMostAxes(r.length, n.rank));return ENV.engine.runKernel(function (e) {
    return e.argMax(n, r[0]);
  }, { $x: n }, function (e) {
    return { $x: function $x() {
        return zerosLike(n);
      } };
  });
}function all_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "all", "bool"),
      o = parseAxisParam(t, r.shape),
      a = o,
      i = getAxesPermutation(a, r.rank);null != i && (r = r.transpose(i), a = getInnerMostAxes(a.length, r.rank));var s = ENV.engine.runKernel(function (e) {
    return e.all(r, a);
  }, { $x: r });if (n) {
    var u = expandShapeToKeepDim(s.shape, o);return s.reshape(u);
  }return s;
}function any_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = convertToTensor(e, "x", "any", "bool"),
      o = parseAxisParam(t, r.shape),
      a = o,
      i = getAxesPermutation(a, r.rank);null != i && (r = r.transpose(i), a = getInnerMostAxes(a.length, r.rank));var s = ENV.engine.runKernel(function (e) {
    return e.any(r, a);
  }, { $x: r });if (n) {
    var u = expandShapeToKeepDim(s.shape, o);return s.reshape(u);
  }return s;
}function moments_(e, t, n) {
  void 0 === t && (t = null), void 0 === n && (n = !1);var r = parseAxisParam(t, (e = convertToTensor(e, "x", "moments")).shape),
      o = e.mean(r, n),
      a = o.shape;return n || (a = expandShapeToKeepDim(o.shape, r)), { mean: o, variance: e.toFloat().sub(o.reshape(a)).square().mean(r, n) };
}var all = op({ all_: all_ }),
    any = op({ any_: any_ }),
    argMax = op({ argMax_: argMax_ }),
    argMin = op({ argMin_: argMin_ }),
    logSumExp = op({ logSumExp_: logSumExp_ }),
    max = op({ max_: max_ }),
    mean = op({ mean_: mean_ }),
    min = op({ min_: min_ }),
    moments = op({ moments_: moments_ }),
    sum$1 = op({ sum_: sum_ }),
    prod = op({ prod_: prod_ });function notEqual_(e, t) {
  var n,
      r = convertToTensor(e, "a", "notEqual"),
      o = convertToTensor(t, "b", "notEqual");return n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape), ENV.engine.runKernel(function (e) {
    return e.notEqual(r, o);
  }, { $a: r, $b: o });
}function notEqualStrict_(e, t) {
  var n = convertToTensor(e, "a", "notEqualStrict"),
      r = convertToTensor(t, "b", "notEqualStrict");return assertShapesMatch(n.shape, r.shape, "Error in notEqualStrict: "), n.notEqual(r);
}function less_(e, t) {
  var n,
      r = convertToTensor(e, "a", "less"),
      o = convertToTensor(t, "b", "less");return n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape), ENV.engine.runKernel(function (e) {
    return e.less(r, o);
  }, { $a: r, $b: o });
}function lessStrict_(e, t) {
  var n = convertToTensor(e, "a", "lessStrict"),
      r = convertToTensor(t, "b", "lessStrict");return assertShapesMatch(n.shape, r.shape, "Error in lessStrict: "), n.less(r);
}function equal_(e, t) {
  var n,
      r = convertToTensor(e, "a", "equal"),
      o = convertToTensor(t, "b", "equal");return n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape), ENV.engine.runKernel(function (e) {
    return e.equal(r, o);
  }, { $a: r, $b: o });
}function equalStrict_(e, t) {
  var n = convertToTensor(e, "a", "equalStrict"),
      r = convertToTensor(t, "b", "equalStrict");return assertShapesMatch(n.shape, r.shape, "Error in equalStrict: "), n.equal(r);
}function lessEqual_(e, t) {
  var n,
      r = convertToTensor(e, "a", "lessEqual"),
      o = convertToTensor(t, "b", "lessEqual");return n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape), ENV.engine.runKernel(function (e) {
    return e.lessEqual(r, o);
  }, { $a: r, $b: o });
}function lessEqualStrict_(e, t) {
  var n = convertToTensor(e, "a", "lessEqualStrict"),
      r = convertToTensor(t, "b", "lessEqualStrict");return assertShapesMatch(n.shape, r.shape, "Error in lessEqualStrict: "), n.lessEqual(r);
}function greater_(e, t) {
  var n,
      r = convertToTensor(e, "a", "greater"),
      o = convertToTensor(t, "b", "greater");return n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape), ENV.engine.runKernel(function (e) {
    return e.greater(r, o);
  }, { $a: r, $b: o });
}function greaterStrict_(e, t) {
  var n = convertToTensor(e, "a", "greaterStrict"),
      r = convertToTensor(t, "b", "greaterStrict");return assertShapesMatch(n.shape, r.shape, "Error in greaterStrict: "), n.greater(r);
}function greaterEqual_(e, t) {
  var n,
      r = convertToTensor(e, "a", "greaterEqual"),
      o = convertToTensor(t, "b", "greaterEqual");n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.greaterEqual(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        return zerosLike(r);
      }, $b: function $b() {
        return zerosLike(o);
      } };
  });
}function greaterEqualStrict_(e, t) {
  var n = convertToTensor(e, "a", "greaterEqualStrict"),
      r = convertToTensor(t, "b", "greaterEqualStrict");return assertShapesMatch(n.shape, r.shape, "Error in greaterEqualStrict: "), n.greaterEqual(r);
}var equal = op({ equal_: equal_ }),
    equalStrict = op({ equalStrict_: equalStrict_ }),
    greater = op({ greater_: greater_ }),
    greaterEqual = op({ greaterEqual_: greaterEqual_ }),
    greaterEqualStrict = op({ greaterEqualStrict_: greaterEqualStrict_ }),
    greaterStrict = op({ greaterStrict_: greaterStrict_ }),
    less = op({ less_: less_ }),
    lessEqual = op({ lessEqual_: lessEqual_ }),
    lessEqualStrict = op({ lessEqualStrict_: lessEqualStrict_ }),
    lessStrict = op({ lessStrict_: lessStrict_ }),
    notEqual = op({ notEqual_: notEqual_ }),
    notEqualStrict = op({ notEqualStrict_: notEqualStrict_ });function add_(e, t) {
  var n,
      r = convertToTensor(e, "a", "add"),
      o = convertToTensor(t, "b", "add");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.add(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = e,
            n = getReductionAxes(r.shape, a);return n.length > 0 && (t = t.sum(n)), t.reshape(r.shape);
      }, $b: function $b() {
        var t = e,
            n = getReductionAxes(o.shape, a);return n.length > 0 && (t = t.sum(n)), t.reshape(o.shape);
      } };
  });
}function addN_(e) {
  assert(Array.isArray(e), function () {
    return "The argument passed to tf.addN() must be a list of tensors";
  }), assert(e.length >= 1, function () {
    return "Must pass at least one tensor to tf.addN(), but got " + e.length;
  });var t = e.map(function (e, t) {
    return convertToTensor(e, "tensors" + t, "addN");
  }),
      n = t[0];t.forEach(function (e) {
    if (e.dtype !== n.dtype) throw new Error("All tensors passed to tf.addN() must have the same dtype");
  }), t.forEach(function (e) {
    if (!arraysEqual(e.shape, n.shape)) throw new Error("All tensors passed to tf.addN() must have the same shape");
  });var r = t;return ENV.engine.runKernel(function (e) {
    return e.addN(t);
  }, r, function (e) {
    var n = {};return t.forEach(function (t, r) {
      n[r] = function () {
        return e.clone();
      };
    }), n;
  });
}function addStrict_(e, t) {
  var n = convertToTensor(e, "a", "addStrict"),
      r = convertToTensor(t, "b", "addStrict");return assertShapesMatch(n.shape, r.shape, "Error in addStrict: "), n.add(r);
}function sub_(e, t) {
  var n,
      r = convertToTensor(e, "a", "sub"),
      o = convertToTensor(t, "b", "sub");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.subtract(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = e,
            n = getReductionAxes(r.shape, a);return n.length > 0 && (t = t.sum(n)), t.reshape(r.shape);
      }, $b: function $b() {
        var t = e,
            n = getReductionAxes(o.shape, a);return n.length > 0 && (t = t.sum(n)), t.neg().reshape(o.shape);
      } };
  });
}function subStrict_(e, t) {
  var n = convertToTensor(e, "a", "subStrict"),
      r = convertToTensor(t, "b", "subStrict");return assertShapesMatch(n.shape, r.shape, "Error in subStrict: "), n.sub(r);
}function pow_(e, t) {
  var n = convertToTensor(e, "base", "pow"),
      r = convertToTensor(t, "exp", "pow"),
      o = assertAndGetBroadcastShape(n.shape, r.shape);e = n.cast(upcastType(n.dtype, r.dtype)), t = r.cast(upcastType(n.dtype, r.dtype));return ENV.engine.runKernel(function (e, t) {
    return t(e.pow(n, r));
  }, { $base: n, $exp: r }, function (e, t) {
    var a = t[0];return { $base: function $base() {
        var t = r.toFloat(),
            a = e.mul(t.mul(n.pow(t.sub(scalar(1))))),
            i = getReductionAxes(n.shape, o);return i.length > 0 && (a = a.sum(i)), a.reshape(n.shape);
      }, $exp: function $exp() {
        var t = n.greater(0),
            i = n.log().where(t, zerosLike(n)),
            s = e.mul(a.mul(i)),
            u = getReductionAxes(r.shape, o);return u.length > 0 && (s = s.sum(u)), s.reshape(r.shape);
      } };
  });
}function powStrict_(e, t) {
  return assertShapesMatch(e.shape, t.shape, "Error in powStrict: "), e.pow(t);
}function mul_(e, t) {
  var n,
      r = convertToTensor(e, "a", "mul"),
      o = convertToTensor(t, "b", "mul");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.multiply(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = e.mul(o.toFloat()),
            n = getReductionAxes(r.shape, a);return n.length > 0 ? t.sum(n).reshape(r.shape) : t;
      }, $b: function $b() {
        var t = e.mul(r.toFloat()),
            n = getReductionAxes(o.shape, a);return n.length > 0 ? t.sum(n).reshape(o.shape) : t;
      } };
  });
}function mulStrict_(e, t) {
  var n = convertToTensor(e, "a", "mul"),
      r = convertToTensor(t, "b", "mul");return assertShapesMatch(n.shape, r.shape, "Error in multiplyStrict: "), n.mul(r);
}function div_(e, t) {
  var n,
      r,
      o = convertToTensor(e, "a", "div"),
      a = convertToTensor(t, "b", "div");if (n = makeTypesMatch(o, a), o = n[0], a = n[1], "int32" === o.dtype && "int32" === a.dtype) return floorDiv(o, a);r = function r(e) {
    return e.realDivide(o, a);
  };var i = assertAndGetBroadcastShape(o.shape, a.shape);return ENV.engine.runKernel(r, { $a: o, $b: a }, function (e) {
    return { $a: function $a() {
        var t = e.div(a.toFloat()),
            n = getReductionAxes(o.shape, i);return n.length > 0 ? t.sum(n).reshape(o.shape) : t;
      }, $b: function $b() {
        var t = e.mul(o.toFloat()),
            n = getReductionAxes(a.shape, i);n.length > 0 && (t = t.sum(n).reshape(a.shape));var r = a.square();return t.div(r.toFloat()).neg();
      } };
  });
}function floorDiv_(e, t) {
  var n,
      r = convertToTensor(e, "a", "floorDiv"),
      o = convertToTensor(t, "b", "floorDiv");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.floorDiv(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = e.div(o.toFloat()),
            n = getReductionAxes(r.shape, a);return n.length > 0 ? t.sum(n).reshape(r.shape) : t;
      }, $b: function $b() {
        var t = e.mul(r.toFloat()),
            n = getReductionAxes(o.shape, a);n.length > 0 && (t = t.sum(n).reshape(o.shape));var i = o.square();return t.div(i.toFloat()).neg();
      } };
  });
}function divStrict_(e, t) {
  var n = convertToTensor(e, "a", "div"),
      r = convertToTensor(t, "b", "div");return assertShapesMatch(n.shape, r.shape, "Error in divideStrict: "), n.div(r);
}function mod_(e, t) {
  var n,
      r = convertToTensor(e, "a", "mod"),
      o = convertToTensor(t, "b", "mod");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.mod(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = getReductionAxes(r.shape, a);return t.length > 0 ? e.sum(t).reshape(r.shape) : e;
      }, $b: function $b() {
        var t = e.mul(r.div(o).floor().neg()),
            n = getReductionAxes(o.shape, a);return n.length > 0 ? t.sum(n).reshape(o.shape) : t;
      } };
  });
}function modStrict_(e, t) {
  var n = convertToTensor(e, "a", "modStrict"),
      r = convertToTensor(t, "b", "modStrict");return assertShapesMatch(n.shape, r.shape, "Error in modStrict: "), n.mod(r);
}function minimum_(e, t) {
  var n,
      r = convertToTensor(e, "a", "minimum"),
      o = convertToTensor(t, "b", "minimum");n = makeTypesMatch(r, o), r = n[0], o = n[1], "bool" === r.dtype && (r = r.toInt(), o = o.toInt()), assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.minimum(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        return e.mul(r.lessEqual(o).toFloat());
      }, $b: function $b() {
        return e.mul(r.greater(o).toFloat());
      } };
  });
}function minimumStrict_(e, t) {
  var n = convertToTensor(e, "a", "minimumStrict"),
      r = convertToTensor(t, "b", "minimumStrict");return assertShapesMatch(n.shape, r.shape, "Error in minimumStrict: "), n.minimum(r);
}function maximum_(e, t) {
  var n,
      r = convertToTensor(e, "a", "maximum"),
      o = convertToTensor(t, "b", "maximum");n = makeTypesMatch(r, o), r = n[0], o = n[1], "bool" === r.dtype && (r = r.toInt(), o = o.toInt()), assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.maximum(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        return e.mul(r.greaterEqual(o).toFloat());
      }, $b: function $b() {
        return e.mul(r.less(o).toFloat());
      } };
  });
}function maximumStrict_(e, t) {
  var n = convertToTensor(e, "a", "maximumStrict"),
      r = convertToTensor(t, "b", "maximumStrict");return assertShapesMatch(n.shape, r.shape, "Error in maximumStrict: "), n.maximum(r);
}function squaredDifference_(e, t) {
  var n,
      r = convertToTensor(e, "a", "squaredDifference"),
      o = convertToTensor(t, "b", "squaredDifference");n = makeTypesMatch(r, o), r = n[0], o = n[1], assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.squaredDifference(r, o);
  }, { $a: r, $b: o }, function (e) {
    var t = scalar(2);return { $a: function $a() {
        return e.mul(r.sub(o).mul(t));
      }, $b: function $b() {
        return e.mul(o.sub(r).mul(t));
      } };
  });
}function squaredDifferenceStrict_(e, t) {
  var n = convertToTensor(e, "a", "squaredDifferenceStrict"),
      r = convertToTensor(t, "b", "squaredDifferenceStrict");return assertShapesMatch(n.shape, r.shape, "Error in squaredDifferenceStrict: "), n.squaredDifference(r);
}function atan2_(e, t) {
  var n,
      r = convertToTensor(e, "a", "atan2"),
      o = convertToTensor(t, "b", "atan2");n = makeTypesMatch(r, o), r = n[0], o = n[1];var a = assertAndGetBroadcastShape(r.shape, o.shape);return ENV.engine.runKernel(function (e) {
    return e.atan2(r, o);
  }, { $a: r, $b: o }, function (e) {
    return { $a: function $a() {
        var t = add(r.square(), o.square()),
            n = e.mul(o.div(t)),
            i = getReductionAxes(r.shape, a);return i.length > 0 && (n = n.sum(i)), n.reshape(r.shape);
      }, $b: function $b() {
        var t = add(r.square(), o.square()),
            n = neg(e.mul(r.div(t))),
            i = getReductionAxes(o.shape, a);return i.length > 0 && (n = n.sum(i)), n.reshape(o.shape);
      } };
  });
}var add = op({ add_: add_ }),
    addN = op({ addN_: addN_ }),
    addStrict = op({ addStrict_: addStrict_ }),
    atan2 = op({ atan2_: atan2_ }),
    div = op({ div_: div_ }),
    divStrict = op({ divStrict_: divStrict_ }),
    floorDiv = op({ floorDiv_: floorDiv_ }),
    maximum = op({ maximum_: maximum_ }),
    maximumStrict = op({ maximumStrict_: maximumStrict_ }),
    minimum = op({ minimum_: minimum_ }),
    minimumStrict = op({ minimumStrict_: minimumStrict_ }),
    mod = op({ mod_: mod_ }),
    modStrict = op({ modStrict_: modStrict_ }),
    mul = op({ mul_: mul_ }),
    mulStrict = op({ mulStrict_: mulStrict_ }),
    pow = op({ pow_: pow_ }),
    powStrict = op({ powStrict_: powStrict_ }),
    squaredDifference = op({ squaredDifference_: squaredDifference_ }),
    squaredDifferenceStrict = op({ squaredDifferenceStrict_: squaredDifferenceStrict_ }),
    sub = op({ sub_: sub_ }),
    subStrict = op({ subStrict_: subStrict_ });function logicalNot_(e) {
  var t = convertToTensor(e, "x", "logicalNot", "bool");return ENV.engine.runKernel(function (e) {
    return e.logicalNot(t);
  }, { $x: t });
}function logicalAnd_(e, t) {
  var n = convertToTensor(e, "a", "logicalAnd", "bool"),
      r = convertToTensor(t, "b", "logicalAnd", "bool");return assertAndGetBroadcastShape(n.shape, r.shape), ENV.engine.runKernel(function (e) {
    return e.logicalAnd(n, r);
  }, { $a: n, $b: r });
}function logicalOr_(e, t) {
  var n = convertToTensor(e, "a", "logicalOr", "bool"),
      r = convertToTensor(t, "b", "logicalOr", "bool");return assertAndGetBroadcastShape(n.shape, r.shape), ENV.engine.runKernel(function (e) {
    return e.logicalOr(n, r);
  }, { $a: n, $b: r });
}function logicalXor_(e, t) {
  var n = convertToTensor(e, "a", "logicalXor", "bool"),
      r = convertToTensor(t, "b", "logicalXor", "bool");return assertAndGetBroadcastShape(n.shape, r.shape), logicalOr(e, t).logicalAnd(logicalAnd(e, t).logicalNot());
}function where_(e, t, n) {
  var r = convertToTensor(t, "a", "where"),
      o = convertToTensor(n, "b", "where"),
      a = convertToTensor(e, "condition", "where", "bool");assertShapesMatch(r.shape, o.shape, "Error in where: "), 1 === a.rank ? assert(a.shape[0] === r.shape[0], "The first dimension of `a` must match the size of `condition`.") : assertShapesMatch(a.shape, o.shape, "Error in where: ");return ENV.engine.runKernel(function (e) {
    return e.select(a, r, o);
  }, { $condition: a, $a: r, $b: o }, function (e) {
    return { $condition: function $condition() {
        return zerosLike(a).toFloat();
      }, $a: function $a() {
        return e.mul(a.cast(e.dtype));
      }, $b: function $b() {
        return e.mul(a.logicalNot().cast(e.dtype));
      } };
  });
}function whereAsync_(e) {
  return __awaiter(this, void 0, void 0, function () {
    var t, n, r;return __generator(this, function (o) {
      switch (o.label) {case 0:
          return [4, (t = convertToTensor(e, "condition", "whereAsync", "bool")).data()];case 1:
          return n = o.sent(), r = whereImpl(t.shape, n), e !== t && t.dispose(), [2, r];}
    });
  });
}var logicalAnd = op({ logicalAnd_: logicalAnd_ }),
    logicalNot = op({ logicalNot_: logicalNot_ }),
    logicalOr = op({ logicalOr_: logicalOr_ }),
    logicalXor = op({ logicalXor_: logicalXor_ }),
    where = op({ where_: where_ }),
    whereAsync = whereAsync_;function relu_(e) {
  var t = convertToTensor(e, "x", "relu");if ("bool" === t.dtype) return t.toInt();return ENV.engine.runKernel(function (e) {
    return e.relu(t);
  }, { $x: t }, function (e) {
    var n = t.step();return { $x: function $x() {
        return e.mulStrict(n.toFloat());
      } };
  });
}function elu_(e) {
  var t = convertToTensor(e, "x", "elu");return ENV.engine.runKernel(function (e, n) {
    return n(e.elu(t));
  }, { $x: t }, function (e, t) {
    var n = t[0];return { $x: function $x() {
        return ENV.engine.runKernel(function (t) {
          return t.eluDer(e, n);
        }, { dy: e, y: n });
      } };
  });
}function selu_(e) {
  var t = convertToTensor(e, "x", "selu");return ENV.engine.runKernel(function (e) {
    return e.selu(t);
  }, { $x: t }, function (e) {
    return { $x: function $x() {
        var n = t.greater(scalar(0)),
            r = scalar(SELU_SCALEALPHA),
            o = scalar(SELU_SCALE),
            a = e.mul(o),
            i = e.mul(r).mul(t.toFloat().exp());return where(n, a, i);
      } };
  });
}function leakyRelu_(e, t) {
  void 0 === t && (t = .2);var n = convertToTensor(e, "x", "leakyRelu");return maximum(scalar(t).mul(n), n);
}function prelu_(e, t) {
  var n = convertToTensor(e, "x", "prelu"),
      r = convertToTensor(t, "alpha", "prelu");return ENV.engine.runKernel(function (e) {
    return e.prelu(n, r);
  }, { $x: n, $alpha: r }, function (e) {
    var t = n.greater(0);return { $x: function $x() {
        return where(t, e, e.mul(r));
      }, $alpha: function $alpha() {
        var o = where(t, zerosLike(e), e.mul(n)),
            a = getReductionAxes(r.shape, e.shape);return a.length > 0 && (o = o.sum(a)), o.reshape(r.shape);
      } };
  });
}var elu = op({ elu_: elu_ }),
    leakyRelu = op({ leakyRelu_: leakyRelu_ }),
    prelu = op({ prelu_: prelu_ }),
    relu = op({ relu_: relu_ }),
    selu = op({ selu_: selu_ });function transpose_(e, t) {
  var n = convertToTensor(e, "x", "transpose");if (null == t && (t = n.shape.map(function (e, t) {
    return t;
  }).reverse()), assert(n.rank === t.length, "Error in transpose: rank of input " + n.rank + " must match length of perm " + t + "."), t.forEach(function (e) {
    assert(e >= 0 && e < n.rank, "All entries in 'perm' must be between 0 and " + (n.rank - 1) + " but got " + t);
  }), n.rank <= 1) return n.clone();return ENV.engine.runKernel(function (e) {
    return e.transpose(n, t);
  }, { $x: n }, function (e) {
    var n = getUndoAxesPermutation(t);return { $x: function $x() {
        return e.transpose(n);
      } };
  });
}var transpose = op({ transpose_: transpose_ });function localResponseNormalization_(e, t, n, r, o) {
  void 0 === t && (t = 5), void 0 === n && (n = 1), void 0 === r && (r = 1), void 0 === o && (o = .5);var a = convertToTensor(e, "x", "localResponseNormalization");assert(4 === a.rank || 3 === a.rank, "Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank " + a.rank + "."), assert(isInt(t), "Error in localResponseNormalization: depthRadius must be an integer\n                     but got depthRadius " + t + ".");var i = a,
      s = !1;3 === a.rank && (s = !0, i = a.as4D(1, a.shape[0], a.shape[1], a.shape[2]));var u = ENV.engine.runKernel(function (e, a) {
    return a(e.localResponseNormalization4D(i, t, n, r, o));
  }, { x4D: i }, function (e, a) {
    var s = a[0];return { x4D: function x4D() {
        return ENV.engine.runKernel(function (a) {
          return a.LRNGrad(e, i, s, t, n, r, o);
        }, {});
      } };
  });return s ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
}var localResponseNormalization = op({ localResponseNormalization_: localResponseNormalization_ });function norm_(e, t, n, r) {
  void 0 === t && (t = "euclidean"), void 0 === n && (n = null), void 0 === r && (r = !1);var o = normImpl(e = convertToTensor(e, "x", "norm"), t, n),
      a = o.shape;if (r) {
    var i = parseAxisParam(n, e.shape);a = expandShapeToKeepDim(o.shape, i);
  }return o.reshape(a);
}function normImpl(e, t, n) {
  if (void 0 === n && (n = null), 0 === e.rank) return e.abs();if (1 !== e.rank && null === n) return normImpl(e.reshape([-1]), t, n);if (1 === e.rank || "number" == typeof n || n instanceof Array && 1 === n.length) {
    if (1 === t) return e.abs().sum(n);if (t === 1 / 0) return e.abs().max(n);if (t === -1 / 0) return e.abs().min(n);if ("euclidean" === t || 2 === t) return e.abs().pow(scalar(2, "int32")).sum(n).sqrt();throw new Error("Error in norm: invalid ord value: " + t);
  }if (n instanceof Array && 2 === n.length) {
    if (1 === t) return e.abs().sum(n[0]).max(n[1] - 1);if (t === 1 / 0) return e.abs().sum(n[1]).max(n[0]);if (t === -1 / 0) return e.abs().sum(n[1]).min(n[0]);if ("fro" === t || "euclidean" === t) return e.square().sum(n).sqrt();throw new Error("Error in norm: invalid ord value: " + t);
  }throw new Error("Error in norm: invalid axis: " + n);
}var norm = op({ norm_: norm_ });function unsortedSegmentSum_(e, t, n) {
  var r = convertToTensor(e, "x", "unsortedSegmentSum"),
      o = convertToTensor(t, "segmentIds", "unsortedSegmentSum", "int32");assert(isInt(n), "numSegments must be of dtype int");return ENV.engine.runKernel(function (e) {
    return e.unsortedSegmentSum(r, o, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        return gatherDropNegatives(e, o);
      } };
  });
}function gather_(e, t, n) {
  void 0 === n && (n = 0);var r = convertToTensor(e, "x", "gather"),
      o = convertToTensor(t, "indices", "gather", "int32");n = parseAxisParam(n, r.shape)[0];return ENV.engine.runKernel(function (e) {
    return e.gather(r, o, n);
  }, { $x: r }, function (e) {
    return { $x: function $x() {
        if (0 === n) return unsortedSegmentSum(e, o, r.shape[n]);var t = r.shape,
            a = o.size,
            i = t.slice(0, n),
            s = i.length,
            u = t.slice(n, t.length).slice(1),
            l = u.length,
            c = arrayRange(0, s),
            p = arrayRange(s + 1, s + 1 + l),
            d = arrayConcat([i, [a], u]),
            h = e.reshape(d),
            f = o.reshape([a]),
            m = arrayConcat([[s], c, p]),
            g = h.transpose(m),
            v = unsortedSegmentSum(g, f, r.shape[n]),
            y = getUndoAxesPermutation(m);return v = v.transpose(y);
      } };
  });
}function arrayRange(e, t) {
  for (var n = [], r = e; r < t; ++r) {
    n.push(r);
  }return n;
}function arrayConcat(e) {
  for (var t = [], n = 0; n < e.length; ++n) {
    for (var r = 0; r < e[n].length; ++r) {
      t.push(e[n][r]);
    }
  }return t;
}function gatherDropNegatives(e, t) {
  for (var n = maximum(t, zerosLike(t)), r = gather(e, n), o = greaterEqual(t, scalar(0, "int32")), a = r.rank - o.rank, i = 0; i < a; ++i) {
    o = expandDims(o, i + 1);
  }o = logicalAnd(o, ones$1(r.shape, "bool"));var s = zerosLike(r);return where(o, r, s);
}var gather = op({ gather_: gather_ }),
    unsortedSegmentSum = op({ unsortedSegmentSum_: unsortedSegmentSum_ });function multiRNNCell_(e, t, n, r) {
  for (var o = convertToTensor(t, "data", "multiRNNCell"), a = convertToTensorArray(n, "c", "multiRNNCell"), i = convertToTensorArray(r, "h", "multiRNNCell"), s = o, u = [], l = 0; l < e.length; l++) {
    var c = e[l](s, a[l], i[l]);u.push(c[0]), u.push(c[1]), s = c[1];
  }var p = [],
      d = [];for (l = 0; l < u.length; l += 2) {
    p.push(u[l]), d.push(u[l + 1]);
  }return [p, d];
}function basicLSTMCell_(e, t, n, r, o, a) {
  var i = convertToTensor(e, "forgetBias", "basicLSTMCell"),
      s = convertToTensor(t, "lstmKernel", "basicLSTMCell"),
      u = convertToTensor(n, "lstmBias", "basicLSTMCell"),
      l = convertToTensor(r, "data", "basicLSTMCell"),
      c = convertToTensor(o, "c", "basicLSTMCell"),
      p = convertToTensor(a, "h", "basicLSTMCell"),
      d = l.concat(p, 1).matMul(s).add(u),
      h = d.shape[0],
      f = d.shape[1] / 4,
      m = [h, f],
      g = d.slice([0, 0], m),
      v = d.slice([0, f], m),
      y = d.slice([0, 2 * f], m),
      x = d.slice([0, 3 * f], m),
      T = g.sigmoid().mulStrict(v.tanh()).addStrict(c.mulStrict(i.add(y).sigmoid()));return [T, T.tanh().mulStrict(x.sigmoid())];
}var basicLSTMCell = op({ basicLSTMCell_: basicLSTMCell_ }),
    multiRNNCell = op({ multiRNNCell_: multiRNNCell_ });function movingAverage_(e, t, n, r, o) {
  void 0 === o && (o = !0);var a = convertToTensor(e, "v", "movingAverage"),
      i = convertToTensor(t, "x", "movingAverage"),
      s = convertToTensor(n, "decay", "movingAverage");assertTypesMatch(a, i), assert(arraysEqual(a.shape, i.shape), "Shape mismatch in v and x");var u = scalar(1),
      l = u.sub(s),
      c = i.sub(a).mul(l);if (o) {
    assert(null != r, "When using zeroDebias: true, step is required.");var p = convertToTensor(r, "step", "movingAverage");c = c.div(u.sub(pow(s, p)));
  }return a.add(c);
}var movingAverage = op({ movingAverage_: movingAverage_ });function stridedSlice_(e, t, n, r, o, a, i, s, u) {
  if (void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), void 0 === u && (u = 0), 0 !== i) throw new Error("ellipsis mask is not yet supported");if (0 !== s) throw new Error("new axis mask is not yet supported");var l = convertToTensor(e, "x", "stridedSlice");if (r.every(function (e) {
    return 1 === e;
  })) {
    var c = getStridedSlicedInfo(l.shape, t, n, r, o, a, i, s, u),
        p = c[0],
        d = c[1],
        h = c[2],
        f = d.filter(function (e, t) {
      return -1 === h.indexOf(t);
    });return slice(l, p, d).reshape(f);
  }return ENV.engine.runKernel(function (e) {
    return e.stridedSlice(l, t, n, r, o, a, i, s, u);
  }, { $x: l });
}var stridedSlice = op({ stridedSlice_: stridedSlice_ });function topk_(e, t, n) {
  void 0 === t && (t = 1), void 0 === n && (n = !0);var r = convertToTensor(e, "x", "topk");if (0 === r.rank) throw new Error("topk() expects the input to be of rank 1 or higher");var o = r.shape[r.shape.length - 1];if (t > o) throw new Error("'k' passed to topk() must be <= the last dimension (" + o + ") but got " + t);var a = ENV.engine.runKernel(function (e) {
    return e.topk(r, t, n);
  }, { $x: r });return { values: a[0], indices: a[1] };
}var topk = op({ topk_: topk_ });function scatterND_(e, t, n) {
  var r = convertToTensor(e, "indices", "scatterND", "int32"),
      o = convertToTensor(t, "updates", "scatterND");return validateInput(o, r, n), ENV.engine.runKernel(function (e) {
    return e.scatterND(r, o, n);
  }, { $indices: r, $updates: o });
}var scatterND = op({ scatterND_: scatterND_ });function fft_(e) {
  assert("complex64" === e.dtype, "The dtype for tf.spectral.fft() must be complex64 but got " + e.dtype + ".");var t = e.shape[e.shape.length - 1],
      n = e.size / t,
      r = e.as2D(n, t);return ENV.engine.runKernel(function (e) {
    return e.fft(r);
  }, { input: e }).reshape(e.shape);
}function ifft_(e) {
  assert("complex64" === e.dtype, "The dtype for tf.spectral.ifft() must be complex64 but got " + e.dtype + ".");var t = e.shape[e.shape.length - 1],
      n = e.size / t,
      r = e.as2D(n, t);return ENV.engine.runKernel(function (e) {
    return e.ifft(r);
  }, { input: e }).reshape(e.shape);
}function rfft_(e) {
  assert("float32" === e.dtype, "The dtype for rfft() must be real value but\n    got " + e.dtype);var t = e.shape[e.shape.length - 1],
      n = e.size / t,
      r = e.zerosLike(),
      o = complex(e, r).as2D(n, t),
      a = fft(o),
      i = Math.floor(t / 2) + 1,
      s = real(a),
      u = imag(a),
      l = s.split([i, t - i], s.shape.length - 1),
      c = u.split([i, t - i], u.shape.length - 1),
      p = e.shape.slice();return p[e.shape.length - 1] = i, complex(l[0], c[0]).reshape(p);
}function irfft_(e) {
  var t = e.shape[e.shape.length - 1],
      n = e.size / t;if (t <= 2) {
    var r = e.as2D(n, t),
        o = ifft(r);return real(o);
  }var a = [n, 2 * (t - 1)],
      i = real(e).as2D(n, t),
      s = imag(e).as2D(n, t),
      u = i.slice([0, 1], [n, t - 2]).reverse(1),
      l = s.slice([0, 1], [n, t - 2]).reverse(1).mul(scalar(-1)),
      c = i.concat(u, 1),
      p = s.concat(l, 1);r = complex(c, p).as2D(a[0], a[1]), o = ifft(r);return real(o);
}var fft = op({ fft_: fft_ }),
    ifft = op({ ifft_: ifft_ }),
    rfft = op({ rfft_: rfft_ }),
    irfft = op({ irfft_: irfft_ }),
    spectral_ops = Object.freeze({ fft: fft, ifft: ifft, rfft: rfft, irfft: irfft });function validateInput$1(e, t, n, r) {
  if ("int32" !== e.dtype) throw new Error("tf.sparseToDense() expects the indices to be int32 type, but the dtype was " + e.dtype + ".");if (e.rank > 2) throw new Error("sparseIndices should be a scalar, vector, or matrix, but got shape " + e.shape + ".");var o = e.rank > 0 ? e.shape[0] : 1,
      a = e.rank > 1 ? e.shape[1] : 1;if (n.length !== a) throw new Error("outputShape has incorrect number of elements:, " + n.length + ", should be: " + a + ".");var i = t.size;if (0 !== t.rank && (1 !== t.rank || i !== o)) throw new Error("sparseValues has incorrect shape " + t.shape + ", should be [] or [" + o + "]");if (t.dtype !== r.dtype) throw new Error("sparseValues.dtype must match defaultValues.dtype");
}function sparseToDense_(e, t, n, r) {
  var o = convertToTensor(e, "sparseIndices", "sparseToDense", "int32"),
      a = convertToTensor(t, "sparseValues", "sparseToDense"),
      i = convertToTensor(r, "defaultValue", "sparseToDense", a.dtype);return validateInput$1(o, a, n, i), ENV.engine.runKernel(function (e) {
    return e.sparseToDense(o, a, n, i);
  }, { $sparseIndices: o, $sparseValues: a, $defaultValue: i });
}var sparseToDense = op({ sparseToDense_: sparseToDense_ });function gatherND_(e, t) {
  var n = convertToTensor(t, "indices", "gatherND", "int32"),
      r = convertToTensor(e, "x", "gatherND");return ENV.engine.runKernel(function (e) {
    return e.gatherND(r, n);
  }, { $x: r, $indices: n });
}var Reduction,
    gatherND = op({ gatherND_: gatherND_ });function computeWeightedLoss_(e, t, n) {
  void 0 === n && (n = Reduction.SUM_BY_NONZERO_WEIGHTS);var r = convertToTensor(e, "losses", "computeWeightedLoss"),
      o = null;null != t && (o = convertToTensor(t, "weights", "computeWeightedLoss"));var a = null == o ? r : r.mul(o);if (n === Reduction.NONE) return a;if (n === Reduction.SUM) return a.sum();if (n === Reduction.MEAN) {
    if (null == o) return a.mean();var i = sizeFromShape(r.shape) / sizeFromShape(o.shape),
        s = a.sum().div(o.sum());return i > 1 ? s.div(scalar(i)) : s;
  }if (n === Reduction.SUM_BY_NONZERO_WEIGHTS) {
    if (null == o) return a.sum().div(scalar(r.size));var u = o.mul(ones$1(r.shape)).notEqual(scalar(0)).sum().toFloat();return a.sum().div(u);
  }throw Error("Unknown reduction: " + n);
}function absoluteDifference_(e, t, n, r) {
  void 0 === r && (r = Reduction.SUM_BY_NONZERO_WEIGHTS);var o = convertToTensor(e, "labels", "absoluteDifference"),
      a = convertToTensor(t, "predictions", "absoluteDifference"),
      i = null;null != n && (i = convertToTensor(n, "weights", "absoluteDifference")), assertShapesMatch(o.shape, a.shape, "Error in absoluteDifference: ");var s = o.sub(a).abs();return computeWeightedLoss(s, i, r);
}function meanSquaredError_(e, t, n, r) {
  void 0 === r && (r = Reduction.SUM_BY_NONZERO_WEIGHTS);var o = convertToTensor(e, "labels", "meanSquaredError"),
      a = convertToTensor(t, "predictions", "meanSquaredError"),
      i = null;null != n && (i = convertToTensor(n, "weights", "meanSquaredError")), assertShapesMatch(o.shape, a.shape, "Error in meanSquaredError: ");var s = o.squaredDifference(a);return computeWeightedLoss(s, i, r);
}function cosineDistance_(e, t, n, r, o) {
  void 0 === o && (o = Reduction.SUM_BY_NONZERO_WEIGHTS);var a = convertToTensor(e, "labels", "cosineDistance"),
      i = convertToTensor(t, "predictions", "cosineDistance"),
      s = null;null != r && (s = convertToTensor(r, "weights", "cosineDistance")), assertShapesMatch(a.shape, i.shape, "Error in cosineDistance: ");var u = scalar(1).sub(a.mul(i).sum(n, !0));return computeWeightedLoss(u, s, o);
}function hingeLoss_(e, t, n, r) {
  void 0 === r && (r = Reduction.SUM_BY_NONZERO_WEIGHTS);var o = convertToTensor(e, "labels", "hingeLoss"),
      a = convertToTensor(t, "predictions", "hingeLoss"),
      i = null;null != n && (i = convertToTensor(n, "weights", "hingeLoss")), assertShapesMatch(o.shape, a.shape, "Error in hingeLoss: ");var s = scalar(1);o = scalar(2).mul(o).sub(s);var u = s.sub(o.mul(a)).relu();return computeWeightedLoss(u, i, r);
}function logLoss_(e, t, n, r, o) {
  void 0 === r && (r = 1e-7), void 0 === o && (o = Reduction.SUM_BY_NONZERO_WEIGHTS);var a = convertToTensor(e, "labels", "logLoss"),
      i = convertToTensor(t, "predictions", "logLoss"),
      s = null;null != n && (s = convertToTensor(n, "weights", "logLoss")), assertShapesMatch(a.shape, i.shape, "Error in logLoss: ");var u = scalar(1),
      l = scalar(r),
      c = a.mul(i.add(l).log()).neg().sub(u.sub(a).mul(u.sub(i).add(l).log()));return computeWeightedLoss(c, s, o);
}function sigmoidCrossEntropyWithLogits_(e, t) {
  var n = convertToTensor(e, "labels", "sigmoidCrossEntropyWithLogits"),
      r = convertToTensor(t, "logits", "sigmoidCrossEntropyWithLogits");assertShapesMatch(n.shape, r.shape, "Error in sigmoidCrossEntropyWithLogits: ");var o = r.relu(),
      a = r.mul(n),
      i = r.abs().neg().exp().log1p();return o.sub(a).add(i);
}function sigmoidCrossEntropy_(e, t, n, r, o) {
  void 0 === r && (r = 0), void 0 === o && (o = Reduction.SUM_BY_NONZERO_WEIGHTS);var a = convertToTensor(e, "multiClassLabels", "sigmoidCrossEntropy"),
      i = convertToTensor(t, "logits", "sigmoidCrossEntropy"),
      s = null;if (null != n && (s = convertToTensor(n, "weights", "sigmoidCrossEntropy")), assertShapesMatch(a.shape, i.shape, "Error in sigmoidCrossEntropy: "), r > 0) {
    var u = scalar(r),
        l = scalar(1),
        c = scalar(.5);a = a.mul(l.sub(u)).add(c.mul(u));
  }var p = sigmoidCrossEntropyWithLogits_(a, i);return computeWeightedLoss(p, s, o);
}function huberLoss_(e, t, n, r, o) {
  void 0 === r && (r = 1), void 0 === o && (o = Reduction.SUM_BY_NONZERO_WEIGHTS);var a = convertToTensor(e, "labels", "huberLoss"),
      i = convertToTensor(t, "predictions", "huberLoss"),
      s = null;null != n && (s = convertToTensor(n, "weights", "huberLoss")), assertShapesMatch(a.shape, i.shape, "Error in huberLoss: ");var u = scalar(r),
      l = i.sub(a).abs(),
      c = minimum(l, u),
      p = l.sub(c),
      d = scalar(.5).mul(c.square()).add(u.mul(p));return computeWeightedLoss(d, s, o);
}function softmaxCrossEntropyWithLogits_(e, t, n) {
  if (void 0 === n && (n = -1), -1 === n && (n = t.rank - 1), n !== t.rank - 1) throw Error("Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank " + t.rank + " and dim was " + n);return customGrad(function (e, t) {
    var r = t.logSumExp([n], !0),
        o = t.toFloat().sub(r);return { value: o.mul(e).neg().sum([n]), gradFunc: function gradFunc(t) {
        var r = expandShapeToKeepDim(t.shape, [n]);return [t.reshape(r).mul(e.toFloat().sub(o.exp())), t.reshape(r).mul(o.exp().sub(e.toFloat()))];
      } };
  })(e, t);
}function softmaxCrossEntropy_(e, t, n, r, o) {
  void 0 === r && (r = 0), void 0 === o && (o = Reduction.SUM_BY_NONZERO_WEIGHTS);var a = convertToTensor(e, "onehotLabels", "softmaxCrossEntropy"),
      i = convertToTensor(t, "logits", "softmaxCrossEntropy"),
      s = null;if (null != n && (s = convertToTensor(n, "weights", "softmaxCrossEntropy")), assertShapesMatch(a.shape, i.shape, "Error in softmaxCrossEntropy: "), r > 0) {
    var u = scalar(r),
        l = scalar(1),
        c = scalar(a.shape[1]);a = a.mul(l.sub(u)).add(u.div(c));
  }var p = softmaxCrossEntropyWithLogits_(a, i);return computeWeightedLoss(p, s, o);
}!function (e) {
  e[e.NONE = 0] = "NONE", e[e.MEAN = 1] = "MEAN", e[e.SUM = 2] = "SUM", e[e.SUM_BY_NONZERO_WEIGHTS = 3] = "SUM_BY_NONZERO_WEIGHTS";
}(Reduction || (Reduction = {}));var absoluteDifference = op({ absoluteDifference_: absoluteDifference_ }),
    computeWeightedLoss = op({ computeWeightedLoss_: computeWeightedLoss_ }),
    cosineDistance = op({ cosineDistance_: cosineDistance_ }),
    hingeLoss = op({ hingeLoss_: hingeLoss_ }),
    huberLoss = op({ huberLoss_: huberLoss_ }),
    logLoss = op({ logLoss_: logLoss_ }),
    meanSquaredError = op({ meanSquaredError_: meanSquaredError_ }),
    sigmoidCrossEntropy = op({ sigmoidCrossEntropy_: sigmoidCrossEntropy_ }),
    softmaxCrossEntropy = op({ softmaxCrossEntropy_: softmaxCrossEntropy_ }),
    loss_ops = Object.freeze({ get Reduction() {
    return Reduction;
  }, absoluteDifference: absoluteDifference, computeWeightedLoss: computeWeightedLoss, cosineDistance: cosineDistance, hingeLoss: hingeLoss, huberLoss: huberLoss, logLoss: logLoss, meanSquaredError: meanSquaredError, sigmoidCrossEntropy: sigmoidCrossEntropy, softmaxCrossEntropy: softmaxCrossEntropy });function gramSchmidt_(e) {
  var t;if (Array.isArray(e)) {
    t = !1, assert(null != e && e.length > 0, "Gram-Schmidt process: input must not be null, undefined, or empty");for (var n = e[0].shape[0], r = 1; r < e.length; ++r) {
      assert(e[r].shape[0] === n, "Gram-Schmidt: Non-unique lengths found in the input vectors: (" + e[r].shape[0] + " vs. " + n + ")");
    }
  } else t = !0, e = split$1(e, e.shape[0], 0).map(function (e) {
    return squeeze(e, [0]);
  });assert(e.length <= e[0].shape[0], "Gram-Schmidt: Number of vectors (" + e.length + ") exceeds number of dimensions (" + e[0].shape[0] + ").");var o = [],
      a = e,
      i = function i(e) {
    o.push(ENV.engine.tidy(function () {
      var t = a[e];if (e > 0) for (var n = 0; n < e; ++n) {
        var r = sum$1(o[n].mulStrict(t)).mul(o[n]);t = t.sub(r);
      }return t.div(norm(t, "euclidean"));
    }));
  };for (r = 0; r < e.length; ++r) {
    i(r);
  }return t ? stack(o, 0) : o;
}function qr_(e, t) {
  if (void 0 === t && (t = !1), e.rank < 2) throw new Error("qr() requires input tensor to have a rank >= 2, but got rank " + e.rank);if (2 === e.rank) return qr2d(e, t);var n = e.shape.slice(0, e.shape.length - 2).reduce(function (e, t) {
    return e * t;
  }),
      r = [],
      o = [];return unstack(e.reshape([n, e.shape[e.shape.length - 2], e.shape[e.shape.length - 1]]), 0).forEach(function (e) {
    var n = qr2d(e, t),
        a = n[0],
        i = n[1];r.push(a), o.push(i);
  }), [stack(r, 0).reshape(e.shape), stack(o, 0).reshape(e.shape)];
}function qr2d(e, t) {
  return void 0 === t && (t = !1), ENV.engine.tidy(function () {
    if (2 !== e.shape.length) throw new Error("qr2d() requires a 2D Tensor, but got a " + e.shape.length + "D Tensor.");for (var n = e.shape[0], r = e.shape[1], o = eye(n), a = e.clone(), i = tensor2d([[1]], [1, 1]), s = i.clone(), u = n >= r ? r : n, l = function l(e) {
      var t,
          u = a,
          l = s,
          c = o;t = ENV.engine.tidy(function () {
        var t = a.slice([e, e], [n - e, 1]),
            u = t.norm(),
            l = a.slice([e, e], [1, 1]),
            c = l.sign().neg(),
            p = l.sub(c.mul(u)),
            d = t.div(p);s = 1 === d.shape[0] ? i.clone() : i.concat(d.slice([1, 0], [d.shape[0] - 1, d.shape[1]]), 0);var h = c.matMul(p).div(u).neg(),
            f = a.slice([e, 0], [n - e, r]),
            m = h.mul(s);a = 0 === e ? f.sub(m.matMul(s.transpose().matMul(f))) : a.slice([0, 0], [e, r]).concat(f.sub(m.matMul(s.transpose().matMul(f))), 0);var g = o.slice([0, e], [n, o.shape[1] - e]);return o = 0 === e ? g.sub(g.matMul(s).matMul(m.transpose())) : o.slice([0, 0], [n, e]).concat(g.sub(g.matMul(s).matMul(m.transpose())), 1), [s, a, o];
      }), s = t[0], a = t[1], o = t[2], dispose([u, l, c]);
    }, c = 0; c < u; ++c) {
      l(c);
    }return !t && n > r && (o = o.slice([0, 0], [n, r]), a = a.slice([0, 0], [r, r])), [o, a];
  });
}var gramSchmidt = op({ gramSchmidt_: gramSchmidt_ }),
    qr = op({ qr_: qr_ }),
    linalg_ops = Object.freeze({ gramSchmidt: gramSchmidt, qr: qr });function resizeBilinear_(e, t, n) {
  void 0 === n && (n = !1);var r = convertToTensor(e, "images", "resizeBilinear");assert(3 === r.rank || 4 === r.rank, "Error in resizeBilinear: x must be rank 3 or 4, but got rank " + r.rank + "."), assert(2 === t.length, "Error in resizeBilinear: new shape must 2D, but got shape " + t + ".");var o = r,
      a = !1;3 === r.rank && (a = !0, o = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));var i = t[0],
      s = t[1],
      u = ENV.engine.runKernel(function (e, t) {
    return e.resizeBilinear(o, i, s, n);
  }, { batchImages: o }, function (e, t) {
    return { batchImages: function batchImages() {
        return ENV.engine.runKernel(function (t) {
          return t.resizeBilinearBackprop(e, o, n);
        }, {});
      } };
  });return a ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
}function resizeNearestNeighbor_(e, t, n) {
  void 0 === n && (n = !1);var r = convertToTensor(e, "images", "resizeNearestNeighbor");assert(3 === r.rank || 4 === r.rank, "Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank " + r.rank + "."), assert(2 === t.length, "Error in resizeNearestNeighbor: new shape must 2D, but got shape " + t + "."), assert("float32" === r.dtype || "int32" === r.dtype, "`images` must have `int32` or `float32` as dtype");var o = r,
      a = !1;3 === r.rank && (a = !0, o = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));var i = t[0],
      s = t[1],
      u = ENV.engine.runKernel(function (e, t) {
    return e.resizeNearestNeighbor(o, i, s, n);
  }, { batchImages: o }, function (e, t) {
    return { batchImages: function batchImages() {
        return ENV.engine.runKernel(function (t) {
          return t.resizeNearestNeighborBackprop(e, o, n);
        }, {});
      } };
  });return a ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
}function nonMaxSuppression_(e, t, n, r, o) {
  void 0 === r && (r = .5), void 0 === o && (o = Number.NEGATIVE_INFINITY);var a = convertToTensor(e, "boxes", "nonMaxSuppression"),
      i = convertToTensor(t, "scores", "nonMaxSuppression"),
      s = nonMaxSuppSanityCheck(a, i, n, r, o);return n = s.maxOutputSize, r = s.iouThreshold, o = s.scoreThreshold, ENV.engine.runKernel(function (e) {
    return e.nonMaxSuppression(a, i, n, r, o);
  }, { $boxes: a });
}function nonMaxSuppressionAsync_(e, t, n, r, o) {
  return void 0 === r && (r = .5), void 0 === o && (o = Number.NEGATIVE_INFINITY), __awaiter(this, void 0, void 0, function () {
    var a, i, s, u, l, c;return __generator(this, function (p) {
      switch (p.label) {case 0:
          return a = convertToTensor(e, "boxes", "nonMaxSuppressionAsync"), i = convertToTensor(t, "scores", "nonMaxSuppressionAsync"), s = nonMaxSuppSanityCheck(a, i, n, r, o), n = s.maxOutputSize, r = s.iouThreshold, o = s.scoreThreshold, [4, a.data()];case 1:
          return u = p.sent(), [4, i.data()];case 2:
          return l = p.sent(), c = nonMaxSuppressionImpl(u, l, n, r, o), a !== e && a.dispose(), i !== t && i.dispose(), [2, c];}
    });
  });
}function nonMaxSuppSanityCheck(e, t, n, r, o) {
  null == r && (r = .5), null == o && (o = Number.NEGATIVE_INFINITY);var a = e.shape[0];return n = Math.min(n, a), assert(0 <= r && r <= 1, "iouThreshold must be in [0, 1], but was '" + r + "'"), assert(2 === e.rank, "boxes must be a 2D tensor, but was of rank '" + e.rank + "'"), assert(4 === e.shape[1], "boxes must have 4 columns, but 2nd dimension was " + e.shape[1]), assert(1 === t.rank, "scores must be a 1D tensor"), assert(t.shape[0] === a, "scores has incompatible shape with boxes. Expected " + a + ", but was " + t.shape[0]), { maxOutputSize: n, iouThreshold: r, scoreThreshold: o };
}function cropAndResize_(e, t, n, r, o, a) {
  var i = convertToTensor(e, "image", "cropAndResize", "float32"),
      s = convertToTensor(t, "boxes", "cropAndResize", "float32"),
      u = convertToTensor(n, "boxInd", "cropAndResize", "int32");o = o || "bilinear", a = a || 0;var l = s.shape[0];assert(4 === i.rank, "Error in cropAndResize: image must be rank 4,but got rank " + i.rank + "."), assert(2 === s.rank && 4 === s.shape[1], "Error in cropAndResize: boxes must be have size [" + l + ",4] but had shape " + s.shape + "."), assert(1 === u.rank && u.shape[0] === l, "Error in cropAndResize: boxInd must be have size [" + l + "] but had shape " + s.shape + "."), assert(2 === r.length, "Error in cropAndResize: cropSize must be of length 2, but got length " + r.length + "."), assert(r[0] >= 1 && r[1] >= 1, "cropSize must be atleast [1,1], but was " + r), assert("bilinear" === o || "nearest" === o, "method must be bilinear or nearest, but was " + o);return ENV.engine.runKernel(function (e, t) {
    return e.cropAndResize(i, s, u, r, o, a);
  }, { $image: i, $boxes: s });
}var resizeBilinear = op({ resizeBilinear_: resizeBilinear_ }),
    resizeNearestNeighbor = op({ resizeNearestNeighbor_: resizeNearestNeighbor_ }),
    nonMaxSuppression = op({ nonMaxSuppression_: nonMaxSuppression_ }),
    nonMaxSuppressionAsync = nonMaxSuppressionAsync_,
    cropAndResize = cropAndResize_,
    image_ops = Object.freeze({ resizeBilinear: resizeBilinear, resizeNearestNeighbor: resizeNearestNeighbor, nonMaxSuppression: nonMaxSuppression, nonMaxSuppressionAsync: nonMaxSuppressionAsync, cropAndResize: cropAndResize }),
    ops = Object.freeze({ image: image_ops, linalg: linalg_ops, losses: loss_ops, spectral: spectral_ops, op: op, batchNormalization2d: batchNormalization2d, batchNormalization3d: batchNormalization3d, batchNormalization4d: batchNormalization4d, batchNormalization: batchNormalization, complex: complex, real: real, imag: imag, concat: concat, concat1d: concat1d, concat2d: concat2d, concat3d: concat3d, concat4d: concat4d, split: split$1, conv1d: conv1d, conv2d: conv2d, conv3d: conv3d, conv2dDerFilter: conv2dDerFilter, depthwiseConv2d: depthwiseConv2d, separableConv2d: separableConv2d, conv2dTranspose: conv2dTranspose, matMul: matMul, dot: dot, outerProduct: outerProduct, reverse: reverse, reverse1d: reverse1d, reverse2d: reverse2d, reverse3d: reverse3d, reverse4d: reverse4d, maxPool: maxPool, avgPool: avgPool, pool: pool, slice: slice, slice1d: slice1d, slice2d: slice2d, slice3d: slice3d, slice4d: slice4d, abs: abs, acos: acos, acosh: acosh, asin: asin, asinh: asinh, atan: atan, atanh: atanh, ceil: ceil, clipByValue: clipByValue, cos: cos, cosh: cosh, erf: erf, exp: exp, expm1: expm1, floor: floor, log: log$1, log1p: log1p, logSigmoid: logSigmoid, neg: neg, reciprocal: reciprocal, round: round, rsqrt: rsqrt, sigmoid: sigmoid, sign: sign, sin: sin, sinh: sinh, softplus: softplus, sqrt: sqrt, square: square, step: step, tan: tan, tanh: tanh$1, all: all, any: any, argMax: argMax, argMin: argMin, logSumExp: logSumExp, max: max, mean: mean, min: min, moments: moments, sum: sum$1, prod: prod, equal: equal, equalStrict: equalStrict, greater: greater, greaterEqual: greaterEqual, greaterEqualStrict: greaterEqualStrict, greaterStrict: greaterStrict, less: less, lessEqual: lessEqual, lessEqualStrict: lessEqualStrict, lessStrict: lessStrict, notEqual: notEqual, notEqualStrict: notEqualStrict, add: add, addN: addN, addStrict: addStrict, atan2: atan2, div: div, divStrict: divStrict, floorDiv: floorDiv, maximum: maximum, maximumStrict: maximumStrict, minimum: minimum, minimumStrict: minimumStrict, mod: mod, modStrict: modStrict, mul: mul, mulStrict: mulStrict, pow: pow, powStrict: powStrict, squaredDifference: squaredDifference, squaredDifferenceStrict: squaredDifferenceStrict, sub: sub, subStrict: subStrict, elu: elu, leakyRelu: leakyRelu, prelu: prelu, relu: relu, selu: selu, logicalAnd: logicalAnd, logicalNot: logicalNot, logicalOr: logicalOr, logicalXor: logicalXor, where: where, whereAsync: whereAsync, buffer: buffer, toPixels: toPixels, print: print, batchToSpaceND: batchToSpaceND, cast: cast, clone: clone, cumsum: cumsum, depthToSpace: depthToSpace, expandDims: expandDims, eye: eye, fromPixels: fromPixels, multinomial: multinomial, oneHot: oneHot, pad: pad, pad1d: pad1d, pad2d: pad2d, pad3d: pad3d, pad4d: pad4d, rand: rand, randomNormal: randomNormal, randomUniform: randomUniform, reshape: reshape, spaceToBatchND: spaceToBatchND, squeeze: squeeze, stack: stack, tile: tile, truncatedNormal: truncatedNormal, unstack: unstack, setdiff1dAsync: setdiff1dAsync, fill: fill, linspace: linspace, ones: ones$1, range: range, scalar: scalar, tensor: tensor, tensor1d: tensor1d, tensor2d: tensor2d, tensor3d: tensor3d, tensor4d: tensor4d, tensor5d: tensor5d, tensor6d: tensor6d, zeros: zeros, onesLike: onesLike, zerosLike: zerosLike, transpose: transpose, softmax: softmax, logSoftmax: logSoftmax, localResponseNormalization: localResponseNormalization, norm: norm, gather: gather, unsortedSegmentSum: unsortedSegmentSum, basicLSTMCell: basicLSTMCell, multiRNNCell: multiRNNCell, movingAverage: movingAverage, stridedSlice: stridedSlice, topk: topk, scatterND: scatterND, fft: fft, ifft: ifft, rfft: rfft, irfft: irfft, sparseToDense: sparseToDense, gatherND: gatherND }),
    MathBackendCPU = function () {
  function e() {
    this.blockSize = 48, this.firstUse = !0, ENV.get("IS_BROWSER") && (this.fromPixels2DContext = document.createElement("canvas").getContext("2d"));
  }return e.prototype.setDataMover = function (e) {
    this.data = new DataStorage(e);
  }, e.prototype.register = function (e, t, n) {
    if (this.firstUse && (this.firstUse = !1, ENV.get("IS_NODE") && warn("\n============================\nHi there 👋. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================\n")), this.data.has(e)) throw new Error("Data buffer is already registered");this.data.set(e, { dtype: n });
  }, e.prototype.write = function (e, t) {
    if (null == t) throw new Error("MathBackendCPU.write(): values can not be null");this.data.get(e).values = t;
  }, e.prototype.fromPixels = function (e, t) {
    if (null == e) throw new Error("pixels passed to tf.fromPixels() can not be null");var n, r;if (ENV.get("IS_NODE") && null == e.getContext) throw new Error("When running in node, pixels must be an HTMLCanvasElement like the one returned by the `canvas` npm package");if (null != e.getContext) n = e.getContext("2d").getImageData(0, 0, e.width, e.height).data;else if (e instanceof ImageData) n = e.data;else {
      if (!(e instanceof HTMLImageElement || e instanceof HTMLVideoElement)) throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was " + e.constructor.name);if (null == this.fromPixels2DContext) throw new Error("Can't read pixels from HTMLImageElement outside the browser.");this.fromPixels2DContext.canvas.width = e.width, this.fromPixels2DContext.canvas.height = e.height, this.fromPixels2DContext.drawImage(e, 0, 0, e.width, e.height), n = this.fromPixels2DContext.getImageData(0, 0, e.width, e.height).data;
    }if (4 === t) r = new Int32Array(n);else {
      var o = e.width * e.height;r = new Int32Array(o * t);for (var a = 0; a < o; a++) {
        for (var i = 0; i < t; ++i) {
          r[a * t + i] = n[4 * a + i];
        }
      }
    }return tensor3d(r, [e.height, e.width, t], "int32");
  }, e.prototype.read = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.readSync(e)];
      });
    });
  }, e.prototype.readSync = function (e) {
    var t = this.data.get(e),
        n = t.dtype,
        r = t.complexTensors;return "complex64" === n ? mergeRealAndImagArrays(r.real.dataSync(), r.imag.dataSync()) : this.data.get(e).values;
  }, e.prototype.disposeData = function (e) {
    if (this.data.has(e)) {
      var t = this.data.get(e).complexTensors;null != t && (t.real.dispose(), t.imag.dispose()), this.data.delete(e);
    }
  }, e.prototype.time = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (n) {
        return t = now(), e(), [2, { kernelMs: now() - t }];
      });
    });
  }, e.prototype.memory = function () {
    return { unreliable: !0, reasons: ["The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."] };
  }, e.prototype.complex = function (e, t) {
    var n = Tensor.make(e.shape, {}, "complex64");return this.data.get(n.dataId).complexTensors = { real: ENV.engine.keep(e.clone()), imag: ENV.engine.keep(t.clone()) }, n;
  }, e.prototype.real = function (e) {
    return this.data.get(e.dataId).complexTensors.real.clone();
  }, e.prototype.imag = function (e) {
    return this.data.get(e.dataId).complexTensors.imag.clone();
  }, e.prototype.assertNotComplex = function (e, t) {
    Array.isArray(e) || (e = [e]), e.forEach(function (e) {
      null != e && assert("complex64" !== e.dtype, t + " does not support complex64 tensors.");
    });
  }, e.prototype.slice = function (e, t, n) {
    if (this.assertNotComplex(e, "slice"), isSliceContinous(e.shape, t, n)) {
      var r = computeFlatOffset(t, e.strides),
          o = sizeFromShape(n);return tensor(e.dataSync().subarray(r, r + o), n, e.dtype);
    }for (var a = buffer(n, e.dtype), i = 0; i < a.size; ++i) {
      var s = a.indexToLoc(i).map(function (e, n) {
        return e + t[n];
      });a.values[i] = e.get.apply(e, s);
    }return a.toTensor();
  }, e.prototype.stridedSlice = function (e, t, n, r, o, a, i, s, u) {
    this.assertNotComplex(e, "stridedSlice");var l = getStridedSlicedInfo(e.shape, t, n, r, o, a, i, s, u),
        c = l[0],
        p = l[1],
        d = l[2],
        h = p.filter(function (e, t) {
      return -1 === d.indexOf(t);
    });if (h.some(function (e) {
      return 0 === e;
    })) return tensor([], h);for (var f = buffer(p, e.dtype), m = 0; m < f.size; m++) {
      for (var g = f.indexToLoc(m), v = new Array(g.length), y = 0; y < v.length; y++) {
        v[y] = g[y] * r[y] + c[y];
      }f.set.apply(f, [e.get.apply(e, v)].concat(g));
    }return f.toTensor().reshape(h);
  }, e.prototype.unstack = function (e, t) {
    for (var n = e.shape[t], r = new Array(e.rank - 1), o = 0, a = 0; a < e.rank; a++) {
      a !== t && (r[o++] = e.shape[a]);
    }var i = new Array(e.rank).fill(0),
        s = e.shape.slice();s[t] = 1;var u = new Array(n);for (a = 0; a < u.length; a++) {
      i[t] = a, u[a] = this.slice(e, i, s).reshape(r);
    }return u;
  }, e.prototype.reverse = function (e, t) {
    this.assertNotComplex(e, "reverse");for (var n = buffer(e.shape, e.dtype), r = e.buffer(), o = function o(_o) {
      var a = n.indexToLoc(_o),
          i = a.slice();t.forEach(function (t) {
        return i[t] = e.shape[t] - 1 - i[t];
      }), n.set.apply(n, [r.get.apply(r, i)].concat(a));
    }, a = 0; a < n.size; a++) {
      o(a);
    }return n.toTensor();
  }, e.prototype.concat = function (e, t) {
    this.assertNotComplex(e, "concat");var n = e.map(function (e) {
      var n = sizeFromShape(e.shape.slice(t));return e.as2D(-1, n);
    }),
        r = computeOutShape(n.map(function (e) {
      return e.shape;
    }), 1),
        o = buffer(r, e[0].dtype).values;if (1 === n[0].shape[0]) {
      var a = 0;n.forEach(function (e) {
        o.set(e.dataSync(), a), a += e.size;
      });
    } else {
      var i = 0;n.forEach(function (e) {
        for (var t = e.dataSync(), n = 0, a = 0; a < e.shape[0]; ++a) {
          for (var s = a * r[1] + i, u = 0; u < e.shape[1]; ++u) {
            o[s + u] = t[n++];
          }
        }i += e.shape[1];
      });
    }var s = computeOutShape(e.map(function (e) {
      return e.shape;
    }), t);return tensor(o, s, e[0].dtype);
  }, e.prototype.neg = function (e) {
    return this.assertNotComplex(e, "neg"), this.multiply(scalar(-1), e);
  }, e.prototype.add = function (e, t) {
    return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
      return { real: e + n, imag: t + r };
    }) : this.broadcastedBinaryOp(e, t, upcastType(e.dtype, t.dtype), function (e, t) {
      return e + t;
    });
  }, e.prototype.addN = function (e) {
    this.assertNotComplex(e, "addN");for (var t = e.map(function (e) {
      return e.dataSync();
    }), n = buffer(e[0].shape, e[0].dtype), r = n.values, o = 0; o < e.length; o++) {
      for (var a = t[o], i = 0; i < r.length; i++) {
        r[i] += a[i];
      }
    }return n.toTensor();
  }, e.prototype.subtract = function (e, t) {
    return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
      return { real: e - n, imag: t - r };
    }) : this.broadcastedBinaryOp(e, t, upcastType(e.dtype, t.dtype), function (e, t) {
      return e - t;
    });
  }, e.prototype.pow = function (e, t) {
    return this.assertNotComplex([e, t], "pow"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      return Math.pow(e, t);
    });
  }, e.prototype.batchMatMul = function (e, t, n, r) {
    this.assertNotComplex([e, t], "matMul");for (var o = n ? e.shape[1] : e.shape[2], a = n ? e.shape[2] : e.shape[1], i = r ? t.shape[1] : t.shape[2], s = e.shape[0], u = e.dataSync(), l = t.dataSync(), c = n ? [e.strides[0], 1, e.strides[1]] : [e.strides[0], e.strides[1], 1], p = c[0], d = c[1], h = c[2], f = r ? [1, t.strides[1], t.strides[0]] : [t.strides[1], 1, t.strides[0]], m = f[0], g = f[1], v = f[2], y = a * i, x = buffer([s, a, i], e.dtype), T = x.values, w = this.blockSize, E = 0; E < s; E++) {
      for (var S = 0; S < a; S += w) {
        for (var b = 0; b < i; b += w) {
          for (var C = 0; C < o; C += w) {
            for (var A = Math.min(S + w, a), _ = Math.min(b + w, i), N = Math.min(C + w, o), R = S; R < A; R++) {
              for (var I = b; I < _; I++) {
                for (var k = 0, D = C; D < N; D++) {
                  k += u[E * p + R * d + D * h] * l[D * m + I * g + E * v];
                }T[E * y + (R * i + I)] += k;
              }
            }
          }
        }
      }
    }return x.toTensor();
  }, e.prototype.multiply = function (e, t) {
    return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
      return { real: e * n - t * r, imag: e * r + t * n };
    }) : this.broadcastedBinaryOp(e, t, upcastType(e.dtype, t.dtype), function (e, t) {
      return e * t;
    });
  }, e.prototype.realDivide = function (e, t) {
    this.assertNotComplex([e, t], "realDivide");return this.broadcastedBinaryOp(e, t, "float32", function (e, t) {
      return e / t;
    });
  }, e.prototype.floorDiv = function (e, t) {
    this.assertNotComplex([e, t], "floorDiv");return this.broadcastedBinaryOp(e, t, "int32", function (e, t) {
      return Math.floor(e / t);
    });
  }, e.prototype.sum = function (e, t) {
    this.assertNotComplex(e, "sum"), assertAxesAreInnerMostDims("sum", t, e.rank);for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, upcastType(e.dtype, "int32")), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = 0, d = 0; d < i; ++d) {
        p += u[c + d];
      }s[l] = p;
    }return a;
  }, e.prototype.prod = function (e, t) {
    this.assertNotComplex(e, "sum");for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, upcastType(e.dtype, "int32")), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = 1, d = 0; d < i; ++d) {
        p *= u[c + d];
      }s[l] = p;
    }return a;
  }, e.prototype.unsortedSegmentSum = function (e, t, n) {
    this.assertNotComplex(e, "unsortedSegmentSum");for (var r = [], o = e.rank - t.rank, a = 0; a < o; ++a) {
      t = t.expandDims(a + 1);
    }for (a = 0; a < n; ++a) {
      var i = scalar(a, "int32"),
          s = equal(i, t).asType("float32").mul(e).sum(0);r.push(s);
    }return stack(r);
  }, e.prototype.argMin = function (e, t) {
    this.assertNotComplex(e, "argMin");var n = [t];assertAxesAreInnerMostDims("argMin", n, e.rank);for (var r = computeOutAndReduceShapes(e.shape, n), o = r[0], a = r[1], i = zeros(o, "int32"), s = sizeFromShape(a), u = i.dataSync(), l = e.dataSync(), c = 0; c < u.length; ++c) {
      for (var p = c * s, d = l[p], h = 0, f = 0; f < s; ++f) {
        var m = l[p + f];m < d && (d = m, h = f);
      }u[c] = h;
    }return i;
  }, e.prototype.argMax = function (e, t) {
    this.assertNotComplex(e, "argMax");var n = [t];assertAxesAreInnerMostDims("argMax", n, e.rank);for (var r = computeOutAndReduceShapes(e.shape, n), o = r[0], a = r[1], i = zeros(o, "int32"), s = sizeFromShape(a), u = i.dataSync(), l = e.dataSync(), c = 0; c < u.length; ++c) {
      for (var p = c * s, d = l[p], h = 0, f = 0; f < s; ++f) {
        var m = l[p + f];m > d && (d = m, h = f);
      }u[c] = h;
    }return i;
  }, e.prototype.cumsum = function (e, t, n, r) {
    if (this.assertNotComplex(e, "cumsum"), t !== e.rank - 1) throw new Error("backend.cumsum in CPU expects an inner-most axis=" + (e.rank - 1) + " but got axis=" + t);for (var o = upcastType(e.dtype, "int32"), a = zeros(e.shape, o), i = a.dataSync(), s = e.dataSync(), u = e.shape[e.rank - 1], l = r ? function (e, t) {
      return e + u - t - 1;
    } : function (e, t) {
      return e + t;
    }, c = 0; c < s.length; c += u) {
      for (var p = 0; p < u; p++) {
        var d = l(c, p);if (0 === p) i[d] = n ? 0 : s[d];else {
          var h = l(c, p - 1);i[d] = n ? s[h] + i[h] : s[d] + i[h];
        }
      }
    }return a;
  }, e.prototype.equal = function (e, t) {
    return this.assertNotComplex([e, t], "equal"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e === t ? 1 : 0;
    });
  }, e.prototype.notEqual = function (e, t) {
    return this.assertNotComplex([e, t], "notEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e !== t ? 1 : 0;
    });
  }, e.prototype.less = function (e, t) {
    return this.assertNotComplex([e, t], "less"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e < t ? 1 : 0;
    });
  }, e.prototype.lessEqual = function (e, t) {
    return this.assertNotComplex([e, t], "lessEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e <= t ? 1 : 0;
    });
  }, e.prototype.greater = function (e, t) {
    return this.assertNotComplex([e, t], "greater"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e > t ? 1 : 0;
    });
  }, e.prototype.greaterEqual = function (e, t) {
    return this.assertNotComplex([e, t], "greaterEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e >= t ? 1 : 0;
    });
  }, e.prototype.logicalNot = function (e) {
    this.assertNotComplex(e, "logicalNot");for (var t = e.dataSync(), n = new Uint8Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = t[r] ? 0 : 1;
    }return Tensor.make(e.shape, { values: n }, "bool");
  }, e.prototype.logicalAnd = function (e, t) {
    return this.assertNotComplex([e, t], "logicalAnd"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e && t;
    });
  }, e.prototype.logicalOr = function (e, t) {
    return this.assertNotComplex([e, t], "logicalOr"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
      return e || t;
    });
  }, e.prototype.select = function (e, t, n) {
    this.assertNotComplex([e, t, n], "select");for (var r = e.dataSync(), o = t.dataSync(), a = n.dataSync(), i = zeros(t.shape, upcastType(t.dtype, n.dtype)), s = i.dataSync(), u = 0, l = 0 === e.rank || e.rank > 1 || 1 === t.rank ? 1 : t.shape[1], c = 0; c < r.length; c++) {
      for (var p = 0; p < l; p++) {
        1 === r[c] ? s[u++] = o[c] : s[u++] = a[c];
      }
    }return i;
  }, e.prototype.where = function (e) {
    this.assertNotComplex([e], "where");var t = e.dataSync();return whereImpl(e.shape, t);
  }, e.prototype.topk = function (e, t, n) {
    return this.assertNotComplex(e, "topk"), topkImpl(e.dataSync(), e.shape, e.dtype, t, n);
  }, e.prototype.min = function (e, t) {
    this.assertNotComplex(e, "min"), assertAxesAreInnerMostDims("min", t, e.rank);for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, e.dtype), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = u[c], d = 0; d < i; ++d) {
        var h = u[c + d];h < p && (p = h);
      }s[l] = p;
    }return a;
  }, e.prototype.minimum = function (e, t) {
    return this.assertNotComplex([e, t], "minimum"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      return Math.min(e, t);
    });
  }, e.prototype.mod = function (e, t) {
    return this.assertNotComplex([e, t], "mod"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      var n = e % t;return e < 0 && t < 0 || e >= 0 && t >= 0 ? n : (n + t) % t;
    });
  }, e.prototype.max = function (e, t) {
    this.assertNotComplex(e, "max"), assertAxesAreInnerMostDims("max", t, e.rank);for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, e.dtype), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = u[c], d = 0; d < i; ++d) {
        var h = u[c + d];h > p && (p = h);
      }s[l] = p;
    }return a;
  }, e.prototype.maximum = function (e, t) {
    return this.assertNotComplex([e, t], "maximum"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      return Math.max(e, t);
    });
  }, e.prototype.all = function (e, t) {
    this.assertNotComplex(e, "all"), assertAxesAreInnerMostDims("all", t, e.rank);for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, e.dtype), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = u[c], d = 0; d < i; ++d) {
        var h = u[c + d];p = p && h;
      }s[l] = p;
    }return a;
  }, e.prototype.any = function (e, t) {
    this.assertNotComplex(e, "any"), assertAxesAreInnerMostDims("any", t, e.rank);for (var n = computeOutAndReduceShapes(e.shape, t), r = n[0], o = n[1], a = zeros(r, e.dtype), i = sizeFromShape(o), s = a.dataSync(), u = e.dataSync(), l = 0; l < s.length; ++l) {
      for (var c = l * i, p = u[c], d = 0; d < i; ++d) {
        var h = u[c + d];p = p || h;
      }s[l] = p;
    }return a;
  }, e.prototype.squaredDifference = function (e, t) {
    return this.assertNotComplex([e, t], "squaredDifference"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      var n = e - t;return n * n;
    });
  }, e.prototype.ceil = function (e) {
    this.assertNotComplex(e, "ceil");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = Math.ceil(t[r]);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.floor = function (e) {
    this.assertNotComplex(e, "floor");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = Math.floor(t[r]);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.sign = function (e) {
    this.assertNotComplex(e, "x");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      t[r] < 0 ? n[r] = -1 : t[r] > 0 ? n[r] = 1 : n[r] = 0;
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.round = function (e) {
    this.assertNotComplex(e, "round");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = Math.floor(t[r]);t[r] - o < .5 ? n[r] = Math.floor(t[r]) : t[r] - o > .5 ? n[r] = Math.ceil(t[r]) : n[r] = o % 2 == 0 ? o : o + 1;
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.exp = function (e) {
    this.assertNotComplex(e, "exp");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = Math.exp(t[r]);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.expm1 = function (e) {
    this.assertNotComplex(e, "expm1");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = Math.expm1(t[r]);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.log = function (e) {
    this.assertNotComplex(e, "log");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = t[r];n[r] = Math.log(o);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.log1p = function (e) {
    this.assertNotComplex(e, "log1p");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = t[r];n[r] = Math.log1p(o);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.sqrt = function (e) {
    this.assertNotComplex(e, "sqrt");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = t[r];n[r] = Math.sqrt(o);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.rsqrt = function (e) {
    this.assertNotComplex(e, "rsqrt");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = t[r];n[r] = 1 / Math.sqrt(o);
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.square = function (e) {
    this.assertNotComplex(e, "square");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      var o = t[r];n[r] = o * o;
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.reciprocal = function (e) {
    this.assertNotComplex(e, "reciprocal");for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
      n[r] = 1 / t[r];
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.relu = function (e) {
    this.assertNotComplex(e, "relu");for (var t = zeros(e.shape, e.dtype), n = t.dataSync(), r = e.dataSync(), o = 0; o < r.length; ++o) {
      n[o] = Math.max(0, r[o]);
    }return t;
  }, e.prototype.prelu = function (e, t) {
    return this.assertNotComplex([e, t], "prelu"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      return e < 0 ? t * e : e;
    });
  }, e.prototype.elu = function (e) {
    this.assertNotComplex(e, "elu");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      var o = n[r];t[r] = o >= 0 ? o : Math.exp(o) - 1;
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.eluDer = function (e, t) {
    this.assertNotComplex([e, t], "eluDer");for (var n = new Float32Array(t.size), r = t.dataSync(), o = e.dataSync(), a = 0; a < r.length; ++a) {
      var i = r[a];n[a] = i >= 1 ? o[a] : o[a] * (i + 1);
    }return Tensor.make(t.shape, { values: n });
  }, e.prototype.selu = function (e) {
    this.assertNotComplex(e, "selu");for (var t = SELU_SCALEALPHA, n = SELU_SCALE, r = new Float32Array(e.size), o = e.dataSync(), a = 0; a < o.length; ++a) {
      var i = o[a];r[a] = i >= 0 ? n * i : t * (Math.exp(i) - 1);
    }return Tensor.make(e.shape, { values: r });
  }, e.prototype.clip = function (e, t, n) {
    this.assertNotComplex(e, "clip");for (var r = new Float32Array(e.size), o = e.dataSync(), a = 0; a < o.length; ++a) {
      var i = o[a];r[a] = i > n ? n : i < t ? t : i;
    }return Tensor.make(e.shape, { values: r });
  }, e.prototype.abs = function (e) {
    for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.abs(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.complexAbs = function (e) {
    for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < e.size; ++r) {
      var o = n[2 * r],
          a = n[2 * r + 1];t[r] = Math.hypot(o, a);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.int = function (e) {
    this.assertNotComplex(e, "int");for (var t = new Int32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = n[r];
    }return Tensor.make(e.shape, { values: t }, "int32");
  }, e.prototype.sigmoid = function (e) {
    this.assertNotComplex(e, "sigmoid");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = 1 / (1 + Math.exp(-n[r]));
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.softplus = function (e) {
    this.assertNotComplex(e, "softplus");for (var t = Math.log(1.1920928955078125e-7) + 2, n = new Float32Array(e.size), r = e.dataSync(), o = 0; o < r.length; ++o) {
      var a = r[o] > -t,
          i = r[o] < t,
          s = Math.exp(r[o]),
          u = void 0;u = i ? s : a ? r[o] : Math.log(1 + s), n[o] = u;
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.sin = function (e) {
    this.assertNotComplex(e, "sin");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.sin(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.cos = function (e) {
    this.assertNotComplex(e, "cos");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.cos(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.tan = function (e) {
    this.assertNotComplex(e, "tan");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.tan(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.asin = function (e) {
    this.assertNotComplex(e, "asin");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.asin(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.acos = function (e) {
    this.assertNotComplex(e, "acos");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.acos(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.atan = function (e) {
    this.assertNotComplex(e, "atan");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.atan(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.atan2 = function (e, t) {
    return this.assertNotComplex([e, t], "atan2"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
      return Math.atan2(e, t);
    });
  }, e.prototype.sinh = function (e) {
    this.assertNotComplex(e, "sinh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.sinh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.cosh = function (e) {
    this.assertNotComplex(e, "cosh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.cosh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.tanh = function (e) {
    this.assertNotComplex(e, "tanh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = tanh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.asinh = function (e) {
    this.assertNotComplex(e, "asinh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.asinh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.acosh = function (e) {
    this.assertNotComplex(e, "acosh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.acosh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.atanh = function (e) {
    this.assertNotComplex(e, "atanh");for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
      t[r] = Math.atanh(n[r]);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.erf = function (e) {
    this.assertNotComplex(e, "erf");for (var t = new Float32Array(e.size), n = e.dataSync(), r = ERF_P, o = ERF_A1, a = ERF_A2, i = ERF_A3, s = ERF_A4, u = ERF_A5, l = 0; l < n.length; ++l) {
      var c = n[l],
          p = 1 / (1 + r * c);t[l] = 1 - ((((u * p + s) * p + i) * p + a) * p + o) * p * Math.exp(-c * c);
    }return Tensor.make(e.shape, { values: t });
  }, e.prototype.step = function (e, t) {
    void 0 === t && (t = 0), this.assertNotComplex(e, "step");for (var n = new Float32Array(e.size), r = e.dataSync(), o = 0; o < r.length; ++o) {
      var a = r[o];isNaN(a) ? n[o] = NaN : n[o] = a > 0 ? 1 : t;
    }return Tensor.make(e.shape, { values: n });
  }, e.prototype.conv2d = function (e, t, n) {
    this.assertNotComplex([e, t], "conv2d");for (var r = n.filterHeight, o = n.filterWidth, a = n.dilationHeight, i = n.dilationWidth, s = n.padInfo.left, u = n.padInfo.top, l = buffer(n.outShape, e.dtype), c = e.dataSync(), p = t.dataSync(), d = l.values, h = 0; h < n.batchSize; ++h) {
      for (var f = h * e.strides[0], m = h * l.strides[0], g = 0; g < n.outHeight; ++g) {
        for (var v = m + g * l.strides[1], y = g * n.strideHeight - s, x = 0; x < r; x++) {
          var T = y + x * a;if (!(T < 0 || T >= n.inHeight)) for (var w = x * t.strides[0], E = f + T * e.strides[1], S = 0; S < n.outWidth; ++S) {
            for (var b = v + S * n.outChannels, C = S * n.strideWidth - u, A = 0; A < o; A++) {
              var _ = C + A * i;if (!(_ < 0 || _ >= n.inWidth)) for (var N = w + A * t.strides[1], R = E + _ * n.inChannels, I = N, k = 0; k < n.inChannels; ++k) {
                for (var D = c[R + k], M = 0; M < n.outChannels; ++M) {
                  d[b + M] += D * p[I + M];
                }I += n.outChannels;
              }
            }
          }
        }
      }
    }return l.toTensor();
  }, e.prototype.conv3d = function (e, t, n) {
    for (var r = n.filterDepth, o = n.filterHeight, a = n.filterWidth, i = n.dilationDepth, s = n.dilationHeight, u = n.dilationWidth, l = n.padInfo.front, c = n.padInfo.left, p = n.padInfo.top, d = buffer(n.outShape, e.dtype), h = e.dataSync(), f = t.dataSync(), m = d.values, g = 0; g < n.batchSize; ++g) {
      for (var v = g * e.strides[0], y = g * d.strides[0], x = 0; x < n.outDepth; ++x) {
        for (var T = y + x * d.strides[1], w = x * n.strideDepth - l, E = 0; E < r; E++) {
          var S = w + E * i;if (!(S < 0 || S >= n.inDepth)) for (var b = E * t.strides[0], C = v + S * e.strides[1], A = 0; A < n.outHeight; ++A) {
            for (var _ = T + A * d.strides[2], N = A * n.strideHeight - p, R = 0; R < o; R++) {
              var I = N + R * s;if (!(I < 0 || I >= n.inHeight)) for (var k = b + R * t.strides[1], D = C + I * e.strides[2], M = 0; M < n.outWidth; ++M) {
                for (var O = _ + M * n.outChannels, P = M * n.strideWidth - c, F = 0; F < a; F++) {
                  var L = P + F * u;if (!(L < 0 || L >= n.inWidth)) for (var B = k + F * t.strides[2], U = D + L * n.inChannels, V = B, z = 0; z < n.inChannels; ++z) {
                    for (var H = h[U + z], W = 0; W < n.outChannels; ++W) {
                      m[O + W] += H * f[V + W];
                    }V += n.outChannels;
                  }
                }
              }
            }
          }
        }
      }
    }return d.toTensor();
  }, e.prototype.conv2dDerInput = function (e, t, n) {
    this.assertNotComplex([e, t], "conv2dDerInput");for (var r = buffer(n.inShape, "float32"), o = r.values, a = r.strides, i = a[0], s = a[1], u = a[2], l = e.dataSync(), c = e.strides, p = c[0], d = c[1], h = c[2], f = t.dataSync(), m = t.strides, g = m[0], v = m[1], y = m[2], x = n.batchSize, T = n.filterHeight, w = n.filterWidth, E = n.inChannels, S = n.inHeight, b = n.inWidth, C = n.outChannels, A = n.outHeight, _ = n.outWidth, N = n.strideHeight, R = n.strideWidth, I = T - 1 - n.padInfo.top, k = w - 1 - n.padInfo.left, D = 0; D < x; ++D) {
      for (var M = 0; M < E; ++M) {
        for (var O = 0; O < S; ++O) {
          for (var P = O - I, F = Math.max(0, Math.ceil(P / N)), L = Math.min(A, (T + P) / N), B = 0; B < b; ++B) {
            for (var U = B - k, V = Math.max(0, Math.ceil(U / R)), z = Math.min(_, (w + U) / R), H = 0, W = F; W < L; ++W) {
              for (var G = W * N - P, q = V; q < z; ++q) {
                for (var $ = p * D + d * W + h * q, X = g * (T - 1 - G) + v * (w - 1 - (q * R - U)) + y * M, K = 0; K < C; ++K) {
                  H += l[$ + K] * f[X + K];
                }
              }
            }o[i * D + s * O + u * B + M] = H;
          }
        }
      }
    }return r.toTensor();
  }, e.prototype.conv3dDerInput = function (e, t, n) {
    for (var r = buffer(n.inShape, "float32"), o = r.values, a = r.strides, i = a[0], s = a[1], u = a[2], l = a[3], c = e.dataSync(), p = e.strides, d = p[0], h = p[1], f = p[2], m = p[3], g = t.dataSync(), v = t.strides, y = v[0], x = v[1], T = v[2], w = v[3], E = n.batchSize, S = n.filterDepth, b = n.filterHeight, C = n.filterWidth, A = n.inChannels, _ = n.inDepth, N = n.inHeight, R = n.inWidth, I = n.outChannels, k = n.outDepth, D = n.outHeight, M = n.outWidth, O = n.strideDepth, P = n.strideHeight, F = n.strideWidth, L = S - 1 - n.padInfo.front, B = b - 1 - n.padInfo.top, U = C - 1 - n.padInfo.left, V = 0; V < E; ++V) {
      for (var z = 0; z < A; ++z) {
        for (var H = 0; H < _; ++H) {
          for (var W = H - L, G = Math.max(0, Math.ceil(W / O)), q = Math.min(k, (S + W) / O), $ = 0; $ < N; ++$) {
            for (var X = $ - B, K = Math.max(0, Math.ceil(X / P)), j = Math.min(D, (b + X) / P), Y = 0; Y < R; ++Y) {
              for (var Q = Y - U, J = Math.max(0, Math.ceil(Q / F)), Z = Math.min(M, (C + Q) / F), ee = 0, te = G; te < q; ++te) {
                for (var ne = te * O - W, re = K; re < j; ++re) {
                  for (var oe = re * P - X, ae = J; ae < Z; ++ae) {
                    for (var ie = d * V + h * te + f * re + m * ae, se = y * (S - 1 - ne) + x * (b - 1 - oe) + T * (C - 1 - (ae * F - Q)) + w * z, ue = 0; ue < I; ++ue) {
                      ee += c[ie + ue] * g[se + ue];
                    }
                  }
                }
              }o[i * V + s * H + u * $ + l * Y + z] = ee;
            }
          }
        }
      }
    }return r.toTensor();
  }, e.prototype.conv2dDerFilter = function (e, t, n) {
    this.assertNotComplex([e, t], "conv2dDerFilter");for (var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = buffer(n.filterShape, "float32"), u = n.padInfo.left, l = n.padInfo.top, c = 0; c < a; ++c) {
      for (var p = Math.max(0, Math.ceil((l - c) / r)), d = Math.min(n.outHeight, (n.inHeight + l - c) / r), h = 0; h < i; ++h) {
        for (var f = Math.max(0, Math.ceil((u - h) / o)), m = Math.min(n.outWidth, (n.inWidth + u - h) / o), g = 0; g < n.inChannels; ++g) {
          for (var v = 0; v < n.outChannels; ++v) {
            for (var y = 0, x = 0; x < n.batchSize; ++x) {
              for (var T = p; T < d; ++T) {
                for (var w = c + T * r - l, E = f; E < m; ++E) {
                  var S = h + E * o - u;y += e.get(x, w, S, g) * t.get(x, T, E, v);
                }
              }
            }s.set(y, c, h, g, v);
          }
        }
      }
    }return s.toTensor();
  }, e.prototype.conv3dDerFilter = function (e, t, n) {
    for (var r = n.strideDepth, o = n.strideHeight, a = n.strideWidth, i = n.filterDepth, s = n.filterHeight, u = n.filterWidth, l = buffer(n.filterShape, "float32"), c = l.values, p = l.strides, d = p[0], h = p[1], f = p[2], m = p[3], g = t.dataSync(), v = t.strides, y = v[0], x = v[1], T = v[2], w = v[3], E = e.dataSync(), S = e.strides, b = S[0], C = S[1], A = S[2], _ = S[3], N = n.padInfo.front, R = n.padInfo.left, I = n.padInfo.top, k = 0; k < i; ++k) {
      for (var D = Math.max(0, Math.ceil((N - k) / r)), M = Math.min(n.outDepth, (n.inDepth + N - k) / r), O = k * d, P = 0; P < s; ++P) {
        for (var F = Math.max(0, Math.ceil((I - P) / o)), L = Math.min(n.outHeight, (n.inHeight + I - P) / o), B = P * h + O, U = 0; U < u; ++U) {
          for (var V = Math.max(0, Math.ceil((R - U) / a)), z = Math.min(n.outWidth, (n.inWidth + R - U) / a), H = U * f + B, W = 0; W < n.inChannels; ++W) {
            for (var G = W * m + H, q = 0; q < n.outChannels; ++q) {
              for (var $ = 0, X = 0; X < n.batchSize; ++X) {
                for (var K = X * b, j = X * y, Y = D; Y < M; ++Y) {
                  for (var Q = (k + Y * r - N) * C + K, J = Y * x + j, Z = F; Z < L; ++Z) {
                    for (var ee = (P + Z * o - I) * A + Q, te = Z * T + J, ne = V; ne < z; ++ne) {
                      var re = ne * w + te;$ += E[(U + ne * a - R) * _ + ee + W] * g[re + q];
                    }
                  }
                }
              }c[G + q] = $;
            }
          }
        }
      }
    }return l.toTensor();
  }, e.prototype.depthwiseConv2D = function (e, t, n) {
    this.assertNotComplex([e, t], "depthwiseConv2D");for (var r = n.filterHeight, o = n.filterWidth, a = n.dilationHeight, i = n.dilationWidth, s = n.padInfo.left, u = n.padInfo.top, l = n.outChannels / n.inChannels, c = buffer(n.outShape, e.dtype), p = e.dataSync(), d = t.dataSync(), h = c.values, f = 0; f < n.batchSize; ++f) {
      for (var m = f * e.strides[0], g = f * c.strides[0], v = 0; v < n.outHeight; ++v) {
        for (var y = g + v * c.strides[1], x = v * n.strideHeight - s, T = 0; T < r; ++T) {
          var w = x + T * a;if (!(w < 0 || w >= n.inHeight)) for (var E = T * t.strides[0], S = m + w * e.strides[1], b = 0; b < n.outWidth; ++b) {
            for (var C = y + b * c.strides[2], A = b * n.strideWidth - u, _ = 0; _ < o; ++_) {
              var N = A + _ * i;if (!(N < 0 || N >= n.inWidth)) for (var R = E + _ * t.strides[1], I = S + N * n.inChannels, k = C, D = R, M = 0; M < n.inChannels; ++M) {
                for (var O = p[I + M], P = 0; P < l; ++P) {
                  h[k + P] += O * d[D + P];
                }k += l, D += l;
              }
            }
          }
        }
      }
    }return c.toTensor();
  }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
    this.assertNotComplex([e, t], "depthwiseConv2DDerInput");for (var r = buffer(n.inShape, "float32"), o = r.values, a = r.strides, i = a[0], s = a[1], u = a[2], l = e.dataSync(), c = e.strides, p = c[0], d = c[1], h = c[2], f = t.dataSync(), m = t.strides, g = m[0], v = m[1], y = m[2], x = n.batchSize, T = n.filterHeight, w = n.filterWidth, E = n.inChannels, S = n.inHeight, b = n.inWidth, C = n.outChannels, A = n.outHeight, _ = n.outWidth, N = n.strideHeight, R = n.strideWidth, I = T - 1 - n.padInfo.top, k = w - 1 - n.padInfo.left, D = C / E, M = 0; M < x; ++M) {
      for (var O = 0; O < E; ++O) {
        for (var P = 0; P < S; ++P) {
          for (var F = P - I, L = Math.max(0, Math.ceil(F / N)), B = Math.min(A, (T + F) / N), U = 0; U < b; ++U) {
            for (var V = U - k, z = Math.max(0, Math.ceil(V / R)), H = Math.min(_, (w + V) / R), W = 0, G = L; G < B; ++G) {
              for (var q = G * N - F, $ = z; $ < H; ++$) {
                for (var X = p * M + d * G + h * $, K = g * (T - 1 - q) + v * (w - 1 - ($ * R - V)) + y * O, j = 0; j < D; ++j) {
                  W += l[X + (O * D + j)] * f[K + j];
                }
              }
            }o[i * M + s * P + u * U + O] = W;
          }
        }
      }
    }return r.toTensor();
  }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
    this.assertNotComplex([e, t], "depthwiseConv2DDerFilter");for (var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = buffer(n.filterShape, "float32"), u = n.padInfo.left, l = n.padInfo.top, c = n.outChannels / n.inChannels, p = 0; p < a; ++p) {
      for (var d = Math.max(0, Math.ceil((l - p) / r)), h = Math.min(n.outHeight, (n.inHeight + l - p) / r), f = 0; f < i; ++f) {
        for (var m = Math.max(0, Math.ceil((u - f) / o)), g = Math.min(n.outWidth, (n.inWidth + u - f) / o), v = 0; v < n.outChannels; ++v) {
          for (var y = Math.trunc(v / c), x = v % c, T = 0, w = 0; w < n.batchSize; ++w) {
            for (var E = d; E < h; ++E) {
              for (var S = p + E * r - l, b = m; b < g; ++b) {
                var C = f + b * o - u;T += e.get(w, S, C, y) * t.get(w, E, b, v);
              }
            }
          }s.set(T, p, f, y, x);
        }
      }
    }return s.toTensor();
  }, e.prototype.tile = function (e, t) {
    this.assertNotComplex(e, "tile");for (var n = new Array(e.rank), r = 0; r < n.length; r++) {
      n[r] = e.shape[r] * t[r];
    }var o = buffer(n, e.dtype),
        a = e.buffer();for (r = 0; r < o.values.length; ++r) {
      for (var i = o.indexToLoc(r), s = new Array(e.rank), u = 0; u < s.length; u++) {
        s[u] = i[u] % e.shape[u];
      }var l = a.locToIndex(s);o.values[r] = a.values[l];
    }return o.toTensor();
  }, e.prototype.pad = function (e, t, n) {
    this.assertNotComplex(e, "pad");var r = t.map(function (t, n) {
      return t[0] + e.shape[n] + t[1];
    }),
        o = t.map(function (e) {
      return e[0];
    }),
        a = e.buffer(),
        i = buffer(r, e.dtype);0 !== n && i.values.fill(n);for (var s = 0; s < e.size; s++) {
      var u = a.indexToLoc(s),
          l = u.map(function (e, t) {
        return e + o[t];
      });i.set.apply(i, [e.get.apply(e, u)].concat(l));
    }return i.toTensor();
  }, e.prototype.transpose = function (e, t) {
    this.assertNotComplex(e, "transpose");for (var n = new Array(e.rank), r = 0; r < n.length; r++) {
      n[r] = e.shape[t[r]];
    }var o = e.dataSync(),
        a = buffer(n, e.dtype),
        i = e.buffer();for (r = 0; r < e.size; ++r) {
      for (var s = i.indexToLoc(r), u = new Array(s.length), l = 0; l < u.length; l++) {
        u[l] = s[t[l]];
      }var c = a.locToIndex(u);a.values[c] = o[r];
    }return a.toTensor();
  }, e.prototype.gather = function (e, t, n) {
    this.assertNotComplex([e, t], "gather");var r = e.shape.slice(),
        o = t.dataSync();r[n] = o.length;for (var a = buffer(r, e.dtype), i = e.buffer(), s = 0; s < a.size; ++s) {
      var u = a.indexToLoc(s),
          l = u.slice();l[n] = o[u[n]];var c = i.locToIndex(l);a.values[s] = i.values[c];
    }return a.toTensor();
  }, e.prototype.batchToSpaceND = function (e, t, n) {
    this.assertNotComplex([e], "batchToSpaceND");var r = t.reduce(function (e, t) {
      return e * t;
    }),
        o = getReshaped(e.shape, t, r),
        a = getPermuted(o.length, t.length),
        i = getReshapedPermuted(e.shape, t, r),
        s = getSliceBeginCoords(n, t.length),
        u = getSliceSize(i, n, t.length);return e.reshape(o).transpose(a).reshape(i).slice(s, u);
  }, e.prototype.spaceToBatchND = function (e, t, n) {
    this.assertNotComplex([e], "spaceToBatchND");var r = t.reduce(function (e, t) {
      return e * t;
    }),
        o = [[0, 0]];o.push.apply(o, n);for (var a = 1 + t.length; a < e.shape.length; ++a) {
      o.push([0, 0]);
    }var i = e.pad(o),
        s = getReshaped(i.shape, t, r, !1),
        u = getPermuted(s.length, t.length, !1),
        l = getReshapedPermuted(i.shape, t, r, !1);return i.reshape(s).transpose(u).reshape(l);
  }, e.prototype.pool = function (e, t, n) {
    this.assertNotComplex(e, "pool");for (var r = t.strideHeight, o = t.strideWidth, a = t.dilationHeight, i = t.dilationWidth, s = t.effectiveFilterHeight, u = t.effectiveFilterWidth, l = t.padInfo.top, c = t.padInfo.left, p = "max" === n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, d = e.dataSync(), h = buffer(t.outShape, e.dtype), f = h.values, m = t.outShape[1] * t.outShape[2] * t.outShape[3], g = t.outShape[2] * t.outShape[3], v = t.outShape[3], y = 0; y < t.batchSize; ++y) {
      for (var x = y * m, T = y * e.strides[0], w = 0; w < t.inChannels; ++w) {
        for (var E = 0; E < t.outHeight; ++E) {
          for (var S = E * r - l, b = Math.max(0, S), C = Math.min(t.inHeight, s + S), A = x + E * g, _ = 0; _ < t.outWidth; ++_) {
            for (var N = _ * o - c, R = Math.max(0, N), I = Math.min(t.inWidth, u + N), k = p, D = 0, M = 0, O = b; O < C; O += a) {
              for (var P = T + O * e.strides[1], F = R; F < I; F += i) {
                var L = d[P + F * e.strides[2] + w];"max" === n && L > k ? k = L : "avg" === n && (D += L, M++);
              }if (isNaN(k)) break;
            }f[A + _ * v + w] = "avg" === n ? D / M : k;
          }
        }
      }
    }return h.toTensor();
  }, e.prototype.maxPool = function (e, t) {
    return this.pool(e, t, "max");
  }, e.prototype.maxPoolPositions = function (e, t) {
    for (var n = buffer(t.outShape, "int32"), r = t.strideHeight, o = t.strideWidth, a = t.dilationHeight, i = t.dilationWidth, s = t.effectiveFilterHeight, u = t.effectiveFilterWidth, l = t.padInfo.top, c = t.padInfo.left, p = 0; p < t.batchSize; ++p) {
      for (var d = 0; d < t.inChannels; ++d) {
        for (var h = 0; h < t.outHeight; ++h) {
          for (var f = h * r - l, m = f; m < 0;) {
            m += a;
          }for (var g = Math.min(t.inHeight, s + f), v = 0; v < t.outWidth; ++v) {
            for (var y = v * o - c, x = y; x < 0;) {
              x += i;
            }for (var T = Math.min(t.inWidth, u + y), w = Number.NEGATIVE_INFINITY, E = -1, S = m; S < g; S += a) {
              for (var b = S - f, C = x; C < T; C += i) {
                var A = C - y,
                    _ = e.get(p, S, C, d);_ > w && (w = _, E = b * u + A);
              }
            }n.set(E, p, h, v, d);
          }
        }
      }
    }return n.toTensor();
  }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
    this.assertNotComplex([t, n], "maxPoolBackprop");for (var o = this.maxPoolPositions(t, r), a = r.strideHeight, i = r.strideWidth, s = r.dilationHeight, u = r.dilationWidth, l = r.effectiveFilterHeight, c = r.effectiveFilterWidth, p = c - 1 - r.padInfo.left, d = l - 1 - r.padInfo.top, h = buffer(t.shape, "float32"), f = 0; f < r.batchSize; ++f) {
      for (var m = 0; m < r.inChannels; ++m) {
        for (var g = 0; g < r.inHeight; ++g) {
          for (var v = 0; v < r.inWidth; ++v) {
            for (var y = g - d, x = v - p, T = 0, w = 0; w < l; w += s) {
              var E = (y + w) / a;if (!(E < 0 || E >= r.outHeight || Math.floor(E) !== E)) for (var S = 0; S < c; S += u) {
                var b = (x + S) / i;if (!(b < 0 || b >= r.outWidth || Math.floor(b) !== b)) {
                  var C = l * c - 1 - o.get(f, E, b, m) === w * c + S ? 1 : 0;if (0 !== C) T += e.get(f, E, b, m) * C;
                }
              }
            }h.set(T, f, g, v, m);
          }
        }
      }
    }return h.toTensor();
  }, e.prototype.avgPoolBackprop = function (e, t, n) {
    this.assertNotComplex([e, t], "avgPoolBackprop");for (var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = n.dilationHeight, u = n.dilationWidth, l = n.effectiveFilterHeight, c = n.effectiveFilterWidth, p = c - 1 - n.padInfo.left, d = l - 1 - n.padInfo.top, h = buffer(t.shape, "float32"), f = 1 / (a * i), m = 0; m < n.batchSize; ++m) {
      for (var g = 0; g < n.inChannels; ++g) {
        for (var v = 0; v < n.inHeight; ++v) {
          for (var y = 0; y < n.inWidth; ++y) {
            for (var x = v - d, T = y - p, w = 0, E = 0; E < l; E += s) {
              var S = (x + E) / r;if (!(S < 0 || S >= n.outHeight || Math.floor(S) !== S)) for (var b = 0; b < c; b += u) {
                var C = (T + b) / o;if (!(C < 0 || C >= n.outWidth || Math.floor(C) !== C)) w += e.get(m, S, C, g);
              }
            }h.set(w * f, m, v, y, g);
          }
        }
      }
    }return h.toTensor();
  }, e.prototype.cast = function (e, t) {
    return castTensor(e, t, this);
  }, e.prototype.reshape = function (e, t) {
    return reshapeTensor(e, t);
  }, e.prototype.avgPool = function (e, t) {
    return this.assertNotComplex(e, "avgPool"), this.pool(e, t, "avg").toFloat();
  }, e.prototype.resizeBilinear = function (e, t, n, r) {
    this.assertNotComplex(e, "resizeBilinear");for (var o = e.shape, a = o[0], i = o[1], s = o[2], u = o[3], l = e.dataSync(), c = new Float32Array(sizeFromShape([a, t, n, u])), p = [r && t > 1 ? i - 1 : i, r && n > 1 ? s - 1 : s], d = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n], h = 0, f = p[0] / d[0], m = p[1] / d[1], g = 0; g < a; g++) {
      for (var v = 0; v < t; v++) {
        for (var y = f * v, x = Math.floor(y), T = y - x, w = Math.min(i - 1, Math.ceil(y)), E = g * e.strides[0] + x * e.strides[1], S = g * e.strides[0] + w * e.strides[1], b = 0; b < n; b++) {
          for (var C = m * b, A = Math.floor(C), _ = C - A, N = Math.min(s - 1, Math.ceil(C)), R = E + A * e.strides[2], I = S + A * e.strides[2], k = E + +N * e.strides[2], D = S + N * e.strides[2], M = 0; M < u; M++) {
            var O = l[R + M],
                P = l[I + M],
                F = O + (l[k + M] - O) * _,
                L = F + (P + (l[D + M] - P) * _ - F) * T;c[h++] = L;
          }
        }
      }
    }return tensor(c, [a, t, n, u]);
  }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
    this.assertNotComplex([e, t], "resizeBilinearBackprop");for (var r = t.shape, o = r[0], a = r[1], i = r[2], s = r[3], u = e.shape, l = u[1], c = u[2], p = new Float32Array(o * a * i * s), d = [n && l > 1 ? a - 1 : a, n && c > 1 ? i - 1 : i], h = [n && l > 1 ? l - 1 : l, n && c > 1 ? c - 1 : c], f = d[0] / h[0], m = d[1] / h[1], g = e.dataSync(), v = 0, y = 0; y < o; y++) {
      for (var x = y * t.strides[0], T = 0; T < l; T++) {
        for (var w = T * f, E = Math.floor(w), S = Math.min(Math.ceil(w), a - 1), b = x + E * t.strides[1], C = x + S * t.strides[1], A = w - E, _ = 1 - A, N = 0; N < c; N++) {
          for (var R = N * m, I = Math.floor(R), k = Math.min(Math.ceil(R), i - 1), D = R - I, M = 1 - D, O = b + I * t.strides[2], P = b + k * t.strides[2], F = C + I * t.strides[2], L = C + k * t.strides[2], B = _ * M, U = _ * D, V = A * M, z = A * D, H = 0; H < s; H++) {
            var W = g[v++];p[O + H] += W * B, p[P + H] += W * U, p[F + H] += W * V, p[L + H] += W * z;
          }
        }
      }
    }return tensor4d(p, [o, i, a, s], t.dtype);
  }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
    this.assertNotComplex(e, "resizeNearestNeighbor");for (var o = e.shape, a = o[0], i = o[1], s = o[2], u = o[3], l = e.dataSync(), c = new Float32Array(a * t * n * u), p = [r && t > 1 ? i - 1 : i, r && n > 1 ? s - 1 : s], d = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n], h = p[0] / d[0], f = p[1] / d[1], m = 0, g = 0; g < a; g++) {
      for (var v = g * e.strides[0], y = 0; y < t; y++) {
        for (var x = h * y, T = v + Math.min(i - 1, r ? Math.round(x) : Math.floor(x)) * e.strides[1], w = 0; w < n; w++) {
          for (var E = f * w, S = T + Math.min(s - 1, r ? Math.round(E) : Math.floor(E)) * e.strides[2], b = 0; b < u; b++) {
            var C = l[S + b];c[m++] = C;
          }
        }
      }
    }return tensor(c, [a, t, n, u], e.dtype);
  }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
    this.assertNotComplex([e, t], "resizeNearestNeighborBackprop");for (var r = t.shape, o = r[0], a = r[1], i = r[2], s = r[3], u = e.shape, l = u[1], c = u[2], p = new Float32Array(o * a * i * s), d = e.dataSync(), h = [n && l > 1 ? a - 1 : a, n && c > 1 ? i - 1 : i], f = [n && l > 1 ? l - 1 : l, n && c > 1 ? c - 1 : c], m = h[0] / f[0], g = h[1] / f[1], v = 1 / m, y = 1 / g, x = 2 * Math.ceil(v) + 2, T = 2 * Math.ceil(y) + 2, w = 0; w < o; w++) {
      for (var E = w * t.strides[0], S = 0; S < a; S++) {
        for (var b = E + S * t.strides[1], C = Math.floor(S * v), A = Math.floor(C - x / 2), _ = 0; _ < i; _++) {
          for (var N = b + _ * t.strides[2], R = Math.floor(_ * y), I = Math.floor(R - T / 2), k = 0; k < s; k++) {
            for (var D = 0, M = 0; M < x; M++) {
              var O = M + A;if (!(O < 0 || O >= l)) {
                var P = E + O * e.strides[1],
                    F = O * m;if (S === Math.min(a - 1, n ? Math.round(F) : Math.floor(F))) for (var L = 0; L < T; L++) {
                  var B = L + I;if (!(B < 0 || B >= c)) {
                    var U = P + B * e.strides[2],
                        V = B * g;_ === Math.min(i - 1, n ? Math.round(V) : Math.floor(V)) && (D += d[U + k]);
                  }
                }
              }
            }p[N + k] = D;
          }
        }
      }
    }return tensor4d(p, t.shape, t.dtype);
  }, e.prototype.batchNormalization = function (e, t, n, r, o, a) {
    this.assertNotComplex([e, t, n, o, a], "batchNormalization");for (var i = e.dataSync(), s = t.dataSync(), u = n.dataSync(), l = o ? o.dataSync() : new Float32Array([1]), c = a ? a.dataSync() : new Float32Array([0]), p = new Float32Array(i.length), d = c.length, h = l.length, f = u.length, m = s.length, g = 0, v = 0, y = 0, x = 0, T = 0; T < i.length; ++T) {
      p[T] = c[g++] + (i[T] - s[v++]) * l[y++] / Math.sqrt(u[x++] + r), g >= d && (g = 0), v >= m && (v = 0), y >= h && (y = 0), x >= f && (x = 0);
    }return tensor4d(p, e.shape);
  }, e.prototype.localResponseNormalization4D = function (e, t, n, r, o) {
    this.assertNotComplex(e, "localResponseNormalization4D");var a = e.shape[3],
        i = a - 1,
        s = e.dataSync(),
        u = sizeFromShape(e.shape),
        l = new Float32Array(u);function c(e) {
      for (var n = e % a, r = e - n + Math.max(0, n - t), o = e - n + Math.min(n + t, i), u = 0; r <= o; r++) {
        var l = s[r];u += l * l;
      }return u;
    }for (var p = 0; p < u; p++) {
      var d = c(p),
          h = s[p] * Math.pow(n + r * d, -o);l[p] = h;
    }return tensor4d(l, e.shape);
  }, e.prototype.LRNGrad = function (e, t, n, r, o, a, i) {
    this.assertNotComplex(e, "LRNGrad");for (var s = e.shape[3], u = e.dataSync(), l = t.dataSync(), c = n.dataSync(), p = new Float32Array(sizeFromShape(e.shape)), d = sizeFromShape(e.shape), h = 0; h < d; h++) {
      for (var f = h % s, m = h - f + Math.max(0, f - r), g = h - f + Math.min(s, f + r + 1), v = 0, y = m; y < g; y++) {
        v += Math.pow(l[y], 2);
      }v = a * v + o;for (y = m; y < g; y++) {
        var x = -2 * a * i * l[y] * c[h] / v;h === y && (x += Math.pow(v, -i)), x *= u[h], p[y] += x;
      }
    }return tensor4d(p, e.shape);
  }, e.prototype.multinomial = function (e, t, n, r) {
    this.assertNotComplex(e, "multinomial");for (var o = t ? e : softmax(e), a = o.shape[0], i = o.shape[1], s = zeros([a, n], "int32"), u = s.dataSync(), l = o.dataSync(), c = 0; c < a; ++c) {
      var p = c * i,
          d = new Float32Array(i - 1);d[0] = l[p];for (var h = 1; h < d.length; ++h) {
        d[h] = d[h - 1] + l[p + h];
      }for (var f = seedrandom_1(r.toString()), m = c * n, g = 0; g < n; ++g) {
        var v = f();u[m + g] = d.length;for (var y = 0; y < d.length; y++) {
          if (v < d[y]) {
            u[m + g] = y;break;
          }
        }
      }
    }return s;
  }, e.prototype.oneHot = function (e, t, n, r) {
    this.assertNotComplex(e, "oneHot");var o = new Float32Array(e.size * t);o.fill(r);for (var a = 0; a < e.size; ++a) {
      e.get(a) >= 0 && e.get(a) < t && (o[a * t + e.get(a)] = n);
    }return tensor2d(o, [e.size, t], "int32");
  }, e.prototype.nonMaxSuppression = function (e, t, n, r, o) {
    return this.assertNotComplex(e, "nonMaxSuppression"), nonMaxSuppressionImpl(e.dataSync(), t.dataSync(), n, r, o);
  }, e.prototype.fft = function (e) {
    return this.fftBatch(e, !1);
  }, e.prototype.ifft = function (e) {
    return this.fftBatch(e, !0);
  }, e.prototype.fftBatch = function (e, t) {
    for (var n = e.shape[0], r = e.shape[1], o = buffer(e.shape, "float32"), a = buffer(e.shape, "float32"), i = real(e).as2D(n, r), s = imag(e).as2D(n, r), u = 0; u < n; u++) {
      for (var l = i.slice([u, 0], [1, r]), c = s.slice([u, 0], [1, r]), p = complex(l, c), d = this.fftImpl(p, t).dataSync(), h = 0; h < r; h++) {
        var f = getComplexWithIndex(d, h);o.values[u * r + h] = f.real, a.values[u * r + h] = f.imag;
      }
    }return complex(o.toTensor(), a.toTensor()).as2D(n, r);
  }, e.prototype.fftImpl = function (e, t) {
    var n = e.as1D(),
        r = n.size;if (this.isExponentOf2(r)) {
      var o = this.fftRadix2(n, r, t).as2D(e.shape[0], e.shape[1]);return t && (o = complex(real(o).div(scalar(r)), imag(o).div(scalar(r)))), o;
    }var a = e.dataSync(),
        i = splitRealAndImagArrays(this.fourierTransformByMatmul(a, r, t));return complex(i.real, i.imag).as2D(e.shape[0], e.shape[1]);
  }, e.prototype.isExponentOf2 = function (e) {
    return 0 == (e & e - 1);
  }, e.prototype.fftRadix2 = function (e, t, n) {
    if (1 === t) return e;var r = e.dataSync(),
        o = t / 2,
        a = complexWithEvenIndex(r),
        i = complex(a.real, a.imag).as1D(),
        s = complexWithOddIndex(r),
        u = complex(s.real, s.imag).as1D();i = this.fftRadix2(i, o, n), u = this.fftRadix2(u, o, n);var l = exponents(t, n),
        c = complex(l.real, l.imag).mul(u),
        p = i.add(c),
        d = i.sub(c),
        h = real(p).concat(real(d)),
        f = imag(p).concat(imag(d));return complex(h, f).as1D();
  }, e.prototype.fourierTransformByMatmul = function (e, t, n) {
    for (var r = new Float32Array(2 * t), o = 0; o < t; o++) {
      for (var a = 0, i = 0, s = 0; s < t; s++) {
        var u = exponent(o * s, t, n),
            l = getComplexWithIndex(e, s);a += l.real * u.real - l.imag * u.imag, i += l.real * u.imag + l.imag * u.real;
      }n && (a /= t, i /= t), assignToTypedArray(r, a, i, o);
    }return r;
  }, e.prototype.depthToSpace = function (e, t, n) {
    assert("NHWC" === n, "Only NHWC dataFormat supported on CPU for depthToSpace. Got " + n), assert(t > 1, "blockSize should be > 1 for depthToSpace, but was: " + t);for (var r = e.shape[0], o = e.shape[1], a = e.shape[2], i = e.shape[3], s = o * t, u = a * t, l = i / (t * t), c = e.dataSync(), p = new Float32Array(r * s * u * l), d = 0, h = 0; h < r; ++h) {
      for (var f = 0; f < s; ++f) {
        for (var m = Math.floor(f / t), g = f % t, v = 0; v < u; ++v) {
          for (var y = Math.floor(v / t), x = (g * t + v % t) * l, T = 0; T < l; ++T) {
            var w = T + x + i * (y + a * (m + o * h));p[d++] = c[w];
          }
        }
      }
    }return tensor4d(p, [r, s, u, l]);
  }, e.prototype.broadcastedBinaryOp = function (e, t, n, r) {
    var o = assertAndGetBroadcastShape(e.shape, t.shape),
        a = buffer(o, n),
        i = e.dataSync(),
        s = t.dataSync(),
        u = getBroadcastDims(e.shape, o),
        l = getBroadcastDims(t.shape, o),
        c = a.values;if (u.length + l.length === 0) for (var p = 0; p < c.length; ++p) {
      c[p] = r(i[p % i.length], s[p % s.length]);
    } else {
      var d = e.buffer(),
          h = t.buffer(),
          f = function f(n) {
        var o = a.indexToLoc(n),
            p = o.slice(-e.rank);u.forEach(function (e) {
          return p[e] = 0;
        });var f = d.locToIndex(p),
            m = o.slice(-t.rank);l.forEach(function (e) {
          return m[e] = 0;
        });var g = h.locToIndex(m);c[n] = r(i[f], s[g]);
      };for (p = 0; p < c.length; ++p) {
        f(p);
      }
    }return a.toTensor();
  }, e.prototype.broadcastedBinaryComplexOp = function (e, t, n) {
    var r = assertAndGetBroadcastShape(e.shape, t.shape),
        o = buffer(r, "float32"),
        a = buffer(r, "float32"),
        i = e.dataSync(),
        s = t.dataSync(),
        u = getBroadcastDims(e.shape, r),
        l = getBroadcastDims(t.shape, r),
        c = o.values,
        p = a.values;if (u.length + l.length === 0) for (var d = 0; d < c.length; d++) {
      var h = d % i.length,
          f = d % s.length,
          m = n(i[2 * h], i[2 * h + 1], s[2 * f], s[2 * f + 1]);c[d] = m.real, p[d] = m.imag;
    } else {
      var g = this.data.get(e.dataId).complexTensors.real.buffer(),
          v = this.data.get(t.dataId).complexTensors.real.buffer(),
          y = function y(r) {
        var a = o.indexToLoc(r),
            d = a.slice(-e.rank);u.forEach(function (e) {
          return d[e] = 0;
        });var h = g.locToIndex(d),
            f = a.slice(-t.rank);l.forEach(function (e) {
          return f[e] = 0;
        });var m = v.locToIndex(f),
            y = n(i[2 * h], i[2 * h + 1], s[2 * m], s[2 * m + 1]);c[r] = y.real, p[r] = y.imag;
      };for (d = 0; d < c.length; d++) {
        y(d);
      }
    }return this.complex(o.toTensor(), a.toTensor());
  }, e.prototype.split = function (e, t, n) {
    return split(e, t, n);
  }, e.prototype.dispose = function () {}, e.prototype.floatPrecision = function () {
    return 32;
  }, e.prototype.cropAndResize = function (e, t, n, r, o, a) {
    for (var i = e.shape, s = i[0], u = i[1], l = i[2], c = i[3], p = t.shape[0], d = r[0], h = r[1], f = buffer([p, d, h, c], e.dtype), m = t.dataSync(), g = n.dataSync(), v = e.dataSync(), y = e.strides, x = f.strides, T = 0; T < p; T++) {
      var w = 4 * T,
          E = m[w],
          S = m[w + 1],
          b = m[w + 2],
          C = m[w + 3],
          A = g[T];if (!(A >= s)) for (var _ = d > 1 ? (b - E) * (u - 1) / (d - 1) : 0, N = h > 1 ? (C - S) * (l - 1) / (h - 1) : 0, R = 0; R < d; R++) {
        var I = d > 1 ? E * (u - 1) + R * _ : .5 * (E + b) * (u - 1);if (I < 0 || I > u - 1) for (var k = 0; k < h; k++) {
          for (var D = 0; D < c; D++) {
            var M = D + k * x[2] + R * x[1] + T * x[0];f.values[M] = a;
          }
        } else if ("bilinear" === o) {
          var O = Math.floor(I),
              P = Math.ceil(I),
              F = I - O;for (k = 0; k < h; k++) {
            if ((q = h > 1 ? S * (l - 1) + k * N : .5 * (S + C) * (l - 1)) < 0 || q > l - 1) for (D = 0; D < c; D++) {
              M = D + k * x[2] + R * x[1] + T * x[0];f.values[M] = a;
            } else {
              var L = Math.floor(q),
                  B = Math.ceil(q),
                  U = q - L;for (D = 0; D < c; D++) {
                var V = v[M = D + L * y[2] + O * y[1] + A * y[0]],
                    z = v[M = D + B * y[2] + O * y[1] + A * y[0]],
                    H = v[M = D + L * y[2] + P * y[1] + A * y[0]],
                    W = V + (z - V) * U,
                    G = H + (v[M = D + B * y[2] + P * y[1] + A * y[0]] - H) * U;M = D + k * x[2] + R * x[1] + T * x[0], f.values[M] = W + (G - W) * F;
              }
            }
          }
        } else for (k = 0; k < h; ++k) {
          var q;if ((q = h > 1 ? S * (l - 1) + k * N : .5 * (S + C) * (l - 1)) < 0 || q > l - 1) for (D = 0; D < c; D++) {
            M = D + k * x[2] + R * x[1] + T * x[0];f.values[M] = a;
          } else {
            var $ = Math.round(q),
                X = Math.round(I);for (D = 0; D < c; D++) {
              var K = D + $ * y[2] + X * y[1] + A * y[0],
                  j = D + k * x[2] + R * x[1] + T * x[0];f.values[j] = v[K];
            }
          }
        }
      }
    }return f.toTensor();
  }, e.prototype.sparseToDense = function (e, t, n, r) {
    var o = calculateShapes(t, e, n),
        a = o.sliceRank,
        i = o.numUpdates,
        s = o.sliceSize,
        u = o.strides,
        l = o.outputSize;return this.scatter(e, t, n, l, s, i, a, u, r, !1);
  }, e.prototype.gatherND = function (e, t) {
    var n = t.shape,
        r = n[n.length - 1],
        o = prepareAndValidate(e, t),
        a = o[0],
        i = o[1],
        s = o[2],
        u = o[3];if (0 === i) return tensor([], a, e.dtype);for (var l = new TensorBuffer([i, s], e.dtype), c = t.dataSync(), p = e.dataSync(), d = 0; d < i; d++) {
      for (var h = [], f = 0, m = 0; m < r; m++) {
        var g = c[d * r + m];f += g * u[m], h.push(g);
      }if (f < 0 || f >= e.size / s) throw new Error("Invalid indices: " + h + " does not index into " + e.shape);for (var v = 0; v < s; v++) {
        l.values[d * s + v] = p[f * s + v];
      }
    }return l.toTensor().reshape(a);
  }, e.prototype.scatterND = function (e, t, n) {
    var r = calculateShapes(t, e, n),
        o = r.sliceRank,
        a = r.numUpdates,
        i = r.sliceSize,
        s = r.strides,
        u = r.outputSize,
        l = scalar(0);return this.scatter(e, t, n, u, i, a, o, s, l, !0);
  }, e.prototype.scatter = function (e, t, n, r, o, a, i, s, u, l) {
    var c = [r / o, o],
        p = e.dataSync(),
        d = t.dataSync();if (0 === r) return tensor([], n, t.dtype);var h = new TensorBuffer(c, t.dtype);h.values.fill(u.dataSync()[0]);for (var f = 0; f < a; f++) {
      for (var m = [], g = 0, v = 0; v < i; v++) {
        var y = p[f * i + v];m.push(y), g += y * s[v];
      }if (g < 0 || g >= r / o) throw new Error("Invalid indices: " + m + " does not index into " + n);for (var x = 0; x < o; x++) {
        l ? h.values[g * o + x] += d[f * o + x] : h.values[g * o + x] = 0 === t.rank ? d[0] : d[f * o + x];
      }
    }return h.toTensor().reshape(n);
  }, e;
}();ENV.registerBackend("cpu", function () {
  return new MathBackendCPU();
}, 1, setTensorTracker);var delayCallback = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setImmediate;function nextFrame() {
  return new Promise(function (e) {
    return delayCallback(function () {
      return e();
    });
  });
}var DTYPE_VALUE_SIZE_MAP = { float32: 4, int32: 4, uint16: 2, uint8: 1, bool: 1 };function encodeWeights(e) {
  return __awaiter(this, void 0, void 0, function () {
    var t, n, r, o;return __generator(this, function (a) {
      switch (a.label) {case 0:
          for (r in t = [], n = [], e) {
            if ("float32" !== (o = e[r]).dtype && "int32" !== o.dtype && "bool" !== o.dtype) throw new Error("Unsupported dtype in weight '" + r + "': " + o.dtype);t.push({ name: r, shape: o.shape, dtype: o.dtype }), n.push(o.data());
          }return [4, Promise.all(n)];case 1:
          return [2, { data: concatenateTypedArrays(a.sent()), specs: t }];}
    });
  });
}function decodeWeights(e, t) {
  for (var n = {}, r = 0, o = function o(t) {
    var o = t.name,
        a = t.dtype,
        i = t.shape,
        s = sizeFromShape(i),
        u = void 0;if (("quantization" in t)) {
      var l = t.quantization;if ("uint8" !== l.dtype && "uint16" !== l.dtype) throw new Error("Weight " + t.name + " has unknown quantization dtype " + l.dtype + ". Supported quantization dtypes are: 'uint8' and 'uint16'.");var c = DTYPE_VALUE_SIZE_MAP[l.dtype],
          p = e.slice(r, r + s * c),
          d = "uint8" === l.dtype ? new Uint8Array(p) : new Uint16Array(p);if ("float32" === a) u = Float32Array.from(d, function (e) {
        return e * l.scale + l.min;
      });else {
        if ("int32" !== a) throw new Error("Unsupported dtype in weight '" + o + "': " + a);u = Int32Array.from(d, function (e) {
          return Math.round(e * l.scale + l.min);
        });
      }r += s * c;
    } else {
      var h = DTYPE_VALUE_SIZE_MAP[a];p = e.slice(r, r + s * h);if ("float32" === a) u = new Float32Array(p);else if ("int32" === a) u = new Int32Array(p);else {
        if ("bool" !== a) throw new Error("Unsupported dtype in weight '" + o + "': " + a);u = new Uint8Array(p);
      }r += s * h;
    }var f = void 0;if ("float32" === a) f = tensor(u, i, "float32");else if ("int32" === a) f = tensor(u, i, "int32");else {
      if ("bool" !== a) throw new Error("Unsupported dtype in weight '" + o + "': " + a);f = tensor(u, i, "bool");
    }n[o] = f;
  }, a = 0, i = t; a < i.length; a++) {
    o(i[a]);
  }return n;
}function concatenateTypedArrays(e) {
  if (null === e) throw new Error("Invalid input value: " + JSON.stringify(e));var t = 0,
      n = [];e.forEach(function (e) {
    if (t += e.byteLength, n.push(e.byteLength === e.buffer.byteLength ? e : new e.constructor(e)), !(e instanceof Float32Array || e instanceof Int32Array || e instanceof Uint8Array)) throw new Error("Unsupported TypedArray subtype: " + e.constructor.name);
  });var r = new Uint8Array(t),
      o = 0;return n.forEach(function (e) {
    r.set(new Uint8Array(e.buffer), o), o += e.byteLength;
  }), r.buffer;
}var useNodeBuffer = "undefined" != typeof Buffer && ("undefined" == typeof Blob || "undefined" == typeof atob || "undefined" == typeof btoa);function stringByteLength(e) {
  return useNodeBuffer ? Buffer.byteLength(e) : new Blob([e]).size;
}function arrayBufferToBase64String(e) {
  return useNodeBuffer ? Buffer.from(e).toString("base64") : btoa(String.fromCharCode.apply(null, new Uint8Array(e)));
}function base64StringToArrayBuffer(e) {
  if (useNodeBuffer) {
    var t = Buffer.from(e, "base64");return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
  }for (var n = atob(e), r = new Uint8Array(n.length), o = 0; o < n.length; ++o) {
    r.set([n.charCodeAt(o)], o);
  }return r.buffer;
}function concatenateArrayBuffers(e) {
  var t = 0;e.forEach(function (e) {
    t += e.byteLength;
  });var n = new Uint8Array(t),
      r = 0;return e.forEach(function (e) {
    n.set(new Uint8Array(e), r), r += e.byteLength;
  }), n.buffer;
}function basename(e) {
  for (e = e.trim(); e.endsWith("/");) {
    e = e.slice(0, e.length - 1);
  }var t = e.split("/");return t[t.length - 1];
}function getModelArtifactsInfoForJSON(e) {
  if (e.modelTopology instanceof ArrayBuffer) throw new Error("Expected JSON model topology, received ArrayBuffer.");return { dateSaved: new Date(), modelTopologyType: "JSON", modelTopologyBytes: null == e.modelTopology ? 0 : stringByteLength(JSON.stringify(e.modelTopology)), weightSpecsBytes: null == e.weightSpecs ? 0 : stringByteLength(JSON.stringify(e.weightSpecs)), weightDataBytes: null == e.weightData ? 0 : e.weightData.byteLength };
}var IORouterRegistry = function () {
  function e() {
    this.saveRouters = [], this.loadRouters = [];
  }return e.getInstance = function () {
    return null == e.instance && (e.instance = new e()), e.instance;
  }, e.registerSaveRouter = function (t) {
    e.getInstance().saveRouters.push(t);
  }, e.registerLoadRouter = function (t) {
    e.getInstance().loadRouters.push(t);
  }, e.getSaveHandlers = function (t) {
    return e.getHandlers(t, "save");
  }, e.getLoadHandlers = function (t) {
    return e.getHandlers(t, "load");
  }, e.getHandlers = function (e, t) {
    var n = [];return ("load" === t ? this.getInstance().loadRouters : this.getInstance().saveRouters).forEach(function (t) {
      var r = t(e);null !== r && n.push(r);
    }), n;
  }, e;
}(),
    URL_SCHEME_SUFFIX = "://",
    ModelStoreManagerRegistry = function () {
  function e() {
    this.managers = {};
  }return e.getInstance = function () {
    return null == e.instance && (e.instance = new e()), e.instance;
  }, e.registerManager = function (t, n) {
    assert(null != t, "scheme must not be undefined or null."), t.endsWith(URL_SCHEME_SUFFIX) && (t = t.slice(0, t.indexOf(URL_SCHEME_SUFFIX))), assert(t.length > 0, "scheme must not be an empty string.");var r = e.getInstance();assert(null == r.managers[t], "A model store manager is already registered for scheme '" + t + "'."), r.managers[t] = n;
  }, e.getManager = function (e) {
    var t = this.getInstance().managers[e];if (null == t) throw new Error("Cannot find model manager for scheme '" + e + "'");return t;
  }, e.getSchemes = function () {
    return Object.keys(this.getInstance().managers);
  }, e;
}();function parseURL(e) {
  if (-1 === e.indexOf(URL_SCHEME_SUFFIX)) throw new Error("The url string provided does not contain a scheme. Supported schemes are: " + ModelStoreManagerRegistry.getSchemes().join(","));return { scheme: e.split(URL_SCHEME_SUFFIX)[0], path: e.split(URL_SCHEME_SUFFIX)[1] };
}function cloneModelInternal(e, t, n) {
  return void 0 === n && (n = !1), __awaiter(this, void 0, void 0, function () {
    var r, o, a, i, s, u, l, c, p;return __generator(this, function (d) {
      switch (d.label) {case 0:
          return assert(e !== t, "Old path and new path are the same: '" + e + "'"), assert((r = IORouterRegistry.getLoadHandlers(e)).length > 0, "Copying failed because no load handler is found for source URL " + e + "."), assert(r.length < 2, "Copying failed because more than one (" + r.length + ") load handlers for source URL " + e + "."), o = r[0], assert((a = IORouterRegistry.getSaveHandlers(t)).length > 0, "Copying failed because no save handler is found for destination URL " + t + "."), assert(a.length < 2, "Copying failed because more than one (" + r.length + ") save handlers for destination URL " + t + "."), i = a[0], s = parseURL(e).scheme, u = parseURL(e).path, l = s === parseURL(e).scheme, [4, o.load()];case 1:
          return c = d.sent(), n && l ? [4, ModelStoreManagerRegistry.getManager(s).removeModel(u)] : [3, 3];case 2:
          d.sent(), d.label = 3;case 3:
          return [4, i.save(c)];case 4:
          return p = d.sent(), !n || l ? [3, 6] : [4, ModelStoreManagerRegistry.getManager(s).removeModel(u)];case 5:
          d.sent(), d.label = 6;case 6:
          return [2, p.modelArtifactsInfo];}
    });
  });
}function listModels() {
  return __awaiter(this, void 0, void 0, function () {
    var e, t, n, r, o, a, i;return __generator(this, function (s) {
      switch (s.label) {case 0:
          e = ModelStoreManagerRegistry.getSchemes(), t = {}, n = 0, r = e, s.label = 1;case 1:
          return n < r.length ? (o = r[n], [4, ModelStoreManagerRegistry.getManager(o).listModels()]) : [3, 4];case 2:
          for (i in a = s.sent()) {
            t[o + URL_SCHEME_SUFFIX + i] = a[i];
          }s.label = 3;case 3:
          return n++, [3, 1];case 4:
          return [2, t];}
    });
  });
}function removeModel(e) {
  return __awaiter(this, void 0, void 0, function () {
    var t;return __generator(this, function (n) {
      switch (n.label) {case 0:
          return t = parseURL(e), [4, ModelStoreManagerRegistry.getManager(t.scheme).removeModel(t.path)];case 1:
          return [2, n.sent()];}
    });
  });
}function copyModel(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (n) {
      switch (n.label) {case 0:
          return [4, cloneModelInternal(e, t, !1)];case 1:
          return [2, n.sent()];}
    });
  });
}function moveModel(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (n) {
      switch (n.label) {case 0:
          return [4, cloneModelInternal(e, t, !0)];case 1:
          return [2, n.sent()];}
    });
  });
}var DATABASE_NAME = "tensorflowjs",
    DATABASE_VERSION = 1,
    MODEL_STORE_NAME = "models_store",
    INFO_STORE_NAME = "model_info_store";function getIndexedDBFactory() {
  if (!ENV.get("IS_BROWSER")) throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");var e = window,
      t = e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB || e.shimIndexedDB;if (null == t) throw new Error("The current browser does not appear to support IndexedDB.");return t;
}function setUpDatabase(e) {
  var t = e.result;t.createObjectStore(MODEL_STORE_NAME, { keyPath: "modelPath" }), t.createObjectStore(INFO_STORE_NAME, { keyPath: "modelPath" });
}var BrowserIndexedDB = function () {
  function e(e) {
    if (this.indexedDB = getIndexedDBFactory(), null == e || !e) throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");this.modelPath = e;
  }return e.prototype.save = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");return [2, this.databaseAction(this.modelPath, e)];
      });
    });
  }, e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, this.databaseAction(this.modelPath)];
      });
    });
  }, e.prototype.databaseAction = function (e, t) {
    var n = this;return new Promise(function (e, r) {
      var o = n.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);o.onupgradeneeded = function () {
        return setUpDatabase(o);
      }, o.onsuccess = function () {
        var a = o.result;if (null == t) {
          var i = a.transaction(MODEL_STORE_NAME, "readonly"),
              s = i.objectStore(MODEL_STORE_NAME).get(n.modelPath);s.onsuccess = function () {
            if (null == s.result) return a.close(), r(new Error("Cannot find model with path '" + n.modelPath + "' in IndexedDB."));e(s.result.modelArtifacts);
          }, s.onerror = function (e) {
            return a.close(), r(s.error);
          }, i.oncomplete = function () {
            return a.close();
          };
        } else {
          var u,
              l = getModelArtifactsInfoForJSON(t),
              c = a.transaction(INFO_STORE_NAME, "readwrite"),
              p = c.objectStore(INFO_STORE_NAME),
              d = p.put({ modelPath: n.modelPath, modelArtifactsInfo: l });d.onsuccess = function () {
            var o = (u = a.transaction(MODEL_STORE_NAME, "readwrite")).objectStore(MODEL_STORE_NAME).put({ modelPath: n.modelPath, modelArtifacts: t, modelArtifactsInfo: l });o.onsuccess = function () {
              return e({ modelArtifactsInfo: l });
            }, o.onerror = function (e) {
              var t = (p = c.objectStore(INFO_STORE_NAME)).delete(n.modelPath);t.onsuccess = function () {
                return a.close(), r(o.error);
              }, t.onerror = function (e) {
                return a.close(), r(o.error);
              };
            };
          }, d.onerror = function (e) {
            return a.close(), r(d.error);
          }, c.oncomplete = function () {
            null == u ? a.close() : u.oncomplete = function () {
              return a.close();
            };
          };
        }
      }, o.onerror = function (e) {
        return r(o.error);
      };
    });
  }, e.URL_SCHEME = "indexeddb://", e;
}(),
    indexedDBRouter = function indexedDBRouter(e) {
  return ENV.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(BrowserIndexedDB.URL_SCHEME) ? browserIndexedDB(e.slice(BrowserIndexedDB.URL_SCHEME.length)) : null;
};function browserIndexedDB(e) {
  return new BrowserIndexedDB(e);
}function maybeStripScheme(e) {
  return e.startsWith(BrowserIndexedDB.URL_SCHEME) ? e.slice(BrowserIndexedDB.URL_SCHEME.length) : e;
}IORouterRegistry.registerSaveRouter(indexedDBRouter), IORouterRegistry.registerLoadRouter(indexedDBRouter);var BrowserIndexedDBManager = function () {
  function e() {
    this.indexedDB = getIndexedDBFactory();
  }return e.prototype.listModels = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e = this;return __generator(this, function (t) {
        return [2, new Promise(function (t, n) {
          var r = e.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);r.onupgradeneeded = function () {
            return setUpDatabase(r);
          }, r.onsuccess = function () {
            var e = r.result,
                o = e.transaction(INFO_STORE_NAME, "readonly"),
                a = o.objectStore(INFO_STORE_NAME).getAll();a.onsuccess = function () {
              for (var e = {}, n = 0, r = a.result; n < r.length; n++) {
                var o = r[n];e[o.modelPath] = o.modelArtifactsInfo;
              }t(e);
            }, a.onerror = function (t) {
              return e.close(), n(a.error);
            }, o.oncomplete = function () {
              return e.close();
            };
          }, r.onerror = function (e) {
            return n(r.error);
          };
        })];
      });
    });
  }, e.prototype.removeModel = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (n) {
        return e = maybeStripScheme(e), [2, new Promise(function (n, r) {
          var o = t.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);o.onupgradeneeded = function () {
            return setUpDatabase(o);
          }, o.onsuccess = function () {
            var t,
                a = o.result,
                i = a.transaction(INFO_STORE_NAME, "readwrite"),
                s = i.objectStore(INFO_STORE_NAME),
                u = s.get(e);u.onsuccess = function () {
              if (null == u.result) return a.close(), r(new Error("Cannot find model with path '" + e + "' in IndexedDB."));var o = s.delete(e),
                  i = function i() {
                var o = (t = a.transaction(MODEL_STORE_NAME, "readwrite")).objectStore(MODEL_STORE_NAME).delete(e);o.onsuccess = function () {
                  return n(u.result.modelArtifactsInfo);
                }, o.onerror = function (e) {
                  return r(u.error);
                };
              };o.onsuccess = i, o.onerror = function (e) {
                return i(), a.close(), r(u.error);
              };
            }, u.onerror = function (e) {
              return a.close(), r(u.error);
            }, i.oncomplete = function () {
              null == t ? a.close() : t.oncomplete = function () {
                return a.close();
              };
            };
          }, o.onerror = function (e) {
            return r(o.error);
          };
        })];
      });
    });
  }, e;
}();if (ENV.get("IS_BROWSER")) try {
  ModelStoreManagerRegistry.registerManager(BrowserIndexedDB.URL_SCHEME, new BrowserIndexedDBManager());
} catch (e) {}var PATH_SEPARATOR = "/",
    PATH_PREFIX = "tensorflowjs_models",
    INFO_SUFFIX = "info",
    MODEL_TOPOLOGY_SUFFIX = "model_topology",
    WEIGHT_SPECS_SUFFIX = "weight_specs",
    WEIGHT_DATA_SUFFIX = "weight_data";function getModelKeys(e) {
  return { info: [PATH_PREFIX, e, INFO_SUFFIX].join(PATH_SEPARATOR), topology: [PATH_PREFIX, e, MODEL_TOPOLOGY_SUFFIX].join(PATH_SEPARATOR), weightSpecs: [PATH_PREFIX, e, WEIGHT_SPECS_SUFFIX].join(PATH_SEPARATOR), weightData: [PATH_PREFIX, e, WEIGHT_DATA_SUFFIX].join(PATH_SEPARATOR) };
}function getModelPathFromKey(e) {
  var t = e.split(PATH_SEPARATOR);if (t.length < 3) throw new Error("Invalid key format: " + e);return t.slice(1, t.length - 1).join(PATH_SEPARATOR);
}function maybeStripScheme$1(e) {
  return e.startsWith(BrowserLocalStorage.URL_SCHEME) ? e.slice(BrowserLocalStorage.URL_SCHEME.length) : e;
}var BrowserLocalStorage = function () {
  function e(e) {
    if (!ENV.get("IS_BROWSER") || void 0 === window.localStorage) throw new Error("The current environment does not support local storage.");if (this.LS = window.localStorage, null == e || !e) throw new Error("For local storage, modelPath must not be null, undefined or empty.");this.modelPath = e, this.keys = getModelKeys(this.modelPath);
  }return e.prototype.save = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o;return __generator(this, function (a) {
        if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");t = JSON.stringify(e.modelTopology), n = JSON.stringify(e.weightSpecs), r = getModelArtifactsInfoForJSON(e);try {
          return this.LS.setItem(this.keys.info, JSON.stringify(r)), this.LS.setItem(this.keys.topology, t), this.LS.setItem(this.keys.weightSpecs, n), this.LS.setItem(this.keys.weightData, arrayBufferToBase64String(e.weightData)), [2, { modelArtifactsInfo: r }];
        } catch (e) {
          for (o in this.keys) {
            this.LS.removeItem(this.keys[o]);
          }throw new Error("Failed to save model '" + this.modelPath + "' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=" + r.modelTopologyBytes + ", weightSpecsBytes=" + r.weightSpecsBytes + ", weightDataBytes=" + r.weightDataBytes + ".");
        }return [2];
      });
    });
  }, e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, n, r, o;return __generator(this, function (a) {
        if (null == (e = JSON.parse(this.LS.getItem(this.keys.info)))) throw new Error("In local storage, there is no model with name '" + this.modelPath + "'");if ("JSON" !== e.modelTopologyType) throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");if (t = {}, null == (n = JSON.parse(this.LS.getItem(this.keys.topology)))) throw new Error("In local storage, the topology of model '" + this.modelPath + "' is missing.");if (t.modelTopology = n, null == (r = JSON.parse(this.LS.getItem(this.keys.weightSpecs)))) throw new Error("In local storage, the weight specs of model '" + this.modelPath + "' are missing.");if (t.weightSpecs = r, null == (o = this.LS.getItem(this.keys.weightData))) throw new Error("In local storage, the binary weight values of model '" + this.modelPath + "' are missing.");return t.weightData = base64StringToArrayBuffer(o), [2, t];
      });
    });
  }, e.URL_SCHEME = "localstorage://", e;
}(),
    localStorageRouter = function localStorageRouter(e) {
  return ENV.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(BrowserLocalStorage.URL_SCHEME) ? browserLocalStorage(e.slice(BrowserLocalStorage.URL_SCHEME.length)) : null;
};function browserLocalStorage(e) {
  return new BrowserLocalStorage(e);
}IORouterRegistry.registerSaveRouter(localStorageRouter), IORouterRegistry.registerLoadRouter(localStorageRouter);var BrowserLocalStorageManager = function () {
  function e() {
    assert(ENV.get("IS_BROWSER"), "Current environment is not a web browser"), assert(void 0 !== window.localStorage, "Current browser does not appear to support localStorage"), this.LS = window.localStorage;
  }return e.prototype.listModels = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, n, r, o, a;return __generator(this, function (i) {
        for (e = {}, t = PATH_PREFIX + PATH_SEPARATOR, n = PATH_SEPARATOR + INFO_SUFFIX, r = 0; r < this.LS.length; ++r) {
          (o = this.LS.key(r)).startsWith(t) && o.endsWith(n) && (a = getModelPathFromKey(o), e[a] = JSON.parse(this.LS.getItem(o)));
        }return [2, e];
      });
    });
  }, e.prototype.removeModel = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n;return __generator(this, function (r) {
        if (e = maybeStripScheme$1(e), t = getModelKeys(e), null == this.LS.getItem(t.info)) throw new Error("Cannot find model at path '" + e + "'");return n = JSON.parse(this.LS.getItem(t.info)), this.LS.removeItem(t.info), this.LS.removeItem(t.topology), this.LS.removeItem(t.weightSpecs), this.LS.removeItem(t.weightData), [2, n];
      });
    });
  }, e;
}();if (ENV.get("IS_BROWSER")) try {
  ModelStoreManagerRegistry.registerManager(BrowserLocalStorage.URL_SCHEME, new BrowserLocalStorageManager());
} catch (e) {}var DEFAULT_FILE_NAME_PREFIX = "model",
    DEFAULT_JSON_EXTENSION_NAME = ".json",
    DEFAULT_WEIGHT_DATA_EXTENSION_NAME = ".weights.bin",
    BrowserDownloads = function () {
  function e(t) {
    if (!ENV.get("IS_BROWSER")) throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");t.startsWith(e.URL_SCHEME) && (t = t.slice(e.URL_SCHEME.length)), null != t && 0 !== t.length || (t = DEFAULT_FILE_NAME_PREFIX), this.modelTopologyFileName = t + DEFAULT_JSON_EXTENSION_NAME, this.weightDataFileName = t + DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
  }return e.prototype.save = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o, a, i;return __generator(this, function (s) {
        if (t = window.URL.createObjectURL(new Blob([e.weightData], { type: "application/octet-stream" })), e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");return n = [{ paths: ["./" + this.weightDataFileName], weights: e.weightSpecs }], r = { modelTopology: e.modelTopology, weightsManifest: n }, o = window.URL.createObjectURL(new Blob([JSON.stringify(r)], { type: "application/json" })), (a = null == this.jsonAnchor ? document.createElement("a") : this.jsonAnchor).download = this.modelTopologyFileName, a.href = o, a.click(), null != e.weightData && ((i = null == this.weightDataAnchor ? document.createElement("a") : this.weightDataAnchor).download = this.weightDataFileName, i.href = t, i.click()), [2, { modelArtifactsInfo: getModelArtifactsInfoForJSON(e) }];
      });
    });
  }, e.URL_SCHEME = "downloads://", e;
}(),
    BrowserFiles = function () {
  function e(e) {
    if (null == e || e.length < 1) throw new Error("When calling browserFiles, at least 1 file is required, but received " + e);this.files = e;
  }return e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e,
          t,
          n = this;return __generator(this, function (r) {
        return e = this.files[0], t = this.files.slice(1), [2, new Promise(function (r, o) {
          var a = new FileReader();a.onload = function (a) {
            var i = JSON.parse(a.target.result),
                s = i.modelTopology;if (null != s) {
              0 === t.length && r({ modelTopology: s });var u = i.weightsManifest;if (null != u) {
                var l;try {
                  l = n.checkManifestAndWeightFiles(u, t);
                } catch (e) {
                  return void o(e);
                }var c = [],
                    p = [],
                    d = [];u.forEach(function (e) {
                  e.paths.forEach(function (e) {
                    p.push(e), d.push(null);
                  }), c.push.apply(c, e.weights);
                }), u.forEach(function (e) {
                  e.paths.forEach(function (e) {
                    var t = new FileReader();t.onload = function (t) {
                      var n = t.target.result,
                          o = p.indexOf(e);d[o] = n, -1 === d.indexOf(null) && r({ modelTopology: s, weightSpecs: c, weightData: concatenateArrayBuffers(d) });
                    }, t.onerror = function (t) {
                      return o("Failed to weights data from file of path '" + e + "'.");
                    }, t.readAsArrayBuffer(l[e]);
                  });
                });
              } else o(new Error("weightManifest field is missing from file " + e.name));
            } else o(new Error("modelTopology field is missing from file " + e.name));
          }, a.onerror = function (t) {
            return o("Failed to read model topology and weights manifest JSON from file '" + e.name + "'. BrowserFiles supports loading Keras-style tf.Model artifacts only.");
          }, a.readAsText(e);
        })];
      });
    });
  }, e.prototype.checkManifestAndWeightFiles = function (e, t) {
    for (var n = [], r = t.map(function (e) {
      return basename(e.name);
    }), o = {}, a = 0, i = e; a < i.length; a++) {
      i[a].paths.forEach(function (e) {
        var a = basename(e);if (-1 !== n.indexOf(a)) throw new Error("Duplicate file basename found in weights manifest: '" + a + "'");if (n.push(a), -1 === r.indexOf(a)) throw new Error("Weight file with basename '" + a + "' is not provided.");o[e] = t[r.indexOf(a)];
      });
    }if (n.length !== t.length) throw new Error("Mismatch in the number of files in weights manifest (" + n.length + ") and the number of weight files provided (" + t.length + ").");return o;
  }, e;
}(),
    browserDownloadsRouter = function browserDownloadsRouter(e) {
  return ENV.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(BrowserDownloads.URL_SCHEME) ? browserDownloads(e.slice(BrowserDownloads.URL_SCHEME.length)) : null;
};function browserDownloads(e) {
  return void 0 === e && (e = "model"), new BrowserDownloads(e);
}function browserFiles(e) {
  return new BrowserFiles(e);
}function loadWeightsAsArrayBuffer(e, t, n) {
  return __awaiter(this, void 0, void 0, function () {
    var r, o;return __generator(this, function (a) {
      switch (a.label) {case 0:
          return null == n && (n = fetch), r = e.map(function (e) {
            return n(e, t);
          }), [4, Promise.all(r)];case 1:
          return o = a.sent(), [4, Promise.all(o.map(function (e) {
            return e.arrayBuffer();
          }))];case 2:
          return [2, a.sent()];}
    });
  });
}function loadWeights(e, t, n, r) {
  return void 0 === t && (t = ""), __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (o) {
      return [2, weightsLoaderFactory(function (e) {
        return loadWeightsAsArrayBuffer(e, r);
      })(e, t, n)];
    });
  });
}function weightsLoaderFactory(e) {
  var t = this;return function (n, r, o) {
    return void 0 === r && (r = ""), __awaiter(t, void 0, void 0, function () {
      var t, a, i, s, u, l, c, p, d, h;return __generator(this, function (f) {
        switch (f.label) {case 0:
            if (t = n.map(function () {
              return !1;
            }), a = {}, i = null != o ? o.map(function () {
              return !1;
            }) : [], s = [], n.forEach(function (e, n) {
              var r = 0;e.weights.forEach(function (e) {
                var u = "quantization" in e ? e.quantization.dtype : e.dtype,
                    l = DTYPE_VALUE_SIZE_MAP[u] * sizeFromShape(e.shape),
                    c = function c() {
                  t[n] = !0, null == a[n] && (a[n] = []), a[n].push({ manifestEntry: e, groupOffset: r, sizeBytes: l });
                };null != o ? o.forEach(function (t, n) {
                  t === e.name && (c(), i[n] = !0);
                }) : c(), s.push(e.name), r += l;
              });
            }), !i.every(function (e) {
              return e;
            })) throw u = o.filter(function (e, t) {
              return !i[t];
            }), new Error("Could not find weights in manifest with names: " + u.join(", ") + ". \nManifest JSON has weights with names: " + s.join(", ") + ".");return l = t.reduce(function (e, t, n) {
              return t && e.push(n), e;
            }, []), c = [], l.forEach(function (e) {
              n[e].paths.forEach(function (e) {
                var t = r + (r.endsWith("/") ? "" : "/") + e;c.push(t);
              });
            }), [4, e(c)];case 1:
            return p = f.sent(), d = {}, h = 0, l.forEach(function (e) {
              for (var t = n[e].paths.length, r = 0, o = 0; o < t; o++) {
                r += p[h + o].byteLength;
              }for (var i = new ArrayBuffer(r), s = new Uint8Array(i), u = 0, l = 0; l < t; l++) {
                var c = new Uint8Array(p[h + l]);s.set(c, u), u += c.byteLength;
              }a[e].forEach(function (e) {
                var t = decodeWeights(i.slice(e.groupOffset, e.groupOffset + e.sizeBytes), [e.manifestEntry]);for (var n in t) {
                  d[n] = t[n];
                }
              }), h += t;
            }), [2, d];}
      });
    });
  };
}IORouterRegistry.registerSaveRouter(browserDownloadsRouter);var BrowserHTTPRequest = function () {
  function e(e, t, n, r) {
    if (this.weightPathPrefix = n, this.DEFAULT_METHOD = "POST", null == r) {
      if ("undefined" == typeof fetch) throw new Error("browserHTTPRequest is not supported outside the web browser without a fetch polyfill.");this.fetchFunc = fetch.bind("undefined" == typeof window ? null : window);
    } else assert("function" == typeof r, "Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)"), this.fetchFunc = r;if (assert(null != e && e.length > 0, "URL path for browserHTTPRequest must not be null, undefined or empty."), Array.isArray(e) && assert(2 === e.length, "URL paths for browserHTTPRequest must have a length of 2, (actual length is " + e.length + ")."), this.path = e, null != t && null != t.body) throw new Error("requestInit is expected to have no pre-existing body, but has one.");this.requestInit = t || {};
  }return e.prototype.save = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o;return __generator(this, function (a) {
        switch (a.label) {case 0:
            if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");return (t = _extends({ method: this.DEFAULT_METHOD }, this.requestInit)).body = new FormData(), n = [{ paths: ["./model.weights.bin"], weights: e.weightSpecs }], r = { modelTopology: e.modelTopology, weightsManifest: n }, t.body.append("model.json", new Blob([JSON.stringify(r)], { type: "application/json" }), "model.json"), null != e.weightData && t.body.append("model.weights.bin", new Blob([e.weightData], { type: "application/octet-stream" }), "model.weights.bin"), [4, this.getFetchFunc()(this.path, t)];case 1:
            if ((o = a.sent()).ok) return [2, { modelArtifactsInfo: getModelArtifactsInfoForJSON(e), responses: [o] }];throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status " + o.status + ".");}
      });
    });
  }, e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, Array.isArray(this.path) ? this.loadBinaryModel() : this.loadJSONModel()];
      });
    });
  }, e.prototype.loadBinaryTopology = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return n.trys.push([0, 3,, 4]), [4, this.getFetchFunc()(this.path[0], this.requestInit)];case 1:
            if (!(e = n.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + e.statusText);return [4, e.arrayBuffer()];case 2:
            return [2, n.sent()];case 3:
            throw t = n.sent(), new Error(this.path[0] + " not found. " + t);case 4:
            return [2];}
      });
    });
  }, e.prototype.loadBinaryModel = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, n, r, o, a, i, s;return __generator(this, function (u) {
        switch (u.label) {case 0:
            return e = this.loadBinaryTopology(), [4, this.getFetchFunc()(this.path[1], this.requestInit)];case 1:
            if (!(t = u.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + t.statusText);return [4, Promise.all([e, t])];case 2:
            return n = u.sent(), r = n[0], [4, n[1].json()];case 3:
            return null == (o = u.sent()) ? [3, 5] : [4, this.loadWeights(o)];case 4:
            s = u.sent(), a = s[0], i = s[1], u.label = 5;case 5:
            return [2, { modelTopology: r, weightSpecs: a, weightData: i }];}
      });
    });
  }, e.prototype.loadJSONModel = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, n, r, o, a, i, s;return __generator(this, function (u) {
        switch (u.label) {case 0:
            return [4, this.getFetchFunc()(this.path, this.requestInit)];case 1:
            if (!(e = u.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + e.statusText);return [4, e.json()];case 2:
            if (t = u.sent(), n = t.modelTopology, r = t.weightsManifest, null == n && null == r) throw new Error("The JSON from HTTP path " + this.path + " contains neither model topology or manifest for weights.");return null == r ? [3, 4] : (i = t.weightsManifest, [4, this.loadWeights(i)]);case 3:
            s = u.sent(), o = s[0], a = s[1], u.label = 4;case 4:
            return [2, { modelTopology: n, weightSpecs: o, weightData: a }];}
      });
    });
  }, e.prototype.loadWeights = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, o, a, i, s, u, l, c, p, d;return __generator(this, function (h) {
        switch (h.label) {case 0:
            for (t = Array.isArray(this.path) ? this.path[1] : this.path, n = parseUrl(t), r = n[0], o = n[1], a = this.weightPathPrefix || r, i = [], s = 0, u = e; s < u.length; s++) {
              l = u[s], i.push.apply(i, l.weights);
            }return c = [], e.forEach(function (e) {
              e.paths.forEach(function (e) {
                c.push(a + e + o);
              });
            }), p = [i], d = concatenateArrayBuffers, [4, loadWeightsAsArrayBuffer(c, this.requestInit, this.getFetchFunc())];case 1:
            return [2, p.concat([d.apply(void 0, [h.sent()])])];}
      });
    });
  }, e.prototype.getFetchFunc = function () {
    return this.fetchFunc;
  }, e.URL_SCHEME_REGEX = /^https?:\/\//, e;
}();function parseUrl(e) {
  var t = e.lastIndexOf("/"),
      n = e.lastIndexOf("?");return [e.substring(0, t) + "/", n > t ? e.substring(n) : ""];
}function isHTTPScheme(e) {
  return null != e.match(BrowserHTTPRequest.URL_SCHEME_REGEX);
}var httpRequestRouter = function httpRequestRouter(e) {
  if ("undefined" == typeof fetch) return null;return (Array.isArray(e) ? e.every(function (e) {
    return isHTTPScheme(e);
  }) : isHTTPScheme(e)) ? browserHTTPRequest(e) : null;
};function browserHTTPRequest(e, t, n, r) {
  return new BrowserHTTPRequest(e, t, n, r);
}IORouterRegistry.registerSaveRouter(httpRequestRouter), IORouterRegistry.registerLoadRouter(httpRequestRouter);var PassthroughLoader = function () {
  function e(e, t, n) {
    this.modelTopology = e, this.weightSpecs = t, this.weightData = n;
  }return e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e;return __generator(this, function (t) {
        return e = {}, null != this.modelTopology && (e = __assign({ modelTopology: this.modelTopology }, e)), null != this.weightSpecs && this.weightSpecs.length > 0 && (e = __assign({ weightSpecs: this.weightSpecs }, e)), null != this.weightData && this.weightData.byteLength > 0 && (e = __assign({ weightData: this.weightData }, e)), [2, e];
      });
    });
  }, e;
}(),
    PassthroughSaver = function () {
  function e(e) {
    this.saveHandler = e;
  }return e.prototype.save = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.saveHandler(e)];
      });
    });
  }, e;
}();function fromMemory(e, t, n) {
  return new PassthroughLoader(e, t, n);
}function withSaveHandler(e) {
  return new PassthroughSaver(e);
}var registerSaveRouter = IORouterRegistry.registerSaveRouter,
    registerLoadRouter = IORouterRegistry.registerLoadRouter,
    getSaveHandlers = IORouterRegistry.getSaveHandlers,
    getLoadHandlers = IORouterRegistry.getLoadHandlers,
    io = Object.freeze({ browserFiles: browserFiles, browserHTTPRequest: browserHTTPRequest, concatenateArrayBuffers: concatenateArrayBuffers, decodeWeights: decodeWeights, encodeWeights: encodeWeights, fromMemory: fromMemory, getLoadHandlers: getLoadHandlers, getModelArtifactsInfoForJSON: getModelArtifactsInfoForJSON, getSaveHandlers: getSaveHandlers, isHTTPScheme: isHTTPScheme, loadWeights: loadWeights, registerLoadRouter: registerLoadRouter, registerSaveRouter: registerSaveRouter, weightsLoaderFactory: weightsLoaderFactory, withSaveHandler: withSaveHandler, copyModel: copyModel, listModels: listModels, moveModel: moveModel, removeModel: removeModel });function confusionMatrix_(e, t, n) {
  var r = convertToTensor(e, "labels", "confusionMatrix"),
      o = convertToTensor(t, "predictions", "confusionMatrix");assert(null == n || n > 0 && Number.isInteger(n), "If provided, numClasses must be a positive integer, but got " + n), assert(1 === r.rank, "Expected the rank of labels to be 1, but got " + r.rank), assert(1 === o.rank, "Expected the rank of predictions to be 1, but got " + o.rank), assert(r.shape[0] === o.shape[0], "Mismatch in the number of examples: " + r.shape[0] + " vs. " + o.shape[0] + ". Labels and predictions should have the same number of elements."), assert(n > 0 && Number.isInteger(n), "numClasses is required to be a positive integer, but got " + n);var a = oneHot(r.asType("int32"), n),
      i = oneHot(o.asType("int32"), n);return a.transpose().matMul(i).asType("int32");
}var confusionMatrix = op({ confusionMatrix_: confusionMatrix_ }),
    math = Object.freeze({ confusionMatrix: confusionMatrix }),
    Serializable = function () {
  function e() {}return e.prototype.getClassName = function () {
    return this.constructor.className;
  }, e.fromConfig = function (e, t) {
    return new e(t);
  }, e;
}(),
    SerializationMap = function () {
  function e() {
    this.classNameMap = {};
  }return e.getMap = function () {
    return null == e.instance && (e.instance = new e()), e.instance;
  }, e.register = function (t) {
    e.getMap().classNameMap[t.className] = [t, t.fromConfig];
  }, e;
}();function registerClass(e) {
  assert(null != e.className, "Class being registered does not have the static className property defined."), assert("string" == typeof e.className, "className is required to be a string, but got type " + typeof e.className), assert(e.className.length > 0, "Class being registered has an empty-string as its className, which is disallowed."), SerializationMap.register(e);
}var serialization = Object.freeze({ Serializable: Serializable, SerializationMap: SerializationMap, registerClass: registerClass }),
    WEBGL_ENVS = { HAS_WEBGL: !0 },
    NODE_ENVS = { IS_NODE: !0 },
    CHROME_ENVS = { IS_CHROME: !0 },
    BROWSER_ENVS = { IS_BROWSER: !0 },
    CPU_ENVS = { HAS_WEBGL: !1 },
    ALL_ENVS = {};function expectArraysClose(e, t, n) {
  return null == n && (n = ENV.get("TEST_EPSILON")), expectArraysPredicate(e, t, function (e, t) {
    return areClose(e, Number(t), n);
  });
}function expectArraysPredicate(e, t, n) {
  if (e instanceof Tensor || t instanceof Tensor) {
    if (e instanceof Tensor && t instanceof Tensor) {
      if (e.dtype !== t.dtype) throw new Error("Arrays are of different type actual: " + e.dtype + " vs expected: " + t.dtype + ".");if (!arraysEqual(e.shape, t.shape)) throw new Error("Arrays are of different shape actual: " + e.shape + " vs expected: " + t.shape + ".");
    }
  } else {
    var r = e.constructor.name,
        o = t.constructor.name;if (r !== o) throw new Error("Arrays are of different type actual: " + r + " vs expected: " + o);
  }var a, i;if (a = e instanceof Tensor ? e.dataSync() : e, i = t instanceof Tensor ? t.dataSync() : t, a.length !== i.length) throw new Error("Arrays have different lengths actual: " + a.length + " vs expected: " + i.length + ".\nActual:   " + a + ".\nExpected: " + i + ".");for (var s = 0; s < i.length; ++s) {
    var u = a[s],
        l = i[s];if (!n(u, l)) throw new Error("Arrays differ: actual[" + s + "] = " + u + ", expected[" + s + "] = " + l + ".\nActual:   " + a + ".\nExpected: " + i + ".");
  }
}function expectPromiseToFail(e, t) {
  e().then(function () {
    return t.fail();
  }, function () {
    return t();
  });
}function expectArraysEqual(e, t) {
  return e instanceof Tensor && "string" === e.dtype || t instanceof Tensor && "string" === t.dtype || e instanceof Array && isString(e[0]) || t instanceof Array && isString(t[0]) ? expectArraysPredicate(e, t, function (e, t) {
    return e == t;
  }) : expectArraysClose(e, t, 0);
}function expectNumbersClose(e, t, n) {
  if (null == n && (n = ENV.get("TEST_EPSILON")), !areClose(e, t, n)) throw new Error("Numbers differ: actual === " + e + ", expected === " + t);
}function areClose(e, t, n) {
  return !(!isNaN(e) || !isNaN(t)) || !(isNaN(e) || isNaN(t) || Math.abs(e - t) > n);
}function expectValuesInRange(e, t, n) {
  var r;r = e instanceof Tensor ? e.dataSync() : e;for (var o = 0; o < r.length; o++) {
    if (r[o] < t || r[o] > n) throw new Error("Value out of range:" + r[o] + " low: " + t + ", high: " + n);
  }
}function expectArrayBuffersEqual(e, t) {
  expect(new Float32Array(e)).toEqual(new Float32Array(t));
}var test_util = Object.freeze({ WEBGL_ENVS: WEBGL_ENVS, NODE_ENVS: NODE_ENVS, CHROME_ENVS: CHROME_ENVS, BROWSER_ENVS: BROWSER_ENVS, CPU_ENVS: CPU_ENVS, ALL_ENVS: ALL_ENVS, expectArraysClose: expectArraysClose, expectPromiseToFail: expectPromiseToFail, expectArraysEqual: expectArraysEqual, expectNumbersClose: expectNumbersClose, expectValuesInRange: expectValuesInRange, expectArrayBuffersEqual: expectArrayBuffersEqual }),
    version = "0.14.5",
    webgl = Object.freeze({ gpgpu_util: gpgpu_util, webgl_util: webgl_util, MathBackendWebGL: MathBackendWebGL, GPGPUContext: GPGPUContext }),
    Optimizer = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.minimize = function (e, t, n) {
    void 0 === t && (t = !1);var r = this.computeGradients(e, n),
        o = r.value,
        a = r.grads;return this.applyGradients(a), Object.keys(a).forEach(function (e) {
      return a[e].dispose();
    }), t ? o : (o.dispose(), null);
  }, t.prototype.computeGradients = function (e, t) {
    return variableGrads(e, t);
  }, t;
}(Serializable);Object.defineProperty(Optimizer, Symbol.hasInstance, { value: function value(e) {
    return null != e.minimize && null != e.computeGradients && null != e.applyGradients;
  } });var AdadeltaOptimizer = function (e) {
  function t(t, n, r) {
    void 0 === r && (r = null);var o = e.call(this) || this;return o.learningRate = t, o.rho = n, o.epsilon = r, o.accumulatedGrads = {}, o.accumulatedUpdates = {}, o.c = keep(scalar(-t)), o.rhoScalar = keep(scalar(n)), o.oneMinusRho = keep(scalar(1 - n)), null === r && (r = ENV.get("EPSILON")), o.epsilonScalar = keep(scalar(r)), o;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this,
        n = function n(_n2) {
      var o = ENV.engine.registeredVariables[_n2];if (null == r.accumulatedGrads[_n2]) {
        tidy(function () {
          t.accumulatedGrads[_n2] = zerosLike(o).variable(!1);
        });
      }if (null == r.accumulatedUpdates[_n2]) {
        tidy(function () {
          t.accumulatedUpdates[_n2] = zerosLike(o).variable(!1);
        });
      }var a = e[_n2],
          i = r.accumulatedGrads[_n2],
          s = r.accumulatedUpdates[_n2];tidy(function () {
        var e = t.rhoScalar.mul(i).add(t.oneMinusRho.mul(a.square())),
            r = s.add(t.epsilonScalar).sqrt().div(i.add(t.epsilonScalar).sqrt()).mul(a),
            u = t.rhoScalar.mul(s).add(t.oneMinusRho.mul(r.square()));t.accumulatedGrads[_n2].assign(e), t.accumulatedUpdates[_n2].assign(u);var l = t.c.mul(r).add(o);o.assign(l);
      });
    },
        r = this;for (var o in e) {
      n(o);
    }
  }, t.prototype.dispose = function () {
    var e = this;this.c.dispose(), this.epsilonScalar.dispose(), this.rhoScalar.dispose(), this.oneMinusRho.dispose(), null != this.accumulatedUpdates && (Object.keys(this.accumulatedUpdates).forEach(function (t) {
      return e.accumulatedUpdates[t].dispose();
    }), Object.keys(this.accumulatedGrads).forEach(function (t) {
      return e.accumulatedGrads[t].dispose();
    }));
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, rho: this.rho, epsilon: this.epsilon };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.rho, t.epsilon);
  }, t.className = "AdadeltaOptimizer", t;
}(Optimizer);registerClass(AdadeltaOptimizer);var AdagradOptimizer = function (e) {
  function t(t, n) {
    void 0 === n && (n = .1);var r = e.call(this) || this;return r.learningRate = t, r.initialAccumulatorValue = n, r.accumulatedGrads = {}, r.c = keep(scalar(-t)), r.epsilon = keep(scalar(ENV.get("EPSILON"))), r;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this,
        n = function n(_n3) {
      var o = ENV.engine.registeredVariables[_n3];if (null == r.accumulatedGrads[_n3]) {
        tidy(function () {
          t.accumulatedGrads[_n3] = fill(o.shape, t.initialAccumulatorValue).variable(!1);
        });
      }var a = e[_n3],
          i = r.accumulatedGrads[_n3];tidy(function () {
        var e = i.add(a.square());t.accumulatedGrads[_n3].assign(e);var r = t.c.mul(a.div(e.add(t.epsilon).sqrt())).add(o);o.assign(r);
      });
    },
        r = this;for (var o in e) {
      n(o);
    }
  }, t.prototype.dispose = function () {
    var e = this;this.epsilon.dispose(), this.c.dispose(), null != this.accumulatedGrads && Object.keys(this.accumulatedGrads).forEach(function (t) {
      return e.accumulatedGrads[t].dispose();
    });
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, initialAccumulatorValue: this.initialAccumulatorValue };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.initialAccumulatorValue);
  }, t.className = "AdagradOptimizer", t;
}(Optimizer);registerClass(AdagradOptimizer);var AdamOptimizer = function (e) {
  function t(t, n, r, o) {
    void 0 === o && (o = null);var a = e.call(this) || this;return a.learningRate = t, a.beta1 = n, a.beta2 = r, a.epsilon = o, a.accumulatedFirstMoment = {}, a.accumulatedSecondMoment = {}, a.c = keep(scalar(-t)), a.beta1Scalar = keep(scalar(n)), a.beta2Scalar = keep(scalar(r)), tidy(function () {
      a.accBeta1 = scalar(n).variable(), a.accBeta2 = scalar(r).variable();
    }), a.oneMinusBeta1 = keep(scalar(1 - n)), a.oneMinusBeta2 = keep(scalar(1 - r)), a.one = keep(scalar(1)), null === o && (o = ENV.get("EPSILON")), a.epsScalar = keep(scalar(o)), a;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this;tidy(function () {
      var n = t.one.sub(t.accBeta1),
          r = t.one.sub(t.accBeta2);for (var o in e) {
        var a = ENV.engine.registeredVariables[o];if (null == t.accumulatedFirstMoment[o]) {
          var i = !1;t.accumulatedFirstMoment[o] = zerosLike(a).variable(i);
        }if (null == t.accumulatedSecondMoment[o]) {
          i = !1;t.accumulatedSecondMoment[o] = zerosLike(a).variable(i);
        }var s = e[o],
            u = t.accumulatedFirstMoment[o],
            l = t.accumulatedSecondMoment[o],
            c = t.beta1Scalar.mul(u).add(t.oneMinusBeta1.mul(s)),
            p = t.beta2Scalar.mul(l).add(t.oneMinusBeta2.mul(s.square())),
            d = c.div(n),
            h = p.div(r);t.accumulatedFirstMoment[o].assign(c), t.accumulatedSecondMoment[o].assign(p);var f = t.c.mul(d.div(t.epsScalar.add(h.sqrt()))).add(a);a.assign(f);
      }t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar)), t.accBeta2.assign(t.accBeta2.mul(t.beta2Scalar));
    });
  }, t.prototype.dispose = function () {
    var e = this;this.c.dispose(), this.epsScalar.dispose(), this.beta1Scalar.dispose(), this.beta2Scalar.dispose(), this.accBeta1.dispose(), this.accBeta2.dispose(), this.oneMinusBeta1.dispose(), this.oneMinusBeta2.dispose(), this.one.dispose(), null != this.accumulatedFirstMoment && Object.keys(this.accumulatedFirstMoment).forEach(function (t) {
      return e.accumulatedFirstMoment[t].dispose();
    }), null != this.accumulatedSecondMoment && Object.keys(this.accumulatedSecondMoment).forEach(function (t) {
      return e.accumulatedSecondMoment[t].dispose();
    });
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, beta1: this.beta1, beta2: this.beta2, epsilon: this.epsilon };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.beta1, t.beta2, t.epsilon);
  }, t.className = "AdamOptimizer", t;
}(Optimizer);registerClass(AdamOptimizer);var AdamaxOptimizer = function (e) {
  function t(t, n, r, o, a) {
    void 0 === o && (o = null), void 0 === a && (a = 0);var i = e.call(this) || this;return i.learningRate = t, i.beta1 = n, i.beta2 = r, i.epsilon = o, i.decay = a, i.accumulatedFirstMoment = {}, i.accumulatedWeightedInfNorm = {}, i.c = keep(scalar(-t)), i.beta1Scalar = keep(scalar(n)), i.beta2Scalar = keep(scalar(r)), i.decayScalar = keep(scalar(a)), tidy(function () {
      i.iteration = scalar(0).variable(), i.accBeta1 = scalar(n).variable();
    }), i.oneMinusBeta1 = keep(scalar(1 - n)), i.one = keep(scalar(1)), null === o && (o = ENV.get("EPSILON")), i.epsScalar = keep(scalar(o)), i;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this;tidy(function () {
      var n = t.one.sub(t.accBeta1),
          r = t.c.div(t.one.add(t.decayScalar.mul(t.iteration)));for (var o in e) {
        var a = ENV.engine.registeredVariables[o];if (null == t.accumulatedFirstMoment[o]) {
          var i = !1;t.accumulatedFirstMoment[o] = zerosLike(a).variable(i);
        }if (null == t.accumulatedWeightedInfNorm[o]) {
          i = !1;t.accumulatedWeightedInfNorm[o] = zerosLike(a).variable(i);
        }var s = e[o],
            u = t.accumulatedFirstMoment[o],
            l = t.accumulatedWeightedInfNorm[o],
            c = t.beta1Scalar.mul(u).add(t.oneMinusBeta1.mul(s)),
            p = t.beta2Scalar.mul(l),
            d = s.abs(),
            h = p.maximum(d);t.accumulatedFirstMoment[o].assign(c), t.accumulatedWeightedInfNorm[o].assign(h);var f = r.div(n).mul(c.div(t.epsScalar.add(h))).add(a);a.assign(f);
      }t.iteration.assign(t.iteration.add(t.one)), t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar));
    });
  }, t.prototype.dispose = function () {
    var e = this;this.c.dispose(), this.epsScalar.dispose(), this.accBeta1.dispose(), this.beta1Scalar.dispose(), this.beta2Scalar.dispose(), this.oneMinusBeta1.dispose(), this.decayScalar.dispose(), this.iteration.dispose(), this.one.dispose(), null != this.accumulatedFirstMoment && Object.keys(this.accumulatedFirstMoment).forEach(function (t) {
      return e.accumulatedFirstMoment[t].dispose();
    }), null != this.accumulatedWeightedInfNorm && Object.keys(this.accumulatedWeightedInfNorm).forEach(function (t) {
      return e.accumulatedWeightedInfNorm[t].dispose();
    });
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, beta1: this.beta1, beta2: this.beta2, epsilon: this.epsilon, decay: this.decay };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.beta1, t.beta2, t.epsilon, t.decay);
  }, t.className = "AdamaxOptimizer", t;
}(Optimizer);registerClass(AdamaxOptimizer);var SGDOptimizer = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.learningRate = t, n.setLearningRate(t), n;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this;Object.keys(e).forEach(function (n) {
      var r = e[n],
          o = ENV.engine.registeredVariables[n];tidy(function () {
        var e = t.c.mul(r).add(o);o.assign(e);
      });
    });
  }, t.prototype.setLearningRate = function (e) {
    this.learningRate = e, null != this.c && this.c.dispose(), this.c = keep(scalar(-e));
  }, t.prototype.dispose = function () {
    this.c.dispose();
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate);
  }, t.className = "SGDOptimizer", t;
}(Optimizer);registerClass(SGDOptimizer);var MomentumOptimizer = function (e) {
  function t(t, n, r) {
    void 0 === r && (r = !1);var o = e.call(this, t) || this;return o.learningRate = t, o.momentum = n, o.useNesterov = r, o.m = scalar(o.momentum), o.accumulations = {}, o;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this,
        n = function n(_n4) {
      var o = ENV.engine.registeredVariables[_n4];if (null == r.accumulations[_n4]) {
        tidy(function () {
          t.accumulations[_n4] = zerosLike(o).variable(!1);
        });
      }var a = r.accumulations[_n4],
          i = e[_n4];tidy(function () {
        var e,
            r = t.m.mul(a).add(i);e = t.useNesterov ? t.c.mul(i.add(r.mul(t.m))).add(o) : t.c.mul(r).add(o), t.accumulations[_n4].assign(r), o.assign(e);
      });
    },
        r = this;for (var o in e) {
      n(o);
    }
  }, t.prototype.dispose = function () {
    if (e.prototype.dispose.call(this), this.m.dispose(), null != this.accumulations) for (var t in this.accumulations) {
      this.accumulations[t].dispose();
    }
  }, t.prototype.setMomentum = function (e) {
    this.momentum = e;
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, momentum: this.momentum, useNesterov: this.useNesterov };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.momentum, t.useNesterov);
  }, t.className = "MomentumOptimizer", t;
}(SGDOptimizer);registerClass(MomentumOptimizer);var RMSPropOptimizer = function (e) {
  function t(t, n, r, o, a) {
    void 0 === n && (n = .9), void 0 === r && (r = 0), void 0 === o && (o = null), void 0 === a && (a = !1);var i = e.call(this) || this;return i.learningRate = t, i.decay = n, i.momentum = r, i.epsilon = o, i.accumulatedMeanSquares = {}, i.accumulatedMeanGrads = {}, i.accumulatedMoments = {}, i.c = keep(scalar(t)), i.decayScalar = keep(scalar(n)), i.momentumScalar = keep(scalar(r)), i.oneMinusDecay = keep(scalar(1 - n)), i.centered = a, null === o && (o = ENV.get("EPSILON")), i.epsilonScalar = keep(scalar(o)), i;
  }return __extends(t, e), t.prototype.applyGradients = function (e) {
    var t = this,
        n = function n(_n5) {
      var o = ENV.engine.registeredVariables[_n5];if (null == r.accumulatedMeanSquares[_n5]) {
        tidy(function () {
          t.accumulatedMeanSquares[_n5] = zerosLike(o).variable(!1);
        });
      }if (null == r.accumulatedMeanGrads[_n5] && r.centered) {
        tidy(function () {
          t.accumulatedMeanGrads[_n5] = zerosLike(o).variable(!1);
        });
      }if (null == r.accumulatedMoments[_n5]) {
        tidy(function () {
          t.accumulatedMoments[_n5] = zerosLike(o).variable(!1);
        });
      }var a = r.accumulatedMeanSquares[_n5],
          i = r.accumulatedMeanGrads[_n5],
          s = r.accumulatedMoments[_n5],
          u = e[_n5];tidy(function () {
        var e = t.decayScalar.mul(a).add(t.oneMinusDecay.mul(u.square()));if (t.centered) {
          var r = t.decayScalar.mul(i).add(t.oneMinusDecay.mul(u)),
              l = t.momentumScalar.mul(s).add(t.c.mul(u).div(e.sub(r.square().add(t.epsilonScalar)).sqrt()));t.accumulatedMeanSquares[_n5].assign(e), t.accumulatedMeanGrads[_n5].assign(r), t.accumulatedMoments[_n5].assign(l);var c = o.sub(l);o.assign(c);
        } else {
          var p = t.decayScalar.mul(a).add(t.oneMinusDecay.mul(u.square()));l = t.momentumScalar.mul(s).add(t.c.mul(u).div(p.add(t.epsilonScalar).sqrt()));t.accumulatedMeanSquares[_n5].assign(p), t.accumulatedMoments[_n5].assign(l);c = o.sub(l);o.assign(c);
        }
      });
    },
        r = this;for (var o in e) {
      n(o);
    }
  }, t.prototype.dispose = function () {
    var e = this;this.c.dispose(), this.epsilonScalar.dispose(), this.decayScalar.dispose(), this.momentumScalar.dispose(), this.oneMinusDecay.dispose(), null != this.accumulatedMeanSquares && Object.keys(this.accumulatedMeanSquares).forEach(function (t) {
      return e.accumulatedMeanSquares[t].dispose();
    }), null != this.accumulatedMeanGrads && this.centered && Object.keys(this.accumulatedMeanGrads).forEach(function (t) {
      return e.accumulatedMeanGrads[t].dispose();
    }), null != this.accumulatedMoments && Object.keys(this.accumulatedMoments).forEach(function (t) {
      return e.accumulatedMoments[t].dispose();
    });
  }, t.prototype.getConfig = function () {
    return { learningRate: this.learningRate, decay: this.decay, momentum: this.momentum, epsilon: this.epsilon, centered: this.centered };
  }, t.fromConfig = function (e, t) {
    return new e(t.learningRate, t.decay, t.momentum, t.epsilon, t.centered);
  }, t.className = "RMSPropOptimizer", t;
}(Optimizer);registerClass(RMSPropOptimizer);var OptimizerConstructors = function () {
  function e() {}return e.sgd = function (e) {
    return new SGDOptimizer(e);
  }, e.momentum = function (e, t, n) {
    return void 0 === n && (n = !1), new MomentumOptimizer(e, t, n);
  }, e.rmsprop = function (e, t, n, r, o) {
    return void 0 === t && (t = .9), void 0 === n && (n = 0), void 0 === r && (r = null), void 0 === o && (o = !1), new RMSPropOptimizer(e, t, n, r, o);
  }, e.adam = function (e, t, n, r) {
    return void 0 === e && (e = .001), void 0 === t && (t = .9), void 0 === n && (n = .999), void 0 === r && (r = null), new AdamOptimizer(e, t, n, r);
  }, e.adadelta = function (e, t, n) {
    return void 0 === e && (e = .001), void 0 === t && (t = .95), void 0 === n && (n = null), new AdadeltaOptimizer(e, t, n);
  }, e.adamax = function (e, t, n, r, o) {
    return void 0 === e && (e = .002), void 0 === t && (t = .9), void 0 === n && (n = .999), void 0 === r && (r = null), void 0 === o && (o = 0), new AdamaxOptimizer(e, t, n, r, o);
  }, e.adagrad = function (e, t) {
    return void 0 === t && (t = .1), new AdagradOptimizer(e, t);
  }, e;
}(),
    train = { sgd: OptimizerConstructors.sgd, momentum: OptimizerConstructors.momentum, adadelta: OptimizerConstructors.adadelta, adagrad: OptimizerConstructors.adagrad, rmsprop: OptimizerConstructors.rmsprop, adamax: OptimizerConstructors.adamax, adam: OptimizerConstructors.adam },
    setBackend = Environment.setBackend,
    getBackend = Environment.getBackend,
    disposeVariables = Environment.disposeVariables,
    memory = Environment.memory;setOpHandler(ops);
//# sourceMappingURL=tf-core.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "35aj":
/***/ (function(module, exports) {

var defaultEncoding;
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8';
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10);

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary';
}
module.exports = defaultEncoding;

/***/ }),

/***/ "3IRH":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "3PYz":
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__("1lLf");
hash.common = __webpack_require__("YSDb");
hash.sha = __webpack_require__("NCTB");
hash.ripemd = __webpack_require__("CKAI");
hash.hmac = __webpack_require__("3kRU");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

/***/ }),

/***/ "3UtB":
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__("16On").Reporter;
base.DecoderBuffer = __webpack_require__("iTY7").DecoderBuffer;
base.EncoderBuffer = __webpack_require__("iTY7").EncoderBuffer;
base.Node = __webpack_require__("vugd");

/***/ }),

/***/ "3fzc":
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__("rOku");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__("geuY");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__("aK3A");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null) return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++) {
      if (k % res[j] === 0) break;
    }if (i !== j && res[j] <= sqrt) continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++) {
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }
  }return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) && fermatTest(n2) && fermatTest(num) && millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }
}

/***/ }),

/***/ "3kRU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var assert = __webpack_require__("08Lv");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++) {
    key.push(0);
  }for (i = 0; i < key.length; i++) {
    key[i] ^= 0x36;
  }this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++) {
    key[i] ^= 0x6a;
  }this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

/***/ }),

/***/ "3nYK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0) return ch32(x, y, z);
  if (s === 1 || s === 3) return p32(x, y, z);
  if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return x & y ^ ~x & z;
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

/***/ }),

/***/ "4/4u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cSWu").Transform;

/***/ }),

/***/ "4R/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

function oldBrowser() {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}
var safeBuffer = __webpack_require__("X3l8");
var randombytes = __webpack_require__("rOku");
var Buffer = safeBuffer.Buffer;
var kBufferMaxLength = safeBuffer.kMaxLength;
var crypto = global.crypto || global.msCrypto;
var kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(offset, length) {
  if (typeof offset !== 'number' || offset !== offset) {
    // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number');
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32');
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range');
  }
}

function assertSize(size, offset, length) {
  if (typeof size !== 'number' || size !== size) {
    // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number');
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32');
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small');
  }
}
if (crypto && crypto.getRandomValues || !process.browser) {
  exports.randomFill = randomFill;
  exports.randomFillSync = randomFillSync;
} else {
  exports.randomFill = oldBrowser;
  exports.randomFillSync = oldBrowser;
}
function randomFill(buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  }

  if (typeof offset === 'function') {
    cb = offset;
    offset = 0;
    size = buf.length;
  } else if (typeof size === 'function') {
    cb = size;
    size = buf.length - offset;
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function');
  }
  assertOffset(offset, buf.length);
  assertSize(size, offset, buf.length);
  return actualFill(buf, offset, size, cb);
}

function actualFill(buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    crypto.getRandomValues(uint);
    if (cb) {
      process.nextTick(function () {
        cb(null, buf);
      });
      return;
    }
    return buf;
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err);
      }
      bytes.copy(buf, offset);
      cb(null, buf);
    });
    return;
  }
  var bytes = randombytes(size);
  bytes.copy(buf, offset);
  return buf;
}
function randomFillSync(buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0;
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
  }

  assertOffset(offset, buf.length);

  if (size === undefined) size = buf.length - offset;

  assertSize(size, offset, buf.length);

  return actualFill(buf, offset, size);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4sPJ":
/***/ (function(module, exports) {

function incr32(iv) {
  var len = iv.length;
  var item;
  while (len--) {
    item = iv.readUInt8(len);
    if (item === 255) {
      iv.writeUInt8(0, len);
    } else {
      item++;
      iv.writeUInt8(item, len);
      break;
    }
  }
}
module.exports = incr32;

/***/ }),

/***/ "5QAX":
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__("geuY");
var Buffer = __webpack_require__("X3l8").Buffer;

function withPublic(paddedMsg, key) {
  return Buffer.from(paddedMsg.toRed(BN.mont(key.modulus)).redPow(new BN(key.publicExponent)).fromRed().toArray());
}

module.exports = withPublic;

/***/ }),

/***/ "63KW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("pYSm");
var ieee754 = __webpack_require__("ujcs");
var isArray = __webpack_require__("sOR5");

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "6hW9":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("BEbT");
var Buffer = __webpack_require__("X3l8").Buffer;
var Transform = __webpack_require__("z+8S");
var inherits = __webpack_require__("LC74");

function StreamCipher(mode, key, iv, decrypt) {
  Transform.call(this);

  this._cipher = new aes.AES(key);
  this._prev = Buffer.from(iv);
  this._cache = Buffer.allocUnsafe(0);
  this._secCache = Buffer.allocUnsafe(0);
  this._decrypt = decrypt;
  this._mode = mode;
}

inherits(StreamCipher, Transform);

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt);
};

StreamCipher.prototype._final = function () {
  this._cipher.scrub();
};

module.exports = StreamCipher;

/***/ }),

/***/ "7VT+":
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;
var evp = __webpack_require__("Cgw8");
var ciphers = __webpack_require__("tXf9");
module.exports = function (okey, password) {
  var key = okey.toString();
  var match = key.match(findProc);
  var decrypted;
  if (!match) {
    var match2 = key.match(fullRegex);
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64');
  } else {
    var suite = 'aes' + match[1];
    var iv = new Buffer(match[2], 'hex');
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64');
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
    var out = [];
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    decrypted = Buffer.concat(out);
  }
  var tag = key.match(startRegex)[1];
  return {
    tag: tag,
    data: decrypted
  };
};

/***/ }),

/***/ "7dSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__("jOgh");
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("iP15")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("UcPO");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("x0Ha");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("DsFX");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("DsFX");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "8/0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var assert = __webpack_require__("08Lv");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];

function SHA512() {
  if (!(this instanceof SHA512)) return new SHA512();

  BlockHash.call(this);
  this.h = [0x6a09e667, 0xf3bcc908, 0xbb67ae85, 0x84caa73b, 0x3c6ef372, 0xfe94f82b, 0xa54ff53a, 0x5f1d36f1, 0x510e527f, 0xade682d1, 0x9b05688c, 0x2b3e6c1f, 0x1f83d9ab, 0xfb41bd6b, 0x5be0cd19, 0x137e2179];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++) {
    W[i] = msg[start + i];
  }for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14]; // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32]; // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = xh & yh ^ ~xh & zh;
  if (r < 0) r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = xl & yl ^ ~xl & zl;
  if (r < 0) r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = xh & yh ^ xh & zh ^ yh & zh;
  if (r < 0) r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = xl & yl ^ xl & zl ^ yl & zl;
  if (r < 0) r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2); // 34
  var c2_hi = rotr64_hi(xl, xh, 7); // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0) r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2); // 34
  var c2_lo = rotr64_lo(xl, xh, 7); // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0) r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9); // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0) r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9); // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0) r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0) r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0) r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29); // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0) r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29); // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0) r += 0x100000000;
  return r;
}

/***/ }),

/***/ "87vf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("7dSG");

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8qoP":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;
var xor = __webpack_require__("H2Pp");

function encryptStart(self, data, decrypt) {
  var len = data.length;
  var out = xor(data, self._cache);
  self._cache = self._cache.slice(len);
  self._prev = Buffer.concat([self._prev, decrypt ? data : out]);
  return out;
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0);
  var len;

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev);
      self._prev = Buffer.allocUnsafe(0);
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length;
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
      data = data.slice(len);
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
      break;
    }
  }

  return out;
};

/***/ }),

/***/ "9DG0":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("vzCy").EventEmitter;
var inherits = __webpack_require__("LC74");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("cSWu");
Stream.Writable = __webpack_require__("87vf");
Stream.Duplex = __webpack_require__("SDM6");
Stream.Transform = __webpack_require__("4/4u");
Stream.PassThrough = __webpack_require__("/MLu");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;

// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function (dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }

  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

/***/ }),

/***/ "9P96":
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__("9hYg");
exports.privateDecrypt = __webpack_require__("fxuI");

exports.privateEncrypt = function privateEncrypt(key, buf) {
  return exports.publicEncrypt(key, buf, true);
};

exports.publicDecrypt = function publicDecrypt(key, buf) {
  return exports.privateDecrypt(key, buf, true);
};

/***/ }),

/***/ "9bI3":
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [['e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a', 'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'], ['8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508', '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'], ['175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739', 'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'], ['363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640', '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'], ['8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c', '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'], ['723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda', '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'], ['eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa', '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'], ['100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0', 'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'], ['e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d', '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'], ['feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d', 'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'], ['da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1', '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'], ['53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0', '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'], ['8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047', '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'], ['385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862', '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'], ['6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7', '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'], ['3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd', '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'], ['85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83', '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'], ['948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a', '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'], ['6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8', 'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'], ['e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d', '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'], ['e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725', '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'], ['213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754', '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'], ['4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c', '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'], ['fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6', '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'], ['76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39', 'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'], ['c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891', '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'], ['d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b', 'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'], ['b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03', '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'], ['e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d', 'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'], ['a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070', '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'], ['90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4', 'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'], ['8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da', '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'], ['e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11', '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'], ['8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e', 'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'], ['e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41', '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'], ['b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef', '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'], ['d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8', 'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'], ['324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d', '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'], ['4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96', '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'], ['9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd', 'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'], ['6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5', '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'], ['a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266', '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'], ['7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71', '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'], ['928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac', 'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'], ['85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751', '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'], ['ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e', '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'], ['827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241', 'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'], ['eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3', 'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'], ['e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f', '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'], ['1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19', 'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'], ['146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be', 'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'], ['fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9', '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'], ['da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2', '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'], ['a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13', '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'], ['174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c', 'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'], ['959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba', '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'], ['d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151', 'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'], ['64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073', 'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'], ['8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458', '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'], ['13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b', '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'], ['bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366', 'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'], ['8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa', '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'], ['8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0', '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'], ['dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787', '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'], ['f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e', 'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82']]
  },
  naf: {
    wnd: 7,
    points: [['f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9', '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'], ['2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4', 'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'], ['5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc', '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'], ['acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe', 'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'], ['774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb', 'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'], ['f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8', 'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'], ['d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e', '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'], ['defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34', '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'], ['2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c', '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'], ['352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5', '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'], ['2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f', '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'], ['9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714', '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'], ['daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729', 'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'], ['c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db', '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'], ['6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4', 'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'], ['1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5', 'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'], ['605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479', '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'], ['62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d', '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'], ['80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f', '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'], ['7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb', 'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'], ['d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9', 'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'], ['49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963', '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'], ['77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74', '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'], ['f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530', 'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'], ['463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b', '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'], ['f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247', 'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'], ['caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1', 'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'], ['2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120', '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'], ['7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435', '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'], ['754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18', '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'], ['e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8', '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'], ['186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb', '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'], ['df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f', '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'], ['5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143', 'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'], ['290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba', 'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'], ['af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45', 'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'], ['766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a', '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'], ['59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e', 'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'], ['f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8', 'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'], ['7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c', '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'], ['948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519', 'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'], ['7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab', '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'], ['3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca', 'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'], ['d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf', '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'], ['1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610', '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'], ['733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4', 'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'], ['15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c', 'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'], ['a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940', 'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'], ['e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980', 'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'], ['311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3', '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'], ['34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf', '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'], ['f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63', '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'], ['d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448', 'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'], ['32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf', '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'], ['7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5', '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'], ['ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6', '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'], ['16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5', '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'], ['eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99', 'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'], ['78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51', 'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'], ['494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5', '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'], ['a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5', '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'], ['c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997', '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'], ['841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881', '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'], ['5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5', '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'], ['36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66', 'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'], ['336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726', 'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'], ['8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede', '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'], ['1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94', '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'], ['85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31', '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'], ['29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51', 'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'], ['a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252', 'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'], ['4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5', 'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'], ['d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b', '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'], ['ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4', '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'], ['af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f', '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'], ['e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889', '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'], ['591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246', 'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'], ['11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984', '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'], ['3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a', 'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'], ['cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030', 'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'], ['c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197', '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'], ['c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593', 'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'], ['a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef', '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'], ['347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38', '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'], ['da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a', '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'], ['c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111', '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'], ['4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502', '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'], ['3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea', 'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'], ['cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26', '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'], ['b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986', '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'], ['d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e', '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'], ['48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4', '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'], ['dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda', 'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'], ['6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859', 'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'], ['e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f', 'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'], ['eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c', '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'], ['13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942', 'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'], ['ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a', '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'], ['b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80', '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'], ['ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d', '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'], ['8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1', 'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'], ['52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63', 'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'], ['e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352', '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'], ['7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193', 'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'], ['5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00', '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'], ['32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58', 'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'], ['e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7', 'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'], ['8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8', 'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'], ['4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e', '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'], ['3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d', 'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'], ['674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b', '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'], ['d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f', 'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'], ['30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6', '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'], ['be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297', '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'], ['93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a', '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'], ['b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c', 'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'], ['d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52', '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'], ['d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb', 'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'], ['463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065', 'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'], ['7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917', '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'], ['74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9', 'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'], ['30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3', '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'], ['9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57', '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'], ['176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66', 'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'], ['75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8', '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'], ['809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721', '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'], ['1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180', '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9']]
  }
};

/***/ }),

/***/ "9hYg":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("jkjm");
var randomBytes = __webpack_require__("rOku");
var createHash = __webpack_require__("BVsN");
var mgf = __webpack_require__("Cua8");
var xor = __webpack_require__("zOO0");
var BN = __webpack_require__("geuY");
var withPublic = __webpack_require__("5QAX");
var crt = __webpack_require__("jSRM");
var Buffer = __webpack_require__("X3l8").Buffer;

module.exports = function publicEncrypt(publicKey, msg, reverse) {
  var padding;
  if (publicKey.padding) {
    padding = publicKey.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  var key = parseKeys(publicKey);
  var paddedMsg;
  if (padding === 4) {
    paddedMsg = oaep(key, msg);
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    paddedMsg = new BN(msg);
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus');
    }
  } else {
    throw new Error('unknown padding');
  }
  if (reverse) {
    return crt(paddedMsg, key);
  } else {
    return withPublic(paddedMsg, key);
  }
};

function oaep(key, msg) {
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long');
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2);
  var dblen = k - hLen - 1;
  var seed = randomBytes(hLen);
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen));
  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k));
}
function pkcs1(key, msg, reverse) {
  var mLen = msg.length;
  var k = key.modulus.byteLength();
  if (mLen > k - 11) {
    throw new Error('message too long');
  }
  var ps;
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff);
  } else {
    ps = nonZero(k - mLen - 3);
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k));
}
function nonZero(len) {
  var out = Buffer.allocUnsafe(len);
  var i = 0;
  var cache = randomBytes(len * 2);
  var cur = 0;
  var num;
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2);
      cur = 0;
    }
    num = cache[cur++];
    if (num) {
      out[i++] = num;
    }
  }
  return out;
}

/***/ }),

/***/ "ARY+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");
var Legacy = __webpack_require__("YQyn");
var Base = __webpack_require__("z+8S");
var Buffer = __webpack_require__("X3l8").Buffer;
var md5 = __webpack_require__("EXeW");
var RIPEMD160 = __webpack_require__("LYGd");

var sha = __webpack_require__("JaR3");

var ZEROS = Buffer.alloc(128);

function Hmac(alg, key) {
  Base.call(this, 'digest');
  if (typeof key === 'string') {
    key = Buffer.from(key);
  }

  var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;

  this._alg = alg;
  this._key = key;
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
    key = hash.update(key).digest();
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize);
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
  var opad = this._opad = Buffer.allocUnsafe(blocksize);

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36;
    opad[i] = key[i] ^ 0x5C;
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg);
  this._hash.update(ipad);
}

inherits(Hmac, Base);

Hmac.prototype._update = function (data) {
  this._hash.update(data);
};

Hmac.prototype._final = function () {
  var h = this._hash.digest();
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg);
  return hash.update(this._opad).update(h).digest();
};

module.exports = function createHmac(alg, key) {
  alg = alg.toLowerCase();
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key);
  }
  if (alg === 'md5') {
    return new Legacy(md5, key);
  }
  return new Hmac(alg, key);
};

/***/ }),

/***/ "AWjC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0) return [];

  if (this.type === 'decrypt') return this._updateDecrypt(data);else return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++) {
    this.buffer[this.bufferOff + i] = data[off + i];
  }this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = (this.bufferOff + data.length) / this.blockSize | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - (data.length - inputOff) % this.blockSize;
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++) {
    this.buffer[this.bufferOff] = data[inputOff];
  }return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer) first = this.update(buffer);

  var last;
  if (this.type === 'encrypt') last = this._finalEncrypt();else last = this._finalDecrypt();

  if (first) return first.concat(last);else return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0) return false;

  while (off < buffer.length) {
    buffer[off++] = 0;
  }return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff)) return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

/***/ }),

/***/ "B6Bn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("geuY");
var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--) {
      nafW = (nafW << 1) + naf[k];
    }repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i) b = b.mixedAdd(doubles.points[j]);else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--) {
      k++;
    }if (i >= 0) k++;
    acc = acc.dblp(k);

    if (i < 0) break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
    } else {
      // J +- J
      if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [points[a], /* 1 */
    null, /* 3 */
    null, /* 5 */
    points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [-3, /* -1 -1 */
    -1, /* -1 0 */
    -5, /* -1 1 */
    -7, /* 0 -1 */
    0, /* 0 0 */
    7, /* 0 1 */
    5, /* 1 -1 */
    1, /* 1 0 */
    3 /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0) zero = false;
      }
      if (!zero) break;
      k++;
      i--;
    }
    if (i >= 0) k++;
    acc = acc.dblp(k);
    if (i < 0) break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0) continue;else if (z > 0) p = wnd[j][z - 1 >> 1];else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();

      if (p.type === 'affine') acc = acc.mixedAdd(p);else acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++) {
    wnd[i] = null;
  }if (jacobianResult) return acc;else return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq() /*other*/{
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);

    var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact) return [this.getY().isEven() ? 0x02 : 0x03].concat(x);

  return [0x04].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed) return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed) return false;

  var doubles = this.precomputed.doubles;
  if (!doubles) return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

  var doubles = [this];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++) {
      acc = acc.dbl();
    }doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

  var res = [this];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++) {
    res[i] = res[i - 1].add(dbl);
  }return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++) {
    r = r.dbl();
  }return r;
};

/***/ }),

/***/ "BCiZ":
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__("U6yG"),
  CBC: __webpack_require__("lUSU"),
  CFB: __webpack_require__("8qoP"),
  CFB8: __webpack_require__("Z7yx"),
  CFB1: __webpack_require__("k2Sm"),
  OFB: __webpack_require__("H1q7"),
  CTR: __webpack_require__("SsjP"),
  GCM: __webpack_require__("SsjP")
};

var modes = __webpack_require__("6ZSt");

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode];
}

module.exports = modes;

/***/ }),

/***/ "BEbT":
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__("X3l8").Buffer;

function asUInt32Array(buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);

  var len = buf.length / 4 | 0;
  var out = new Array(len);

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4);
  }

  return out;
}

function scrubVec(v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0;
  }
}

function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0];
  var SUB_MIX1 = SUB_MIX[1];
  var SUB_MIX2 = SUB_MIX[2];
  var SUB_MIX3 = SUB_MIX[3];

  var s0 = M[0] ^ keySchedule[0];
  var s1 = M[1] ^ keySchedule[1];
  var s2 = M[2] ^ keySchedule[2];
  var s3 = M[3] ^ keySchedule[3];
  var t0, t1, t2, t3;
  var ksRow = 4;

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
    s0 = t0;
    s1 = t1;
    s2 = t2;
    s3 = t3;
  }

  t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
  t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
  t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
  t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
  t0 = t0 >>> 0;
  t1 = t1 >>> 0;
  t2 = t2 >>> 0;
  t3 = t3 >>> 0;

  return [t0, t1, t2, t3];
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
var G = function () {
  // Compute double table
  var d = new Array(256);
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1;
    } else {
      d[j] = j << 1 ^ 0x11b;
    }
  }

  var SBOX = [];
  var INV_SBOX = [];
  var SUB_MIX = [[], [], [], []];
  var INV_SUB_MIX = [[], [], [], []];

  // Walk GF(2^8)
  var x = 0;
  var xi = 0;
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
    sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
    SBOX[x] = sx;
    INV_SBOX[sx] = x;

    // Compute multiplication
    var x2 = d[x];
    var x4 = d[x2];
    var x8 = d[x4];

    // Compute sub bytes, mix columns tables
    var t = d[sx] * 0x101 ^ sx * 0x1010100;
    SUB_MIX[0][x] = t << 24 | t >>> 8;
    SUB_MIX[1][x] = t << 16 | t >>> 16;
    SUB_MIX[2][x] = t << 8 | t >>> 24;
    SUB_MIX[3][x] = t;

    // Compute inv sub bytes, inv mix columns tables
    t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
    INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
    INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
    INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
    INV_SUB_MIX[3][sx] = t;

    if (x === 0) {
      x = xi = 1;
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]];
      xi ^= d[d[xi]];
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  };
}();

function AES(key) {
  this._key = asUInt32Array(key);
  this._reset();
}

AES.blockSize = 4 * 4;
AES.keySize = 256 / 8;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function () {
  var keyWords = this._key;
  var keySize = keyWords.length;
  var nRounds = keySize + 6;
  var ksRows = (nRounds + 1) * 4;

  var keySchedule = [];
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k];
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1];

    if (k % keySize === 0) {
      t = t << 8 | t >>> 24;
      t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];

      t ^= RCON[k / keySize | 0] << 24;
    } else if (keySize > 6 && k % keySize === 4) {
      t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t;
  }

  var invKeySchedule = [];
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik;
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt;
    } else {
      invKeySchedule[ik] = G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[tt >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[tt >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
    }
  }

  this._nRounds = nRounds;
  this._keySchedule = keySchedule;
  this._invKeySchedule = invKeySchedule;
};

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M);
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
};

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M);
  var buf = Buffer.allocUnsafe(16);
  buf.writeUInt32BE(out[0], 0);
  buf.writeUInt32BE(out[1], 4);
  buf.writeUInt32BE(out[2], 8);
  buf.writeUInt32BE(out[3], 12);
  return buf;
};

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M);

  // swap
  var m1 = M[1];
  M[1] = M[3];
  M[3] = m1;

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
  var buf = Buffer.allocUnsafe(16);
  buf.writeUInt32BE(out[0], 0);
  buf.writeUInt32BE(out[3], 4);
  buf.writeUInt32BE(out[2], 8);
  buf.writeUInt32BE(out[1], 12);
  return buf;
};

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule);
  scrubVec(this._invKeySchedule);
  scrubVec(this._key);
};

module.exports.AES = AES;

/***/ }),

/***/ "BO8W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__("iNQt");
exports.Cipher = __webpack_require__("AWjC");
exports.DES = __webpack_require__("Icsf");
exports.CBC = __webpack_require__("nyV4");
exports.EDE = __webpack_require__("YePo");

/***/ }),

/***/ "BVsN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");
var MD5 = __webpack_require__("eCz2");
var RIPEMD160 = __webpack_require__("LYGd");
var sha = __webpack_require__("JaR3");
var Base = __webpack_require__("z+8S");

function Hash(hash) {
  Base.call(this, 'digest');

  this._hash = hash;
}

inherits(Hash, Base);

Hash.prototype._update = function (data) {
  this._hash.update(data);
};

Hash.prototype._final = function () {
  return this._hash.digest();
};

module.exports = function createHash(alg) {
  alg = alg.toLowerCase();
  if (alg === 'md5') return new MD5();
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160();

  return new Hash(sha(alg));
};

/***/ }),

/***/ "C015":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];

var W = new Array(160);

function Sha512() {
  this.init();
  this._w = W;

  Hash.call(this, 128, 112);
}

inherits(Sha512, Hash);

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667;
  this._bh = 0xbb67ae85;
  this._ch = 0x3c6ef372;
  this._dh = 0xa54ff53a;
  this._eh = 0x510e527f;
  this._fh = 0x9b05688c;
  this._gh = 0x1f83d9ab;
  this._hh = 0x5be0cd19;

  this._al = 0xf3bcc908;
  this._bl = 0x84caa73b;
  this._cl = 0xfe94f82b;
  this._dl = 0x5f1d36f1;
  this._el = 0xade682d1;
  this._fl = 0x2b3e6c1f;
  this._gl = 0xfb41bd6b;
  this._hl = 0x137e2179;

  return this;
};

function Ch(x, y, z) {
  return z ^ x & (y ^ z);
}

function maj(x, y, z) {
  return x & y | z & (x | y);
}

function sigma0(x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}

function sigma1(x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}

function Gamma0(x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}

function Gamma0l(x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}

function Gamma1(x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}

function Gamma1l(x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}

function getCarry(a, b) {
  return a >>> 0 < b >>> 0 ? 1 : 0;
}

Sha512.prototype._update = function (M) {
  var W = this._w;

  var ah = this._ah | 0;
  var bh = this._bh | 0;
  var ch = this._ch | 0;
  var dh = this._dh | 0;
  var eh = this._eh | 0;
  var fh = this._fh | 0;
  var gh = this._gh | 0;
  var hh = this._hh | 0;

  var al = this._al | 0;
  var bl = this._bl | 0;
  var cl = this._cl | 0;
  var dl = this._dl | 0;
  var el = this._el | 0;
  var fl = this._fl | 0;
  var gl = this._gl | 0;
  var hl = this._hl | 0;

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4);
    W[i + 1] = M.readInt32BE(i * 4 + 4);
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2];
    var xl = W[i - 15 * 2 + 1];
    var gamma0 = Gamma0(xh, xl);
    var gamma0l = Gamma0l(xl, xh);

    xh = W[i - 2 * 2];
    xl = W[i - 2 * 2 + 1];
    var gamma1 = Gamma1(xh, xl);
    var gamma1l = Gamma1l(xl, xh);

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2];
    var Wi7l = W[i - 7 * 2 + 1];

    var Wi16h = W[i - 16 * 2];
    var Wi16l = W[i - 16 * 2 + 1];

    var Wil = gamma0l + Wi7l | 0;
    var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
    Wil = Wil + gamma1l | 0;
    Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
    Wil = Wil + Wi16l | 0;
    Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;

    W[i] = Wih;
    W[i + 1] = Wil;
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j];
    Wil = W[j + 1];

    var majh = maj(ah, bh, ch);
    var majl = maj(al, bl, cl);

    var sigma0h = sigma0(ah, al);
    var sigma0l = sigma0(al, ah);
    var sigma1h = sigma1(eh, el);
    var sigma1l = sigma1(el, eh);

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j];
    var Kil = K[j + 1];

    var chh = Ch(eh, fh, gh);
    var chl = Ch(el, fl, gl);

    var t1l = hl + sigma1l | 0;
    var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
    t1l = t1l + chl | 0;
    t1h = t1h + chh + getCarry(t1l, chl) | 0;
    t1l = t1l + Kil | 0;
    t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
    t1l = t1l + Wil | 0;
    t1h = t1h + Wih + getCarry(t1l, Wil) | 0;

    // t2 = sigma0 + maj
    var t2l = sigma0l + majl | 0;
    var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;

    hh = gh;
    hl = gl;
    gh = fh;
    gl = fl;
    fh = eh;
    fl = el;
    el = dl + t1l | 0;
    eh = dh + t1h + getCarry(el, dl) | 0;
    dh = ch;
    dl = cl;
    ch = bh;
    cl = bl;
    bh = ah;
    bl = al;
    al = t1l + t2l | 0;
    ah = t1h + t2h + getCarry(al, t1l) | 0;
  }

  this._al = this._al + al | 0;
  this._bl = this._bl + bl | 0;
  this._cl = this._cl + cl | 0;
  this._dl = this._dl + dl | 0;
  this._el = this._el + el | 0;
  this._fl = this._fl + fl | 0;
  this._gl = this._gl + gl | 0;
  this._hl = this._hl + hl | 0;

  this._ah = this._ah + ah + getCarry(this._al, al) | 0;
  this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
  this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
  this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
  this._eh = this._eh + eh + getCarry(this._el, el) | 0;
  this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
  this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
  this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
};

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64);

  function writeInt64BE(h, l, offset) {
    H.writeInt32BE(h, offset);
    H.writeInt32BE(l, offset + 4);
  }

  writeInt64BE(this._ah, this._al, 0);
  writeInt64BE(this._bh, this._bl, 8);
  writeInt64BE(this._ch, this._cl, 16);
  writeInt64BE(this._dh, this._dl, 24);
  writeInt64BE(this._eh, this._el, 32);
  writeInt64BE(this._fh, this._fl, 40);
  writeInt64BE(this._gh, this._gl, 48);
  writeInt64BE(this._hh, this._hl, 56);

  return H;
};

module.exports = Sha512;

/***/ }),

/***/ "C1C2":
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__("TnCn");

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

/***/ }),

/***/ "CKAI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160)) return new RIPEMD160();

  BlockHash.call(this);

  this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex') return utils.toHex32(this.h, 'little');else return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15) return x ^ y ^ z;else if (j <= 31) return x & y | ~x & z;else if (j <= 47) return (x | ~y) ^ z;else if (j <= 63) return x & z | y & ~z;else return x ^ (y | ~z);
}

function K(j) {
  if (j <= 15) return 0x00000000;else if (j <= 31) return 0x5a827999;else if (j <= 47) return 0x6ed9eba1;else if (j <= 63) return 0x8f1bbcdc;else return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15) return 0x50a28be6;else if (j <= 31) return 0x5c4dd124;else if (j <= 47) return 0x6d703ef3;else if (j <= 63) return 0x7a6d76e9;else return 0x00000000;
}

var r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];

var rh = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];

var s = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];

var sh = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];

/***/ }),

/***/ "Cgw8":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;
var MD5 = __webpack_require__("eCz2");

/* eslint-disable camelcase */
function EVP_BytesToKey(password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary');
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary');
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
  }

  var keyLen = keyBits / 8;
  var key = Buffer.alloc(keyLen);
  var iv = Buffer.alloc(ivLen || 0);
  var tmp = Buffer.alloc(0);

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5();
    hash.update(tmp);
    hash.update(password);
    if (salt) hash.update(salt);
    tmp = hash.digest();

    var used = 0;

    if (keyLen > 0) {
      var keyStart = key.length - keyLen;
      used = Math.min(keyLen, tmp.length);
      tmp.copy(key, keyStart, 0, used);
      keyLen -= used;
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen;
      var length = Math.min(ivLen, tmp.length - used);
      tmp.copy(iv, ivStart, used, used + length);
      ivLen -= length;
    }
  }

  tmp.fill(0);
  return { key: key, iv: iv };
}

module.exports = EVP_BytesToKey;

/***/ }),

/***/ "Csua":
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function (arr, obj) {
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "Cua8":
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__("BVsN");
var Buffer = __webpack_require__("X3l8").Buffer;

module.exports = function (seed, len) {
  var t = Buffer.alloc(0);
  var i = 0;
  var c;
  while (t.length < len) {
    c = i2ops(i++);
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
  }
  return t.slice(0, len);
};

function i2ops(c) {
  var out = Buffer.allocUnsafe(4);
  out.writeUInt32BE(c, 0);
  return out;
}

/***/ }),

/***/ "CzQx":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;

// prototype class for hash functions
function Hash(blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize);
  this._finalSize = finalSize;
  this._blockSize = blockSize;
  this._len = 0;
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8';
    data = Buffer.from(data, enc);
  }

  var block = this._block;
  var blockSize = this._blockSize;
  var length = data.length;
  var accum = this._len;

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize;
    var remainder = Math.min(length - offset, blockSize - assigned);

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i];
    }

    accum += remainder;
    offset += remainder;

    if (accum % blockSize === 0) {
      this._update(block);
    }
  }

  this._len += length;
  return this;
};

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize;

  this._block[rem] = 0x80;

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1);

  if (rem >= this._finalSize) {
    this._update(this._block);
    this._block.fill(0);
  }

  var bits = this._len * 8;

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4);

    // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0;
    var highBits = (bits - lowBits) / 0x100000000;

    this._block.writeUInt32BE(highBits, this._blockSize - 8);
    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
  }

  this._update(this._block);
  var hash = this._hash();

  return enc ? hash.toString(enc) : hash;
};

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass');
};

module.exports = Hash;

/***/ }),

/***/ "D1Va":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("DsFX");

/*<replacement>*/
var util = __webpack_require__("jOgh");
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "DsFX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__("jOgh");
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

var Readable = __webpack_require__("Rt1F");
var Writable = __webpack_require__("7dSG");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "EBst":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "EH7o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");

var SHA512 = __webpack_require__("8/0b");

function SHA384() {
  if (!(this instanceof SHA384)) return new SHA384();

  SHA512.call(this);
  this.h = [0xcbbb9d5d, 0xc1059ed8, 0x629a292a, 0x367cd507, 0x9159015a, 0x3070dd17, 0x152fecd8, 0xf70e5939, 0x67332667, 0xffc00b31, 0x8eb44a87, 0x68581511, 0xdb0c2e0d, 0x64f98fa7, 0x47b5481d, 0xbefa4fa4];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex') return utils.toHex32(this.h.slice(0, 12), 'big');else return utils.split32(this.h.slice(0, 12), 'big');
};

/***/ }),

/***/ "EXeW":
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__("eCz2");

module.exports = function (buffer) {
  return new MD5().update(buffer).digest();
};

/***/ }),

/***/ "F11g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("geuY");
var HmacDRBG = __webpack_require__("HzeT");
var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__("yMmo");
var Signature = __webpack_require__("NMED");

function EC(options) {
  if (!(this instanceof EC)) return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve) options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options) options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0) continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0) msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);else return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options) options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity()) continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0) continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0) continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity()) return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function (msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);else r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function (e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null) return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q)) return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

/***/ }),

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GUE9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var checkParameters = __webpack_require__("2JY6");
var defaultEncoding = __webpack_require__("35aj");
var sync = __webpack_require__("Zq1s");
var Buffer = __webpack_require__("X3l8").Buffer;

var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
};
var checks = [];
function checkNative(algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false);
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false);
  }
  if (checks[algo] !== undefined) {
    return checks[algo];
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo).then(function () {
    return true;
  }).catch(function () {
    return false;
  });
  checks[algo] = prom;
  return prom;
}

function browserPbkdf2(password, salt, iterations, length, algo) {
  return subtle.importKey('raw', password, { name: 'PBKDF2' }, false, ['deriveBits']).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3);
  }).then(function (res) {
    return Buffer.from(res);
  });
}

function resolvePromise(promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out);
    });
  }, function (e) {
    process.nextTick(function () {
      callback(e);
    });
  });
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest;
    digest = undefined;
  }

  digest = digest || 'sha1';
  var algo = toBrowser[digest.toLowerCase()];

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out;
      try {
        out = sync(password, salt, iterations, keylen, digest);
      } catch (e) {
        return callback(e);
      }
      callback(null, out);
    });
  }

  checkParameters(password, salt, iterations, keylen);
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding);
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding);

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo);

    return sync(password, salt, iterations, keylen, digest);
  }), callback);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "H1q7":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("H2Pp");

function getBlock(self) {
  self._prev = self._cipher.encryptBlock(self._prev);
  return self._prev;
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)]);
  }

  var pad = self._cache.slice(0, chunk.length);
  self._cache = self._cache.slice(chunk.length);
  return xor(chunk, pad);
};

/***/ }),

/***/ "H2Pp":
/***/ (function(module, exports) {

module.exports = function xor(a, b) {
  var length = Math.min(a.length, b.length);
  var buffer = new Buffer(length);

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i];
  }

  return buffer;
};

/***/ }),

/***/ "HgQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export FrozenModel */
/* unused harmony export loadFrozenModel */
/* unused harmony export loadTfHubModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__ = __webpack_require__("2qEw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var __assign = Object.assign || function (e) {
  for (var t, a = 1, r = arguments.length; a < r; a++) {
    for (var n in t = arguments[a]) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }return e;
};function __awaiter(e, t, a, r) {
  return new (a || (a = Promise))(function (n, o) {
    function s(e) {
      try {
        p(r.next(e));
      } catch (e) {
        o(e);
      }
    }function i(e) {
      try {
        p(r.throw(e));
      } catch (e) {
        o(e);
      }
    }function p(e) {
      e.done ? n(e.value) : new a(function (t) {
        t(e.value);
      }).then(s, i);
    }p((r = r.apply(e, t || [])).next());
  });
}function __generator(e, t) {
  var a,
      r,
      n,
      o,
      s = { label: 0, sent: function sent() {
      if (1 & n[0]) throw n[1];return n[1];
    }, trys: [], ops: [] };return o = { next: i(0), throw: i(1), return: i(2) }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;function i(o) {
    return function (i) {
      return function (o) {
        if (a) throw new TypeError("Generator is already executing.");for (; s;) {
          try {
            if (a = 1, r && (n = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(n = n.call(r, o[1])).done) return n;switch (r = 0, n && (o = [0, n.value]), o[0]) {case 0:case 1:
                n = o;break;case 4:
                return s.label++, { value: o[1], done: !1 };case 5:
                s.label++, r = o[1], o = [0];continue;case 7:
                o = s.ops.pop(), s.trys.pop();continue;default:
                if (!(n = (n = s.trys).length > 0 && n[n.length - 1]) && (6 === o[0] || 2 === o[0])) {
                  s = 0;continue;
                }if (3 === o[0] && (!n || o[1] > n[0] && o[1] < n[3])) {
                  s.label = o[1];break;
                }if (6 === o[0] && s.label < n[1]) {
                  s.label = n[1], n = o;break;
                }if (n && s.label < n[2]) {
                  s.label = n[2], s.ops.push(o);break;
                }n[2] && s.ops.pop(), s.trys.pop();continue;}o = t.call(e, s);
          } catch (e) {
            o = [6, e], r = 0;
          } finally {
            a = n = 0;
          }
        }if (5 & o[0]) throw o[1];return { value: o[0] ? o[1] : void 0, done: !0 };
      }([o, i]);
    };
  }
}var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};function createCommonjsModule(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}var aspromise = asPromise;function asPromise(e, t) {
  for (var a = new Array(arguments.length - 1), r = 0, n = 2, o = !0; n < arguments.length;) {
    a[r++] = arguments[n++];
  }return new Promise(function (n, s) {
    a[r] = function (e) {
      if (o) if (o = !1, e) s(e);else {
        for (var t = new Array(arguments.length - 1), a = 0; a < t.length;) {
          t[a++] = arguments[a];
        }n.apply(null, t);
      }
    };try {
      e.apply(t || null, a);
    } catch (e) {
      o && (o = !1, s(e));
    }
  });
}var base64_1 = createCommonjsModule(function (e, t) {
  var a = t;a.length = function (e) {
    var t = e.length;if (!t) return 0;for (var a = 0; --t % 4 > 1 && "=" === e.charAt(t);) {
      ++a;
    }return Math.ceil(3 * e.length) / 4 - a;
  };for (var r = new Array(64), n = new Array(123), o = 0; o < 64;) {
    n[r[o] = o < 26 ? o + 65 : o < 52 ? o + 71 : o < 62 ? o - 4 : o - 59 | 43] = o++;
  }a.encode = function (e, t, a) {
    for (var n, o = null, s = [], i = 0, p = 0; t < a;) {
      var m = e[t++];switch (p) {case 0:
          s[i++] = r[m >> 2], n = (3 & m) << 4, p = 1;break;case 1:
          s[i++] = r[n | m >> 4], n = (15 & m) << 2, p = 2;break;case 2:
          s[i++] = r[n | m >> 6], s[i++] = r[63 & m], p = 0;}i > 8191 && ((o || (o = [])).push(String.fromCharCode.apply(String, s)), i = 0);
    }return p && (s[i++] = r[n], s[i++] = 61, 1 === p && (s[i++] = 61)), o ? (i && o.push(String.fromCharCode.apply(String, s.slice(0, i))), o.join("")) : String.fromCharCode.apply(String, s.slice(0, i));
  };a.decode = function (e, t, a) {
    for (var r, o = a, s = 0, i = 0; i < e.length;) {
      var p = e.charCodeAt(i++);if (61 === p && s > 1) break;if (void 0 === (p = n[p])) throw Error("invalid encoding");switch (s) {case 0:
          r = p, s = 1;break;case 1:
          t[a++] = r << 2 | (48 & p) >> 4, r = p, s = 2;break;case 2:
          t[a++] = (15 & r) << 4 | (60 & p) >> 2, r = p, s = 3;break;case 3:
          t[a++] = (3 & r) << 6 | p, s = 0;}
    }if (1 === s) throw Error("invalid encoding");return a - o;
  }, a.test = function (e) {
    return (/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(e)
    );
  };
}),
    eventemitter = EventEmitter;function EventEmitter() {
  this._listeners = {};
}EventEmitter.prototype.on = function (e, t, a) {
  return (this._listeners[e] || (this._listeners[e] = [])).push({ fn: t, ctx: a || this }), this;
}, EventEmitter.prototype.off = function (e, t) {
  if (void 0 === e) this._listeners = {};else if (void 0 === t) this._listeners[e] = [];else for (var a = this._listeners[e], r = 0; r < a.length;) {
    a[r].fn === t ? a.splice(r, 1) : ++r;
  }return this;
}, EventEmitter.prototype.emit = function (e) {
  var t = this._listeners[e];if (t) {
    for (var a = [], r = 1; r < arguments.length;) {
      a.push(arguments[r++]);
    }for (r = 0; r < t.length;) {
      t[r].fn.apply(t[r++].ctx, a);
    }
  }return this;
};var float_1 = factory(factory);function factory(e) {
  return "undefined" != typeof Float32Array ? function () {
    var t = new Float32Array([-0]),
        a = new Uint8Array(t.buffer),
        r = 128 === a[3];function n(e, r, n) {
      t[0] = e, r[n] = a[0], r[n + 1] = a[1], r[n + 2] = a[2], r[n + 3] = a[3];
    }function o(e, r, n) {
      t[0] = e, r[n] = a[3], r[n + 1] = a[2], r[n + 2] = a[1], r[n + 3] = a[0];
    }function s(e, r) {
      return a[0] = e[r], a[1] = e[r + 1], a[2] = e[r + 2], a[3] = e[r + 3], t[0];
    }function i(e, r) {
      return a[3] = e[r], a[2] = e[r + 1], a[1] = e[r + 2], a[0] = e[r + 3], t[0];
    }e.writeFloatLE = r ? n : o, e.writeFloatBE = r ? o : n, e.readFloatLE = r ? s : i, e.readFloatBE = r ? i : s;
  }() : function () {
    function t(e, t, a, r) {
      var n = t < 0 ? 1 : 0;if (n && (t = -t), 0 === t) e(1 / t > 0 ? 0 : 2147483648, a, r);else if (isNaN(t)) e(2143289344, a, r);else if (t > 3.4028234663852886e38) e((n << 31 | 2139095040) >>> 0, a, r);else if (t < 1.1754943508222875e-38) e((n << 31 | Math.round(t / 1.401298464324817e-45)) >>> 0, a, r);else {
        var o = Math.floor(Math.log(t) / Math.LN2);e((n << 31 | o + 127 << 23 | 8388607 & Math.round(t * Math.pow(2, -o) * 8388608)) >>> 0, a, r);
      }
    }function a(e, t, a) {
      var r = e(t, a),
          n = 2 * (r >> 31) + 1,
          o = r >>> 23 & 255,
          s = 8388607 & r;return 255 === o ? s ? NaN : n * (1 / 0) : 0 === o ? 1.401298464324817e-45 * n * s : n * Math.pow(2, o - 150) * (s + 8388608);
    }e.writeFloatLE = t.bind(null, writeUintLE), e.writeFloatBE = t.bind(null, writeUintBE), e.readFloatLE = a.bind(null, readUintLE), e.readFloatBE = a.bind(null, readUintBE);
  }(), "undefined" != typeof Float64Array ? function () {
    var t = new Float64Array([-0]),
        a = new Uint8Array(t.buffer),
        r = 128 === a[7];function n(e, r, n) {
      t[0] = e, r[n] = a[0], r[n + 1] = a[1], r[n + 2] = a[2], r[n + 3] = a[3], r[n + 4] = a[4], r[n + 5] = a[5], r[n + 6] = a[6], r[n + 7] = a[7];
    }function o(e, r, n) {
      t[0] = e, r[n] = a[7], r[n + 1] = a[6], r[n + 2] = a[5], r[n + 3] = a[4], r[n + 4] = a[3], r[n + 5] = a[2], r[n + 6] = a[1], r[n + 7] = a[0];
    }function s(e, r) {
      return a[0] = e[r], a[1] = e[r + 1], a[2] = e[r + 2], a[3] = e[r + 3], a[4] = e[r + 4], a[5] = e[r + 5], a[6] = e[r + 6], a[7] = e[r + 7], t[0];
    }function i(e, r) {
      return a[7] = e[r], a[6] = e[r + 1], a[5] = e[r + 2], a[4] = e[r + 3], a[3] = e[r + 4], a[2] = e[r + 5], a[1] = e[r + 6], a[0] = e[r + 7], t[0];
    }e.writeDoubleLE = r ? n : o, e.writeDoubleBE = r ? o : n, e.readDoubleLE = r ? s : i, e.readDoubleBE = r ? i : s;
  }() : function () {
    function t(e, t, a, r, n, o) {
      var s = r < 0 ? 1 : 0;if (s && (r = -r), 0 === r) e(0, n, o + t), e(1 / r > 0 ? 0 : 2147483648, n, o + a);else if (isNaN(r)) e(0, n, o + t), e(2146959360, n, o + a);else if (r > 1.7976931348623157e308) e(0, n, o + t), e((s << 31 | 2146435072) >>> 0, n, o + a);else {
        var i;if (r < 2.2250738585072014e-308) e((i = r / 5e-324) >>> 0, n, o + t), e((s << 31 | i / 4294967296) >>> 0, n, o + a);else {
          var p = Math.floor(Math.log(r) / Math.LN2);1024 === p && (p = 1023), e(4503599627370496 * (i = r * Math.pow(2, -p)) >>> 0, n, o + t), e((s << 31 | p + 1023 << 20 | 1048576 * i & 1048575) >>> 0, n, o + a);
        }
      }
    }function a(e, t, a, r, n) {
      var o = e(r, n + t),
          s = e(r, n + a),
          i = 2 * (s >> 31) + 1,
          p = s >>> 20 & 2047,
          m = 4294967296 * (1048575 & s) + o;return 2047 === p ? m ? NaN : i * (1 / 0) : 0 === p ? 5e-324 * i * m : i * Math.pow(2, p - 1075) * (m + 4503599627370496);
    }e.writeDoubleLE = t.bind(null, writeUintLE, 0, 4), e.writeDoubleBE = t.bind(null, writeUintBE, 4, 0), e.readDoubleLE = a.bind(null, readUintLE, 0, 4), e.readDoubleBE = a.bind(null, readUintBE, 4, 0);
  }(), e;
}function writeUintLE(e, t, a) {
  t[a] = 255 & e, t[a + 1] = e >>> 8 & 255, t[a + 2] = e >>> 16 & 255, t[a + 3] = e >>> 24;
}function writeUintBE(e, t, a) {
  t[a] = e >>> 24, t[a + 1] = e >>> 16 & 255, t[a + 2] = e >>> 8 & 255, t[a + 3] = 255 & e;
}function readUintLE(e, t) {
  return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
}function readUintBE(e, t) {
  return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
}var inquire_1 = inquire;function inquire(moduleName) {
  try {
    var mod$$1 = eval("quire".replace(/^/, "re"))(moduleName);if (mod$$1 && (mod$$1.length || Object.keys(mod$$1).length)) return mod$$1;
  } catch (e) {}return null;
}var utf8_1 = createCommonjsModule(function (e, t) {
  var a = t;a.length = function (e) {
    for (var t = 0, a = 0, r = 0; r < e.length; ++r) {
      (a = e.charCodeAt(r)) < 128 ? t += 1 : a < 2048 ? t += 2 : 55296 == (64512 & a) && 56320 == (64512 & e.charCodeAt(r + 1)) ? (++r, t += 4) : t += 3;
    }return t;
  }, a.read = function (e, t, a) {
    if (a - t < 1) return "";for (var r, n = null, o = [], s = 0; t < a;) {
      (r = e[t++]) < 128 ? o[s++] = r : r > 191 && r < 224 ? o[s++] = (31 & r) << 6 | 63 & e[t++] : r > 239 && r < 365 ? (r = ((7 & r) << 18 | (63 & e[t++]) << 12 | (63 & e[t++]) << 6 | 63 & e[t++]) - 65536, o[s++] = 55296 + (r >> 10), o[s++] = 56320 + (1023 & r)) : o[s++] = (15 & r) << 12 | (63 & e[t++]) << 6 | 63 & e[t++], s > 8191 && ((n || (n = [])).push(String.fromCharCode.apply(String, o)), s = 0);
    }return n ? (s && n.push(String.fromCharCode.apply(String, o.slice(0, s))), n.join("")) : String.fromCharCode.apply(String, o.slice(0, s));
  }, a.write = function (e, t, a) {
    for (var r, n, o = a, s = 0; s < e.length; ++s) {
      (r = e.charCodeAt(s)) < 128 ? t[a++] = r : r < 2048 ? (t[a++] = r >> 6 | 192, t[a++] = 63 & r | 128) : 55296 == (64512 & r) && 56320 == (64512 & (n = e.charCodeAt(s + 1))) ? (r = 65536 + ((1023 & r) << 10) + (1023 & n), ++s, t[a++] = r >> 18 | 240, t[a++] = r >> 12 & 63 | 128, t[a++] = r >> 6 & 63 | 128, t[a++] = 63 & r | 128) : (t[a++] = r >> 12 | 224, t[a++] = r >> 6 & 63 | 128, t[a++] = 63 & r | 128);
    }return a - o;
  };
}),
    pool_1 = pool;function pool(e, t, a) {
  var r = a || 8192,
      n = r >>> 1,
      o = null,
      s = r;return function (a) {
    if (a < 1 || a > n) return e(a);s + a > r && (o = e(r), s = 0);var i = t.call(o, s, s += a);return 7 & s && (s = 1 + (7 | s)), i;
  };
}var longbits = LongBits;function LongBits(e, t) {
  this.lo = e >>> 0, this.hi = t >>> 0;
}var zero = LongBits.zero = new LongBits(0, 0);zero.toNumber = function () {
  return 0;
}, zero.zzEncode = zero.zzDecode = function () {
  return this;
}, zero.length = function () {
  return 1;
};var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";LongBits.fromNumber = function (e) {
  if (0 === e) return zero;var t = e < 0;t && (e = -e);var a = e >>> 0,
      r = (e - a) / 4294967296 >>> 0;return t && (r = ~r >>> 0, a = ~a >>> 0, ++a > 4294967295 && (a = 0, ++r > 4294967295 && (r = 0))), new LongBits(a, r);
}, LongBits.from = function (e) {
  if ("number" == typeof e) return LongBits.fromNumber(e);if (minimal.isString(e)) {
    if (!minimal.Long) return LongBits.fromNumber(parseInt(e, 10));e = minimal.Long.fromString(e);
  }return e.low || e.high ? new LongBits(e.low >>> 0, e.high >>> 0) : zero;
}, LongBits.prototype.toNumber = function (e) {
  if (!e && this.hi >>> 31) {
    var t = 1 + ~this.lo >>> 0,
        a = ~this.hi >>> 0;return t || (a = a + 1 >>> 0), -(t + 4294967296 * a);
  }return this.lo + 4294967296 * this.hi;
}, LongBits.prototype.toLong = function (e) {
  return minimal.Long ? new minimal.Long(0 | this.lo, 0 | this.hi, Boolean(e)) : { low: 0 | this.lo, high: 0 | this.hi, unsigned: Boolean(e) };
};var charCodeAt = String.prototype.charCodeAt;LongBits.fromHash = function (e) {
  return e === zeroHash ? zero : new LongBits((charCodeAt.call(e, 0) | charCodeAt.call(e, 1) << 8 | charCodeAt.call(e, 2) << 16 | charCodeAt.call(e, 3) << 24) >>> 0, (charCodeAt.call(e, 4) | charCodeAt.call(e, 5) << 8 | charCodeAt.call(e, 6) << 16 | charCodeAt.call(e, 7) << 24) >>> 0);
}, LongBits.prototype.toHash = function () {
  return String.fromCharCode(255 & this.lo, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, 255 & this.hi, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
}, LongBits.prototype.zzEncode = function () {
  var e = this.hi >> 31;return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ e) >>> 0, this.lo = (this.lo << 1 ^ e) >>> 0, this;
}, LongBits.prototype.zzDecode = function () {
  var e = -(1 & this.lo);return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ e) >>> 0, this.hi = (this.hi >>> 1 ^ e) >>> 0, this;
}, LongBits.prototype.length = function () {
  var e = this.lo,
      t = (this.lo >>> 28 | this.hi << 4) >>> 0,
      a = this.hi >>> 24;return 0 === a ? 0 === t ? e < 16384 ? e < 128 ? 1 : 2 : e < 2097152 ? 3 : 4 : t < 16384 ? t < 128 ? 5 : 6 : t < 2097152 ? 7 : 8 : a < 128 ? 9 : 10;
};var minimal = createCommonjsModule(function (e, t) {
  var a = t;function r(e, t, a) {
    for (var r = Object.keys(t), n = 0; n < r.length; ++n) {
      void 0 !== e[r[n]] && a || (e[r[n]] = t[r[n]]);
    }return e;
  }function n(e) {
    function t(e, a) {
      if (!(this instanceof t)) return new t(e, a);Object.defineProperty(this, "message", { get: function get() {
          return e;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), a && r(this, a);
    }return (t.prototype = Object.create(Error.prototype)).constructor = t, Object.defineProperty(t.prototype, "name", { get: function get() {
        return e;
      } }), t.prototype.toString = function () {
      return this.name + ": " + this.message;
    }, t;
  }a.asPromise = aspromise, a.base64 = base64_1, a.EventEmitter = eventemitter, a.float = float_1, a.inquire = inquire_1, a.utf8 = utf8_1, a.pool = pool_1, a.LongBits = longbits, a.emptyArray = Object.freeze ? Object.freeze([]) : [], a.emptyObject = Object.freeze ? Object.freeze({}) : {}, a.isNode = Boolean(commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), a.isInteger = Number.isInteger || function (e) {
    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
  }, a.isString = function (e) {
    return "string" == typeof e || e instanceof String;
  }, a.isObject = function (e) {
    return e && "object" == typeof e;
  }, a.isset = a.isSet = function (e, t) {
    var a = e[t];return !(null == a || !e.hasOwnProperty(t)) && ("object" != typeof a || (Array.isArray(a) ? a.length : Object.keys(a).length) > 0);
  }, a.Buffer = function () {
    try {
      var e = a.inquire("buffer").Buffer;return e.prototype.utf8Write ? e : null;
    } catch (e) {
      return null;
    }
  }(), a._Buffer_from = null, a._Buffer_allocUnsafe = null, a.newBuffer = function (e) {
    return "number" == typeof e ? a.Buffer ? a._Buffer_allocUnsafe(e) : new a.Array(e) : a.Buffer ? a._Buffer_from(e) : "undefined" == typeof Uint8Array ? e : new Uint8Array(e);
  }, a.Array = "undefined" != typeof Uint8Array ? Uint8Array : Array, a.Long = commonjsGlobal.dcodeIO && commonjsGlobal.dcodeIO.Long || a.inquire("long"), a.key2Re = /^true|false|0|1$/, a.key32Re = /^-?(?:0|[1-9][0-9]*)$/, a.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, a.longToHash = function (e) {
    return e ? a.LongBits.from(e).toHash() : a.LongBits.zeroHash;
  }, a.longFromHash = function (e, t) {
    var r = a.LongBits.fromHash(e);return a.Long ? a.Long.fromBits(r.lo, r.hi, t) : r.toNumber(Boolean(t));
  }, a.merge = r, a.lcFirst = function (e) {
    return e.charAt(0).toLowerCase() + e.substring(1);
  }, a.newError = n, a.ProtocolError = n("ProtocolError"), a.oneOfGetter = function (e) {
    for (var t = {}, a = 0; a < e.length; ++a) {
      t[e[a]] = 1;
    }return function () {
      for (var e = Object.keys(this), a = e.length - 1; a > -1; --a) {
        if (1 === t[e[a]] && void 0 !== this[e[a]] && null !== this[e[a]]) return e[a];
      }
    };
  }, a.oneOfSetter = function (e) {
    return function (t) {
      for (var a = 0; a < e.length; ++a) {
        e[a] !== t && delete this[e[a]];
      }
    };
  }, a.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, a._configure = function () {
    var e = a.Buffer;e ? (a._Buffer_from = e.from !== Uint8Array.from && e.from || function (t, a) {
      return new e(t, a);
    }, a._Buffer_allocUnsafe = e.allocUnsafe || function (t) {
      return new e(t);
    }) : a._Buffer_from = a._Buffer_allocUnsafe = null;
  };
}),
    writer = Writer,
    BufferWriter,
    LongBits$1 = minimal.LongBits,
    base64 = minimal.base64,
    utf8 = minimal.utf8;function Op(e, t, a) {
  this.fn = e, this.len = t, this.next = void 0, this.val = a;
}function noop() {}function State(e) {
  this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
}function Writer() {
  this.len = 0, this.head = new Op(noop, 0, 0), this.tail = this.head, this.states = null;
}function writeByte(e, t, a) {
  t[a] = 255 & e;
}function writeVarint32(e, t, a) {
  for (; e > 127;) {
    t[a++] = 127 & e | 128, e >>>= 7;
  }t[a] = e;
}function VarintOp(e, t) {
  this.len = e, this.next = void 0, this.val = t;
}function writeVarint64(e, t, a) {
  for (; e.hi;) {
    t[a++] = 127 & e.lo | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
  }for (; e.lo > 127;) {
    t[a++] = 127 & e.lo | 128, e.lo = e.lo >>> 7;
  }t[a++] = e.lo;
}function writeFixed32(e, t, a) {
  t[a] = 255 & e, t[a + 1] = e >>> 8 & 255, t[a + 2] = e >>> 16 & 255, t[a + 3] = e >>> 24;
}Writer.create = minimal.Buffer ? function () {
  return (Writer.create = function () {
    return new BufferWriter();
  })();
} : function () {
  return new Writer();
}, Writer.alloc = function (e) {
  return new minimal.Array(e);
}, minimal.Array !== Array && (Writer.alloc = minimal.pool(Writer.alloc, minimal.Array.prototype.subarray)), Writer.prototype._push = function (e, t, a) {
  return this.tail = this.tail.next = new Op(e, t, a), this.len += t, this;
}, VarintOp.prototype = Object.create(Op.prototype), VarintOp.prototype.fn = writeVarint32, Writer.prototype.uint32 = function (e) {
  return this.len += (this.tail = this.tail.next = new VarintOp((e >>>= 0) < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5, e)).len, this;
}, Writer.prototype.int32 = function (e) {
  return e < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(e)) : this.uint32(e);
}, Writer.prototype.sint32 = function (e) {
  return this.uint32((e << 1 ^ e >> 31) >>> 0);
}, Writer.prototype.uint64 = function (e) {
  var t = LongBits$1.from(e);return this._push(writeVarint64, t.length(), t);
}, Writer.prototype.int64 = Writer.prototype.uint64, Writer.prototype.sint64 = function (e) {
  var t = LongBits$1.from(e).zzEncode();return this._push(writeVarint64, t.length(), t);
}, Writer.prototype.bool = function (e) {
  return this._push(writeByte, 1, e ? 1 : 0);
}, Writer.prototype.fixed32 = function (e) {
  return this._push(writeFixed32, 4, e >>> 0);
}, Writer.prototype.sfixed32 = Writer.prototype.fixed32, Writer.prototype.fixed64 = function (e) {
  var t = LongBits$1.from(e);return this._push(writeFixed32, 4, t.lo)._push(writeFixed32, 4, t.hi);
}, Writer.prototype.sfixed64 = Writer.prototype.fixed64, Writer.prototype.float = function (e) {
  return this._push(minimal.float.writeFloatLE, 4, e);
}, Writer.prototype.double = function (e) {
  return this._push(minimal.float.writeDoubleLE, 8, e);
};var writeBytes = minimal.Array.prototype.set ? function (e, t, a) {
  t.set(e, a);
} : function (e, t, a) {
  for (var r = 0; r < e.length; ++r) {
    t[a + r] = e[r];
  }
};Writer.prototype.bytes = function (e) {
  var t = e.length >>> 0;if (!t) return this._push(writeByte, 1, 0);if (minimal.isString(e)) {
    var a = Writer.alloc(t = base64.length(e));base64.decode(e, a, 0), e = a;
  }return this.uint32(t)._push(writeBytes, t, e);
}, Writer.prototype.string = function (e) {
  var t = utf8.length(e);return t ? this.uint32(t)._push(utf8.write, t, e) : this._push(writeByte, 1, 0);
}, Writer.prototype.fork = function () {
  return this.states = new State(this), this.head = this.tail = new Op(noop, 0, 0), this.len = 0, this;
}, Writer.prototype.reset = function () {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop, 0, 0), this.len = 0), this;
}, Writer.prototype.ldelim = function () {
  var e = this.head,
      t = this.tail,
      a = this.len;return this.reset().uint32(a), a && (this.tail.next = e.next, this.tail = t, this.len += a), this;
}, Writer.prototype.finish = function () {
  for (var e = this.head.next, t = this.constructor.alloc(this.len), a = 0; e;) {
    e.fn(e.val, t, a), a += e.len, e = e.next;
  }return t;
}, Writer._configure = function (e) {
  BufferWriter = e;
};var writer_buffer = BufferWriter$1;(BufferWriter$1.prototype = Object.create(writer.prototype)).constructor = BufferWriter$1;var Buffer = minimal.Buffer;function BufferWriter$1() {
  writer.call(this);
}BufferWriter$1.alloc = function (e) {
  return (BufferWriter$1.alloc = minimal._Buffer_allocUnsafe)(e);
};var writeBytesBuffer = Buffer && Buffer.prototype instanceof Uint8Array && "set" === Buffer.prototype.set.name ? function (e, t, a) {
  t.set(e, a);
} : function (e, t, a) {
  if (e.copy) e.copy(t, a, 0, e.length);else for (var r = 0; r < e.length;) {
    t[a++] = e[r++];
  }
};function writeStringBuffer(e, t, a) {
  e.length < 40 ? minimal.utf8.write(e, t, a) : t.utf8Write(e, a);
}BufferWriter$1.prototype.bytes = function (e) {
  minimal.isString(e) && (e = minimal._Buffer_from(e, "base64"));var t = e.length >>> 0;return this.uint32(t), t && this._push(writeBytesBuffer, t, e), this;
}, BufferWriter$1.prototype.string = function (e) {
  var t = Buffer.byteLength(e);return this.uint32(t), t && this._push(writeStringBuffer, t, e), this;
};var reader = Reader,
    BufferReader,
    LongBits$2 = minimal.LongBits,
    utf8$1 = minimal.utf8;function indexOutOfRange(e, t) {
  return RangeError("index out of range: " + e.pos + " + " + (t || 1) + " > " + e.len);
}function Reader(e) {
  this.buf = e, this.pos = 0, this.len = e.length;
}var create_array = "undefined" != typeof Uint8Array ? function (e) {
  if (e instanceof Uint8Array || Array.isArray(e)) return new Reader(e);throw Error("illegal buffer");
} : function (e) {
  if (Array.isArray(e)) return new Reader(e);throw Error("illegal buffer");
};function readLongVarint() {
  var e = new LongBits$2(0, 0),
      t = 0;if (!(this.len - this.pos > 4)) {
    for (; t < 3; ++t) {
      if (this.pos >= this.len) throw indexOutOfRange(this);if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
    }return e.lo = (e.lo | (127 & this.buf[this.pos++]) << 7 * t) >>> 0, e;
  }for (; t < 4; ++t) {
    if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
  }if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 28) >>> 0, e.hi = (e.hi | (127 & this.buf[this.pos]) >> 4) >>> 0, this.buf[this.pos++] < 128) return e;if (t = 0, this.len - this.pos > 4) {
    for (; t < 5; ++t) {
      if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
    }
  } else for (; t < 5; ++t) {
    if (this.pos >= this.len) throw indexOutOfRange(this);if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
  }throw Error("invalid varint encoding");
}function readFixed32_end(e, t) {
  return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
}function readFixed64() {
  if (this.pos + 8 > this.len) throw indexOutOfRange(this, 8);return new LongBits$2(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}Reader.create = minimal.Buffer ? function (e) {
  return (Reader.create = function (e) {
    return minimal.Buffer.isBuffer(e) ? new BufferReader(e) : create_array(e);
  })(e);
} : create_array, Reader.prototype._slice = minimal.Array.prototype.subarray || minimal.Array.prototype.slice, Reader.prototype.uint32 = function () {
  var e = 4294967295;return function () {
    if (e = (127 & this.buf[this.pos]) >>> 0, this.buf[this.pos++] < 128) return e;if (e = (e | (127 & this.buf[this.pos]) << 7) >>> 0, this.buf[this.pos++] < 128) return e;if (e = (e | (127 & this.buf[this.pos]) << 14) >>> 0, this.buf[this.pos++] < 128) return e;if (e = (e | (127 & this.buf[this.pos]) << 21) >>> 0, this.buf[this.pos++] < 128) return e;if (e = (e | (15 & this.buf[this.pos]) << 28) >>> 0, this.buf[this.pos++] < 128) return e;if ((this.pos += 5) > this.len) throw this.pos = this.len, indexOutOfRange(this, 10);return e;
  };
}(), Reader.prototype.int32 = function () {
  return 0 | this.uint32();
}, Reader.prototype.sint32 = function () {
  var e = this.uint32();return e >>> 1 ^ -(1 & e) | 0;
}, Reader.prototype.bool = function () {
  return 0 !== this.uint32();
}, Reader.prototype.fixed32 = function () {
  if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);return readFixed32_end(this.buf, this.pos += 4);
}, Reader.prototype.sfixed32 = function () {
  if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);return 0 | readFixed32_end(this.buf, this.pos += 4);
}, Reader.prototype.float = function () {
  if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);var e = minimal.float.readFloatLE(this.buf, this.pos);return this.pos += 4, e;
}, Reader.prototype.double = function () {
  if (this.pos + 8 > this.len) throw indexOutOfRange(this, 4);var e = minimal.float.readDoubleLE(this.buf, this.pos);return this.pos += 8, e;
}, Reader.prototype.bytes = function () {
  var e = this.uint32(),
      t = this.pos,
      a = this.pos + e;if (a > this.len) throw indexOutOfRange(this, e);return this.pos += e, Array.isArray(this.buf) ? this.buf.slice(t, a) : t === a ? new this.buf.constructor(0) : this._slice.call(this.buf, t, a);
}, Reader.prototype.string = function () {
  var e = this.bytes();return utf8$1.read(e, 0, e.length);
}, Reader.prototype.skip = function (e) {
  if ("number" == typeof e) {
    if (this.pos + e > this.len) throw indexOutOfRange(this, e);this.pos += e;
  } else do {
    if (this.pos >= this.len) throw indexOutOfRange(this);
  } while (128 & this.buf[this.pos++]);return this;
}, Reader.prototype.skipType = function (e) {
  switch (e) {case 0:
      this.skip();break;case 1:
      this.skip(8);break;case 2:
      this.skip(this.uint32());break;case 3:
      for (;;) {
        if (4 == (e = 7 & this.uint32())) break;this.skipType(e);
      }break;case 5:
      this.skip(4);break;default:
      throw Error("invalid wire type " + e + " at offset " + this.pos);}return this;
}, Reader._configure = function (e) {
  BufferReader = e;var t = minimal.Long ? "toLong" : "toNumber";minimal.merge(Reader.prototype, { int64: function int64() {
      return readLongVarint.call(this)[t](!1);
    }, uint64: function uint64() {
      return readLongVarint.call(this)[t](!0);
    }, sint64: function sint64() {
      return readLongVarint.call(this).zzDecode()[t](!1);
    }, fixed64: function fixed64() {
      return readFixed64.call(this)[t](!0);
    }, sfixed64: function sfixed64() {
      return readFixed64.call(this)[t](!1);
    } });
};var reader_buffer = BufferReader$1;function BufferReader$1(e) {
  reader.call(this, e);
}(BufferReader$1.prototype = Object.create(reader.prototype)).constructor = BufferReader$1, minimal.Buffer && (BufferReader$1.prototype._slice = minimal.Buffer.prototype.slice), BufferReader$1.prototype.string = function () {
  var e = this.uint32();return this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len));
};var service = Service;function Service(e, t, a) {
  if ("function" != typeof e) throw TypeError("rpcImpl must be a function");minimal.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = Boolean(t), this.responseDelimited = Boolean(a);
}(Service.prototype = Object.create(minimal.EventEmitter.prototype)).constructor = Service, Service.prototype.rpcCall = function e(t, a, r, n, o) {
  if (!n) throw TypeError("request must be specified");var s = this;if (!o) return minimal.asPromise(e, s, t, a, r, n);if (s.rpcImpl) try {
    return s.rpcImpl(t, a[s.requestDelimited ? "encodeDelimited" : "encode"](n).finish(), function (e, a) {
      if (e) return s.emit("error", e, t), o(e);if (null !== a) {
        if (!(a instanceof r)) try {
          a = r[s.responseDelimited ? "decodeDelimited" : "decode"](a);
        } catch (e) {
          return s.emit("error", e, t), o(e);
        }return s.emit("data", a, t), o(null, a);
      }s.end(!0);
    });
  } catch (e) {
    return s.emit("error", e, t), void setTimeout(function () {
      o(e);
    }, 0);
  } else setTimeout(function () {
    o(Error("already ended"));
  }, 0);
}, Service.prototype.end = function (e) {
  return this.rpcImpl && (e || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};var rpc_1 = createCommonjsModule(function (e, t) {
  t.Service = service;
}),
    roots = {},
    indexMinimal = createCommonjsModule(function (e, t) {
  var a = t;function r() {
    a.Reader._configure(a.BufferReader), a.util._configure();
  }a.build = "minimal", a.Writer = writer, a.BufferWriter = writer_buffer, a.Reader = reader, a.BufferReader = reader_buffer, a.util = minimal, a.rpc = rpc_1, a.roots = roots, a.configure = r, a.Writer._configure(a.BufferWriter), r();
}),
    minimal$1 = indexMinimal,
    minimal_1 = minimal$1.roots,
    minimal_2 = minimal$1.Reader,
    minimal_3 = minimal$1.util,
    $Reader = minimal$1.Reader,
    $util = minimal$1.util,
    $root = minimal$1.roots.default || (minimal$1.roots.default = {});$root.tensorflow = function () {
  var e,
      t,
      a = {};return a.Any = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.typeUrl = "", e.prototype.value = $util.newBuffer([]), e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.Any(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.typeUrl = e.string();break;case 2:
            r.value = e.bytes();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.DataType = (e = {}, (t = Object.create(e))[e[0] = "DT_INVALID"] = 0, t[e[1] = "DT_FLOAT"] = 1, t[e[2] = "DT_DOUBLE"] = 2, t[e[3] = "DT_INT32"] = 3, t[e[4] = "DT_UINT8"] = 4, t[e[5] = "DT_INT16"] = 5, t[e[6] = "DT_INT8"] = 6, t[e[7] = "DT_STRING"] = 7, t[e[8] = "DT_COMPLEX64"] = 8, t[e[9] = "DT_INT64"] = 9, t[e[10] = "DT_BOOL"] = 10, t[e[11] = "DT_QINT8"] = 11, t[e[12] = "DT_QUINT8"] = 12, t[e[13] = "DT_QINT32"] = 13, t[e[14] = "DT_BFLOAT16"] = 14, t[e[101] = "DT_FLOAT_REF"] = 101, t[e[102] = "DT_DOUBLE_REF"] = 102, t[e[103] = "DT_INT32_REF"] = 103, t[e[104] = "DT_UINT8_REF"] = 104, t[e[105] = "DT_INT16_REF"] = 105, t[e[106] = "DT_INT8_REF"] = 106, t[e[107] = "DT_STRING_REF"] = 107, t[e[108] = "DT_COMPLEX64_REF"] = 108, t[e[109] = "DT_INT64_REF"] = 109, t[e[110] = "DT_BOOL_REF"] = 110, t[e[111] = "DT_QINT8_REF"] = 111, t[e[112] = "DT_QUINT8_REF"] = 112, t[e[113] = "DT_QINT32_REF"] = 113, t[e[114] = "DT_BFLOAT16_REF"] = 114, t), a.TensorShape = function () {
    function e(e) {
      if (this.dim = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.dim = $util.emptyArray, e.prototype.unknownRank = !1, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.TensorShape(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 2:
            r.dim && r.dim.length || (r.dim = []), r.dim.push($root.tensorflow.TensorShape.Dim.decode(e, e.uint32()));break;case 3:
            r.unknownRank = e.bool();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.Dim = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, e.prototype.name = "", e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.TensorShape.Dim(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.size = e.int64();break;case 2:
              r.name = e.string();break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.Tensor = function () {
    function e(e) {
      if (this.floatVal = [], this.doubleVal = [], this.intVal = [], this.stringVal = [], this.scomplexVal = [], this.int64Val = [], this.boolVal = [], this.uint32Val = [], this.uint64Val = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.dtype = 0, e.prototype.tensorShape = null, e.prototype.versionNumber = 0, e.prototype.tensorContent = $util.newBuffer([]), e.prototype.floatVal = $util.emptyArray, e.prototype.doubleVal = $util.emptyArray, e.prototype.intVal = $util.emptyArray, e.prototype.stringVal = $util.emptyArray, e.prototype.scomplexVal = $util.emptyArray, e.prototype.int64Val = $util.emptyArray, e.prototype.boolVal = $util.emptyArray, e.prototype.uint32Val = $util.emptyArray, e.prototype.uint64Val = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.Tensor(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.dtype = e.int32();break;case 2:
            r.tensorShape = $root.tensorflow.TensorShape.decode(e, e.uint32());break;case 3:
            r.versionNumber = e.int32();break;case 4:
            r.tensorContent = e.bytes();break;case 5:
            if (r.floatVal && r.floatVal.length || (r.floatVal = []), 2 == (7 & n)) for (var o = e.uint32() + e.pos; e.pos < o;) {
              r.floatVal.push(e.float());
            } else r.floatVal.push(e.float());break;case 6:
            if (r.doubleVal && r.doubleVal.length || (r.doubleVal = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.doubleVal.push(e.double());
            } else r.doubleVal.push(e.double());break;case 7:
            if (r.intVal && r.intVal.length || (r.intVal = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.intVal.push(e.int32());
            } else r.intVal.push(e.int32());break;case 8:
            r.stringVal && r.stringVal.length || (r.stringVal = []), r.stringVal.push(e.bytes());break;case 9:
            if (r.scomplexVal && r.scomplexVal.length || (r.scomplexVal = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.scomplexVal.push(e.float());
            } else r.scomplexVal.push(e.float());break;case 10:
            if (r.int64Val && r.int64Val.length || (r.int64Val = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.int64Val.push(e.int64());
            } else r.int64Val.push(e.int64());break;case 11:
            if (r.boolVal && r.boolVal.length || (r.boolVal = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.boolVal.push(e.bool());
            } else r.boolVal.push(e.bool());break;case 16:
            if (r.uint32Val && r.uint32Val.length || (r.uint32Val = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.uint32Val.push(e.uint32());
            } else r.uint32Val.push(e.uint32());break;case 17:
            if (r.uint64Val && r.uint64Val.length || (r.uint64Val = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
              r.uint64Val.push(e.uint64());
            } else r.uint64Val.push(e.uint64());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.AttrValue = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }var t;return e.prototype.list = null, e.prototype.s = $util.newBuffer([]), e.prototype.i = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, e.prototype.f = 0, e.prototype.b = !1, e.prototype.type = 0, e.prototype.shape = null, e.prototype.tensor = null, e.prototype.placeholder = "", e.prototype.func = null, Object.defineProperty(e.prototype, "value", { get: $util.oneOfGetter(t = ["list", "s", "i", "f", "b", "type", "shape", "tensor", "placeholder", "func"]), set: $util.oneOfSetter(t) }), e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.AttrValue(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.list = $root.tensorflow.AttrValue.ListValue.decode(e, e.uint32());break;case 2:
            r.s = e.bytes();break;case 3:
            r.i = e.int64();break;case 4:
            r.f = e.float();break;case 5:
            r.b = e.bool();break;case 6:
            r.type = e.int32();break;case 7:
            r.shape = $root.tensorflow.TensorShape.decode(e, e.uint32());break;case 8:
            r.tensor = $root.tensorflow.Tensor.decode(e, e.uint32());break;case 9:
            r.placeholder = e.string();break;case 10:
            r.func = $root.tensorflow.NameAttrList.decode(e, e.uint32());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.ListValue = function () {
      function e(e) {
        if (this.s = [], this.i = [], this.f = [], this.b = [], this.type = [], this.shape = [], this.tensor = [], this.func = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.s = $util.emptyArray, e.prototype.i = $util.emptyArray, e.prototype.f = $util.emptyArray, e.prototype.b = $util.emptyArray, e.prototype.type = $util.emptyArray, e.prototype.shape = $util.emptyArray, e.prototype.tensor = $util.emptyArray, e.prototype.func = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.AttrValue.ListValue(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 2:
              r.s && r.s.length || (r.s = []), r.s.push(e.bytes());break;case 3:
              if (r.i && r.i.length || (r.i = []), 2 == (7 & n)) for (var o = e.uint32() + e.pos; e.pos < o;) {
                r.i.push(e.int64());
              } else r.i.push(e.int64());break;case 4:
              if (r.f && r.f.length || (r.f = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
                r.f.push(e.float());
              } else r.f.push(e.float());break;case 5:
              if (r.b && r.b.length || (r.b = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
                r.b.push(e.bool());
              } else r.b.push(e.bool());break;case 6:
              if (r.type && r.type.length || (r.type = []), 2 == (7 & n)) for (o = e.uint32() + e.pos; e.pos < o;) {
                r.type.push(e.int32());
              } else r.type.push(e.int32());break;case 7:
              r.shape && r.shape.length || (r.shape = []), r.shape.push($root.tensorflow.TensorShape.decode(e, e.uint32()));break;case 8:
              r.tensor && r.tensor.length || (r.tensor = []), r.tensor.push($root.tensorflow.Tensor.decode(e, e.uint32()));break;case 9:
              r.func && r.func.length || (r.func = []), r.func.push($root.tensorflow.NameAttrList.decode(e, e.uint32()));break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.NameAttrList = function () {
    function e(e) {
      if (this.attr = {}, e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.name = "", e.prototype.attr = $util.emptyObject, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a, r = void 0 === t ? e.len : e.pos + t, n = new $root.tensorflow.NameAttrList(); e.pos < r;) {
        var o = e.uint32();switch (o >>> 3) {case 1:
            n.name = e.string();break;case 2:
            e.skip().pos++, n.attr === $util.emptyObject && (n.attr = {}), a = e.string(), e.pos++, n.attr[a] = $root.tensorflow.AttrValue.decode(e, e.uint32());break;default:
            e.skipType(7 & o);}
      }return n;
    }, e;
  }(), a.NodeDef = function () {
    function e(e) {
      if (this.input = [], this.attr = {}, e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.name = "", e.prototype.op = "", e.prototype.input = $util.emptyArray, e.prototype.device = "", e.prototype.attr = $util.emptyObject, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a, r = void 0 === t ? e.len : e.pos + t, n = new $root.tensorflow.NodeDef(); e.pos < r;) {
        var o = e.uint32();switch (o >>> 3) {case 1:
            n.name = e.string();break;case 2:
            n.op = e.string();break;case 3:
            n.input && n.input.length || (n.input = []), n.input.push(e.string());break;case 4:
            n.device = e.string();break;case 5:
            e.skip().pos++, n.attr === $util.emptyObject && (n.attr = {}), a = e.string(), e.pos++, n.attr[a] = $root.tensorflow.AttrValue.decode(e, e.uint32());break;default:
            e.skipType(7 & o);}
      }return n;
    }, e;
  }(), a.VersionDef = function () {
    function e(e) {
      if (this.badConsumers = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.producer = 0, e.prototype.minConsumer = 0, e.prototype.badConsumers = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.VersionDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.producer = e.int32();break;case 2:
            r.minConsumer = e.int32();break;case 3:
            if (r.badConsumers && r.badConsumers.length || (r.badConsumers = []), 2 == (7 & n)) for (var o = e.uint32() + e.pos; e.pos < o;) {
              r.badConsumers.push(e.int32());
            } else r.badConsumers.push(e.int32());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.GraphDef = function () {
    function e(e) {
      if (this.node = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.node = $util.emptyArray, e.prototype.versions = null, e.prototype.library = null, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.GraphDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.node && r.node.length || (r.node = []), r.node.push($root.tensorflow.NodeDef.decode(e, e.uint32()));break;case 4:
            r.versions = $root.tensorflow.VersionDef.decode(e, e.uint32());break;case 2:
            r.library = $root.tensorflow.FunctionDefLibrary.decode(e, e.uint32());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.CollectionDef = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }var t;return e.prototype.nodeList = null, e.prototype.bytesList = null, e.prototype.int64List = null, e.prototype.floatList = null, e.prototype.anyList = null, Object.defineProperty(e.prototype, "kind", { get: $util.oneOfGetter(t = ["nodeList", "bytesList", "int64List", "floatList", "anyList"]), set: $util.oneOfSetter(t) }), e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.nodeList = $root.tensorflow.CollectionDef.NodeList.decode(e, e.uint32());break;case 2:
            r.bytesList = $root.tensorflow.CollectionDef.BytesList.decode(e, e.uint32());break;case 3:
            r.int64List = $root.tensorflow.CollectionDef.Int64List.decode(e, e.uint32());break;case 4:
            r.floatList = $root.tensorflow.CollectionDef.FloatList.decode(e, e.uint32());break;case 5:
            r.anyList = $root.tensorflow.CollectionDef.AnyList.decode(e, e.uint32());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.NodeList = function () {
      function e(e) {
        if (this.value = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.value = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef.NodeList(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.value && r.value.length || (r.value = []), r.value.push(e.string());break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.BytesList = function () {
      function e(e) {
        if (this.value = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.value = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef.BytesList(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.value && r.value.length || (r.value = []), r.value.push(e.bytes());break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.Int64List = function () {
      function e(e) {
        if (this.value = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.value = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef.Int64List(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              if (r.value && r.value.length || (r.value = []), 2 == (7 & n)) for (var o = e.uint32() + e.pos; e.pos < o;) {
                r.value.push(e.int64());
              } else r.value.push(e.int64());break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.FloatList = function () {
      function e(e) {
        if (this.value = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.value = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef.FloatList(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              if (r.value && r.value.length || (r.value = []), 2 == (7 & n)) for (var o = e.uint32() + e.pos; e.pos < o;) {
                r.value.push(e.float());
              } else r.value.push(e.float());break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.AnyList = function () {
      function e(e) {
        if (this.value = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.value = $util.emptyArray, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.CollectionDef.AnyList(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.value && r.value.length || (r.value = []), r.value.push($root.tensorflow.Any.decode(e, e.uint32()));break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.SaverDef = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }var t, a;return e.prototype.filenameTensorName = "", e.prototype.saveTensorName = "", e.prototype.restoreOpName = "", e.prototype.maxToKeep = 0, e.prototype.sharded = !1, e.prototype.keepCheckpointEveryNHours = 0, e.prototype.version = 0, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.SaverDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.filenameTensorName = e.string();break;case 2:
            r.saveTensorName = e.string();break;case 3:
            r.restoreOpName = e.string();break;case 4:
            r.maxToKeep = e.int32();break;case 5:
            r.sharded = e.bool();break;case 6:
            r.keepCheckpointEveryNHours = e.float();break;case 7:
            r.version = e.int32();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.CheckpointFormatVersion = (t = {}, (a = Object.create(t))[t[0] = "LEGACY"] = 0, a[t[1] = "V1"] = 1, a[t[2] = "V2"] = 2, a), e;
  }(), a.TensorInfo = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }var t;return e.prototype.name = "", e.prototype.cooSparse = null, e.prototype.dtype = 0, e.prototype.tensorShape = null, Object.defineProperty(e.prototype, "encoding", { get: $util.oneOfGetter(t = ["name", "cooSparse"]), set: $util.oneOfSetter(t) }), e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.TensorInfo(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.name = e.string();break;case 4:
            r.cooSparse = $root.tensorflow.TensorInfo.CooSparse.decode(e, e.uint32());break;case 2:
            r.dtype = e.int32();break;case 3:
            r.tensorShape = $root.tensorflow.TensorShape.decode(e, e.uint32());break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.CooSparse = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.valuesTensorName = "", e.prototype.indicesTensorName = "", e.prototype.denseShapeTensorName = "", e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.TensorInfo.CooSparse(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.valuesTensorName = e.string();break;case 2:
              r.indicesTensorName = e.string();break;case 3:
              r.denseShapeTensorName = e.string();break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.SignatureDef = function () {
    function e(e) {
      if (this.inputs = {}, this.outputs = {}, e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.inputs = $util.emptyObject, e.prototype.outputs = $util.emptyObject, e.prototype.methodName = "", e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a, r = void 0 === t ? e.len : e.pos + t, n = new $root.tensorflow.SignatureDef(); e.pos < r;) {
        var o = e.uint32();switch (o >>> 3) {case 1:
            e.skip().pos++, n.inputs === $util.emptyObject && (n.inputs = {}), a = e.string(), e.pos++, n.inputs[a] = $root.tensorflow.TensorInfo.decode(e, e.uint32());break;case 2:
            e.skip().pos++, n.outputs === $util.emptyObject && (n.outputs = {}), a = e.string(), e.pos++, n.outputs[a] = $root.tensorflow.TensorInfo.decode(e, e.uint32());break;case 3:
            n.methodName = e.string();break;default:
            e.skipType(7 & o);}
      }return n;
    }, e;
  }(), a.AssetFileDef = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.tensorInfo = null, e.prototype.filename = "", e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.AssetFileDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.tensorInfo = $root.tensorflow.TensorInfo.decode(e, e.uint32());break;case 2:
            r.filename = e.string();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.OpDef = function () {
    function e(e) {
      if (this.inputArg = [], this.outputArg = [], this.attr = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.name = "", e.prototype.inputArg = $util.emptyArray, e.prototype.outputArg = $util.emptyArray, e.prototype.attr = $util.emptyArray, e.prototype.deprecation = null, e.prototype.summary = "", e.prototype.description = "", e.prototype.isCommutative = !1, e.prototype.isAggregate = !1, e.prototype.isStateful = !1, e.prototype.allowsUninitializedInput = !1, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.OpDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.name = e.string();break;case 2:
            r.inputArg && r.inputArg.length || (r.inputArg = []), r.inputArg.push($root.tensorflow.OpDef.ArgDef.decode(e, e.uint32()));break;case 3:
            r.outputArg && r.outputArg.length || (r.outputArg = []), r.outputArg.push($root.tensorflow.OpDef.ArgDef.decode(e, e.uint32()));break;case 4:
            r.attr && r.attr.length || (r.attr = []), r.attr.push($root.tensorflow.OpDef.AttrDef.decode(e, e.uint32()));break;case 8:
            r.deprecation = $root.tensorflow.OpDef.OpDeprecation.decode(e, e.uint32());break;case 5:
            r.summary = e.string();break;case 6:
            r.description = e.string();break;case 18:
            r.isCommutative = e.bool();break;case 16:
            r.isAggregate = e.bool();break;case 17:
            r.isStateful = e.bool();break;case 19:
            r.allowsUninitializedInput = e.bool();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e.ArgDef = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.name = "", e.prototype.description = "", e.prototype.type = 0, e.prototype.typeAttr = "", e.prototype.numberAttr = "", e.prototype.typeListAttr = "", e.prototype.isRef = !1, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.OpDef.ArgDef(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.name = e.string();break;case 2:
              r.description = e.string();break;case 3:
              r.type = e.int32();break;case 4:
              r.typeAttr = e.string();break;case 5:
              r.numberAttr = e.string();break;case 6:
              r.typeListAttr = e.string();break;case 16:
              r.isRef = e.bool();break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.AttrDef = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.name = "", e.prototype.type = "", e.prototype.defaultValue = null, e.prototype.description = "", e.prototype.hasMinimum = !1, e.prototype.minimum = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, e.prototype.allowedValues = null, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.OpDef.AttrDef(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.name = e.string();break;case 2:
              r.type = e.string();break;case 3:
              r.defaultValue = $root.tensorflow.AttrValue.decode(e, e.uint32());break;case 4:
              r.description = e.string();break;case 5:
              r.hasMinimum = e.bool();break;case 6:
              r.minimum = e.int64();break;case 7:
              r.allowedValues = $root.tensorflow.AttrValue.decode(e, e.uint32());break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e.OpDeprecation = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.version = 0, e.prototype.explanation = "", e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.OpDef.OpDeprecation(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.version = e.int32();break;case 2:
              r.explanation = e.string();break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.OpList = function () {
    function e(e) {
      if (this.op = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.op = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.OpList(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.op && r.op.length || (r.op = []), r.op.push($root.tensorflow.OpDef.decode(e, e.uint32()));break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.MetaGraphDef = function () {
    function e(e) {
      if (this.collectionDef = {}, this.signatureDef = {}, this.assetFileDef = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.metaInfoDef = null, e.prototype.graphDef = null, e.prototype.saverDef = null, e.prototype.collectionDef = $util.emptyObject, e.prototype.signatureDef = $util.emptyObject, e.prototype.assetFileDef = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a, r = void 0 === t ? e.len : e.pos + t, n = new $root.tensorflow.MetaGraphDef(); e.pos < r;) {
        var o = e.uint32();switch (o >>> 3) {case 1:
            n.metaInfoDef = $root.tensorflow.MetaGraphDef.MetaInfoDef.decode(e, e.uint32());break;case 2:
            n.graphDef = $root.tensorflow.GraphDef.decode(e, e.uint32());break;case 3:
            n.saverDef = $root.tensorflow.SaverDef.decode(e, e.uint32());break;case 4:
            e.skip().pos++, n.collectionDef === $util.emptyObject && (n.collectionDef = {}), a = e.string(), e.pos++, n.collectionDef[a] = $root.tensorflow.CollectionDef.decode(e, e.uint32());break;case 5:
            e.skip().pos++, n.signatureDef === $util.emptyObject && (n.signatureDef = {}), a = e.string(), e.pos++, n.signatureDef[a] = $root.tensorflow.SignatureDef.decode(e, e.uint32());break;case 6:
            n.assetFileDef && n.assetFileDef.length || (n.assetFileDef = []), n.assetFileDef.push($root.tensorflow.AssetFileDef.decode(e, e.uint32()));break;default:
            e.skipType(7 & o);}
      }return n;
    }, e.MetaInfoDef = function () {
      function e(e) {
        if (this.tags = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
          null != e[t[a]] && (this[t[a]] = e[t[a]]);
        }
      }return e.prototype.metaGraphVersion = "", e.prototype.strippedOpList = null, e.prototype.anyInfo = null, e.prototype.tags = $util.emptyArray, e.prototype.tensorflowVersion = "", e.prototype.tensorflowGitVersion = "", e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.MetaGraphDef.MetaInfoDef(); e.pos < a;) {
          var n = e.uint32();switch (n >>> 3) {case 1:
              r.metaGraphVersion = e.string();break;case 2:
              r.strippedOpList = $root.tensorflow.OpList.decode(e, e.uint32());break;case 3:
              r.anyInfo = $root.tensorflow.Any.decode(e, e.uint32());break;case 4:
              r.tags && r.tags.length || (r.tags = []), r.tags.push(e.string());break;case 5:
              r.tensorflowVersion = e.string();break;case 6:
              r.tensorflowGitVersion = e.string();break;default:
              e.skipType(7 & n);}
        }return r;
      }, e;
    }(), e;
  }(), a.SavedModel = function () {
    function e(e) {
      if (this.metaGraphs = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.savedModelSchemaVersion = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, e.prototype.metaGraphs = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.SavedModel(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.savedModelSchemaVersion = e.int64();break;case 2:
            r.metaGraphs && r.metaGraphs.length || (r.metaGraphs = []), r.metaGraphs.push($root.tensorflow.MetaGraphDef.decode(e, e.uint32()));break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.FunctionDefLibrary = function () {
    function e(e) {
      if (this.function = [], this.gradient = [], e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.function = $util.emptyArray, e.prototype.gradient = $util.emptyArray, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.FunctionDefLibrary(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.function && r.function.length || (r.function = []), r.function.push($root.tensorflow.FunctionDef.decode(e, e.uint32()));break;case 2:
            r.gradient && r.gradient.length || (r.gradient = []), r.gradient.push($root.tensorflow.GradientDef.decode(e, e.uint32()));break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a.FunctionDef = function () {
    function e(e) {
      if (this.attr = {}, this.nodeDef = [], this.ret = {}, e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.signature = null, e.prototype.attr = $util.emptyObject, e.prototype.nodeDef = $util.emptyArray, e.prototype.ret = $util.emptyObject, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a, r = void 0 === t ? e.len : e.pos + t, n = new $root.tensorflow.FunctionDef(); e.pos < r;) {
        var o = e.uint32();switch (o >>> 3) {case 1:
            n.signature = $root.tensorflow.OpDef.decode(e, e.uint32());break;case 5:
            e.skip().pos++, n.attr === $util.emptyObject && (n.attr = {}), a = e.string(), e.pos++, n.attr[a] = $root.tensorflow.AttrValue.decode(e, e.uint32());break;case 3:
            n.nodeDef && n.nodeDef.length || (n.nodeDef = []), n.nodeDef.push($root.tensorflow.NodeDef.decode(e, e.uint32()));break;case 4:
            e.skip().pos++, n.ret === $util.emptyObject && (n.ret = {}), a = e.string(), e.pos++, n.ret[a] = e.string();break;default:
            e.skipType(7 & o);}
      }return n;
    }, e;
  }(), a.GradientDef = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), a = 0; a < t.length; ++a) {
        null != e[t[a]] && (this[t[a]] = e[t[a]]);
      }
    }return e.prototype.functionName = "", e.prototype.gradientFunc = "", e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));for (var a = void 0 === t ? e.len : e.pos + t, r = new $root.tensorflow.GradientDef(); e.pos < a;) {
        var n = e.uint32();switch (n >>> 3) {case 1:
            r.functionName = e.string();break;case 2:
            r.gradientFunc = e.string();break;default:
            e.skipType(7 & n);}
      }return r;
    }, e;
  }(), a;
}();var compiled_api = $root,
    compiled_api_1 = compiled_api.tensorflow;function getParamValue(e, t, a, r) {
  var n = t.params[e];if (n && void 0 !== n.inputIndex) {
    if ("tensor" === n.type) return getTensor(t.inputNames[n.inputIndex], a, r);if ("tensors" === n.type) return (0 === n.inputIndex ? 0 === n.inputParamLength ? t.inputNames : t.inputNames.slice(n.inputIndex, -n.inputParamLength) : t.inputNames.splice(n.inputIndex)).map(function (e) {
      return getTensor(e, a, r);
    });var o = Array.prototype.slice.call(getTensor(t.inputNames.slice(n.inputIndex)[0], a, r).dataSync());return "number" === n.type ? o[0] : o;
  }return n && n.value;
}function getTensor(e, t, a) {
  var r = parseNodeName(e),
      n = r[0],
      o = r[1],
      s = a.currentContextIds.find(function (e) {
    return !!t[getNodeNameWithContextId(n, e)];
  });return void 0 !== s ? t[getNodeNameWithContextId(n, s)][o] : void 0;
}function getTensorsForCurrentContenxt(e, t, a) {
  return t[getNodeNameWithContextId(e, a.currentContextId)];
}function getNodeNameAndIndex(e, t) {
  var a = parseNodeName(e),
      r = a[0],
      n = a[1];return [getNodeNameWithContextId(r, t && t.currentContextId), n];
}function getNodeNameWithContextId(e, t) {
  return t ? e + "-" + t : e;
}function parseNodeName(e) {
  var t = e.lastIndexOf(":");return -1 === t ? [e, 0] : [e.substring(0, t), Number(e.substring(t + 1))];
}function split$1(e, t) {
  for (var a = [], r = 0; r < e.length; r += t) {
    a.push(e.slice(r, r + t));
  }return a;
}var json = [{ tfOpName: "Add", dlOpName: "add", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "AddN", dlOpName: "addN", category: "arithmetic", params: [{ tfInputIndex: 0, tfInputParamLength: 0, dlParamName: "tensors", type: "tensors" }] }, { tfOpName: "BiasAdd", dlOpName: "add", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sub", dlOpName: "sub", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "RealDiv", dlOpName: "div", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Div", dlOpName: "div", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "FloorDiv", dlOpName: "floorDiv", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Mul", dlOpName: "mul", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Maximum", dlOpName: "maximum", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }] }, { tfOpName: "Minimum", dlOpName: "minimum", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }] }, { tfOpName: "Pow", dlOpName: "pow", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "SquaredDifference", dlOpName: "squaredDifference", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Mod", dlOpName: "mod", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "FloorMod", dlOpName: "mod", category: "arithmetic", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }],
    arithmetic = Object.freeze({ json: json }),
    json$1 = [{ tfOpName: "Abs", dlOpName: "abs", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Acos", dlOpName: "acos", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Asin", dlOpName: "asin", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Atan", dlOpName: "atan", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Atan2", dlOpName: "atan2", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "y", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Ceil", dlOpName: "ceil", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "ClipByValue", dlOpName: "clipByValue", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "clip_value_min", dlParamName: "clipValueMin", type: "number" }, { tfParamName: "clip_value_max", dlParamName: "clipValueMax", type: "number" }] }, { tfOpName: "Cos", dlOpName: "cos", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Cosh", dlOpName: "cosh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Elu", dlOpName: "elu", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Exp", dlOpName: "exp", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Floor", dlOpName: "floor", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Log", dlOpName: "log", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Neg", dlOpName: "neg", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Relu", dlOpName: "relu", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Relu6", dlOpName: "clipByValue", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }, { dlParamName: "clipValueMin", type: "number", defaultValue: 0 }, { dlParamName: "clipValueMax", type: "number", defaultValue: 6 }] }, { tfOpName: "Selu", dlOpName: "selu", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sigmoid", dlOpName: "sigmoid", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sin", dlOpName: "sin", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sinh", dlOpName: "sinh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sqrt", dlOpName: "sqrt", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Rsqrt", dlOpName: "rsqrt", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Square", dlOpName: "square", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Tan", dlOpName: "tan", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Tanh", dlOpName: "tanh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Sign", dlOpName: "sign", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Round", dlOpName: "round", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Expm1", dlOpName: "expm1", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Log1p", dlOpName: "log1p", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Reciprocal", dlOpName: "reciprocal", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Reciprocal", dlOpName: "reciprocal", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Softplus", dlOpName: "softplus", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Asinh", dlOpName: "asinh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Acosh", dlOpName: "acosh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Atanh", dlOpName: "atanh", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Erf", dlOpName: "erf", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Prod", dlOpName: "prod", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axes", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool", notSupported: !0 }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "LeakyRelu", dlOpName: "leakyRelu", category: "basic_math", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "alpha", dlParamName: "alpha", type: "number", defaultValue: .2 }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }],
    basicMath = Object.freeze({ json: json$1 }),
    json$2 = [{ tfOpName: "LoopCond", dlOpName: "loopCond", category: "control", params: [{ tfInputIndex: 0, dlParamName: "pred", type: "tensor" }] }, { tfOpName: "Switch", dlOpName: "switch", category: "control", params: [{ tfInputIndex: 0, dlParamName: "data", type: "tensor" }, { tfInputIndex: 1, dlParamName: "pred", type: "tensor" }] }, { tfOpName: "Merge", dlOpName: "merge", category: "control", params: [{ tfInputIndex: 0, tfInputParamLength: 0, dlParamName: "tensors", type: "tensors" }] }, { tfOpName: "Enter", dlOpName: "enter", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensor", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }, { tfParamName: "frame_name", dlParamName: "frameName", type: "string" }, { tfParamName: "is_constant", dlParamName: "isConstant", type: "bool" }] }, { tfOpName: "Exit", dlOpName: "exit", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensor", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "NextIteration", dlOpName: "nextIteration", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensor", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "TensorArrayV3", dlOpName: "tensorArray", category: "control", params: [{ tfInputIndex: 0, dlParamName: "size", type: "number" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }, { tfParamName: "element_shape", dlParamName: "elementShape", type: "shape" }, { tfParamName: "dynamic_size", dlParamName: "dynamicSize", type: "bool" }, { tfParamName: "clear_after_read", dlParamName: "clearAfterRead", type: "bool" }, { tfParamName: "identical_element_shapes", dlParamName: "identicalElementShapes", type: "bool" }, { tfParamName: "tensor_array_name", dlParamName: "name", type: "string" }] }, { tfOpName: "TensorArrayWriteV3", dlOpName: "tensorArrayWrite", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "index", type: "number" }, { tfInputIndex: 2, dlParamName: "tensor", type: "tensor" }, { tfInputIndex: 3, dlParamName: "flowIn", type: "number" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "TensorArrayReadV3", dlOpName: "tensorArrayRead", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "index", type: "number" }, { tfInputIndex: 2, dlParamName: "flowIn", type: "number" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "TensorArrayGatherV3", dlOpName: "tensorArrayGather", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "indices", type: "number[]" }, { tfInputIndex: 2, dlParamName: "flowIn", type: "number" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }, { tfParamName: "element_shape", dlParamName: "elementShape", type: "shape" }] }, { tfOpName: "TensorArrayScatterV3", dlOpName: "tensorArrayScatter", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "indices", type: "number[]" }, { tfInputIndex: 2, dlParamName: "tensor", type: "tensor" }, { tfInputIndex: 3, dlParamName: "flowIn", type: "number" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "TensorArrayConcatV3", dlOpName: "tensorArrayConcat", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "flowIn", type: "number" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }, { tfParamName: "element_shape_except0", dlParamName: "elementShapeExcept0", type: "shape", notSupported: !0 }] }, { tfOpName: "TensorArraySplitV3", dlOpName: "tensorArraySplit", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "tensor", type: "tensor" }, { tfInputIndex: 2, dlParamName: "lengths", type: "number[]" }, { tfInputIndex: 3, dlParamName: "flowIn", type: "number" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "TensorArraySizeV3", dlOpName: "tensorArraySize", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }, { tfInputIndex: 1, dlParamName: "flowIn", type: "number" }] }, { tfOpName: "TensorArrayCloseV3", dlOpName: "tensorArrayClose", category: "control", params: [{ tfInputIndex: 0, dlParamName: "tensorArrayId", type: "number" }] }],
    control = Object.freeze({ json: json$2 }),
    json$3 = [{ tfOpName: "AvgPool", dlOpName: "avgPool", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", notSupported: !0 }, { tfParamName: "ksize", dlParamName: "kernelSize", type: "number[]" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "MaxPool", dlOpName: "maxPool", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", notSupported: !0 }, { tfParamName: "ksize", dlParamName: "kernelSize", type: "number[]" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Conv1D", dlOpName: "conv1d", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "filter", type: "tensor" }, { tfParamName: "stride", dlParamName: "stride", type: "number" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", defaultValue: "NWC" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }, { tfParamName: "dilation", dlParamName: "dilation", type: "number", defaultValue: 1 }] }, { tfOpName: "Conv2D", dlOpName: "conv2d", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "filter", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "useCudnnOnGpu", dlParamName: "useCudnnOnGpu", type: "bool" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", defaultValue: "NHWC" }, { tfParamName: "dilations", dlParamName: "dilations", type: "number[]" }] }, { tfOpName: "Conv2DBackpropInput", dlOpName: "conv2dTranspose", category: "convolution", params: [{ tfInputIndex: 2, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "filter", type: "tensor" }, { tfInputIndex: 0, dlParamName: "outputShape", type: "number[]" }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", notSupported: !0 }] }, { tfOpName: "DepthwiseConv2d", dlOpName: "depthwiseConv2d", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "input", type: "tensor" }, { tfInputIndex: 1, dlParamName: "filter", type: "tensor" }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", defaultValue: "NHWC" }, { tfParamName: "dilations", dlParamName: "dilations", type: "number[]" }] }, { tfOpName: "DepthwiseConv2dNative", dlOpName: "depthwiseConv2d", category: "convolution", params: [{ tfInputIndex: 0, dlParamName: "input", type: "tensor" }, { tfInputIndex: 1, dlParamName: "filter", type: "tensor" }, { tfParamName: "strides", dlParamName: "strides", type: "number[]" }, { tfParamName: "padding", dlParamName: "pad", type: "string" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", defaultValue: "NHWC" }, { tfParamName: "dilations", dlParamName: "dilations", type: "number[]" }] }],
    convolution = Object.freeze({ json: json$3 }),
    json$4 = [{ tfOpName: "Fill", dlOpName: "fill", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "shape", type: "number[]" }, { tfInputIndex: 1, dlParamName: "value", type: "number" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "LinSpace", dlOpName: "linspace", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "start", type: "number" }, { tfInputIndex: 1, dlParamName: "stop", type: "number" }, { tfInputIndex: 2, dlParamName: "num", type: "number" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "OneHot", dlOpName: "oneHot", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "indices", type: "tensor" }, { tfInputIndex: 1, dlParamName: "depth", type: "number" }, { tfInputIndex: 2, dlParamName: "onValue", type: "number", defaultValue: 1 }, { tfInputIndex: 3, dlParamName: "offValue", type: "number", defaultValue: 0 }, { tfParamName: "axis", dlParamName: "axis", type: "number", notSupported: !0 }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Ones", dlOpName: "ones", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "shape", type: "number[]" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "OnesLike", dlOpName: "onesLike", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "RandomUniform", dlOpName: "randomUniform", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "shape", type: "number[]" }, { tfParamName: "minval", dlParamName: "minval", type: "number", defaultValue: 0 }, { tfParamName: "maxval", dlParamName: "maxval", type: "number", defaultValue: 1 }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }, { tfParamName: "seed", dlParamName: "seed", type: "number", defaultValue: 0 }, { tfParamName: "seed2", dlParamName: "seed2", type: "number", defaultValue: 0, notSupported: !0 }, { tfParamName: "T", dlParamName: "T", type: "number", notSupported: !0 }] }, { tfOpName: "Range", dlOpName: "range", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "start", type: "number" }, { tfInputIndex: 1, dlParamName: "stop", type: "number" }, { tfInputIndex: 2, dlParamName: "step", type: "number", defaultValue: 0 }, { tfParamName: "Tidx", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "truncatedNormal", dlOpName: "truncatedNormal", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "shape", type: "number[]" }, { tfParamName: "means", dlParamName: "mean", type: "number", defaultValue: 0 }, { tfParamName: "stddev", dlParamName: "stdDev", type: "number", defaultValue: 1 }, { tfParamName: "seed", dlParamName: "seed", type: "number" }, { tfParamName: "seed2", dlParamName: "seed2", type: "number", defaultValue: 0, notSupported: !0 }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }, { tfParamName: "T", dlParamName: "T", type: "number", notSupported: !0 }] }, { tfOpName: "Zeros", dlOpName: "zeros", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "shape", type: "number[]" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "ZerosLike", dlOpName: "zerosLike", category: "creation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype" }] }],
    creation = Object.freeze({ json: json$4 }),
    json$5 = [{ tfOpName: "NonMaxSuppressionV2", dlOpName: "nonMaxSuppression", category: "dynamic", params: [{ tfInputIndex: 0, dlParamName: "boxes", type: "tensor" }, { tfInputIndex: 1, dlParamName: "scores", type: "tensor" }, { tfInputIndex: 2, dlParamName: "maxOutputSize", type: "number" }, { tfInputIndex: 3, dlParamName: "iouThreshold", type: "number" }] }, { tfOpName: "NonMaxSuppressionV3", dlOpName: "nonMaxSuppression", category: "dynamic", params: [{ tfInputIndex: 0, dlParamName: "boxes", type: "tensor" }, { tfInputIndex: 1, dlParamName: "scores", type: "tensor" }, { tfInputIndex: 2, dlParamName: "maxOutputSize", type: "number" }, { tfInputIndex: 3, dlParamName: "iouThreshold", type: "number" }, { tfInputIndex: 4, dlParamName: "scoreThreshold", type: "number" }] }, { tfOpName: "Where", dlOpName: "whereAsync", category: "dynamic", params: [{ tfInputIndex: 0, dlParamName: "condition", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "ListDiff", dlOpName: "setdiff1dAsync", category: "dynamic", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "y", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }],
    dynamic = Object.freeze({ json: json$5 }),
    json$6 = [{ tfOpName: "TopKV2", dlOpName: "topK", category: "evaluation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "k", type: "number" }, { tfParamName: "sorted", dlParamName: "sorted", type: "bool" }] }],
    evaluation = Object.freeze({ json: json$6 }),
    json$7 = [{ tfOpName: "PlaceholderWithDefault", dlOpName: "placeholder", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "default", type: "tensor" }, { tfParamName: "shape", dlParamName: "shape", type: "shape" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "Placeholder", dlOpName: "placeholder", category: "graph", params: [{ tfParamName: "shape", dlParamName: "shape", type: "shape" }, { tfParamName: "dtype", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "Const", dlOpName: "const", category: "graph" }, { tfOpName: "Identity", dlOpName: "identity", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "Snapshot", dlOpName: "snapshot", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "Rank", dlOpName: "rank", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "Size", dlOpName: "size", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "Shape", dlOpName: "shape", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "ShapeN", dlOpName: "shapeN", category: "graph", params: [{ tfInputIndex: 0, tfInputParamLength: 0, dlParamName: "x", type: "tensors" }] }, { tfOpName: "Print", dlOpName: "print", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, tfInputParamLength: 1, dlParamName: "data", type: "tensors" }, { tfParamName: "message", dlParamName: "message", type: "string" }, { tfParamName: "first_n", dlParamName: "firstN", type: "number", notSupprted: !0 }, { tfParamName: "summarize", dlParamName: "summarize", type: "number", defaultValue: 3 }] }, { tfOpName: "NoOp", dlOpName: "noop", category: "graph", params: [] }, { tfOpName: "StopGradient", dlOpName: "stopGradient", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "FakeQuantWithMinMaxVars", dlOpName: "fakeQuantWithMinMaxVars", category: "graph", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "min", dlParamName: "min", type: "number" }, { tfParamName: "max", dlParamName: "max", type: "number" }] }],
    graph = Object.freeze({ json: json$7 }),
    json$8 = [{ tfOpName: "ResizeBilinear", dlOpName: "resizeBilinear", category: "image", params: [{ tfInputIndex: 0, dlParamName: "images", type: "tensor" }, { tfInputIndex: 1, dlParamName: "size", type: "number[]" }, { tfParamName: "align_corners", dlParamName: "alignCorners", type: "bool" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "ResizeNearestNeighbor", dlOpName: "resizeNearestNeighbor", category: "image", params: [{ tfInputIndex: 0, dlParamName: "images", type: "tensor" }, { tfInputIndex: 1, dlParamName: "size", type: "number[]" }, { tfParamName: "align_corners", dlParamName: "alignCorners", type: "bool" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "CropAndResize", dlOpName: "cropAndResize", category: "image", params: [{ tfInputIndex: 0, dlParamName: "image", type: "tensor" }, { tfInputIndex: 1, dlParamName: "boxes", type: "tensor" }, { tfInputIndex: 2, dlParamName: "boxInd", type: "tensor" }, { tfInputIndex: 3, dlParamName: "cropSize", type: "number[]" }, { tfParamName: "method", dlParamName: "method", type: "string" }, { tfParamName: "extrapolation_value", dlParamName: "extrapolationValue", type: "number" }] }],
    image$1 = Object.freeze({ json: json$8 }),
    json$9 = [{ tfOpName: "Equal", dlOpName: "equal", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "NotEqual", dlOpName: "notEqual", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Greater", dlOpName: "greater", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "GreaterEqual", dlOpName: "greaterEqual", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Less", dlOpName: "less", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "LessEqual", dlOpName: "lessEqual", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "LogicalAnd", dlOpName: "logicalAnd", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "LogicalNot", dlOpName: "logicalNot", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "LogicalOr", dlOpName: "logicalOr", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Select", dlOpName: "where", category: "logical", params: [{ tfInputIndex: 0, dlParamName: "condition", type: "tensor" }, { tfInputIndex: 1, dlParamName: "a", type: "tensor" }, { tfInputIndex: 2, dlParamName: "b", type: "tensor" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }],
    logical = Object.freeze({ json: json$9 }),
    json$10 = [{ tfOpName: "MatMul", dlOpName: "matMul", category: "matrices", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "transpose_a", dlParamName: "transposeA", type: "bool", defaultValue: !1 }, { tfParamName: "transpose_b", dlParamName: "transposeB", type: "bool", defaultValue: !1 }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "BatchMatMul", dlOpName: "matMul", category: "matrices", params: [{ tfInputIndex: 0, dlParamName: "a", type: "tensor" }, { tfInputIndex: 1, dlParamName: "b", type: "tensor" }, { tfParamName: "adj_x", dlParamName: "transposeA", type: "bool", defaultValue: !1 }, { tfParamName: "adj_y", dlParamName: "transposeB", type: "bool", defaultValue: !1 }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }, { tfOpName: "Transpose", dlOpName: "transpose", category: "matrices", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "perm", type: "number[]" }, { tfParamName: "T", dlParamName: "dtype", type: "dtype", notSupported: !0 }] }],
    matrices = Object.freeze({ json: json$10 }),
    json$11 = [{ tfOpName: "FusedBatchNorm", dlOpName: "batchNormalization", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "scale", type: "tensor" }, { tfInputIndex: 2, dlParamName: "offset", type: "tensor" }, { tfInputIndex: 3, dlParamName: "mean", type: "tensor" }, { tfInputIndex: 4, dlParamName: "variance", type: "tensor" }, { tfParamName: "epsilon", dlParamName: "epsilon", type: "number", defaultValue: .001 }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", notSupported: !0 }] }, { tfOpName: "FusedBatchNormV2", dlOpName: "batchNormalization", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "scale", type: "tensor" }, { tfInputIndex: 2, dlParamName: "offset", type: "tensor" }, { tfInputIndex: 3, dlParamName: "mean", type: "tensor" }, { tfInputIndex: 4, dlParamName: "variance", type: "tensor" }, { tfParamName: "epsilon", dlParamName: "epsilon", type: "number", defaultValue: .001 }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string", notSupported: !0 }] }, { tfOpName: "LRN", dlOpName: "localResponseNormalization", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "depth_radius", dlParamName: "radius", type: "number", defaultValue: 5 }, { tfParamName: "bias", dlParamName: "bias", type: "number", defaultValue: 1 }, { tfParamName: "alpha", dlParamName: "alpha", type: "number", defaultValue: 1 }, { tfParamName: "beta", dlParamName: "beta", type: "number", defaultValue: .5 }] }, { tfOpName: "Softmax", dlOpName: "softmax", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "LogSoftmax", dlOpName: "logSoftmax", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "SparseToDense", dlOpName: "sparseToDense", category: "normalization", params: [{ tfInputIndex: 0, dlParamName: "sparseIndices", type: "tensor" }, { tfInputIndex: 1, dlParamName: "outputShape", type: "number[]" }, { tfInputIndex: 2, dlParamName: "sparseValues", type: "tensor" }, { tfInputIndex: 3, dlParamName: "defaultValue", type: "tensor" }, { tfParamName: "validate_indices", dlParamName: "validateIndices", type: "bool", defaultValue: !0, notSupported: !0 }] }],
    normalization = Object.freeze({ json: json$11 }),
    json$12 = [{ tfOpName: "Max", dlOpName: "max", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "Mean", dlOpName: "mean", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "Min", dlOpName: "min", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "Sum", dlOpName: "sum", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "All", dlOpName: "all", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "Any", dlOpName: "any", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }, { tfOpName: "ArgMax", dlOpName: "argMax", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number" }] }, { tfOpName: "ArgMin", dlOpName: "argMin", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number" }] }, { tfOpName: "Prod", dlOpName: "prod", category: "reduction", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }, { tfParamName: "keep_dims", dlParamName: "keepDims", type: "bool" }] }],
    reduction = Object.freeze({ json: json$12 }),
    json$13 = [{ tfOpName: "ConcatV2", dlOpName: "concat", category: "slice_join", params: [{ tfInputIndex: 0, tfInputParamLength: 1, dlParamName: "tensors", type: "tensors" }, { tfInputIndex: -1, dlParamName: "axis", type: "number" }] }, { tfOpName: "Concat", dlOpName: "concat", category: "slice_join", params: [{ tfInputIndex: 1, tfInputParamLength: 1, dlParamName: "tensors", type: "tensors" }, { tfInputIndex: 0, dlParamName: "axis", type: "number" }] }, { tfOpName: "GatherV2", dlOpName: "gather", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "indices", type: "tensor" }, { tfInputIndex: 2, dlParamName: "axis", type: "number", defaultValue: 0 }] }, { tfOpName: "Gather", dlOpName: "gather", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "indices", type: "tensor" }, { tfParamName: "axis", dlParamName: "axis", type: "number", defaultValue: 0 }, { tfParamName: "validate_indices", dlParamName: "validateIndices", type: "bool", notSupported: !0 }] }, { tfOpName: "Reverse", dlOpName: "reverse", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "dims", type: "bool", notSupported: !0 }] }, { tfOpName: "ReverseV2", dlOpName: "reverse", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "axis", type: "number[]" }] }, { tfOpName: "Slice", dlOpName: "slice", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "begin", type: "number[]" }, { tfInputIndex: 2, dlParamName: "size", type: "number[]" }] }, { tfOpName: "StridedSlice", dlOpName: "stridedSlice", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "begin", type: "number[]" }, { tfInputIndex: 2, dlParamName: "end", type: "number[]" }, { tfInputIndex: 3, dlParamName: "strides", type: "number[]" }, { tfParamName: "begin_mask", dlParamName: "beginMask", type: "number", defaultValue: 0 }, { tfParamName: "end_mask", dlParamName: "endMask", type: "number", defaultValue: 0 }, { tfParamName: "new_axis_mask", dlParamName: "newAxisMask", type: "number", defaultValue: 0 }, { tfParamName: "ellipsis_mask", dlParamName: "ellipsisMask", type: "number", defaultValue: 0 }, { tfParamName: "shrink_axis_mask", dlParamName: "shrinkAxisMask", type: "number", defaultValue: 0 }] }, { tfOpName: "Pack", dlOpName: "stack", category: "slice_join", params: [{ tfInputIndex: 0, tfInputParamLength: 0, dlParamName: "tensors", type: "tensors" }, { tfParamName: "axis", dlParamName: "axis", type: "number", defaultValue: 0 }] }, { tfOpName: "Unpack", dlOpName: "unstack", category: "slice_join", params: [{ tfInputIndex: 0, tfInputParamLength: 0, dlParamName: "tensor", type: "tensor" }, { tfParamName: "axis", dlParamName: "axis", type: "number", defaultValue: 0 }, { tfParamName: "num", dlParamName: "num", type: "number", defaultValue: 0, notSupported: !0 }] }, { tfOpName: "Tile", dlOpName: "tile", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "reps", type: "number[]" }] }, { tfOpName: "Split", dlOpName: "split", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "axis", type: "number", defaultValue: 0 }, { tfInputIndex: 1, dlParamName: "x", type: "tensor" }, { tfParamName: "num_split", dlParamName: "numOrSizeSplits", type: "number", defaultValue: 1 }] }, { tfOpName: "SplitV", dlOpName: "split", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "numOrSizeSplits", type: "number[]" }, { tfInputIndex: 2, dlParamName: "axis", type: "number", defaultValue: 0 }] }, { tfOpName: "ScatterNd", dlOpName: "scatterNd", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "indices", type: "tensor" }, { tfInputIndex: 1, dlParamName: "values", type: "tensor" }, { tfInputIndex: 2, dlParamName: "shape", type: "number[]" }] }, { tfOpName: "GatherNd", dlOpName: "gatherNd", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "indices", type: "tensor" }] }, { tfOpName: "SparseToDense", dlOpName: "sparseToDense", category: "slice_join", params: [{ tfInputIndex: 0, dlParamName: "sparseIndices", type: "tensor" }, { tfInputIndex: 1, dlParamName: "outputShape", type: "number[]" }, { tfInputIndex: 2, dlParamName: "sparseValues", type: "tensor" }, { tfInputIndex: 3, dlParamName: "defaultValue", type: "tensor" }, { tfParamName: "validate_indices", dlParamName: "validateIndices", type: "bool", defaultValue: !1, notSupported: !0 }] }],
    sliceJoin = Object.freeze({ json: json$13 }),
    json$14 = [{ tfOpName: "FFT", dlOpName: "fft", category: "spectral", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "IFFT", dlOpName: "ifft", category: "spectral", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }] }, { tfOpName: "RFFT", dlOpName: "rfft", category: "spectral", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "fft_length", type: "number", unsupported: !0 }] }, { tfOpName: "IRFFT", dlOpName: "irfft", category: "spectral", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "fft_length", type: "number", unsupported: !0 }] }],
    spectral = Object.freeze({ json: json$14 }),
    json$15 = [{ tfOpName: "Cast", dlOpName: "cast", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "SrcT", dlParamName: "sdtype", type: "dtype", notSupported: !0 }, { tfParamName: "DstT", dlParamName: "dtype", type: "dtype" }] }, { tfOpName: "ExpandDims", dlOpName: "expandDims", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, tfParamNameDeprecated: "dim", dlParamName: "axis", type: "number" }] }, { tfOpName: "Pad", dlOpName: "pad", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "padding", type: "number[]" }, { tfParamName: "constant_value", dlParamName: "constantValue", type: "number", defaultValue: 0 }] }, { tfOpName: "PadV2", dlOpName: "pad", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "padding", type: "number[]" }, { tfInputIndex: 2, dlParamName: "constantValue", type: "number", defaultValue: 0 }] }, { tfOpName: "Reshape", dlOpName: "reshape", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "shape", type: "number[]" }] }, { tfOpName: "Squeeze", dlOpName: "squeeze", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "axis", tfParamNameDeprecated: "squeeze_dims", dlParamName: "axis", type: "number[]" }] }, { tfOpName: "SpaceToBatchND", dlOpName: "spaceToBatchND", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "blockShape", type: "number[]" }, { tfInputIndex: 2, dlParamName: "paddings", type: "number[]" }] }, { tfOpName: "BatchToSpaceND", dlOpName: "batchToSpaceND", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfInputIndex: 1, dlParamName: "blockShape", type: "number[]" }, { tfInputIndex: 2, dlParamName: "crops", type: "number[]" }] }, { tfOpName: "DepthToSpace", dlOpName: "depthToSpace", category: "transformation", params: [{ tfInputIndex: 0, dlParamName: "x", type: "tensor" }, { tfParamName: "block_size", dlParamName: "blockSize", type: "number" }, { tfParamName: "data_format", dlParamName: "dataFormat", type: "string" }] }],
    transformation = Object.freeze({ json: json$15 }),
    CONTROL_FLOW_OPS = ["Switch", "Merge", "Enter", "Exit", "NextIteration"],
    DYNAMIC_SHAPE_OPS = ["NonMaxSuppressionV2", "NonMaxSuppressionV3", "Where"],
    OperationMapper = function () {
  function e() {
    var e = [arithmetic, basicMath, control, convolution, creation, dynamic, evaluation, logical, image$1, graph, matrices, normalization, reduction, sliceJoin, spectral, transformation],
        t = [].concat.apply([], e.map(function (e) {
      return e.json;
    }));this.opMappers = t.reduce(function (e, t) {
      return e[t.tfOpName] = t, e;
    }, {});
  }return Object.defineProperty(e, "Instance", { get: function get() {
      return this._instance || (this._instance = new this());
    }, enumerable: !0, configurable: !0 }), e.prototype.isControlFlow = function (e) {
    return CONTROL_FLOW_OPS.some(function (t) {
      return t === e.op;
    });
  }, e.prototype.isDynamicShape = function (e) {
    return DYNAMIC_SHAPE_OPS.some(function (t) {
      return t === e.op;
    });
  }, e.prototype.transformGraph = function (e) {
    var t = this,
        a = !1,
        r = !1,
        n = [],
        o = [],
        s = e.node.reduce(function (e, s) {
      return e[s.name] = t.mapNode(s), t.isControlFlow(s) && (a = !0), t.isDynamicShape(s) && (r = !0), "Placeholder" === s.op && n.push(e[s.name]), "Const" === s.op && o.push(e[s.name]), e;
    }, {}),
        i = [],
        p = [];return Object.keys(s).forEach(function (e) {
      var t = s[e];t.inputNames.forEach(function (e) {
        var a = getNodeNameAndIndex(e)[0];t.inputs.push(s[a]), s[a].children.push(t);
      }), 0 === t.inputs.length && i.push(t);
    }), Object.keys(s).forEach(function (e) {
      var t = s[e];0 === t.children.length && p.push(t);
    }), { nodes: s, inputs: i, outputs: p, weights: o, placeholders: n, withControlFlow: a, withDynamicShape: r };
  }, e.prototype.mapNode = function (e) {
    var t = this,
        a = this.opMappers[e.op];if (void 0 === a) throw new Error("Tensorflow Op is not supported: " + e.op);var r = { name: e.name, op: a.dlOpName, category: a.category, inputNames: (e.input || []).map(function (e) {
        return e.startsWith("^") ? e.substr(1) : e;
      }), inputs: [], children: [], params: {} };return a.params && (r.params = a.params.reduce(function (a, r) {
      var n = r.tfInputIndex,
          o = r.tfInputParamLength,
          s = r.type,
          i = void 0;if (void 0 === n) switch (r.type) {case "string":
          void 0 === (i = t.getStringParam(e.attr, r.tfParamName, r.defaultValue)) && r.tfParamNameDeprecated && (i = t.getStringParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "number":
          void 0 === (i = t.getNumberParam(e.attr, r.tfParamName, r.defaultValue || 0)) && r.tfParamNameDeprecated && (i = t.getNumberParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "number[]":
          void 0 === (i = t.getNumericArrayParam(e.attr, r.tfParamName, r.defaultValue)) && r.tfParamNameDeprecated && (i = t.getNumericArrayParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "bool":
          void 0 === (i = t.getBoolParam(e.attr, r.tfParamName, r.defaultValue)) && r.tfParamNameDeprecated && (i = t.getBoolParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "shape":
          void 0 === (i = t.getTensorShapeParam(e.attr, r.tfParamName, r.defaultValue)) && r.tfParamNameDeprecated && (i = t.getTensorShapeParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "dtype":
          void 0 === (i = t.getDtypeParam(e.attr, r.tfParamName, r.defaultValue)) && r.tfParamNameDeprecated && (i = t.getDtypeParam(e.attr, r.tfParamNameDeprecated, r.defaultValue));break;case "tensor":case "tensors":
          break;default:
          throw new Error("Unsupported param type: " + r.type + " for op: " + e.op);}return a[r.dlParamName] = { value: i, inputIndex: n, type: s, inputParamLength: o }, a;
    }, {})), r;
  }, e.prototype.getStringParam = function (e, t, a, r) {
    void 0 === r && (r = !1);var n = e[t];if (void 0 !== n) {
      var o = String.fromCharCode.apply(null, n.s);return r ? o : o.toLowerCase();
    }return a;
  }, e.prototype.getBoolParam = function (e, t, a) {
    var r = e[t];return r ? r.b : a;
  }, e.prototype.getNumberParam = function (e, t, a) {
    var r = e[t],
        n = r ? r[r.value] : a;return "number" == typeof n ? n : n.toInt();
  }, e.prototype.getDtypeParam = function (e, t, a) {
    var r = e[t];if (r && r.type) switch (r.type) {case compiled_api_1.DataType.DT_FLOAT:
        return "float32";case compiled_api_1.DataType.DT_INT32:
        return "int32";case compiled_api_1.DataType.DT_BOOL:
        return "bool";default:
        return a;}return a;
  }, e.prototype.getTensorShapeParam = function (e, t, a) {
    var r = e[t];return r && r.shape ? r.shape.dim.map(function (e) {
      return "number" == typeof e.size ? e.size : e.size.toInt();
    }) : a;
  }, e.prototype.getNumericArrayParam = function (e, t, a) {
    var r = e[t];return r ? (r.list.f && r.list.f.length ? r.list.f : r.list.i).map(function (e) {
      return "number" == typeof e ? e : e.toInt();
    }) : a;
  }, e;
}(),
    executeOp = function executeOp(e, t, a) {
  switch (e.op) {case "add":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "addN":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["h" /* addN */])(getParamValue("tensors", e, t, a))];case "mod":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* mod */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "mul":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_31" /* mul */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "div":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["O" /* div */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "floorDiv":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Z" /* floorDiv */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "sub":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* sub */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "minimum":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_28" /* minimum */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "maximum":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_24" /* maximum */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "pow":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_40" /* pow */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "squaredDifference":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* squaredDifference */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$1 = function executeOp$1(e, t, a) {
  switch (e.op) {case "abs":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(getParamValue("x", e, t, a))];case "acos":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["e" /* acos */])(getParamValue("x", e, t, a))];case "acosh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["f" /* acosh */])(getParamValue("x", e, t, a))];case "asin":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["m" /* asin */])(getParamValue("x", e, t, a))];case "asinh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["n" /* asinh */])(getParamValue("x", e, t, a))];case "atan":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["o" /* atan */])(getParamValue("x", e, t, a))];case "atan2":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["p" /* atan2 */])(getParamValue("x", e, t, a), getParamValue("y", e, t, a))];case "atanh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["q" /* atanh */])(getParamValue("x", e, t, a))];case "ceil":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["y" /* ceil */])(getParamValue("x", e, t, a))];case "cos":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["J" /* cos */])(getParamValue("x", e, t, a))];case "cosh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["K" /* cosh */])(getParamValue("x", e, t, a))];case "elu":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["P" /* elu */])(getParamValue("x", e, t, a))];case "erf":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["R" /* erf */])(getParamValue("x", e, t, a))];case "exp":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["S" /* exp */])(getParamValue("x", e, t, a))];case "expm1":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["U" /* expm1 */])(getParamValue("x", e, t, a))];case "floor":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Y" /* floor */])(getParamValue("x", e, t, a))];case "log":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_15" /* log */])(getParamValue("x", e, t, a))];case "log1p":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_16" /* log1p */])(getParamValue("x", e, t, a))];case "neg":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_33" /* neg */])(getParamValue("x", e, t, a))];case "reciprocal":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* reciprocal */])(getParamValue("x", e, t, a))];case "relu":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_47" /* relu */])(getParamValue("x", e, t, a))];case "round":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_51" /* round */])(getParamValue("x", e, t, a))];case "selu":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_54" /* selu */])(getParamValue("x", e, t, a))];case "sigmoid":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_58" /* sigmoid */])(getParamValue("x", e, t, a))];case "sin":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_60" /* sin */])(getParamValue("x", e, t, a))];case "sign":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_59" /* sign */])(getParamValue("x", e, t, a))];case "sinh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_61" /* sinh */])(getParamValue("x", e, t, a))];case "softplus":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_68" /* softplus */])(getParamValue("x", e, t, a))];case "sqrt":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_72" /* sqrt */])(getParamValue("x", e, t, a))];case "square":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* square */])(getParamValue("x", e, t, a))];case "tanh":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* tanh */])(getParamValue("x", e, t, a))];case "tan":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_81" /* tan */])(getParamValue("x", e, t, a))];case "clipByValue":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(getParamValue("x", e, t, a), getParamValue("clipValueMin", e, t, a), getParamValue("clipValueMax", e, t, a))];case "rsqrt":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["O" /* div */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(1, "float32"), Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_72" /* sqrt */])(getTensor(e.inputNames[0], t, a)))];case "prod":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* prod */])(getParamValue("x", e, t, a), getParamValue("axes", e, t, a))];case "leakyRelu":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_9" /* leakyRelu */])(getParamValue("x", e, t, a), getParamValue("alpha", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    TensorArray = function () {
  function e(t, a, r, n, o, s, i) {
    this.name = t, this.dtype = a, this.maxSize = r, this.elementShape = n, this.identicalElementShapes = o, this.dynamicSize = s, this.clearAfterRead = i, this.tensors = [], this.closed_ = !1, this.id = e.nextId++;
  }return Object.defineProperty(e.prototype, "closed", { get: function get() {
      return this.closed_;
    }, enumerable: !0, configurable: !0 }), e.prototype.clearAndClose = function () {
    this.tensors.forEach(function (e) {
      return e.tensor.dispose();
    }), this.tensors = [], this.closed_ = !0;
  }, e.prototype.size = function () {
    return this.tensors.length;
  }, e.prototype.read = function (e) {
    if (this.closed_) throw new Error("TensorArray " + this.name + " has already been closed.");if (e < 0 || e >= this.tensors.length) throw new Error("Tried to read from index " + e + ", but array size is: " + this.tensors.length);var t = this.tensors[e];if (t.cleared) throw new Error("TensorArray " + this.name + ": Could not read index " + e + " twice because it was cleared after a previous read (perhaps try setting clear_after_read = false?).");return this.clearAfterRead && (t.cleared = !0), t.read = !0, t.tensor;
  }, e.prototype.readMany = function (e) {
    var t = this;return e.map(function (e) {
      return t.read(e);
    });
  }, e.prototype.write = function (e, t) {
    if (this.closed_) throw new Error("TensorArray " + this.name + " has already been closed.");if (e < 0 || !this.dynamicSize && e >= this.maxSize) throw new Error("Tried to write to index " + e + ", but array is not resizeable and size is: " + this.maxSize);var a = this.tensors[e] || {};if (t.dtype !== this.dtype) throw new Error("TensorArray " + this.name + ": Could not write to TensorArray index " + e + ",\n          because the value dtype is " + t.dtype + ", but TensorArray dtype is " + this.dtype + ".");if (0 === this.size() && 0 === this.elementShape.length && (this.elementShape = t.shape), this.assertShapesMatch(this.elementShape, t.shape, "TensorArray " + this.name + ": Could not write to TensorArray index " + e + "."), a && a.read) throw new Error("TensorArray " + this.name + ": Could not write to TensorArray index " + e + ", because it has already been read.");if (a && a.written) throw new Error("TensorArray " + this.name + ": Could not write to TensorArray index " + e + ", because it has already been written.");a.tensor = t, a.written = !0, this.tensors[e] = a;
  }, e.prototype.writeMany = function (e, t) {
    var a = this;if (e.length !== t.length) throw new Error("TensorArray " + this.name + ": could not write multiple tensors,because the index size: " + e.length + " is not the same as tensors size: " + t.length + ".");e.forEach(function (e, r) {
      return a.write(e, t[r]);
    });
  }, e.prototype.gather = function (e, t) {
    if (t && t !== this.dtype) throw new Error("TensorArray dtype is " + this.dtype + " but gather requested dtype " + t);if (!e) {
      e = [];for (var a = 0; a < this.size(); a++) {
        e.push(a);
      }
    }if (0 === e.length) return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* tensor */])([], [0].concat(this.elementShape));var r = this.readMany(e);return this.assertShapesMatch(this.elementShape, r[0].shape, "TensorArray shape mismatch: "), Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_76" /* stack */])(r, 0);
  }, e.prototype.concat = function (e) {
    if (e && e !== this.dtype) throw new Error("TensorArray dtype is " + this.dtype + " but concat requested dtype " + e);if (0 === this.size()) return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* tensor */])([], [0].concat(this.elementShape));for (var t = [], a = 0; a < this.size(); a++) {
      t.push(a);
    }var r = this.readMany(t);return this.assertShapesMatch(this.elementShape, r[0].shape, "TensorArray shape mismatch: tensor array shape (" + this.elementShape + ") vs first tensor shape (" + r[0].shape + ")"), Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["B" /* concat */])(r, 0);
  }, e.prototype.scatter = function (e, t) {
    if (t.dtype !== this.dtype) throw new Error("TensorArray dtype is " + this.dtype + " but tensor has dtype " + t.dtype);if (e.length !== t.shape[0]) throw new Error("Expected len(indices) == tensor.shape[0], but saw: " + e.length + " vs. " + t.shape[0]);var a = Math.max.apply(Math, e);if (!this.dynamicSize && a >= this.maxSize) throw new Error("Max index must be < array size (" + a + "  vs. " + this.maxSize + ")");this.writeMany(e, Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* unstack */])(t, 0));
  }, e.prototype.split = function (e, t) {
    var a = this;if (t.dtype !== this.dtype) throw new Error("TensorArray dtype is " + this.dtype + " but tensor has dtype " + t.dtype);var r = 0,
        n = e.map(function (e) {
      return r += e;
    });if (r !== t.shape[0]) throw new Error("Expected sum of lengths to be equal to\n          tensor.shape[0], but sum of lengths is\n        " + r + ", and tensor's shape is: " + t.shape);if (!this.dynamicSize && e.length !== this.maxSize) throw new Error("TensorArray's size is not equal to the size of lengths (" + this.maxSize + " vs. " + e.length + "), and the TensorArray is not marked as dynamically resizeable");var o = 0 === r ? 0 : t.size / r,
        s = [];Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
      t = t.reshape([1, r, o]);for (var i = 0; i < e.length; ++i) {
        var p = [0, 0 === i ? 0 : n[i - 1], 0],
            m = [1, e[i], o];s[i] = Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_62" /* slice */])(t, p, m).reshape(a.elementShape);
      }return s;
    });for (var i = [], p = 0; p < e.length; p++) {
      i[p] = p;
    }this.writeMany(i, s);
  }, e.prototype.assertShapesMatch = function (e, t, a) {
    void 0 === a && (a = ""), __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(this.arraysEqual(e, t), a + " Shapes " + e + " and " + t + " must match");
  }, e.prototype.arraysEqual = function (e, t) {
    if (e.length !== t.length) return !1;for (var a = 0; a < e.length; a++) {
      if (-1 !== e[a] && -1 !== t[a] && e[a] !== t[a]) return !1;
    }return !0;
  }, e.nextId = 0, e;
}();function executeOp$2(e, t, a) {
  return __awaiter(this, void 0, void 0, function () {
    var r, n, o, s, i, p, m, u, l, d, f, c, y, h, N, g, P, x, b, I, v, O, V, w, T, k, S, _, A, $, D, E, j, R, C;return __generator(this, function (L) {
      switch (L.label) {case 0:
          switch (e.op) {case "loopCond":
              return [3, 1];case "switch":
              return [3, 2];case "merge":
              return [3, 4];case "enter":
              return [3, 5];case "exit":
              return [3, 6];case "nextIteration":
              return [3, 7];case "tensorArray":
              return [3, 8];case "tensorArrayWrite":
              return [3, 9];case "tensorArrayRead":
              return [3, 10];case "tensorArrayGather":
              return [3, 11];case "tensorArrayScatter":
              return [3, 12];case "tensorArrayConcat":
              return [3, 13];case "tensorArraySplit":
              return [3, 14];case "tensorArraySize":
              return [3, 15];case "tensorArrayClose":
              return [3, 16];}return [3, 17];case 1:
          return [2, [getParamValue("pred", e, t, a).clone()]];case 2:
          return r = getParamValue("pred", e, t, a), n = getParamValue("data", e, t, a), [4, r.data()];case 3:
          return [2, L.sent()[0] ? [void 0, n.clone()] : [n.clone(), void 0]];case 4:
          return [2, (o = e.inputNames.find(function (e) {
            return void 0 !== getTensor(e, t, a);
          })) ? [getTensor(o, t, a).clone()] : void 0];case 5:
          return s = getParamValue("frameName", e, t, a), i = getParamValue("tensor", e, t, a), a.enterFrame(s), [2, [i.clone()]];case 6:
          return p = getParamValue("tensor", e, t, a), a.exitFrame(), [2, [p.clone()]];case 7:
          return m = getParamValue("tensor", e, t, a), a.nextIteration(), [2, [m.clone()]];case 8:
          return u = getParamValue("size", e, t, a), l = getParamValue("dtype", e, t, a), d = getParamValue("elementShape", e, t, a), f = getParamValue("dynamicSize", e, t, a), c = getParamValue("clearAfterRead", e, t, a), y = getParamValue("identicalElementShapes", e, t, a), h = getParamValue("name", e, t, a), N = new TensorArray(h, l, u, d, y, f, c), a.addTensorArray(N), [2, [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(N.id), Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(1)]];case 9:
          return g = getParamValue("tensorArrayId", e, t, a), P = getParamValue("index", e, t, a), x = getParamValue("tensor", e, t, a), a.getTensorArray(g).write(P, x), [2, [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(1)]];case 10:
          return b = getParamValue("tensorArrayId", e, t, a), I = getParamValue("index", e, t, a), [2, [a.getTensorArray(b).read(I)]];case 11:
          return v = getParamValue("tensorArrayId", e, t, a), O = getParamValue("indices", e, t, a), V = getParamValue("dtype", e, t, a), [2, [a.getTensorArray(v).gather(O, V)]];case 12:
          return w = getParamValue("tensorArrayId", e, t, a), T = getParamValue("indices", e, t, a), k = getParamValue("tensor", e, t, a), a.getTensorArray(w).scatter(T, k), [2, [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(1)]];case 13:
          return S = getParamValue("tensorArrayId", e, t, a), _ = a.getTensorArray(S), A = getParamValue("dtype", e, t, a), [2, [_.concat(A)]];case 14:
          return $ = getParamValue("tensorArrayId", e, t, a), D = getParamValue("tensor", e, t, a), E = getParamValue("lengths", e, t, a), a.getTensorArray($).split(E, D), [2, [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(1)]];case 15:
          return j = getParamValue("tensorArrayId", e, t, a), R = a.getTensorArray(j), [2, [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(R.size(), "int32")]];case 16:
          return C = getParamValue("tensorArrayId", e, t, a), a.getTensorArray(C).clearAndClose(), [2, []];case 17:
          throw TypeError("Node type " + e.op + " is not implemented");}
    });
  });
}var executeOp$3 = function executeOp$3(e, t, a) {
  switch (e.op) {case "conv1d":
      var r = getParamValue("stride", e, t, a),
          n = getParamValue("pad", e, t, a),
          o = getParamValue("dataFormat", e, t, a).toUpperCase(),
          s = getParamValue("dilation", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["G" /* conv1d */])(getParamValue("x", e, t, a), getParamValue("filter", e, t, a), r, n, o, s)];case "conv2d":
      r = getParamValue("strides", e, t, a), n = getParamValue("pad", e, t, a), o = getParamValue("dataFormat", e, t, a).toUpperCase();var i = getParamValue("dilations", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["H" /* conv2d */])(getParamValue("x", e, t, a), getParamValue("filter", e, t, a), [r[1], r[2]], n, o, [i[0], i[1]])];case "conv2dTranspose":
      var p = getParamValue("outputShape", e, t, a);r = getParamValue("strides", e, t, a), n = getParamValue("pad", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["I" /* conv2dTranspose */])(getParamValue("x", e, t, a), getParamValue("filter", e, t, a), p, [r[1], r[2]], n)];case "depthwiseConv2d":
      r = getParamValue("strides", e, t, a), n = getParamValue("pad", e, t, a), i = getParamValue("dilations", e, t, a), o = getParamValue("dataFormat", e, t, a).toUpperCase();return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* depthwiseConv2d */])(getParamValue("input", e, t, a), getParamValue("filter", e, t, a), [r[1], r[2]], n, o, [i[0], i[1]])];case "avgPool":
      r = getParamValue("strides", e, t, a), n = getParamValue("pad", e, t, a);var m = getParamValue("kernelSize", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["r" /* avgPool */])(getParamValue("x", e, t, a), [m[1], m[2]], [r[1], r[2]], n)];case "maxPool":
      r = getParamValue("strides", e, t, a), n = getParamValue("pad", e, t, a), m = getParamValue("kernelSize", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_23" /* maxPool */])(getParamValue("x", e, t, a), [m[1], m[2]], [r[1], r[2]], n)];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$4 = function executeOp$4(e, t, a) {
  switch (e.op) {case "fill":
      var r = getParamValue("shape", e, t, a),
          n = getParamValue("dtype", e, t, a),
          o = getParamValue("value", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["X" /* fill */])(r, o, n)];case "linspace":
      var s = getParamValue("start", e, t, a),
          i = getParamValue("stop", e, t, a),
          p = getParamValue("num", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_13" /* linspace */])(s, i, p)];case "oneHot":
      var m = getParamValue("indices", e, t, a),
          u = getParamValue("depth", e, t, a),
          l = getParamValue("onValue", e, t, a),
          d = getParamValue("offValue", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_36" /* oneHot */])(m, u, l, d)];case "ones":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_37" /* ones */])(getParamValue("shape", e, t, a), getParamValue("dtype", e, t, a))];case "onesLike":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_38" /* onesLike */])(getParamValue("x", e, t, a))];case "randomUniform":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_44" /* randomUniform */])(getParamValue("shape", e, t, a), getParamValue("minval", e, t, a), getParamValue("maxval", e, t, a), getParamValue("dtype", e, t, a))];case "range":
      s = getParamValue("start", e, t, a);var f = getParamValue("stop", e, t, a),
          c = getParamValue("step", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_45" /* range */])(s, f, c, getParamValue("dtype", e, t, a))];case "truncatedNormal":
      r = getParamValue("shape", e, t, a);var y = getParamValue("mean", e, t, a),
          h = getParamValue("stdDev", e, t, a),
          N = getParamValue("seed", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_90" /* truncatedNormal */])(r, y, h, getParamValue("dtype", e, t, a), N)];case "zeros":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_97" /* zeros */])(getParamValue("shape", e, t, a), getParamValue("dtype", e, t, a))];case "zerosLike":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_98" /* zerosLike */])(getParamValue("x", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
};function executeOp$5(e, t, a) {
  return __awaiter(this, void 0, void 0, function () {
    var r, n, o, s, i;return __generator(this, function (p) {
      switch (p.label) {case 0:
          switch (e.op) {case "nonMaxSuppression":
              return [3, 1];case "whereAsync":
              return [3, 3];case "setdiff1dAsync":
              return [3, 5];}return [3, 7];case 1:
          return r = getParamValue("boxes", e, t, a), n = getParamValue("scores", e, t, a), o = getParamValue("maxOutputSize", e, t, a), s = getParamValue("iouThreshold", e, t, a), i = getParamValue("scoreThreshold", e, t, a), [4, __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* image */].nonMaxSuppressionAsync(r, n, o, s, i)];case 2:
          return [2, [p.sent()]];case 3:
          return [4, Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_96" /* whereAsync */])(getParamValue("condition", e, t, a))];case 4:
          return [2, [p.sent()]];case 5:
          return [4, Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_57" /* setdiff1dAsync */])(getParamValue("x", e, t, a), getParamValue("y", e, t, a))];case 6:
          return [2, p.sent()];case 7:
          throw TypeError("Node type " + e.op + " is not implemented");}
    });
  });
}var executeOp$6 = function executeOp$6(e, t, a) {
  switch (e.op) {case "topK":
      var r = getParamValue("x", e, t, a),
          n = getParamValue("k", e, t, a),
          o = getParamValue("sorted", e, t, a),
          s = Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_87" /* topk */])(r, n, o);return [s.values, s.indices];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$7 = function executeOp$7(e, t, a) {
  switch (e.op) {case "const":
      return t[e.name];case "placeholder":
      var r = getParamValue("default", e, t, a);return [getTensor(e.name, t, a) || r];case "identity":case "stopGradient":case "fakeQuantWithMinMaxVars":
      return [getParamValue("x", e, t, a).clone()];case "snapshot":
      return [getParamValue("x", e, t, a).clone()];case "shape":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_84" /* tensor1d */])(getParamValue("x", e, t, a).shape, "int32")];case "shapeN":
      return getParamValue("x", e, t, a).map(function (e) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_84" /* tensor1d */])(e.shape);
      });case "size":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(getParamValue("x", e, t, a).size, "int32")];case "rank":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* scalar */])(getParamValue("x", e, t, a).rank, "int32")];case "noop":
      return [];case "print":
      var n = getParamValue("x", e, t, a),
          o = getParamValue("data", e, t, a),
          s = getParamValue("message", e, t, a),
          i = getParamValue("summarize", e, t, a);console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance."), console.log(s);for (var p = 0; p < o.length; p++) {
        console.log(Array.prototype.slice.call(o[0].dataSync()).slice(0, i));
      }return [n];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$8 = function executeOp$8(e, t, a) {
  switch (e.op) {case "resizeBilinear":
      var r = getParamValue("images", e, t, a),
          n = getParamValue("size", e, t, a),
          o = getParamValue("alignCorners", e, t, a);return [__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* image */].resizeBilinear(r, [n[0], n[1]], o)];case "resizeNearestNeighbor":
      r = getParamValue("images", e, t, a), n = getParamValue("size", e, t, a), o = getParamValue("alignCorners", e, t, a);return [__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* image */].resizeNearestNeighbor(r, [n[0], n[1]], o)];case "cropAndResize":
      var s = getParamValue("image", e, t, a),
          i = getParamValue("boxes", e, t, a),
          p = getParamValue("boxInd", e, t, a),
          m = getParamValue("cropSize", e, t, a),
          u = getParamValue("method", e, t, a),
          l = getParamValue("extrapolationValue", e, t, a);return [__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* image */].cropAndResize(s, i, p, m, u, l)];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$9 = function executeOp$9(e, t, a) {
  switch (e.op) {case "equal":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Q" /* equal */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "notEqual":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_35" /* notEqual */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "greater":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_2" /* greater */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "greaterEqual":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* greaterEqual */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "less":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_10" /* less */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "lessEqual":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* lessEqual */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "logicalAnd":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* logicalAnd */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "logicalNot":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_19" /* logicalNot */])(getParamValue("a", e, t, a))];case "logicalOr":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* logicalOr */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a))];case "where":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_95" /* where */])(getParamValue("condition", e, t, a), getParamValue("a", e, t, a), getParamValue("b", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$10 = function executeOp$10(e, t, a) {
  switch (e.op) {case "matMul":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* matMul */])(getParamValue("a", e, t, a), getParamValue("b", e, t, a), getParamValue("transposeA", e, t, a), getParamValue("transposeB", e, t, a))];case "transpose":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_89" /* transpose */])(getParamValue("x", e, t, a), getParamValue("perm", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$11 = function executeOp$11(e, t, a) {
  switch (e.op) {case "batchNormalization":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["s" /* batchNormalization */])(getParamValue("x", e, t, a), getParamValue("mean", e, t, a), getParamValue("variance", e, t, a), getParamValue("epsilon", e, t, a), getParamValue("scale", e, t, a), getParamValue("offset", e, t, a))];case "localResponseNormalization":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_14" /* localResponseNormalization */])(getParamValue("x", e, t, a), getParamValue("radius", e, t, a), getParamValue("bias", e, t, a), getParamValue("alpha", e, t, a), getParamValue("beta", e, t, a))];case "softmax":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_67" /* softmax */])(getParamValue("x", e, t, a))];case "logSoftmax":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_17" /* logSoftmax */])(getParamValue("x", e, t, a))];case "sparseToDense":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_70" /* sparseToDense */])(getParamValue("sparseIndices", e, t, a), getParamValue("outputShape", e, t, a), getParamValue("sparseValues", e, t, a), getParamValue("defaultValue", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$12 = function executeOp$12(e, t, a) {
  switch (e.op) {case "max":
      var r = getParamValue("axis", e, t, a),
          n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_22" /* max */])(getParamValue("x", e, t, a), r, n)];case "mean":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_25" /* mean */])(getParamValue("x", e, t, a), r, n)];case "min":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* min */])(getParamValue("x", e, t, a), r, n)];case "sum":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_80" /* sum */])(getParamValue("x", e, t, a), r, n)];case "all":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["i" /* all */])(getParamValue("x", e, t, a), r, n)];case "any":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["j" /* any */])(getParamValue("x", e, t, a), r, n)];case "argMax":
      r = getParamValue("axis", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["k" /* argMax */])(getParamValue("x", e, t, a), r)];case "argMin":
      r = getParamValue("axis", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["l" /* argMin */])(getParamValue("x", e, t, a), r)];case "prod":
      r = getParamValue("axis", e, t, a), n = getParamValue("keepDims", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* prod */])(getParamValue("x", e, t, a), r, n)];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$13 = function executeOp$13(e, t, a) {
  switch (e.op) {case "concat":
      var r = getParamValue("axis", e, t, a),
          n = getParamValue("tensors", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["B" /* concat */])(n, r)];case "gather":
      r = getParamValue("axis", e, t, a);var o = getParamValue("x", e, t, a),
          s = getParamValue("indices", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_0" /* gather */])(o, s, r)];case "reverse":
      r = getParamValue("axis", e, t, a), o = getParamValue("x", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_49" /* reverse */])(o, r)];case "slice":
      var i = getParamValue("begin", e, t, a),
          p = getParamValue("size", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_62" /* slice */])(getParamValue("x", e, t, a), i, p)];case "stridedSlice":
      i = getParamValue("begin", e, t, a);var m = getParamValue("end", e, t, a),
          u = getParamValue("strides", e, t, a),
          l = getParamValue("beginMask", e, t, a),
          d = getParamValue("endMask", e, t, a),
          f = getParamValue("ellipsisMask", e, t, a),
          c = getParamValue("newAxisMask", e, t, a),
          y = getParamValue("shrinkAxisMask", e, t, a),
          h = getParamValue("x", e, t, a);if (1 === i.length && h.shape.length > 1) for (var N = 1; N < h.shape.length; N++) {
        i.push(0), m.push(h.shape[N]), u.push(u[0]);
      }return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* stridedSlice */])(h, i, m, u, l, d, f, c, y)];case "stack":
      return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
        var r = getParamValue("axis", e, t, a),
            n = getParamValue("tensors", e, t, a),
            o = n[0].shape,
            s = n[0].squeeze().shape,
            i = n.map(function (e) {
          var t = __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].arraysEqual(e.shape, o);if (!t && !__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].arraysEqual(e.squeeze().shape, s)) throw new Error("the input tensors shape does not match");return t ? e : e.reshape(o);
        });return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_76" /* stack */])(i, r)];
      });case "unstack":
      return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
        var r = getParamValue("axis", e, t, a),
            n = getParamValue("tensor", e, t, a);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* unstack */])(n, r);
      });case "tile":
      var g = getParamValue("reps", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* tile */])(getParamValue("x", e, t, a), g)];case "split":
      r = getParamValue("axis", e, t, a);var P = getParamValue("numOrSizeSplits", e, t, a);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_71" /* split */])(getParamValue("x", e, t, a), P, r);case "scatterNd":
      s = getParamValue("indices", e, t, a);var x = getParamValue("values", e, t, a),
          b = getParamValue("shape", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_53" /* scatterND */])(s, x, b)];case "gatherNd":
      var I = getParamValue("x", e, t, a);s = getParamValue("indices", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_1" /* gatherND */])(I, s)];case "sparseToDense":
      s = getParamValue("sparseIndices", e, t, a), b = getParamValue("outputShape", e, t, a);var v = getParamValue("sparseValues", e, t, a),
          O = getParamValue("defaultValue", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_70" /* sparseToDense */])(s, v, b, O)];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$14 = function executeOp$14(e, t, a) {
  switch (e.op) {case "fft":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["W" /* fft */])(getParamValue("x", e, t, a))];case "ifft":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* ifft */])(getParamValue("x", e, t, a))];case "rfft":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* rfft */])(getParamValue("x", e, t, a))];case "irfft":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_7" /* irfft */])(getParamValue("x", e, t, a))];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
},
    executeOp$15 = function executeOp$15(e, t, a) {
  switch (e.op) {case "cast":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["x" /* cast */])(getParamValue("x", e, t, a), getParamValue("dtype", e, t, a))];case "expandDims":
      var r = getParamValue("axis", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["T" /* expandDims */])(getParamValue("x", e, t, a), r)];case "squeeze":
      r = getParamValue("axis", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_75" /* squeeze */])(getParamValue("x", e, t, a), r)];case "reshape":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_48" /* reshape */])(getParamValue("x", e, t, a), getParamValue("shape", e, t, a))];case "pad":
      return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_39" /* pad */])(getParamValue("x", e, t, a), split$1(getParamValue("padding", e, t, a), 2), getParamValue("constantValue", e, t, a))];case "spaceToBatchND":
      var n = getParamValue("blockShape", e, t, a),
          o = split$1(getParamValue("paddings", e, t, a), 2);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_69" /* spaceToBatchND */])(getParamValue("x", e, t, a), n, o)];case "batchToSpaceND":
      n = getParamValue("blockShape", e, t, a);var s = split$1(getParamValue("crops", e, t, a), 2);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["w" /* batchToSpaceND */])(getParamValue("x", e, t, a), n, s)];case "depthToSpace":
      var i = getParamValue("blockSize", e, t, a),
          p = getParamValue("dataFormat", e, t, a);return [Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["L" /* depthToSpace */])(getParamValue("x", e, t, a), i, p)];default:
      throw TypeError("Node type " + e.op + " is not implemented");}
};function executeOp$16(e, t, a) {
  switch (e.category) {case "arithmetic":
      return executeOp(e, t, a);case "basic_math":
      return executeOp$1(e, t, a);case "control":
      return executeOp$2(e, t, a);case "convolution":
      return executeOp$3(e, t, a);case "creation":
      return executeOp$4(e, t, a);case "dynamic":
      return executeOp$5(e, t, a);case "evaluation":
      return executeOp$6(e, t, a);case "image":
      return executeOp$8(e, t, a);case "graph":
      return executeOp$7(e, t, a);case "logical":
      return executeOp$9(e, t, a);case "matrices":
      return executeOp$10(e, t, a);case "normalization":
      return executeOp$11(e, t, a);case "reduction":
      return executeOp$12(e, t, a);case "slice_join":
      return executeOp$13(e, t, a);case "spectral":
      return executeOp$14(e, t, a);case "transformation":
      return executeOp$15(e, t, a);default:
      throw TypeError("Node type " + e.op + " is not implemented");}
}var ExecutionContext = function () {
  function e(e, t) {
    this.weightMap = e, this.tensorArrayMap = t, this.rootContext = { id: 0, frameName: "", iterationId: 0 }, this.contexts = [this.rootContext], this.lastId = 0, this.generateCurrentContextIds();
  }return e.prototype.newFrame = function (e, t) {
    return { id: e, frameName: t, iterationId: 0 };
  }, Object.defineProperty(e.prototype, "currentContext", { get: function get() {
      return this.contexts;
    }, set: function set(e) {
      this.contexts !== e && (this.contexts = e, this.generateCurrentContextIds());
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "currentContextId", { get: function get() {
      return this._currentContextIds[0];
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "currentContextIds", { get: function get() {
      return this._currentContextIds;
    }, enumerable: !0, configurable: !0 }), e.prototype.generateCurrentContextIds = function () {
    for (var e = [], t = 0; t < this.contexts.length - 1; t++) {
      var a = this.contexts.slice(0, this.contexts.length - t);e.push(this.contextIdforContexts(a));
    }e.push(""), this._currentContextIds = e;
  }, e.prototype.contextIdforContexts = function (e) {
    return e ? e.map(function (e) {
      return 0 === e.id && 0 === e.iterationId ? "" : e.frameName + "-" + e.iterationId;
    }).join("/") : "";
  }, e.prototype.enterFrame = function (e) {
    this.contexts && (this.lastId++, this.contexts = this.contexts.slice(), this.contexts.push(this.newFrame(this.lastId, e)), this._currentContextIds.unshift(this.contextIdforContexts(this.contexts)));
  }, e.prototype.exitFrame = function () {
    if (!(this.contexts && this.contexts.length > 1)) throw new Error("Cannot exit frame, the context is empty");this.contexts = this.contexts.slice(), this.contexts.splice(-1), this.currentContextIds.shift();
  }, e.prototype.nextIteration = function () {
    if (!(this.contexts && this.contexts.length > 0)) throw new Error("Cannot increase frame iteration, the context is empty");this.contexts = this.contexts.slice(), this.lastId++;var e = _extends({}, this.contexts[this.contexts.length - 1]);e.iterationId += 1, e.id = this.lastId, this.contexts.splice(-1, 1, e), this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
  }, e.prototype.getWeight = function (e) {
    return this.weightMap[e];
  }, e.prototype.addTensorArray = function (e) {
    this.tensorArrayMap[e.id] = e;
  }, e.prototype.getTensorArray = function (e) {
    return this.tensorArrayMap[e];
  }, e;
}(),
    GraphExecutor = function () {
  function e(e) {
    this.graph = e, this.compiledMap = new Map(), this._weightMap = {}, this.SEPERATOR = ",", this.placeholders = e.placeholders, this._outputs = e.outputs, this.compile();
  }return Object.defineProperty(e.prototype, "weightMap", { get: function get() {
      return this._weightMap;
    }, set: function set(e) {
      var t = Object.keys(e).map(function (t) {
        return e[t].map(function (e) {
          return e.id;
        });
      });this.weightIds = [].concat.apply([], t), this._weightMap = e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "inputs", { get: function get() {
      return this.placeholders.map(function (e) {
        return { name: e.name, shape: e.params.shape ? e.params.shape.value : void 0, dtype: e.params.dtype ? e.params.dtype.value : void 0 };
      });
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "outputs", { get: function get() {
      return this._outputs.map(function (e) {
        return { name: e.name, shape: e.params.shape ? e.params.shape.value : void 0, dtype: e.params.dtype ? e.params.dtype.value : void 0 };
      });
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "inputNodes", { get: function get() {
      return this.placeholders.map(function (e) {
        return e.name;
      });
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "outputNodes", { get: function get() {
      return this.outputs.map(function (e) {
        return e.name;
      });
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "isControlFlowModel", { get: function get() {
      return this.graph.withControlFlow;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "isDynamicShapeModel", { get: function get() {
      return this.graph.withDynamicShape;
    }, enumerable: !0, configurable: !0 }), e.prototype.compile = function (e) {
    if (!this.graph.withControlFlow && !this.graph.withDynamicShape) {
      var t = [],
          a = e || this.graph.placeholders,
          r = a.map(function (e) {
        return e.name;
      }).sort().join(this.SEPERATOR);if (!this.compiledMap.get(r)) {
        for (var n = a.concat(this.graph.weights), o = {}; n.length > 0;) {
          var s = n.pop();o[s.name] = !0, t.push(s), s.children.forEach(function (e) {
            !o[e.name] && e.inputNames.every(function (e) {
              var t = getNodeNameAndIndex(e)[0];return o[t];
            }) && n.push(e);
          });
        }this.compiledMap.set(r, t);
      }
    }
  }, e.prototype.execute = function (e, t, a) {
    var r = this;void 0 === t && (t = !0);var n = Object.keys(e).sort();this.checkInput(e, t), this.checkInputShapeAndType(e, t), this.compile(n.map(function (e) {
      return r.graph.nodes[e];
    }));var o = this.calculateOutputs(a);this.checkOutput(this.compiledMap.get(n.join(this.SEPERATOR)), o);var s = {};return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
      for (var t = new ExecutionContext(r._weightMap, s), a = __assign({}, r.weightMap, e), i = r.getFrozenTensorIds(a), p = {}, m = r.compiledMap.get(n.join(r.SEPERATOR)), u = 0; u < m.length; u++) {
        var l = m[u];if (a[l.name] || (a[l.name] = executeOp$16(l, a, t), r.checkTensorForDisposal(l.name, l, a, t, i, o, p)), o.every(function (e) {
          return !!a[e];
        })) break;
      }return r.findOutputs(a, t, o);
    });
  }, e.prototype.getFrozenTensorIds = function (e) {
    var t = [].concat.apply([], Object.keys(e).map(function (t) {
      return e[t];
    }).map(function (e) {
      return e.map(function (e) {
        return e.id;
      });
    }));return new Set(t);
  }, e.prototype.checkTensorForDisposal = function (e, t, a, r, n, o, s) {
    "control" !== t.category && -1 === o.indexOf(e) && (a[e].forEach(function (e) {
      null != e && (s[e.id] = (s[e.id] || 0) + t.children.length);
    }), t.inputs.forEach(function (e) {
      if ("control" !== e.category) {
        var t = getTensorsForCurrentContenxt(e.name, a, r);null != t && t.forEach(function (e) {
          if (e && !n.has(e.id)) {
            var t = s[e.id];1 === t ? (e.dispose(), delete s[e.id]) : null != t && s[e.id]--;
          }
        });
      }
    }));
  }, e.prototype.executeAsync = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var a,
          r,
          n,
          o,
          s,
          i,
          p,
          m,
          u = this;return __generator(this, function (l) {
        switch (l.label) {case 0:
            return this.checkInput(e, !1), this.checkInputShapeAndType(e, !1), a = {}, r = new ExecutionContext(this._weightMap, a), n = this.calculateOutputs(t), [4, this.executeWithControlFlow(e, r, n)];case 1:
            return o = l.sent(), s = this.findOutputs(o, r, t), i = Object.keys(s).map(function (e) {
              return s[e].id;
            }), p = Object.keys(e).map(function (t) {
              return e[t].map(function (e) {
                return e.id;
              });
            }), m = [].concat.apply([], p), Object.keys(o).forEach(function (e) {
              o[e].forEach(function (e) {
                e && -1 === i.indexOf(e.id) && -1 === m.indexOf(e.id) && -1 === u.weightIds.indexOf(e.id) && e.dispose();
              });
            }), [2, s];}
      });
    });
  }, e.prototype.executeWithControlFlow = function (e, t, a) {
    return __awaiter(this, void 0, void 0, function () {
      var r,
          n,
          o,
          s,
          i,
          p,
          m,
          u,
          l = this;return __generator(this, function (d) {
        switch (d.label) {case 0:
            r = Object.keys(e), n = r.map(function (e) {
              return l.graph.nodes[e];
            }), o = n.concat(this.graph.weights).map(function (e) {
              return { node: e, contexts: t.currentContext };
            }), s = __assign({}, this.weightMap, e), i = {}, p = this.getFrozenTensorIds(s), m = {}, d.label = 1;case 1:
            return o.length > 0 ? (u = this.processStack(n, o, t, s, m, p, a, i), [4, Promise.all(u)]) : [3, 3];case 2:
            return d.sent(), [3, 1];case 3:
            return [2, s];}
      });
    });
  }, e.prototype.processStack = function (e, t, a, r, n, o, s, i) {
    for (var p = this, m = [], u = function u() {
      var u = t.pop();a.currentContext = u.contexts;var d = "";if ("enter" === u.node.op && getParamValue("isConstant", u.node, r, a) && (d = getNodeNameAndIndex(u.node.name, a)[0]), -1 === e.indexOf(u.node)) {
        var f = executeOp$16(u.node, r, a);d || (d = getNodeNameAndIndex(u.node.name, a)[0]);var c = a.currentContext;f instanceof Promise ? m.push(f.then(function (e) {
          return r[d] = e, a.currentContext = c, p.checkTensorForDisposal(d, u.node, r, a, o, s, i), p.processChildNodes(u.node, t, a, r, n), e;
        })) : (r[d] = f, l.checkTensorForDisposal(d, u.node, r, a, o, s, i), l.processChildNodes(u.node, t, a, r, n));
      } else l.processChildNodes(u.node, t, a, r, n);
    }, l = this; t.length > 0;) {
      u();
    }return m;
  }, e.prototype.processChildNodes = function (e, t, a, r, n) {
    e.children.forEach(function (e) {
      var o = getNodeNameAndIndex(e.name, a)[0];n[o] || ("merge" === e.op ? e.inputNames.some(function (e) {
        return !!getTensor(e, r, a);
      }) && (n[o] = !0, t.push({ contexts: a.currentContext, node: e })) : e.inputNames.every(function (e) {
        return !!getTensor(e, r, a);
      }) && (n[o] = !0, t.push({ contexts: a.currentContext, node: e })));
    });
  }, e.prototype.calculateOutputs = function (e) {
    return !e || e instanceof Array || (e = [e]), e || this.graph.outputs.map(function (e) {
      return e.name;
    });
  }, e.prototype.findOutputs = function (e, t, a) {
    return this.calculateOutputs(a).reduce(function (a, r) {
      return a[r] = getTensor(r, e, t), a;
    }, {});
  }, e.prototype.dispose = function () {
    var e = this;Object.keys(this.weightMap).forEach(function (t) {
      return e.weightMap[t].forEach(function (e) {
        return e.dispose();
      });
    });
  }, e.prototype.checkInputShapeAndType = function (e, t) {
    void 0 === t && (t = !0), this.placeholders.forEach(function (a) {
      var r = e[a.name];if (t || r) {
        var n = r[0];if (a.params.shape && a.params.shape.value) {
          var o = a.params.shape.value,
              s = o.length === n.shape.length && n.shape.every(function (e, t) {
            return -1 === o[t] || o[t] === e;
          });__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(s, "The shape of dict['" + a.name + "'] provided in model.execute(dict) must be [" + o + "], but was [" + n.shape + "]");
        }a.params.dtype && a.params.dtype.value && __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(n.dtype === a.params.dtype.value, "The dtype of dict['" + a.name + "'] provided in model.execute(dict) must be " + a.params.dtype.value + ", but was " + n.dtype);
      }
    });
  }, e.prototype.checkInput = function (e, t) {
    var a = this;void 0 === t && (t = !0);var r = Object.keys(e),
        n = [],
        o = [];this.inputNodes.forEach(function (e) {
      -1 === r.indexOf(e) && n.push(e);
    }), r.forEach(function (e) {
      -1 === a.inputNodes.indexOf(e) && o.push(e);
    });var s = o.filter(function (e) {
      return !a.graph.nodes[e];
    });if (n.length > 0 && t) throw new Error("The dict provided in model.execute(dict) has the keys [" + r + "], but is missing the required keys: [" + n + "].");if (o.length > 0 && t) throw new Error("The dict provided in model.execute(dict) has unused keys: [" + o + "]. Please provide only the following keys: [" + this.inputNodes + "].");if (s.length > 0) throw new Error("The dict provided in model.execute(dict) has keys: [" + s + "] not part of model graph.");
  }, e.prototype.checkOutput = function (e, t) {
    var a = e.map(function (e) {
      return e.name;
    }),
        r = [];if (t.forEach(function (e) {
      -1 === a.indexOf(e) && r.push(e);
    }), r.length > 0) throw new Error("The following outputs are not generated by the execution: [" + r + "].");
  }, e;
}(),
    TFHUB_SEARCH_PARAM = "?tfjs-format=file",
    DEFAULT_MODEL_NAME = "tensorflowjs_model.pb",
    DEFAULT_MANIFEST_NAME = "weights_manifest.json",
    FrozenModel = function () {
  function e(e, t, a, r) {
    this.modelUrl = e, this.weightManifestUrl = t, this.requestOption = a, this.weightPrefix = r, this.version = "n/a";
  }return Object.defineProperty(e.prototype, "modelVersion", { get: function get() {
      return this.version;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "inputNodes", { get: function get() {
      return this.executor.inputNodes;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "outputNodes", { get: function get() {
      return this.executor.outputNodes;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "inputs", { get: function get() {
      return this.executor.inputs;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "outputs", { get: function get() {
      return this.executor.outputs;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(e.prototype, "weights", { get: function get() {
      return this.executor.weightMap;
    }, enumerable: !0, configurable: !0 }), e.prototype.findIOHandler = function () {
    var e = [this.modelUrl, this.weightManifestUrl];if (this.requestOption) this.handler = __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_6" /* io */].browserHTTPRequest(e, this.requestOption, this.weightPrefix);else {
      var t = __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_6" /* io */].getLoadHandlers(e);if (0 === t.length) t.push(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_6" /* io */].browserHTTPRequest(e, this.requestOption));else if (t.length > 1) throw new Error("Found more than one (" + t.length + ") load handlers for URL '" + [e] + "'");this.handler = t[0];
    }
  }, e.prototype.load = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, a;return __generator(this, function (r) {
        switch (r.label) {case 0:
            if (this.findIOHandler(), null == this.handler.load) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");return [4, this.handler.load()];case 1:
            return e = r.sent(), t = compiled_api_1.GraphDef.decode(new Uint8Array(e.modelTopology)), this.version = t.versions.producer + "." + t.versions.minConsumer, a = __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_6" /* io */].decodeWeights(e.weightData, e.weightSpecs), this.executor = new GraphExecutor(OperationMapper.Instance.transformGraph(t)), this.executor.weightMap = this.convertTensorMapToTensorsMap(a), [2, !0];}
      });
    });
  }, e.prototype.predict = function (e, t) {
    return this.execute_(e, !0, this.outputNodes);
  }, e.prototype.constructTensorMap = function (e) {
    var t = e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */] ? [e] : e;if (t.length !== this.inputNodes.length) throw new Error("Input tensor count mismatch,the frozen model has " + this.inputNodes.length + " placeholders, while there are " + t.length + " input tensors.");return this.inputNodes.reduce(function (e, a, r) {
      return e[a] = t[r], e;
    }, {});
  }, e.prototype.execute = function (e, t) {
    return this.execute_(e, !1, t);
  }, e.prototype.execute_ = function (e, t, a) {
    if (void 0 === t && (t = !0), a = a || this.outputNodes, (e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */] || Array.isArray(e)) && (e = this.constructTensorMap(e)), this.executor.isControlFlowModel || this.executor.isDynamicShapeModel) throw new Error("The model contains control flow or dynamic shape ops, please use executeAsync method");var r = this.executor.execute(this.convertTensorMapToTensorsMap(e), t, a),
        n = Object.keys(r);return Array.isArray(a) && a.length > 1 ? a.map(function (e) {
      return r[e];
    }) : r[n[0]];
  }, e.prototype.executeAsync = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var a, r;return __generator(this, function (n) {
        switch (n.label) {case 0:
            if (!this.executor.isControlFlowModel && !this.executor.isDynamicShapeModel) throw new Error("The model does not contain control flow or dynamic shape ops, please use execute method for better performance.");return t = t || this.outputNodes, (e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */] || Array.isArray(e)) && (e = this.constructTensorMap(e)), [4, this.executor.executeAsync(this.convertTensorMapToTensorsMap(e), t)];case 1:
            return a = n.sent(), r = Object.keys(a), [2, Array.isArray(t) && t.length > 1 ? t.map(function (e) {
              return a[e];
            }) : a[r[0]]];}
      });
    });
  }, e.prototype.convertTensorMapToTensorsMap = function (e) {
    return Object.keys(e).reduce(function (t, a) {
      return t[a] = [e[a]], t;
    }, {});
  }, e.prototype.dispose = function () {
    this.executor.dispose();
  }, e;
}();function loadFrozenModel(e, t, a) {
  return __awaiter(this, void 0, void 0, function () {
    var r;return __generator(this, function (n) {
      switch (n.label) {case 0:
          return [4, (r = new FrozenModel(e, t, a)).load()];case 1:
          return n.sent(), [2, r];}
    });
  });
}function loadTfHubModule(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (a) {
      return e.endsWith("/") || (e += "/"), [2, loadFrozenModel("" + e + DEFAULT_MODEL_NAME + TFHUB_SEARCH_PARAM, "" + e + DEFAULT_MANIFEST_NAME + TFHUB_SEARCH_PARAM, t)];
    });
  });
}var version = "0.7.2";
//# sourceMappingURL=tf-converter.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "HzeT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("3PYz");
var utils = __webpack_require__("tpuU");
var assert = __webpack_require__("08Lv");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000; // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac().update(this.V).update([0x00]);
  if (seed) kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed) return;

  this.K = this._hmac().update(this.V).update([0x01]).update(seed).digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

/***/ }),

/***/ "IRek":
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__("z+8S");
var des = __webpack_require__("BO8W");
var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("X3l8").Buffer;

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
};
modes.des = modes['des-cbc'];
modes.des3 = modes['des-ede3-cbc'];
module.exports = DES;
inherits(DES, CipherBase);
function DES(opts) {
  CipherBase.call(this);
  var modeName = opts.mode.toLowerCase();
  var mode = modes[modeName];
  var type;
  if (opts.decrypt) {
    type = 'decrypt';
  } else {
    type = 'encrypt';
  }
  var key = opts.key;
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key);
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)]);
  }
  var iv = opts.iv;
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv);
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  });
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data));
};
DES.prototype._final = function () {
  return Buffer.from(this._des.final());
};

/***/ }),

/***/ "Icsf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var des = __webpack_require__("BO8W");
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);else this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++) {
    buffer[i] = value;
  }return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++) {
    assert.equal(buffer[i], pad);
  }return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

/***/ }),

/***/ "JaR3":
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA(algorithm) {
  algorithm = algorithm.toLowerCase();

  var Algorithm = exports[algorithm];
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');

  return new Algorithm();
};

exports.sha = __webpack_require__("N1es");
exports.sha1 = __webpack_require__("KQ4j");
exports.sha224 = __webpack_require__("lXn8");
exports.sha256 = __webpack_require__("zvjZ");
exports.sha384 = __webpack_require__("aY2F");
exports.sha512 = __webpack_require__("C015");

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("EBst");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js
var tf_core_esm = __webpack_require__("2qEw");

// CONCATENATED MODULE: ./node_modules/@tensorflow/tfjs-layers/dist/tf-layers.esm.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var _extendStatics = function extendStatics(e, t) {
  return (_extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (e[n] = t[n]);
    }
  })(e, t);
};function __extends(e, t) {
  function n() {
    this.constructor = e;
  }_extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}var _epsilon,
    _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var i in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }return e;
  }).apply(this, arguments);
};function __awaiter(e, t, n, r) {
  return new (n || (n = Promise))(function (i, a) {
    function o(e) {
      try {
        l(r.next(e));
      } catch (e) {
        a(e);
      }
    }function s(e) {
      try {
        l(r.throw(e));
      } catch (e) {
        a(e);
      }
    }function l(e) {
      e.done ? i(e.value) : new n(function (t) {
        t(e.value);
      }).then(o, s);
    }l((r = r.apply(e, t || [])).next());
  });
}function __generator(e, t) {
  var n,
      r,
      i,
      a,
      o = { label: 0, sent: function sent() {
      if (1 & i[0]) throw i[1];return i[1];
    }, trys: [], ops: [] };return a = { next: s(0), throw: s(1), return: s(2) }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;function s(a) {
    return function (s) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");for (; o;) {
          try {
            if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {case 0:case 1:
                i = a;break;case 4:
                return o.label++, { value: a[1], done: !1 };case 5:
                o.label++, r = a[1], a = [0];continue;case 7:
                a = o.ops.pop(), o.trys.pop();continue;default:
                if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === a[0] || 2 === a[0])) {
                  o = 0;continue;
                }if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                  o.label = a[1];break;
                }if (6 === a[0] && o.label < i[1]) {
                  o.label = i[1], i = a;break;
                }if (i && o.label < i[2]) {
                  o.label = i[2], o.ops.push(a);break;
                }i[2] && o.ops.pop(), o.trys.pop();continue;}a = t.call(e, o);
          } catch (e) {
            a = [6, e], r = 0;
          } finally {
            n = i = 0;
          }
        }if (5 & a[0]) throw a[1];return { value: a[0] ? a[1] : void 0, done: !0 };
      }([a, s]);
    };
  }
}function epsilon() {
  return null == _epsilon && (_epsilon = tf_core_esm["a" /* ENV */].get("EPSILON")), _epsilon;
}function imageDataFormat() {
  return "channelsLast";
}var _nextUniqueTensorId = 0;function getNextUniqueTensorId() {
  return _nextUniqueTensorId++;
}var _uidPrefixes = {};function getUid(e) {
  return void 0 === e && (e = ""), e in _uidPrefixes || (_uidPrefixes[e] = 0), _uidPrefixes[e] += 1, e + _uidPrefixes[e].toString();
}var scalarCache = { float32: {}, int32: {} },
    DEFAULT_DTYPE = "float32";function getScalar(e, t) {
  return void 0 === t && (t = DEFAULT_DTYPE), null == scalarCache[t][e] && (scalarCache[t][e] = Object(tf_core_esm["_52" /* scalar */])(e, t), Object(tf_core_esm["_8" /* keep */])(scalarCache[t][e])), scalarCache[t][e];
}var AttributeError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error),
    RuntimeError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error),
    ValueError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error),
    NotImplementedError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error),
    AssertionError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error),
    IndexError = function (e) {
  function t(n) {
    var r = e.call(this, n) || this;return Object.setPrototypeOf(r, t.prototype), r;
  }return __extends(t, e), t;
}(Error);function pyListRepeat(e, t) {
  if (Array.isArray(e)) {
    for (var n = [], r = 0; r < t; r++) {
      n = n.concat(e);
    }return n;
  }return (n = new Array(t)).fill(e), n;
}function assert(e, t) {
  if (!e) throw new AssertionError(t);
}function count(e, t) {
  for (var n = 0, r = 0, i = e; r < i.length; r++) {
    i[r] === t && n++;
  }return n;
}function singletonOrArray(e) {
  return 1 === e.length ? e[0] : e;
}function toList(e) {
  return Array.isArray(e) ? e : [e];
}function toSnakeCase(e) {
  var t = e.replace(/(.)([A-Z][a-z0-9]+)/g, "$1_$2").replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();return "_" !== t[0] ? t : "private" + t;
}function toCamelCase(e) {
  return e.length <= 1 ? e : -1 === e.indexOf("_") ? e : e.replace(/[_]+(\w|$)/g, function (e, t) {
    return t.toUpperCase();
  });
}var _GLOBAL_CUSTOM_OBJECTS = {};function serializeKerasObject(e) {
  return null === e || void 0 === e ? null : { className: e.getClassName(), config: e.getConfig() };
}function deserializeKerasObject(e, t, n, r, i) {
  if (void 0 === t && (t = {}), void 0 === n && (n = {}), void 0 === r && (r = "object"), void 0 === i && (i = !1), "string" == typeof e) {
    var a = e,
        o = void 0;if (a in n) o = n[a];else if (a in _GLOBAL_CUSTOM_OBJECTS) o = _GLOBAL_CUSTOM_OBJECTS[a];else if (null == (o = t[a])) throw new ValueError("Unknown " + r + ": " + e + ". This may be due to one of the following reasons:\n1. The " + r + " is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom " + r + " is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().");return o;
  }var s = e;if (null == s.className || null == s.config) throw new ValueError(r + ": Improper config format: " + JSON.stringify(s) + ".\n'className' and 'config' must set.");var l = s.className,
      u = void 0,
      c = void 0;if (l in n ? (u = (I = n.get(l))[0], c = I[1]) : l in _GLOBAL_CUSTOM_OBJECTS ? (u = (A = _GLOBAL_CUSTOM_OBJECTS.className)[0], c = A[1]) : l in t && (u = (_ = t[l])[0], c = _[1]), null == u) throw new ValueError("Unknown " + r + ": " + l + ". This may be due to one of the following reasons:\n1. The " + r + " is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom " + r + " is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().");if (null != c) {
    for (var h = {}, p = 0, d = Object.keys(_GLOBAL_CUSTOM_OBJECTS); p < d.length; p++) {
      h[b = d[p]] = _GLOBAL_CUSTOM_OBJECTS[b];
    }for (var g = 0, f = Object.keys(n); g < f.length; g++) {
      h[b = f[g]] = n[b];
    }s.config.customObjects = h;for (var m = _assign({}, _GLOBAL_CUSTOM_OBJECTS), y = 0, v = Object.keys(n); y < v.length; y++) {
      var b = v[y];_GLOBAL_CUSTOM_OBJECTS[b] = n[b];
    }var w = c(u, s.config, n, i);return _GLOBAL_CUSTOM_OBJECTS = _assign({}, m), w;
  }m = _assign({}, _GLOBAL_CUSTOM_OBJECTS);for (var z = 0, S = Object.keys(n); z < S.length; z++) {
    b = S[z];_GLOBAL_CUSTOM_OBJECTS[b] = n[b];
  }var I, A, _;w = new u(s.config);return _GLOBAL_CUSTOM_OBJECTS = _assign({}, m), w;
}function numberCompare(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}function reverseNumberCompare(e, t) {
  return -1 * numberCompare(e, t);
}function stringToDType(e) {
  switch (e) {case "float32":
      return "float32";default:
      throw new ValueError("Invalid dtype: " + e);}
}function unique(e) {
  if (null == e) return e;for (var t = [], n = 0, r = e; n < r.length; n++) {
    var i = r[n];-1 === t.indexOf(i) && t.push(i);
  }return t;
}function isObjectEmpty(e) {
  if (null == e) throw new ValueError("Invalid value in obj: " + JSON.stringify(e));for (var t in e) {
    if (e.hasOwnProperty(t)) return !1;
  }return !0;
}function checkStringTypeUnionValue(e, t, n) {
  if (null != n && e.indexOf(n) < 0) throw new ValueError(n + " is not a valid " + t + ".  Valid values are " + e + " or null/undefined.");
}function checkArrayTypeAndLength(e, t, n, r) {
  return void 0 === n && (n = 0), void 0 === r && (r = 1 / 0), assert(n >= 0), assert(r >= n), Array.isArray(e) && e.length >= n && e.length <= r && e.every(function (e) {
    return typeof e === t;
  });
}function calcL2Norms(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return Object(tf_core_esm["_72" /* sqrt */])(Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_32" /* mulStrict */])(e, e), t, !0));
  });
}var Constraint = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.getConfig = function () {
    return {};
  }, t;
}(tf_core_esm["_56" /* serialization */].Serializable),
    MaxNorm = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.defaultMaxValue = 2, n.defaultAxis = 0, n.maxValue = null != t.maxValue ? t.maxValue : n.defaultMaxValue, n.axis = null != t.axis ? t.axis : n.defaultAxis, n;
  }return __extends(t, e), t.prototype.apply = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var n = calcL2Norms(e, t.axis),
          r = Object(tf_core_esm["z" /* clipByValue */])(n, 0, t.maxValue);return Object(tf_core_esm["_31" /* mul */])(e, Object(tf_core_esm["O" /* div */])(r, Object(tf_core_esm["g" /* add */])(getScalar(epsilon()), n)));
    });
  }, t.prototype.getConfig = function () {
    return { maxValue: this.maxValue, axis: this.axis };
  }, t.className = "MaxNorm", t;
}(Constraint);tf_core_esm["_56" /* serialization */].registerClass(MaxNorm);var UnitNorm = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.defaultAxis = 0, n.axis = null != t.axis ? t.axis : n.defaultAxis, n;
  }return __extends(t, e), t.prototype.apply = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return Object(tf_core_esm["O" /* div */])(e, Object(tf_core_esm["g" /* add */])(getScalar(epsilon()), calcL2Norms(e, t.axis)));
    });
  }, t.prototype.getConfig = function () {
    return { axis: this.axis };
  }, t.className = "UnitNorm", t;
}(Constraint);tf_core_esm["_56" /* serialization */].registerClass(UnitNorm);var NonNeg = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_47" /* relu */])(e);
  }, t.className = "NonNeg", t;
}(Constraint);tf_core_esm["_56" /* serialization */].registerClass(NonNeg);var MinMaxNorm = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.defaultMinValue = 0, n.defaultMaxValue = 1, n.defaultRate = 1, n.defaultAxis = 0, n.minValue = null != t.minValue ? t.minValue : n.defaultMinValue, n.maxValue = null != t.maxValue ? t.maxValue : n.defaultMaxValue, n.rate = null != t.rate ? t.rate : n.defaultRate, n.axis = null != t.axis ? t.axis : n.defaultAxis, n;
  }return __extends(t, e), t.prototype.apply = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var n = calcL2Norms(e, t.axis),
          r = Object(tf_core_esm["g" /* add */])(Object(tf_core_esm["_31" /* mul */])(getScalar(t.rate), Object(tf_core_esm["z" /* clipByValue */])(n, t.minValue, t.maxValue)), Object(tf_core_esm["_31" /* mul */])(getScalar(1 - t.rate), n));return Object(tf_core_esm["_31" /* mul */])(e, Object(tf_core_esm["O" /* div */])(r, Object(tf_core_esm["g" /* add */])(getScalar(epsilon()), n)));
    });
  }, t.prototype.getConfig = function () {
    return { minValue: this.minValue, maxValue: this.maxValue, rate: this.rate, axis: this.axis };
  }, t.className = "MinMaxNorm", t;
}(Constraint);tf_core_esm["_56" /* serialization */].registerClass(MinMaxNorm);var CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP = { maxNorm: "MaxNorm", minMaxNorm: "MinMaxNorm", nonNeg: "NonNeg", unitNorm: "UnitNorm" };function serializeConstraint(e) {
  return serializeKerasObject(e);
}function deserializeConstraint(e, t) {
  return void 0 === t && (t = {}), deserializeKerasObject(e, tf_core_esm["_56" /* serialization */].SerializationMap.getMap().classNameMap, t, "constraint");
}function getConstraint(e) {
  return null == e ? null : "string" == typeof e ? deserializeConstraint({ className: e in CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP ? CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP[e] : e, config: {} }) : e instanceof Constraint ? e : deserializeConstraint(e);
}function maxNorm(e) {
  return new MaxNorm(e);
}function unitNorm(e) {
  return new UnitNorm(e);
}function nonNeg() {
  return new NonNeg();
}function minMaxNorm(e) {
  return new MinMaxNorm(e);
}var exports_constraints = Object.freeze({ maxNorm: maxNorm, unitNorm: unitNorm, nonNeg: nonNeg, minMaxNorm: minMaxNorm }),
    nameMap = new Map(),
    VALID_DATA_FORMAT_VALUES = ["channelsFirst", "channelsLast"];function checkDataFormat(e) {
  checkStringTypeUnionValue(VALID_DATA_FORMAT_VALUES, "DataFormat", e);
}var VALID_PADDING_MODE_VALUES = ["valid", "same", "causal"];function checkPaddingMode(e) {
  checkStringTypeUnionValue(VALID_PADDING_MODE_VALUES, "PaddingMode", e);
}var VALID_POOL_MODE_VALUES = ["max", "avg"];function checkPoolMode(e) {
  checkStringTypeUnionValue(VALID_POOL_MODE_VALUES, "PoolMode", e);
}var _nameScopeStack = [],
    _nameScopeDivider = "/";function nameScope(e, t) {
  _nameScopeStack.push(e);try {
    var n = t();return _nameScopeStack.pop(), n;
  } catch (e) {
    throw _nameScopeStack.pop(), e;
  }
}function currentNameScopePrefix() {
  return 0 === _nameScopeStack.length ? "" : _nameScopeStack.join(_nameScopeDivider) + _nameScopeDivider;
}function getScopedTensorName(e) {
  if (!isValidTensorName(e)) throw new Error("Not a valid tensor name: '" + e + "'");return currentNameScopePrefix() + e;
}function getUniqueTensorName(e) {
  if (!isValidTensorName(e)) throw new Error("Not a valid tensor name: '" + e + "'");nameMap.has(e) || nameMap.set(e, 0);var t = nameMap.get(e);if (nameMap.set(e, nameMap.get(e) + 1), t > 0) {
    var n = e + "_" + t;return nameMap.set(n, 1), n;
  }return e;
}var tensorNameRegex = new RegExp(/^[A-Za-z][-A-Za-z0-9\._\/]*$/);function isValidTensorName(e) {
  return !!e.match(tensorNameRegex);
}function isInteger(e) {
  return e === parseInt(e.toString(), 10);
}function arrayProd(e, t, n) {
  null == t && (t = 0), null == n && (n = e.length);for (var r = 1, i = t; i < n; ++i) {
    r *= e[i];
  }return r;
}function toArray1D(e) {
  return e = Array.isArray(e) ? new Float32Array(e) : e, Object(tf_core_esm["_84" /* tensor1d */])(e);
}function min$1(e) {
  return Object(tf_core_esm["_27" /* min */])(toArray1D(e)).dataSync()[0];
}function max$1(e) {
  return Object(tf_core_esm["_22" /* max */])(toArray1D(e)).dataSync()[0];
}function range(e, t) {
  if (t < e) throw new ValueError("end (" + t + ") < begin (" + e + ") is forbidden.");for (var n = [], r = e; r < t; ++r) {
    n.push(r);
  }return n;
}function cast$1(e, t) {
  return e.asType(t);
}function expandDims$1(e, t) {
  void 0 === t && (t = -1);var n = e.shape.slice();return t < 0 && (t = n.length + t + 1), n.splice(t, 0, 1), e.reshape(n);
}function repeat(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    if (2 !== e.shape.length) throw new ValueError("repeat() expects a rank-2 tensor, but received a rank-" + e.shape.length + " tensor.");return tile$1(expandDims$1(e, 1), [1, t, 1]);
  });
}function flatten(e) {
  var t = [arrayProd(e.shape)];return e.reshape(t);
}function batchFlatten(e) {
  if (e.rank <= 1) throw new ValueError("batchFlatten requires a minimum rank of 2. Got rank: " + e.rank + ".");var t = [e.shape[0], arrayProd(e.shape, 1)];return e.reshape(t);
}function sliceAlongFirstAxis(e, t, n) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    switch (e.rank) {case 1:
        return Object(tf_core_esm["_63" /* slice1d */])(e, t, n);case 2:
        return Object(tf_core_esm["_64" /* slice2d */])(e, [t, 0], [n, e.shape[1]]);case 3:
        return Object(tf_core_esm["_65" /* slice3d */])(e, [t, 0, 0], [n, e.shape[1], e.shape[2]]);case 4:
        return Object(tf_core_esm["_66" /* slice4d */])(e, [t, 0, 0, 0], [n, e.shape[1], e.shape[2], e.shape[3]]);default:
        throw new ValueError("sliceAlongFirstAxis() received an unsupported tensor rank: " + e.rank);}
  });
}function sliceAlongLastAxis(e, t, n) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    switch (e.rank) {case 1:
        return Object(tf_core_esm["_63" /* slice1d */])(e, t, n);case 2:
        return Object(tf_core_esm["_64" /* slice2d */])(e, [0, t], [e.shape[0], n]);case 3:
        return Object(tf_core_esm["_65" /* slice3d */])(e, [0, 0, t], [e.shape[0], e.shape[1], n]);case 4:
        return Object(tf_core_esm["_66" /* slice4d */])(e, [0, 0, 0, t], [e.shape[0], e.shape[1], e.shape[2], n]);default:
        throw new ValueError("sliceAlongLastAxis() received an unsupported tensor rank: " + e.rank);}
  });
}function sliceAlongAxis(e, t, n, r) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    switch (e.rank) {case 1:
        return Object(tf_core_esm["_63" /* slice1d */])(e, t, n);case 2:
        switch (r) {case 1:
            return sliceAlongFirstAxis(e, t, n);case 2:
            return sliceAlongLastAxis(e, t, n);default:
            throw new ValueError("The axis is not within the rank of the tensor " + r);}case 3:
        switch (r) {case 1:
            return sliceAlongFirstAxis(e, t, n);case 2:
            return Object(tf_core_esm["_65" /* slice3d */])(e, [0, t, 0], [e.shape[0], n, e.shape[2]]);case 3:
            return sliceAlongLastAxis(e, t, n);default:
            throw new ValueError("The axis is not within the rank of the tensor " + r);}case 4:
        switch (r) {case 1:
            return sliceAlongFirstAxis(e, t, n);case 2:
            return Object(tf_core_esm["_66" /* slice4d */])(e, [0, t, 0, 0], [e.shape[0], n, e.shape[2], e.shape[3]]);case 3:
            return Object(tf_core_esm["_66" /* slice4d */])(e, [0, 0, t, 0], [e.shape[0], e.shape[1], n, e.shape[3]]);case 4:
            return sliceAlongLastAxis(e, t, n);default:
            throw new ValueError("The axis is not within the rank of the tensor " + r);}default:
        throw new ValueError("sliceAlongLastAxis() received an unsupported tensor rank: " + e.rank);}
  });
}function concatenate(e, t) {
  var n;return void 0 === t && (t = -1), t < 0 && (t = 0 !== (n = e[0].rank) ? n : 0), t === e[0].rank && (t = -1), Object(tf_core_esm["B" /* concat */])(e, t);
}function concatAlongFirstAxis(e, t) {
  switch (e.rank) {case 1:
      return Object(tf_core_esm["C" /* concat1d */])([e, t]);case 2:
      return Object(tf_core_esm["D" /* concat2d */])([e, t], 0);case 3:
      return Object(tf_core_esm["E" /* concat3d */])([e, t], 0);case 4:
      return Object(tf_core_esm["F" /* concat4d */])([e, t], 0);default:
      throw new ValueError("concatAlongFirstAxis() received an unsupported tensor rank: " + e.rank);}
}function tile$1(e, t) {
  if (Array.isArray(t) || (t = [t]), e.rank !== t.length) throw new ValueError("The length of input n (" + t.length + ") does not match the number of dimensions in input x (" + e.rank + ")");return Object(tf_core_esm["_86" /* tile */])(e, t);
}function randomNormal$1(e, t, n, r, i) {
  return void 0 === t && (t = 0), void 0 === n && (n = 1), Object(tf_core_esm["_43" /* randomNormal */])(e, t, n, r, i);
}function dot(e, t) {
  if (e.rank < 2 || t.rank < 2) throw new NotImplementedError("dot requires both inputs to be rank >= 2 but got x shape = " + e.shape + " and y shape = " + t.shape);if (t.rank >= 3 && (r = e.shape.slice(-1)[0]) !== (o = t.shape.slice(-2)[0])) throw new NotImplementedError("If rank y >= 3, then the second last dim of y must equal the last dim of x but got x shape = " + e.shape + " and  y shape = " + t.shape);if (2 === e.rank && 2 === t.rank) return Object(tf_core_esm["_21" /* matMul */])(e, t);var n = e.shape.slice(),
      r = n.pop();e = e.reshape([-1, r]);var i = t.shape.slice(),
      a = i.pop(),
      o = i.pop(),
      s = i.concat([a]),
      l = Array.from({ length: t.rank }, function (e, n) {
    return 0 === n ? t.rank - 2 : n <= t.rank - 2 ? n - 1 : n;
  });t = t.transpose(l).reshape([o, -1]);var u = n.concat(s);return Object(tf_core_esm["_21" /* matMul */])(e, t).reshape(u);
}function gather$1(e, t, n) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return t = Array.isArray(t) ? Object(tf_core_esm["_84" /* tensor1d */])(t, "int32") : t.toInt(), Object(tf_core_esm["_0" /* gather */])(e, t, n);
  });
}function square(e) {
  return Object(tf_core_esm["_32" /* mulStrict */])(e, e);
}function biasAdd(e, t, n) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    if (null == n && (n = imageDataFormat()), checkDataFormat(n), 1 !== t.rank && t.rank !== e.rank) throw new ValueError("Unexpected bias dimensions: " + t.rank + "; expected it to be 1 or " + e.rank);var r,
        i = t.shape;if (5 === e.rank) "channelsFirst" === n ? r = 1 === i.length ? e.add(t.reshape([1, i[0], 1, 1, 1])) : e.add(t.reshape([1, i[3], i[0], i[1], i[2]])) : "channelsLast" === n && (r = 1 === i.length ? e.add(t.reshape([1, 1, 1, 1, i[0]])) : e.add(t.reshape([1].concat(i))));else if (4 === e.rank) "channelsFirst" === n ? r = 1 === i.length ? e.add(t.reshape([1, i[0], 1, 1])) : e.add(t.reshape([1, i[2], i[0], i[1]])) : "channelsLast" === n && (r = 1 === i.length ? e.add(t.reshape([1, 1, 1, i[0]])) : e.add(t.reshape([1].concat(i))));else if (3 === e.rank) "channelsFirst" === n ? r = 1 === i.length ? e.add(t.reshape([1, i[0], 1])) : e.add(t.reshape([1, i[1], i[0]])) : "channelsLast" === n && (r = 1 === i.length ? e.add(t.reshape([1, 1, i[0]])) : e.add(t.reshape([1].concat(i))));else {
      if (!(e.rank < 3)) throw new ValueError("Unsupported input rank by biasAdd: " + e.rank);r = e.add(t);
    }return r;
  });
}function elu$1(e, t) {
  if (void 0 === t && (t = 1), 1 !== t) throw new NotImplementedError("Support for alpha values other than 1 (" + t + ") is not implemented yet.");return Object(tf_core_esm["P" /* elu */])(e);
}function softsign(e) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return Object(tf_core_esm["O" /* div */])(e, Object(tf_core_esm["g" /* add */])(getScalar(1), Object(tf_core_esm["d" /* abs */])(e)));
  });
}function dropout(e, t, n, r) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    if (null != n && !tf_core_esm["_92" /* util */].arraysEqual(e.shape, n)) throw new NotImplementedError("Non-default noise shape is not implemented yet: " + JSON.stringify(n));if (null != r) throw new NotImplementedError("seed is not implemented for dropout yet.");var i = Object(tf_core_esm["_77" /* step */])(Object(tf_core_esm["g" /* add */])(Object(tf_core_esm["_33" /* neg */])(t), Object(tf_core_esm["_44" /* randomUniform */])(e.shape, 0, 1, "float32")));return i = Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["O" /* div */])(getScalar(1), Object(tf_core_esm["_79" /* sub */])(getScalar(1), t)), i), Object(tf_core_esm["_31" /* mul */])(e, i);
  });
}function hardSigmoid(e) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var t = Object(tf_core_esm["g" /* add */])(getScalar(.5), Object(tf_core_esm["_31" /* mul */])(getScalar(.2), e));return Object(tf_core_esm["z" /* clipByValue */])(t, 0, 1);
  });
}function inTrainPhase(e, t, n) {
  return void 0 === n && (n = !1), n ? e() : t();
}var VALID_FAN_MODE_VALUES = ["fanIn", "fanOut", "fanAvg"];function checkFanMode(e) {
  checkStringTypeUnionValue(VALID_FAN_MODE_VALUES, "FanMode", e);
}var VALID_DISTRIBUTION_VALUES = ["normal", "uniform"];function checkDistribution(e) {
  checkStringTypeUnionValue(VALID_DISTRIBUTION_VALUES, "Distribution", e);
}var Initializer = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.fromConfigUsesCustomObjects = function () {
    return !1;
  }, t.prototype.getConfig = function () {
    return {};
  }, t;
}(tf_core_esm["_56" /* serialization */].Serializable),
    Zeros = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    return Object(tf_core_esm["_97" /* zeros */])(e, t);
  }, t.className = "Zeros", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(Zeros);var Ones = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    return Object(tf_core_esm["_37" /* ones */])(e, t);
  }, t.className = "Ones", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(Ones);var Constant = function (e) {
  function t(t) {
    var n = e.call(this) || this;if ("object" != typeof t) throw new ValueError("Expected argument of type ConstantConfig but got " + t);if (void 0 === t.value) throw new ValueError("config must have value set but got " + t);return n.value = t.value, n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["_52" /* scalar */])(n.value), Object(tf_core_esm["_37" /* ones */])(e, t));
    });
  }, t.prototype.getConfig = function () {
    return { value: this.value };
  }, t.className = "Constant", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(Constant);var RandomUniform = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.DEFAULT_MINVAL = -.05, n.DEFAULT_MAXVAL = .05, n.minval = t.minval || n.DEFAULT_MINVAL, n.maxval = t.maxval || n.DEFAULT_MAXVAL, n.seed = t.seed, n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    return Object(tf_core_esm["_44" /* randomUniform */])(e, this.minval, this.maxval, t);
  }, t.prototype.getConfig = function () {
    return { minval: this.minval, maxval: this.maxval, seed: this.seed };
  }, t.className = "RandomUniform", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(RandomUniform);var RandomNormal = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.DEFAULT_MEAN = 0, n.DEFAULT_STDDEV = .05, n.mean = t.mean || n.DEFAULT_MEAN, n.stddev = t.stddev || n.DEFAULT_STDDEV, n.seed = t.seed, n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    if ("float32" !== (t = t || "float32") && "int32" !== t) throw new NotImplementedError("randomNormal does not support dType " + t + ".");return randomNormal$1(e, this.mean, this.stddev, t, this.seed);
  }, t.prototype.getConfig = function () {
    return { mean: this.mean, stddev: this.stddev, seed: this.seed };
  }, t.className = "RandomNormal", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(RandomNormal);var TruncatedNormal = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.DEFAULT_MEAN = 0, n.DEFAULT_STDDEV = .05, n.mean = t.mean || n.DEFAULT_MEAN, n.stddev = t.stddev || n.DEFAULT_STDDEV, n.seed = t.seed, n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    if ("float32" !== (t = t || "float32") && "int32" !== t) throw new NotImplementedError("truncatedNormal does not support dType " + t + ".");return Object(tf_core_esm["_90" /* truncatedNormal */])(e, this.mean, this.stddev, t, this.seed);
  }, t.prototype.getConfig = function () {
    return { mean: this.mean, stddev: this.stddev, seed: this.seed };
  }, t.className = "TruncatedNormal", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(TruncatedNormal);var Identity = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.gain = null != t.gain ? Object(tf_core_esm["_52" /* scalar */])(t.gain) : getScalar(1), n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (2 !== e.length || e[0] !== e[1]) throw new ValueError("Identity matrix initializer can only be used for 2D square matrices.");return Object(tf_core_esm["_31" /* mul */])(n.gain, Object(tf_core_esm["V" /* eye */])(e[0]));
    });
  }, t.prototype.getConfig = function () {
    return { gain: this.gain.get() };
  }, t.className = "Identity", t;
}(Initializer);function computeFans(e, t) {
  var n, r;if (void 0 === t && (t = "channelsLast"), checkDataFormat(t), 2 === e.length) n = e[0], r = e[1];else if (-1 !== [3, 4, 5].indexOf(e.length)) {
    if ("channelsFirst" === t) {
      var i = arrayProd(e, 2);n = e[1] * i, r = e[0] * i;
    } else if ("channelsLast" === t) {
      i = arrayProd(e, 0, e.length - 2);n = e[e.length - 2] * i, r = e[e.length - 1] * i;
    }
  } else {
    var a = arrayProd(e);n = Math.sqrt(a), r = Math.sqrt(a);
  }return [n, r];
}tf_core_esm["_56" /* serialization */].registerClass(Identity);var VarianceScaling = function (e) {
  function t(t) {
    var n = e.call(this) || this;if (t.scale < 0) throw new ValueError("scale must be a positive float. Got: " + t.scale);return n.scale = null == t.scale ? 1 : t.scale, n.mode = t.mode, checkFanMode(n.mode), n.distribution = t.distribution, checkDistribution(n.distribution), n.seed = t.seed, n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    var n = computeFans(e),
        r = n[0],
        i = n[1],
        a = this.scale;if ("fanIn" === this.mode ? a /= Math.max(1, r) : "fanOut" === this.mode ? a /= Math.max(1, i) : a /= Math.max(1, (r + i) / 2), "normal" === this.distribution) {
      var o = Math.sqrt(a);if ("float32" !== (t = t || "float32") && "int32" !== t) throw new NotImplementedError(this.getClassName() + " does not support dType " + t + ".");return Object(tf_core_esm["_90" /* truncatedNormal */])(e, 0, o, t, this.seed);
    }var s = Math.sqrt(3 * a);return Object(tf_core_esm["_44" /* randomUniform */])(e, -s, s, t);
  }, t.prototype.getConfig = function () {
    return { scale: this.scale, mode: this.mode, distribution: this.distribution, seed: this.seed };
  }, t.className = "VarianceScaling", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(VarianceScaling);var GlorotUniform = function (e) {
  function t(t) {
    return e.call(this, { scale: 1, mode: "fanAvg", distribution: "uniform", seed: null == t ? null : t.seed }) || this;
  }return __extends(t, e), t.prototype.getClassName = function () {
    return VarianceScaling.className;
  }, t.className = "GlorotUniform", t;
}(VarianceScaling);tf_core_esm["_56" /* serialization */].registerClass(GlorotUniform);var GlorotNormal = function (e) {
  function t(t) {
    return e.call(this, { scale: 1, mode: "fanAvg", distribution: "normal", seed: null == t ? null : t.seed }) || this;
  }return __extends(t, e), t.prototype.getClassName = function () {
    return VarianceScaling.className;
  }, t.className = "GlorotNormal", t;
}(VarianceScaling);tf_core_esm["_56" /* serialization */].registerClass(GlorotNormal);var HeNormal = function (e) {
  function t(t) {
    return e.call(this, { scale: 2, mode: "fanIn", distribution: "normal", seed: null == t ? null : t.seed }) || this;
  }return __extends(t, e), t.prototype.getClassName = function () {
    return VarianceScaling.className;
  }, t.className = "HeNormal", t;
}(VarianceScaling);tf_core_esm["_56" /* serialization */].registerClass(HeNormal);var LeCunNormal = function (e) {
  function t(t) {
    return e.call(this, { scale: 1, mode: "fanIn", distribution: "normal", seed: null == t ? null : t.seed }) || this;
  }return __extends(t, e), t.prototype.getClassName = function () {
    return VarianceScaling.className;
  }, t.className = "LeCunNormal", t;
}(VarianceScaling);tf_core_esm["_56" /* serialization */].registerClass(LeCunNormal);var Orthogonal = function (e) {
  function t(t) {
    var n = e.call(this) || this;if (n.DEFAULT_GAIN = 1, n.gain = null == t.gain ? n.DEFAULT_GAIN : t.gain, n.seed = t.seed, null != n.seed) throw new NotImplementedError("Random seed is not implemented for Orthogonal Initializer yet.");return n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (2 !== e.length) throw new NotImplementedError("The Orthogonal Initializer does not support non-2D shapes yet.");e[0] * e[1] > 2e3 && console.warn("Orthogonal initializer is being called on a matrix with more than 2000 (" + e[0] * e[1] + ") elements: Slowness may result.");var t = randomNormal$1(e[0] > e[1] ? [e[1], e[0]] : e, 0, 1, "float32"),
          r = tf_core_esm["_12" /* linalg */].gramSchmidt(t);return e[0] > e[1] && (r = r.transpose()), Object(tf_core_esm["_31" /* mul */])(getScalar(n.gain), r);
    });
  }, t.prototype.getConfig = function () {
    return { gain: this.gain, seed: this.seed };
  }, t.className = "Orthogonal", t;
}(Initializer);tf_core_esm["_56" /* serialization */].registerClass(Orthogonal);var INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP = { constant: "Constant", glorotNormal: "GlorotNormal", glorotUniform: "GlorotUniform", heNormal: "HeNormal", identity: "Identity", leCunNormal: "LeCunNormal", ones: "Ones", orthogonal: "Orthogonal", randomNormal: "RandomNormal", randomUniform: "RandomUniform", truncatedNormal: "TruncatedNormal", varianceScaling: "VarianceScaling", zeros: "Zeros" };function deserializeInitializer(e, t) {
  return void 0 === t && (t = {}), deserializeKerasObject(e, tf_core_esm["_56" /* serialization */].SerializationMap.getMap().classNameMap, t, "initializer");
}function serializeInitializer(e) {
  return serializeKerasObject(e);
}function getInitializer(e) {
  if ("string" == typeof e) {
    var t = e in INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP ? INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[e] : e;return "GlorotUniform" === t ? new GlorotUniform() : "GlorotNormal" === t ? new GlorotNormal() : "HeNormal" === t ? new HeNormal() : "LeCunNormal" === t ? new LeCunNormal() : deserializeInitializer({ className: t, config: {} });
  }return e instanceof Initializer ? e : deserializeInitializer(e);
}function zeros$1() {
  return new Zeros();
}function ones$1() {
  return new Ones();
}function constant(e) {
  return new Constant(e);
}function randomUniform$1(e) {
  return new RandomUniform(e);
}function randomNormal$2(e) {
  return new RandomNormal(e);
}function truncatedNormal$1(e) {
  return new TruncatedNormal(e);
}function identity(e) {
  return new Identity(e);
}function varianceScaling(e) {
  return new VarianceScaling(e);
}function glorotUniform(e) {
  return new GlorotUniform(e);
}function glorotNormal(e) {
  return new GlorotNormal(e);
}function heNormal(e) {
  return new HeNormal(e);
}function leCunNormal(e) {
  return new LeCunNormal(e);
}function orthogonal(e) {
  return new Orthogonal(e);
}var exports_initializers = Object.freeze({ zeros: zeros$1, ones: ones$1, constant: constant, randomUniform: randomUniform$1, randomNormal: randomNormal$2, truncatedNormal: truncatedNormal$1, identity: identity, varianceScaling: varianceScaling, glorotUniform: glorotUniform, glorotNormal: glorotNormal, heNormal: heNormal, leCunNormal: leCunNormal, orthogonal: orthogonal });function isArrayOfShapes(e) {
  return Array.isArray(e) && Array.isArray(e[0]);
}function normalizeShapeList(e) {
  return 0 === e.length ? [] : Array.isArray(e[0]) ? e : [e];
}function getExactlyOneTensor(e) {
  var t;if (Array.isArray(e)) {
    if (1 !== e.length) throw new ValueError("Expected Tensor length to be 1; got " + e.length);t = e[0];
  } else t = e;return t;
}function getExactlyOneShape(e) {
  if (Array.isArray(e) && Array.isArray(e[0])) {
    if (1 === e.length) return (e = e)[0];throw new ValueError("Expected exactly 1 Shape; got " + e.length);
  }return e;
}function countParamsInWeights(e) {
  for (var t = 0, n = 0, r = e; n < r.length; n++) {
    var i = r[n];0 === i.shape.length ? t += 1 : t += i.shape.reduce(function (e, t) {
      return e * t;
    });
  }return t;
}var DEFAULT_VARIABLE_NAME_PREFIX = "Variable",
    LayerVariable = function () {
  function e(e, t, n, r, i) {
    void 0 === t && (t = "float32"), void 0 === n && (n = DEFAULT_VARIABLE_NAME_PREFIX), void 0 === r && (r = !0), void 0 === i && (i = null), this.dtype = null == t ? "float32" : t, this.shape = e.shape, this.id = getNextUniqueTensorId(), n = null == n ? DEFAULT_VARIABLE_NAME_PREFIX : n, this.originalName = getScopedTensorName(n), this.name = getUniqueTensorName(this.originalName), this.trainable = r, this.constraint = i, this.val = Object(tf_core_esm["_93" /* variable */])(e, this.trainable, this.name, this.dtype);
  }return e.prototype.read = function () {
    return this.assertNotDisposed(), this.val;
  }, e.prototype.write = function (e) {
    return this.assertNotDisposed(), checkShapesMatch(this.val, e), this.val.id !== e.id && (this.val.assign(e), null != this.constraint && this.val.assign(this.constraint.apply(this.val))), this;
  }, e.prototype.dispose = function () {
    this.assertNotDisposed(), this.val.dispose();
  }, e.prototype.assertNotDisposed = function () {
    if (this.val.isDisposed) throw new Error("LayersVariable " + this.name + " is already disposed.");
  }, e;
}();function checkShapesMatch(e, t) {
  if (e.shape.toString() !== t.shape.toString()) throw new Error("Shape mismatch: " + JSON.stringify(e.shape) + " vs. " + JSON.stringify(t.shape));
}function batchGetValue(e) {
  return e.map(function (e) {
    return e.read();
  });
}function batchSetValue(e) {
  e.map(function (e) {
    e[0].write(e[1]);
  });
}var InputSpec = function () {
  return function (e) {
    this.dtype = e.dtype, this.shape = e.shape, null != e.shape ? this.ndim = e.shape.length : this.ndim = e.ndim, this.maxNDim = e.maxNDim, this.minNDim = e.minNDim, this.axes = e.axes || {};
  };
}(),
    SymbolicTensor = function () {
  return function (e, t, n, r, i, a, o) {
    this.dtype = e, this.shape = t, this.sourceLayer = n, this.inputs = r, this.callArgs = i, this.outputTensorIndex = o, this.id = getNextUniqueTensorId(), null != a && (this.originalName = getScopedTensorName(a), this.name = getUniqueTensorName(this.originalName)), this.rank = t.length;
  };
}(),
    _nextNodeID = 0,
    Node = function () {
  function e(e, t) {
    this.callArgs = t, this.id = _nextNodeID++, this.outboundLayer = e.outboundLayer, this.inboundLayers = e.inboundLayers, this.nodeIndices = e.nodeIndices, this.tensorIndices = e.tensorIndices, this.inputTensors = e.inputTensors, this.outputTensors = e.outputTensors, this.inputMasks = e.inputMasks, this.outputMasks = e.outputMasks, this.inputShapes = e.inputShapes, this.outputShapes = e.outputShapes;for (var n = 0, r = e.inboundLayers; n < r.length; n++) {
      var i = r[n];null != i && i.outboundNodes.push(this);
    }e.outboundLayer.inboundNodes.push(this);
  }return e.prototype.getConfig = function () {
    for (var e = [], t = 0, n = this.inboundLayers; t < n.length; t++) {
      var r = n[t];null != r ? e.push(r.name) : e.push(null);
    }return { outboundLayer: this.outboundLayer ? this.outboundLayer.name : null, inboundLayers: e, nodeIndices: this.nodeIndices, tensorIndices: this.tensorIndices };
  }, e;
}(),
    _nextLayerID = 0,
    Layer = function (e) {
  function t(t) {
    var n = e.call(this) || this;n._callHook = null, n._addedWeightNames = [], n._stateful = !1, n.id = _nextLayerID++, n.activityRegularizer = null, n.inputSpec = null, n.supportsMasking = !1, n._trainableWeights = [], n._nonTrainableWeights = [], n._losses = [], n._updates = [], n._built = !1, n.inboundNodes = [], n.outboundNodes = [];var r = t.name;if (!r) {
      var i = n.getClassName();r = toSnakeCase(i) + "_" + getUid(i);
    }if (n.name = r, n.trainable = null == t.trainable || t.trainable, n.updatable = null == t.updatable || t.updatable, null != t.inputShape || null != t.batchInputShape) {
      var a = void 0;if (null != t.batchInputShape) a = t.batchInputShape;else if (null != t.inputShape) {
        var o = null;null != t.batchSize && (o = t.batchSize), a = [o].concat(t.inputShape);
      }n.batchInputShape = a;var s = t.dtype;null == s && (s = t.inputDType), null == s && (s = "float32"), n.dtype = s;
    }return null != t.weights ? n.initialWeights = t.weights : n.initialWeights = null, n._refCount = null, n.fastWeightInitDuringBuild = !1, n;
  }return __extends(t, e), t.nodeKey = function (e, t) {
    return e.name + "_ib-" + t.toString();
  }, t.prototype.getNodeAtIndex = function (e, t) {
    if (0 === this.inboundNodes.length) throw new RuntimeError("The layer has never been called and thus has no defined " + t + ".");if (this.inboundNodes.length <= e) throw new ValueError("Asked to get " + t + " at node " + e + ", but the layer has only " + this.inboundNodes.length + " inbound nodes.");return this.inboundNodes[e];
  }, t.prototype.getInputAt = function (e) {
    return singletonOrArray(this.getNodeAtIndex(e, "input").inputTensors);
  }, t.prototype.getOutputAt = function (e) {
    return singletonOrArray(this.getNodeAtIndex(e, "output").outputTensors);
  }, Object.defineProperty(t.prototype, "input", { get: function get() {
      if (this.inboundNodes.length > 1) throw new AttributeError("Layer " + this.name + ' has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use `getInputAt(nodeIndex)` instead.');if (0 === this.inboundNodes.length) throw new AttributeError("Layer " + this.name + " is not connected, no input to return.");return singletonOrArray(this.getNodeAtIndex(0, "input").inputTensors);
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "output", { get: function get() {
      if (0 === this.inboundNodes.length) throw new AttributeError("Layer " + this.name + " has no inbound nodes.");if (this.inboundNodes.length > 1) throw new AttributeError("Layer " + this.name + ' has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use `getOutputAt(nodeIndex)` instead.');return singletonOrArray(this.getNodeAtIndex(0, "output").outputTensors);
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "losses", { get: function get() {
      return this._losses;
    }, enumerable: !0, configurable: !0 }), t.prototype.calculateLosses = function () {
    return this.losses.map(function (e) {
      return e();
    });
  }, Object.defineProperty(t.prototype, "updates", { get: function get() {
      return this._updates;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "built", { get: function get() {
      return this._built;
    }, set: function set(e) {
      this._built = e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      return this.trainable ? this._trainableWeights : [];
    }, set: function set(e) {
      this._trainableWeights = e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      return this.trainable ? this._nonTrainableWeights : this._trainableWeights.concat(this._nonTrainableWeights);
    }, set: function set(e) {
      this._nonTrainableWeights = e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "weights", { get: function get() {
      return this.trainableWeights.concat(this.nonTrainableWeights);
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "stateful", { get: function get() {
      return this._stateful;
    }, enumerable: !0, configurable: !0 }), t.prototype.resetStates = function () {
    if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
  }, t.prototype.assertInputCompatibility = function (e) {
    if (e = toList(e), null != this.inputSpec && 0 !== this.inputSpec.length) {
      var t = toList(this.inputSpec);if (e.length !== t.length) throw new ValueError("Layer " + this.name + " expects " + t.length + " inputs, but it received " + e.length + " input tensors. Input received: " + e);for (var n = 0; n < e.length; n++) {
        var r = e[n],
            i = t[n];if (null != i) {
          var a = r.rank;if (null != i.ndim && a !== i.ndim) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + ": expected ndim=" + i.ndim + ", found ndim=" + a);if (null != i.maxNDim && a > i.maxNDim) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + ": expected max_ndim=" + i.maxNDim + ", found ndim=" + a);if (null != i.minNDim && a < i.minNDim) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + ": expected min_ndim=" + i.minNDim + ", found ndim=" + a + ".");if (null != i.dtype && r.dtype !== i.dtype) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + " : expected dtype=" + i.dtype + ", found dtype=" + r.dtype + ".");if (i.axes) {
            var o = r.shape;for (var s in i.axes) {
              var l = Number(s),
                  u = i.axes[s],
                  c = l >= 0 ? o[l] : o[o.length + l];if (null != u && -1 === [u, null].indexOf(c)) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + ": expected axis " + l + " of input shape to have value " + u + " but got shape " + o + ".");
            }
          }if (null != i.shape) for (var h = 0; h < i.shape.length; ++h) {
            var p = i.shape[h],
                d = r.shape[h];if (null != p && null != d && p !== d) throw new ValueError("Input " + n + " is incompatible with layer " + this.name + ": expected shape=" + i.shape + ", found shape=${xShape}.");
          }
        }
      }
    }
  }, t.prototype.call = function (e, t) {
    return e;
  }, t.prototype.invokeCallHook = function (e, t) {
    null != this._callHook && this._callHook(e, t);
  }, t.prototype.setCallHook = function (e) {
    this._callHook = e;
  }, t.prototype.clearCallHook = function () {
    this._callHook = null;
  }, t.prototype.apply = function (e, t) {
    var n = this;t = t || {}, this.assertNotDisposed();for (var r = toList(e), i = !0, a = 0, o = r; a < o.length; a++) {
      if (!(o[a] instanceof SymbolicTensor)) {
        i = !1;break;
      }
    }for (var s = !0, l = 0, u = r; l < u.length; l++) {
      if (u[l] instanceof SymbolicTensor) {
        s = !1;break;
      }
    }if (i === s) throw new ValueError("Arguments to apply() must be all SymbolicTensors or all Tensors");return nameScope(this.name, function () {
      if (!n.built) {
        n.assertInputCompatibility(e);for (var i = [], a = 0, o = toList(e); a < o.length; a++) {
          var l = o[a];i.push(l.shape);
        }n.build(singletonOrArray(i)), n.built = !0, n.initialWeights && n.setWeights(n.initialWeights), null === n._refCount && s && (n._refCount = 1);
      }if (n.assertInputCompatibility(e), s) {
        for (var u = [], c = 0, h = toList(f = n.call(e, t)); c < h.length; c++) {
          var p = h[c];-1 !== r.indexOf(p) && (p = p.clone()), u.push(p);
        }if (f = singletonOrArray(u), null != n.activityRegularizer) throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");return f;
      }var d = collectInputShape(e),
          g = n.computeOutputShape(d),
          f = void 0,
          m = guessOutputDType(e);if (n.warnOnIncompatibleInputShape(Array.isArray(e) ? d[0] : d), f = null != g && g.length > 0 && Array.isArray(g[0]) ? g.map(function (r, i) {
        return new SymbolicTensor(m, r, n, toList(e), t, n.name, i);
      }) : new SymbolicTensor(m, g, n, toList(e), t, n.name), n.addInboundNode(e, f, null, null, d, g, t), n._refCount++, null != n.activityRegularizer) throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");return f;
    });
  }, t.prototype.warnOnIncompatibleInputShape = function (e) {
    if (null != this.batchInputShape) if (e.length !== this.batchInputShape.length) console.warn("The rank of the input tensor provided (shape: " + JSON.stringify(e) + ") does not match that of the batchInputShape (" + JSON.stringify(this.batchInputShape) + ") of the layer " + this.name);else {
      var t = !1;this.batchInputShape.forEach(function (n, r) {
        null != n && null != e[r] && e[r] !== n && (t = !0);
      }), t && console.warn("The shape of the input tensor (" + JSON.stringify(e) + ") does not match the expectation of layer " + this.name + ": " + JSON.stringify(this.batchInputShape));
    }
  }, Object.defineProperty(t.prototype, "outputShape", { get: function get() {
      if (null == this.inboundNodes || 0 === this.inboundNodes.length) throw new AttributeError("The layer " + this.name + " has never been called and thus has no defined output shape.");for (var e = [], t = 0, n = this.inboundNodes; t < n.length; t++) {
        var r = n[t],
            i = JSON.stringify(r.outputShapes);-1 === e.indexOf(i) && e.push(i);
      }if (1 === e.length) {
        var a = this.inboundNodes[0].outputShapes;return Array.isArray(a) && Array.isArray(a[0]) && 1 === a.length ? a[0] : a;
      }throw new AttributeError("The layer " + this.name + ' has multiple inbound nodes with different output shapes. Hence the notion of "outut shape" is ill-defined for the layer.');
    }, enumerable: !0, configurable: !0 }), t.prototype.countParams = function () {
    if (!this.built) throw new RuntimeError("You tried to call countParams() on " + this.name + ", but the layer is not built yet. Build it first by calling build(batchInputShape).");return countParamsInWeights(this.weights);
  }, t.prototype.build = function (e) {
    this.built = !0;
  }, t.prototype.getWeights = function (e) {
    return void 0 === e && (e = !1), batchGetValue(e ? this.trainableWeights : this.weights);
  }, t.prototype.setWeights = function (e) {
    var t = this;Object(tf_core_esm["_85" /* tidy */])(function () {
      var n = t.weights;if (n.length !== e.length) throw new ValueError('You called setWeights(weights) on layer "' + t.name + '" with a weight list of length ' + e.length + ", but the layer was expecting " + n.length + " weights. Provided weights: " + e + "...");if (0 !== n.length) {
        for (var r = [], i = batchGetValue(n), a = 0; a < i.length; ++a) {
          var o = i[a],
              s = n[a],
              l = e[a];if (!tf_core_esm["_92" /* util */].arraysEqual(o.shape, l.shape)) throw new ValueError("Layer weight shape " + o.shape + " not compatible with provided weight shape " + l.shape);r.push([s, l]);
        }batchSetValue(r);
      }
    });
  }, t.prototype.addWeight = function (e, t, n, r, i, a, o) {
    if (-1 !== this._addedWeightNames.indexOf(e)) throw new ValueError("Duplicate weight name " + e + " for layer " + this.name);this._addedWeightNames.push(e), null == n && (n = "float32"), this.fastWeightInitDuringBuild && (r = getInitializer("zeros"));var s = r.apply(t, n),
        l = new LayerVariable(s, n, e, a, o);return s.dispose(), null != i && this.addLoss(function () {
      return i.apply(l.read());
    }), null == a && (a = !0), a ? this._trainableWeights.push(l) : this._nonTrainableWeights.push(l), l;
  }, t.prototype.setFastWeightInitDuringBuild = function (e) {
    this.fastWeightInitDuringBuild = e;
  }, t.prototype.addLoss = function (e) {
    var t;null == e || Array.isArray(e) && 0 === e.length || (e = toList(e), void 0 !== this._losses && null !== this._losses && (t = this.losses).push.apply(t, e));
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.computeMask = function (e, t) {
    var n = this;if (!this.supportsMasking) {
      if (null != t) {
        if (!Array.isArray(t)) throw new TypeError("Layer " + this.name + " does not support masking, but was passed an inputMask.");t.forEach(function (e) {
          if (null != e) throw new TypeError("Layer " + n.name + " does not support masking, but was passed an inputMask.");
        });
      }return null;
    }return t;
  }, t.prototype.addInboundNode = function (e, t, n, r, i, a, o) {
    void 0 === o && (o = null);var s = toList(e);t = toList(t), n = toList(n), r = toList(r), i = normalizeShapeList(i), a = normalizeShapeList(a);for (var l = [], u = [], c = [], h = 0, p = s; h < p.length; h++) {
      var d = p[h];l.push(d.sourceLayer), u.push(d.nodeIndex), c.push(d.tensorIndex);
    }new Node({ outboundLayer: this, inboundLayers: l, nodeIndices: u, tensorIndices: c, inputTensors: s, outputTensors: t, inputMasks: n, outputMasks: r, inputShapes: i, outputShapes: a }, o);for (var g = 0; g < t.length; g++) {
      t[g].sourceLayer = this, t[g].nodeIndex = this.inboundNodes.length - 1, t[g].tensorIndex = g;
    }
  }, t.prototype.getConfig = function () {
    var e = { name: this.name, trainable: this.trainable };return null != this.batchInputShape && (e.batchInputShape = this.batchInputShape), null != this.dtype && (e.dtype = this.dtype), e;
  }, t.prototype.disposeWeights = function () {
    return this.weights.forEach(function (e) {
      return e.dispose();
    }), this.weights.length;
  }, t.prototype.assertNotDisposed = function () {
    if (0 === this._refCount) throw new Error("Layer '" + this.name + "' is already disposed.");
  }, t.prototype.dispose = function () {
    if (!this.built) throw new Error("Cannot dispose Layer " + this.name + " because it has not been built yet.");if (null === this._refCount) throw new Error("Cannot dispose Layer " + this.name + " because it has not been used yet.");this.assertNotDisposed();var e = 0;return 0 == --this._refCount && (e = this.disposeWeights()), { refCountAfterDispose: this._refCount, numDisposedVariables: e };
  }, t;
}(tf_core_esm["_56" /* serialization */].Serializable);function collectInputShape(e) {
  for (var t = [], n = 0, r = e = toList(e); n < r.length; n++) {
    var i = r[n];t.push(i.shape);
  }return singletonOrArray(t);
}function guessOutputDType(e) {
  return "float32";
}function getSourceInputs(e, t, n) {
  if ((null == t || null != n && n > 0) && (t = e.sourceLayer, n = e.nodeIndex), 0 === t.inboundNodes.length) return [e];var r = t.inboundNodes[n];if (0 === r.inboundLayers.length) return r.inputTensors;for (var i = [], a = 0; a < r.inboundLayers.length; a++) {
    for (var o = 0, s = getSourceInputs(r.inputTensors[a], r.inboundLayers[a], r.nodeIndices[a]); o < s.length; o++) {
      var l = s[o];-1 === i.indexOf(l) && i.push(l);
    }
  }return i;
}var ModelLoggingVerbosity,
    InputLayer = function (e) {
  function t(t) {
    var n = e.call(this, { dtype: t.dtype, name: null != t.name ? t.name : getUid("input").toString() }) || this;if (null == t.batchSize && (t.batchSize = null), null == t.sparse && (t.sparse = !1), n.trainable = !1, n.built = !0, n.sparse = t.sparse, null != t.inputShape && null != t.batchInputShape) throw new ValueError("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");var r = t.batchInputShape;if (null == r) {
      if (null == t.inputShape) throw new ValueError("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");r = [t.batchSize].concat(t.inputShape);
    } else if (null != t.batchSize) throw new ValueError("Cannot specify batchSize if batchInputShape isspecified when creating an InputLayer.");var i = t.dtype || "float32";n.batchInputShape = r, n.dtype = i, n.inputSpec = [{ shape: r }];var a = new SymbolicTensor(n.dtype, n.batchInputShape, n, [], {}, n.name);return a.nodeIndex = 0, a.tensorIndex = 0, new Node({ outboundLayer: n, inboundLayers: [], nodeIndices: [], tensorIndices: [], inputTensors: [a], outputTensors: [a], inputMasks: [null], outputMasks: [null], inputShapes: [r], outputShapes: [r] }), n;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    throw new ValueError("Cannot pass any input to an InputLayer's apply() method. InputLayer name: " + this.name);
  }, t.prototype.dispose = function () {
    return { refCountAfterDispose: this._refCount, numDisposedVariables: 0 };
  }, t.prototype.getConfig = function () {
    return { batchInputShape: this.batchInputShape, dtype: this.dtype, sparse: this.sparse, name: this.name };
  }, t.className = "InputLayer", t;
}(Layer);function Input(e) {
  if (null == e.batchShape && null == e.shape) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");if (null != e.batchShape && null != e.shape) throw new ValueError("Please provide either a `shape` or `batchShape` argument to Input, but not both.");var t = e.batchShape;null != e.shape && null == t && (t = [null].concat(e.shape));var n = e.dtype;return null == n && (n = "float32"), new InputLayer({ batchInputShape: t, name: e.name, dtype: n, sparse: e.sparse }).inboundNodes[0].outputTensors[0];
}function resolveScalarsInLogs(e) {
  return __awaiter(this, void 0, void 0, function () {
    var t, n, r, i, a, o, s, l;return __generator(this, function (u) {
      switch (u.label) {case 0:
          if (null == e) return [2];for (i in t = [], n = [], r = [], e) {
            "number" != typeof (a = e[i]) && (o = a, t.push(o.data()), n.push(i), r.push(o));
          }return [4, Promise.all(t)];case 1:
          for (s = u.sent(), l = 0; l < s.length; ++l) {
            e[n[l]] = s[l][0];
          }return Object(tf_core_esm["N" /* dispose */])(r), [2];}
    });
  });
}function disposeTensorsInLogs(e) {
  if (null != e) for (var t in e) {
    var n = e[t];"number" != typeof n && n.dispose();
  }
}tf_core_esm["_56" /* serialization */].registerClass(InputLayer), function (e) {
  e[e.SILENT = 0] = "SILENT", e[e.VERBOSE = 1] = "VERBOSE";
}(ModelLoggingVerbosity || (ModelLoggingVerbosity = {}));var BaseCallback = function () {
  function e() {
    this.validationData = null;
  }return e.prototype.setParams = function (e) {
    this.params = e;
  }, e.prototype.onEpochBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.onEpochEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.onBatchBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.onBatchEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.onTrainBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.onTrainEnd = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2];
      });
    });
  }, e.prototype.setModel = function (e) {}, e;
}(),
    CallbackList = function () {
  function e(e, t) {
    void 0 === t && (t = 10), null == e && (e = []), this.callbacks = e, this.queueLength = t;
  }return e.prototype.append = function (e) {
    this.callbacks.push(e);
  }, e.prototype.setParams = function (e) {
    for (var t = 0, n = this.callbacks; t < n.length; t++) {
      n[t].setParams(e);
    }
  }, e.prototype.setModel = function (e) {
    for (var t = 0, n = this.callbacks; t < n.length; t++) {
      n[t].setModel(e);
    }
  }, e.prototype.onEpochBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r;return __generator(this, function (i) {
        switch (i.label) {case 0:
            null == t && (t = {}), n = 0, r = this.callbacks, i.label = 1;case 1:
            return n < r.length ? [4, r[n].onEpochBegin(e, t)] : [3, 4];case 2:
            i.sent(), i.label = 3;case 3:
            return n++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.onEpochEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r;return __generator(this, function (i) {
        switch (i.label) {case 0:
            null == t && (t = {}), n = 0, r = this.callbacks, i.label = 1;case 1:
            return n < r.length ? [4, r[n].onEpochEnd(e, t)] : [3, 4];case 2:
            i.sent(), i.label = 3;case 3:
            return n++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.onBatchBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r;return __generator(this, function (i) {
        switch (i.label) {case 0:
            null == t && (t = {}), n = 0, r = this.callbacks, i.label = 1;case 1:
            return n < r.length ? [4, r[n].onBatchBegin(e, t)] : [3, 4];case 2:
            i.sent(), i.label = 3;case 3:
            return n++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.onBatchEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r;return __generator(this, function (i) {
        switch (i.label) {case 0:
            null == t && (t = {}), n = 0, r = this.callbacks, i.label = 1;case 1:
            return n < r.length ? [4, r[n].onBatchEnd(e, t)] : [3, 4];case 2:
            i.sent(), i.label = 3;case 3:
            return n++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.onTrainBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n;return __generator(this, function (r) {
        switch (r.label) {case 0:
            null == e && (e = {}), t = 0, n = this.callbacks, r.label = 1;case 1:
            return t < n.length ? [4, n[t].onTrainBegin(e)] : [3, 4];case 2:
            r.sent(), r.label = 3;case 3:
            return t++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.onTrainEnd = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n;return __generator(this, function (r) {
        switch (r.label) {case 0:
            null == e && (e = {}), t = 0, n = this.callbacks, r.label = 1;case 1:
            return t < n.length ? [4, n[t].onTrainEnd(e)] : [3, 4];case 2:
            r.sent(), r.label = 3;case 3:
            return t++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e;
}(),
    ModelTrainingYielder = function () {
  function e(e) {
    this.yieldEvery = e, this.batchCount = 0, this.batchDurationsMillis = [], this.autoYieldEveryBatches = null, this.batchStartMillis = tf_core_esm["_92" /* util */].now();
  }return e.prototype.resolveOneTensorInLogs = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var t, n, r, i, a;return __generator(this, function (o) {
        switch (o.label) {case 0:
            for (n in t = [], e) {
              t.push(n);
            }r = 0, o.label = 1;case 1:
            return r < t.length ? (i = t[r], "number" == typeof (a = e[i]) ? [3, 3] : [4, a.data()]) : [3, 4];case 2:
            return o.sent(), [3, 4];case 3:
            return r++, [3, 1];case 4:
            return [2];}
      });
    });
  }, e.prototype.maybeYieldOnBatch = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r;return __generator(this, function (i) {
        switch (i.label) {case 0:
            return "auto" !== this.yieldEvery ? [3, 7] : (this.batchCount++, null != this.autoYieldEveryBatches ? [3, 3] : [4, this.resolveOneTensorInLogs(t)]);case 1:
            return i.sent(), n = tf_core_esm["_92" /* util */].now(), [4, Object(tf_core_esm["_34" /* nextFrame */])()];case 2:
            return i.sent(), this.batchCount > e.SKIP_FIRST_BATCHES && (this.batchDurationsMillis.push(n - this.batchStartMillis), this.batchDurationsMillis.length >= e.DECISION_BATCH_COUNT && (r = this.batchDurationsMillis.reduce(function (e, t) {
              return e + t;
            }) / this.batchDurationsMillis.length, this.autoYieldEveryBatches = Math.round(e.THRESHOLD_MILLIS / r), this.autoYieldEveryBatches < 1 && (this.autoYieldEveryBatches = 1))), this.batchStartMillis = tf_core_esm["_92" /* util */].now(), this.lastYieldBatchCount = this.batchCount, [3, 6];case 3:
            return this.batchCount - this.lastYieldBatchCount >= this.autoYieldEveryBatches ? [4, Object(tf_core_esm["_34" /* nextFrame */])()] : [3, 6];case 4:
            return i.sent(), [4, this.resolveOneTensorInLogs(t)];case 5:
            i.sent(), this.lastYieldBatchCount = this.batchCount, i.label = 6;case 6:
            return [3, 9];case 7:
            return "batch" !== this.yieldEvery ? [3, 9] : [4, Object(tf_core_esm["_34" /* nextFrame */])()];case 8:
            i.sent(), i.label = 9;case 9:
            return [2];}
      });
    });
  }, e.prototype.maybeYieldOnEpoch = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {case 0:
            return "epoch" !== this.yieldEvery ? [3, 2] : [4, Object(tf_core_esm["_34" /* nextFrame */])()];case 1:
            e.sent(), e.label = 2;case 2:
            return [2];}
      });
    });
  }, e.SKIP_FIRST_BATCHES = 1, e.DECISION_BATCH_COUNT = 2, e.THRESHOLD_MILLIS = 16, e;
}(),
    BaseLogger = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.yieldEvery = t || "auto", n;
  }return __extends(t, e), t.prototype.onTrainBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return this.autoYielder = new ModelTrainingYielder(this.yieldEvery), [2];
      });
    });
  }, t.prototype.onEpochBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return this.seen = 0, this.totals = {}, [2];
      });
    });
  }, t.prototype.onBatchEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var e,
          n,
          r,
          i,
          a = this;return __generator(this, function (o) {
        switch (o.label) {case 0:
            return [4, this.autoYielder.maybeYieldOnBatch(t)];case 1:
            for (i in o.sent(), null == t && (t = {}), e = null == t.size ? 0 : t.size, this.seen += e, n = function n(_n) {
              var i = t[_n];if ("number" == typeof i) r.totals.hasOwnProperty(_n) || (r.totals[_n] = 0), r.totals[_n] = r.totals[_n] + i * e;else {
                var o = void 0;_n in r.totals ? o = r.totals[_n] : r.totals[_n] = getScalar(0), r.totals[_n] = Object(tf_core_esm["_85" /* tidy */])(function () {
                  return Object(tf_core_esm["g" /* add */])(a.totals[_n], Object(tf_core_esm["_31" /* mul */])(i, getScalar(e)));
                }), null != o && o.dispose();
              }
            }, r = this, t) {
              n(i);
            }return [2];}
      });
    });
  }, t.prototype.onEpochEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var e,
          n,
          r,
          i,
          a,
          o = this;return __generator(this, function (s) {
        switch (s.label) {case 0:
            return [4, this.autoYielder.maybeYieldOnEpoch()];case 1:
            if (s.sent(), null != t) for (e = function e(_e) {
              if (null == n.totals[_e]) return "continue";"number" == typeof n.totals[_e] ? t[_e] = n.totals[_e] / n.seen : Object(tf_core_esm["_85" /* tidy */])(function () {
                t[_e] = Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["O" /* div */])(getScalar(1), getScalar(o.seen)), o.totals[_e]), o.totals[_e].dispose(), Object(tf_core_esm["_8" /* keep */])(t[_e]);
              });
            }, n = this, r = 0, i = this.params.metrics; r < i.length; r++) {
              a = i[r], e(a);
            }return [2];}
      });
    });
  }, t;
}(BaseCallback),
    History = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.onTrainBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return this.epoch = [], this.history = {}, [2];
      });
    });
  }, t.prototype.onEpochEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n;return __generator(this, function (r) {
        for (n in null == t && (t = {}), this.epoch.push(e), t) {
          null == this.history[n] && (this.history[n] = []), this.history[n].push(t[n]);
        }return [2];
      });
    });
  }, t.prototype.syncData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, t, n, r, i, a, o, s, l;return __generator(this, function (u) {
        switch (u.label) {case 0:
            for (r in e = [], t = [], n = [], this.history) {
              for (i = this.history[r], a = 0; a < i.length; ++a) {
                "number" != typeof i[a] && (o = i[a], e.push(o.data()), t.push(r), n.push(a));
              }
            }return [4, Promise.all(e)];case 1:
            for (s = u.sent(), l = 0; l < s.length; ++l) {
              this.history[t[l]][n[l]].dispose(), this.history[t[l]][n[l]] = s[l][0];
            }return [2];}
      });
    });
  }, t;
}(BaseCallback),
    CustomCallback = function (e) {
  function t(t) {
    var n = e.call(this) || this;return n.trainBegin = t.onTrainBegin, n.trainEnd = t.onTrainEnd, n.epochBegin = t.onEpochBegin, n.epochEnd = t.onEpochEnd, n.batchBegin = t.onBatchBegin, n.batchEnd = t.onBatchEnd, n;
  }return __extends(t, e), t.prototype.onEpochBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        switch (n.label) {case 0:
            return null == this.epochBegin ? [3, 3] : [4, resolveScalarsInLogs(t)];case 1:
            return n.sent(), [4, this.epochBegin(e, t)];case 2:
            n.sent(), n.label = 3;case 3:
            return [2];}
      });
    });
  }, t.prototype.onEpochEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        switch (n.label) {case 0:
            return null == this.epochEnd ? [3, 3] : [4, resolveScalarsInLogs(t)];case 1:
            return n.sent(), [4, this.epochEnd(e, t)];case 2:
            n.sent(), n.label = 3;case 3:
            return [2];}
      });
    });
  }, t.prototype.onBatchBegin = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        switch (n.label) {case 0:
            return null == this.batchBegin ? [3, 3] : [4, resolveScalarsInLogs(t)];case 1:
            return n.sent(), [4, this.batchBegin(e, t)];case 2:
            n.sent(), n.label = 3;case 3:
            return [2];}
      });
    });
  }, t.prototype.onBatchEnd = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        switch (n.label) {case 0:
            return null == this.batchEnd ? [3, 3] : [4, resolveScalarsInLogs(t)];case 1:
            return n.sent(), [4, this.batchEnd(e, t)];case 2:
            n.sent(), n.label = 3;case 3:
            return [2];}
      });
    });
  }, t.prototype.onTrainBegin = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return null == this.trainBegin ? [3, 3] : [4, resolveScalarsInLogs(e)];case 1:
            return t.sent(), [4, this.trainBegin(e)];case 2:
            t.sent(), t.label = 3;case 3:
            return [2];}
      });
    });
  }, t.prototype.onTrainEnd = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return null == this.trainEnd ? [3, 3] : [4, resolveScalarsInLogs(e)];case 1:
            return t.sent(), [4, this.trainEnd(e)];case 2:
            t.sent(), t.label = 3;case 3:
            return [2];}
      });
    });
  }, t;
}(BaseCallback);function standardizeCallbacks(e) {
  return null == e ? null : e instanceof BaseCallback ? [e] : Array.isArray(e) && e[0] instanceof BaseCallback ? e : toList(e).map(function (e) {
    return new CustomCallback(e);
  });
}var CallbackConstructorRegistry = function () {
  function e() {}return e.registerCallbackConstructor = function (t, n) {
    tf_core_esm["_92" /* util */].assert(t >= 0 && Number.isInteger(t), "Verbosity level is expected to be an integer >= 0, but got " + t), e.checkForDuplicate(n), null == e.constructors[t] && (e.constructors[t] = []), e.constructors[t].push(n);
  }, e.checkForDuplicate = function (t) {
    for (var n in e.constructors) {
      e.constructors[+n].forEach(function (e) {
        if (e === t) throw new ValueError("Duplicate callback constructor.");
      });
    }
  }, e.clear = function () {
    e.constructors = {};
  }, e.createCallbacks = function (t) {
    var n = [];for (var r in e.constructors) {
      var i = +r;t >= i && n.push.apply(n, e.constructors[i]);
    }return n.map(function (e) {
      return new e();
    });
  }, e.constructors = {}, e;
}();function configureCallbacks(e, t, n, r, i, a, o, s, l, u) {
  var c = new History(),
      h = [new BaseLogger(t)].concat(CallbackConstructorRegistry.createCallbacks(n));null != e && h.push.apply(h, e), h.push(c);var p = new CallbackList(h);return p.setParams({ epochs: r, initialEpoch: i, samples: a, steps: o, batchSize: s, verbose: n, doValidation: l, metrics: u }), { callbackList: p, history: c };
}function l2Normalize(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["_80" /* sum */])(square(e), t, !0),
        r = Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["_52" /* scalar */])(epsilon()), Object(tf_core_esm["_38" /* onesLike */])(e)),
        i = Object(tf_core_esm["_72" /* sqrt */])(Object(tf_core_esm["_24" /* maximum */])(n, r));return Object(tf_core_esm["O" /* div */])(e, i);
  });
}function meanSquaredError(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return Object(tf_core_esm["_25" /* mean */])(square(Object(tf_core_esm["_79" /* sub */])(t, e)), -1);
  });
}function meanAbsoluteError(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return Object(tf_core_esm["_25" /* mean */])(Object(tf_core_esm["d" /* abs */])(Object(tf_core_esm["_79" /* sub */])(t, e)), -1);
  });
}function meanAbsolutePercentageError(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["_79" /* sub */])(e, t),
        r = Object(tf_core_esm["z" /* clipByValue */])(Object(tf_core_esm["d" /* abs */])(e), epsilon(), Number.MAX_VALUE),
        i = Object(tf_core_esm["d" /* abs */])(Object(tf_core_esm["O" /* div */])(n, r));return Object(tf_core_esm["_31" /* mul */])(getScalar(100), Object(tf_core_esm["_25" /* mean */])(i, -1));
  });
}function meanSquaredLogarithmicError(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(1),
        r = Object(tf_core_esm["z" /* clipByValue */])(t, epsilon(), Number.MAX_VALUE),
        i = Object(tf_core_esm["_15" /* log */])(Object(tf_core_esm["g" /* add */])(n, r)),
        a = Object(tf_core_esm["z" /* clipByValue */])(e, epsilon(), Number.MAX_VALUE),
        o = Object(tf_core_esm["_15" /* log */])(Object(tf_core_esm["g" /* add */])(n, a));return Object(tf_core_esm["_25" /* mean */])(square(Object(tf_core_esm["_79" /* sub */])(i, o)), -1);
  });
}function squaredHinge(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(0),
        r = getScalar(1),
        i = Object(tf_core_esm["_24" /* maximum */])(n, Object(tf_core_esm["_79" /* sub */])(r, Object(tf_core_esm["_31" /* mul */])(e, t)));return Object(tf_core_esm["_25" /* mean */])(square(i), -1);
  });
}function hinge(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(0),
        r = getScalar(1),
        i = Object(tf_core_esm["_24" /* maximum */])(n, Object(tf_core_esm["_79" /* sub */])(r, Object(tf_core_esm["_31" /* mul */])(e, t)));return Object(tf_core_esm["_25" /* mean */])(i, -1);
  });
}function categoricalHinge(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(0),
        r = getScalar(1),
        i = Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_31" /* mul */])(e, t), -1),
        a = Object(tf_core_esm["_22" /* max */])(Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["_79" /* sub */])(r, e), t), -1);return Object(tf_core_esm["_24" /* maximum */])(n, Object(tf_core_esm["g" /* add */])(r, Object(tf_core_esm["_79" /* sub */])(a, i)));
  });
}function logcosh(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(Math.log(2)),
        r = Object(tf_core_esm["_79" /* sub */])(t, e),
        i = Object(tf_core_esm["_79" /* sub */])(Object(tf_core_esm["g" /* add */])(r, Object(tf_core_esm["_68" /* softplus */])(Object(tf_core_esm["_31" /* mul */])(getScalar(-2), r))), n);return Object(tf_core_esm["_25" /* mean */])(i, -1);
  });
}function categoricalCrossentropy(e, t, n) {
  return void 0 === n && (n = !1), Object(tf_core_esm["_85" /* tidy */])(function () {
    if (n) t = Object(tf_core_esm["_67" /* softmax */])(t);else {
      var r = Object(tf_core_esm["_80" /* sum */])(t, t.shape.length - 1, !0);t = Object(tf_core_esm["O" /* div */])(t, r);
    }return t = Object(tf_core_esm["z" /* clipByValue */])(t, epsilon(), 1 - epsilon()), Object(tf_core_esm["_33" /* neg */])(Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_31" /* mul */])(e.toFloat(), Object(tf_core_esm["_15" /* log */])(t)), t.shape.length - 1));
  });
}function sparseCategoricalCrossentropy(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["Y" /* floor */])(flatten(e)).toInt(),
        r = (t = Object(tf_core_esm["z" /* clipByValue */])(t, epsilon(), 1 - epsilon())).shape;return categoricalCrossentropy(Object(tf_core_esm["_36" /* oneHot */])(n, r[r.length - 1]).reshape(r), t, !1);
  });
}function sigmoidCrossEntropyWithLogits(e, t) {
  if (!tf_core_esm["_92" /* util */].arraysEqual(e.shape, t.shape)) throw new ValueError("logits and labels must have the same shape, but got shapes " + JSON.stringify(e.shape) + " and " + JSON.stringify(t.shape));return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = t.relu(),
        r = t.abs().neg();return n.sub(t.mul(e)).add(r.exp().log1p());
  });
}function binaryCrossentropy(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n;return n = Object(tf_core_esm["z" /* clipByValue */])(t, epsilon(), 1 - epsilon()), n = Object(tf_core_esm["_15" /* log */])(Object(tf_core_esm["O" /* div */])(n, Object(tf_core_esm["_79" /* sub */])(getScalar(1), n))), Object(tf_core_esm["_25" /* mean */])(sigmoidCrossEntropyWithLogits(e, n), -1);
  });
}function kullbackLeiblerDivergence(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["z" /* clipByValue */])(e, epsilon(), 1),
        r = Object(tf_core_esm["z" /* clipByValue */])(t, epsilon(), 1);return Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_31" /* mul */])(e, Object(tf_core_esm["_15" /* log */])(Object(tf_core_esm["O" /* div */])(n, r))), -1);
  });
}function poisson(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["_15" /* log */])(Object(tf_core_esm["g" /* add */])(getScalar(epsilon()), t));return Object(tf_core_esm["_25" /* mean */])(Object(tf_core_esm["_79" /* sub */])(t, Object(tf_core_esm["_31" /* mul */])(e, n)), -1);
  });
}function cosineProximity(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = l2Normalize(e, -1),
        r = l2Normalize(t, -1),
        i = Object(tf_core_esm["_31" /* mul */])(n, r);return Object(tf_core_esm["_33" /* neg */])(Object(tf_core_esm["_80" /* sum */])(i, -1));
  });
}function get(e) {
  var t = { meanSquaredError: meanSquaredError, meanAbsoluteError: meanAbsoluteError, meanAbsolutePercentageError: meanAbsolutePercentageError, meanSquaredLogarithmicError: meanSquaredLogarithmicError, squaredHinge: squaredHinge, hinge: hinge, categoricalHinge: categoricalHinge, logcosh: logcosh, categoricalCrossentropy: categoricalCrossentropy, sparseCategoricalCrossentropy: sparseCategoricalCrossentropy, binaryCrossentropy: binaryCrossentropy, kullbackLeiblerDivergence: kullbackLeiblerDivergence, poisson: poisson, cosineProximity: cosineProximity };if ("string" == typeof e) {
    if (e in t) return t[e];var n = "Unknown loss " + e;throw e.toLowerCase().includes("softmaxcrossentropy") && (n = "Unknown loss " + e + '. Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy'), new ValueError(n);
  }return e;
}function binaryAccuracy(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = Object(tf_core_esm["_31" /* mul */])(getScalar(.5), Object(tf_core_esm["_38" /* onesLike */])(t)),
        r = cast$1(Object(tf_core_esm["_2" /* greater */])(t, n), e.dtype);return Object(tf_core_esm["_25" /* mean */])(Object(tf_core_esm["Q" /* equal */])(e, r), -1);
  });
}function categoricalAccuracy(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return cast$1(Object(tf_core_esm["Q" /* equal */])(Object(tf_core_esm["k" /* argMax */])(e, -1), Object(tf_core_esm["k" /* argMax */])(t, -1)), "float32");
  });
}function truePositives(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(1);return Object(tf_core_esm["_18" /* logicalAnd */])(e.equal(n), t.equal(n)).sum().cast("float32");
  });
}function falseNegatives(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(1),
        r = getScalar(0);return Object(tf_core_esm["_18" /* logicalAnd */])(e.equal(n), t.equal(r)).sum().cast("float32");
  });
}function falsePositives(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(1),
        r = getScalar(0);return Object(tf_core_esm["_18" /* logicalAnd */])(e.equal(r), t.equal(n)).sum().cast("float32");
  });
}function precision(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(0),
        r = truePositives(e, t),
        i = falsePositives(e, t),
        a = r.add(i);return Object(tf_core_esm["_95" /* where */])(Object(tf_core_esm["_2" /* greater */])(a, n), r.div(a), n).cast("float32");
  });
}function recall(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n = getScalar(0),
        r = truePositives(e, t),
        i = falseNegatives(e, t),
        a = r.add(i);return Object(tf_core_esm["_95" /* where */])(Object(tf_core_esm["_2" /* greater */])(a, n), r.div(a), n).cast("float32");
  });
}function binaryCrossentropy$1(e, t) {
  return binaryCrossentropy(e, t);
}function sparseCategoricalAccuracy(e, t) {
  return e.rank === t.rank && (e = e.squeeze([e.rank - 1])), (t = t.argMax(-1)).dtype !== e.dtype && (t = t.asType(e.dtype)), Object(tf_core_esm["Q" /* equal */])(e, t).asType("float32");
}var mse$1 = meanSquaredError,
    MSE$1 = meanSquaredError,
    mae$1 = meanAbsoluteError,
    MAE$1 = meanAbsoluteError,
    mape$1 = meanAbsolutePercentageError,
    MAPE$1 = meanAbsolutePercentageError,
    categoricalCrossentropy$1 = categoricalCrossentropy,
    cosine$1 = cosineProximity,
    sparseCategoricalCrossentropy$1 = sparseCategoricalCrossentropy;function get$1(e) {
  var t = { binaryAccuracy: binaryAccuracy, categoricalAccuracy: categoricalAccuracy, precision: precision, categoricalCrossentropy: categoricalCrossentropy$1, sparseCategoricalCrossentropy: sparseCategoricalCrossentropy$1, mse: mse$1, MSE: MSE$1, mae: mae$1, MAE: MAE$1, mape: mape$1, MAPE: MAPE$1, cosine: cosine$1 };if ("string" == typeof e && e in t) return t[e];if ("string" != typeof e && null != e) return e;throw new ValueError("Unknown metric " + e);
}function getOptimizer(e) {
  var t = { Adagrad: function Adagrad() {
      return tf_core_esm["_88" /* train */].adagrad(.01);
    }, Adadelta: function Adadelta() {
      return tf_core_esm["_88" /* train */].adadelta(1, .95, epsilon());
    }, Adam: function Adam() {
      return tf_core_esm["_88" /* train */].adam(.001, .9, .999, epsilon());
    }, Adamax: function Adamax() {
      return tf_core_esm["_88" /* train */].adamax(.002, .9, .999, epsilon(), 0);
    }, RMSProp: function RMSProp() {
      return tf_core_esm["_88" /* train */].rmsprop(.001, .9, 0, epsilon());
    }, SGD: function SGD() {
      return tf_core_esm["_88" /* train */].sgd(.01);
    } };if (t.adagrad = t.Adagrad, t.adadelta = t.Adadelta, t.adam = t.Adam, t.adamax = t.Adamax, t.rmsprop = t.RMSProp, t.sgd = t.SGD, e in t) return t[e]();throw new ValueError("Unknown Optimizer " + e);
}function printSummary(e, t, n, r) {
  void 0 === r && (r = console.log);var i,
      a = isModelSequentialLike(e),
      o = ["Layer (type)", "Output shape", "Param #"];if (a ? (t = t || 65, n = n || [.45, .85, 1]) : (t = t || 98, n = n || [.33, .55, .67, 1]), n[n.length - 1] <= 1 && (n = n.map(function (e) {
    return Math.floor(t * e);
  })), !a) for (var s in o.push("Receives inputs"), i = [], e.nodesByDepth) {
    i.push.apply(i, e.nodesByDepth[s]);
  }r("_".repeat(t)), printRow(o, n, r), r("=".repeat(t));for (var l = e.layers, u = 0; u < l.length; ++u) {
    a ? printLayerSummary(l[u], n, r) : printLayerSummaryWithConnections(l[u], n, i, r), r((u === l.length - 1 ? "=" : "_").repeat(t));
  }e.checkTrainableWeightsConsistency();var c = countTrainableParams(e),
      h = countParamsInWeights(e.nonTrainableWeights);r("Total params: " + (c + h)), r("Trainable params: " + c), r("Non-trainable params: " + h), r("_".repeat(t));
}function countTrainableParams(e) {
  return null != e.collectedTrainableWeights ? countParamsInWeights(e.collectedTrainableWeights) : countParamsInWeights(e.trainableWeights);
}function isModelSequentialLike(e) {
  var t = !0,
      n = [],
      r = [];for (var i in e.nodesByDepth) {
    n.push(e.nodesByDepth[i]);
  }for (var a = 0, o = n; a < o.length; a++) {
    var s = o[a];if (s.length > 1 || 1 === s.length && s[0].inboundLayers.length > 1) {
      t = !1;break;
    }r.push.apply(r, s);
  }if (t) for (var l = 0, u = e.layers; l < u.length; l++) {
    for (var c = !1, h = 0, p = u[l].inboundNodes; h < p.length; h++) {
      var d = p[h];if (-1 !== r.indexOf(d)) {
        if (c) {
          t = !1;break;
        }c = !0;
      }
    }if (!t) break;
  }return t;
}function printRow(e, t, n) {
  void 0 === n && (n = console.log);for (var r = "", i = 0; i < e.length; ++i) {
    i > 0 && (r = r.slice(0, r.length - 1) + " "), r = (r += e[i]).slice(0, t[i]), r += " ".repeat(t[i] - r.length);
  }n(r);
}function printLayerSummary(e, t, n) {
  var r;try {
    r = JSON.stringify(e.outputShape);
  } catch (e) {
    r = "multiple";
  }printRow([e.name + " (" + e.getClassName() + ")", r, e.countParams().toString()], t, n);
}function printLayerSummaryWithConnections(e, t, n, r) {
  var i;try {
    i = JSON.stringify(e.outputShape);
  } catch (e) {
    i = "multiple";
  }for (var a = [], o = 0, s = e.inboundNodes; o < s.length; o++) {
    var l = s[o];if (!(null != n && n.length > 0 && -1 === n.indexOf(l))) for (var u = 0; u < l.inboundLayers.length; ++u) {
      var c = l.inboundLayers[u].name,
          h = l.nodeIndices[u],
          p = l.tensorIndices[u];a.push(c + "[" + h + "][" + p + "]");
    }
  }var d = e.name,
      g = e.getClassName(),
      f = 0 === a.length ? "" : a[0];printRow([d + " (" + g + ")", i, e.countParams().toString(), f], t, r);for (u = 1; u < a.length; ++u) {
    printRow(["", "", "", a[u]], t, r);
  }
}function deserialize(e, t, n) {
  return void 0 === t && (t = {}), void 0 === n && (n = !1), deserializeKerasObject(e, tf_core_esm["_56" /* serialization */].SerializationMap.getMap().classNameMap, t, "layer", n);
}function isArrayItemInputOrOutputName(e, t, n) {
  return ("inboundNodes" === e || "outputLayers" === e || "inputLayers" === e) && 0 === t && "string" == typeof n;
}function convertPythonicToTs(e, t) {
  if (null === e) return null;if ("string" == typeof e) return toCamelCase(e);if ("number" == typeof e || "boolean" == typeof e) return e;if (e instanceof Array) {
    for (var n = [], r = e.length, i = 0; i < r; ++i) {
      var a = e[i];isArrayItemInputOrOutputName(t, i, a) ? n.push(a) : n.push(convertPythonicToTs(a, t));
    }return n;
  }for (var o = {}, s = 0, l = Object.keys(e); s < l.length; s++) {
    var u = l[s],
        c = e[u];if ("name" === u && "string" == typeof c) o[u] = c;else {
      var h = toCamelCase(u);o[h] = convertPythonicToTs(c, h);
    }
  }return o;
}function convertTsToPythonic(e, t) {
  if (null === e || void 0 === e) return null;if ("string" == typeof e) return toSnakeCase(e);if ("number" == typeof e || "boolean" == typeof e) return e;if (e instanceof Array) {
    for (var n = [], r = e.length, i = 0; i < r; ++i) {
      var a = e[i];isArrayItemInputOrOutputName(t, i, a) ? n.push(a) : n.push(convertTsToPythonic(a, t));
    }return n;
  }for (var o = {}, s = 0, l = Object.keys(e); s < l.length; s++) {
    var u = l[s],
        c = e[u],
        h = toSnakeCase(u);o[h] = "name" !== u && "className" !== u || "string" != typeof c ? convertTsToPythonic(c, u) : c;
  }return o;
}var version = "0.9.2";function assertFeedCompatibility(e, t) {
  if (null == e.dtype || e.dtype === t.dtype) return t;try {
    return Object(tf_core_esm["x" /* cast */])(t, e.dtype);
  } catch (n) {
    throw new ValueError("The dtype of the feed (" + t.dtype + ") can not be cast to the dtype of the key '" + e.name + "' (" + e.dtype + ").");
  }
}var FeedDict = function () {
  function e(t) {
    if (this.id2Value = {}, this.id2Mask = {}, this.name2Id = {}, t instanceof e) for (var n in t.id2Value) {
      this.id2Value[n] = t.id2Value[n], n in t.id2Mask && (this.id2Mask[n] = t.id2Mask[n]);
    } else {
      if (null == t) return;for (var r = 0, i = t; r < i.length; r++) {
        var a = i[r];this.add(a.key, a.value);
      }
    }
  }return e.prototype.add = function (e, t, n) {
    if (null != this.id2Value[e.id]) throw new ValueError("Duplicate key: name=" + e.name + ", id=" + e.id);return this.id2Value[e.id] = assertFeedCompatibility(e, t), this.name2Id[e.name] = e.id, null != n && (this.id2Mask[e.id] = n), this;
  }, e.prototype.addFeed = function (e) {
    this.add(e.key, e.value);
  }, e.prototype.hasKey = function (e) {
    return null != this.id2Value[e.id];
  }, e.prototype.names = function () {
    return Object.keys(this.name2Id);
  }, e.prototype.getValue = function (e) {
    if (e instanceof SymbolicTensor) {
      if (null == this.id2Value[e.id]) throw new ValueError("Nonexistent key: " + e.name);return this.id2Value[e.id];
    }var t = this.name2Id[e];if (null == t) throw new ValueError("Feed dict has no SymbolicTensor name: " + e);return this.id2Value[t];
  }, e.prototype.getMask = function (e) {
    if (e instanceof SymbolicTensor) {
      if (null == this.id2Value[e.id]) throw new ValueError("Nonexistent key: " + e.name);return this.id2Mask[e.id];
    }var t = this.name2Id[e];if (null == t) throw new ValueError("Feed dict has no SymbolicTensor name: " + e);return this.id2Mask[t];
  }, e.prototype.disposeMasks = function () {
    null != this.id2Mask && Object(tf_core_esm["N" /* dispose */])(this.id2Mask);
  }, e;
}(),
    cachedSorted = {},
    cachedRecipientCounts = {};function execute(e, t, n, r) {
  for (var i = null != n && n.training, a = Array.isArray(e), o = a ? e : [e], s = o.map(function (e) {
    return e.name;
  }), l = [], u = t.names(), c = 0, h = s; c < h.length; c++) {
    var p = h[c];-1 !== u.indexOf(p) ? l.push(t.getValue(p)) : l.push(null);
  }null != r && (r.maxNumTensors = -1 / 0, r.minNumTensors = 1 / 0);var d,
      g,
      f = s.join(",") + "|" + t.names().join(",");if (null == cachedSorted[f]) {
    var m = getTopologicalSortAndRecipientCounts(o, t);d = m.sorted, g = m.recipientCounts, cachedSorted[f] = d, cachedRecipientCounts[f] = g;
  }d = cachedSorted[f], g = {}, i || _extends(g, cachedRecipientCounts[f]);for (var y = new FeedDict(t), v = 0; v < d.length; ++v) {
    if (null != r) {
      var b = Object(tf_core_esm["_26" /* memory */])().numTensors;b > r.maxNumTensors && (r.maxNumTensors = b), b < r.minNumTensors && (r.minNumTensors = b);
    }var w = d[v],
        z = w.sourceLayer;if (!(z instanceof InputLayer)) {
      for (var S = [], I = [], A = [], _ = !1, C = 0, N = w.inputs; C < N.length; C++) {
        var E = N[C],
            k = y.getValue(E),
            x = y.getMask(E);S.push(k), I.push(x), null != x && (_ = !0), i || (g[E.name]--, 0 !== g[E.name] || t.hasKey(E) || -1 !== s.indexOf(E.name) || k.isDisposed || A.push(k));
      }_ && ((n = n || {}).mask = I[0]);var L = toList(z.apply(S, n)),
          T = null;z.supportsMasking && (T = z.computeMask(S, I));for (var D = getNodeOutputs(w), O = Array.isArray(D) ? D : [D], R = 0; R < O.length; ++R) {
        y.hasKey(O[R]) || y.add(O[R], L[R], Array.isArray(T) ? T[0] : T);var M = s.indexOf(O[R].name);-1 !== M && (l[M] = L[R]);
      }i || Object(tf_core_esm["N" /* dispose */])(A);
    }
  }return y.disposeMasks(), a ? l : l[0];
}function getTopologicalSortAndRecipientCounts(e, t) {
  tf_core_esm["_92" /* util */].assert(null != e && e.length > 0, "Exepcted at least one fetch, got none");var n = [],
      r = {};if (1 === e.length) {
    var i = getTopologicalSortAndRecipientCountsForOneFetch(e[0], t);n = i.sorted, r = i.recipientMap;
  } else for (var a = new Set(), o = 0, s = e; o < s.length; o++) {
    for (var l = getTopologicalSortAndRecipientCountsForOneFetch(s[o], t), u = l.sorted, c = l.recipientMap, h = 0, p = u; h < p.length; h++) {
      var d = p[h];a.has(d.name) || (n.push(d), a.add(d.name));
    }var g = function g(e) {
      null == r[e] && (r[e] = new Set()), c[e].forEach(function (t) {
        return r[e].add(t);
      });
    };for (var f in c) {
      g(f);
    }
  }return { sorted: n, recipientCounts: recipientMap2Counts(r) };
}function recipientMap2Counts(e) {
  var t = {};for (var n in e) {
    t[n] = e[n].size;
  }return t;
}function getTopologicalSortAndRecipientCountsForOneFetch(e, t) {
  for (var n = new Set(), r = [], i = {}, a = 0, o = t.names(); a < o.length; a++) {
    var s = o[a];n.add(s);
  }var l = [],
      u = [];for (l.push(e); l.length > 0;) {
    var c = l[l.length - 1];if (n.has(c.name)) l.pop();else {
      var h = u[u.length - 1] === l.length - 1;if (0 === c.inputs.length || h) l.pop(), r.push(c), n.add(c.name), h && u.pop();else {
        u.push(l.length - 1);for (var p = 0, d = c.inputs; p < d.length; p++) {
          var g = d[p];null == i[g.name] && (i[g.name] = new Set()), i[g.name].add(c.name), n.has(g.name) || l.push(g);
        }
      }
    }
  }return { sorted: r, recipientMap: i };
}function getNodeOutputs(e) {
  var t;if (1 === e.sourceLayer.inboundNodes.length) t = e.sourceLayer.output;else {
    for (var n = null, r = 0; r < e.sourceLayer.inboundNodes.length; ++r) {
      for (var i = 0, a = e.sourceLayer.inboundNodes[r].outputTensors; i < a.length; i++) {
        if (a[i].id === e.id) {
          n = r;break;
        }
      }
    }t = e.sourceLayer.getOutputAt(n);
  }return t;
}function preprocessWeightsForLoading(e, t, n, r) {
  if (!n.startsWith("2.")) throw new ValueError("Unsupported Keras version in weights being loaded: " + n);return t;
}function loadTensor(e, t, n) {
  var r = stringToDType(e);return tf_core_esm["c" /* Tensor */].make(t, { values: 0 === t.length ? n : tf_core_esm["_92" /* util */].flatten(n) }, r);
}function loadWeightsFromJson(e, t, n) {
  void 0 === n && (n = !1);for (var r = e.keras_version, i = e.backend, a = t.map(function (e) {
    return e.name;
  }), o = {}, s = 0, l = t; s < l.length; s++) {
    null != (b = l[s]).name && (null == o[b.name] && (o[b.name] = []), o[b.name].push(b));
  }for (var u = e.weights, c = [], h = 0; h < a.length; ++h) {
    var p = a[h],
        d = u[p];null == d && (d = []);for (var g = [], f = 0; f < d.length; ++f) {
      var m = d[f];g.push(new LayerVariable(loadTensor(m.dtype, m.shape, m.value)));
    }for (var y = 0, v = o[p]; y < v.length; y++) {
      var b,
          w = (b = v[y]).weights;if ((g = preprocessWeightsForLoading(b, g, r, i)).length !== w.length) {
        if (!n) throw new ValueError("Layer #" + h + ' (named "' + b.name + '") expects ' + w.length + " weight(s), but the saved weights have " + g.length + " element(s).");console.warn("Skipping loading of weights of layer " + b.name + " due to mismatch in number of weights: (" + g.length + " vs " + w.length + ").");
      }for (var z = 0; z < g.length; ++z) {
        !n || tf_core_esm["_92" /* util */].arraysEqual(w[z].shape, g[z].shape) ? c.push([w[z], g[z].read()]) : console.warn("Skipping loading of weights for layer " + b.name + " due to mismatch in shape (" + w[z].shape + " vs " + g[z].shape + ")");
      }
    }
  }batchSetValue(c);
}function loadWeightsFromNamedTensorMap(e, t, n) {
  void 0 === n && (n = !0);for (var r = {}, i = 0, a = 0, o = t; a < o.length; a++) {
    for (var s = 0, l = o[a].weights; s < l.length; s++) {
      var u = l[s];if (null != r[u.originalName]) throw new ValueError("Duplicate weight name: " + u.originalName);r[u.originalName] = u, i++;
    }
  }var c = [];for (var h in e) {
    if (null != r[h]) c.push([r[h], e[h]]);else if (n) throw new ValueError("Provided weight data has no target variable: " + h);delete r[h];
  }if (n) {
    var p = [];for (var d in r) {
      p.push(d);
    }if (p.length > 0) throw new ValueError(p.length + " of " + i + " weights are not set: " + p);
  }batchSetValue(c);
}var Container = function (e) {
  function t(n) {
    var r = e.call(this, {}) || this;if (r.containerNodes = new Set(), r.name = n.name, null == r.name) {
      var i = r.getClassName().toLowerCase();r.name = getUid(i);
    }if (r.supportsMasking = !1, r.trainable = !0, r.updatable = !0, Array.isArray(n.inputs) ? r.inputs = n.inputs.slice() : r.inputs = [n.inputs], Array.isArray(n.outputs) ? r.outputs = n.outputs.slice() : r.outputs = [n.outputs], unique(r.inputs).length !== r.inputs.length) throw new ValueError("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: " + r.inputs.map(function (e) {
      return e.name;
    }));unique(r.outputs).length !== r.outputs.length && console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: " + r.outputs.map(function (e) {
      return e.name;
    })), r.inputLayers = [], r.inputLayersNodeIndices = [], r.inputLayersTensorIndices = [], r.outputLayers = [], r.outputLayersNodeIndices = [], r.outputLayersTensorIndices = [], r.layers = [];for (var a = 0, o = r.outputs; a < o.length; a++) {
      var s = (C = o[a]).sourceLayer,
          l = C.nodeIndex,
          u = C.tensorIndex;r.outputLayers.push(s), r.outputLayersNodeIndices.push(l), r.outputLayersTensorIndices.push(u);
    }for (var c = 0, h = r.inputs; c < h.length; c++) {
      s = (C = h[c]).sourceLayer, l = C.nodeIndex, u = C.tensorIndex;assert(0 === l, "input layer has >1 nodes"), assert(0 === u, "input layer has >1 tensors"), r.inputLayers.push(s), r.inputLayersNodeIndices.push(l), r.inputLayersTensorIndices.push(u);
    }r.inputNames = [], r.outputNames = [], r.feedInputShapes = [], r.feedInputNames = [], r.feedOutputNames = [];for (var p = 0; p < r.inputLayers.length; p++) {
      if (!((s = r.inputLayers[p]) instanceof InputLayer)) throw new TypeError("Input layers to a Model must be InputLayer objects. Received inputs: " + n.inputs + ". Input " + p + " (0-based) originates from layer type " + s.getClassName() + ".");r.inputNames.push(s.name), r.feedInputShapes.push(s.batchInputShape), r.feedInputNames.push(s.name);
    }for (var d = 0, g = r.outputLayers; d < g.length; d++) {
      s = g[d];r.outputNames.push(s.name);
    }r.internalInputShapes = r.inputs.map(function (e) {
      return e.shape;
    }), r.internalOutputShapes = r.outputs.map(function (e) {
      return e.shape;
    });for (var f = {}, m = {}, y = {}, v = {}, b = {}, w = [], z = function z(e, n, i, a, o, s) {
      null != a && null != o && null != s || (a = e.sourceLayer, o = e.nodeIndex, s = e.tensorIndex);var l = a.inboundNodes[o];if (-1 !== i.indexOf(l)) throw new RuntimeError("The tensor " + e.name + ' at layer "' + a.name + '" is part of a cycle.');if (-1 === n.indexOf(l)) {
        r.containerNodes.add(t.nodeKey(a, o)), (a.id in b) || (b[a.id] = Object.keys(b).length), -1 === i.indexOf(l) && i.push(l);for (var u = l.inboundLayers.length, c = 0; c < u; c++) {
          var h = l.inputTensors[c],
              p = l.inboundLayers[c],
              d = l.nodeIndices[c],
              g = l.tensorIndices[c];z(h, n, i, p, d, g);
        }for (n.push(l); i.indexOf(l) >= 0;) {
          i.splice(i.indexOf(l), 1);
        }w.push(l);
      }
    }, S = [], I = [], A = 0, _ = r.outputs; A < _.length; A++) {
      var C = _[A];z(C, S, I);
    }for (var N = 0, E = w.slice().reverse(); N < E.length; N++) {
      m[(K = E[N]).id] = K, K.id in f || (f[K.id] = 0);var k = f[K.id],
          x = null == y[K.outboundLayer.id] ? 0 : y[K.outboundLayer.id];k = Math.max(k, x), y[K.outboundLayer.id] = k, v[K.outboundLayer.id] = K.outboundLayer, f[K.id] = k;for (p = 0; p < K.inboundLayers.length; p++) {
        var L = K.inboundLayers[p],
            T = (l = K.nodeIndices[p], L.inboundNodes[l]),
            D = null == f[T.id] ? 0 : f[T.id];f[T.id] = Math.max(k + 1, D), m[T.id] = T;
      }
    }var O = {};for (var R in f) {
      (k = f[R]) in O || (O[k] = []), O[k].push(m[R]);
    }var M = {};for (var P in y) {
      (k = y[P]) in M || (M[k] = []), M[k].push(v[P]);
    }var F = Object.keys(M).map(function (e) {
      return parseInt(e, 10);
    }).sort(reverseNumberCompare);r.layers = [];for (var V = 0, B = F; V < B.length; V++) {
      var U = M[k = B[V]];U.sort(function (e, t) {
        var n = b[e.id],
            r = b[t.id];return n < r ? -1 : n > r ? 1 : 0;
      });for (var j = 0, W = U; j < W.length; j++) {
        s = W[j];r.layers.push(s);
      }
    }r.layersByDepth = M, F = Object.keys(O).map(function (e) {
      return parseInt(e, 10);
    }).sort(reverseNumberCompare);for (var $ = r.inputs.slice(), q = [], G = 0, J = F; G < J.length; G++) {
      for (var H = 0, Z = O[k = J[G]]; H < Z.length; H++) {
        var K;if (null != (s = (K = Z[H]).outboundLayer)) {
          for (var Y = 0, X = K.inputTensors; Y < X.length; Y++) {
            C = X[Y];if (-1 === $.indexOf(C)) throw new RuntimeError("Graph disconnected: cannot obtain value for tensor " + C + ' at layer "' + s.name + '". The following previous layers were accessed without issue: ' + q);
          }for (var Q = 0, ee = K.outputTensors; Q < ee.length; Q++) {
            C = ee[Q];$.push(C);
          }q.push(s.name);
        }
      }
    }r.nodesByDepth = O;for (var te = r.layers.map(function (e) {
      return e.name;
    }), ne = function ne(e) {
      var t = te.filter(function (t) {
        return t === e;
      }).length;if (1 !== t) throw new RuntimeError('The name "' + e + '" is used ' + t + " times in the model. All layer names should be unique. Layer names: " + JSON.stringify(te));
    }, re = 0, ie = te; re < ie.length; re++) {
      ne(ie[re]);
    }return r.outboundNodes = [], r.inboundNodes = [], new Node({ outboundLayer: r, inboundLayers: [], nodeIndices: [], tensorIndices: [], inputTensors: r.inputs, outputTensors: r.outputs, inputMasks: r.inputs.map(function (e) {
        return null;
      }), outputMasks: r.outputs.map(function (e) {
        return null;
      }), inputShapes: r.inputs.map(function (e) {
        return e.shape;
      }), outputShapes: r.outputs.map(function (e) {
        return e.shape;
      }) }), r.built = !0, r._refCount = 1, r;
  }return __extends(t, e), t.prototype.assertNotDisposed = function () {
    if (0 === this._refCount) throw new Error("Container '" + this.name + "' is already disposed.");
  }, t.prototype.dispose = function () {
    this.assertNotDisposed();var e = { refCountAfterDispose: null, numDisposedVariables: 0 };if (0 == --this._refCount) for (var t = 0, n = this.layers; t < n.length; t++) {
      var r = n[t];e.numDisposedVariables += r.dispose().numDisposedVariables;
    }return e.refCountAfterDispose = this._refCount, e;
  }, Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      if (this._trainableWeights.length > 0) throw new ValueError("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");if (!this.trainable) return [];for (var e = [], t = 0, n = this.layers; t < n.length; t++) {
        var r = n[t];e = e.concat(r.trainableWeights);
      }return e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      for (var e = [], t = 0, n = this.layers; t < n.length; t++) {
        var r = n[t];e.push.apply(e, r.nonTrainableWeights);
      }if (!this.trainable) {
        for (var i = [], a = 0, o = this.layers; a < o.length; a++) {
          r = o[a];i.push.apply(i, r.trainableWeights);
        }return i.concat(e);
      }return e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "weights", { get: function get() {
      return this.trainableWeights.concat(this.nonTrainableWeights);
    }, enumerable: !0, configurable: !0 }), t.prototype.loadWeights = function (e, t, n, r) {
    void 0 === t && (t = !1), void 0 === n && (n = !1), void 0 === r && (r = !0), n ? loadWeightsFromNamedTensorMap(e, this.layers, r) : loadWeightsFromJson(e, this.layers, t);
  }, t.prototype.updatedConfig = function () {
    var e = this.getConfig();return { className: this.getClassName(), config: e, kerasVersion: "tfjs-layers " + version, backend: "TensorFlow.js" };
  }, t.prototype.toJSON = function (e, t) {
    void 0 === t && (t = !0);var n = convertTsToPythonic(this.updatedConfig());return t ? JSON.stringify(n) : n;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      e = toList(e);for (var r = new FeedDict(), i = 0; i < n.inputs.length; ++i) {
        r.add(n.inputs[i], e[i]);
      }return execute(n.outputs, r, t);
    });
  }, t.prototype.computeMask = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var r;return e = toList(e), r = null == t ? pyListRepeat(null, e.length) : toList(t), n.runInternalGraph(e, r)[1];
    });
  }, t.prototype.computeOutputShape = function (e) {
    var t = normalizeShapeList(e);if (t.length !== this.inputLayers.length) throw new ValueError("Invalid inputShape argument " + e + ": model has " + this.inputLayers.length + " tensor inputs.");for (var n = {}, r = 0; r < t.length; r++) {
      var i = this.inputLayers[r],
          a = t[r];n[I = i.name + "_0_0"] = a;
    }var o = Object.keys(this.nodesByDepth).map(function (e) {
      return parseInt(e, 10);
    }).sort(reverseNumberCompare);if (o.length > 1) for (var s = 0, l = o; s < l.length; s++) {
      for (var u = l[s], c = 0, h = this.nodesByDepth[u]; c < h.length; c++) {
        var p = h[c];i = p.outboundLayer;if (-1 === this.inputLayers.map(function (e) {
          return e.id;
        }).indexOf(i.id)) {
          for (var d = [], g = 0; g < p.inboundLayers.length; g++) {
            var f = p.inboundLayers[g],
                m = p.nodeIndices[g],
                y = p.tensorIndices[g],
                v = n[I = f.name + "_" + m + "_" + y];d.push(v);
          }var b = normalizeShapeList(i.computeOutputShape(singletonOrArray(d))),
              w = i.inboundNodes.indexOf(p);for (g = 0; g < b.length; g++) {
            n[I = i.name + "_" + w + "_" + g] = b[g];
          }
        }
      }
    }var z = [],
        S = [];for (r = 0; r < this.outputLayers.length; r++) {
      i = this.outputLayers[r], w = this.outputLayersNodeIndices[r], y = this.outputLayersTensorIndices[r];var I = i.name + "_" + w + "_" + y;S.push(I);
    }for (r = 0; r < S.length; r++) {
      var A = S[r];assert(A in n), z.push(n[A]);
    }return singletonOrArray(z);
  }, t.prototype.runInternalGraph = function (e, t) {
    null == t && (t = pyListRepeat(null, e.length));for (var n = {}, r = 0; r < this.inputs.length; ++r) {
      var i = this.inputs[r],
          a = e[r],
          o = t[r];n[i.id] = [a, o];
    }for (var s = 0, l = Object.keys(this.nodesByDepth).map(function (e) {
      return parseInt(e, 10);
    }).sort(reverseNumberCompare); s < l.length; s++) {
      for (var u = l[s], c = 0, h = this.nodesByDepth[u]; c < h.length; c++) {
        for (var p = h[c], d = p.outboundLayer, g = p.inputTensors, f = p.outputTensors, m = new Array(), y = 0, v = g; y < v.length; y++) {
          (i = v[y]).id in n && m.push(n[i.id]);
        }if (m.length === g.length) {
          var b = {},
              w = void 0,
              z = void 0,
              S = void 0,
              I = void 0;if (null != p.callArgs && (b = p.callArgs), 1 === m.length) {
            var A = m[0],
                _ = A[0],
                C = A[1];null == b.mask && (b.mask = C), S = toList(d.call(_, b)), I = toList(d.computeMask(_, C)), w = [_], z = [C];
          } else w = m.map(function (e) {
            return e[0];
          }), z = m.map(function (e) {
            return e[1];
          }), null == b.mask && (b.mask = z), S = toList(d.call(w, b)), I = toList(d.computeMask(w, z));if (d.activityRegularizer) throw new NotImplementedError("Model invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");for (r = 0; r < f.length; ++r) {
            i = f[r], a = S[r], o = I[r];n[i.id] = [a, o];
          }
        }
      }
    }for (var N = [], E = [], k = [], x = 0, L = this.outputs; x < L.length; x++) {
      assert((i = L[x]).id in n, "Could not compute output " + i.name + " : " + i.id);var T = n[i.id],
          D = T[0];o = T[1];k.push(D.shape), N.push(D), E.push(o);
    }return [N, E, k];
  }, t.prototype.buildNodeConversionMap = function (e) {
    for (var n, r = {}, i = 0, a = this.layers; i < a.length; i++) {
      var o = a[i];n = o instanceof t ? 1 : 0;for (var s = 0; s < o.inboundNodes.length; s++) {
        var l = t.nodeKey(o, s);this.containerNodes.has(l) && (r[l] = n, n += 1);
      }
    }return r;
  }, t.prototype.getLayer = function (e, t) {
    if (null != t) {
      if (this.layers.length <= t) throw new ValueError("Was asked to retrieve layer at index " + t + ", but model only has " + this.layers.length + " layer(s).");return this.layers[t];
    }if (null == e) throw new ValueError("Provide either a layer name or layer index");for (var n = 0, r = this.layers; n < r.length; n++) {
      var i = r[n];if (i.name === e) return i;
    }throw new ValueError("No such layer: " + e);
  }, t.prototype.calculateLosses = function () {
    var e = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var n = [], r = 0, i = e.layers; r < i.length; r++) {
        for (var a = i[r], o = 0; o < a.inboundNodes.length; ++o) {
          var s = t.nodeKey(a, o);e.containerNodes.has(s) && n.push.apply(n, a.calculateLosses());
        }
      }return n;
    });
  }, t.prototype.getConfig = function () {
    for (var e = { name: this.name }, n = this.buildNodeConversionMap(this.layers), r = [], i = 0, a = this.layers; i < a.length; i++) {
      for (var o = (b = a[i]).getClassName(), s = b.getConfig(), l = [], u = 0; u < b.inboundNodes.length; u++) {
        var c = b.inboundNodes[u],
            h = t.nodeKey(b, u),
            p = {};if (this.containerNodes.has(h)) {
          if (c.callArgs) try {
            JSON.stringify(c.callArgs), p = c.callArgs;
          } catch (e) {
            console.warn("Layer " + b.name + " was passed non-serializable keyword arguments: " + c.callArgs + ". They will not be included in the serialized model (and thus will be missing at deserialization time)."), p = {};
          }if (c.inboundLayers.length > 0) {
            for (var d = [], g = 0; g < c.inboundLayers.length; g++) {
              var f = c.inboundLayers[g],
                  m = c.nodeIndices[g],
                  y = c.tensorIndices[g];null == (z = n[t.nodeKey(f, m)]) && (z = 0), d.push([f.name, z, y, p]);
            }l.push(d);
          }
        }
      }r.push({ name: b.name, className: o, config: s, inboundNodes: l });
    }e.layers = r;var v = [];for (g = 0; g < this.inputLayers.length; g++) {
      var b = this.inputLayers[g];m = this.inputLayersNodeIndices[g], h = t.nodeKey(b, m);if (this.containerNodes.has(h)) {
        null !== (z = n[h]) && void 0 !== z || (z = 0);y = this.inputLayersTensorIndices[g];v.push([b.name, z, y]);
      }
    }e.inputLayers = v;var w = [];for (g = 0; g < this.outputLayers.length; g++) {
      b = this.outputLayers[g], m = this.outputLayersNodeIndices[g], h = t.nodeKey(b, m);if (this.containerNodes.has(h)) {
        var z;null !== (z = n[h]) && void 0 !== z || (z = 0);y = this.outputLayersTensorIndices[g];w.push([b.name, z, y]);
      }
    }return e.outputLayers = w, e;
  }, t.fromConfig = function (e, t, n, r) {
    void 0 === n && (n = {}), void 0 === r && (r = !1);var i = {},
        a = {};function o(e, t) {
      e.name in a ? a[e.name].push(t) : a[e.name] = [t];
    }function s(e, t) {
      for (var n, r = [], a = 0, s = t; a < s.length; a++) {
        var l = s[a],
            u = l[0],
            c = l[1],
            h = l[2];if (3 === l.length) n = {};else {
          if (4 !== l.length) throw new ValueError("Improperly formatted model config for layer " + JSON.stringify(e) + ": " + JSON.stringify(l));n = l[3];
        }if (!(u in i)) return void o(e, t);var p = i[u];if (p.inboundNodes.length <= c) return void o(e, t);var d = p.inboundNodes[c];r.push(d.outputTensors[h]);
      }r.length > 0 && e.apply(singletonOrArray(r), n);
    }function l(e) {
      var n = e.name,
          a = deserialize(e, null != t.customObjects ? t.customObjects : {});a.setFastWeightInitDuringBuild(r), i[n] = a;for (var s = 0, l = e.inboundNodes; s < l.length; s++) {
        var u = l[s];if (!(u instanceof Array)) throw new ValueError("Corrupted configuration, expected array for nodeData: " + u);o(a, u);
      }
    }for (var u = t.name, c = t.layers, h = 0, p = c; h < p.length; h++) {
      l(f = p[h]);
    }for (; !isObjectEmpty(a);) {
      for (var d = 0, g = c; d < g.length; d++) {
        var f = g[d];if ((k = i[f.name]).name in a) {
          var m = a[k.name];delete a[k.name];for (var y = 0, v = m; y < v.length; y++) {
            s(k, v[y]);
          }
        }
      }
    }for (var b = [], w = [], z = 0, S = t.inputLayers; z < S.length; z++) {
      var I = (f = S[z])[0],
          A = f[1],
          _ = f[2];assert(I in i);var C = (k = i[I]).inboundNodes[A].outputTensors;b.push(C[_]);
    }for (var N = 0, E = t.outputLayers; N < E.length; N++) {
      I = (f = E[N])[0], A = f[1], _ = f[2];assert(I in i);var k;C = (k = i[I]).inboundNodes[A].outputTensors;w.push(C[_]);
    }return new e({ inputs: b, outputs: w, name: u });
  }, Object.defineProperty(t.prototype, "stateful", { get: function get() {
      if (this._stateful) throw new ValueError("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");for (var e = 0, t = this.layers; e < t.length; e++) {
        if (t[e].stateful) return !0;
      }return !1;
    }, enumerable: !0, configurable: !0 }), t.prototype.resetStates = function () {
    var e = this;Object(tf_core_esm["_85" /* tidy */])(function () {
      e.layers.forEach(function (e) {
        e.stateful && e.resetStates();
      });
    });
  }, t;
}(Layer),
    DEFAULT_VALIDATION_BATCH_SIZE = 32;function standardizeDataIteratorOutput(e, t) {
  if (e.outputs.length > 1) throw new NotImplementedError("Support for training a model with multiple output tensors with a dataset object is not implemented yet.");tf_core_esm["_92" /* util */].assert(Array.isArray(t) && 2 === t.length, "Dataset iterator for fitDataset() is expected to generate an Array of length 2: `[xs, ys]`, but instead generates " + t);var n = (t = t)[1],
      r = t[0];if (r instanceof tf_core_esm["c" /* Tensor */]) return tf_core_esm["_92" /* util */].assert(1 === e.inputs.length, "Model has multiple " + e.inputs.length + " inputs, hence it expects the input dataset to generate a dictionary of tensors  (with keys " + JSON.stringify(e.inputNames) + ", but received a single tensor."), tf_core_esm["_92" /* util */].assert(r.shape[0] === n.shape[0], "Mismatch in batch size between x and y tensors (" + r.shape[0] + " vs. " + n.shape[0] + ")"), [r, n];var i = void 0;r = r;for (var a = [], o = 0, s = e.inputNames; o < s.length; o++) {
    var l = s[o];if (null == r[l]) throw new ValueError("The feature data generated by the dataset lacks the required input key '" + l + "'.");a.push(r[l]), null == i ? i = r[l].shape[0] : tf_core_esm["_92" /* util */].assert(r[l].shape[0] === i, "Mismatch in batch size between x and y tensors (" + r[l].shape[0] + " vs. " + n.shape[0] + ")");
  }return a.concat(n);
}function standardizeTensorValidationData(e) {
  if (3 === e.length) throw new NotImplementedError("Validation with sample weights is not implemented yet.");return { xs: e[0], ys: e[1] };
}function fitDataset(e, t, n) {
  return __awaiter(this, void 0, void 0, function () {
    var r, i, a, o, s, l, u, c, h, p, d, g, f, m, y, v, b, w, z, S, I, A, _, C, N, E;return __generator(this, function (k) {
      switch (k.label) {case 0:
          if (r = null != n.batchesPerEpoch, tf_core_esm["_92" /* util */].assert(null != e.optimizer, "You must compile a model before training/testing. Use Model.compile(modelCompileConfig)."), tf_core_esm["_92" /* util */].assert(null != n, "For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call."), tf_core_esm["_92" /* util */].assert(null != n.epochs && n.epochs > 0 && Number.isInteger(n.epochs), "For fitDataset(), config.epochs is expected to be a positive integer, but got " + n.epochs), tf_core_esm["_92" /* util */].assert(!r || n.batchesPerEpoch > 0 && Number.isInteger(n.batchesPerEpoch), "For fitDataset(), config.batchesPerEpoch is expected to be a positive integer if specified, but got " + n.batchesPerEpoch), tf_core_esm["_92" /* util */].assert(null == n.validationSplit, "`validationSplit` is not supported by `fitDataset()`. Use validationData instead."), e.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");e.isTraining = !0, k.label = 1;case 1:
          return k.trys.push([1,, 22, 23]), i = null != n.validationData, a = void 0, o = void 0, i && (isDatasetObject(n.validationData) ? tf_core_esm["_92" /* util */].assert(null == n.validationBatches || n.validationBatches > 0 && Number.isInteger(n.validationBatches), "For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, but got " + n.validationBatches) : (s = standardizeTensorValidationData(n.validationData), a = s.xs, o = s.ys)), l = e.makeTrainFunction(), u = e.getDedupedMetricsNames(), c = void 0, c = i ? u.slice().concat(u.map(function (e) {
            return "val_" + e;
          })) : u.slice(), h = standardizeCallbacks(n.callbacks), p = configureCallbacks(h, n.yieldEvery, n.verbose, n.epochs, null, null, n.batchesPerEpoch, null, i, c), d = p.callbackList, g = p.history, d.setModel(e), e.history = g, [4, d.onTrainBegin()];case 2:
          return k.sent(), e.stopTraining_ = !1, f = null == n.initialEpoch ? 0 : n.initialEpoch, [4, t.iterator()];case 3:
          m = k.sent(), k.label = 4;case 4:
          return f < n.epochs ? (y = {}, [4, d.onEpochBegin(f)]) : [3, 19];case 5:
          return k.sent(), v = 0, b = 0, r ? [3, 7] : [4, t.iterator()];case 6:
          m = k.sent(), k.label = 7;case 7:
          return !r || v < n.batchesPerEpoch ? [4, m.next()] : [3, 17];case 8:
          return w = k.sent(), r && w.done ? (console.warn("You provided `batchesPerEpoch` as " + n.batchesPerEpoch + ", but your dataset iterator ran out of data after " + v + " batches; interrupting training. Make sure that your dataset can generate at least `batchesPerEpoch * epochs` batches (in this case, " + n.batchesPerEpoch * n.epochs + " batches). You may need to use the repeat() function when building your dataset."), [3, 17]) : null == w.value ? [3, 11] : (z = standardizeDataIteratorOutput(e, w.value), (S = {}).batch = b, S.size = z[0].shape[0], [4, d.onBatchBegin(b, S)]);case 9:
          for (k.sent(), I = l(z), Object(tf_core_esm["N" /* dispose */])(z), E = 0; E < u.length; ++E) {
            A = u[E], _ = I[E], S[A] = _, Object(tf_core_esm["_8" /* keep */])(_);
          }return [4, d.onBatchEnd(b, S)];case 10:
          k.sent(), disposeTensorsInLogs(S), b++, v++, k.label = 11;case 11:
          return (r ? v >= n.batchesPerEpoch : w.done) ? i ? (C = void 0, isDatasetObject(n.validationData) ? (N = toList, [4, e.evaluateDataset(n.validationData, { batches: n.validationBatches })]) : [3, 13]) : [3, 15] : [3, 16];case 12:
          return C = N.apply(void 0, [k.sent()]), [3, 14];case 13:
          C = toList(e.evaluate(a, o, { batchSize: null == n.validationBatchSize ? DEFAULT_VALIDATION_BATCH_SIZE : n.validationBatchSize, verbose: 0 })), k.label = 14;case 14:
          for (E = 0; E < e.metricsNames.length; ++E) {
            y["val_" + e.metricsNames[E]] = C[E];
          }k.label = 15;case 15:
          return [3, 17];case 16:
          return e.stopTraining_ ? [3, 17] : [3, 7];case 17:
          return [4, d.onEpochEnd(f, y)];case 18:
          return k.sent(), f++, e.stopTraining_ ? [3, 19] : [3, 4];case 19:
          return [4, d.onTrainEnd()];case 20:
          return k.sent(), [4, e.history.syncData()];case 21:
          return k.sent(), [2, e.history];case 22:
          return e.isTraining = !1, [7];case 23:
          return [2];}
    });
  });
}function isDatasetObject(e) {
  return "function" == typeof e.iterator;
}function isLazyIteratorObject(e) {
  return "function" == typeof e.next;
}function evaluateDataset(e, t, n) {
  return __awaiter(this, void 0, void 0, function () {
    var r, i, a, o, s, l, u, c, h, p;return __generator(this, function (d) {
      switch (d.label) {case 0:
          if (r = null != n.batches, i = e.testFunction, a = [], n.verbose > 0) throw new NotImplementedError("Verbose mode is not implemented yet.");return tf_core_esm["_92" /* util */].assert(!r || n.batches > 0 && Number.isInteger(n.batches), "Test loop expects `batches` to be a positive integer, but received " + JSON.stringify(n.batches)), isLazyIteratorObject(t) ? (s = t, [3, 3]) : [3, 1];case 1:
          return [4, t.iterator()];case 2:
          s = d.sent(), d.label = 3;case 3:
          o = s, l = 0, u = 0, c = function c() {
            var t, s, c, h, p, d;return __generator(this, function (g) {
              switch (g.label) {case 0:
                  return [4, o.next()];case 1:
                  if ((t = g.sent()).value) {
                    if (s = standardizeDataIteratorOutput(e, t.value), c = Object(tf_core_esm["_85" /* tidy */])(function () {
                      return i(s);
                    }), Object(tf_core_esm["N" /* dispose */])(s), 0 === u) for (d = 0; d < c.length; ++d) {
                      a.push(getScalar(0));
                    }for (h = s[0].shape[0], p = function p(e) {
                      var t = c[e],
                          n = a[e];a[e] = Object(tf_core_esm["_85" /* tidy */])(function () {
                        return Object(tf_core_esm["g" /* add */])(a[e], Object(tf_core_esm["_31" /* mul */])(getScalar(h), t));
                      }), u > 0 && Object(tf_core_esm["N" /* dispose */])(n);
                    }, d = 0; d < c.length; ++d) {
                      p(d);
                    }Object(tf_core_esm["N" /* dispose */])(c), l += h, ++u;
                  }return t.done ? (r && console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` batches (in this case, " + n.batches + " batches). You may need to use the repeat() function when building your dataset."), [2, "break"]) : [2];}
            });
          }, d.label = 4;case 4:
          return !r || u < n.batches ? [5, c()] : [3, 6];case 5:
          return "break" === d.sent() ? [3, 6] : [3, 4];case 6:
          for (h = function h(e) {
            var t = a[e];a[e] = Object(tf_core_esm["_85" /* tidy */])(function () {
              return Object(tf_core_esm["O" /* div */])(a[e], getScalar(l));
            }), Object(tf_core_esm["N" /* dispose */])(t);
          }, p = 0; p < a.length; ++p) {
            h(p);
          }return [2, singletonOrArray(a)];}
    });
  });
}function checkBatchSize(e) {
  tf_core_esm["_92" /* util */].assert(e > 0 && Number.isInteger(e), "batchSize is required to be a positive integer, but got " + e);
}function sliceArrays(e, t, n) {
  return null == e ? [null] : Array.isArray(e) ? e.map(function (e) {
    return sliceAlongFirstAxis(e, t, n - t);
  }) : sliceAlongFirstAxis(e, t, n - t);
}function sliceArraysByIndices(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return null == e ? null : Array.isArray(e) ? e.map(function (e) {
      return sliceArraysByIndices(e, t);
    }) : gather$1(e, "int32" === t.dtype ? t : t.toInt());
  });
}function makeBatches(e, t) {
  for (var n = [], r = 0, i = null; r < e;) {
    (i = r + t) >= e && (i = e), n.push([r, i]), r = i;
  }return n;
}function fitLoop(e, t, n, r, i, a, o, s, l, u, c, h, p, d, g, f) {
  return __awaiter(this, void 0, void 0, function () {
    var m, y, v, b, w, z, S, I;return __generator(this, function (A) {
      switch (A.label) {case 0:
          if (null == i && (i = 32), null == a && (a = 1), null == c && (c = !0), null == p && (p = 0), m = !1, null != l && null != u && (m = !0), null != g && (m = !0, null == d)) throw new ValueError("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");return null != (y = e.checkNumSamples(n, i, d, "steps_per_epoch")) && (v = range(0, y)), null == o && (o = 1), b = configureCallbacks(s, f, o, a, p, y, d, i, m, h), w = b.callbackList, z = b.history, w.setModel(e), e.history = z, [4, w.onTrainBegin()];case 1:
          A.sent(), e.stopTraining_ = !1, S = function S(a) {
            var o, s, h, p, g;return __generator(this, function (f) {
              switch (f.label) {case 0:
                  return [4, w.onEpochBegin(a)];case 1:
                  if (f.sent(), o = {}, null == d) return [3, 2];throw new NotImplementedError("stepsPerEpoch mode is not implemented yet.");case 2:
                  if ("batch" === c) throw new NotImplementedError("batch shuffling is not implemneted yet");c && tf_core_esm["_92" /* util */].shuffle(v), s = Object(tf_core_esm["_84" /* tensor1d */])(v), h = makeBatches(y, i), p = function p(a) {
                    var c;return __generator(this, function (p) {
                      switch (p.label) {case 0:
                          return c = {}, [4, w.onBatchBegin(a, c)];case 1:
                          return p.sent(), Object(tf_core_esm["_85" /* tidy */])(function () {
                            var p = h[a][0],
                                d = h[a][1],
                                g = sliceAlongFirstAxis(s, p, d - p);c.batch = a, c.size = d - p;for (var f = sliceArraysByIndices(n, g), y = t(f), v = 0; v < r.length; ++v) {
                              var b = r[v],
                                  w = y[v];c[b] = w, Object(tf_core_esm["_8" /* keep */])(w);
                            }if (a === h.length - 1 && m) {
                              var z = e.testLoop(l, u, i);for (v = 0; v < r.length; ++v) {
                                b = r[v], w = z[v];Object(tf_core_esm["_8" /* keep */])(w), o["val_" + b] = w;
                              }
                            }
                          }), [4, w.onBatchEnd(a, c)];case 2:
                          return p.sent(), disposeTensorsInLogs(c), e.stopTraining_ ? [2, "break"] : [2];}
                    });
                  }, g = 0, f.label = 3;case 3:
                  return g < h.length ? [5, p(g)] : [3, 6];case 4:
                  if ("break" === f.sent()) return [3, 6];f.label = 5;case 5:
                  return ++g, [3, 3];case 6:
                  s.dispose(), f.label = 7;case 7:
                  return [4, w.onEpochEnd(a, o)];case 8:
                  return f.sent(), e.stopTraining_ ? [2, "break"] : [2];}
            });
          }, I = p, A.label = 2;case 2:
          return I < a ? [5, S(I)] : [3, 5];case 3:
          if ("break" === A.sent()) return [3, 5];A.label = 4;case 4:
          return ++I, [3, 2];case 5:
          return [4, w.onTrainEnd()];case 6:
          return A.sent(), [4, e.history.syncData()];case 7:
          return A.sent(), [2, e.history];}
    });
  });
}function fitTensors(e, t, n, r) {
  return void 0 === r && (r = {}), __awaiter(this, void 0, void 0, function () {
    var i, a, o, s, l, u, c, h, p, d, g, f, m, y, v, b, w, z, S;return __generator(this, function (I) {
      switch (I.label) {case 0:
          if (e.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");e.isTraining = !0, I.label = 1;case 1:
          if (I.trys.push([1,, 3, 4]), checkBatchSize(c = null == r.batchSize ? 32 : r.batchSize), h = e.standardizeUserData(t, n, !1, c), i = h[0], a = h[1], p = !1, d = void 0, null != r.validationData && r.validationData.length > 0) {
            if (p = !0, 2 !== r.validationData.length) throw 3 === r.validationData.length ? new NotImplementedError("validationData including sample weights is not supported yet.") : new ValueError("When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; " + r.validationData + " is invalid.");o = r.validationData[0], s = r.validationData[1], g = e.standardizeUserData(o, s, !0, c), l = g[0], u = g[1], d = l.concat(u);
          } else null != r.validationSplit && r.validationSplit > 0 && r.validationSplit < 1 ? (p = !0, f = Math.floor(i[0].shape[0] * (1 - r.validationSplit)), m = i[0].shape[0], l = sliceArrays(i, f, m), i = sliceArrays(i, 0, f), u = sliceArrays(a, f, m), a = sliceArrays(a, 0, f), d = l.concat(u)) : null != r.validationSteps && (p = !0);return y = i.concat(a), e.checkTrainableWeightsConsistency(), v = e.makeTrainFunction(), b = e.getDedupedMetricsNames(), w = void 0, z = void 0, p ? (e.makeTestFunction(), w = e.testFunction, z = b.slice().concat(b.map(function (e) {
            return "val_" + e;
          }))) : (w = null, d = [], z = b.slice()), S = standardizeCallbacks(r.callbacks), [4, fitLoop(e, v, y, b, c, r.epochs, r.verbose, S, w, d, r.shuffle, z, r.initialEpoch, null, null, r.yieldEvery)];case 2:
          return [2, I.sent()];case 3:
          return e.isTraining = !1, disposeNewTensors(i, t), disposeNewTensors(a, n), disposeNewTensors(l, o), disposeNewTensors(u, s), [7];case 4:
          return [2];}
    });
  });
}function ensureTensorsRank2OrHigher(e) {
  var t = [];e instanceof tf_core_esm["c" /* Tensor */] && (e = [e]);for (var n = 0; n < e.length; ++n) {
    var r = e[n];if (1 === r.rank) t.push(expandDims$1(r, 1));else {
      if (0 === r.rank) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");t.push(r);
    }
  }return t;
}function disposeNewTensors(e, t) {
  if (null != e) {
    var n = [];if (t instanceof tf_core_esm["c" /* Tensor */]) n.push(t.id);else if (Array.isArray(t)) t.forEach(function (e) {
      return n.push(e.id);
    });else if (null != t) for (var r in t) {
      var i = t[r];n.push(i.id);
    }var a = [];if (e instanceof tf_core_esm["c" /* Tensor */]) -1 === n.indexOf(e.id) && a.push(e);else if (Array.isArray(e)) e.forEach(function (e) {
      -1 === n.indexOf(e.id) && a.push(e);
    });else if (null != e) for (var o in e) {
      var s = e[o];-1 === n.indexOf(s.id) && a.push(s);
    }a.forEach(function (e) {
      e.isDisposed || e.dispose();
    });
  }
}function isDataTensor(e) {
  return e instanceof tf_core_esm["c" /* Tensor */];
}function isDataArray(e) {
  return Array.isArray(e);
}function isDataDict(e) {
  return !isDataTensor(e) && !isDataArray(e);
}function standardizeInputData(e, t, n, r, i) {
  if (void 0 === r && (r = !0), void 0 === i && (i = ""), null == t || 0 === t.length) {
    if (null != e) {
      var a = !1;if (isDataArray(e) && e.length > 0) a = !0;else if (isDataDict(e)) {
        for (var o in e) {
          if (e.hasOwnProperty(o)) {
            a = !0;break;
          }
        }
      } else a = !0;if (a) throw new ValueError("Error when checking model " + i + " expected no data, but got " + e);
    }return [];
  }if (null == e) return t.map(function (e) {
    return null;
  });var s;if (isDataDict(e)) {
    e = e, s = [];for (var l = 0, u = t; l < u.length; l++) {
      var c = u[l];if (null == e[c]) throw new ValueError('No data provided for "' + c + '". Need data for each key in: ' + t);s.push(e[c]);
    }
  } else if (isDataArray(e)) {
    if ((e = e).length !== t.length) throw new ValueError("Error when checking model " + i + ": the Array of Tensors that you are passing to your model is not the size the model expected. Expected to see " + t.length + " Tensor(s), but instead got the following list of Tensor(s): " + e);s = e;
  } else {
    if (e = e, t.length > 1) throw new ValueError("The model " + i + " expects " + t.length + " Tensor(s), but only received one Tensor. Found: Tensor with shape " + e.shape);s = [e];
  }if (s = ensureTensorsRank2OrHigher(s), null != n) for (var h = 0; h < t.length; ++h) {
    if (null != n[h]) {
      var p = s[h];if (p.shape.length !== n[h].length) throw new ValueError("Error when checking " + i + ": expected " + t[h] + " to have " + n[h].length + " dimension(s). but got array with shape " + p.shape);for (var d = 0; d < n[h].length; ++d) {
        if (0 !== d || r) {
          var g = p.shape[d],
              f = n[h][d];if (null != f && f >= 0 && g !== f) throw new ValueError("Error when checking " + i + ": expected " + t[h] + " to have shape [" + n[h] + "], but got array with shape [" + p.shape + "].");
        }
      }
    }
  }return s;
}function checkArrayLengths(e, t, n) {
  var r = unique(e.map(function (e) {
    return e.shape[0];
  }));r.sort();var i = unique(t.map(function (e) {
    return e.shape[0];
  }));if (i.sort(), r.length > 1) throw new ValueError("All input Tensors (x) should have the same number of samples. Got array shapes: " + JSON.stringify(e.map(function (e) {
    return e.shape;
  })));if (i.length > 1) throw new ValueError("All target Tensors (y) should have the same number of samples. Got array shapes: " + JSON.stringify(t.map(function (e) {
    return e.shape;
  })));if (r.length > 0 && i.length > 0 && !tf_core_esm["_92" /* util */].arraysEqual(r, i)) throw new ValueError("Input Tensors should have the same number of samples as target Tensors. Found " + r[0] + " input sample(s) and " + i[0] + " target sample(s).");
}function checkLossAndTargetCompatibility(e, t, n) {
  for (var r = [meanSquaredError, binaryCrossentropy, categoricalCrossentropy], i = 0; i < e.length; ++i) {
    var a = e[i],
        o = t[i],
        s = n[i];if (null != o) {
      if (o === categoricalCrossentropy && 1 === a.shape[a.shape.length - 1]) throw new ValueError("You are passing a target array of shape " + a.shape + " while using a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].");if (-1 !== r.indexOf(o)) for (var l = a.shape.slice(1), u = s.slice(1), c = 0; c < l.length; ++c) {
        var h = l[c],
            p = u[c];if (null != p && h !== p) throw new ValueError("A target Tensor with shape " + a.shape + " was passed for an output of shape " + s + ", while using a loss function that expects targets to have the same shape as the output.");
      }
    }
  }
}function checkInputData(e, t, n, r, i) {
  var a;if (void 0 === r && (r = !0), void 0 === i && (i = ""), Array.isArray(e)) {
    if (e.length !== t.length) throw new ValueError("Error when checking model " + i + ": the Array of Tensors that you are passing to your model is not the size the the model expected. Expected to see " + t.length + " Tensor(s), but instead got " + e.length + " Tensors(s).");a = e;
  } else {
    if (t.length > 1) throw new ValueError("The model expects " + t.length + " " + i + " Tensors, but only received one Tensor. Found: array with shape " + JSON.stringify(e.shape) + ".");a = [e];
  }if (null != n) for (var o = 0; o < t.length; ++o) {
    if (null != n[o]) {
      var s = a[o];if (s.shape.length !== n[o].length) throw new ValueError("Error when checking " + i + ": expected " + t[o] + " to have " + n[o].length + " dimension(s), but got array with shape " + JSON.stringify(s.shape));for (var l = 0; l < n[o].length; ++l) {
        if (0 !== l || r) {
          var u = s.shape[l],
              c = n[o][l];if (null != c && c !== u) throw new ValueError("Error when checking " + i + ": expected " + t[o] + " to have shape " + JSON.stringify(n[o]) + " but got array with shape " + JSON.stringify(s.shape) + ".");
        }
      }
    }
  }
}function collectMetrics(e, t) {
  if (null == e || Array.isArray(e) && 0 === e.length) return t.map(function (e) {
    return [];
  });if (Array.isArray(e)) return t.map(function (t) {
    return e;
  });if (null != e) {
    for (var n = [], r = 0, i = t; r < i.length; r++) {
      var a = i[r],
          o = e.hasOwnProperty(a) ? e[a] : [];Array.isArray(o) || (o = [o]), n.push(o);
    }return n;
  }throw new TypeError("Type of metrics argument not understood. Expected an Array or Object, found: " + e);
}var Model = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.isTraining = !1, n;
  }return __extends(t, e), t.prototype.summary = function (e, t, n) {
    if (void 0 === n && (n = console.log), !this.built) throw new ValueError("This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).");printSummary(this, e, t, n);
  }, t.prototype.compile = function (e) {
    var t = this;if (null == e.loss && (e.loss = []), this.loss = e.loss, "string" == typeof e.optimizer) this.optimizer = getOptimizer(e.optimizer);else {
      if (!(e.optimizer instanceof tf_core_esm["b" /* Optimizer */])) throw new ValueError("User-defined optimizer must be an instance of tf.Optimizer.");this.optimizer = e.optimizer;
    }var n = [];if (Array.isArray(e.loss) || "string" == typeof e.loss || "function" == typeof e.loss) {
      if (Array.isArray(e.loss)) {
        if (e.loss.length !== this.outputs.length) throw new ValueError("When passing an Array as loss, it should have one entry per model output. The model has " + this.outputs.length + " output(s), but you passed loss=" + e.loss + ".");var r = e.loss;n = r.map(function (e) {
          return get(e);
        });
      } else {
        var i = get(e.loss);this.outputs.map(function (e) {
          n.push(i);
        });
      }
    } else {
      for (var a in e.loss = e.loss, e.loss) {
        if (-1 === this.outputNames.indexOf(a)) throw new ValueError('Unknown entry in loss dictionary: "' + a + '". Only expected the following keys: ' + this.outputNames);
      }for (var o = 0, s = this.outputNames; o < s.length; o++) {
        var l = s[o];null == e.loss[l] && console.warn('Output "' + l + '" is missing from loss dictionary. We assume this was done on purpose, and we will not be expecting data to be passed to ' + l + " during training"), n.push(get(e.loss[l]));
      }
    }this.lossFunctions = n, this.feedOutputNames = [], this.feedOutputShapes = [], this.feedLossFns = [];for (var u = 0; u < this.outputs.length; ++u) {
      var c = this.internalOutputShapes[u],
          h = this.outputNames[u];this.feedOutputNames.push(h), this.feedOutputShapes.push(c), this.feedLossFns.push(this.lossFunctions[u]);
    }var p = [];this.metrics = e.metrics, this.metricsNames = ["loss"], this.metricsTensors = [], nameScope("loss", function () {
      for (var e = 0; e < t.outputs.length; ++e) {
        if (-1 === p.indexOf(e)) {
          var n = t.lossFunctions[e];t.outputs.length > 1 && (t.metricsTensors.push([n, e]), t.metricsNames.push(t.outputNames[e] + "_loss"));
        }
      }
    });var d = collectMetrics(e.metrics, this.outputNames);nameScope("metric", function () {
      for (var e = function e(_e2) {
        if (-1 !== p.indexOf(_e2)) return "continue";!function (n) {
          for (var r, i, a, o = function o(n) {
            if (-1 !== ["accuracy", "acc", "crossentropy", "ce"].indexOf(n)) {
              var o = t.internalOutputShapes[_e2];1 === o[o.length - 1] || t.lossFunctions[_e2] === binaryCrossentropy ? -1 !== ["accuracy", "acc"].indexOf(n) ? i = binaryAccuracy : -1 !== ["crossentropy", "ce"].indexOf(n) && (i = binaryCrossentropy$1) : t.lossFunctions[_e2] === sparseCategoricalCrossentropy ? -1 !== ["accuracy", "acc"].indexOf(n) ? i = sparseCategoricalAccuracy : -1 !== ["crossentropy", "ce"].indexOf(n) && (i = sparseCategoricalCrossentropy$1) : -1 !== ["accuracy", "acc"].indexOf(n) ? i = categoricalAccuracy : -1 !== ["crossentropy", "ce"].indexOf(n) && (i = categoricalCrossentropy$1);var s = void 0;-1 !== ["accuracy", "acc"].indexOf(n) ? s = "acc" : -1 !== ["crossentropy", "ce"].indexOf(n) && (s = "ce"), a = i, r = "" + s;
            } else {
              var l = get$1(n);a = l, r = "" + n;
            }var u;nameScope(r, function () {
              u = a;
            }), function (e, n, r) {
              t.outputNames.length > 1 && (n = t.outputNames[e] + "_" + n), t.metricsNames.push(n), t.metricsTensors.push([r, e]);
            }(_e2, r, u);
          }, s = 0, l = n; s < l.length; s++) {
            o(l[s]);
          }
        }(d[_e2]);
      }, n = 0; n < t.outputs.length; ++n) {
        e(n);
      }
    }), this.collectedTrainableWeights = this.trainableWeights;
  }, t.prototype.checkTrainableWeightsConsistency = function () {
    null != this.collectedTrainableWeights && this.trainableWeights.length !== this.collectedTrainableWeights.length && console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
  }, t.prototype.evaluate = function (e, t, n) {
    void 0 === n && (n = {});var r = null == n.batchSize ? 32 : n.batchSize;checkBatchSize(r);var i = this.standardizeUserData(e, t, !0, r);try {
      var a = i[0].concat(i[1]);this.makeTestFunction();var o = this.testFunction;return singletonOrArray(this.testLoop(o, a, r, n.verbose, n.steps));
    } finally {
      disposeNewTensors(i[0], e), disposeNewTensors(i[1], t);
    }
  }, t.prototype.evaluateDataset = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        return this.makeTestFunction(), [2, evaluateDataset(this, e, t)];
      });
    });
  }, t.prototype.checkNumSamples = function (e, t, n, r) {
    var i;if (void 0 === r && (r = "steps"), null != n) {
      if (i = null, null != t) throw new ValueError("If " + r + " is set, batchSize must be null or undefined.Got batchSize = " + t);
    } else {
      if (null == e) throw new ValueError("Either the input data should have a defined shape, or " + r + " shoud be specified.");i = Array.isArray(e) ? e[0].shape[0] : e.shape[0];
    }return i;
  }, t.prototype.execute = function (e, t) {
    if (Array.isArray(t) && 0 === t.length) throw new ValueError("`outputs` is an empty Array, which is not allowed.");var n = Array.isArray(t),
        r = n ? t : [t],
        i = this.retrieveSymbolicTensors(r),
        a = new FeedDict();if (e instanceof tf_core_esm["c" /* Tensor */] && (e = [e]), Array.isArray(e)) {
      if (e.length !== this.inputs.length) throw new ValueError("The number of inputs provided (" + e.length + ") does not match the number of inputs of this model (" + this.inputs.length + ").");for (var o = 0; o < this.inputs.length; ++o) {
        a.add(this.inputs[o], e[o]);
      }
    } else for (var s = 0, l = this.inputs; s < l.length; s++) {
      var u = l[s],
          c = e[u.name];if (null == c) throw new ValueError("No value is provided for the model's input " + u.name);a.add(u, c);
    }var h = execute(i, a);return n ? h : h[0];
  }, t.prototype.retrieveSymbolicTensors = function (e) {
    for (var t = pyListRepeat(null, e.length), n = e.length, r = 0, i = this.layers; r < i.length; r++) {
      for (var a = i[r], o = Array.isArray(a.output) ? a.output : [a.output], s = o.map(function (e) {
        return e.name;
      }), l = 0; l < e.length; ++l) {
        var u = s.indexOf(e[l]);if (-1 !== u && (t[l] = o[u], n--), 0 === n) break;
      }if (0 === n) break;
    }if (n > 0) {
      var c = [];throw t.forEach(function (t, n) {
        null == t && c.push(e[n]);
      }), new ValueError("Cannot find SymbolicTensors for output name(s): " + JSON.stringify(c));
    }return t;
  }, t.prototype.predictLoop = function (e, t, n) {
    var r = this;return void 0 === t && (t = 32), void 0 === n && (n = !1), Object(tf_core_esm["_85" /* tidy */])(function () {
      var i = r.checkNumSamples(e);if (n) throw new NotImplementedError("Verbose predictLoop() is not implemented yet.");for (var a = makeBatches(i, t), o = [], s = function s(t) {
        var n = Object(tf_core_esm["_85" /* tidy */])(function () {
          var n = a[t][0],
              i = a[t][1],
              o = sliceArrays(e, n, i),
              s = [];if (Array.isArray(o)) for (var l = 0; l < o.length; ++l) {
            s.push({ key: r.inputs[l], value: o[l] });
          } else s.push({ key: r.inputs[0], value: o });var u = new FeedDict(s);return execute(r.outputs, u);
        });if (0 === t) for (var i = 0, s = n; i < s.length; i++) {
          var l = s[i];o.push(l);
        } else for (var u = 0; u < n.length; ++u) {
          o[u] = concatAlongFirstAxis(o[u], n[u]);
        }
      }, l = 0; l < a.length; ++l) {
        s(l);
      }return singletonOrArray(o);
    });
  }, t.prototype.predict = function (e, t) {
    void 0 === t && (t = {});var n = ensureTensorsRank2OrHigher(e);checkInputData(n, this.inputNames, this.feedInputShapes, !1);try {
      var r = null == t.batchSize ? 32 : t.batchSize;return checkBatchSize(r), this.predictLoop(n, r);
    } finally {
      disposeNewTensors(n, e);
    }
  }, t.prototype.predictOnBatch = function (e) {
    return checkInputData(e, this.inputNames, this.feedInputShapes, !0), this.predictLoop(e, e.shape[0]);
  }, t.prototype.standardizeUserData = function (e, t, n, r) {
    if (void 0 === n && (n = !0), null == this.optimizer) throw new RuntimeError("You must compile a model before training/testing. Use Model.compile(modelCompileArgs).");for (var i = [], a = 0; a < this.feedOutputShapes.length; ++a) {
      var o = this.feedOutputShapes[a];this.feedLossFns[a] === sparseCategoricalCrossentropy ? i.push(o.slice(0, o.length - 1).concat([1])) : i.push(o);
    }if (checkArrayLengths(e = standardizeInputData(e, this.feedInputNames, this.feedInputShapes, !1, "input"), t = standardizeInputData(t, this.feedOutputNames, i, !1, "target"), null), checkLossAndTargetCompatibility(t, this.feedLossFns, this.feedOutputShapes), this.stateful && null != r && r > 0 && e[0].shape[0] % r != 0) throw new ValueError("In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size " + r + ". Found: " + e[0].shape[0] + " sample(s).");return [e, t, null];
  }, t.prototype.testLoop = function (e, t, n, r, i) {
    var a = this;return void 0 === r && (r = 0), Object(tf_core_esm["_85" /* tidy */])(function () {
      var o = a.checkNumSamples(t, n, i, "steps"),
          s = [];if (r > 0) throw new NotImplementedError("Verbose mode is not implemented yet.");if (null != i) throw new NotImplementedError("steps mode in testLoop() is not implemented yet");for (var l = makeBatches(o, n), u = Object(tf_core_esm["_84" /* tensor1d */])(range(0, o)), c = 0; c < l.length; ++c) {
        var h = l[c][0],
            p = l[c][1],
            d = sliceAlongFirstAxis(u, h, p - h),
            g = sliceArraysByIndices(t, d),
            f = e(g);if (0 === c) for (var m = 0; m < f.length; ++m) {
          s.push(getScalar(0));
        }for (m = 0; m < f.length; ++m) {
          var y = f[m];s[m] = Object(tf_core_esm["g" /* add */])(s[m], Object(tf_core_esm["_31" /* mul */])(getScalar(p - h), y));
        }
      }for (m = 0; m < s.length; ++m) {
        s[m] = Object(tf_core_esm["O" /* div */])(s[m], getScalar(o));
      }return s;
    });
  }, t.prototype.getDedupedMetricsNames = function () {
    for (var e = this.metricsNames, t = [], n = 0; n < e.length; ++n) {
      var r = e[n],
          i = r;if (count(e, r) > 1) i += "_" + count(e.slice(0, n), r);t.push(i);
    }return t;
  }, t.prototype.makeTrainFunction = function () {
    var e = this;return function (t) {
      var n = t.slice(0, e.inputs.length),
          r = t.slice(e.inputs.length, e.inputs.length + e.outputs.length),
          i = [],
          a = e.collectedTrainableWeights.map(function (e) {
        return e.read();
      });return [e.optimizer.minimize(function () {
        for (var t = [], a = 0; a < e.inputs.length; ++a) {
          t.push({ key: e.inputs[a], value: n[a] });
        }var o,
            s = new FeedDict(t),
            l = execute(e.outputs, s, { training: !0 });for (a = 0; a < e.lossFunctions.length; ++a) {
          var u = (0, e.lossFunctions[a])(r[a], l[a]);Object(tf_core_esm["_25" /* mean */])(u), o = 0 === a ? u : Object(tf_core_esm["g" /* add */])(o, u);
        }for (a = 0; a < e.metricsTensors.length; ++a) {
          var c = e.metricsTensors[a][0],
              h = e.metricsTensors[a][1],
              p = Object(tf_core_esm["_25" /* mean */])(c(r[h], l[h]));Object(tf_core_esm["_8" /* keep */])(p), i.push(p);
        }return o = Object(tf_core_esm["_25" /* mean */])(o), e.calculateLosses().forEach(function (e) {
          o = Object(tf_core_esm["g" /* add */])(o, e);
        }), o;
      }, !0, a)].concat(i);
    };
  }, t.prototype.makeTestFunction = function () {
    var e = this;this.testFunction = function (t) {
      return Object(tf_core_esm["_85" /* tidy */])(function () {
        for (var n, r = [], i = t.slice(0, e.inputs.length), a = t.slice(e.inputs.length, e.inputs.length + e.outputs.length), o = [], s = 0; s < e.inputs.length; ++s) {
          o.push({ key: e.inputs[s], value: i[s] });
        }var l = new FeedDict(o),
            u = execute(e.outputs, l);for (s = 0; s < e.lossFunctions.length; ++s) {
          var c = e.lossFunctions[s],
              h = Object(tf_core_esm["_25" /* mean */])(c(a[s], u[s]));n = 0 === s ? h : Object(tf_core_esm["g" /* add */])(n, h), r.push(n);
        }for (s = 0; s < e.metricsTensors.length; ++s) {
          var p = e.metricsTensors[s][0],
              d = e.metricsTensors[s][1],
              g = Object(tf_core_esm["_25" /* mean */])(p(a[d], u[d]));r.push(g);
        }return r;
      });
    };
  }, t.prototype.fit = function (e, t, n) {
    return void 0 === n && (n = {}), __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (r) {
        return [2, fitTensors(this, e, t, n)];
      });
    });
  }, t.prototype.fitDataset = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        return [2, fitDataset(this, e, t)];
      });
    });
  }, t.prototype.trainOnBatch = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r, i, a, o, s, l, u, c, h, p;return __generator(this, function (d) {
        switch (d.label) {case 0:
            n = this.standardizeUserData(e, t), r = n[0], i = n[1], a = this.makeTrainFunction(), o = a(r.concat(i)), s = [], l = 0, u = o, d.label = 1;case 1:
            return l < u.length ? (c = u[l], p = (h = s).push, [4, c.data()]) : [3, 4];case 2:
            p.apply(h, [d.sent()[0]]), d.label = 3;case 3:
            return l++, [3, 1];case 4:
            return Object(tf_core_esm["N" /* dispose */])(o), [2, singletonOrArray(s)];}
      });
    });
  }, t.prototype.getNamedWeights = function (e) {
    for (var t = {}, n = null != e && e.trainableOnly, r = n ? this.trainableWeights : this.weights, i = this.getWeights(n), a = 0; a < r.length; ++a) {
      n && !r[a].trainable || (t[r[a].originalName] = i[a]);
    }return t;
  }, Object.defineProperty(t.prototype, "stopTraining", { set: function set(e) {
      this.stopTraining_ = e;
    }, enumerable: !0, configurable: !0 }), t.prototype.save = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      var n, r, i, a, o;return __generator(this, function (s) {
        switch (s.label) {case 0:
            if ("string" == typeof e) {
              if (0 === (n = tf_core_esm["_6" /* io */].getSaveHandlers(e)).length) throw new ValueError("Cannot find any save handlers for URL '" + e + "'");if (n.length > 1) throw new ValueError("Found more than one (" + n.length + ") save handlers for URL '" + e + "'");e = n[0];
            }if (null == e.save) throw new ValueError("Model.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");return [4, tf_core_esm["_6" /* io */].encodeWeights(this.getNamedWeights(t))];case 1:
            return r = s.sent(), i = !1, a = null, o = this.toJSON(a, i), [2, e.save({ modelTopology: o, weightData: r.data, weightSpecs: r.specs })];}
      });
    });
  }, t.className = "Model", t;
}(Container);function modelFromJSON(e, t) {
  return __awaiter(this, void 0, void 0, function () {
    var n, r, i, a, o, s, l, u, c, h;return __generator(this, function (p) {
      switch (p.label) {case 0:
          return "modelTopology" in e || (e = { modelTopology: e }), null != (n = (e = e).modelTopology).model_config && (n = n.model_config), r = convertPythonicToTs(n), i = deserialize(r, t), null == e.weightsManifest ? [3, 2] : [4, tf_core_esm["_6" /* io */].loadWeights(e.weightsManifest, e.pathPrefix, i.weights.map(function (e) {
            return e.originalName;
          }))];case 1:
          for (a = p.sent(), o = {}, s = 0, l = i.weights; s < l.length; s++) {
            u = l[s], o[u.originalName] = a[u.originalName];
          }c = null, h = !0, i.loadWeights(o, c, h), p.label = 2;case 2:
          return [2, i];}
    });
  });
}function loadModelInternal(e, t) {
  return void 0 === t && (t = !0), __awaiter(this, void 0, void 0, function () {
    var n;return __generator(this, function (r) {
      if ("string" == typeof e) {
        if (0 === (n = tf_core_esm["_6" /* io */].getLoadHandlers(e)).length) n.push(tf_core_esm["_6" /* io */].browserHTTPRequest(e));else if (n.length > 1) throw new ValueError("Found more than one (" + n.length + ") load handlers for URL '" + e + "'");e = n[0];
      }return [2, loadModelFromIOHandler(e, void 0, t)];
    });
  });
}function loadModelFromIOHandler(e, t, n) {
  return void 0 === n && (n = !0), __awaiter(this, void 0, void 0, function () {
    var r, i, a, o, s, l;return __generator(this, function (u) {
      switch (u.label) {case 0:
          if (null == e.load) throw new ValueError("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");return [4, e.load()];case 1:
          if (r = u.sent(), null != (i = r.modelTopology).model_config && (i = i.model_config), a = null != r.weightData && null != r.weightSpecs && n, o = deserialize(convertPythonicToTs(i), t, a), null != r.weightData) {
            if (null == r.weightSpecs) throw new ValueError("Model artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");s = !1, l = !0, o.loadWeights(tf_core_esm["_6" /* io */].decodeWeights(r.weightData, r.weightSpecs), s, l, n);
          }return [2, o];}
    });
  });
}tf_core_esm["_56" /* serialization */].registerClass(Model);var Sequential = function (e) {
  function t(t) {
    var n = e.call(this, { inputs: [], outputs: [] }) || this;if (t = t || {}, n.trainable = !0, n._updatable = !0, n.built = !1, n.name = null != t.name ? t.name : getUid("sequential_"), null != t.layers) for (var r = 0, i = t.layers; r < i.length; r++) {
      var a = i[r];n.add(a);
    }return n;
  }return __extends(t, e), t.prototype.checkShape = function (e) {
    if (e.inboundNodes[0].outputTensors[0].shape.some(function (e) {
      return e < 0;
    })) throw new ValueError("Negative dimension size caused by adding layer " + e.name + " with input shape [" + e.inboundNodes[0].inputTensors[0].shape + "]");
  }, t.prototype.add = function (e) {
    var n,
        r = e instanceof t || e instanceof Model;if (r) {
      if (1 !== (n = e).outputs.length) throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");if (1 !== n.inputs.length) throw new ValueError("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
    }if (0 === this.outputs.length) {
      if (0 === e.inboundNodes.length) {
        if (null == e.batchInputShape) throw new ValueError("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");var i = Input({ batchShape: e.batchInputShape, dtype: e.dtype, name: e.name + "_input" });e.apply(i);
      }if (r) this.outputs = n.outputs, this.inputs = n.inputs;else {
        if (1 !== e.inboundNodes.length) throw new ValueError("A layer added to a Sequential model must not already be connected somewhere else. Model received layer " + e.name + " which has " + e.inboundNodes.length + " pre-existing inbound connections.");if (1 !== e.inboundNodes[0].outputTensors.length) throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");this.checkShape(e), this.outputs = [e.inboundNodes[0].outputTensors[0]], this.inputs = getSourceInputs(this.outputs[0]);
      }this.inboundNodes = [], new Node({ outboundLayer: this, inboundLayers: [], nodeIndices: [], tensorIndices: [], inputTensors: this.inputs, outputTensors: this.outputs, inputMasks: pyListRepeat(null, this.inputs.length), outputMasks: [null], inputShapes: this.inputs.map(function (e) {
          return e.shape;
        }), outputShapes: this.outputs[0].shape });
    } else {
      var a = e.apply(this.outputs[0]);if (Array.isArray(a)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");this.checkShape(e), this.outputs = [a], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [this.outputs[0].shape];
    }this.layers.push(e), this.built = !1;
  }, t.prototype.pop = function () {
    if (0 === this.layers.length) throw new TypeError("There are no layers in the model.");if (this.layers.pop(), 0 === this.layers.length) this.outputs = [], this.inboundNodes = [], this.outboundNodes = [];else {
      var e = this.layers.length - 1;this.layers[e].outboundNodes = [], this.outputs = [this.layers[e].output], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [this.outputs[0].shape];
    }
  }, t.prototype.call = function (e, t) {
    return null == this.model && this.build(), this.model.call(e, t);
  }, t.prototype.build = function (e) {
    if (getExactlyOneShape(e), 0 === this.inputs.length || 0 === this.outputs.length) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");this.model = new Model({ inputs: this.inputs, outputs: this.outputs[0], name: this.name + "_model" }), this.model.trainable = this.trainable, this.model.updatable = this.updatable, this.supportsMasking = this.model.supportsMasking, this.inputLayers = this.model.inputLayers, this.inputLayersNodeIndices = this.model.inputLayersNodeIndices, this.inputLayersTensorIndices = this.model.inputLayersTensorIndices, this.outputLayers = this.model.outputLayers, this.outputLayersNodeIndices = this.model.outputLayersNodeIndices, this.outputLayersTensorIndices = this.model.outputLayersTensorIndices, this.nodesByDepth = this.model.nodesByDepth, this.containerNodes = this.model.containerNodes, this.outputNames = this.model.outputNames, this.inputNames = this.model.inputNames, this.built = !0;
  }, t.prototype.countParams = function () {
    return this.built || this.build(), e.prototype.countParams.call(this);
  }, t.prototype.summary = function (t, n, r) {
    void 0 === r && (r = console.log), this.built || this.build(), e.prototype.summary.call(this, t, n, r);
  }, t.prototype.setWeights = function (e) {
    null == this.model && this.build(), this.model.setWeights(e);
  }, Object.defineProperty(t.prototype, "updatable", { get: function get() {
      return this._updatable;
    }, set: function set(e) {
      this.built && (this.model.updatable = e), this._updatable = e;
    }, enumerable: !0, configurable: !0 }), t.prototype.evaluate = function (e, t, n) {
    if (void 0 === n && (n = {}), !this.built) throw new RuntimeError("The model needs to be compiled before being used.");return this.model.evaluate(e, t, n);
  }, t.prototype.evaluateDataset = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        if (!this.built) throw new RuntimeError("The model needs to be compiled before being used.");return [2, this.model.evaluateDataset(e, t)];
      });
    });
  }, t.prototype.predict = function (e, t) {
    return void 0 === t && (t = {}), null == this.model && this.build(), this.model.predict(e, t);
  }, t.prototype.predictOnBatch = function (e) {
    return null == this.model && this.build(), this.model.predictOnBatch(e);
  }, t.prototype.compile = function (e) {
    this.build(), this.model.compile(e), this.optimizer = this.model.optimizer, this.loss = this.model.loss, this.metrics = this.model.metrics, this.metricsTensors = this.model.metricsTensors, this.metricsNames = this.model.metricsNames;
  }, t.prototype.fit = function (e, t, n) {
    return void 0 === n && (n = {}), __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (r) {
        if (!this.built) throw new RuntimeError("The model needs to be compiled before being used.");return [2, this.model.fit(e, t, n)];
      });
    });
  }, t.prototype.fitDataset = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        if (!this.built) throw new RuntimeError("The model needs to be compiled before being used.");return [2, this.model.fitDataset(e, t)];
      });
    });
  }, t.prototype.trainOnBatch = function (e, t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (n) {
        return [2, this.model.trainOnBatch(e, t)];
      });
    });
  }, t.fromConfig = function (e, n, r, i) {
    var a;void 0 === r && (r = {}), void 0 === i && (i = !1);var o = {};if (n instanceof Array) {
      if (null == n[0].className || "Merge" === n[0].className) throw new ValueError("Legacy serialization format not supported yet.");a = n;
    } else tf_core_esm["_92" /* util */].assert(null != n.layers, "When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field."), a = n.layers, delete n.layers, o = n;var s = new e(o);if (!(s instanceof t)) throw new NotImplementedError("Sequential.fromConfig called on non-Sequential input: " + s);for (var l = 0, u = a; l < u.length; l++) {
      var c = deserialize(u[l], void 0, i);i && c.setFastWeightInitDuringBuild(!0), s.add(c);
    }return s;
  }, Object.defineProperty(t.prototype, "stopTraining", { set: function set(e) {
      this.model.stopTraining = e;
    }, enumerable: !0, configurable: !0 }), t.prototype.getConfig = function () {
    for (var e = [], t = 0, n = this.layers; t < n.length; t++) {
      var r = n[t];e.push({ className: r.getClassName(), config: r.getConfig() });
    }return e;
  }, t.className = "Sequential", t;
}(Model);function model(e) {
  return new Model(e);
}function sequential(e) {
  return new Sequential(e);
}function loadModel(e, t) {
  return void 0 === t && (t = !0), loadModelInternal(e, t);
}function input(e) {
  return Input(e);
}function registerCallbackConstructor(e, t) {
  CallbackConstructorRegistry.registerCallbackConstructor(e, t);
}tf_core_esm["_56" /* serialization */].registerClass(Sequential);var Activation = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.getConfig = function () {
    return {};
  }, t;
}(tf_core_esm["_56" /* serialization */].Serializable),
    Elu = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    return void 0 === t && (t = 1), elu$1(e, t);
  }, t.className = "elu", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Elu);var Selu = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_54" /* selu */])(e);
  }, t.className = "selu", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Selu);var Relu = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_47" /* relu */])(e);
  }, t.className = "relu", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Relu);var Relu6 = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      return Object(tf_core_esm["_28" /* minimum */])(getScalar(6), Object(tf_core_esm["_47" /* relu */])(e));
    });
  }, t.className = "relu6", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Relu6);var Linear = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return e;
  }, t.className = "linear", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Linear);var Sigmoid = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_58" /* sigmoid */])(e);
  }, t.className = "sigmoid", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Sigmoid);var HardSigmoid = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return hardSigmoid(e);
  }, t.className = "hardSigmoid", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(HardSigmoid);var Softplus = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_68" /* softplus */])(e);
  }, t.className = "softplus", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Softplus);var Softsign = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return softsign(e);
  }, t.className = "softsign", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Softsign);var Tanh = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e) {
    return Object(tf_core_esm["_82" /* tanh */])(e);
  }, t.className = "tanh", t;
}(Activation);tf_core_esm["_56" /* serialization */].registerClass(Tanh);var Softmax = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.apply = function (e, t) {
    return void 0 === t && (t = -1), Object(tf_core_esm["_67" /* softmax */])(e, t);
  }, t.className = "softmax", t;
}(Activation);function serializeActivation(e) {
  return e.getClassName();
}function deserializeActivation(e, t) {
  return void 0 === t && (t = {}), deserializeKerasObject(e, tf_core_esm["_56" /* serialization */].SerializationMap.getMap().classNameMap, t, "activation");
}function getActivation(e) {
  return null == e ? deserializeActivation({ className: "linear", config: {} }) : "string" == typeof e ? deserializeActivation({ className: e, config: {} }) : e instanceof Activation ? e : deserializeActivation(e);
}tf_core_esm["_56" /* serialization */].registerClass(Softmax);var Regularizer = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t;
}(tf_core_esm["_56" /* serialization */].Serializable),
    L1L2 = function (e) {
  function t(t) {
    var n = e.call(this) || this,
        r = null == t || null == t.l1 ? .01 : t.l1,
        i = null == t || null == t.l2 ? .01 : t.l2;return n.hasL1 = 0 !== r, n.hasL2 = 0 !== i, n.l1 = getScalar(r), n.l2 = getScalar(i), n;
  }return __extends(t, e), t.prototype.apply = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var n = Object(tf_core_esm["_97" /* zeros */])([1]);return t.hasL1 && (n = Object(tf_core_esm["g" /* add */])(n, Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_31" /* mul */])(t.l1, Object(tf_core_esm["d" /* abs */])(e))))), t.hasL2 && (n = Object(tf_core_esm["g" /* add */])(n, Object(tf_core_esm["_80" /* sum */])(Object(tf_core_esm["_31" /* mul */])(t.l2, square(e))))), n.asScalar();
    });
  }, t.prototype.getConfig = function () {
    return { l1: this.l1.dataSync()[0], l2: this.l2.dataSync()[0] };
  }, t.fromConfig = function (e, t) {
    return new e({ l1: t.l1, l2: t.l2 });
  }, t.className = "L1L2", t;
}(Regularizer);function l1(e) {
  return new L1L2({ l1: null != e ? e.l1 : null, l2: 0 });
}function l2(e) {
  return new L1L2({ l2: null != e ? e.l2 : null, l1: 0 });
}tf_core_esm["_56" /* serialization */].registerClass(L1L2);var REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP = { l1l2: "L1L2" };function serializeRegularizer(e) {
  return serializeKerasObject(e);
}function deserializeRegularizer(e, t) {
  return void 0 === t && (t = {}), deserializeKerasObject(e, tf_core_esm["_56" /* serialization */].SerializationMap.getMap().classNameMap, t, "regularizer");
}function getRegularizer(e) {
  return null == e ? null : "string" == typeof e ? deserializeRegularizer({ className: e in REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP ? REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[e] : e, config: {} }) : e instanceof Regularizer ? e : deserializeRegularizer(e);
}var ReLU = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;return n.supportsMasking = !0, null != t && (n.maxValue = t.maxValue), n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    e = getExactlyOneTensor(e);var n = Object(tf_core_esm["_47" /* relu */])(e);return null != this.maxValue && (n = Object(tf_core_esm["z" /* clipByValue */])(n, 0, this.maxValue)), n;
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.getConfig = function () {
    var t = { maxValue: this.maxValue },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "ReLU", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(ReLU);var LeakyReLU = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;return n.DEFAULT_ALPHA = .3, null == t && (t = {}), n.alpha = null == t.alpha ? n.DEFAULT_ALPHA : t.alpha, n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = getExactlyOneTensor(e);return Object(tf_core_esm["_9" /* leakyRelu */])(n, this.alpha);
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.getConfig = function () {
    var t = { alpha: this.alpha },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "LeakyReLU", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(LeakyReLU);var PReLU = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;if (n.DEFAULT_ALPHA_INITIALIZER = "zeros", null == t && (t = {}), n.supportsMasking = !0, n.alphaInitializer = getInitializer(t.alphaInitializer || n.DEFAULT_ALPHA_INITIALIZER), n.alphaRegularizer = getRegularizer(t.alphaRegularizer), n.alphaConstraint = getConstraint(t.alphaConstraint), null == t.sharedAxes) n.sharedAxes = null;else if (Array.isArray(t.sharedAxes)) n.sharedAxes = t.sharedAxes;else {
      if ("number" != typeof t.sharedAxes) throw new ValueError("Expected sharedAxes to be a number or an array of numbers, but got " + t.sharedAxes);n.sharedAxes = [t.sharedAxes];
    }return n;
  }return __extends(t, e), t.prototype.build = function (e) {
    var t = (e = getExactlyOneShape(e)).slice(1);if (null != this.sharedAxes) for (var n = 0, r = this.sharedAxes; n < r.length; n++) {
      t[(a = r[n]) - 1] = 1;
    }this.alpha = this.addWeight("alpha", t, "float32", this.alphaInitializer, this.alphaRegularizer, !0, this.alphaConstraint);var i = {};if (null != this.sharedAxes) for (var a = 1; a < e.length; ++a) {
      i[a] = e[a];
    }this.inputSpec = [new InputSpec({ ndim: e.length, axes: i })], this.built = !0;
  }, t.prototype.call = function (e, t) {
    return e = getExactlyOneTensor(e), Object(tf_core_esm["_41" /* prelu */])(e, this.alpha.read());
  }, t.prototype.getConfig = function () {
    var t = { alphaInitializer: serializeInitializer(this.alphaInitializer), alphaRegularizer: serializeRegularizer(this.alphaRegularizer), alphaConstraint: serializeConstraint(this.alphaConstraint), sharedAxes: this.sharedAxes },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "PReLU", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(PReLU);var ELU = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;if (n.DEFAULT_ALPHA = 1, null == t && (t = {}), null != t.alpha && t.alpha !== n.DEFAULT_ALPHA) throw new NotImplementedError("Non-default alpha value (" + t.alpha + ") is not supported by the ELU layer yet.");return n.alpha = null == t.alpha ? n.DEFAULT_ALPHA : t.alpha, n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = getExactlyOneTensor(e);return Object(tf_core_esm["P" /* elu */])(n);
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.getConfig = function () {
    var t = { alpha: this.alpha },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "ELU", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(ELU);var ThresholdedReLU = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;return n.DEFAULT_THETA = 1, null == t && (t = {}), n.theta = null == t.theta ? n.DEFAULT_THETA : t.theta, n.thetaTensor = getScalar(n.theta), n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = getExactlyOneTensor(e);return n.mul(cast$1(n.greater(this.thetaTensor), "float32"));
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.getConfig = function () {
    var t = { theta: this.theta },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "ThresholdedReLU", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(ThresholdedReLU);var Softmax$1 = function (e) {
  function t(t) {
    var n = e.call(this, null == t ? {} : t) || this;return n.DEFAULT_AXIS = 1, null == t && (t = {}), n.softmax = new Softmax().apply, n.axis = null == t.axis ? n.DEFAULT_AXIS : t.axis, n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = getExactlyOneTensor(e);return this.softmax(n, this.axis);
  }, t.prototype.computeOutputShape = function (e) {
    return e;
  }, t.prototype.getConfig = function () {
    var t = { axis: this.axis },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Softmax", t;
}(Layer);function normalizeArray(e, t, n) {
  if ("number" == typeof e) return pyListRepeat(e, t);if (e.length !== t) throw new ValueError("The " + n + " argument must be a tuple of " + t + " integers. Received: " + e.length + " elements.");for (var r = 0; r < t; ++r) {
    var i = e[r];if (!isInteger(i)) throw new ValueError("The " + n + " argument must be a tuple of " + t + " integers. Received: " + JSON.stringify(e) + " including a non-integer number " + i);
  }return e;
}function convOutputLength(e, t, n, r, i) {
  return void 0 === i && (i = 1), null == e ? e : (a = "same" === n ? e : e - (t + (t - 1) * (i - 1)) + 1, Math.floor((a + r - 1) / r));var a;
}function deconvLength(e, t, n, r) {
  if (null == e) return null;if ("valid" === r) e = e * t + max$1([n - t, 0]);else {
    if ("same" !== r) throw new ValueError("Unsupport padding mode: " + r + ".");e *= t;
  }return e;
}function preprocessConv2DInput(e, t) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    return checkDataFormat(t), "channelsFirst" === t ? Object(tf_core_esm["_89" /* transpose */])(e, [0, 2, 3, 1]) : e;
  });
}function conv1dWithBias(e, t, n, r, i, a, o) {
  return void 0 === r && (r = 1), void 0 === i && (i = "valid"), void 0 === o && (o = 1), Object(tf_core_esm["_85" /* tidy */])(function () {
    if (null == a && (a = imageDataFormat()), checkDataFormat(a), 3 !== e.shape.length) throw new ValueError("The input of a conv1dWithBias operation should be 3, but is " + e.shape.length + " instead.");if (3 !== t.shape.length) throw new ValueError("The kernel for a conv1dWithBias operation should be 3, but is " + t.shape.length + " instead");if (null != n && 1 !== n.shape.length) throw new ValueError("The bias for a conv1dWithBias operation should be 1, but is " + t.shape.length + " instead");if ("channelsFirst" === a && (e = Object(tf_core_esm["_89" /* transpose */])(e, [0, 2, 1])), "causal" === i) throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");var s = Object(tf_core_esm["G" /* conv1d */])(e, t, r, "same" === i ? "same" : "valid", "NWC", o);return null != n && (s = biasAdd(s, n)), s;
  });
}function conv2dWithBias(e, t, n, r, i, a, o) {
  return void 0 === r && (r = [1, 1]), void 0 === i && (i = "valid"), Object(tf_core_esm["_85" /* tidy */])(function () {
    if (null == a && (a = imageDataFormat()), checkDataFormat(a), 3 !== e.rank && 4 !== e.rank) throw new ValueError("conv2dWithBias expects input to be of rank 3 or 4, but received " + e.rank + ".");if (3 !== t.rank && 4 !== t.rank) throw new ValueError("conv2dWithBias expects kernel to be of rank 3 or 4, but received " + e.rank + ".");var s = preprocessConv2DInput(e, a);if ("causal" === i) throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");return s = Object(tf_core_esm["H" /* conv2d */])(s, t, r, "same" === i ? "same" : "valid", "NHWC", o), null != n && (s = biasAdd(s, n)), "channelsFirst" === a && (s = Object(tf_core_esm["_89" /* transpose */])(s, [0, 3, 1, 2])), s;
  });
}tf_core_esm["_56" /* serialization */].registerClass(Softmax$1);var BaseConv = function (e) {
  function t(n, r) {
    var i = e.call(this, r) || this;if (i.bias = null, i.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", i.DEFAULT_BIAS_INITIALIZER = "zeros", t.verifyArgs(r), i.rank = n, 1 !== i.rank && 2 !== i.rank) throw new NotImplementedError("Convolution layer for rank other than 1 or 2 (" + i.rank + ") is not implemented yet.");if (i.kernelSize = normalizeArray(r.kernelSize, n, "kernelSize"), i.strides = normalizeArray(null == r.strides ? 1 : r.strides, n, "strides"), i.padding = null == r.padding ? "valid" : r.padding, checkPaddingMode(i.padding), i.dataFormat = null == r.dataFormat ? "channelsLast" : r.dataFormat, checkDataFormat(i.dataFormat), i.activation = getActivation(r.activation), i.useBias = null == r.useBias || r.useBias, i.biasInitializer = getInitializer(r.biasInitializer || i.DEFAULT_BIAS_INITIALIZER), i.biasConstraint = getConstraint(r.biasConstraint), i.biasRegularizer = getRegularizer(r.biasRegularizer), i.activityRegularizer = getRegularizer(r.activityRegularizer), i.dilationRate = normalizeArray(null == r.dilationRate ? 1 : r.dilationRate, n, "dilationRate"), 1 === i.rank && Array.isArray(i.dilationRate) && 1 !== i.dilationRate.length) throw new ValueError("dilationRate must be a number or an array of a single number for 1D convolution, but received " + JSON.stringify(i.dilationRate));if (2 === i.rank) if ("number" == typeof i.dilationRate) i.dilationRate = [i.dilationRate, i.dilationRate];else if (2 !== i.dilationRate.length) throw new ValueError("dilationRate must be a number or array of two numbers for 2D convolution, but received " + JSON.stringify(i.dilationRate));return i;
  }return __extends(t, e), t.verifyArgs = function (e) {
    if (assert("kernelSize" in e, "required key 'kernelSize' not in config"), "number" != typeof e.kernelSize && !checkArrayTypeAndLength(e.kernelSize, "number", 1, 2)) throw new ValueError("BaseConv expects config.kernelSize to be number or number[] with length 1 or 2, but received " + JSON.stringify(e.kernelSize) + ".");
  }, t.prototype.getConfig = function () {
    var t = { kernelSize: this.kernelSize, strides: this.strides, padding: this.padding, dataFormat: this.dataFormat, dilationRate: this.dilationRate, activation: serializeActivation(this.activation), useBias: this.useBias, biasInitializer: serializeInitializer(this.biasInitializer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), biasConstraint: serializeConstraint(this.biasConstraint) },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t;
}(Layer),
    Conv = function (e) {
  function t(n, r) {
    var i = e.call(this, n, r) || this;return i.kernel = null, t.verifyArgs(r), i.filters = r.filters, i.kernelInitializer = getInitializer(r.kernelInitializer || i.DEFAULT_KERNEL_INITIALIZER), i.kernelConstraint = getConstraint(r.kernelConstraint), i.kernelRegularizer = getRegularizer(r.kernelRegularizer), i;
  }return __extends(t, e), t.prototype.build = function (e) {
    e = getExactlyOneShape(e);var t = "channelsFirst" === this.dataFormat ? 1 : e.length - 1;if (null == e[t]) throw new ValueError("The channel dimension of the input should be defined. Found " + e[t]);var n,
        r = e[t],
        i = this.kernelSize.concat([r, this.filters]);this.kernel = this.addWeight("kernel", i, null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.filters], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [{ ndim: this.rank + 2, axes: (n = {}, n[t] = r, n) }], this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t;e = getExactlyOneTensor(e);var r = null == n.bias ? null : n.bias.read();if (1 === n.rank) t = conv1dWithBias(e, n.kernel.read(), r, n.strides[0], n.padding, n.dataFormat, n.dilationRate[0]);else if (2 === n.rank) t = conv2dWithBias(e, n.kernel.read(), r, n.strides, n.padding, n.dataFormat, n.dilationRate);else if (3 === n.rank) throw new NotImplementedError("3D convolution is not implemented yet.");return null != n.activation && (t = n.activation.apply(t)), t;
    });
  }, t.prototype.computeOutputShape = function (e) {
    e = getExactlyOneShape(e);for (var t = [], n = "channelsLast" === this.dataFormat ? e.slice(1, e.length - 1) : e.slice(2), r = 0; r < n.length; ++r) {
      var i = convOutputLength(n[r], this.kernelSize[r], this.padding, this.strides[r], "number" == typeof this.dilationRate ? this.dilationRate : this.dilationRate[r]);t.push(i);
    }var a = [e[0]];return "channelsLast" === this.dataFormat ? (a = a.concat(t)).push(this.filters) : (a.push(this.filters), a = a.concat(t)), a;
  }, t.prototype.getConfig = function () {
    var t = { filters: this.filters, kernelInitializer: serializeInitializer(this.kernelInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint) },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.verifyArgs = function (e) {
    if (!("filters" in e) || "number" != typeof e.filters || e.filters < 1) throw new ValueError("Convolution layer expected config.filters to be a 'number' > 0 but got " + JSON.stringify(e.filters));
  }, t;
}(BaseConv),
    Conv2D = function (e) {
  function t(n) {
    var r = e.call(this, 2, n) || this;return t.verifyArgs(n), r;
  }return __extends(t, e), t.prototype.getConfig = function () {
    var t = e.prototype.getConfig.call(this);return delete t.rank, t;
  }, t.verifyArgs = function (e) {
    if ("number" != typeof e.kernelSize && !checkArrayTypeAndLength(e.kernelSize, "number", 1, 2)) throw new ValueError("Conv2D expects config.kernelSize to be number or number[] with length 1 or 2, but received " + JSON.stringify(e.kernelSize) + ".");
  }, t.className = "Conv2D", t;
}(Conv);tf_core_esm["_56" /* serialization */].registerClass(Conv2D);var Conv2DTranspose = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;if (n.inputSpec = [new InputSpec({ ndim: 4 })], "same" !== n.padding && "valid" !== n.padding) throw new ValueError("Conv2DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode " + n.padding);return n;
  }return __extends(t, e), t.prototype.build = function (e) {
    if (4 !== (e = getExactlyOneShape(e)).length) throw new ValueError("Input should have rank 4; Received input shape: " + JSON.stringify(e));var t = "channelsFirst" === this.dataFormat ? 1 : e.length - 1;if (null == e[t]) throw new ValueError("The channel dimension of the inputs should be defined. Found `None`.");var n,
        r = e[t],
        i = this.kernelSize.concat([this.filters, r]);this.kernel = this.addWeight("kernel", i, "float32", this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [new InputSpec({ ndim: 4, axes: (n = {}, n[t] = r, n) })], this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e);if (4 !== t.shape.length) throw new ValueError("Conv2DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-" + t.shape.length);var r,
          i,
          a = t.shape,
          o = a[0];"channelsFirst" === n.dataFormat ? (r = 2, i = 3) : (r = 1, i = 2);var s = a[r],
          l = a[i],
          u = n.kernelSize[0],
          c = n.kernelSize[1],
          h = n.strides[0],
          p = n.strides[1],
          d = [o, deconvLength(s, h, u, n.padding), deconvLength(l, p, c, n.padding), n.filters];"channelsLast" !== n.dataFormat && (t = Object(tf_core_esm["_89" /* transpose */])(t, [0, 2, 3, 1]));var g = Object(tf_core_esm["I" /* conv2dTranspose */])(t, n.kernel.read(), d, n.strides, n.padding);return "channelsLast" !== n.dataFormat && (g = Object(tf_core_esm["_89" /* transpose */])(g, [0, 3, 1, 2])), null != n.bias && (g = biasAdd(g, n.bias.read(), n.dataFormat)), null != n.activation && (g = n.activation.apply(g)), g;
    });
  }, t.prototype.computeOutputShape = function (e) {
    var t,
        n,
        r,
        i = (e = getExactlyOneShape(e)).slice();"channelsFirst" === this.dataFormat ? (t = 1, n = 2, r = 3) : (t = 3, n = 1, r = 2);var a = this.kernelSize[0],
        o = this.kernelSize[1],
        s = this.strides[0],
        l = this.strides[1];return i[t] = this.filters, i[n] = deconvLength(i[n], s, a, this.padding), i[r] = deconvLength(i[r], l, o, this.padding), i;
  }, t.prototype.getConfig = function () {
    var t = e.prototype.getConfig.call(this);return delete t.dilationRate, t;
  }, t.className = "Conv2DTranspose", t;
}(Conv2D);tf_core_esm["_56" /* serialization */].registerClass(Conv2DTranspose);var SeparableConv = function (e) {
  function t(t, n) {
    var r = e.call(this, t, n) || this;if (r.DEFAULT_DEPTHWISE_INITIALIZER = "glorotUniform", r.DEFAULT_POINTWISE_INITIALIZER = "glorotUniform", r.depthwiseKernel = null, r.pointwiseKernel = null, null == n.filters) throw new ValueError("The `filters` configuration field is required by SeparableConv, but is unspecified.");if (null != n.kernelInitializer || null != n.kernelRegularizer || null != n.kernelConstraint) throw new ValueError("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");if (null != n.padding && "same" !== n.padding && "valid" !== n.padding) throw new ValueError("SeparableConv" + r.rank + "D supports only padding modes: 'same' and 'valid', but received " + JSON.stringify(n.padding));return r.depthMultiplier = null == n.depthMultiplier ? 1 : n.depthMultiplier, r.depthwiseInitializer = getInitializer(n.depthwiseInitializer || r.DEFAULT_DEPTHWISE_INITIALIZER), r.depthwiseRegularizer = getRegularizer(n.depthwiseRegularizer), r.depthwiseConstraint = getConstraint(n.depthwiseConstraint), r.pointwiseInitializer = getInitializer(n.depthwiseInitializer || r.DEFAULT_POINTWISE_INITIALIZER), r.pointwiseRegularizer = getRegularizer(n.pointwiseRegularizer), r.pointwiseConstraint = getConstraint(n.pointwiseConstraint), r;
  }return __extends(t, e), t.prototype.build = function (e) {
    if ((e = getExactlyOneShape(e)).length < this.rank + 2) throw new ValueError("Inputs to SeparableConv" + this.rank + "D should have rank " + (this.rank + 2) + ", but received input shape: " + JSON.stringify(e));var t = "channelsFirst" === this.dataFormat ? 1 : e.length - 1;if (null == e[t] || e[t] < 0) throw new ValueError("The channel dimension of the inputs should be defined, but found " + JSON.stringify(e[t]));for (var n = e[t], r = this.kernelSize.concat([n, this.depthMultiplier]), i = [], a = 0; a < this.rank; ++a) {
      i.push(1);
    }i.push(n * this.depthMultiplier, this.filters);var o;this.depthwiseKernel = this.addWeight("depthwise_kernel", r, "float32", this.depthwiseInitializer, this.depthwiseRegularizer, !0, this.depthwiseConstraint), this.pointwiseKernel = this.addWeight("pointwise_kernel", i, "float32", this.pointwiseInitializer, this.pointwiseRegularizer, !0, this.pointwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.inputSpec = [new InputSpec({ ndim: this.rank + 2, axes: (o = {}, o[t] = n, o) })], this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t;if (e = getExactlyOneTensor(e), 1 === n.rank) throw new NotImplementedError("1D separable convolution is not implemented yet.");return 2 === n.rank && ("channelsFirst" === n.dataFormat && (e = Object(tf_core_esm["_89" /* transpose */])(e, [0, 2, 3, 1])), t = Object(tf_core_esm["_55" /* separableConv2d */])(e, n.depthwiseKernel.read(), n.pointwiseKernel.read(), n.strides, n.padding, n.dilationRate, "NHWC")), n.useBias && (t = biasAdd(t, n.bias.read(), n.dataFormat)), null != n.activation && (t = n.activation.apply(t)), "channelsFirst" === n.dataFormat && (t = Object(tf_core_esm["_89" /* transpose */])(t, [0, 3, 1, 2])), t;
    });
  }, t.prototype.getConfig = function () {
    var t = e.prototype.getConfig.call(this);return delete t.rank, delete t.kernelInitializer, delete t.kernelRegularizer, delete t.kernelConstraint, t.depthwiseInitializer = serializeInitializer(this.depthwiseInitializer), t.pointwiseInitializer = serializeInitializer(this.pointwiseInitializer), t.depthwiseRegularizer = serializeRegularizer(this.depthwiseRegularizer), t.pointwiseRegularizer = serializeRegularizer(this.pointwiseRegularizer), t.depthwiseConstraint = serializeConstraint(this.depthwiseConstraint), t.pointwiseConstraint = serializeConstraint(this.pointwiseConstraint), t;
  }, t.className = "SeparableConv", t;
}(Conv),
    SeparableConv2D = function (e) {
  function t(t) {
    return e.call(this, 2, t) || this;
  }return __extends(t, e), t.className = "SeparableConv2D", t;
}(SeparableConv);tf_core_esm["_56" /* serialization */].registerClass(SeparableConv2D);var Conv1D = function (e) {
  function t(n) {
    var r = e.call(this, 1, n) || this;return t.verifyArgs(n), r.inputSpec = [{ ndim: 3 }], r;
  }return __extends(t, e), t.prototype.getConfig = function () {
    var t = e.prototype.getConfig.call(this);return delete t.rank, delete t.dataFormat, t;
  }, t.verifyArgs = function (e) {
    if ("number" != typeof e.kernelSize && !checkArrayTypeAndLength(e.kernelSize, "number", 1, 1)) throw new ValueError("Conv1D expects config.kernelSize to be number or number[] with length 1, but received " + JSON.stringify(e.kernelSize) + ".");
  }, t.className = "Conv1D", t;
}(Conv);tf_core_esm["_56" /* serialization */].registerClass(Conv1D);var Cropping2D = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return "number" == typeof t.cropping ? n.cropping = [[t.cropping, t.cropping], [t.cropping, t.cropping]] : "number" == typeof t.cropping[0] ? n.cropping = [[t.cropping[0], t.cropping[0]], [t.cropping[1], t.cropping[1]]] : n.cropping = t.cropping, n.dataFormat = void 0 === t.dataFormat ? "channelsLast" : t.dataFormat, n.inputSpec = [{ ndim: 4 }], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    return "channelsFirst" === this.dataFormat ? [e[0], e[1], e[2] - this.cropping[0][0] - this.cropping[0][1], e[3] - this.cropping[1][0] - this.cropping[1][1]] : [e[0], e[1] - this.cropping[0][0] - this.cropping[0][1], e[2] - this.cropping[1][0] - this.cropping[1][1], e[3]];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return e = getExactlyOneTensor(e), "channelsLast" === n.dataFormat ? sliceAlongAxis(sliceAlongAxis(e, n.cropping[0][0], e.shape[1] - n.cropping[0][0] - n.cropping[0][1], 2), n.cropping[1][0], e.shape[2] - n.cropping[1][1] - n.cropping[1][0], 3) : sliceAlongAxis(sliceAlongAxis(e, n.cropping[0][0], e.shape[2] - n.cropping[0][0] - n.cropping[0][1], 3), n.cropping[1][0], e.shape[3] - n.cropping[1][1] - n.cropping[1][0], 4);
    });
  }, t.prototype.getConfig = function () {
    var t = { cropping: this.cropping, dataFormat: this.dataFormat },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Cropping2D", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Cropping2D);var UpSampling2D = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.DEFAULT_SIZE = [2, 2], n.inputSpec = [{ ndim: 4 }], n.size = null == t.size ? n.DEFAULT_SIZE : t.size, n.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    if ("channelsFirst" === this.dataFormat) {
      var t = null == e[2] ? null : this.size[0] * e[2],
          n = null == e[3] ? null : this.size[1] * e[3];return [e[0], e[1], t, n];
    }t = null == e[1] ? null : this.size[0] * e[1], n = null == e[2] ? null : this.size[1] * e[2];return [e[0], t, n, e[3]];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e),
          r = t.shape;if ("channelsFirst" === n.dataFormat) {
        t = Object(tf_core_esm["_89" /* transpose */])(t, [0, 2, 3, 1]);var i = n.size[0] * r[2],
            a = n.size[1] * r[3],
            o = t.resizeNearestNeighbor([i, a]);return Object(tf_core_esm["_89" /* transpose */])(o, [0, 3, 1, 2]);
      }i = n.size[0] * r[1], a = n.size[1] * r[2];return t.resizeNearestNeighbor([i, a]);
    });
  }, t.prototype.getConfig = function () {
    var t = { size: this.size, dataFormat: this.dataFormat },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "UpSampling2D", t;
}(Layer);function depthwiseConv2d$1(e, t, n, r, i, a) {
  return void 0 === n && (n = [1, 1]), void 0 === r && (r = "valid"), Object(tf_core_esm["_85" /* tidy */])(function () {
    null == i && (i = imageDataFormat()), checkDataFormat(i);var o = preprocessConv2DInput(e, i);if (4 !== e.rank) throw new ValueError("Input for depthwiseConv2d is required to be 4-D, but is instead " + e.rank + "-D");if (4 !== t.rank) throw new ValueError("depthwiseKernel is required to be 4-D, but is instead " + t.rank + "-D");return o = Object(tf_core_esm["M" /* depthwiseConv2d */])(o, t, n, "same" === r ? "same" : "valid", "NHWC", a), "channelsFirst" === i && (o = Object(tf_core_esm["_89" /* transpose */])(o, [0, 3, 1, 2])), o;
  });
}tf_core_esm["_56" /* serialization */].registerClass(UpSampling2D);var DepthwiseConv2D = function (e) {
  function t(t) {
    var n = e.call(this, 2, t) || this;return n.depthwiseKernel = null, n.depthMultiplier = null == t.depthMultiplier ? 1 : t.depthMultiplier, n.depthwiseInitializer = getInitializer(t.depthwiseInitializer || n.DEFAULT_KERNEL_INITIALIZER), n.depthwiseConstraint = getConstraint(t.depthwiseConstraint), n.depthwiseRegularizer = getRegularizer(t.depthwiseRegularizer), n;
  }return __extends(t, e), t.prototype.build = function (e) {
    if ((e = getExactlyOneShape(e)).length < 4) throw new ValueError("Inputs to DepthwiseConv2D should have rank 4. Received input shape: " + JSON.stringify(e) + ".");var t = "channelsFirst" === this.dataFormat ? 1 : 3;if (null == e[t] || e[t] < 0) throw new ValueError("The channel dimension of the inputs to DepthwiseConv2D should be defined, but is not (" + e[t] + ").");var n = e[t],
        r = [this.kernelSize[0], this.kernelSize[1], n, this.depthMultiplier];this.depthwiseKernel = this.addWeight("depthwise_kernel", r, null, this.depthwiseInitializer, this.depthwiseRegularizer, !0, this.depthwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [n * this.depthMultiplier], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = depthwiseConv2d$1(e = getExactlyOneTensor(e), n.depthwiseKernel.read(), n.strides, n.padding, n.dataFormat, null);return n.useBias && (t = biasAdd(t, n.bias.read(), n.dataFormat)), null != n.activation && (t = n.activation.apply(t)), t;
    });
  }, t.prototype.computeOutputShape = function (e) {
    e = getExactlyOneShape(e);var t = "channelsFirst" === this.dataFormat ? e[2] : e[1],
        n = "channelsFirst" === this.dataFormat ? e[3] : e[2],
        r = "channelsFirst" === this.dataFormat ? e[1] * this.depthMultiplier : e[3] * this.depthMultiplier,
        i = convOutputLength(t, this.kernelSize[0], this.padding, this.strides[0]),
        a = convOutputLength(n, this.kernelSize[1], this.padding, this.strides[1]);return "channelsFirst" === this.dataFormat ? [e[0], r, i, a] : [e[0], i, a, r];
  }, t.prototype.getConfig = function () {
    var t = e.prototype.getConfig.call(this);return t.depthMultiplier = this.depthMultiplier, t.depthwiseInitializer = serializeInitializer(this.depthwiseInitializer), t.depthwiseRegularizer = serializeRegularizer(this.depthwiseRegularizer), t.depthwiseConstraint = serializeConstraint(this.depthwiseRegularizer), t;
  }, t.className = "DepthwiseConv2D", t;
}(BaseConv);tf_core_esm["_56" /* serialization */].registerClass(DepthwiseConv2D);var Dropout = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;if (n.rate = Math.max(Math.min(t.rate, 1), 0), n.rateScalar = getScalar(n.rate), n.noiseShape = t.noiseShape, n.seed = t.seed, null != n.seed) throw new NotImplementedError("Non-default seed is not implemented in Dropout layer yet: " + n.seed);return n.supportsMasking = !0, n;
  }return __extends(t, e), t.prototype.getNoiseShape = function (e) {
    if (null == this.noiseShape) return this.noiseShape;for (var t = e.shape, n = [], r = 0; r < this.noiseShape.length; ++r) {
      n.push(null == this.noiseShape[r] ? t[r] : this.noiseShape[r]);
    }return n;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t);var r = getExactlyOneTensor(e);if (null != n.noiseShape && !tf_core_esm["_92" /* util */].arraysEqual(r.shape, n.noiseShape)) throw new NotImplementedError("Non-default noise shape is not implemented in Dropout layer yet: " + JSON.stringify(n.noiseShape));if (0 < n.rate && n.rate < 1) {
        var i = null != t.training && t.training,
            a = n.getNoiseShape(r);return inTrainPhase(function () {
          return dropout(r, n.rateScalar, a, n.seed);
        }, function () {
          return r;
        }, i);
      }return e;
    });
  }, t.prototype.getConfig = function () {
    var t = { rate: this.rate, noiseShape: this.noiseShape, seed: this.seed },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Dropout", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Dropout);var Dense = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;if (n.activation = null, n.useBias = !0, n.kernel = null, n.bias = null, n.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", n.DEFAULT_BIAS_INITIALIZER = "zeros", null == t.batchInputShape && null == t.inputShape && null != t.inputDim) {
      var r = null;null != t.batchSize && (r = t.batchSize), n.batchInputShape = [r, t.inputDim];
    }return n.units = t.units, n.activation = getActivation(t.activation), null != t.useBias && (n.useBias = t.useBias), n.kernelInitializer = getInitializer(t.kernelInitializer || n.DEFAULT_KERNEL_INITIALIZER), n.biasInitializer = getInitializer(t.biasInitializer || n.DEFAULT_BIAS_INITIALIZER), n.kernelConstraint = getConstraint(t.kernelConstraint), n.biasConstraint = getConstraint(t.biasConstraint), n.kernelRegularizer = getRegularizer(t.kernelRegularizer), n.biasRegularizer = getRegularizer(t.biasRegularizer), n.activityRegularizer = getRegularizer(t.activityRegularizer), n.supportsMasking = !0, n.inputSpec = [{ minNDim: 2 }], n;
  }return __extends(t, e), t.prototype.build = function (e) {
    var t,
        n = (e = getExactlyOneShape(e))[e.length - 1];null == this.kernel && (this.kernel = this.addWeight("kernel", [n, this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint))), this.inputSpec = [{ minNDim: 2, axes: (t = {}, t[-1] = n, t) }], this.built = !0;
  }, t.prototype.computeOutputShape = function (e) {
    var t = (e = getExactlyOneShape(e)).slice();return t[t.length - 1] = this.units, t;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t);var r = dot(getExactlyOneTensor(e), n.kernel.read());return null != n.bias && (r = biasAdd(r, n.bias.read())), null != n.activation && (r = n.activation.apply(r)), r;
    });
  }, t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), biasInitializer: serializeInitializer(this.biasInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), biasConstraint: serializeConstraint(this.biasConstraint) },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Dense", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Dense);var Flatten = function (e) {
  function t(t) {
    var n = e.call(this, t || {}) || this;return n.inputSpec = [{ minNDim: 3 }], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    for (var t = 0, n = (e = getExactlyOneShape(e)).slice(1); t < n.length; t++) {
      if (null == n[t]) throw new ValueError('The shape of the input to "Flatten" is not fully defined (got ' + e.slice(1) + '). Make sure to pass a complete "input_shape" or "batch_input_shape" argument to the first layer in your model.');
    }return [e[0], arrayProd(e, 1)];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return n.invokeCallHook(e, t), batchFlatten(getExactlyOneTensor(e));
    });
  }, t.className = "Flatten", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Flatten);var Activation$1 = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.supportsMasking = !0, n.activation = getActivation(t.activation), n;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t);var r = getExactlyOneTensor(e);return n.activation.apply(r);
    });
  }, t.prototype.getConfig = function () {
    var t = { activation: serializeActivation(this.activation) },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Activation", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Activation$1);var RepeatVector = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.n = t.n, n.inputSpec = [{ ndim: 2 }], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    return [e[0], this.n, e[1]];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return repeat(e = getExactlyOneTensor(e), n.n);
    });
  }, t.prototype.getConfig = function () {
    var t = { n: this.n },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "RepeatVector", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(RepeatVector);var Reshape = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;n.targetShape = t.targetShape;for (var r = 0; r < n.targetShape.length; ++r) {
      n.isUnknown(n.targetShape[r]) && (n.targetShape[r] = null);
    }return n;
  }return __extends(t, e), t.prototype.isUnknown = function (e) {
    return e < 0 || null == e;
  }, t.prototype.fixUnknownDimension = function (e, t) {
    for (var n = "Total size of new array must be unchanged.", r = t.slice(), i = 1, a = null, o = 0; o < r.length; ++o) {
      var s = r[o];if (this.isUnknown(s)) {
        if (null !== a) throw new ValueError("Can only specifiy one unknown dimension.");a = o;
      } else i *= s;
    }var l = arrayProd(e);if (null !== a) {
      if (0 === i || l % i != 0) throw new ValueError(n);r[a] = l / i;
    } else if (l !== i) throw new ValueError(n);return r;
  }, t.prototype.computeOutputShape = function (e) {
    for (var t = !1, n = 0; n < e.length; ++n) {
      if (this.isUnknown(e[n])) {
        t = !0;break;
      }
    }return t ? e.slice(0, 1).concat(this.targetShape) : e.slice(0, 1).concat(this.fixUnknownDimension(e.slice(1), this.targetShape));
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t);var r = getExactlyOneTensor(e),
          i = r.shape,
          a = i.slice(0, 1).concat(n.fixUnknownDimension(i.slice(1), n.targetShape));return r.reshape(a);
    });
  }, t.prototype.getConfig = function () {
    var t = { targetShape: this.targetShape },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Reshape", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Reshape);var Permute = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;if (null == t.dims) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");if (!Array.isArray(t.dims)) throw new Error("Permute constructor requires `dims` to be an Array, but received " + t.dims + " instead.");var r = range(1, t.dims.length + 1);if (!tf_core_esm["_92" /* util */].arraysEqual(t.dims.slice().sort(), r)) throw new Error("Invalid permutation `dims`: " + JSON.stringify(t.dims) + " `dims` must contain consecutive integers starting from 1.");return n.dims = t.dims, n.dimsIncludingBatch = [0].concat(n.dims), n.inputSpec = [new InputSpec({ ndim: n.dims.length + 1 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    var t = (e = getExactlyOneShape(e)).slice();return this.dims.forEach(function (n, r) {
      t[r + 1] = e[n];
    }), t;
  }, t.prototype.call = function (e, t) {
    return Object(tf_core_esm["_89" /* transpose */])(getExactlyOneTensor(e), this.dimsIncludingBatch);
  }, t.prototype.getConfig = function () {
    var t = { dims: this.dims },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Permute", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Permute);var Embedding = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;if (n.embeddings = null, n.DEFAULT_EMBEDDINGS_INITIALIZER = "randomUniform", null == t.batchInputShape && null == t.inputShape) {
      var r = null;null != t.batchSize && (r = t.batchSize), null == t.inputLength ? n.batchInputShape = [r, null] : n.batchInputShape = [r].concat(toList(t.inputLength));
    }return n.inputDim = t.inputDim, n.outputDim = t.outputDim, n.embeddingsInitializer = getInitializer(t.embeddingsInitializer || n.DEFAULT_EMBEDDINGS_INITIALIZER), n.embeddingsRegularizer = getRegularizer(t.embeddingsRegularizer), n.activityRegularizer = getRegularizer(t.activityRegularizer), n.embeddingsConstraint = getConstraint(t.embeddingsConstraint), n.maskZero = t.maskZero, n.supportsMasking = t.maskZero, n.inputLength = t.inputLength, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    this.embeddings = this.addWeight("embeddings", [this.inputDim, this.outputDim], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, !0, this.embeddingsConstraint), this.built = !0;
  }, t.prototype.warnOnIncompatibleInputShape = function (e) {}, t.prototype.computeMask = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return n.maskZero ? (e = getExactlyOneTensor(e), Object(tf_core_esm["_35" /* notEqual */])(e, Object(tf_core_esm["_98" /* zerosLike */])(e))) : null;
    });
  }, t.prototype.computeOutputShape = function (e) {
    if (e = getExactlyOneShape(e), null == this.inputLength) return e.concat([this.outputDim]);var t = toList(this.inputLength);if (t.length !== e.length - 1) throw new ValueError('"inputLength" is ' + this.inputLength + ", but received input shape has shape " + e);for (var n = 0, r = 0; r < t.length; ++r) {
      var i = t[r],
          a = e[r + 1];if (null != i && null != a && i !== a) throw new ValueError('"inputLength" is ' + this.inputLength + ", but received input shape has shape " + e);null == i && (t[n] = a), n++;
    }return [e[0]].concat(t, [this.outputDim]);
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t);var r = getExactlyOneTensor(e);return "int32" !== r.dtype && (r = cast$1(r, "int32")), gather$1(n.embeddings.read(), r.as1D()).reshape(getExactlyOneShape(n.computeOutputShape(r.shape)));
    });
  }, t.prototype.getConfig = function () {
    var t = { inputDim: this.inputDim, outputDim: this.outputDim, embeddingsInitializer: serializeInitializer(this.embeddingsInitializer), embeddingsRegularizer: serializeRegularizer(this.embeddingsRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), embeddingsConstraint: serializeConstraint(this.embeddingsConstraint), maskZero: this.maskZero, inputLength: this.inputLength },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Embedding", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(Embedding);var Merge = function (e) {
  function t(t) {
    var n = e.call(this, t || {}) || this;return n.supportsMasking = !0, n;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    throw new NotImplementedError();
  }, t.prototype.computeElementwiseOpOutputShape = function (e, t) {
    if (null == e || null == t) return null;if (e.length < t.length) return this.computeElementwiseOpOutputShape(t, e);if (0 === t.length) return e;for (var n = e.slice(0, e.length - t.length), r = 0; r < t.length; ++r) {
      var i = e[e.length - t.length + r],
          a = t[r];if (null == i || null == a || i < 0 || a < 0) n.push(null);else if (1 === i) n.push(a);else if (1 === a) n.push(i);else {
        if (i !== a) throw new ValueError("Operands could not be broadcast together with shapes " + JSON.stringify(e) + " " + JSON.stringify(t));n.push(i);
      }
    }return n;
  }, t.prototype.build = function (e) {
    if (Array.isArray(e) && !Array.isArray(e[0]) && (e = [getExactlyOneShape(e)]), (e = e).length < 2) throw new ValueError("A merge layer should be called on an Array of at least 2 inputs. Got " + e.length + " input(s).");for (var t = [], n = 0, r = e; n < r.length; n++) {
      null != (o = r[n]) && null !== o[0] && t.push(o[0]);
    }if ((t = unique(t)).length > 1) throw new ValueError("Can not merge tensors with different batch sizes. Got tensors with shapes: " + JSON.stringify(e) + ".");for (var i = null == e[0] ? null : e[0].slice(1), a = 1; a < e.length; ++a) {
      var o = null == e[a] ? null : e[a].slice(1);i = this.computeElementwiseOpOutputShape(i, o);
    }var s = e.map(function (e) {
      return e.length;
    });-1 === e.indexOf(null) && 1 === unique(s).length ? this.reshapeRequired = !1 : this.reshapeRequired = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (e = e, n.reshapeRequired) {
        var t = [],
            r = e.map(function (e) {
          return e.rank;
        });if (-1 === r.indexOf(null)) {
          for (var i = max$1(r), a = 0, o = e; a < o.length; a++) {
            for (var s = (p = o[a]).rank, l = 0; l < i - s; ++l) {
              p = expandDims$1(p, 1);
            }t.push(p);
          }return n.mergeFunction(t);
        }for (var u = !1, c = 0, h = e; c < h.length; c++) {
          var p;if (null == (s = (p = h[c]).rank)) {
            var d = p.shape,
                g = d[0],
                f = d.slice(1).concat([g]),
                m = p.reshape([g].concat(arrayProd(d.slice(1))));m = (m = Object(tf_core_esm["_89" /* transpose */])(m, [1, 0])).reshape(f), t.push(m), u = !0;
          } else if (s > 1) {
            var y = range(1, s).concat([0]);t.push(Object(tf_core_esm["_89" /* transpose */])(p, y)), u = !0;
          } else t.push(p);
        }var v = n.mergeFunction(t),
            b = v.rank;if (u) if (null == b) {
          var w = v.shape;f = [g = w[w.length - 1]].concat(w.slice(0, w.length - 1));v = Object(tf_core_esm["_89" /* transpose */])(v.reshape([-1, g]), [1, 0]).reshape(f);
        } else if (b > 1) {
          y = [b - 1].concat(range(0, b - 1));v = Object(tf_core_esm["_89" /* transpose */])(v, y);
        }return v;
      }return n.mergeFunction(e);
    });
  }, t.prototype.computeOutputShape = function (e) {
    var t;t = null == (e = e)[0] ? null : e[0].slice(1);for (var n = 1; n < e.length; ++n) {
      var r = null == e[n] ? null : e[n].slice(1);t = this.computeElementwiseOpOutputShape(t, r);
    }for (var i = [], a = 0, o = e; a < o.length; a++) {
      null != (r = o[a]) && null !== r[0] && i.push(r[0]);
    }return t = 1 === (i = unique(i)).length ? i.concat(t) : [null].concat(t);
  }, t.prototype.computeMask = function (e, t) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (null == t) return null;if (!Array.isArray(t)) throw new ValueError("`mask` should be an Array");if (!Array.isArray(e)) throw new ValueError("`inputs` should be an Array");if (t.length !== e.length) throw new ValueError("The Array 'inputs' and 'mask' are expected to have the same length, but have different lengths (" + e.length + " vs " + t.length + ")");if (t.every(function (e) {
        return null == e;
      })) return null;for (var n = (t = t.map(function (e) {
        return null == e ? e : Object(tf_core_esm["T" /* expandDims */])(e, 0);
      }))[0], r = 1; r < t.length - 1; ++r) {
        n = Object(tf_core_esm["_18" /* logicalAnd */])(n, t[r]);
      }return n;
    });
  }, t;
}(Layer),
    Add = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var t = e[0].clone(), n = 1; n < e.length; ++n) {
        t = Object(tf_core_esm["g" /* add */])(t, e[n]);
      }return t;
    });
  }, t.className = "Add", t;
}(Merge);tf_core_esm["_56" /* serialization */].registerClass(Add);var Multiply = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var t = e[0].clone(), n = 1; n < e.length; ++n) {
        t = Object(tf_core_esm["_31" /* mul */])(t, e[n]);
      }return t;
    });
  }, t.className = "Multiply", t;
}(Merge);tf_core_esm["_56" /* serialization */].registerClass(Multiply);var Average = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var t = e[0].clone(), n = 1; n < e.length; ++n) {
        t = Object(tf_core_esm["g" /* add */])(t, e[n]);
      }return Object(tf_core_esm["_31" /* mul */])(getScalar(1 / e.length), t);
    });
  }, t.className = "Average", t;
}(Merge);tf_core_esm["_56" /* serialization */].registerClass(Average);var Maximum = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var t = e[0], n = 1; n < e.length; ++n) {
        t = Object(tf_core_esm["_24" /* maximum */])(t, e[n]);
      }return t;
    });
  }, t.className = "Maximum", t;
}(Merge);tf_core_esm["_56" /* serialization */].registerClass(Maximum);var Minimum = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.mergeFunction = function (e) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var t = e[0], n = 1; n < e.length; ++n) {
        t = Object(tf_core_esm["_28" /* minimum */])(t, e[n]);
      }return t;
    });
  }, t.className = "Minimum", t;
}(Merge);tf_core_esm["_56" /* serialization */].registerClass(Minimum);var Concatenate = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.DEFAULT_AXIS = -1, null == t && (t = {}), n.axis = null == t.axis ? n.DEFAULT_AXIS : t.axis, n.supportsMasking = !0, n.reshapeRequired = !1, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    if (!Array.isArray(e) || !Array.isArray(e[0]) || 1 === e.length) throw new ValueError("A `Concatenate` layer should be called on a list of at least 2 inputs");for (var t = !0, n = 0, r = e = e; n < r.length; n++) {
      if (null != (c = r[n])) {
        t = !1;break;
      }
    }if (!t) {
      for (var i = [], a = 0; a < e.length; ++a) {
        var o = e[a].slice();o.splice(this.axis, 1);for (var s = !1, l = 0, u = i; l < u.length; l++) {
          var c = u[l];if (tf_core_esm["_92" /* util */].arraysEqual(c, o)) {
            s = !0;break;
          }
        }s || i.push(o);
      }if (i.length > 1) throw new ValueError("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(e));
    }
  }, t.prototype.mergeFunction = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return concatenate(e, t.axis);
    });
  }, t.prototype.computeOutputShape = function (e) {
    if (!Array.isArray(e) || !Array.isArray(e[0])) throw new ValueError("A `Concatenate` layer should be called on a list of inputs.");for (var t = e, n = t[0].slice(), r = this.axis < 0 ? n.length + this.axis : this.axis, i = 0, a = t.slice(1); i < a.length; i++) {
      var o = a[i];if (null == n[r] || null == o[r]) {
        n[r] = null;break;
      }n[r] += o[r];
    }return n;
  }, t.prototype.computeMask = function (e, t) {
    var n = this;if (null == t) return null;if (!Array.isArray(t)) throw new ValueError("`mask` should be an array for Concatenate");if (!Array.isArray(e)) throw new ValueError("`inputs` should be an array for Concatenate");if (t.length !== e.length) throw new ValueError("Mismatch in the length of mask (" + t.length + ") and the legnth of inputs (" + e.length + ")");return Object(tf_core_esm["_85" /* tidy */])(function () {
      var r = !0;if (t.forEach(function (e) {
        null == e || (r = !1);
      }), r) return null;for (var i = [], a = 0; a < e.length; ++a) {
        null == t[a] ? i.push(Object(tf_core_esm["_38" /* onesLike */])(e[a]).asType("bool")) : t[a].rank < e[a].rank ? i.push(Object(tf_core_esm["T" /* expandDims */])(t[a], -1)) : i.push(t[a]);
      }var o = Object(tf_core_esm["B" /* concat */])(i, n.axis);return Object(tf_core_esm["i" /* all */])(o, -1, !1);
    });
  }, t.prototype.getConfig = function () {
    var t = { axis: this.axis },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Concatenate", t;
}(Merge);function interpretAxis(e, t) {
  for (; e < 0;) {
    e += t;
  }return e;
}function batchDot(e, t, n) {
  if (e.shape.length > 3 || t.shape.length > 3) throw new NotImplementedError("batchDot is not implemented for tensors of 4D or higher rank yet");if (tf_core_esm["_92" /* util */].assert(e.shape.length >= 2, "batchDot requires the rank of x to be >= 2, but got " + e.shape.length), tf_core_esm["_92" /* util */].assert(e.shape.length >= 2, "batchDot requires the rank of y to be >= 2, but got " + t.shape.length), "number" == typeof n && (n = [n, n]), "complex64" === e.dtype || "complex64" === t.dtype) throw new NotImplementedError("batchDot is not implemented for complex64-type Tensors yet.");var r = e.shape.length,
      i = t.shape.length;null == n && (n = [r - 1, i - 2]);var a = n;return Object(tf_core_esm["_85" /* tidy */])(function () {
    var n, o;if (r > i) {
      n = r - i;for (var s = [], l = 0; l < n; ++l) {
        s.push(1);
      }t = t.reshape(t.shape.concat(s));
    } else if (i > r) {
      n = i - r;for (s = [], l = 0; l < n; ++l) {
        s.push(1);
      }e = e.reshape(e.shape.concat(s));
    } else n = 0;if (2 === e.shape.length && 2 === t.shape.length) o = a[0] === a[1] ? e.mulStrict(t).sum(a[0]) : e.transpose([1, 0]).mulStrict(t).sum(a[1]);else {
      var u = a[0] !== e.shape.length - 1 || null,
          c = a[1] === t.shape.length - 1 || null;o = e.matMul(t, u, c);
    }if (n > 0) {
      var h = void 0,
          p = [];for (l = h = r > i ? r + i - 3 : r - 1; l < h + n; ++l) {
        p.push(l);
      }o = o.squeeze(p);
    }return 1 === o.shape.length && (o = o.expandDims(1)), o;
  });
}tf_core_esm["_56" /* serialization */].registerClass(Concatenate);var Dot = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.axes = t.axes, n.normalize = null != t.normalize && t.normalize, n.supportsMasking = !0, n.reshapeRequired = !1, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    tf_core_esm["_92" /* util */].assert(Array.isArray(e) && 2 === e.length && Array.isArray(e[0]) && Array.isArray(e[1]), "A `Dot` layer should be called on a list of exactly 2 inputs.");var t = e[0],
        n = e[1];if (t.length > 3 || n.length > 3) throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");var r = this.interpretAxes(t, n);if (t[r[0]] !== n[r[1]]) throw new ValueError("Dimension incompatibility: " + t[r[0]] + " !== " + n[r[1]]);
  }, t.prototype.mergeFunction = function (e) {
    if (2 !== e.length) throw new ValueError("A `Dot` layer must be called on exactly 2 inputs, but received " + e.length + " input(s).");var t,
        n = e[0],
        r = e[1];return t = Array.isArray(this.axes) ? this.axes.map(function (t, n) {
      return interpretAxis(t, e[n].shape.length);
    }) : [interpretAxis(this.axes, n.shape.length), interpretAxis(this.axes, r.shape.length)], this.normalize && (n = l2Normalize(n, t[0]), r = l2Normalize(r, t[1])), batchDot(n, r, t);
  }, t.prototype.interpretAxes = function (e, t) {
    return Array.isArray(this.axes) ? this.axes : [interpretAxis(this.axes, e.length), interpretAxis(this.axes, t.length)];
  }, t.prototype.computeOutputShape = function (e) {
    tf_core_esm["_92" /* util */].assert(Array.isArray(e) && 2 === e.length && Array.isArray(e[0]) && Array.isArray(e[1]), "A `Dot` layer should be called on a list of exactly 2 inputs.");var t = e[0].slice(),
        n = e[1].slice();if (t.length > 3 || n.length > 3) throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");var r = this.interpretAxes(t, n);t.splice(r[0], 1), n.splice(r[1], 1), n.splice(0, 1);var i = t.concat(n);return 1 === i.length && i.push(1), i;
  }, t.prototype.computeMask = function (e, t) {
    return null;
  }, t.prototype.getConfig = function () {
    var t = { axes: this.axes, normalize: this.normalize },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "Dot", t;
}(Merge);function batchNormalization(e, t, n, r, i, a) {
  var o;if (void 0 === a && (a = .001), 2 === e.rank) o = Object(tf_core_esm["t" /* batchNormalization2d */])(e, t, n, a, i, r);else if (3 === e.rank) o = Object(tf_core_esm["u" /* batchNormalization3d */])(e, t, n, a, i, r);else {
    if (4 !== e.rank) throw new NotImplementedError("batchNormalization is not implemented for array of rank " + e.rank + " yet");o = Object(tf_core_esm["v" /* batchNormalization4d */])(e, t, n, a, i, r);
  }return o;
}function regularNormalizeBatchInTraining(e, t, n, r, i) {
  return void 0 === i && (i = .001), Object(tf_core_esm["_85" /* tidy */])(function () {
    var a = Object(tf_core_esm["_30" /* moments */])(e, r),
        o = a.mean,
        s = a.variance;return [batchNormalization(e, o, s, n, t, i), o, s];
  });
}function broadcastNormalizeBatchInTraining(e, t, n, r, i) {
  return void 0 === i && (i = .001), Object(tf_core_esm["_85" /* tidy */])(function () {
    for (var a = Object(tf_core_esm["_30" /* moments */])(e, r), o = a.mean, s = a.variance, l = [], u = 0, c = range(0, e.rank); u < c.length; u++) {
      var h = c[u];-1 !== r.indexOf(h) ? l.push(1) : l.push(e.shape[h]);
    }var p = o.reshape(l),
        d = s.reshape(l),
        g = null == t ? null : t.reshape(l),
        f = null == n ? null : n.reshape(l);return [batchNormalization(e, p, d, f, g, i), o, s];
  });
}function normalizeBatchInTraining(e, t, n, r, i) {
  return void 0 === i && (i = .001), tf_core_esm["_92" /* util */].arraysEqual(r.slice().sort(), range(0, e.rank - 1)) ? regularNormalizeBatchInTraining(e, t, n, r, i) : broadcastNormalizeBatchInTraining(e, t, n, r, i);
}tf_core_esm["_56" /* serialization */].registerClass(Dot);var BatchNormalization = function (e) {
  function t(t) {
    var n = this;return null == t && (t = {}), (n = e.call(this, t) || this).supportsMasking = !0, n.axis = null == t.axis ? -1 : t.axis, n.momentum = null == t.momentum ? .99 : t.momentum, n.epsilon = null == t.epsilon ? .001 : t.epsilon, n.center = null == t.center || t.center, n.scale = null == t.scale || t.scale, n.betaInitializer = getInitializer(t.betaInitializer || "zeros"), n.gammaInitializer = getInitializer(t.gammaInitializer || "ones"), n.movingMeanInitializer = getInitializer(t.movingMeanInitializer || "zeros"), n.movingVarianceInitializer = getInitializer(t.movingVarianceInitializer || "ones"), n.betaConstraint = getConstraint(t.betaConstraint), n.gammaConstraint = getConstraint(t.gammaConstraint), n.betaRegularizer = getRegularizer(t.betaRegularizer), n.gammaRegularizer = getRegularizer(t.gammaRegularizer), n;
  }return __extends(t, e), t.prototype.build = function (e) {
    e = getExactlyOneShape(e);var t = this.axis >= 0 ? this.axis : this.axis + e.length,
        n = e[t];if (null == n) throw new ValueError("Axis " + t + " of input tensor should have a defined dimension but the layer received an input with shape " + JSON.stringify(e) + ".");this.inputSpec = [new InputSpec({ ndim: e.length, axes: (r = {}, r[t] = n, r) })];var r,
        i = [n];this.scale && (this.gamma = this.addWeight("gamma", i, null, this.gammaInitializer, this.gammaRegularizer, !0, this.gammaConstraint)), this.center && (this.beta = this.addWeight("beta", i, null, this.betaInitializer, this.betaRegularizer, !0, this.betaConstraint)), this.movingMean = this.addWeight("moving_mean", i, null, this.movingMeanInitializer, null, !1), this.movingVariance = this.addWeight("moving_variance", i, null, this.movingVarianceInitializer, null, !1), this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var r = null != t.training && t.training,
          i = getExactlyOneTensor(e),
          a = i.shape,
          o = a.length,
          s = range(0, o),
          l = n.axis >= 0 ? n.axis : n.axis + o;s.splice(l, 1);var u = pyListRepeat(1, o);u[l] = a[l];var c = s.slice();c.sort();var h = !tf_core_esm["_92" /* util */].arraysEqual(c, range(0, o).slice(0, o - 1));if (!r) return function () {
        if (h) {
          var e = n.movingMean.read().reshape(u),
              t = n.movingVariance.read().reshape(u),
              r = n.center ? n.beta.read().reshape(u) : null,
              a = n.scale ? n.gamma.read().reshape(u) : null;return batchNormalization(i, e, t, r, a, n.epsilon);
        }return batchNormalization(i, n.movingMean.read(), n.movingVariance.read(), null == n.beta ? null : n.beta.read(), null == n.gamma ? null : n.gamma.read(), n.epsilon);
      }();var p = normalizeBatchInTraining(i, n.gamma.read(), n.beta.read(), s, n.epsilon),
          d = p[0],
          g = p[1],
          f = p[2],
          m = function m(e, t, n) {
        Object(tf_core_esm["_85" /* tidy */])(function () {
          var r = getScalar(1).sub(getScalar(n)),
              i = e.read(),
              a = i.sub(t).mul(r);e.write(i.sub(a));
        });
      };return m(n.movingMean, g, n.momentum), m(n.movingVariance, f, n.momentum), d;
    });
  }, t.prototype.getConfig = function () {
    var t = { axis: this.axis, momentum: this.momentum, epsilon: this.epsilon, center: this.center, scale: this.scale, betaInitializer: serializeInitializer(this.betaInitializer), gammaInitializer: serializeInitializer(this.gammaInitializer), movingMeanInitializer: serializeInitializer(this.movingMeanInitializer), movingVarianceInitializer: serializeInitializer(this.movingVarianceInitializer), betaRegularizer: serializeRegularizer(this.betaRegularizer), gammaRegularizer: serializeRegularizer(this.gammaRegularizer), betaConstraint: serializeConstraint(this.betaConstraint), gammaConstraint: serializeConstraint(this.gammaConstraint) },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "BatchNormalization", t;
}(Layer);function spatial2dPadding(e, t, n) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    if (4 !== e.rank) throw new ValueError("temporalPadding expects input tensor to be 4-D, but received a " + e.rank + "-D tensor.");if (null == t && (t = [[1, 1], [1, 1]]), 2 !== t.length || 2 !== t[0].length || 2 !== t[1].length) throw new ValueError("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");if (null == n && (n = imageDataFormat()), "channelsLast" !== n && "channelsFirst" !== n) throw new ValueError("Unknown data format: " + n + ". Supported data formats are 'channelsLast' and 'channelsFirst.");var r;return r = "channelsFirst" === n ? [[0, 0], [0, 0], t[0], t[1]] : [[0, 0], t[0], t[1], [0, 0]], Object(tf_core_esm["_39" /* pad */])(e, r);
  });
}tf_core_esm["_56" /* serialization */].registerClass(BatchNormalization);var ZeroPadding2D = function (e) {
  function t(t) {
    var n = this;if (null == t && (t = {}), (n = e.call(this, t) || this).dataFormat = null == t.dataFormat ? imageDataFormat() : t.dataFormat, null == t.padding) n.padding = [[1, 1], [1, 1]];else if ("number" == typeof t.padding) n.padding = [[t.padding, t.padding], [t.padding, t.padding]];else {
      if (t.padding = t.padding, 2 !== t.padding.length) throw new ValueError("ZeroPadding2D expects padding to be a length-2 array, but received a length-" + t.padding.length + " array.");var r = void 0,
          i = void 0;if ("number" == typeof t.padding[0]) r = [t.padding[0], t.padding[0]], i = [t.padding[1], t.padding[1]];else {
        if (t.padding = t.padding, 2 !== t.padding[0].length) throw new ValueError("ZeroPadding2D expects height padding to be a length-2 array, but received a length-" + t.padding[0].length + " array.");if (r = t.padding[0], 2 !== t.padding[1].length) throw new ValueError("ZeroPadding2D expects width padding to be a length-2 array, but received a length-" + t.padding[1].length + " array.");i = t.padding[1];
      }n.padding = [r, i];
    }return n.inputSpec = [new InputSpec({ ndim: 4 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    var t, n;return e = getExactlyOneShape(e), "channelsFirst" === this.dataFormat ? (t = null != e[2] && e[2] >= 0 ? e[2] + this.padding[0][0] + this.padding[0][1] : null, n = null != e[3] && e[3] >= 0 ? e[3] + this.padding[1][0] + this.padding[1][1] : null, [e[0], e[1], t, n]) : (t = null != e[1] && e[1] >= 0 ? e[1] + this.padding[0][0] + this.padding[0][1] : null, n = null != e[2] && e[2] >= 0 ? e[2] + this.padding[1][0] + this.padding[1][1] : null, [e[0], t, n, e[3]]);
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return spatial2dPadding(getExactlyOneTensor(e), n.padding, n.dataFormat);
    });
  }, t.prototype.getConfig = function () {
    var t = { padding: this.padding, dataFormat: this.dataFormat },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "ZeroPadding2D", t;
}(Layer);function pool2d(e, t, n, r, i, a) {
  return Object(tf_core_esm["_85" /* tidy */])(function () {
    var o;checkDataFormat(i), checkPoolMode(a), checkPaddingMode(r), null == n && (n = [1, 1]), null == r && (r = "valid"), null == i && (i = imageDataFormat()), null == a && (a = "max"), e = preprocessConv2DInput(e, i);var s = "same" === r ? "same" : "valid";return o = "max" === a ? Object(tf_core_esm["_23" /* maxPool */])(e, t, n, s) : Object(tf_core_esm["r" /* avgPool */])(e, t, n, s), "channelsFirst" === i && (o = Object(tf_core_esm["_89" /* transpose */])(o, [0, 3, 1, 2])), o;
  });
}tf_core_esm["_56" /* serialization */].registerClass(ZeroPadding2D);var Pooling1D = function (e) {
  function t(t) {
    var n = this;if (null == t.poolSize && (t.poolSize = 2), n = e.call(this, t) || this, "number" == typeof t.poolSize) n.poolSize = [t.poolSize];else {
      if (!Array.isArray(t.poolSize) || 1 !== t.poolSize.length || "number" != typeof t.poolSize[0]) throw new ValueError("poolSize for 1D convolutional layer must be a number or an Array of a single number, but received " + JSON.stringify(t.poolSize));n.poolSize = t.poolSize;
    }if (null == t.strides) n.strides = n.poolSize;else if ("number" == typeof t.strides) n.strides = [t.strides];else {
      if (!Array.isArray(t.strides) || 1 !== t.strides.length || "number" != typeof t.strides[0]) throw new ValueError("strides for 1D convolutional layer must be a number or an Array of a single number, but received " + JSON.stringify(t.strides));n.strides = t.strides;
    }return n.padding = null == t.padding ? "valid" : t.padding, checkPaddingMode(n.padding), n.inputSpec = [new InputSpec({ ndim: 3 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    var t = convOutputLength((e = getExactlyOneShape(e))[1], this.poolSize[0], this.padding, this.strides[0]);return [e[0], t, e[2]];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      n.invokeCallHook(e, t), e = expandDims$1(getExactlyOneTensor(e), 2);var r = n.poolingFunction(getExactlyOneTensor(e), [n.poolSize[0], 1], [n.strides[0], 1], n.padding, "channelsLast");return Object(tf_core_esm["_75" /* squeeze */])(r, [2]);
    });
  }, t.prototype.getConfig = function () {
    var t = { poolSize: this.poolSize, padding: this.padding, strides: this.strides },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t;
}(Layer),
    MaxPooling1D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.poolingFunction = function (e, t, n, r, i) {
    return checkDataFormat(i), checkPaddingMode(r), pool2d(e, t, n, r, i, "max");
  }, t.className = "MaxPooling1D", t;
}(Pooling1D);tf_core_esm["_56" /* serialization */].registerClass(MaxPooling1D);var AveragePooling1D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.poolingFunction = function (e, t, n, r, i) {
    return checkDataFormat(i), checkPaddingMode(r), pool2d(e, t, n, r, i, "avg");
  }, t.className = "AveragePooling1D", t;
}(Pooling1D);tf_core_esm["_56" /* serialization */].registerClass(AveragePooling1D);var Pooling2D = function (e) {
  function t(t) {
    var n = this;if (null == t.poolSize && (t.poolSize = [2, 2]), (n = e.call(this, t) || this).poolSize = Array.isArray(t.poolSize) ? t.poolSize : [t.poolSize, t.poolSize], null == t.strides) n.strides = n.poolSize;else if (Array.isArray(t.strides)) {
      if (2 !== t.strides.length) throw new ValueError("If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length " + t.strides.length + ".");n.strides = t.strides;
    } else n.strides = [t.strides, t.strides];return n.padding = null == t.padding ? "valid" : t.padding, n.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, checkDataFormat(n.dataFormat), checkPaddingMode(n.padding), n.inputSpec = [new InputSpec({ ndim: 4 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    e = getExactlyOneShape(e);var t = "channelsFirst" === this.dataFormat ? e[2] : e[1],
        n = "channelsFirst" === this.dataFormat ? e[3] : e[2];return t = convOutputLength(t, this.poolSize[0], this.padding, this.strides[0]), n = convOutputLength(n, this.poolSize[1], this.padding, this.strides[1]), "channelsFirst" === this.dataFormat ? [e[0], e[1], t, n] : [e[0], t, n, e[3]];
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return n.invokeCallHook(e, t), n.poolingFunction(getExactlyOneTensor(e), n.poolSize, n.strides, n.padding, n.dataFormat);
    });
  }, t.prototype.getConfig = function () {
    var t = { poolSize: this.poolSize, padding: this.padding, strides: this.strides, dataFormat: this.dataFormat },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t;
}(Layer),
    MaxPooling2D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.poolingFunction = function (e, t, n, r, i) {
    return checkDataFormat(i), checkPaddingMode(r), pool2d(e, t, n, r, i, "max");
  }, t.className = "MaxPooling2D", t;
}(Pooling2D);tf_core_esm["_56" /* serialization */].registerClass(MaxPooling2D);var AveragePooling2D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.poolingFunction = function (e, t, n, r, i) {
    return checkDataFormat(i), checkPaddingMode(r), pool2d(e, t, n, r, i, "avg");
  }, t.className = "AveragePooling2D", t;
}(Pooling2D);tf_core_esm["_56" /* serialization */].registerClass(AveragePooling2D);var GlobalPooling1D = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.inputSpec = [new InputSpec({ ndim: 3 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    return [e[0], e[2]];
  }, t.prototype.call = function (e, t) {
    throw new NotImplementedError();
  }, t;
}(Layer),
    GlobalAveragePooling1D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e);return Object(tf_core_esm["_25" /* mean */])(t, 1);
    });
  }, t.className = "GlobalAveragePooling1D", t;
}(GlobalPooling1D);tf_core_esm["_56" /* serialization */].registerClass(GlobalAveragePooling1D);var GlobalMaxPooling1D = function (e) {
  function t(t) {
    return e.call(this, t) || this;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e);return Object(tf_core_esm["_22" /* max */])(t, 1);
    });
  }, t.className = "GlobalMaxPooling1D", t;
}(GlobalPooling1D);tf_core_esm["_56" /* serialization */].registerClass(GlobalMaxPooling1D);var GlobalPooling2D = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, checkDataFormat(n.dataFormat), n.inputSpec = [new InputSpec({ ndim: 4 })], n;
  }return __extends(t, e), t.prototype.computeOutputShape = function (e) {
    return e = e, "channelsLast" === this.dataFormat ? [e[0], e[3]] : [e[0], e[1]];
  }, t.prototype.call = function (e, t) {
    throw new NotImplementedError();
  }, t.prototype.getConfig = function () {
    var t = { dataFormat: this.dataFormat },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t;
}(Layer),
    GlobalAveragePooling2D = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e);return "channelsLast" === n.dataFormat ? Object(tf_core_esm["_25" /* mean */])(t, [1, 2]) : Object(tf_core_esm["_25" /* mean */])(t, [2, 3]);
    });
  }, t.className = "GlobalAveragePooling2D", t;
}(GlobalPooling2D);tf_core_esm["_56" /* serialization */].registerClass(GlobalAveragePooling2D);var GlobalMaxPooling2D = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var t = getExactlyOneTensor(e);return "channelsLast" === n.dataFormat ? Object(tf_core_esm["_22" /* max */])(t, [1, 2]) : Object(tf_core_esm["_22" /* max */])(t, [2, 3]);
    });
  }, t.className = "GlobalMaxPooling2D", t;
}(GlobalPooling2D);function standardizeArgs(e, t, n, r) {
  if (Array.isArray(e)) {
    if (null != t || null != n) throw new ValueError("When inputs is an array, neither initialState or constants should be provided");null != r && (n = e.slice(e.length - r, e.length), e = e.slice(0, e.length - r)), e.length > 1 && (t = e.slice(1, e.length)), e = e[0];
  }function i(e) {
    return null == e || Array.isArray(e) ? e : [e];
  }return { inputs: e, initialState: t = i(t), constants: n = i(n) };
}function rnn(e, t, n, r, i, a, o, s) {
  return void 0 === r && (r = !1), void 0 === o && (o = !1), void 0 === s && (s = !1), Object(tf_core_esm["_85" /* tidy */])(function () {
    var l = t.shape.length;if (l < 3) throw new ValueError("Input should be at least 3D, but is " + l + "D.");var u = [1, 0].concat(range(2, l));if (t = Object(tf_core_esm["_89" /* transpose */])(t, u), null != a) throw new NotImplementedError("The rnn() functoin of the deeplearn.js backend does not support constants yet.");o && console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend."), null != i && ((i = i.asType("bool").asType("float32")).rank === l - 1 && (i = Object(tf_core_esm["T" /* expandDims */])(i, -1)), i = Object(tf_core_esm["_89" /* transpose */])(i, u)), r && (t = Object(tf_core_esm["_49" /* reverse */])(t, 0), null != i && (i = Object(tf_core_esm["_49" /* reverse */])(i, 0)));var c,
        h,
        p = [],
        d = n,
        g = t.shape[0],
        f = Object(tf_core_esm["_91" /* unstack */])(t);null != i && (h = Object(tf_core_esm["_91" /* unstack */])(i));for (var m, y = function y(t) {
      var n = f[t],
          r = Object(tf_core_esm["_85" /* tidy */])(function () {
        return e(n, d);
      });if (null == i) c = r[0], d = r[1];else {
        var a = Object(tf_core_esm["_85" /* tidy */])(function () {
          var e = h[t],
              n = Object(tf_core_esm["_38" /* onesLike */])(e).sub(e);return { output: r[0].mul(e).addStrict(d[0].mul(n)), newStates: d.map(function (t, i) {
              return r[1][i].mul(e).addStrict(t.mul(n));
            }) };
        });c = a.output, d = a.newStates;
      }s && p.push(c);
    }, v = 0; v < g; ++v) {
      y(v);
    }if (s) {
      m = Object(tf_core_esm["_76" /* stack */])(p, 1);
    }return [c, m, d];
  });
}tf_core_esm["_56" /* serialization */].registerClass(GlobalMaxPooling2D);var RNN = function (e) {
  function t(t) {
    var n,
        r = e.call(this, t) || this;if (null == t.cell) throw new ValueError("cell property is missing for the constructor of RNN.");if (null == (n = Array.isArray(t.cell) ? new StackedRNNCells({ cells: t.cell }) : t.cell).stateSize) throw new ValueError("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");return r.cell = n, r.returnSequences = null != t.returnSequences && t.returnSequences, r.returnState = null != t.returnState && t.returnState, r.goBackwards = null != t.goBackwards && t.goBackwards, r._stateful = null != t.stateful && t.stateful, r.unroll = null != t.unroll && t.unroll, r.supportsMasking = !0, r.inputSpec = [new InputSpec({ ndim: 3 })], r.stateSpec = null, r.states_ = null, r.numConstants = null, r.keptStates = [], r;
  }return __extends(t, e), t.prototype.getStates = function () {
    return null == this.states_ ? range(0, Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1).map(function (e) {
      return null;
    }) : this.states_;
  }, t.prototype.setStates = function (e) {
    this.states_ = e;
  }, t.prototype.computeOutputShape = function (e) {
    isArrayOfShapes(e) && (e = e[0]), e = e;var t = this.cell.stateSize;Array.isArray(t) || (t = [t]);var n,
        r = t[0];if (n = this.returnSequences ? [e[0], e[1], r] : [e[0], r], this.returnState) {
      for (var i = [], a = 0, o = t; a < o.length; a++) {
        var s = o[a];i.push([e[0], s]);
      }return [n].concat(i);
    }return n;
  }, t.prototype.computeMask = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      Array.isArray(t) && (t = t[0]);var e = n.returnSequences ? t : null;if (n.returnState) {
        var r = n.states.map(function (e) {
          return null;
        });return [e].concat(r);
      }return e;
    });
  }, Object.defineProperty(t.prototype, "states", { get: function get() {
      if (null == this.states_) {
        for (var e = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1, t = [], n = 0; n < e; ++n) {
          t.push(null);
        }return t;
      }return this.states_;
    }, set: function set(e) {
      this.states_ = e;
    }, enumerable: !0, configurable: !0 }), t.prototype.build = function (e) {
    if (null != this.numConstants) throw new NotImplementedError("Constants support is not implemented in RNN yet.");isArrayOfShapes(e) && (e = e[0]), e = e;var t = this.stateful ? e[0] : null,
        n = e[e.length - 1];this.inputSpec[0] = new InputSpec({ shape: [t, null, n] });var r,
        i = [e[0]].concat(e.slice(2));if (this.cell.build(i), r = Array.isArray(this.cell.stateSize) ? this.cell.stateSize : [this.cell.stateSize], null != this.stateSpec) {
      if (!tf_core_esm["_92" /* util */].arraysEqual(this.stateSpec.map(function (e) {
        return e.shape[e.shape.length - 1];
      }), r)) throw new ValueError("An initialState was passed that is not compatible with cell.stateSize. Received stateSpec=" + this.stateSpec + "; However cell.stateSize is " + this.cell.stateSize);
    } else this.stateSpec = r.map(function (e) {
      return new InputSpec({ shape: [null, e] });
    });this.stateful && this.resetStates();
  }, t.prototype.resetStates = function (e, t) {
    var n = this;void 0 === t && (t = !1), Object(tf_core_esm["_85" /* tidy */])(function () {
      if (!n.stateful) throw new AttributeError("Cannot call resetStates() on an RNN Layer that is not stateful.");var r = n.inputSpec[0].shape[0];if (null == r) throw new ValueError("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");if (null == n.states_) Array.isArray(n.cell.stateSize) ? n.states_ = n.cell.stateSize.map(function (e) {
        return Object(tf_core_esm["_97" /* zeros */])([r, e]);
      }) : n.states_ = [Object(tf_core_esm["_97" /* zeros */])([r, n.cell.stateSize])];else if (null == e) Object(tf_core_esm["N" /* dispose */])(n.states_), null != n.keptStates && (Object(tf_core_esm["N" /* dispose */])(n.keptStates), n.keptStates = []), Array.isArray(n.cell.stateSize) ? n.states_ = n.cell.stateSize.map(function (e) {
        return Object(tf_core_esm["_97" /* zeros */])([r, e]);
      }) : n.states_[0] = Object(tf_core_esm["_97" /* zeros */])([r, n.cell.stateSize]);else {
        if (Array.isArray(e) || (e = [e]), e.length !== n.states_.length) throw new ValueError("Layer " + n.name + " expects " + n.states_.length + " state(s), but it received " + e.length + " state value(s). Input received: " + e);!0 === t ? n.keptStates.push(n.states_.slice()) : Object(tf_core_esm["N" /* dispose */])(n.states_);for (var i = 0; i < n.states_.length; ++i) {
          var a = e[i],
              o = Array.isArray(n.cell.stateSize) ? n.cell.stateSize[i] : n.cell.stateSize,
              s = [r, o];if (!tf_core_esm["_92" /* util */].arraysEqual(a.shape, s)) throw new ValueError("State " + i + " is incompatible with layer " + n.name + ": expected shape=" + s + ", received shape=" + a.shape);n.states_[i] = a;
        }
      }n.states_.forEach(function (e) {
        return Object(tf_core_esm["_8" /* keep */])(e);
      });
    });
  }, t.prototype.apply = function (t, n) {
    var r = null == n ? null : n.initialState,
        i = null == n ? null : n.constants;null == n && (n = {});var a = standardizeArgs(t, r, i, this.numConstants);t = a.inputs, r = a.initialState, i = a.constants;var o = [],
        s = [];if (null != r) {
      n.initialState = r, o = o.concat(r), this.stateSpec = [];for (var l = 0, u = r; l < u.length; l++) {
        var c = u[l];this.stateSpec.push(new InputSpec({ shape: c.shape }));
      }s = s.concat(this.stateSpec);
    }if (null != i && (n.constants = i, o = o.concat(i), this.numConstants = i.length), o[0] instanceof SymbolicTensor) {
      var h = [t].concat(o),
          p = this.inputSpec.concat(s),
          d = this.inputSpec;this.inputSpec = p;var g = e.prototype.apply.call(this, h, n);return this.inputSpec = d, g;
    }return e.prototype.apply.call(this, t, n);
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var r = null == t ? null : t.mask,
          i = null == t ? null : t.training,
          a = null == t ? null : t.initialState;e = getExactlyOneTensor(e), null == a && (a = n.stateful ? n.states_ : n.getInitialState(e));var o = Array.isArray(n.cell.stateSize) ? n.cell.stateSize.length : 1;if (a.length !== o) throw new ValueError("RNN Layer has " + o + " state(s) but was passed " + a.length + " initial state(s).");n.unroll && console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");var s = { training: i },
          l = rnn(function (e, t) {
        var r = n.cell.call([e].concat(t), s);return [r[0], r.slice(1)];
      }, e, a, n.goBackwards, r, null, n.unroll, n.returnSequences),
          u = l[0],
          c = l[1],
          h = l[2];n.stateful && n.resetStates(h, i);var p = n.returnSequences ? c : u;return n.returnState ? [p].concat(h) : p;
    });
  }, t.prototype.getInitialState = function (e) {
    var t = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var n = Object(tf_core_esm["_97" /* zeros */])(e.shape);return n = expandDims$1(n = Object(tf_core_esm["_80" /* sum */])(n, [1, 2])), Array.isArray(t.cell.stateSize) ? t.cell.stateSize.map(function (e) {
        return e > 1 ? tile$1(n, [1, e]) : n;
      }) : t.cell.stateSize > 1 ? [tile$1(n, [1, t.cell.stateSize])] : [n];
    });
  }, Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      return this.trainable ? this.cell.trainableWeights : [];
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      return this.trainable ? this.cell.nonTrainableWeights : this.cell.weights;
    }, enumerable: !0, configurable: !0 }), t.prototype.setFastWeightInitDuringBuild = function (t) {
    e.prototype.setFastWeightInitDuringBuild.call(this, t), null != this.cell && this.cell.setFastWeightInitDuringBuild(t);
  }, t.prototype.getConfig = function () {
    var t = { returnSequences: this.returnSequences, returnState: this.returnState, goBackwards: this.goBackwards, stateful: this.stateful, unroll: this.unroll };null != this.numConstants && (t.numConstants = this.numConstants);var n = this.cell.getConfig();t.cell = { className: this.cell.getClassName(), config: n };var r = e.prototype.getConfig.call(this);return _extends(t, r), t;
  }, t.className = "RNN", t;
}(Layer);tf_core_esm["_56" /* serialization */].registerClass(RNN);var RNNCell = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }return __extends(t, e), t;
}(Layer),
    SimpleRNNCell = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.DEFAULT_ACTIVATION = "tanh", n.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", n.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", n.DEFAULT_BIAS_INITIALIZER = "zeros", n.units = t.units, n.activation = getActivation(null == t.activation ? n.DEFAULT_ACTIVATION : t.activation), n.useBias = null == t.useBias || t.useBias, n.kernelInitializer = getInitializer(t.kernelInitializer || n.DEFAULT_KERNEL_INITIALIZER), n.recurrentInitializer = getInitializer(t.recurrentInitializer || n.DEFAULT_RECURRENT_INITIALIZER), n.biasInitializer = getInitializer(t.biasInitializer || n.DEFAULT_BIAS_INITIALIZER), n.kernelRegularizer = getRegularizer(t.kernelRegularizer), n.recurrentRegularizer = getRegularizer(t.recurrentRegularizer), n.biasRegularizer = getRegularizer(t.biasRegularizer), n.kernelConstraint = getConstraint(t.kernelConstraint), n.recurrentConstraint = getConstraint(t.recurrentConstraint), n.biasConstraint = getConstraint(t.biasConstraint), n.dropout = min$1([1, max$1([0, null == t.dropout ? 0 : t.dropout])]), n.recurrentDropout = min$1([1, max$1([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), n.stateSize = n.units, n.dropoutMask = null, n.recurrentDropoutMask = null, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    e = getExactlyOneShape(e), this.kernel = this.addWeight("kernel", [e[e.length - 1], this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (2 !== (e = e).length) throw new ValueError("SimpleRNNCell expects 2 input Tensors, got " + e.length + ".");var r = e[1];e = e[0];var i,
          a = null != t.training && t.training;0 < n.dropout && n.dropout < 1 && null == n.dropoutMask && (n.dropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(e);
      }, n.dropout, a)), 0 < n.recurrentDropout && n.recurrentDropout < 1 && null == n.recurrentDropoutMask && (n.recurrentDropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(r);
      }, n.recurrentDropout, a));var o = n.dropoutMask,
          s = n.recurrentDropoutMask;i = dot(null != o ? Object(tf_core_esm["_31" /* mul */])(e, o) : e, n.kernel.read()), null != n.bias && (i = biasAdd(i, n.bias.read())), null != s && (r = Object(tf_core_esm["_31" /* mul */])(r, s));var l = Object(tf_core_esm["g" /* add */])(i, dot(r, n.recurrentKernel.read()));return null != n.activation && (l = n.activation.apply(l)), [l, l];
    });
  }, t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "SimpleRNNCell", t;
}(RNNCell);tf_core_esm["_56" /* serialization */].registerClass(SimpleRNNCell);var SimpleRNN = function (e) {
  function t(t) {
    return t.cell = new SimpleRNNCell(t), e.call(this, t) || this;
  }return __extends(t, e), t.prototype.call = function (t, n) {
    var r = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      null != r.cell.dropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.dropoutMask), r.cell.dropoutMask = null), null != r.cell.recurrentDropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.recurrentDropoutMask), r.cell.recurrentDropoutMask = null);var i = null == n ? null : n.mask,
          a = null == n ? null : n.training,
          o = null == n ? null : n.initialState;return e.prototype.call.call(r, t, { mask: i, training: a, initialState: o });
    });
  }, Object.defineProperty(t.prototype, "units", { get: function get() {
      return this.cell.units;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "activation", { get: function get() {
      return this.cell.activation;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "useBias", { get: function get() {
      return this.cell.useBias;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelInitializer", { get: function get() {
      return this.cell.kernelInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentInitializer", { get: function get() {
      return this.cell.recurrentInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasInitializer", { get: function get() {
      return this.cell.biasInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelRegularizer", { get: function get() {
      return this.cell.kernelRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentRegularizer", { get: function get() {
      return this.cell.recurrentRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasRegularizer", { get: function get() {
      return this.cell.biasRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelConstraint", { get: function get() {
      return this.cell.kernelConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentConstraint", { get: function get() {
      return this.cell.recurrentConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasConstraint", { get: function get() {
      return this.cell.biasConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "dropout", { get: function get() {
      return this.cell.dropout;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentDropout", { get: function get() {
      return this.cell.recurrentDropout;
    }, enumerable: !0, configurable: !0 }), t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout },
        n = e.prototype.getConfig.call(this);return delete n.cell, _extends(t, n), t;
  }, t.className = "SimpleRNN", t;
}(RNN);tf_core_esm["_56" /* serialization */].registerClass(SimpleRNN);var GRUCell = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.DEFAULT_ACTIVATION = "tanh", n.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", n.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", n.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", n.DEFAULT_BIAS_INITIALIZER = "zeros", n.units = t.units, n.activation = getActivation(void 0 === t.activation ? n.DEFAULT_ACTIVATION : t.activation), n.recurrentActivation = getActivation(void 0 === t.recurrentActivation ? n.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), n.useBias = null == t.useBias || t.useBias, n.kernelInitializer = getInitializer(t.kernelInitializer || n.DEFAULT_KERNEL_INITIALIZER), n.recurrentInitializer = getInitializer(t.recurrentInitializer || n.DEFAULT_RECURRENT_INITIALIZER), n.biasInitializer = getInitializer(t.biasInitializer || n.DEFAULT_BIAS_INITIALIZER), n.kernelRegularizer = getRegularizer(t.kernelRegularizer), n.recurrentRegularizer = getRegularizer(t.recurrentRegularizer), n.biasRegularizer = getRegularizer(t.biasRegularizer), n.kernelConstraint = getConstraint(t.kernelConstraint), n.recurrentConstraint = getConstraint(t.recurrentConstraint), n.biasConstraint = getConstraint(t.biasConstraint), n.dropout = min$1([1, max$1([0, null == t.dropout ? 0 : t.dropout])]), n.recurrentDropout = min$1([1, max$1([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), n.implementation = t.implementation, n.stateSize = n.units, n.dropoutMask = null, n.recurrentDropoutMask = null, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    var t = (e = getExactlyOneShape(e))[e.length - 1];this.kernel = this.addWeight("kernel", [t, 3 * this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, 3 * this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [3 * this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (2 !== (e = e).length) throw new ValueError("GRUCell expects 2 input Tensors (inputs, h, c), got " + e.length + ".");var r = null != t.training && t.training,
          i = e[1];e = e[0], 0 < n.dropout && n.dropout < 1 && null == n.dropoutMask && (n.dropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(e);
      }, n.dropout, r, 3)), 0 < n.recurrentDropout && n.recurrentDropout < 1 && null == n.recurrentDropoutMask && (n.recurrentDropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(i);
      }, n.recurrentDropout, r, 3));var a,
          o,
          s,
          l = n.dropoutMask,
          u = n.recurrentDropoutMask;0 < n.dropout && n.dropout < 1 && (e = Object(tf_core_esm["_31" /* mul */])(e, l[0]));var c = dot(e, n.kernel.read());n.useBias && (c = biasAdd(c, n.bias.read())), 0 < n.recurrentDropout && n.recurrentDropout < 1 && (i = Object(tf_core_esm["_31" /* mul */])(i, u[0]));var h = n.recurrentKernel.read(),
          p = Object(tf_core_esm["_71" /* split */])(h, [2 * n.units, n.units], h.rank - 1),
          d = p[0],
          g = p[1],
          f = dot(i, d),
          m = Object(tf_core_esm["_71" /* split */])(c, 3, c.rank - 1),
          y = m[0],
          v = m[1],
          b = m[2],
          w = Object(tf_core_esm["_71" /* split */])(f, 2, f.rank - 1),
          z = w[0],
          S = w[1];a = n.recurrentActivation.apply(Object(tf_core_esm["g" /* add */])(y, z)), o = n.recurrentActivation.apply(Object(tf_core_esm["g" /* add */])(v, S));var I = dot(Object(tf_core_esm["_31" /* mul */])(o, i), g);s = n.activation.apply(Object(tf_core_esm["g" /* add */])(b, I));var A = Object(tf_core_esm["g" /* add */])(Object(tf_core_esm["_31" /* mul */])(a, i), Object(tf_core_esm["_31" /* mul */])(Object(tf_core_esm["g" /* add */])(getScalar(1), Object(tf_core_esm["_33" /* neg */])(a)), s));return [A, A];
    });
  }, t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), recurrentActivation: serializeActivation(this.recurrentActivation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout, implementation: this.implementation },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "GRUCell", t;
}(RNNCell);tf_core_esm["_56" /* serialization */].registerClass(GRUCell);var GRU = function (e) {
  function t(t) {
    return 0 === t.implementation && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new GRUCell(t), e.call(this, t) || this;
  }return __extends(t, e), t.prototype.call = function (t, n) {
    var r = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      null != r.cell.dropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.dropoutMask), r.cell.dropoutMask = null), null != r.cell.recurrentDropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.recurrentDropoutMask), r.cell.recurrentDropoutMask = null);var i = null == n ? null : n.mask,
          a = null == n ? null : n.training,
          o = null == n ? null : n.initialState;return e.prototype.call.call(r, t, { mask: i, training: a, initialState: o });
    });
  }, Object.defineProperty(t.prototype, "units", { get: function get() {
      return this.cell.units;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "activation", { get: function get() {
      return this.cell.activation;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentActivation", { get: function get() {
      return this.cell.recurrentActivation;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "useBias", { get: function get() {
      return this.cell.useBias;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelInitializer", { get: function get() {
      return this.cell.kernelInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentInitializer", { get: function get() {
      return this.cell.recurrentInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasInitializer", { get: function get() {
      return this.cell.biasInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelRegularizer", { get: function get() {
      return this.cell.kernelRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentRegularizer", { get: function get() {
      return this.cell.recurrentRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasRegularizer", { get: function get() {
      return this.cell.biasRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelConstraint", { get: function get() {
      return this.cell.kernelConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentConstraint", { get: function get() {
      return this.cell.recurrentConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasConstraint", { get: function get() {
      return this.cell.biasConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "dropout", { get: function get() {
      return this.cell.dropout;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentDropout", { get: function get() {
      return this.cell.recurrentDropout;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "implementation", { get: function get() {
      return this.cell.implementation;
    }, enumerable: !0, configurable: !0 }), t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), recurrentActivation: serializeActivation(this.recurrentActivation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout, implementation: this.implementation },
        n = e.prototype.getConfig.call(this);return delete n.cell, _extends(t, n), t;
  }, t.fromConfig = function (e, t) {
    return 0 === t.implmentation && (t.implementation = 1), new e(t);
  }, t.className = "GRU", t;
}(RNN);tf_core_esm["_56" /* serialization */].registerClass(GRU);var LSTMCell = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.DEFAULT_ACTIVATION = "tanh", n.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", n.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", n.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", n.DEFAULT_BIAS_INITIALIZER = "zeros", n.units = t.units, n.activation = getActivation(void 0 === t.activation ? n.DEFAULT_ACTIVATION : t.activation), n.recurrentActivation = getActivation(void 0 === t.recurrentActivation ? n.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), n.useBias = null == t.useBias || t.useBias, n.kernelInitializer = getInitializer(t.kernelInitializer || n.DEFAULT_KERNEL_INITIALIZER), n.recurrentInitializer = getInitializer(t.recurrentInitializer || n.DEFAULT_RECURRENT_INITIALIZER), n.biasInitializer = getInitializer(t.biasInitializer || n.DEFAULT_BIAS_INITIALIZER), n.unitForgetBias = t.unitForgetBias, n.kernelRegularizer = getRegularizer(t.kernelRegularizer), n.recurrentRegularizer = getRegularizer(t.recurrentRegularizer), n.biasRegularizer = getRegularizer(t.biasRegularizer), n.kernelConstraint = getConstraint(t.kernelConstraint), n.recurrentConstraint = getConstraint(t.recurrentConstraint), n.biasConstraint = getConstraint(t.biasConstraint), n.dropout = min$1([1, max$1([0, null == t.dropout ? 0 : t.dropout])]), n.recurrentDropout = min$1([1, max$1([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), n.implementation = t.implementation, n.stateSize = [n.units, n.units], n.dropoutMask = null, n.recurrentDropoutMask = null, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    var t,
        n,
        r = (e = getExactlyOneShape(e))[e.length - 1];if (this.kernel = this.addWeight("kernel", [r, 4 * this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, 4 * this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias) {
      if (this.unitForgetBias) {
        var i = this.biasInitializer,
            a = this.units;t = new ((n = function (e) {
          function t() {
            return null !== e && e.apply(this, arguments) || this;
          }return __extends(t, e), t.prototype.apply = function (e, t) {
            var n = i.apply([a]),
                r = new Ones().apply([a]),
                o = i.apply([2 * a]);return concatAlongFirstAxis(concatAlongFirstAxis(n, r), o);
          }, t;
        }(Initializer)).className = "CustomInit", n)();
      } else t = this.biasInitializer;this.bias = this.addWeight("bias", [4 * this.units], null, t, this.biasRegularizer, !0, this.biasConstraint);
    } else this.bias = null;this.built = !0;
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      var r = null != t.training && t.training;if (3 !== (e = e).length) throw new ValueError("LSTMCell expects 3 input Tensors (inputs, h, c), got " + e.length + ".");var i = e[1],
          a = e[2];e = e[0], 0 < n.dropout && n.dropout < 1 && null == n.dropoutMask && (n.dropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(e);
      }, n.dropout, r, 4)), 0 < n.recurrentDropout && n.recurrentDropout < 1 && null == n.recurrentDropoutMask && (n.recurrentDropoutMask = generateDropoutMask(function () {
        return Object(tf_core_esm["_38" /* onesLike */])(i);
      }, n.recurrentDropout, r, 4));var o,
          s,
          l,
          u,
          c = n.dropoutMask,
          h = n.recurrentDropoutMask;0 < n.dropout && n.dropout < 1 && (e = Object(tf_core_esm["_31" /* mul */])(e, c[0]));var p = dot(e, n.kernel.read());0 < n.recurrentDropout && n.recurrentDropout < 1 && (i = Object(tf_core_esm["_31" /* mul */])(i, h[0])), p = Object(tf_core_esm["g" /* add */])(p, dot(i, n.recurrentKernel.read())), n.useBias && (p = biasAdd(p, n.bias.read()));var d = Object(tf_core_esm["_71" /* split */])(p, 4, p.rank - 1),
          g = d[0],
          f = d[1],
          m = d[2],
          y = d[3];o = n.recurrentActivation.apply(g), s = n.recurrentActivation.apply(f), l = Object(tf_core_esm["g" /* add */])(Object(tf_core_esm["_31" /* mul */])(s, a), Object(tf_core_esm["_31" /* mul */])(o, n.activation.apply(m))), u = n.recurrentActivation.apply(y);var v = Object(tf_core_esm["_31" /* mul */])(u, n.activation.apply(l));return [v, v, l];
    });
  }, t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), recurrentActivation: serializeActivation(this.recurrentActivation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), unitForgetBias: this.unitForgetBias, kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout, implementation: this.implementation },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.className = "LSTMCell", t;
}(RNNCell);tf_core_esm["_56" /* serialization */].registerClass(LSTMCell);var LSTM = function (e) {
  function t(t) {
    return 0 === t.implementation && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new LSTMCell(t), e.call(this, t) || this;
  }return __extends(t, e), t.prototype.call = function (t, n) {
    var r = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      null != r.cell.dropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.dropoutMask), r.cell.dropoutMask = null), null != r.cell.recurrentDropoutMask && (Object(tf_core_esm["N" /* dispose */])(r.cell.recurrentDropoutMask), r.cell.recurrentDropoutMask = null);var i = null == n ? null : n.mask,
          a = null == n ? null : n.training,
          o = null == n ? null : n.initialState;return e.prototype.call.call(r, t, { mask: i, training: a, initialState: o });
    });
  }, Object.defineProperty(t.prototype, "units", { get: function get() {
      return this.cell.units;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "activation", { get: function get() {
      return this.cell.activation;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentActivation", { get: function get() {
      return this.cell.recurrentActivation;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "useBias", { get: function get() {
      return this.cell.useBias;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelInitializer", { get: function get() {
      return this.cell.kernelInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentInitializer", { get: function get() {
      return this.cell.recurrentInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasInitializer", { get: function get() {
      return this.cell.biasInitializer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "unitForgetBias", { get: function get() {
      return this.cell.unitForgetBias;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelRegularizer", { get: function get() {
      return this.cell.kernelRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentRegularizer", { get: function get() {
      return this.cell.recurrentRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasRegularizer", { get: function get() {
      return this.cell.biasRegularizer;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "kernelConstraint", { get: function get() {
      return this.cell.kernelConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentConstraint", { get: function get() {
      return this.cell.recurrentConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "biasConstraint", { get: function get() {
      return this.cell.biasConstraint;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "dropout", { get: function get() {
      return this.cell.dropout;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "recurrentDropout", { get: function get() {
      return this.cell.recurrentDropout;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "implementation", { get: function get() {
      return this.cell.implementation;
    }, enumerable: !0, configurable: !0 }), t.prototype.getConfig = function () {
    var t = { units: this.units, activation: serializeActivation(this.activation), recurrentActivation: serializeActivation(this.recurrentActivation), useBias: this.useBias, kernelInitializer: serializeInitializer(this.kernelInitializer), recurrentInitializer: serializeInitializer(this.recurrentInitializer), biasInitializer: serializeInitializer(this.biasInitializer), unitForgetBias: this.unitForgetBias, kernelRegularizer: serializeRegularizer(this.kernelRegularizer), recurrentRegularizer: serializeRegularizer(this.recurrentRegularizer), biasRegularizer: serializeRegularizer(this.biasRegularizer), activityRegularizer: serializeRegularizer(this.activityRegularizer), kernelConstraint: serializeConstraint(this.kernelConstraint), recurrentConstraint: serializeConstraint(this.recurrentConstraint), biasConstraint: serializeConstraint(this.biasConstraint), dropout: this.dropout, recurrentDropout: this.recurrentDropout, implementation: this.implementation },
        n = e.prototype.getConfig.call(this);return delete n.cell, _extends(t, n), t;
  }, t.fromConfig = function (e, t) {
    return 0 === t.implmentation && (t.implementation = 1), new e(t);
  }, t.className = "LSTM", t;
}(RNN);tf_core_esm["_56" /* serialization */].registerClass(LSTM);var StackedRNNCells = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.cells = t.cells, n;
  }return __extends(t, e), Object.defineProperty(t.prototype, "stateSize", { get: function get() {
      for (var e = [], t = 0, n = this.cells.slice().reverse(); t < n.length; t++) {
        var r = n[t];Array.isArray(r.stateSize) ? e.push.apply(e, r.stateSize) : e.push(r.stateSize);
      }return e;
    }, enumerable: !0, configurable: !0 }), t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      for (var r = (e = e).slice(1), i = [], a = 0, o = n.cells.slice().reverse(); a < o.length; a++) {
        var s = o[a];Array.isArray(s.stateSize) ? i.push(r.splice(0, s.stateSize.length)) : i.push(r.splice(0, 1));
      }i.reverse();for (var l, u = [], c = 0; c < n.cells.length; ++c) {
        s = n.cells[c];r = i[c], l = 0 === c ? [e[0]].concat(r) : [l[0]].concat(r), l = s.call(l, t), u.push(l.slice(1));
      }r = [];for (var h = 0, p = u.slice().reverse(); h < p.length; h++) {
        var d = p[h];r.push.apply(r, d);
      }return [l[0]].concat(r);
    });
  }, t.prototype.build = function (e) {
    var t;isArrayOfShapes(e) && (e = e[0]), e = e;for (var n = 0, r = this.cells; n < r.length; n++) {
      var i = r[n];i.build(e), t = Array.isArray(i.stateSize) ? i.stateSize[0] : i.stateSize, e = [e[0], t];
    }this.built = !0;
  }, t.prototype.getConfig = function () {
    for (var t = [], n = 0, r = this.cells; n < r.length; n++) {
      var i = r[n];t.push({ className: this.getClassName(), config: i.getConfig() });
    }var a = { cells: t },
        o = e.prototype.getConfig.call(this);return _extends(a, o), a;
  }, t.fromConfig = function (e, t, n) {
    void 0 === n && (n = {});for (var r = [], i = 0, a = t.cells; i < a.length; i++) {
      var o = a[i];r.push(deserialize(o, n));
    }return new e({ cells: r });
  }, Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      if (!this.trainable) return [];for (var e = [], t = 0, n = this.cells; t < n.length; t++) {
        var r = n[t];e.push.apply(e, r.trainableWeights);
      }return e;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      for (var e = [], t = 0, n = this.cells; t < n.length; t++) {
        var r = n[t];e.push.apply(e, r.nonTrainableWeights);
      }if (!this.trainable) {
        for (var i = [], a = 0, o = this.cells; a < o.length; a++) {
          r = o[a];i.push.apply(i, r.trainableWeights);
        }return i.concat(e);
      }return e;
    }, enumerable: !0, configurable: !0 }), t.prototype.getWeights = function () {
    for (var e = [], t = 0, n = this.cells; t < n.length; t++) {
      var r = n[t];e.push.apply(e, r.weights);
    }return batchGetValue(e);
  }, t.prototype.setWeights = function (e) {
    for (var t = [], n = 0, r = this.cells; n < r.length; n++) {
      for (var i = r[n], a = i.weights.length, o = e.splice(a), s = 0; s < i.weights.length; ++s) {
        t.push([i.weights[s], o[s]]);
      }
    }batchSetValue(t);
  }, t.className = "StackedRNNCells", t;
}(RNNCell);function generateDropoutMask(e, t, n, r) {
  function i() {
    return dropout(e(), getScalar(t));
  }if (void 0 === n && (n = null), void 0 === r && (r = 1), r > 1) {
    for (var a = [], o = 0; o < r; o++) {
      a.push(inTrainPhase(i, e, n));
    }return a.forEach(function (e) {
      return Object(tf_core_esm["_8" /* keep */])(e);
    }), a;
  }return Object(tf_core_esm["_8" /* keep */])(inTrainPhase(i, e, n));
}tf_core_esm["_56" /* serialization */].registerClass(StackedRNNCells);var Wrapper = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.layer = t.layer, n;
  }return __extends(t, e), t.prototype.build = function (e) {
    this.built = !0;
  }, Object.defineProperty(t.prototype, "trainable", { get: function get() {
      return null != this.layer && this.layer.trainable;
    }, set: function set(e) {
      null != this.layer && (this.layer.trainable = e);
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      return this.layer.trainableWeights;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      return this.layer.nonTrainableWeights;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "updates", { get: function get() {
      return this.layer._updates;
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "losses", { get: function get() {
      return this.layer.losses;
    }, enumerable: !0, configurable: !0 }), t.prototype.getWeights = function () {
    return this.layer.getWeights();
  }, t.prototype.setWeights = function (e) {
    this.layer.setWeights(e);
  }, t.prototype.getConfig = function () {
    var t = { layer: { className: this.layer.getClassName(), config: this.layer.getConfig() } },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.prototype.setFastWeightInitDuringBuild = function (t) {
    e.prototype.setFastWeightInitDuringBuild.call(this, t), null != this.layer && this.layer.setFastWeightInitDuringBuild(t);
  }, t.fromConfig = function (e, t, n) {
    void 0 === n && (n = {});var r = deserialize(t.layer, n);delete t.layer;var i = { layer: r };return _extends(i, t), new e(i);
  }, t;
}(Layer),
    TimeDistributed = function (e) {
  function t(t) {
    var n = e.call(this, t) || this;return n.supportsMasking = !0, n;
  }return __extends(t, e), t.prototype.build = function (t) {
    if ((t = getExactlyOneShape(t)).length < 3) throw new ValueError("TimeDistributed layer expects an input shape >= 3D, but received input shape " + JSON.stringify(t));this.inputSpec = [{ shape: t }];var n = [t[0]].concat(t.slice(2));this.layer.built || (this.layer.build(n), this.layer.built = !0), e.prototype.build.call(this, t);
  }, t.prototype.computeOutputShape = function (e) {
    var t = [(e = getExactlyOneShape(e))[0]].concat(e.slice(2)),
        n = this.layer.computeOutputShape(t),
        r = e[1];return [n[0], r].concat(n.slice(1));
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      return rnn(function (e, r) {
        return [getExactlyOneTensor(n.layer.call(e, t)), []];
      }, e = getExactlyOneTensor(e), [], !1, null, null, !1, !0)[1];
    });
  }, t.className = "TimeDistributed", t;
}(Wrapper);tf_core_esm["_56" /* serialization */].registerClass(TimeDistributed);var VALID_BIDIRECTIONAL_MERGE_MODES = ["sum", "mul", "concat", "ave"];function checkBidirectionalMergeMode(e) {
  checkStringTypeUnionValue(VALID_BIDIRECTIONAL_MERGE_MODES, "BidirectionalMergeMode", e);
}var Bidirectional = function (e) {
  function t(t) {
    var n = e.call(this, t) || this,
        r = t.layer.getConfig();if (n.forwardLayer = deserialize({ className: t.layer.getClassName(), config: r }), r.goBackwards = !0 !== r.goBackwards, n.backwardLayer = deserialize({ className: t.layer.getClassName(), config: r }), n.forwardLayer.name = "forward_" + n.forwardLayer.name, n.backwardLayer.name = "backward_" + n.backwardLayer.name, checkBidirectionalMergeMode(t.mergeMode), n.mergeMode = t.mergeMode, t.weights) throw new NotImplementedError("weights support is not implemented for Bidirectional layer yet.");return n._stateful = t.layer.stateful, n.returnSequences = t.layer.returnSequences, n.returnState = t.layer.returnState, n.supportsMasking = !0, n._trainable = !0, n.inputSpec = t.layer.inputSpec, n.numConstants = null, n;
  }return __extends(t, e), Object.defineProperty(t.prototype, "trainable", { get: function get() {
      return this._trainable;
    }, set: function set(e) {
      this._trainable = e, null != this.forwardLayer && (this.forwardLayer.trainable = e), null != this.backwardLayer && (this.backwardLayer.trainable = e);
    }, enumerable: !0, configurable: !0 }), t.prototype.getWeights = function () {
    return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
  }, t.prototype.setWeights = function (e) {
    var t = e.length,
        n = Math.floor(t / 2);this.forwardLayer.setWeights(e.slice(0, n)), this.backwardLayer.setWeights(e.slice(n));
  }, t.prototype.computeOutputShape = function (e) {
    var t,
        n,
        r,
        i = this.forwardLayer.computeOutputShape(e);return Array.isArray(i) && Array.isArray(i[0]) || (i = [i]), i = i, this.returnState ? (r = i.slice(1), t = i[0]) : t = i[0], t = t, "concat" === this.mergeMode ? (t[t.length - 1] *= 2, n = [t]) : n = null == this.mergeMode ? [t, t.slice()] : [t], this.returnState ? null == this.mergeMode ? n.concat(r).concat(r.slice()) : [t].concat(r).concat(r.slice()) : singletonOrArray(n);
  }, t.prototype.apply = function (t, n) {
    var r = null == n ? null : n.initialState,
        i = null == n ? null : n.constants;null == n && (n = {});var a = standardizeArgs(t, r, i, this.numConstants);if (t = a.inputs, r = a.initialState, i = a.constants, Array.isArray(t) && (r = t.slice(1), t = t[0]), (null == r || 0 === r.length) && null == i) return e.prototype.apply.call(this, t, n);var o = [],
        s = [];if (null != r) {
      var l = r.length;if (l % 2 > 0) throw new ValueError("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");n.initialState = r, o.push.apply(o, r);var u = r.map(function (e) {
        return new InputSpec({ shape: e.shape });
      });this.forwardLayer.stateSpec = u.slice(0, l / 2), this.backwardLayer.stateSpec = u.slice(l / 2), s.push.apply(s, u);
    }if (null != i) throw new NotImplementedError("Support for constants in Bidirectional layers is not implemented yet.");for (var c = o[0] instanceof SymbolicTensor, h = 0, p = o; h < p.length; h++) {
      if (p[h] instanceof SymbolicTensor !== c) throw new ValueError("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
    }if (c) {
      var d = [t].concat(o),
          g = this.inputSpec.concat(s),
          f = this.inputSpec;this.inputSpec = g;var m = e.prototype.apply.call(this, d, n);return this.inputSpec = f, m;
    }return e.prototype.apply.call(this, t, n);
  }, t.prototype.call = function (e, t) {
    var n = this;return Object(tf_core_esm["_85" /* tidy */])(function () {
      if (null != t.mask) throw new NotImplementedError("The support for masking is not implemented for Bidirectional layers yet.");var r,
          i,
          a,
          o,
          s = t.initialState;if (null == s) r = n.forwardLayer.call(e, t), i = n.backwardLayer.call(e, t);else {
        var l = s.slice(0, s.length / 2),
            u = s.slice(s.length / 2);r = n.forwardLayer.call(e, _extends(t, { initialState: l })), i = n.backwardLayer.call(e, _extends(t, { initialState: u }));
      }return n.returnState && (Array.isArray(r) && (a = r.slice(1).concat(i.slice(1))), r = r[0], i = i[0]), n.returnSequences && (i = Object(tf_core_esm["_49" /* reverse */])(i, 1)), "concat" === n.mergeMode ? o = concatenate([r, i]) : "sum" === n.mergeMode ? o = Object(tf_core_esm["g" /* add */])(r, i) : "ave" === n.mergeMode ? o = Object(tf_core_esm["_31" /* mul */])(getScalar(.5), Object(tf_core_esm["g" /* add */])(r, i)) : "mul" === n.mergeMode ? o = Object(tf_core_esm["_31" /* mul */])(r, i) : null == n.mergeMode && (o = [r, i]), n.returnState ? null == n.mergeMode ? o.concat(a) : [o].concat(a) : o;
    });
  }, t.prototype.resetStates = function (e) {
    this.forwardLayer.resetStates(), this.backwardLayer.resetStates();
  }, t.prototype.build = function (e) {
    var t = this;nameScope(this.forwardLayer.name, function () {
      t.forwardLayer.build(e);
    }), nameScope(this.backwardLayer.name, function () {
      t.backwardLayer.build(e);
    }), this.built = !0;
  }, Object.defineProperty(t.prototype, "trainableWeights", { get: function get() {
      return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
    }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "nonTrainableWeights", { get: function get() {
      return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
    }, enumerable: !0, configurable: !0 }), t.prototype.setFastWeightInitDuringBuild = function (t) {
    e.prototype.setFastWeightInitDuringBuild.call(this, t), null != this.forwardLayer && this.forwardLayer.setFastWeightInitDuringBuild(t), null != this.backwardLayer && this.backwardLayer.setFastWeightInitDuringBuild(t);
  }, t.prototype.getConfig = function () {
    var t = { mergeMode: this.mergeMode },
        n = e.prototype.getConfig.call(this);return _extends(t, n), t;
  }, t.fromConfig = function (e, t) {
    var n = deserialize(t.layer);if (delete t.layer, null != t.numConstants) throw new NotImplementedError("Deserialization of a Bidirectional layer with numConstants present is not supported yet.");var r = t;return r.layer = n, new e(r);
  }, t.className = "Bidirectional", t;
}(Wrapper);function inputLayer(e) {
  return new InputLayer(e);
}function elu$2(e) {
  return new ELU(e);
}function reLU(e) {
  return new ReLU(e);
}function leakyReLU(e) {
  return new LeakyReLU(e);
}function prelu$1(e) {
  return new PReLU(e);
}function softmax$1(e) {
  return new Softmax$1(e);
}function thresholdedReLU(e) {
  return new ThresholdedReLU(e);
}function conv1d$2(e) {
  return new Conv1D(e);
}function conv2d$2(e) {
  return new Conv2D(e);
}function conv2dTranspose$1(e) {
  return new Conv2DTranspose(e);
}function separableConv2d$1(e) {
  return new SeparableConv2D(e);
}function cropping2D(e) {
  return new Cropping2D(e);
}function upSampling2d(e) {
  return new UpSampling2D(e);
}function depthwiseConv2d$2(e) {
  return new DepthwiseConv2D(e);
}function activation(e) {
  return new Activation$1(e);
}function dense(e) {
  return new Dense(e);
}function dropout$1(e) {
  return new Dropout(e);
}function flatten$1(e) {
  return new Flatten(e);
}function repeatVector(e) {
  return new RepeatVector(e);
}function reshape(e) {
  return new Reshape(e);
}function permute(e) {
  return new Permute(e);
}function embedding(e) {
  return new Embedding(e);
}function add$2(e) {
  return new Add(e);
}function average$1(e) {
  return new Average(e);
}function concatenate$2(e) {
  return new Concatenate(e);
}function maximum$2(e) {
  return new Maximum(e);
}function minimum$2(e) {
  return new Minimum(e);
}function multiply$1(e) {
  return new Multiply(e);
}function dot$1(e) {
  return new Dot(e);
}function batchNormalization$1(e) {
  return new BatchNormalization(e);
}function zeroPadding2d(e) {
  return new ZeroPadding2D(e);
}function averagePooling1d(e) {
  return new AveragePooling1D(e);
}function avgPool1d(e) {
  return averagePooling1d(e);
}function avgPooling1d(e) {
  return averagePooling1d(e);
}function averagePooling2d(e) {
  return new AveragePooling2D(e);
}function avgPool2d(e) {
  return averagePooling2d(e);
}function avgPooling2d(e) {
  return averagePooling2d(e);
}function globalAveragePooling1d(e) {
  return new GlobalAveragePooling1D(e);
}function globalAveragePooling2d(e) {
  return new GlobalAveragePooling2D(e);
}function globalMaxPooling1d(e) {
  return new GlobalMaxPooling1D(e);
}function globalMaxPooling2d(e) {
  return new GlobalMaxPooling2D(e);
}function maxPooling1d(e) {
  return new MaxPooling1D(e);
}function maxPooling2d(e) {
  return new MaxPooling2D(e);
}function gru(e) {
  return new GRU(e);
}function gruCell(e) {
  return new GRUCell(e);
}function lstm(e) {
  return new LSTM(e);
}function lstmCell(e) {
  return new LSTMCell(e);
}function simpleRNN(e) {
  return new SimpleRNN(e);
}function simpleRNNCell(e) {
  return new SimpleRNNCell(e);
}function rnn$1(e) {
  return new RNN(e);
}function stackedRNNCells(e) {
  return new StackedRNNCells(e);
}function bidirectional(e) {
  return new Bidirectional(e);
}function timeDistributed(e) {
  return new TimeDistributed(e);
}tf_core_esm["_56" /* serialization */].registerClass(Bidirectional);var globalMaxPool1d = globalMaxPooling1d,
    globalMaxPool2d = globalMaxPooling2d,
    maxPool1d = maxPooling1d,
    maxPool2d = maxPooling2d,
    exports_layers = Object.freeze({ inputLayer: inputLayer, elu: elu$2, reLU: reLU, leakyReLU: leakyReLU, prelu: prelu$1, softmax: softmax$1, thresholdedReLU: thresholdedReLU, conv1d: conv1d$2, conv2d: conv2d$2, conv2dTranspose: conv2dTranspose$1, separableConv2d: separableConv2d$1, cropping2D: cropping2D, upSampling2d: upSampling2d, depthwiseConv2d: depthwiseConv2d$2, activation: activation, dense: dense, dropout: dropout$1, flatten: flatten$1, repeatVector: repeatVector, reshape: reshape, permute: permute, embedding: embedding, add: add$2, average: average$1, concatenate: concatenate$2, maximum: maximum$2, minimum: minimum$2, multiply: multiply$1, dot: dot$1, batchNormalization: batchNormalization$1, zeroPadding2d: zeroPadding2d, averagePooling1d: averagePooling1d, avgPool1d: avgPool1d, avgPooling1d: avgPooling1d, averagePooling2d: averagePooling2d, avgPool2d: avgPool2d, avgPooling2d: avgPooling2d, globalAveragePooling1d: globalAveragePooling1d, globalAveragePooling2d: globalAveragePooling2d, globalMaxPooling1d: globalMaxPooling1d, globalMaxPooling2d: globalMaxPooling2d, maxPooling1d: maxPooling1d, maxPooling2d: maxPooling2d, gru: gru, gruCell: gruCell, lstm: lstm, lstmCell: lstmCell, simpleRNN: simpleRNN, simpleRNNCell: simpleRNNCell, rnn: rnn$1, stackedRNNCells: stackedRNNCells, bidirectional: bidirectional, timeDistributed: timeDistributed, globalMaxPool1d: globalMaxPool1d, globalMaxPool2d: globalMaxPool2d, maxPool1d: maxPool1d, maxPool2d: maxPool2d, Layer: Layer, RNN: RNN, RNNCell: RNNCell, input: input });function binaryAccuracy$1(e, t) {
  return binaryAccuracy(e, t);
}function binaryCrossentropy$2(e, t) {
  return binaryCrossentropy$1(e, t);
}function sparseCategoricalAccuracy$1(e, t) {
  return sparseCategoricalAccuracy(e, t);
}function categoricalAccuracy$1(e, t) {
  return categoricalAccuracy(e, t);
}function categoricalCrossentropy$2(e, t) {
  return categoricalCrossentropy$1(e, t);
}function precision$1(e, t) {
  return precision(e, t);
}function recall$1(e, t) {
  return recall(e, t);
}function cosineProximity$1(e, t) {
  return cosineProximity(e, t);
}function meanAbsoluteError$1(e, t) {
  return meanAbsoluteError(e, t);
}function meanAbsolutePercentageError$1(e, t) {
  return meanAbsolutePercentageError(e, t);
}function MAPE$2(e, t) {
  return meanAbsolutePercentageError(e, t);
}function mape$2(e, t) {
  return meanAbsolutePercentageError(e, t);
}function meanSquaredError$1(e, t) {
  return meanSquaredError(e, t);
}function MSE$2(e, t) {
  return meanSquaredError(e, t);
}function mse$2(e, t) {
  return meanSquaredError(e, t);
}var exports_metrics = Object.freeze({ binaryAccuracy: binaryAccuracy$1, binaryCrossentropy: binaryCrossentropy$2, sparseCategoricalAccuracy: sparseCategoricalAccuracy$1, categoricalAccuracy: categoricalAccuracy$1, categoricalCrossentropy: categoricalCrossentropy$2, precision: precision$1, recall: recall$1, cosineProximity: cosineProximity$1, meanAbsoluteError: meanAbsoluteError$1, meanAbsolutePercentageError: meanAbsolutePercentageError$1, MAPE: MAPE$2, mape: mape$2, meanSquaredError: meanSquaredError$1, MSE: MSE$2, mse: mse$2 }),
    exports_models = Object.freeze({ modelFromJSON: modelFromJSON });function l1l2(e) {
  return new L1L2(e);
}function l1$1(e) {
  return l1(e);
}function l2$1(e) {
  return l2(e);
}var exports_regularizers = Object.freeze({ l1l2: l1l2, l1: l1$1, l2: l2$1 }),
    Callback = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;return t.model = null, t;
  }return __extends(t, e), t.prototype.setModel = function (e) {
    if (!(e instanceof Model)) throw new Error("model must be a Model, not some other Container");this.model = e;
  }, t;
}(BaseCallback);
//# sourceMappingURL=tf-layers.esm.js.map
// EXTERNAL MODULE: ./node_modules/@tensorflow/tfjs-converter/dist/tf-converter.esm.js
var tf_converter_esm = __webpack_require__("HgQK");

// EXTERNAL MODULE: ./node_modules/@tensorflow/tfjs-data/dist/tf-data.esm.js
var tf_data_esm = __webpack_require__("MSVd");

// CONCATENATED MODULE: ./node_modules/@tensorflow/tfjs/dist/tf.esm.js
// @tensorflow/tfjs Copyright 2019 Google
var tf_esm_version = "0.14.2",
    version$1 = { "tfjs-core": tf_core_esm["_94" /* version_core */], "tfjs-data": tf_data_esm["a" /* version_data */], "tfjs-layers": version, "tfjs-converter": tf_converter_esm["a" /* version_converter */], tfjs: tf_esm_version };
//# sourceMappingURL=tf.esm.js.map
// EXTERNAL MODULE: ./vae-app/styles.scss
var styles = __webpack_require__("PmhB");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// CONCATENATED MODULE: ./vae-app/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = Object(preact_min["h"])(
    'div',
    { 'class': 'canvas-wrapper' },
    Object(preact_min["h"])('canvas', { id: 'canvas' })
);

var vae_app_VAEApp = function (_Component) {
    _inherits(VAEApp, _Component);

    function VAEApp() {
        _classCallCheck(this, VAEApp);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.canvas = null;
        _this.model = null;

        _this.onSliderChange = function (_ref) {
            var e = _ref.e,
                dim = _ref.dim;

            _this.setState({
                latentDims: _this.state.latentDims.map(function (latentDim, i) {
                    if (i === dim) {
                        return Number(e.target.value);
                    } else {
                        return latentDim;
                    }
                })
            });
        };

        _this.state = {
            latentDims: [1, 1]
        };
        return _this;
    }

    VAEApp.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var canvasEl = document.querySelector('canvas');

        canvasEl.width = '28';
        canvasEl.height = '28';

        this.canvas = canvasEl.getContext('2d');

        console.log("production");

        loadModel('http://127.0.0.1:8081/model.json').then(function (model) {
            _this2.model = model;
        });
    };

    VAEApp.prototype.componentDidUpdate = function componentDidUpdate() {
        var prediction = this.model.predict(tf_core_esm["_83" /* tensor */]([this.state.latentDims])).dataSync();

        var imageData = new ImageData(28, 28);

        for (var i = 0; i < 28 * 28; ++i) {
            var j = i * 4;
            imageData.data[j + 0] = prediction[i] * 255;
            imageData.data[j + 1] = prediction[i] * 255;
            imageData.data[j + 2] = prediction[i] * 255;
            imageData.data[j + 3] = 255;
        }

        this.canvas.putImageData(imageData, 0, 0);
    };

    VAEApp.prototype.render = function render() {
        var _this3 = this,
            _h,
            _h2;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])('input', (_h = {
                type: 'range',
                min: '-3', max: '3', value: '1', step: '0.1'
            }, _h['value'] = this.state.latentDims[0], _h.onChange = function onChange(e) {
                return _this3.onSliderChange({ e: e, dim: 0 });
            }, _h)),
            Object(preact_min["h"])('input', (_h2 = {
                type: 'range',
                min: '-2', max: '2', value: '1', step: '0.1'
            }, _h2['value'] = this.state.latentDims[1], _h2.onChange = function onChange(e) {
                return _this3.onSliderChange({ e: e, dim: 1 });
            }, _h2)),
            _ref2
        );
    };

    return VAEApp;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return App; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref = Object(preact_min["h"])(vae_app_VAEApp, null);

var App = function (_Component) {
	index__inherits(App, _Component);

	function App() {
		index__classCallCheck(this, App);

		return index__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	App.prototype.render = function render() {
		return _ref;
	};

	return App;
}(preact_min["Component"]);



/***/ }),

/***/ "KCUl":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__("geuY");
var EC = __webpack_require__("lZ6o").ec;
var parseKeys = __webpack_require__("jkjm");
var curves = __webpack_require__("QDfD");

function verify(sig, hash, key, signType, tag) {
  var pub = parseKeys(key);
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    return ecVerify(sig, hash, pub);
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type');
    return dsaVerify(sig, hash, pub);
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
  }
  hash = Buffer.concat([tag, hash]);
  var len = pub.modulus.byteLength();
  var pad = [1];
  var padNum = 0;
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff);
    padNum++;
  }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }
  pad = new Buffer(pad);
  var red = BN.mont(pub.modulus);
  sig = new BN(sig).toRed(red);

  sig = sig.redPow(new BN(pub.publicExponent));
  sig = new Buffer(sig.fromRed().toArray());
  var out = padNum < 8 ? 1 : 0;
  len = Math.min(sig.length, pad.length);
  if (sig.length !== pad.length) out = 1;

  i = -1;
  while (++i < len) {
    out |= sig[i] ^ pad[i];
  }return out === 0;
}

function ecVerify(sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')];
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));

  var curve = new EC(curveId);
  var pubkey = pub.data.subjectPrivateKey.data;

  return curve.verify(hash, sig, pubkey);
}

function dsaVerify(sig, hash, pub) {
  var p = pub.data.p;
  var q = pub.data.q;
  var g = pub.data.g;
  var y = pub.data.pub_key;
  var unpacked = parseKeys.signature.decode(sig, 'der');
  var s = unpacked.s;
  var r = unpacked.r;
  checkValue(s, q);
  checkValue(r, q);
  var montp = BN.mont(p);
  var w = s.invm(q);
  var v = g.toRed(montp).redPow(new BN(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
  return v.cmp(r) === 0;
}

function checkValue(b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig');
  if (b.cmp(q) >= q) throw new Error('invalid sig');
}

module.exports = verify;

/***/ }),

/***/ "KDHK":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__("geuY");

asn1.define = __webpack_require__("kJAH").define;
asn1.base = __webpack_require__("3UtB");
asn1.constants = __webpack_require__("TnCn");
asn1.decoders = __webpack_require__("iLJX");
asn1.encoders = __webpack_require__("SAez");

/***/ }),

/***/ "KQ4j":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__("LC74");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];

var W = new Array(80);

function Sha1() {
  this.init();
  this._w = W;

  Hash.call(this, 64, 56);
}

inherits(Sha1, Hash);

Sha1.prototype.init = function () {
  this._a = 0x67452301;
  this._b = 0xefcdab89;
  this._c = 0x98badcfe;
  this._d = 0x10325476;
  this._e = 0xc3d2e1f0;

  return this;
};

function rotl1(num) {
  return num << 1 | num >>> 31;
}

function rotl5(num) {
  return num << 5 | num >>> 27;
}

function rotl30(num) {
  return num << 30 | num >>> 2;
}

function ft(s, b, c, d) {
  if (s === 0) return b & c | ~b & d;
  if (s === 2) return b & c | b & d | c & d;
  return b ^ c ^ d;
}

Sha1.prototype._update = function (M) {
  var W = this._w;

  var a = this._a | 0;
  var b = this._b | 0;
  var c = this._c | 0;
  var d = this._d | 0;
  var e = this._e | 0;

  for (var i = 0; i < 16; ++i) {
    W[i] = M.readInt32BE(i * 4);
  }for (; i < 80; ++i) {
    W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
  }for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20);
    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;

    e = d;
    d = c;
    c = rotl30(b);
    b = a;
    a = t;
  }

  this._a = a + this._a | 0;
  this._b = b + this._b | 0;
  this._c = c + this._c | 0;
  this._d = d + this._d | 0;
  this._e = e + this._e | 0;
};

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20);

  H.writeInt32BE(this._a | 0, 0);
  H.writeInt32BE(this._b | 0, 4);
  H.writeInt32BE(this._c | 0, 8);
  H.writeInt32BE(this._d | 0, 12);
  H.writeInt32BE(this._e | 0, 16);

  return H;
};

module.exports = Sha1;

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_shasum":"c2d0b7776911b86722c632c3c06c60f2f819939a","_spec":"elliptic@^6.0.0","_where":"/Users/pedro/Documents/rants/basic-ae/vae/client/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),

/***/ "KeN/":
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__("BVsN");
var stream = __webpack_require__("9DG0");
var inherits = __webpack_require__("LC74");
var sign = __webpack_require__("pn+s");
var verify = __webpack_require__("KCUl");

var algorithms = __webpack_require__("ejIc");
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex');
  algorithms[key.toLowerCase()] = algorithms[key];
});

function Sign(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) throw new Error('Unknown message digest');

  this._hashType = data.hash;
  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Sign, stream.Writable);

Sign.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Sign.prototype.update = function update(data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc);

  this._hash.update(data);
  return this;
};

Sign.prototype.sign = function signMethod(key, enc) {
  this.end();
  var hash = this._hash.digest();
  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

  return enc ? sig.toString(enc) : sig;
};

function Verify(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) throw new Error('Unknown message digest');

  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Verify, stream.Writable);

Verify.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Verify.prototype.update = function update(data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc);

  this._hash.update(data);
  return this;
};

Verify.prototype.verify = function verifyMethod(key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc);

  this.end();
  var hash = this._hash.digest();
  return verify(sig, hash, key, this._signType, this._tag);
};

function createSign(algorithm) {
  return new Sign(algorithm);
}

function createVerify(algorithm) {
  return new Verify(algorithm);
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
};

/***/ }),

/***/ "LC74":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),

/***/ "LYGd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__("63KW").Buffer;
var inherits = __webpack_require__("LC74");
var HashBase = __webpack_require__("yDvu");

var ARRAY16 = new Array(16);

var zl = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13];

var zr = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11];

var sl = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6];

var sr = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];

function RIPEMD160() {
  HashBase.call(this, 64);

  // state
  this._a = 0x67452301;
  this._b = 0xefcdab89;
  this._c = 0x98badcfe;
  this._d = 0x10325476;
  this._e = 0xc3d2e1f0;
}

inherits(RIPEMD160, HashBase);

RIPEMD160.prototype._update = function () {
  var words = ARRAY16;
  for (var j = 0; j < 16; ++j) {
    words[j] = this._block.readInt32LE(j * 4);
  }var al = this._a | 0;
  var bl = this._b | 0;
  var cl = this._c | 0;
  var dl = this._d | 0;
  var el = this._e | 0;

  var ar = this._a | 0;
  var br = this._b | 0;
  var cr = this._c | 0;
  var dr = this._d | 0;
  var er = this._e | 0;

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl;
    var tr;
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
    } else {
      // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
    }

    al = el;
    el = dl;
    dl = rotl(cl, 10);
    cl = bl;
    bl = tl;

    ar = er;
    er = dr;
    dr = rotl(cr, 10);
    cr = br;
    br = tr;
  }

  // update state
  var t = this._b + cl + dr | 0;
  this._b = this._c + dl + er | 0;
  this._c = this._d + el + ar | 0;
  this._d = this._e + al + br | 0;
  this._e = this._a + bl + cr | 0;
  this._a = t;
};

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80;
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64);
    this._update();
    this._blockOffset = 0;
  }

  this._block.fill(0, this._blockOffset, 56);
  this._block.writeUInt32LE(this._length[0], 56);
  this._block.writeUInt32LE(this._length[1], 60);
  this._update();

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
  buffer.writeInt32LE(this._a, 0);
  buffer.writeInt32LE(this._b, 4);
  buffer.writeInt32LE(this._c, 8);
  buffer.writeInt32LE(this._d, 12);
  buffer.writeInt32LE(this._e, 16);
  return buffer;
};

function rotl(x, n) {
  return x << n | x >>> 32 - n;
}

function fn1(a, b, c, d, e, m, k, s) {
  return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}

function fn2(a, b, c, d, e, m, k, s) {
  return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}

function fn3(a, b, c, d, e, m, k, s) {
  return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}

function fn4(a, b, c, d, e, m, k, s) {
  return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}

function fn5(a, b, c, d, e, m, k, s) {
  return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}

module.exports = RIPEMD160;

/***/ }),

/***/ "MSVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export array */
/* unused harmony export Dataset */
/* unused harmony export zip */
/* unused harmony export CSVDataset */
/* unused harmony export TextLineDataset */
/* unused harmony export csv */
/* unused harmony export generator */
/* unused harmony export FileDataSource */
/* unused harmony export URLDataSource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__ = __webpack_require__("2qEw");
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var _extendStatics = function extendStatics(t, e) {
  return (_extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var r in e) {
      e.hasOwnProperty(r) && (t[r] = e[r]);
    }
  })(t, e);
};function __extends(t, e) {
  function r() {
    this.constructor = t;
  }_extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
}function __awaiter(t, e, r, n) {
  return new (r || (r = Promise))(function (o, i) {
    function s(t) {
      try {
        u(n.next(t));
      } catch (t) {
        i(t);
      }
    }function a(t) {
      try {
        u(n.throw(t));
      } catch (t) {
        i(t);
      }
    }function u(t) {
      t.done ? o(t.value) : new r(function (e) {
        e(t.value);
      }).then(s, a);
    }u((n = n.apply(t, e || [])).next());
  });
}function __generator(t, e) {
  var r,
      n,
      o,
      i,
      s = { label: 0, sent: function sent() {
      if (1 & o[0]) throw o[1];return o[1];
    }, trys: [], ops: [] };return i = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;function a(i) {
    return function (a) {
      return function (i) {
        if (r) throw new TypeError("Generator is already executing.");for (; s;) {
          try {
            if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {case 0:case 1:
                o = i;break;case 4:
                return s.label++, { value: i[1], done: !1 };case 5:
                s.label++, n = i[1], i = [0];continue;case 7:
                i = s.ops.pop(), s.trys.pop();continue;default:
                if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  s = 0;continue;
                }if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  s.label = i[1];break;
                }if (6 === i[0] && s.label < o[1]) {
                  s.label = o[1], o = i;break;
                }if (o && s.label < o[2]) {
                  s.label = o[2], s.ops.push(i);break;
                }o[2] && s.ops.pop(), s.trys.pop();continue;}i = e.call(t, s);
          } catch (t) {
            i = [6, t], n = 0;
          } finally {
            r = o = 0;
          }
        }if (5 & i[0]) throw i[1];return { value: i[0] ? i[1] : void 0, done: !0 };
      }([i, a]);
    };
  }
}var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};function unwrapExports(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}function createCommonjsModule(t, e) {
  return t(e = { exports: {} }, e.exports), e.exports;
}var alea = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.c = t.c, e.s0 = t.s0, e.s1 = t.s1, e.s2 = t.s2, e;
    }function o(t, e) {
      var r = new function (t) {
        var e,
            r = this,
            n = (e = 4022871197, function (t) {
          t = t.toString();for (var r = 0; r < t.length; r++) {
            var n = .02519603282416938 * (e += t.charCodeAt(r));n -= e = n >>> 0, e = (n *= e) >>> 0, e += 4294967296 * (n -= e);
          }return 2.3283064365386963e-10 * (e >>> 0);
        });r.next = function () {
          var t = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;return r.s0 = r.s1, r.s1 = r.s2, r.s2 = t - (r.c = 0 | t);
        }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(t), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(t), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(t), r.s2 < 0 && (r.s2 += 1), n = null;
      }(t),
          o = e && e.state,
          i = r.next;return i.int32 = function () {
        return 4294967296 * r.next() | 0;
      }, i.double = function () {
        return i() + 1.1102230246251565e-16 * (2097152 * i() | 0);
      }, i.quick = i, o && ("object" == typeof o && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.alea = o;
  }(0, t, !1);
}),
    xor128 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e;
    }function o(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.next = function () {
          var t = e.x ^ e.x << 11;return e.x = e.y, e.y = e.z, e.z = e.w, e.w ^= e.w >>> 19 ^ t ^ t >>> 8;
        }, t === (0 | t) ? e.x = t : r += t;for (var n = 0; n < r.length + 64; n++) {
          e.x ^= 0 | r.charCodeAt(n), e.next();
        }
      }(t),
          o = e && e.state,
          i = function i() {
        return (r.next() >>> 0) / 4294967296;
      };return i.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);return t;
      }, i.int32 = r.next, i.quick = i, o && ("object" == typeof o && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.xor128 = o;
  }(0, t, !1);
}),
    xorwow = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e.v = t.v, e.d = t.d, e;
    }function o(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";e.next = function () {
          var t = e.x ^ e.x >>> 2;return e.x = e.y, e.y = e.z, e.z = e.w, e.w = e.v, (e.d = e.d + 362437 | 0) + (e.v = e.v ^ e.v << 4 ^ t ^ t << 1) | 0;
        }, e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.v = 0, t === (0 | t) ? e.x = t : r += t;for (var n = 0; n < r.length + 64; n++) {
          e.x ^= 0 | r.charCodeAt(n), n == r.length && (e.d = e.x << 10 ^ e.x >>> 4), e.next();
        }
      }(t),
          o = e && e.state,
          i = function i() {
        return (r.next() >>> 0) / 4294967296;
      };return i.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);return t;
      }, i.int32 = r.next, i.quick = i, o && ("object" == typeof o && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.xorwow = o;
  }(0, t, !1);
}),
    xorshift7 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.x = t.x.slice(), e.i = t.i, e;
    }function o(t, e) {
      null == t && (t = +new Date());var r = new function (t) {
        var e = this;e.next = function () {
          var t,
              r,
              n = e.x,
              o = e.i;return t = n[o], r = (t ^= t >>> 7) ^ t << 24, r ^= (t = n[o + 1 & 7]) ^ t >>> 10, r ^= (t = n[o + 3 & 7]) ^ t >>> 3, r ^= (t = n[o + 4 & 7]) ^ t << 7, t = n[o + 7 & 7], r ^= (t ^= t << 13) ^ t << 9, n[o] = r, e.i = o + 1 & 7, r;
        }, function (t, e) {
          var r,
              n = [];if (e === (0 | e)) n[0] = e;else for (e = "" + e, r = 0; r < e.length; ++r) {
            n[7 & r] = n[7 & r] << 15 ^ e.charCodeAt(r) + n[r + 1 & 7] << 13;
          }for (; n.length < 8;) {
            n.push(0);
          }for (r = 0; r < 8 && 0 === n[r]; ++r) {}for (8 == r ? n[7] = -1 : n[r], t.x = n, t.i = 0, r = 256; r > 0; --r) {
            t.next();
          }
        }(e, t);
      }(t),
          o = e && e.state,
          i = function i() {
        return (r.next() >>> 0) / 4294967296;
      };return i.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);return t;
      }, i.int32 = r.next, i.quick = i, o && (o.x && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.xorshift7 = o;
  }(0, t, !1);
}),
    xor4096 = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.i = t.i, e.w = t.w, e.X = t.X.slice(), e;
    }function o(t, e) {
      null == t && (t = +new Date());var r = new function (t) {
        var e = this;e.next = function () {
          var t,
              r,
              n = e.w,
              o = e.X,
              i = e.i;return e.w = n = n + 1640531527 | 0, r = o[i + 34 & 127], t = o[i = i + 1 & 127], r ^= r << 13, t ^= t << 17, r ^= r >>> 15, t ^= t >>> 12, r = o[i] = r ^ t, e.i = i, r + (n ^ n >>> 16) | 0;
        }, function (t, e) {
          var r,
              n,
              o,
              i,
              s,
              a = [],
              u = 128;for (e === (0 | e) ? (n = e, e = null) : (e += "\0", n = 0, u = Math.max(u, e.length)), o = 0, i = -32; i < u; ++i) {
            e && (n ^= e.charCodeAt((i + 32) % e.length)), 0 === i && (s = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, i >= 0 && (s = s + 1640531527 | 0, o = 0 == (r = a[127 & i] ^= n + s) ? o + 1 : 0);
          }for (o >= 128 && (a[127 & (e && e.length || 0)] = -1), o = 127, i = 512; i > 0; --i) {
            n = a[o + 34 & 127], r = a[o = o + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, a[o] = n ^ r;
          }t.w = s, t.X = a, t.i = o;
        }(e, t);
      }(t),
          o = e && e.state,
          i = function i() {
        return (r.next() >>> 0) / 4294967296;
      };return i.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);return t;
      }, i.int32 = r.next, i.quick = i, o && (o.X && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.xor4096 = o;
  }(0, t, !1);
}),
    tychei = createCommonjsModule(function (t) {
  !function (t, e, r) {
    function n(t, e) {
      return e.a = t.a, e.b = t.b, e.c = t.c, e.d = t.d, e;
    }function o(t, e) {
      var r = new function (t) {
        var e = this,
            r = "";e.next = function () {
          var t = e.b,
              r = e.c,
              n = e.d,
              o = e.a;return t = t << 25 ^ t >>> 7 ^ r, r = r - n | 0, n = n << 24 ^ n >>> 8 ^ o, o = o - t | 0, e.b = t = t << 20 ^ t >>> 12 ^ r, e.c = r = r - n | 0, e.d = n << 16 ^ r >>> 16 ^ o, e.a = o - t | 0;
        }, e.a = 0, e.b = 0, e.c = -1640531527, e.d = 1367130551, t === Math.floor(t) ? (e.a = t / 4294967296 | 0, e.b = 0 | t) : r += t;for (var n = 0; n < r.length + 20; n++) {
          e.b ^= 0 | r.charCodeAt(n), e.next();
        }
      }(t),
          o = e && e.state,
          i = function i() {
        return (r.next() >>> 0) / 4294967296;
      };return i.double = function () {
        do {
          var t = ((r.next() >>> 11) + (r.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === t);return t;
      }, i.int32 = r.next, i.quick = i, o && ("object" == typeof o && n(o, r), i.state = function () {
        return n(r, {});
      }), i;
    }e && e.exports ? e.exports = o : r && r.amd ? r(function () {
      return o;
    }) : this.tychei = o;
  }(0, t, !1);
}),
    seedrandom = createCommonjsModule(function (t) {
  !function (e, r) {
    var n,
        o = (0, eval)("this"),
        i = 256,
        s = 6,
        a = "random",
        u = r.pow(i, s),
        h = r.pow(2, 52),
        c = 2 * h,
        l = i - 1;function f(t, f, m) {
      var v = [],
          w = d(function t(e, r) {
        var n,
            o = [],
            i = typeof e;if (r && "object" == i) for (n in e) {
          try {
            o.push(t(e[n], r - 1));
          } catch (t) {}
        }return o.length ? o : "string" == i ? e : e + "\0";
      }((f = 1 == f ? { entropy: !0 } : f || {}).entropy ? [t, y(e)] : null == t ? function () {
        try {
          var t;return n && (t = n.randomBytes) ? t = t(i) : (t = new Uint8Array(i), (o.crypto || o.msCrypto).getRandomValues(t)), y(t);
        } catch (t) {
          var r = o.navigator,
              s = r && r.plugins;return [+new Date(), o, s, o.screen, y(e)];
        }
      }() : t, 3), v),
          _ = new function (t) {
        var e,
            r = t.length,
            n = this,
            o = 0,
            s = n.i = n.j = 0,
            a = n.S = [];r || (t = [r++]);for (; o < i;) {
          a[o] = o++;
        }for (o = 0; o < i; o++) {
          a[o] = a[s = l & s + t[o % r] + (e = a[o])], a[s] = e;
        }(n.g = function (t) {
          for (var e, r = 0, o = n.i, s = n.j, a = n.S; t--;) {
            e = a[o = l & o + 1], r = r * i + a[l & (a[o] = a[s = l & s + e]) + (a[s] = e)];
          }return n.i = o, n.j = s, r;
        })(i);
      }(v),
          g = function g() {
        for (var t = _.g(s), e = u, r = 0; t < h;) {
          t = (t + r) * i, e *= i, r = _.g(1);
        }for (; t >= c;) {
          t /= 2, e /= 2, r >>>= 1;
        }return (t + r) / e;
      };return g.int32 = function () {
        return 0 | _.g(4);
      }, g.quick = function () {
        return _.g(4) / 4294967296;
      }, g.double = g, d(y(_.S), e), (f.pass || m || function (t, e, n, o) {
        return o && (o.S && p(o, _), t.state = function () {
          return p(_, {});
        }), n ? (r[a] = t, e) : t;
      })(g, w, "global" in f ? f.global : this == r, f.state);
    }function p(t, e) {
      return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
    }function d(t, e) {
      for (var r, n = t + "", o = 0; o < n.length;) {
        e[l & o] = l & (r ^= 19 * e[l & o]) + n.charCodeAt(o++);
      }return y(e);
    }function y(t) {
      return String.fromCharCode.apply(0, t);
    }if (r["seed" + a] = f, d(r.random(), e), t.exports) {
      t.exports = f;try {
        n = __webpack_require__("VI/i");
      } catch (t) {}
    } else 0;
  }([], Math);
});seedrandom.alea = alea, seedrandom.xor128 = xor128, seedrandom.xorwow = xorwow, seedrandom.xorshift7 = xorshift7, seedrandom.xor4096 = xor4096, seedrandom.tychei = tychei;var seedrandom$1 = seedrandom,
    seedrandom_1 = seedrandom$1.alea,
    util$1 = createCommonjsModule(function (t, e) {
  function r(t) {
    for (var e = t.length, r = 0, n = 0; e > 0;) {
      n = Math.random() * e | 0, r = t[--e], t[e] = t[n], t[n] = r;
    }
  }function n(t, e) {
    if (!t) throw new Error("string" == typeof e ? e : e());
  }function o(t, e) {
    if (void 0 === e && (e = []), Array.isArray(t) || h(t)) for (var r = 0; r < t.length; ++r) {
      o(t[r], e);
    } else e.push(t);return e;
  }function i(t, e) {
    if (t === e) return !0;if (null == t || null == e) return !1;if (t.length !== e.length) return !1;for (var r = 0; r < t.length; r++) {
      if (t[r] !== e[r]) return !1;
    }return !0;
  }function s(t) {
    return t % 1 == 0;
  }function a(t, e) {
    var r = e.length;return n((t = null == t ? e.map(function (t, e) {
      return e;
    }) : [].concat(t)).every(function (t) {
      return t >= -r && t < r;
    }), "All values in axis param must be in range [-" + r + ", " + r + ") but got axis " + t), n(t.every(function (t) {
      return s(t);
    }), "All values in axis param must be integers but got axis " + t), t.map(function (t) {
      return t < 0 ? r + t : t;
    });
  }function u(t, e) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];if (isNaN(n) || !isFinite(n)) throw Error("A tensor of type " + e + " being uploaded contains " + n + ".");
    }
  }function h(t) {
    return t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array;
  }function c(t) {
    return "string" == typeof t || t instanceof String;
  }function l(t) {
    return "boolean" == typeof t;
  }function f(t) {
    return "number" == typeof t;
  }function p(t, e) {
    if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);if ("int32" === e) return new Int32Array(t);if ("bool" === e) return new Uint8Array(t);throw new Error("Unknown data type " + e);
  }Object.defineProperty(e, "__esModule", { value: !0 }), e.shuffle = r, e.clamp = function (t, e, r) {
    return Math.max(t, Math.min(e, r));
  }, e.nearestLargerEven = function (t) {
    return t % 2 == 0 ? t : t + 1;
  }, e.sum = function (t) {
    for (var e = 0, r = 0; r < t.length; r++) {
      e += t[r];
    }return e;
  }, e.randUniform = function (t, e) {
    var r = Math.random();return e * r + (1 - r) * t;
  }, e.distSquared = function (t, e) {
    for (var r = 0, n = 0; n < t.length; n++) {
      var o = Number(t[n]) - Number(e[n]);r += o * o;
    }return r;
  }, e.assert = n, e.assertShapesMatch = function (t, e, r) {
    void 0 === r && (r = ""), n(i(t, e), r + " Shapes " + t + " and " + e + " must match");
  }, e.assertNonNull = function (t) {
    n(null != t, "The input to the tensor constructor must be a non-null value.");
  }, e.flatten = o, e.sizeFromShape = function (t) {
    if (0 === t.length) return 1;for (var e = t[0], r = 1; r < t.length; r++) {
      e *= t[r];
    }return e;
  }, e.isScalarShape = function (t) {
    return 0 === t.length;
  }, e.arraysEqual = i, e.isInt = s, e.tanh = function (t) {
    if (null != Math.tanh) return Math.tanh(t);if (t === 1 / 0) return 1;if (t === -1 / 0) return -1;var e = Math.exp(2 * t);return (e - 1) / (e + 1);
  }, e.sizeToSquarishShape = function (t) {
    for (var e = Math.floor(Math.sqrt(t)); e > 1; --e) {
      if (t % e == 0) return [e, t / e];
    }return [1, t];
  }, e.createShuffledIndices = function (t) {
    for (var e = new Uint32Array(t), n = 0; n < t; ++n) {
      e[n] = n;
    }return r(e), e;
  }, e.rightPad = function (t, e) {
    return e <= t.length ? t : t + " ".repeat(e - t.length);
  }, e.repeatedTry = function (t, e, r) {
    return void 0 === e && (e = function e(t) {
      return 0;
    }), new Promise(function (n, o) {
      var i = 0,
          s = function s() {
        if (t()) n();else {
          var a = e(++i);null != r && i >= r ? o() : setTimeout(s, a);
        }
      };s();
    });
  }, e.inferFromImplicitShape = function (t, e) {
    for (var r = 1, n = -1, o = 0; o < t.length; ++o) {
      if (t[o] >= 0) r *= t[o];else if (-1 === t[o]) {
        if (-1 !== n) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + n + " and dim " + o);n = o;
      } else if (t[o] < 0) throw Error("Shapes can not be < 0. Found " + t[o] + " at dim " + o);
    }if (-1 === n) {
      if (e > 0 && e !== r) throw Error("Size(" + e + ") must match the product of shape " + t);return t;
    }if (0 === r) throw Error("Cannot infer the missing size in [" + t + "] when there are 0 elements");if (e % r != 0) throw Error("The implicit shape can't be a fractional number. Got " + e + " / " + r);var i = t.slice();return i[n] = e / r, i;
  }, e.parseAxisParam = a, e.squeezeShape = function (t, e) {
    for (var r = [], n = [], o = null == e ? null : a(e, t).sort(), i = 0, s = 0; s < t.length; ++s) {
      if (null != o) {
        if (o[i] === s && 1 !== t[s]) throw new Error("Can't squeeze axis " + s + " since its dim '" + t[s] + "' is not 1");(null == o[i] || o[i] > s) && 1 === t[s] && (r.push(t[s]), n.push(s)), o[i] <= s && i++;
      }1 !== t[s] && (r.push(t[s]), n.push(s));
    }return { newShape: r, keptDims: n };
  }, e.getTypedArrayFromDType = function (t, e) {
    var r = null;if (null == t || "float32" === t) r = new Float32Array(e);else if ("int32" === t) r = new Int32Array(e);else {
      if ("bool" !== t) throw new Error("Unknown data type " + t);r = new Uint8Array(e);
    }return r;
  }, e.getArrayFromDType = function (t, e) {
    var r = null;if (null == t || "float32" === t) r = new Float32Array(e);else if ("int32" === t) r = new Int32Array(e);else if ("bool" === t) r = new Uint8Array(e);else {
      if ("string" !== t) throw new Error("Unknown data type " + t);r = new Array(e);
    }return r;
  }, e.checkComputationForErrors = function (t, e, r) {
    if ("float32" === e) for (var n = 0; n < t.length; n++) {
      var o = t[n];if (isNaN(o) || !isFinite(o)) throw Error("The result of the '" + r + "' is " + o + ".");
    }
  }, e.checkConversionForErrors = u, e.hasEncodingLoss = function (t, e) {
    return !("complex64" === e || "float32" === e && "complex64" !== t || "int32" === e && "float32" !== t && "complex64" !== t || "bool" === e && "bool" === t);
  }, e.isTypedArray = h, e.bytesPerElement = function (t) {
    if ("float32" === t || "int32" === t) return 4;if ("complex64" === t) return 8;if ("bool" === t) return 1;throw new Error("Unknown dtype " + t);
  }, e.bytesFromStringArray = function (t) {
    if (null == t) return 0;var e = 0;return t.forEach(function (t) {
      return e += 2 * t.length;
    }), e;
  }, e.isString = c, e.isBoolean = l, e.isNumber = f, e.inferDtype = function t(e) {
    return e instanceof Array ? t(e[0]) : e instanceof Float32Array ? "float32" : e instanceof Int32Array || e instanceof Uint8Array ? "int32" : f(e) ? "float32" : c(e) ? "string" : l(e) ? "bool" : "float32";
  }, e.isFunction = function (t) {
    return !!(t && t.constructor && t.call && t.apply);
  }, e.nearestDivisor = function (t, e) {
    for (var r = e; r < t; ++r) {
      if (t % r == 0) return r;
    }return t;
  }, e.computeStrides = function (t) {
    var e = t.length;if (e < 2) return [];var r = new Array(e - 1);r[e - 2] = t[e - 1];for (var n = e - 3; n >= 0; --n) {
      r[n] = r[n + 1] * t[n + 1];
    }return r;
  }, e.toTypedArray = function (t, e, r) {
    if ("string" === e) throw new Error("Cannot convert a string[] to a TypedArray");if (Array.isArray(t) && (t = o(t)), r && u(t, e), function (t, e) {
      return t instanceof Float32Array && "float32" === e || t instanceof Int32Array && "int32" === e || t instanceof Uint8Array && "bool" === e;
    }(t, e)) return t;if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);if ("int32" === e) return new Int32Array(t);if ("bool" === e) {
      for (var n = new Uint8Array(t.length), i = 0; i < n.length; ++i) {
        0 !== Math.round(t[i]) && (n[i] = 1);
      }return n;
    }throw new Error("Unknown data type " + e);
  }, e.makeOnesTypedArray = function (t, e) {
    for (var r = p(t, e), n = 0; n < r.length; n++) {
      r[n] = 1;
    }return r;
  }, e.makeZerosTypedArray = p, e.now = function () {
    if ("undefined" != typeof performance) return performance.now();if ("undefined" != typeof process) {
      var t = process.hrtime();return 1e3 * t[0] + t[1] / 1e6;
    }throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js");
  };
});unwrapExports(util$1);var util_1 = util$1.shuffle,
    util_2 = util$1.clamp,
    util_3 = util$1.nearestLargerEven,
    util_4 = util$1.sum,
    util_5 = util$1.randUniform,
    util_6 = util$1.distSquared,
    util_7 = util$1.assert,
    util_8 = util$1.assertShapesMatch,
    util_9 = util$1.assertNonNull,
    util_10 = util$1.flatten,
    util_11 = util$1.sizeFromShape,
    util_12 = util$1.isScalarShape,
    util_13 = util$1.arraysEqual,
    util_14 = util$1.isInt,
    util_15 = util$1.tanh,
    util_16 = util$1.sizeToSquarishShape,
    util_17 = util$1.createShuffledIndices,
    util_18 = util$1.rightPad,
    util_19 = util$1.repeatedTry,
    util_20 = util$1.inferFromImplicitShape,
    util_21 = util$1.parseAxisParam,
    util_22 = util$1.squeezeShape,
    util_23 = util$1.getTypedArrayFromDType,
    util_24 = util$1.getArrayFromDType,
    util_25 = util$1.checkComputationForErrors,
    util_26 = util$1.checkConversionForErrors,
    util_27 = util$1.hasEncodingLoss,
    util_28 = util$1.isTypedArray,
    util_29 = util$1.bytesPerElement,
    util_30 = util$1.bytesFromStringArray,
    util_31 = util$1.isString,
    util_32 = util$1.isBoolean,
    util_33 = util$1.isNumber,
    util_34 = util$1.inferDtype,
    util_35 = util$1.isFunction,
    util_36 = util$1.nearestDivisor,
    util_37 = util$1.computeStrides,
    util_38 = util$1.toTypedArray,
    util_39 = util$1.makeOnesTypedArray,
    util_40 = util$1.makeZerosTypedArray,
    util_41 = util$1.now,
    tensor_format = createCommonjsModule(function (t, e) {
  Object.defineProperty(e, "__esModule", { value: !0 });var r = 20,
      n = 3,
      o = 7;function i(t, e) {
    var r;return r = Array.isArray(t) ? parseFloat(t[0].toFixed(o)) + " + " + parseFloat(t[1].toFixed(o)) + "j" : util$1.isString(t) ? "'" + t + "'" : parseFloat(t.toFixed(o)).toString(), util$1.rightPad(r, e);
  }function s(t) {
    for (var e = [], r = 0; r < t.length; r += 2) {
      e.push([t[r], t[r + 1]]);
    }return e;
  }e.tensorToString = function (t, e, o, a) {
    var u = util$1.computeStrides(e),
        h = function (t, e, r, n) {
      var o = util$1.sizeFromShape(e),
          a = n[n.length - 1],
          u = new Array(a).fill(0),
          h = e.length,
          c = "complex64" === r ? s(t) : t;if (h > 1) for (var l = 0; l < o / a; l++) {
        for (var f = l * a, p = 0; p < a; p++) {
          u[p] = Math.max(u[p], i(c[f + p], 0).length);
        }
      }return u;
    }(t, e, o, u),
        c = e.length,
        l = function t(e, o, a, u, h, c) {
      void 0 === c && (c = !0);var l = "complex64" === a ? 2 : 1,
          f = o[0],
          p = o.length;if (0 === p) {
        if ("complex64" === a) {
          var d = s(e);return [i(d[0], 0)];
        }return [e[0].toString()];
      }if (1 === p) {
        if (f > r) {
          var y = n * l,
              m = Array.from(e.slice(0, y)),
              v = Array.from(e.slice(f - n * l, f));return "complex64" === a && (m = s(m), v = s(v)), ["[" + m.map(function (t, e) {
            return i(t, h[e]);
          }).join(", ") + ", ..., " + v.map(function (t, e) {
            return i(t, h[f - n + e]);
          }).join(", ") + "]"];
        }var w = "complex64" === a ? s(e) : Array.from(e);return ["[" + w.map(function (t, e) {
          return i(t, h[e]);
        }).join(", ") + "]"];
      }var _ = o.slice(1),
          g = u.slice(1),
          I = u[0] * l,
          b = [];if (f > r) {
        for (var x = 0; x < n; x++) {
          var D = x * I,
              S = D + I;b.push.apply(b, t(e.slice(D, S), _, a, g, h, !1));
        }b.push("...");for (var x = f - n; x < f; x++) {
          var D = x * I,
              S = D + I;b.push.apply(b, t(e.slice(D, S), _, a, g, h, x === f - 1));
        }
      } else for (var x = 0; x < f; x++) {
        var D = x * I,
            S = D + I;b.push.apply(b, t(e.slice(D, S), _, a, g, h, x === f - 1));
      }var T = 2 === p ? "," : "";b[0] = "[" + b[0] + T;for (var x = 1; x < b.length - 1; x++) {
        b[x] = " " + b[x] + T;
      }for (var E = ",\n", x = 2; x < p; x++) {
        E += "\n";
      }return b[b.length - 1] = " " + b[b.length - 1] + "]" + (c ? "" : E), b;
    }(t, e, o, u, h),
        f = ["Tensor"];return a && (f.push("  dtype: " + o), f.push("  rank: " + c), f.push("  shape: [" + e + "]"), f.push("  values:")), f.push(l.map(function (t) {
      return "    " + t;
    }).join("\n")), f.join("\n");
  };
});unwrapExports(tensor_format);var tensor_format_1 = tensor_format.tensorToString,
    tensor = createCommonjsModule(function (t, e) {
  var r,
      n = commonjsGlobal && commonjsGlobal.__extends || (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var r in e) {
      e.hasOwnProperty(r) && (t[r] = e[r]);
    }
  }, function (t, e) {
    function n() {
      this.constructor = t;
    }r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
  }),
      o = commonjsGlobal && commonjsGlobal.__awaiter || function (t, e, r, n) {
    return new (r || (r = Promise))(function (o, i) {
      function s(t) {
        try {
          u(n.next(t));
        } catch (t) {
          i(t);
        }
      }function a(t) {
        try {
          u(n.throw(t));
        } catch (t) {
          i(t);
        }
      }function u(t) {
        t.done ? o(t.value) : new r(function (e) {
          e(t.value);
        }).then(s, a);
      }u((n = n.apply(t, e || [])).next());
    });
  },
      i = commonjsGlobal && commonjsGlobal.__generator || function (t, e) {
    var r,
        n,
        o,
        i,
        s = { label: 0, sent: function sent() {
        if (1 & o[0]) throw o[1];return o[1];
      }, trys: [], ops: [] };return i = { next: a(0), throw: a(1), return: a(2) }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;function a(i) {
      return function (a) {
        return function (i) {
          if (r) throw new TypeError("Generator is already executing.");for (; s;) {
            try {
              if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {case 0:case 1:
                  o = i;break;case 4:
                  return s.label++, { value: i[1], done: !1 };case 5:
                  s.label++, n = i[1], i = [0];continue;case 7:
                  i = s.ops.pop(), s.trys.pop();continue;default:
                  if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                    s = 0;continue;
                  }if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    s.label = i[1];break;
                  }if (6 === i[0] && s.label < o[1]) {
                    s.label = o[1], o = i;break;
                  }if (o && s.label < o[2]) {
                    s.label = o[2], s.ops.push(i);break;
                  }o[2] && s.ops.pop(), s.trys.pop();continue;}i = e.call(t, s);
            } catch (t) {
              i = [6, t], n = 0;
            } finally {
              r = o = 0;
            }
          }if (5 & i[0]) throw i[1];return { value: i[0] ? i[1] : void 0, done: !0 };
        }([i, a]);
      };
    }
  };Object.defineProperty(e, "__esModule", { value: !0 });var s = util$1,
      a = function () {
    function t(t, e, r) {
      if (this.dtype = e, this.shape = t.slice(), this.size = util$1.sizeFromShape(t), null != r) {
        var n = r.length;util$1.assert(n === this.size, "Length of values '" + n + "' does not match the size inferred by the shape '" + this.size + "'.");
      }if ("complex64" === e) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");this.values = r || util$1.getArrayFromDType(e, util$1.sizeFromShape(this.shape)), this.strides = s.computeStrides(t);
    }return t.prototype.set = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }0 === e.length && (e = [0]), util$1.assert(e.length === this.rank, "The number of provided coordinates (" + e.length + ") must match the rank (" + this.rank + ")");var n = this.locToIndex(e);this.values[n] = t;
    }, t.prototype.get = function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }0 === t.length && (t = [0]);for (var r = t[t.length - 1], n = 0; n < t.length - 1; ++n) {
        r += this.strides[n] * t[n];
      }return this.values[r];
    }, t.prototype.locToIndex = function (t) {
      if (0 === this.rank) return 0;if (1 === this.rank) return t[0];for (var e = t[t.length - 1], r = 0; r < t.length - 1; ++r) {
        e += this.strides[r] * t[r];
      }return e;
    }, t.prototype.indexToLoc = function (t) {
      if (0 === this.rank) return [];if (1 === this.rank) return [t];for (var e = new Array(this.shape.length), r = 0; r < e.length - 1; ++r) {
        e[r] = Math.floor(t / this.strides[r]), t -= e[r] * this.strides[r];
      }return e[e.length - 1] = t, e;
    }, Object.defineProperty(t.prototype, "rank", { get: function get() {
        return this.shape.length;
      }, enumerable: !0, configurable: !0 }), t.prototype.toTensor = function () {
      return c.make(this.shape, { values: this.values }, this.dtype);
    }, t;
  }();e.TensorBuffer = a;var u = null,
      h = null;e.setTensorTracker = function (t) {
    u = t;
  }, e.setOpHandler = function (t) {
    h = t;
  };var c = function () {
    function t(t, e, r, n) {
      this.isDisposedInternal = !1, this.shape = t.slice(), this.dtype = e || "float32", this.size = util$1.sizeFromShape(t), this.strides = s.computeStrides(t), this.dataId = null != n ? n : {}, this.id = u().nextTensorId(), this.rankType = this.rank < 5 ? this.rank.toString() : "higher", u().registerTensor(this), null != r && u().write(this.dataId, r);
    }return t.make = function (e, r, n) {
      return new t(e, n, r.values, r.dataId);
    }, t.prototype.flatten = function () {
      return this.throwIfDisposed(), this.as1D();
    }, t.prototype.asScalar = function () {
      return this.throwIfDisposed(), util$1.assert(1 === this.size, "The array must have only 1 element."), this.reshape([]);
    }, t.prototype.as1D = function () {
      return this.throwIfDisposed(), this.reshape([this.size]);
    }, t.prototype.as2D = function (t, e) {
      return this.throwIfDisposed(), this.reshape([t, e]);
    }, t.prototype.as3D = function (t, e, r) {
      return this.throwIfDisposed(), this.reshape([t, e, r]);
    }, t.prototype.as4D = function (t, e, r, n) {
      return this.throwIfDisposed(), this.reshape([t, e, r, n]);
    }, t.prototype.as5D = function (t, e, r, n, o) {
      return this.throwIfDisposed(), this.reshape([t, e, r, n, o]);
    }, t.prototype.asType = function (t) {
      return this.throwIfDisposed(), h.cast(this, t);
    }, Object.defineProperty(t.prototype, "rank", { get: function get() {
        return this.shape.length;
      }, enumerable: !0, configurable: !0 }), t.prototype.get = function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }util$1.assert(t.length === this.rank, "Number of coordinates in get() must match the rank of the tensor"), util$1.assert("complex64" !== this.dtype, "Tensor.get() is not supported for complex64 tensors yet."), this.throwIfDisposed(), 0 === t.length && (t = [0]);for (var r = t[t.length - 1], n = 0; n < t.length - 1; ++n) {
        r += this.strides[n] * t[n];
      }return this.dataSync()[r];
    }, t.prototype.buffer = function () {
      return h.buffer(this.shape, this.dtype, this.dataSync());
    }, t.prototype.data = function () {
      return o(this, void 0, void 0, function () {
        return i(this, function (t) {
          return this.throwIfDisposed(), [2, u().read(this.dataId)];
        });
      });
    }, t.prototype.dataSync = function () {
      return this.throwIfDisposed(), u().readSync(this.dataId);
    }, t.prototype.dispose = function () {
      this.isDisposed || (u().disposeTensor(this), this.isDisposedInternal = !0);
    }, Object.defineProperty(t.prototype, "isDisposed", { get: function get() {
        return this.isDisposedInternal;
      }, enumerable: !0, configurable: !0 }), t.prototype.throwIfDisposed = function () {
      if (this.isDisposed) throw new Error("Tensor is disposed.");
    }, t.prototype.toFloat = function () {
      return this.asType("float32");
    }, t.prototype.toInt = function () {
      return this.asType("int32");
    }, t.prototype.toBool = function () {
      return this.asType("bool");
    }, t.prototype.print = function (t) {
      return void 0 === t && (t = !1), h.print(this, t);
    }, t.prototype.reshape = function (t) {
      return this.throwIfDisposed(), h.reshape(this, t);
    }, t.prototype.reshapeAs = function (t) {
      return this.throwIfDisposed(), this.reshape(t.shape);
    }, t.prototype.expandDims = function (t) {
      return void 0 === t && (t = 0), h.expandDims(this, t);
    }, t.prototype.cumsum = function (t, e, r) {
      return void 0 === t && (t = 0), void 0 === e && (e = !1), void 0 === r && (r = !1), h.cumsum(this, t, e, r);
    }, t.prototype.squeeze = function (t) {
      return this.throwIfDisposed(), h.squeeze(this, t);
    }, t.prototype.clone = function () {
      return this.throwIfDisposed(), h.clone(this);
    }, t.prototype.toString = function (t) {
      void 0 === t && (t = !1);var e = this.dataSync();return tensor_format.tensorToString(e, this.shape, this.dtype, t);
    }, t.prototype.tile = function (t) {
      return this.throwIfDisposed(), h.tile(this, t);
    }, t.prototype.gather = function (t, e) {
      return void 0 === e && (e = 0), this.throwIfDisposed(), h.gather(this, t, e);
    }, t.prototype.matMul = function (t, e, r) {
      return void 0 === e && (e = !1), void 0 === r && (r = !1), this.throwIfDisposed(), h.matMul(this, t, e, r);
    }, t.prototype.dot = function (t) {
      return this.throwIfDisposed(), h.dot(this, t);
    }, t.prototype.norm = function (t, e, r) {
      return void 0 === t && (t = "euclidean"), void 0 === e && (e = null), void 0 === r && (r = !1), this.throwIfDisposed(), h.norm(this, t, e, r);
    }, t.prototype.slice = function (t, e) {
      return this.throwIfDisposed(), h.slice(this, t, e);
    }, t.prototype.reverse = function (t) {
      return this.throwIfDisposed(), h.reverse(this, t);
    }, t.prototype.concat = function (e, r) {
      return void 0 === r && (r = 0), this.throwIfDisposed(), e instanceof t && (e = [e]), h.concat([this].concat(e), r);
    }, t.prototype.split = function (t, e) {
      return void 0 === e && (e = 0), this.throwIfDisposed(), h.split(this, t, e);
    }, t.prototype.stack = function (t, e) {
      return void 0 === e && (e = 0), h.stack([this, t], e);
    }, t.prototype.unstack = function (t, e) {
      return void 0 === e && (e = 0), h.unstack(this, e);
    }, t.prototype.pad = function (t, e) {
      return void 0 === e && (e = 0), h.pad(this, t, e);
    }, t.prototype.batchNormalization = function (t, e, r, n, o) {
      return void 0 === r && (r = .001), this.throwIfDisposed(), h.batchNormalization(this, t, e, r, n, o);
    }, t.prototype.all = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.all(this, t, e);
    }, t.prototype.any = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.any(this, t, e);
    }, t.prototype.logSumExp = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.logSumExp(this, t, e);
    }, t.prototype.sum = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.sum(this, t, e);
    }, t.prototype.prod = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.prod(this, t, e);
    }, t.prototype.mean = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.mean(this, t, e);
    }, t.prototype.min = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.min(this, t, e);
    }, t.prototype.max = function (t, e) {
      return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), h.max(this, t, e);
    }, t.prototype.argMin = function (t) {
      return void 0 === t && (t = null), this.throwIfDisposed(), h.argMin(this, t);
    }, t.prototype.argMax = function (t) {
      return void 0 === t && (t = null), this.throwIfDisposed(), h.argMax(this, t);
    }, t.prototype.cast = function (t) {
      return this.throwIfDisposed(), h.cast(this, t);
    }, t.prototype.add = function (t) {
      return this.throwIfDisposed(), h.add(this, t);
    }, t.prototype.addStrict = function (t) {
      return this.throwIfDisposed(), h.addStrict(this, t);
    }, t.prototype.atan2 = function (t) {
      return this.throwIfDisposed(), h.atan2(this, t);
    }, t.prototype.sub = function (t) {
      return this.throwIfDisposed(), h.sub(this, t);
    }, t.prototype.subStrict = function (t) {
      return this.throwIfDisposed(), h.subStrict(this, t);
    }, t.prototype.pow = function (t) {
      return this.throwIfDisposed(), h.pow(this, t);
    }, t.prototype.powStrict = function (t) {
      return this.throwIfDisposed(), h.powStrict(this, t);
    }, t.prototype.mul = function (t) {
      return this.throwIfDisposed(), h.mul(this, t);
    }, t.prototype.mulStrict = function (t) {
      return this.throwIfDisposed(), h.mulStrict(this, t);
    }, t.prototype.div = function (t) {
      return this.throwIfDisposed(), h.div(this, t);
    }, t.prototype.floorDiv = function (t) {
      return this.throwIfDisposed(), h.floorDiv(this, t);
    }, t.prototype.divStrict = function (t) {
      return this.throwIfDisposed(), h.divStrict(this, t);
    }, t.prototype.minimum = function (t) {
      return this.throwIfDisposed(), h.minimum(this, t);
    }, t.prototype.minimumStrict = function (t) {
      return this.throwIfDisposed(), h.minimumStrict(this, t);
    }, t.prototype.maximum = function (t) {
      return this.throwIfDisposed(), h.maximum(this, t);
    }, t.prototype.maximumStrict = function (t) {
      return this.throwIfDisposed(), h.maximumStrict(this, t);
    }, t.prototype.mod = function (t) {
      return this.throwIfDisposed(), h.mod(this, t);
    }, t.prototype.modStrict = function (t) {
      return this.throwIfDisposed(), h.modStrict(this, t);
    }, t.prototype.squaredDifference = function (t) {
      return this.throwIfDisposed(), h.squaredDifference(this, t);
    }, t.prototype.squaredDifferenceStrict = function (t) {
      return this.throwIfDisposed(), h.squaredDifferenceStrict(this, t);
    }, t.prototype.transpose = function (t) {
      return this.throwIfDisposed(), h.transpose(this, t);
    }, t.prototype.notEqual = function (t) {
      return this.throwIfDisposed(), h.notEqual(this, t);
    }, t.prototype.notEqualStrict = function (t) {
      return this.throwIfDisposed(), h.notEqualStrict(this, t);
    }, t.prototype.less = function (t) {
      return this.throwIfDisposed(), h.less(this, t);
    }, t.prototype.lessStrict = function (t) {
      return this.throwIfDisposed(), h.lessStrict(this, t);
    }, t.prototype.equal = function (t) {
      return this.throwIfDisposed(), h.equal(this, t);
    }, t.prototype.equalStrict = function (t) {
      return this.throwIfDisposed(), h.equalStrict(this, t);
    }, t.prototype.lessEqual = function (t) {
      return this.throwIfDisposed(), h.lessEqual(this, t);
    }, t.prototype.lessEqualStrict = function (t) {
      return this.throwIfDisposed(), h.lessEqualStrict(this, t);
    }, t.prototype.greater = function (t) {
      return this.throwIfDisposed(), h.greater(this, t);
    }, t.prototype.greaterStrict = function (t) {
      return this.throwIfDisposed(), h.greaterStrict(this, t);
    }, t.prototype.greaterEqual = function (t) {
      return this.throwIfDisposed(), h.greaterEqual(this, t);
    }, t.prototype.greaterEqualStrict = function (t) {
      return this.throwIfDisposed(), h.greaterEqualStrict(this, t);
    }, t.prototype.logicalAnd = function (t) {
      return this.throwIfDisposed(), h.logicalAnd(this, t);
    }, t.prototype.logicalOr = function (t) {
      return this.throwIfDisposed(), h.logicalOr(this, t);
    }, t.prototype.logicalNot = function () {
      return this.throwIfDisposed(), h.logicalNot(this);
    }, t.prototype.logicalXor = function (t) {
      return this.throwIfDisposed(), h.logicalXor(this, t);
    }, t.prototype.where = function (t, e) {
      return this.throwIfDisposed(), h.where(t, this, e);
    }, t.prototype.neg = function () {
      return this.throwIfDisposed(), h.neg(this);
    }, t.prototype.ceil = function () {
      return this.throwIfDisposed(), h.ceil(this);
    }, t.prototype.floor = function () {
      return this.throwIfDisposed(), h.floor(this);
    }, t.prototype.sign = function () {
      return this.throwIfDisposed(), h.sign(this);
    }, t.prototype.exp = function () {
      return this.throwIfDisposed(), h.exp(this);
    }, t.prototype.expm1 = function () {
      return this.throwIfDisposed(), h.expm1(this);
    }, t.prototype.log = function () {
      return this.throwIfDisposed(), h.log(this);
    }, t.prototype.log1p = function () {
      return this.throwIfDisposed(), h.log1p(this);
    }, t.prototype.sqrt = function () {
      return this.throwIfDisposed(), h.sqrt(this);
    }, t.prototype.rsqrt = function () {
      return this.throwIfDisposed(), h.rsqrt(this);
    }, t.prototype.square = function () {
      return this.throwIfDisposed(), h.square(this);
    }, t.prototype.reciprocal = function () {
      return this.throwIfDisposed(), h.reciprocal(this);
    }, t.prototype.abs = function () {
      return this.throwIfDisposed(), h.abs(this);
    }, t.prototype.clipByValue = function (t, e) {
      return this.throwIfDisposed(), h.clipByValue(this, t, e);
    }, t.prototype.relu = function () {
      return this.throwIfDisposed(), h.relu(this);
    }, t.prototype.elu = function () {
      return this.throwIfDisposed(), h.elu(this);
    }, t.prototype.selu = function () {
      return this.throwIfDisposed(), h.selu(this);
    }, t.prototype.leakyRelu = function (t) {
      return void 0 === t && (t = .2), this.throwIfDisposed(), h.leakyRelu(this, t);
    }, t.prototype.prelu = function (t) {
      return this.throwIfDisposed(), h.prelu(this, t);
    }, t.prototype.sigmoid = function () {
      return this.throwIfDisposed(), h.sigmoid(this);
    }, t.prototype.logSigmoid = function () {
      return this.throwIfDisposed(), h.logSigmoid(this);
    }, t.prototype.softplus = function () {
      return this.throwIfDisposed(), h.softplus(this);
    }, t.prototype.zerosLike = function () {
      return this.throwIfDisposed(), h.zerosLike(this);
    }, t.prototype.onesLike = function () {
      return this.throwIfDisposed(), h.onesLike(this);
    }, t.prototype.sin = function () {
      return this.throwIfDisposed(), h.sin(this);
    }, t.prototype.cos = function () {
      return this.throwIfDisposed(), h.cos(this);
    }, t.prototype.tan = function () {
      return this.throwIfDisposed(), h.tan(this);
    }, t.prototype.asin = function () {
      return this.throwIfDisposed(), h.asin(this);
    }, t.prototype.acos = function () {
      return this.throwIfDisposed(), h.acos(this);
    }, t.prototype.atan = function () {
      return this.throwIfDisposed(), h.atan(this);
    }, t.prototype.sinh = function () {
      return this.throwIfDisposed(), h.sinh(this);
    }, t.prototype.cosh = function () {
      return this.throwIfDisposed(), h.cosh(this);
    }, t.prototype.tanh = function () {
      return this.throwIfDisposed(), h.tanh(this);
    }, t.prototype.asinh = function () {
      return this.throwIfDisposed(), h.asinh(this);
    }, t.prototype.acosh = function () {
      return this.throwIfDisposed(), h.acosh(this);
    }, t.prototype.atanh = function () {
      return this.throwIfDisposed(), h.atanh(this);
    }, t.prototype.erf = function () {
      return this.throwIfDisposed(), h.erf(this);
    }, t.prototype.round = function () {
      return this.throwIfDisposed(), h.round(this);
    }, t.prototype.step = function (t) {
      return void 0 === t && (t = 0), this.throwIfDisposed(), h.step(this, t);
    }, t.prototype.softmax = function (t) {
      return void 0 === t && (t = -1), this.throwIfDisposed(), h.softmax(this, t);
    }, t.prototype.logSoftmax = function (t) {
      return void 0 === t && (t = -1), this.throwIfDisposed(), h.logSoftmax(this, t);
    }, t.prototype.resizeBilinear = function (t, e) {
      return void 0 === e && (e = !1), this.throwIfDisposed(), h.image.resizeBilinear(this, t, e);
    }, t.prototype.resizeNearestNeighbor = function (t, e) {
      return void 0 === e && (e = !1), this.throwIfDisposed(), h.image.resizeNearestNeighbor(this, t, e);
    }, t.prototype.conv1d = function (t, e, r, n, o, i) {
      return void 0 === n && (n = "NWC"), void 0 === o && (o = 1), this.throwIfDisposed(), h.conv1d(this, t, e, r, n, o, i);
    }, t.prototype.conv2d = function (t, e, r, n, o, i) {
      return void 0 === n && (n = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), h.conv2d(this, t, e, r, n, o, i);
    }, t.prototype.conv2dTranspose = function (t, e, r, n, o) {
      return this.throwIfDisposed(), h.conv2dTranspose(this, t, e, r, n, o);
    }, t.prototype.depthwiseConv2D = function (t, e, r, n, o, i) {
      return void 0 === n && (n = "NHWC"), void 0 === o && (o = [1, 1]), this.throwIfDisposed(), h.depthwiseConv2d(this, t, e, r, n, o, i);
    }, t.prototype.separableConv2d = function (t, e, r, n, o, i) {
      return void 0 === o && (o = [1, 1]), void 0 === i && (i = "NHWC"), this.throwIfDisposed(), h.separableConv2d(this, t, e, r, n, o, i);
    }, t.prototype.avgPool = function (t, e, r, n) {
      return this.throwIfDisposed(), h.avgPool(this, t, e, r, n);
    }, t.prototype.maxPool = function (t, e, r, n) {
      return this.throwIfDisposed(), h.maxPool(this, t, e, r, n);
    }, t.prototype.localResponseNormalization = function (t, e, r, n) {
      return void 0 === t && (t = 5), void 0 === e && (e = 1), void 0 === r && (r = 1), void 0 === n && (n = .5), h.localResponseNormalization(this, t, e, r, n);
    }, t.prototype.pool = function (t, e, r, n, o) {
      return this.throwIfDisposed(), h.pool(this, t, e, r, n, o);
    }, t.prototype.variable = function (t, e, r) {
      return void 0 === t && (t = !0), this.throwIfDisposed(), l.variable(this, t, e, r);
    }, t.prototype.unsortedSegmentSum = function (t, e) {
      return this.throwIfDisposed(), h.unsortedSegmentSum(this, t, e);
    }, t.prototype.batchToSpaceND = function (t, e) {
      return this.throwIfDisposed(), h.batchToSpaceND(this, t, e);
    }, t.prototype.spaceToBatchND = function (t, e) {
      return this.throwIfDisposed(), h.spaceToBatchND(this, t, e);
    }, t.prototype.topk = function (t, e) {
      return void 0 === t && (t = 1), void 0 === e && (e = !0), this.throwIfDisposed(), h.topk(this, t, e);
    }, t.prototype.stridedSlice = function (t, e, r, n, o, i, s, a) {
      return void 0 === n && (n = 0), void 0 === o && (o = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), void 0 === a && (a = 0), this.throwIfDisposed(), h.stridedSlice(this, t, e, r, n, o, i, s, a);
    }, t.prototype.depthToSpace = function (t, e) {
      return this.throwIfDisposed(), h.depthToSpace(this, t, e);
    }, t.prototype.fft = function () {
      return this.throwIfDisposed(), h.spectral.fft(this);
    }, t.prototype.ifft = function () {
      return this.throwIfDisposed(), h.spectral.ifft(this);
    }, t.prototype.rfft = function () {
      return this.throwIfDisposed(), h.spectral.rfft(this);
    }, t.prototype.irfft = function () {
      return this.throwIfDisposed(), h.spectral.irfft(this);
    }, t;
  }();e.Tensor = c, Object.defineProperty(c, Symbol.hasInstance, { value: function value(t) {
      return !!t && null != t.dataId && null != t.shape && null != t.dtype;
    } });var l = function (t) {
    function e(e, r, n) {
      void 0 === r && (r = !0);var o = t.call(this, e.shape, e.dtype, null, e.dataId) || this;o.trainable = r, o.name = n, null == o.name && (o.name = u().nextVariableId().toString());try {
        u().registerVariable(o);
      } catch (t) {
        throw u().disposeTensor(o), t;
      }return o;
    }return n(e, t), e.variable = function (t, r, n, o) {
      return void 0 === r && (r = !0), null != o && o !== t.dtype && (t = t.asType(o)), new e(t, r, n);
    }, e.prototype.assign = function (t) {
      if (t.dtype !== this.dtype) throw new Error("dtype of the new value (" + t.dtype + ") and previous value (" + this.dtype + ") must match");if (!util$1.arraysEqual(t.shape, this.shape)) throw new Error("shape of the new value (" + t.shape + ") and previous value (" + this.shape + ") must match");u().disposeTensor(this), this.dataId = t.dataId, u().registerTensor(this);
    }, e;
  }(c);e.Variable = l, Object.defineProperty(l, Symbol.hasInstance, { value: function value(t) {
      return t instanceof c && null != t.assign && t.assign instanceof Function;
    } });var f = l.variable;e.variable = f;
});unwrapExports(tensor);var tensor_1 = tensor.TensorBuffer,
    tensor_2 = tensor.setTensorTracker,
    tensor_3 = tensor.setOpHandler,
    tensor_4 = tensor.Tensor,
    tensor_5 = tensor.Variable,
    tensor_6 = tensor.variable,
    types = createCommonjsModule(function (t, e) {
  var r, n, o, i;Object.defineProperty(e, "__esModule", { value: !0 }), function (t) {
    t.R0 = "R0", t.R1 = "R1", t.R2 = "R2", t.R3 = "R3", t.R4 = "R4", t.R5 = "R5", t.R6 = "R6";
  }(e.Rank || (e.Rank = {})), function (t) {
    t.float32 = "float32", t.int32 = "int32", t.bool = "int32", t.complex64 = "complex64";
  }(r || (r = {})), function (t) {
    t.float32 = "float32", t.int32 = "int32", t.bool = "bool", t.complex64 = "complex64";
  }(n || (n = {})), function (t) {
    t.float32 = "float32", t.int32 = "float32", t.bool = "float32", t.complex64 = "complex64";
  }(o || (o = {})), function (t) {
    t.float32 = "complex64", t.int32 = "complex64", t.bool = "complex64", t.complex64 = "complex64";
  }(i || (i = {}));var s = { float32: o, int32: r, bool: n, complex64: i };function a(t, e) {
    if ("string" === t || "string" === e) {
      if ("string" === t && "string" === e) return "string";throw new Error("Can not upcast " + t + " with " + e);
    }return s[t][e];
  }e.upcastType = a, e.sumOutType = function (t) {
    return a(t, "int32");
  };
});unwrapExports(types);var types_1 = types.Rank,
    types_2 = types.upcastType,
    types_3 = types.sumOutType,
    tensor_util = createCommonjsModule(function (t, e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.makeTypesMatch = function (t, e) {
    if (t.dtype === e.dtype) return [t, e];var r = types.upcastType(t.dtype, e.dtype);return [t.cast(r), e.cast(r)];
  }, e.assertTypesMatch = function (t, e) {
    util$1.assert(t.dtype === e.dtype, "The dtypes of the first(" + t.dtype + ") and second(" + e.dtype + ") input must match");
  }, e.isTensorInList = function (t, e) {
    for (var r = 0; r < e.length; r++) {
      if (e[r].id === t.id) return !0;
    }return !1;
  }, e.flattenNameArrayMap = function (t, e) {
    var r = [];if (t instanceof tensor.Tensor) r.push(t);else for (var n = t, o = 0; o < e.length; o++) {
      r.push(n[e[o]]);
    }return r;
  }, e.unflattenToNameArrayMap = function (t, e) {
    if (t.length !== e.length) throw new Error("Cannot unflatten Tensor[], keys and arrays are not of same length.");for (var r = {}, n = 0; n < t.length; n++) {
      r[t[n]] = e[n];
    }return r;
  }, e.getTensorsInContainer = function (t) {
    var e = [];return function t(e, r, n) {
      if (null != e) if (e instanceof tensor.Tensor) r.push(e);else if (o = e, Array.isArray(o) || "object" == typeof o) {
        var o,
            i = e;for (var s in i) {
          var a = i[s];n.has(a) || (n.add(a), t(a, r, n));
        }
      }
    }(t, e, new Set()), e;
  };
});unwrapExports(tensor_util);var tensor_util_1 = tensor_util.makeTypesMatch,
    tensor_util_2 = tensor_util.assertTypesMatch,
    tensor_util_3 = tensor_util.isTensorInList,
    tensor_util_4 = tensor_util.flattenNameArrayMap,
    tensor_util_5 = tensor_util.unflattenToNameArrayMap,
    tensor_util_6 = tensor_util.getTensorsInContainer;function deepMapInternal(t, e, r, n) {
  if (void 0 === r && (r = new Map()), void 0 === n && (n = new Set()), null == t) return null;if (n.has(t)) throw new Error("Circular references are not supported.");if (r.has(t)) return r.get(t);var o = e(t);if (o.recurse && null !== o.value) throw new Error("A deep map function may not return both a value and recurse=true.");if (o.recurse) {
    if (isIterable(t)) {
      var i = Array.isArray(t) ? [] : {};for (var s in n.add(t), t) {
        var a = deepMapInternal(t[s], e, r, n);i[s] = a;
      }return n.delete(t), i;
    }throw new Error("Can't recurse into non-iterable type: " + t);
  }return r.set(t, o.value), o.value;
}function deepZip(t, e) {
  return void 0 === e && (e = zipToList), deepZipInternal(t, e);
}function deepZipInternal(t, e, r) {
  void 0 === r && (r = new Set());var n = t[0];if (r.has(n)) throw new Error("Circular references are not supported.");var o = e(t);if (o.recurse && null !== o.value) throw new Error("A deep zip function may not return both a value and recurse=true.");if (o.recurse) {
    if (isIterable(n)) {
      var i = Array.isArray(n) ? [] : {};r.add(n);var s = function s(n) {
        var o = deepZipInternal(t.map(function (t) {
          return t[n];
        }), e, r);i[n] = o;
      };for (var a in n) {
        s(a);
      }return r.delete(n), i;
    }throw new Error("Can't recurse into non-iterable type: " + n);
  }return o.value;
}function zipToList(t) {
  return null === t ? null : isIterable(t[0]) ? { value: null, recurse: !0 } : { value: t, recurse: !1 };
}function deepMapAndAwaitAll(t, e) {
  return __awaiter(this, void 0, void 0, function () {
    var r, n, o, i, s, a;return __generator(this, function (u) {
      switch (u.label) {case 0:
          r = new Map(), deepMapInternal(t, e, r), n = 0, o = Array.from(r.keys()), u.label = 1;case 1:
          return n < o.length ? (i = o[n], (s = r.get(i)) instanceof Promise ? [4, s] : [3, 3]) : [3, 4];case 2:
          a = u.sent(), r.set(i, a), u.label = 3;case 3:
          return n++, [3, 1];case 4:
          return [2, deepMapInternal(t, e, r)];}
    });
  });
}function isIterable(t) {
  return null != t && (Array.isArray(t) || "object" == typeof t && !(t instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]));
}function isNumericArray(t) {
  if (null == t) return !1;if (!Array.isArray(t)) return !1;for (var e in t) {
    if ("number" != typeof t[e]) return !1;
  }return !0;
}var RingBuffer = function () {
  function t(t) {
    if (this.capacity = t, this.begin = 0, this.end = 0, t < 1) throw new RangeError("Can't create ring buffer of capacity < 1.");this.data = new Array(t), this.doubledCapacity = 2 * t;
  }return t.prototype.wrap = function (t) {
    for (; t < 0;) {
      t += this.doubledCapacity;
    }return t % this.doubledCapacity;
  }, t.prototype.get = function (t) {
    if (t < 0) throw new RangeError("Can't get item at a negative index.");return this.data[t % this.capacity];
  }, t.prototype.set = function (t, e) {
    if (t < 0) throw new RangeError("Can't set item at a negative index.");this.data[t % this.capacity] = e;
  }, t.prototype.length = function () {
    var t = this.end - this.begin;return t < 0 && (t = this.doubledCapacity + t), t;
  }, t.prototype.isFull = function () {
    return this.length() === this.capacity;
  }, t.prototype.isEmpty = function () {
    return 0 === this.length();
  }, t.prototype.push = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");this.set(this.end, t), this.end = this.wrap(this.end + 1);
  }, t.prototype.pushAll = function (t) {
    for (var e = 0, r = t; e < r.length; e++) {
      var n = r[e];this.push(n);
    }
  }, t.prototype.pop = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");this.end = this.wrap(this.end - 1);var t = this.get(this.end);return this.set(this.end, void 0), t;
  }, t.prototype.unshift = function (t) {
    if (this.isFull()) throw new RangeError("Ring buffer is full.");this.begin = this.wrap(this.begin - 1), this.set(this.begin, t);
  }, t.prototype.shift = function () {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");var t = this.get(this.begin);return this.set(this.begin, void 0), this.begin = this.wrap(this.begin + 1), t;
  }, t.prototype.shuffleExcise = function (t) {
    if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");var e = this.wrap(this.begin + t),
        r = this.get(e);return this.set(e, this.pop()), r;
  }, t;
}(),
    GrowingRingBuffer = function (t) {
  function e() {
    return t.call(this, e.INITIAL_CAPACITY) || this;
  }return __extends(e, t), e.prototype.isFull = function () {
    return !1;
  }, e.prototype.push = function (e) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.push.call(this, e);
  }, e.prototype.unshift = function (e) {
    t.prototype.isFull.call(this) && this.expand(), t.prototype.unshift.call(this, e);
  }, e.prototype.expand = function () {
    for (var t = 2 * this.capacity, e = new Array(t), r = this.length(), n = 0; n < r; n++) {
      e[n] = this.get(this.wrap(this.begin + n));
    }this.data = e, this.capacity = t, this.doubledCapacity = 2 * this.capacity, this.begin = 0, this.end = r;
  }, e.INITIAL_CAPACITY = 32, e;
}(RingBuffer);function iteratorFromItems(t) {
  return new ArrayIterator(t);
}function iteratorFromFunction(t) {
  return new FunctionCallIterator(t);
}function iteratorFromConcatenated(t, e) {
  return new ChainedIterator(t, e);
}function iteratorFromZipped(t, e) {
  return void 0 === e && (e = ZipMismatchMode.FAIL), new ZipIterator(t, e);
}var ZipMismatchMode,
    LazyIterator = function () {
  function t() {}return t.prototype.collect = function (t, e) {
    return void 0 === t && (t = 1e3), void 0 === e && (e = 100), __awaiter(this, void 0, void 0, function () {
      var r, n, o, i;return __generator(this, function (s) {
        switch (s.label) {case 0:
            return r = e > 0 ? this.prefetch(e) : this, n = [], o = 0, [4, r.next()];case 1:
            i = s.sent(), s.label = 2;case 2:
            return i.done ? [3, 4] : (n.push(i.value), ++o >= t ? [2, n] : [4, r.next()]);case 3:
            return i = s.sent(), [3, 2];case 4:
            return [2, n];}
      });
    });
  }, t.prototype.resolveFully = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (e) {
        switch (e.label) {case 0:
            return [4, this.next()];case 1:
            t = e.sent(), e.label = 2;case 2:
            return t.done ? [3, 4] : [4, this.next()];case 3:
            return t = e.sent(), [3, 2];case 4:
            return [2];}
      });
    });
  }, t.prototype.resolveWhile = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var e, r;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return [4, this.next()];case 1:
            e = n.sent(), r = t(e.value), n.label = 2;case 2:
            return e.done || !r ? [3, 4] : [4, this.next()];case 3:
            return e = n.sent(), r = t(e.value), [3, 2];case 4:
            return [2];}
      });
    });
  }, t.prototype.handleErrors = function (t) {
    return new ErrorHandlingLazyIterator(this, t);
  }, t.prototype.filter = function (t) {
    return new FilterIterator(this, t);
  }, t.prototype.map = function (t) {
    return new MapIterator(this, t);
  }, t.prototype.mapAsync = function (t) {
    return new AsyncMapIterator(this, t);
  }, t.prototype.serialMapAsync = function (t) {
    return new AsyncMapIterator(this, t).serial();
  }, t.prototype.flatmap = function (t) {
    return new FlatmapIterator(this, t);
  }, t.prototype.forEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, this.map(t).resolveFully()];
      });
    });
  }, t.prototype.serialForEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, this.serialMapAsync(t).resolveWhile(function (t) {
          return !0 === t;
        })];
      });
    });
  }, t.prototype.rowMajorBatch = function (t, e) {
    return void 0 === e && (e = !0), new RowMajorBatchIterator(this, t, e);
  }, t.prototype.columnMajorBatch = function (t, e, r) {
    return void 0 === e && (e = !0), void 0 === r && (r = zipToList), this.rowMajorBatch(t, e).map(function (t) {
      return deepZip(t, r);
    });
  }, t.prototype.concatenate = function (t, e) {
    return new ChainedIterator(iteratorFromItems([this, t]), e);
  }, t.prototype.take = function (t) {
    return t < 0 || null == t ? this : new TakeIterator(this, t);
  }, t.prototype.skip = function (t) {
    return t < 0 || null == t ? this : new SkipIterator(this, t);
  }, t.prototype.prefetch = function (t) {
    return new PrefetchIterator(this, t);
  }, t.prototype.shuffle = function (t, e) {
    return new ShuffleIterator(this, t, e);
  }, t.prototype.serial = function () {
    return new SerialIterator(this);
  }, t;
}(),
    ArrayIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;return r.items = e, r.trav = 0, r;
  }return __extends(e, t), e.prototype.summary = function () {
    return "Array of " + this.items.length + " items";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;return __generator(this, function (r) {
        return this.trav >= this.items.length ? [2, { value: null, done: !0 }] : (t = this.items[this.trav], e = t instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */] ? Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["A" /* clone */])(t) : t, this.trav++, [2, { value: e, done: !1 }]);
      });
    });
  }, e;
}(LazyIterator),
    FunctionCallIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;return r.nextFn = e, r;
  }return __extends(e, t), e.prototype.summary = function () {
    return "Function call";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        try {
          return [2, this.nextFn()];
        } catch (t) {
          throw t.message = "Error thrown while iterating through a dataset: " + t.message, t;
        }return [2];
      });
    });
  }, e;
}(LazyIterator),
    SerialIterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;return r.upstream = e, r.lastRead = Promise.resolve({ value: null, done: !1 }), r;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Serial";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.upstream.next()];
      });
    });
  }, e;
}(LazyIterator),
    SkipIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.maxCount = r, n.count = 0, n.lastRead = Promise.resolve({ value: null, done: !1 }), n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Skip";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (e) {
        switch (e.label) {case 0:
            return this.count++ < this.maxCount ? [4, this.upstream.next()] : [3, 2];case 1:
            return (t = e.sent()).done ? [2, t] : (Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* dispose */])(t.value), [3, 0]);case 2:
            return [2, this.upstream.next()];}
      });
    });
  }, e;
}(LazyIterator),
    TakeIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.maxCount = r, n.count = 0, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Take";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.count++ >= this.maxCount ? [2, { value: null, done: !0 }] : [2, this.upstream.next()];
      });
    });
  }, e;
}(LazyIterator),
    RowMajorBatchIterator = function (t) {
  function e(e, r, n) {
    void 0 === n && (n = !0);var o = t.call(this) || this;return o.upstream = e, o.batchSize = r, o.enableSmallLastBatch = n, o.lastRead = Promise.resolve({ value: null, done: !1 }), o;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> RowMajorBatch";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;return __generator(this, function (r) {
        switch (r.label) {case 0:
            t = [], r.label = 1;case 1:
            return t.length < this.batchSize ? [4, this.upstream.next()] : [3, 3];case 2:
            return (e = r.sent()).done ? this.enableSmallLastBatch && t.length > 0 ? [2, { value: t, done: !1 }] : [2, { value: null, done: !0 }] : (t.push(e.value), [3, 1]);case 3:
            return [2, { value: t, done: !1 }];}
      });
    });
  }, e;
}(LazyIterator),
    FilterIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.predicate = r, n.lastRead = Promise.resolve({ value: null, done: !1 }), n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Filter";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (e) {
        switch (e.label) {case 0:
            return [4, this.upstream.next()];case 1:
            return (t = e.sent()).done || this.predicate(t.value) ? [2, t] : (Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* dispose */])(t.value), [3, 0]);case 2:
            return [2];}
      });
    });
  }, e;
}(LazyIterator),
    MapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.transform = r, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Map";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, o, i, s;return __generator(this, function (a) {
        switch (a.label) {case 0:
            return [4, this.upstream.next()];case 1:
            if ((t = a.sent()).done) return [2, { value: null, done: !0 }];for (e = tensor_util_6(t.value), r = this.transform(t.value), n = tensor_util_6(r), o = 0, i = e; o < i.length; o++) {
              s = i[o], tensor_util_3(s, n) || s.dispose();
            }return [2, { value: r, done: !1 }];}
      });
    });
  }, e;
}(LazyIterator),
    ErrorHandlingLazyIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.handler = r, n.count = 0, n.lastRead = Promise.resolve({ value: null, done: !1 }), n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> handleErrors";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (e) {
        switch (e.label) {case 0:
            e.label = 1;case 1:
            return e.trys.push([1, 3,, 4]), [4, this.upstream.next()];case 2:
            return [2, e.sent()];case 3:
            return t = e.sent(), this.handler(t) ? [3, 4] : [2, { value: null, done: !0 }];case 4:
            return [3, 0];case 5:
            return [2];}
      });
    });
  }, e;
}(LazyIterator),
    AsyncMapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.transform = r, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> AsyncMap";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, o, i, s;return __generator(this, function (a) {
        switch (a.label) {case 0:
            return [4, this.upstream.next()];case 1:
            return (t = a.sent()).done ? [2, { value: null, done: !0 }] : (e = tensor_util_6(t.value), [4, this.transform(t.value)]);case 2:
            for (r = a.sent(), n = tensor_util_6(r), o = 0, i = e; o < i.length; o++) {
              s = i[o], tensor_util_3(s, n) || s.dispose();
            }return [2, { value: r, done: !1 }];}
      });
    });
  }, e;
}(LazyIterator),
    OneToManyIterator = function (t) {
  function e() {
    var e = t.call(this) || this;return e.outputQueue = new GrowingRingBuffer(), e.lastRead = Promise.resolve({ value: null, done: !1 }), e;
  }return __extends(e, t), e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return 0 !== this.outputQueue.length() ? [3, 2] : [4, this.pump()];case 1:
            return t.sent() ? [3, 0] : [2, { value: null, done: !0 }];case 2:
            return [2, { value: this.outputQueue.shift(), done: !1 }];}
      });
    });
  }, e;
}(LazyIterator),
    FlatmapIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.transform = r, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Flatmap";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, o, i, s;return __generator(this, function (a) {
        switch (a.label) {case 0:
            return [4, this.upstream.next()];case 1:
            if ((t = a.sent()).done) return [2, !1];for (e = tensor_util_6(t.value), r = this.transform(t.value), n = tensor_util_6(r), this.outputQueue.pushAll(r), o = 0, i = e; o < i.length; o++) {
              s = i[o], tensor_util_3(s, n) || s.dispose();
            }return [2, !0];}
      });
    });
  }, e;
}(OneToManyIterator),
    ChainedIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.baseErrorHandler = r, n.lastRead = null, n.iterator = null, n.moreIterators = e, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return "TODO: fill in upstream of chained summaries -> Chained";
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return this.lastRead = this.readFromChain(this.lastRead), [2, this.lastRead];
      });
    });
  }, e.prototype.readFromChain = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      var e, r;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return [4, t];case 1:
            return n.sent(), null != this.iterator ? [3, 3] : [4, this.moreIterators.next()];case 2:
            if ((e = n.sent()).done) return [2, { value: null, done: !0 }];this.iterator = e.value, null != this.baseErrorHandler && (this.iterator = this.iterator.handleErrors(this.baseErrorHandler)), n.label = 3;case 3:
            return [4, this.iterator.next()];case 4:
            return (r = n.sent()).done ? (this.iterator = null, [2, this.readFromChain(t)]) : [2, r];}
      });
    });
  }, e;
}(LazyIterator);!function (t) {
  t[t.FAIL = 0] = "FAIL", t[t.SHORTEST = 1] = "SHORTEST", t[t.LONGEST = 2] = "LONGEST";
}(ZipMismatchMode || (ZipMismatchMode = {}));var ZipIterator = function (t) {
  function e(e, r) {
    void 0 === r && (r = ZipMismatchMode.FAIL);var n = t.call(this) || this;return n.iterators = e, n.mismatchMode = r, n.count = 0, n.currentPromise = null, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return "{TODO: fill in upstream of zip summaries} -> Zip";
  }, e.prototype.nextState = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      function e(t) {
        return t instanceof LazyIterator ? { value: t.next().then(function (t) {
            return r++, t.done && n++, t.value;
          }), recurse: !1 } : { value: null, recurse: !0 };
      }var r, n, o;return __generator(this, function (i) {
        switch (i.label) {case 0:
            return [4, t];case 1:
            return i.sent(), r = 0, n = 0, [4, deepMapAndAwaitAll(this.iterators, e)];case 2:
            if (o = i.sent(), r === n) return [2, { value: null, done: !0 }];if (n > 0) switch (this.mismatchMode) {case ZipMismatchMode.FAIL:
                throw new Error("Zipped streams should have the same length. Mismatched at element " + this.count + ".");case ZipMismatchMode.SHORTEST:
                return [2, { value: null, done: !0 }];case ZipMismatchMode.LONGEST:}return this.count++, [2, { value: o, done: !1 }];}
      });
    });
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return this.currentPromise = this.nextState(this.currentPromise), [4, this.currentPromise];case 1:
            return [2, t.sent()];}
      });
    });
  }, e;
}(LazyIterator),
    PrefetchIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.bufferSize = r, n.buffer = new RingBuffer(r), n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Prefetch";
  }, e.prototype.refill = function () {
    for (; !this.buffer.isFull();) {
      var t = this.upstream.next();this.buffer.push(t);
    }
  }, e.prototype.next = function () {
    return this.refill(), this.buffer.shift();
  }, e;
}(LazyIterator),
    ShuffleIterator = function (t) {
  function e(e, r, n) {
    var o = t.call(this, e, r) || this;return o.upstream = e, o.windowSize = r, o.upstreamExhausted = !1, o.random = seedrandom_1(n || __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].now().toString()), o.lastRead = Promise.resolve({ value: null, done: !1 }), o;
  }return __extends(e, t), e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t = this;return __generator(this, function (e) {
        return this.lastRead = this.lastRead.then(function () {
          return t.serialNext();
        }), [2, this.lastRead];
      });
    });
  }, e.prototype.randomInt = function (t) {
    return Math.floor(this.random() * t);
  }, e.prototype.chooseIndex = function () {
    return this.randomInt(this.buffer.length());
  }, e.prototype.serialNext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;return __generator(this, function (r) {
        switch (r.label) {case 0:
            this.upstreamExhausted || this.refill(), r.label = 1;case 1:
            return this.buffer.isEmpty() ? [3, 3] : (t = this.chooseIndex(), [4, this.buffer.shuffleExcise(t)]);case 2:
            return (e = r.sent()).done ? (this.upstreamExhausted = !0, [3, 1]) : (this.refill(), [2, e]);case 3:
            return [2, { value: null, done: !0 }];}
      });
    });
  }, e;
}(PrefetchIterator),
    Dataset = function () {
  function t() {}return t.prototype.filter = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().filter(function (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
                  return t(e);
                });
              })];}
        });
      });
    });
  }, t.prototype.map = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().map(function (e) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* tidy */])(function () {
                  return t(e);
                });
              })];}
        });
      });
    });
  }, t.prototype.mapAsync = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().mapAsync(t)];}
        });
      });
    });
  }, t.prototype.batch = function (t, e) {
    var r = this;void 0 === e && (e = !0);var n = this;return datasetFromIteratorFn(function () {
      return __awaiter(r, void 0, void 0, function () {
        return __generator(this, function (r) {
          switch (r.label) {case 0:
              return [4, n.iterator()];case 1:
              return [2, r.sent().columnMajorBatch(t, e, deepBatchConcat)];}
        });
      });
    });
  }, t.prototype.concatenate = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        var e, n;return __generator(this, function (o) {
          switch (o.label) {case 0:
              return [4, r.iterator()];case 1:
              return n = (e = o.sent()).concatenate, [4, t.iterator()];case 2:
              return [2, n.apply(e, [o.sent()])];}
        });
      });
    });
  }, t.prototype.repeat = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        var e = this;return __generator(this, function (n) {
          return [2, iteratorFromConcatenated(iteratorFromFunction(function () {
            return __awaiter(e, void 0, void 0, function () {
              var t;return __generator(this, function (e) {
                switch (e.label) {case 0:
                    return t = {}, [4, r.iterator()];case 1:
                    return [2, (t.value = e.sent(), t.done = !1, t)];}
              });
            });
          }).take(t))];
        });
      });
    });
  }, t.prototype.take = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().take(t)];}
        });
      });
    });
  }, t.prototype.skip = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().skip(t)];}
        });
      });
    });
  }, t.prototype.shuffle = function (t, e, r) {
    var n = this;void 0 === r && (r = !0);var o = this,
        i = seedrandom_1(e || __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].now().toString());return datasetFromIteratorFn(function () {
      return __awaiter(n, void 0, void 0, function () {
        var e;return __generator(this, function (n) {
          switch (n.label) {case 0:
              return e = i.int32(), r && (e += i.int32()), [4, o.iterator()];case 1:
              return [2, n.sent().shuffle(t, e.toString())];}
        });
      });
    });
  }, t.prototype.prefetch = function (t) {
    var e = this,
        r = this;return datasetFromIteratorFn(function () {
      return __awaiter(e, void 0, void 0, function () {
        return __generator(this, function (e) {
          switch (e.label) {case 0:
              return [4, r.iterator()];case 1:
              return [2, e.sent().prefetch(t)];}
        });
      });
    });
  }, t.prototype.toArray = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return [4, this.iterator()];case 1:
            return [2, t.sent().collect()];}
      });
    });
  }, t.prototype.forEach = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {case 0:
            return [4, this.iterator()];case 1:
            return [2, e.sent().forEach(t)];}
      });
    });
  }, t;
}();function datasetFromIteratorFn(t) {
  return new (function (e) {
    function r() {
      return null !== e && e.apply(this, arguments) || this;
    }return __extends(r, e), r.prototype.iterator = function () {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (e) {
          return [2, t()];
        });
      });
    }, r;
  }(Dataset))();
}function array(t) {
  var e = this;return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      return __generator(this, function (e) {
        return [2, iteratorFromItems(t)];
      });
    });
  });
}function zip(t) {
  var e = this;if (!isIterable(t)) throw new Error("The argument to zip() must be an object or array.");return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {case 0:
            return [4, deepMapAndAwaitAll(t, function (t) {
              if (t instanceof Dataset) return { value: t.iterator(), recurse: !1 };if (isIterable(t)) return { value: null, recurse: !0 };throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
            })];case 1:
            return [2, iteratorFromZipped(e.sent(), ZipMismatchMode.SHORTEST)];}
      });
    });
  });
}function deepBatchConcat(t) {
  if (null === t) return null;var e = t[0];return "string" == typeof e ? { value: t, recurse: !1 } : isIterable(e) ? isNumericArray(e) ? { value: batchConcat(t), recurse: !1 } : { value: null, recurse: !0 } : { value: batchConcat(t), recurse: !1 };
}function batchConcat(t) {
  if (0 === t.length) throw new Error("Can't make a batch of zero elements.");if (t[0] instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]) return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_76" /* stack */])(t);if (Array.isArray(t[0])) return batchConcatArrays(t);var e = t;return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */].make([e.length], { values: new Float32Array(e) });
}function batchConcatArrays(t) {
  for (var e = t[0].length, r = [t.length, t[0].length], n = new Float32Array(t.length * e), o = 0, i = 0, s = t; i < s.length; i++) {
    var a = s[i];if (a.length !== e) throw new Error("Elements must have the same shape to be batched");n.set(a, o), o += e;
  }return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */].make(r, { values: n });
}var TextLineDataset = function (t) {
  function e(e) {
    var r = t.call(this) || this;return r.input = e, r;
  }return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e;return __generator(this, function (r) {
        switch (r.label) {case 0:
            return [4, this.input.iterator()];case 1:
            return t = r.sent(), e = t.decodeUTF8(), [2, e.split("\n")];}
      });
    });
  }, e;
}(Dataset),
    CODE_QUOTE = '"',
    STATE_OUT = Symbol("out"),
    STATE_FIELD = Symbol("field"),
    STATE_QUOTE = Symbol("quote"),
    STATE_QUOTE_AFTER_QUOTE = Symbol("quoteafterquote"),
    STATE_WITHIN_QUOTE_IN_QUOTE = Symbol("quoteinquote"),
    CSVDataset = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.input = e, n.hasHeader = !0, n.fullColumnNames = null, n.columnNamesValidated = !1, n.columnConfigs = null, n.configuredColumnsOnly = !1, n.delimiter = ",", n.base = new TextLineDataset(e), r || (r = {}), n.hasHeader = !1 !== r.hasHeader, n.fullColumnNames = r.columnNames, n.columnConfigs = r.columnConfigs, n.configuredColumnsOnly = r.configuredColumnsOnly, n.delimiter = r.delimiter ? r.delimiter : ",", n;
  }return __extends(e, t), e.prototype.columnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];case 1:
            t.sent(), t.label = 2;case 2:
            return [2, this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames];}
      });
    });
  }, e.prototype.setColumnNames = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, o, i;return __generator(this, function (s) {
        switch (s.label) {case 0:
            return [4, this.maybeReadHeaderLine()];case 1:
            if (t = s.sent(), !this.fullColumnNames && !t) throw new Error("Column names must be provided if there is no header line.");if (this.fullColumnNames && t && __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(t.length === this.fullColumnNames.length, "The length of provided columnNames (" + this.fullColumnNames.length.toString() + ") does not match the length of the header line read from file (" + t.length.toString() + ")."), this.fullColumnNames || (this.fullColumnNames = t), e = this.fullColumnNames.reduce(function (t, e) {
              return t[e] = t[e] + 1 || 1, t;
            }, {}), r = Object.keys(e).filter(function (t) {
              return e[t] > 1;
            }), __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(0 === r.length, "Duplicate column names found: " + r.toString()), this.columnConfigs) for (n = 0, o = Object.keys(this.columnConfigs); n < o.length; n++) {
              if (i = o[n], -1 === this.fullColumnNames.indexOf(i)) throw new Error('The key "' + i + '" provided in columnConfigs does not match any of the column names (' + this.fullColumnNames.toString() + ").");
            }return this.columnNamesValidated = !0, [2];}
      });
    });
  }, e.prototype.maybeReadHeaderLine = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t;return __generator(this, function (e) {
        switch (e.label) {case 0:
            return this.hasHeader ? [4, this.base.iterator()] : [3, 3];case 1:
            return [4, e.sent().next()];case 2:
            if ((t = e.sent()).done) throw new Error("No data was found for CSV parsing.");return [2, t.value.split(this.delimiter)];case 3:
            return [2, null];}
      });
    });
  }, e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e = this;return __generator(this, function (r) {
        switch (r.label) {case 0:
            return this.columnNamesValidated ? [3, 2] : [4, this.setColumnNames()];case 1:
            r.sent(), r.label = 2;case 2:
            return [4, this.base.iterator()];case 3:
            return t = r.sent(), this.hasHeader && (t = t.skip(1)), [2, t.map(function (t) {
              return e.makeDataElement(t);
            })];}
      });
    });
  }, e.prototype.makeDataElement = function (t) {
    for (var e = this.parseRow(t), r = {}, n = {}, o = 0; o < this.fullColumnNames.length; o++) {
      var i = this.fullColumnNames[o],
          s = this.columnConfigs ? this.columnConfigs[i] : null;if (!this.configuredColumnsOnly || s) {
        var a = e[o],
            u = null;if ("" === a) {
          if (s && void 0 !== s.default) u = s.default;else {
            if (s && (s.required || s.isLabel)) throw new Error("Required column " + i + " is empty in this line: " + t);u = void 0;
          }
        } else {
          var h = Number(a);if (isNaN(h)) u = s && "bool" === s.dtype ? this.getBoolean(a) : a;else if (s && s.dtype) switch (s.dtype) {case "float32":
              u = h;break;case "int32":
              u = Math.floor(h);break;case "bool":
              u = this.getBoolean(a);break;default:
              u = h;} else u = h;
        }s && s.isLabel ? n[i] = u : r[i] = u;
      }
    }return 0 === Object.keys(n).length ? r : [r, n];
  }, e.prototype.getBoolean = function (t) {
    return "1" === t || "true" === t.toLowerCase() ? 1 : 0;
  }, e.prototype.parseRow = function (t) {
    for (var e = [], r = 0, n = t.length, o = STATE_FIELD, i = 0; i < n; i++) {
      switch (o) {case STATE_OUT:
          switch (t.charAt(i)) {case CODE_QUOTE:
              r = i + 1, o = STATE_QUOTE;break;case this.delimiter:
              e.push(""), o = STATE_OUT, r = i + 1;break;default:
              o = STATE_FIELD, r = i;}break;case STATE_FIELD:
          switch (t.charAt(i)) {case this.delimiter:
              e.push(t.substring(r, i)), o = STATE_OUT, r = i + 1;}break;case STATE_QUOTE:
          switch (t.charAt(i)) {case CODE_QUOTE:
              o = STATE_QUOTE_AFTER_QUOTE;}break;case STATE_QUOTE_AFTER_QUOTE:
          switch (t.charAt(i)) {case this.delimiter:
              e.push(t.substring(r, i - 1)), o = STATE_OUT, r = i + 1;break;case CODE_QUOTE:
              o = STATE_QUOTE;break;default:
              o = STATE_WITHIN_QUOTE_IN_QUOTE;}break;case STATE_WITHIN_QUOTE_IN_QUOTE:
          switch (t.charAt(i)) {case CODE_QUOTE:
              o = STATE_QUOTE;}}
    }return o === STATE_QUOTE_AFTER_QUOTE ? e.push(t.substring(r, n - 1)) : e.push(t.substring(r)), e;
  }, e;
}(Dataset),
    DataSource = function () {
  return function () {};
}(),
    StringIterator = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }return __extends(e, t), e.prototype.split = function (t) {
    return new SplitIterator(this, t);
  }, e;
}(LazyIterator),
    SplitIterator = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.impl = new SplitIteratorImpl(e, r), n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.impl.summary();
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, e;
}(StringIterator),
    SplitIteratorImpl = function (t) {
  function e(e, r) {
    var n = t.call(this) || this;return n.upstream = e, n.separator = r, n.carryover = "", n;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Split('" + this.separator + "')";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r, n, o;return __generator(this, function (i) {
        switch (i.label) {case 0:
            return [4, this.upstream.next()];case 1:
            if ((t = i.sent()).done) return "" === this.carryover ? [2, !1] : (this.outputQueue.push(this.carryover), this.carryover = "", [2, !0]);for ((e = t.value.split(this.separator))[0] = this.carryover + e[0], r = 0, n = e.slice(0, -1); r < n.length; r++) {
              o = n[r], this.outputQueue.push(o);
            }return this.carryover = e[e.length - 1], [2, !0];}
      });
    });
  }, e;
}(OneToManyIterator),
    ByteChunkIterator = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }return __extends(e, t), e.prototype.decodeUTF8 = function () {
    return new Utf8Iterator(this);
  }, e;
}(LazyIterator),
    Utf8Iterator = function (t) {
  function e(e) {
    var r = t.call(this) || this;return r.upstream = e, r.impl = new Utf8IteratorImpl(e), r;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.impl.summary();
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, this.impl.next()];
      });
    });
  }, e;
}(StringIterator),
    Utf8IteratorImpl = function (t) {
  function e(e) {
    var r = t.call(this) || this;if (r.upstream = e, __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["a" /* ENV */].get("IS_BROWSER")) r.decoder = new TextDecoder("utf-8");else {
      var n = __webpack_require__("X4X3").StringDecoder;r.decoder = new n("utf8");
    }return r;
  }return __extends(e, t), e.prototype.summary = function () {
    return this.upstream.summary() + " -> Utf8";
  }, e.prototype.pump = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, e, r;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return [4, this.upstream.next()];case 1:
            return (t = n.sent()).done ? [2, !1] : (e = t.value, r = __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["a" /* ENV */].get("IS_BROWSER") ? this.decoder.decode(e, { stream: !0 }) : this.decoder.write(Buffer.from(e.buffer)), this.outputQueue.push(r), [2, !0]);}
      });
    });
  }, e;
}(OneToManyIterator),
    FileChunkIterator = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});var n = t.call(this) || this;return n.file = e, n.options = r, __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* util */].assert(e instanceof Uint8Array || !!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["a" /* ENV */].get("IS_BROWSER") && (e instanceof File || e instanceof Blob), "FileChunkIterator only supports File, Blob and Uint8Array right now."), n.offset = r.offset || 0, n.chunkSize = r.chunkSize || 1048576, n;
  }return __extends(e, t), e.prototype.summary = function () {
    return "FileChunks " + this.file;
  }, e.prototype.next = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t,
          e,
          r = this;return __generator(this, function (n) {
        switch (n.label) {case 0:
            return this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size) ? [2, { value: null, done: !0 }] : (t = new Promise(function (t, e) {
              var n = r.offset + r.chunkSize;if (r.file instanceof Uint8Array) t(new Uint8Array(r.file.slice(r.offset, n)));else {
                var o = new FileReader();o.onload = function (r) {
                  var n = o.result;if (n instanceof ArrayBuffer && (n = new Uint8Array(n)), !(n instanceof Uint8Array)) return e(new TypeError("FileReader returned unknown type."));t(n);
                }, o.onabort = function (t) {
                  return e(new Error("Aborted"));
                }, o.onerror = function (t) {
                  return e(new Error(t.type));
                };var i = r.file.slice(r.offset, n);o.readAsArrayBuffer(i);
              }r.offset = n;
            }), e = {}, [4, t]);case 1:
            return [2, (e.value = n.sent(), e.done = !1, e)];}
      });
    });
  }, e;
}(ByteChunkIterator);function urlChunkIterator(t, e) {
  return void 0 === e && (e = {}), __awaiter(this, void 0, void 0, function () {
    var r, n, o, i;return __generator(this, function (s) {
      switch (s.label) {case 0:
          return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["a" /* ENV */].get("IS_BROWSER") ? [4, fetch(t)] : [3, 5];case 1:
          return (r = s.sent()).ok ? [4, r.blob()] : [3, 3];case 2:
          return n = s.sent(), [2, new FileChunkIterator(n, e)];case 3:
          throw new Error(r.statusText);case 4:
          return [3, 9];case 5:
          if (o = __webpack_require__("pEK1"), "string" != typeof t) throw new Error("URL must be a string. Request objects are not supported in the node.js environment yet.");return [4, o(t)];case 6:
          return (r = s.sent()).ok ? [4, r.buffer()] : [3, 8];case 7:
          return i = s.sent(), [2, new FileChunkIterator(i, e)];case 8:
          throw new Error(r.statusText);case 9:
          return [2];}
    });
  });
}var URLDataSource = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});var n = t.call(this) || this;return n.url = e, n.fileOptions = r, n;
  }return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, urlChunkIterator(this.url, this.fileOptions)];
      });
    });
  }, e;
}(DataSource);function csv(t, e) {
  return void 0 === e && (e = {}), new CSVDataset(new URLDataSource(t), e);
}function generator(t) {
  var e = this,
      r = iteratorFromFunction(t);return datasetFromIteratorFn(function () {
    return __awaiter(e, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, r];
      });
    });
  });
}var FileDataSource = function (t) {
  function e(e, r) {
    void 0 === r && (r = {});var n = t.call(this) || this;return n.input = e, n.options = r, n;
  }return __extends(e, t), e.prototype.iterator = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        return [2, new FileChunkIterator(this.input, this.options)];
      });
    });
  }, e;
}(DataSource),
    version = "0.1.7";
//# sourceMappingURL=tf-data.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "N1es":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__("LC74");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];

var W = new Array(80);

function Sha() {
  this.init();
  this._w = W;

  Hash.call(this, 64, 56);
}

inherits(Sha, Hash);

Sha.prototype.init = function () {
  this._a = 0x67452301;
  this._b = 0xefcdab89;
  this._c = 0x98badcfe;
  this._d = 0x10325476;
  this._e = 0xc3d2e1f0;

  return this;
};

function rotl5(num) {
  return num << 5 | num >>> 27;
}

function rotl30(num) {
  return num << 30 | num >>> 2;
}

function ft(s, b, c, d) {
  if (s === 0) return b & c | ~b & d;
  if (s === 2) return b & c | b & d | c & d;
  return b ^ c ^ d;
}

Sha.prototype._update = function (M) {
  var W = this._w;

  var a = this._a | 0;
  var b = this._b | 0;
  var c = this._c | 0;
  var d = this._d | 0;
  var e = this._e | 0;

  for (var i = 0; i < 16; ++i) {
    W[i] = M.readInt32BE(i * 4);
  }for (; i < 80; ++i) {
    W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
  }for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20);
    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;

    e = d;
    d = c;
    c = rotl30(b);
    b = a;
    a = t;
  }

  this._a = a + this._a | 0;
  this._b = b + this._b | 0;
  this._c = c + this._c | 0;
  this._d = d + this._d | 0;
  this._e = e + this._e | 0;
};

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20);

  H.writeInt32BE(this._a | 0, 0);
  H.writeInt32BE(this._b | 0, 4);
  H.writeInt32BE(this._c | 0, 8);
  H.writeInt32BE(this._d | 0, 12);
  H.writeInt32BE(this._e | 0, 16);

  return H;
};

module.exports = Sha;

/***/ }),

/***/ "NCTB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__("bMQ9");
exports.sha224 = __webpack_require__("fWB8");
exports.sha256 = __webpack_require__("Q48P");
exports.sha384 = __webpack_require__("EH7o");
exports.sha512 = __webpack_require__("8/0b");

/***/ }),

/***/ "NMED":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("geuY");

var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature) return options;

  if (this._importDER(options, enc)) return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined) this.recoveryParam = null;else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len + p.place !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && r[1] & 0x80) {
    r = r.slice(1);
  }
  if (s[0] === 0 && s[1] & 0x80) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push(len >>> (octets << 3) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r);
  // Pad values
  if (s[0] & 0x80) s = [0].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [0x02];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [0x30];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

/***/ }),

/***/ "O+gO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ejIc");

/***/ }),

/***/ "PBsE":
/***/ (function(module, exports, __webpack_require__) {

var generatePrime = __webpack_require__("3fzc");
var primes = __webpack_require__("4Vh3");

var DH = __webpack_require__("Ztz7");

function getDiffieHellman(mod) {
  var prime = new Buffer(primes[mod].prime, 'hex');
  var gen = new Buffer(primes[mod].gen, 'hex');

  return new DH(prime, gen);
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
};

function createDiffieHellman(prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator);
  }

  enc = enc || 'binary';
  genc = genc || 'binary';
  generator = generator || new Buffer([2]);

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc);
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true);
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc);
  }

  return new DH(prime, generator, true);
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman;
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman;

/***/ }),

/***/ "PmhB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q48P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var shaCommon = __webpack_require__("3nYK");
var assert = __webpack_require__("08Lv");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

function SHA256() {
  if (!(this instanceof SHA256)) return new SHA256();

  BlockHash.call(this);
  this.h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++) {
    W[i] = msg[start + i];
  }for (; i < W.length; i++) {
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
  }var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
};

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "Rt1F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("sOR5");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("vzCy").EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("UcPO");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__("jOgh");
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(0);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("+HRN");
var destroyImpl = __webpack_require__("x0Ha");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("DsFX");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("DsFX");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "RzOE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub)) this._pub = params.pub;else this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair) return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair) return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

/***/ }),

/***/ "SAez":
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__("ps4E");
encoders.pem = __webpack_require__("VqvS");

/***/ }),

/***/ "SDM6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("DsFX");

/***/ }),

/***/ "SsjP":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("H2Pp");
var Buffer = __webpack_require__("X3l8").Buffer;
var incr32 = __webpack_require__("4sPJ");

function getBlock(self) {
  var out = self._cipher.encryptBlockRaw(self._prev);
  incr32(self._prev);
  return out;
}

var blockSize = 16;
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize);
  var start = self._cache.length;
  self._cache = Buffer.concat([self._cache, Buffer.allocUnsafe(chunkNum * blockSize)]);
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self);
    var offset = start + i * blockSize;
    self._cache.writeUInt32BE(out[0], offset + 0);
    self._cache.writeUInt32BE(out[1], offset + 4);
    self._cache.writeUInt32BE(out[2], offset + 8);
    self._cache.writeUInt32BE(out[3], offset + 12);
  }
  var pad = self._cache.slice(0, chunk.length);
  self._cache = self._cache.slice(chunk.length);
  return xor(chunk, pad);
};

/***/ }),

/***/ "TkWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__("geuY");
var minAssert = __webpack_require__("08Lv");
var minUtils = __webpack_require__("tpuU");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << w + 1;
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;else z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = k.cmpn(0) !== 0 && k.andln(ws - 1) === 0 ? w + 1 : 1;
    for (var i = 1; i < shift; i++) {
      naf.push(0);
    }k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [[], []];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = k1.andln(3) + d1 & 3;
    var m24 = k2.andln(3) + d2 & 3;
    if (m14 === 3) m14 = -1;
    if (m24 === 3) m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = k1.andln(7) + d1 & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;else u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = k2.andln(7) + d2 & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;else u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1) d1 = 1 - d1;
    if (2 * d2 === u2 + 1) d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') : bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;

/***/ }),

/***/ "TnCn":
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function (key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key) key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__("C1C2");

/***/ }),

/***/ "U6yG":
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block);
};

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block);
};

/***/ }),

/***/ "UBa7":
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
};
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
};
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
};
exports['des-ede3'] = {
  key: 24,
  iv: 0
};
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
};
exports['des-ede'] = {
  key: 16,
  iv: 0
};

/***/ }),

/***/ "UPHp":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;
var ZEROES = Buffer.alloc(16, 0);

function toArray(buf) {
  return [buf.readUInt32BE(0), buf.readUInt32BE(4), buf.readUInt32BE(8), buf.readUInt32BE(12)];
}

function fromArray(out) {
  var buf = Buffer.allocUnsafe(16);
  buf.writeUInt32BE(out[0] >>> 0, 0);
  buf.writeUInt32BE(out[1] >>> 0, 4);
  buf.writeUInt32BE(out[2] >>> 0, 8);
  buf.writeUInt32BE(out[3] >>> 0, 12);
  return buf;
}

function GHASH(key) {
  this.h = key;
  this.state = Buffer.alloc(16, 0);
  this.cache = Buffer.allocUnsafe(0);
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1;
  while (++i < block.length) {
    this.state[i] ^= block[i];
  }
  this._multiply();
};

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h);
  var Zi = [0, 0, 0, 0];
  var j, xi, lsbVi;
  var i = -1;
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0];
      Zi[1] ^= Vi[1];
      Zi[2] ^= Vi[2];
      Zi[3] ^= Vi[3];
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0;

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
    }
    Vi[0] = Vi[0] >>> 1;

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ 0xe1 << 24;
    }
  }
  this.state = fromArray(Zi);
};

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf]);
  var chunk;
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16);
    this.cache = this.cache.slice(16);
    this.ghash(chunk);
  }
};

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16));
  }

  this.ghash(fromArray([0, abl, 0, bl]));
  return this.state;
};

module.exports = GHASH;

/***/ }),

/***/ "UcPO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("vzCy").EventEmitter;

/***/ }),

/***/ "VI/i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__("rOku");
exports.createHash = exports.Hash = __webpack_require__("BVsN");
exports.createHmac = exports.Hmac = __webpack_require__("ARY+");

var algos = __webpack_require__("O+gO");
var algoKeys = Object.keys(algos);
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys);
exports.getHashes = function () {
  return hashes;
};

var p = __webpack_require__("/vd3");
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;

var aes = __webpack_require__("VKDQ");

exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;

var dh = __webpack_require__("PBsE");

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;

var sign = __webpack_require__("KeN/");

exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;

exports.createECDH = __webpack_require__("gw8B");

var publicEncrypt = __webpack_require__("9P96");

exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__("4R/o");

exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;

exports.createCredentials = function () {
  throw new Error(['sorry, createCredentials is not implemented yet', 'we accept pull requests', 'https://github.com/crypto-browserify/crypto-browserify'].join('\n'));
};

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
};

/***/ }),

/***/ "VKDQ":
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__("IRek");
var aes = __webpack_require__("tXf9");
var aesModes = __webpack_require__("BCiZ");
var desModes = __webpack_require__("UBa7");
var ebtk = __webpack_require__("Cgw8");

function createCipher(suite, password) {
  suite = suite.toLowerCase();

  var keyLen, ivLen;
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key;
    ivLen = aesModes[suite].iv;
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8;
    ivLen = desModes[suite].iv;
  } else {
    throw new TypeError('invalid suite type');
  }

  var keys = ebtk(password, false, keyLen, ivLen);
  return createCipheriv(suite, keys.key, keys.iv);
}

function createDecipher(suite, password) {
  suite = suite.toLowerCase();

  var keyLen, ivLen;
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key;
    ivLen = aesModes[suite].iv;
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8;
    ivLen = desModes[suite].iv;
  } else {
    throw new TypeError('invalid suite type');
  }

  var keys = ebtk(password, false, keyLen, ivLen);
  return createDecipheriv(suite, keys.key, keys.iv);
}

function createCipheriv(suite, key, iv) {
  suite = suite.toLowerCase();
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv);
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite });

  throw new TypeError('invalid suite type');
}

function createDecipheriv(suite, key, iv) {
  suite = suite.toLowerCase();
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv);
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true });

  throw new TypeError('invalid suite type');
}

function getCiphers() {
  return Object.keys(desModes).concat(aes.getCiphers());
}

exports.createCipher = exports.Cipher = createCipher;
exports.createCipheriv = exports.Cipheriv = createCipheriv;
exports.createDecipher = exports.Decipher = createDecipher;
exports.createDecipheriv = exports.Decipheriv = createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

/***/ }),

/***/ "VqvS":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");

var DEREncoder = __webpack_require__("ps4E");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = ['-----BEGIN ' + options.label + '-----'];
  for (var i = 0; i < p.length; i += 64) {
    out.push(p.slice(i, i + 64));
  }out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

/***/ }),

/***/ "X3l8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("63KW");
var Buffer = buffer.Buffer;

// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
  for (var key in src) {
    dst[key] = src[key];
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer;
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports);
  exports.Buffer = SafeBuffer;
}

function SafeBuffer(arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length);
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number');
  }
  return Buffer(arg, encodingOrOffset, length);
};

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  var buf = Buffer(size);
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding);
    } else {
      buf.fill(fill);
    }
  } else {
    buf.fill(0);
  }
  return buf;
};

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return Buffer(size);
};

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return buffer.SlowBuffer(size);
};

/***/ }),

/***/ "X4X3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\uFFFD';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\uFFFD';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\uFFFD';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\uFFFD';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "YQyn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("X3l8").Buffer;

var Base = __webpack_require__("z+8S");

var ZEROS = Buffer.alloc(128);
var blocksize = 64;

function Hmac(alg, key) {
  Base.call(this, 'digest');
  if (typeof key === 'string') {
    key = Buffer.from(key);
  }

  this._alg = alg;
  this._key = key;

  if (key.length > blocksize) {
    key = alg(key);
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize);
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
  var opad = this._opad = Buffer.allocUnsafe(blocksize);

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36;
    opad[i] = key[i] ^ 0x5C;
  }

  this._hash = [ipad];
}

inherits(Hmac, Base);

Hmac.prototype._update = function (data) {
  this._hash.push(data);
};

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash));
  return this._alg(Buffer.concat([this._opad, h]));
};
module.exports = Hmac;

/***/ }),

/***/ "YSDb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var assert = __webpack_require__("08Lv");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending) this.pending = msg;else this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0) this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32) {
      this._update(msg, i, i + this._delta32);
    }
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - (len + this.padLength) % bytes;
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++) {
    res[i] = 0;
  } // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++) {
      res[i++] = 0;
    }res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = len >>> 24 & 0xff;
    res[i++] = len >>> 16 & 0xff;
    res[i++] = len >>> 8 & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = len >>> 8 & 0xff;
    res[i++] = len >>> 16 & 0xff;
    res[i++] = len >>> 24 & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++) {
      res[i++] = 0;
    }
  }

  return res;
};

/***/ }),

/***/ "YePo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var des = __webpack_require__("BO8W");
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [DES.create({ type: 'encrypt', key: k1 }), DES.create({ type: 'decrypt', key: k2 }), DES.create({ type: 'encrypt', key: k3 })];
  } else {
    this.ciphers = [DES.create({ type: 'decrypt', key: k3 }), DES.create({ type: 'encrypt', key: k2 }), DES.create({ type: 'decrypt', key: k1 })];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

/***/ }),

/***/ "Z7yx":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;

function encryptByte(self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev);
  var out = pad[0] ^ byteParam;

  self._prev = Buffer.concat([self._prev.slice(1), Buffer.from([decrypt ? byteParam : out])]);

  return out;
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length;
  var out = Buffer.allocUnsafe(len);
  var i = -1;

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt);
  }

  return out;
};

/***/ }),

/***/ "Zq1s":
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__("EXeW");
var RIPEMD160 = __webpack_require__("LYGd");
var sha = __webpack_require__("JaR3");

var checkParameters = __webpack_require__("2JY6");
var defaultEncoding = __webpack_require__("35aj");
var Buffer = __webpack_require__("X3l8").Buffer;
var ZEROS = Buffer.alloc(128);
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
};

function Hmac(alg, key, saltLen) {
  var hash = getDigest(alg);
  var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;

  if (key.length > blocksize) {
    key = hash(key);
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize);
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36;
    opad[i] = key[i] ^ 0x5C;
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
  ipad.copy(ipad1, 0, 0, blocksize);
  this.ipad1 = ipad1;
  this.ipad2 = ipad;
  this.opad = opad;
  this.alg = alg;
  this.blocksize = blocksize;
  this.hash = hash;
  this.size = sizes[alg];
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize);
  var h = this.hash(ipad);
  h.copy(this.opad, this.blocksize);
  return this.hash(this.opad);
};

function getDigest(alg) {
  function shaFunc(data) {
    return sha(alg).update(data).digest();
  }
  function rmd160Func(data) {
    return new RIPEMD160().update(data).digest();
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
  if (alg === 'md5') return md5;
  return shaFunc;
}

function pbkdf2(password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen);

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding);
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding);

  digest = digest || 'sha1';

  var hmac = new Hmac(digest, password, salt.length);

  var DK = Buffer.allocUnsafe(keylen);
  var block1 = Buffer.allocUnsafe(salt.length + 4);
  salt.copy(block1, 0, 0, salt.length);

  var destPos = 0;
  var hLen = sizes[digest];
  var l = Math.ceil(keylen / hLen);

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length);

    var T = hmac.run(block1, hmac.ipad1);
    var U = T;

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2);
      for (var k = 0; k < hLen; k++) {
        T[k] ^= U[k];
      }
    }

    T.copy(DK, destPos);
    destPos += hLen;
  }

  return DK;
}

module.exports = pbkdf2;

/***/ }),

/***/ "Ztz7":
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__("geuY");
var MillerRabin = __webpack_require__("aK3A");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__("3fzc");
var randomBytes = __webpack_require__("rOku");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() || !primes.simpleSieve || !primes.fermatTest(prime) || !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function get() {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/***/ }),

/***/ "aK3A":
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__("geuY");
var brorand = __webpack_require__("txgm");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do {
    var a = new bn(this.rand.generate(min_bytes));
  } while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k) k = Math.max(1, len / 48 | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb) cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0) return false;
      if (x.cmp(rn1) === 0) break;
    }

    if (i === s) return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k) k = Math.max(1, len / 48 | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0) return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0) break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

/***/ }),

/***/ "aY2F":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");
var SHA512 = __webpack_require__("C015");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var W = new Array(160);

function Sha384() {
  this.init();
  this._w = W;

  Hash.call(this, 128, 112);
}

inherits(Sha384, SHA512);

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d;
  this._bh = 0x629a292a;
  this._ch = 0x9159015a;
  this._dh = 0x152fecd8;
  this._eh = 0x67332667;
  this._fh = 0x8eb44a87;
  this._gh = 0xdb0c2e0d;
  this._hh = 0x47b5481d;

  this._al = 0xc1059ed8;
  this._bl = 0x367cd507;
  this._cl = 0x3070dd17;
  this._dl = 0xf70e5939;
  this._el = 0xffc00b31;
  this._fl = 0x68581511;
  this._gl = 0x64f98fa7;
  this._hl = 0xbefa4fa4;

  return this;
};

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48);

  function writeInt64BE(h, l, offset) {
    H.writeInt32BE(h, offset);
    H.writeInt32BE(l, offset + 4);
  }

  writeInt64BE(this._ah, this._al, 0);
  writeInt64BE(this._bh, this._bl, 8);
  writeInt64BE(this._ch, this._cl, 16);
  writeInt64BE(this._dh, this._dl, 24);
  writeInt64BE(this._eh, this._el, 32);
  writeInt64BE(this._fh, this._fl, 40);

  return H;
};

module.exports = Sha384;

/***/ }),

/***/ "bMQ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var shaCommon = __webpack_require__("3nYK");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xCA62C1D6];

function SHA1() {
  if (!(this instanceof SHA1)) return new SHA1();

  BlockHash.call(this);
  this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++) {
    W[i] = msg[start + i];
  }for (; i < W.length; i++) {
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
  }var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex') return utils.toHex32(this.h, 'big');else return utils.split32(this.h, 'big');
};

/***/ }),

/***/ "bSQl":
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__("BCiZ");
var AuthCipher = __webpack_require__("/y0r");
var Buffer = __webpack_require__("X3l8").Buffer;
var StreamCipher = __webpack_require__("6hW9");
var Transform = __webpack_require__("z+8S");
var aes = __webpack_require__("BEbT");
var ebtk = __webpack_require__("Cgw8");
var inherits = __webpack_require__("LC74");

function Cipher(mode, key, iv) {
  Transform.call(this);

  this._cache = new Splitter();
  this._cipher = new aes.AES(key);
  this._prev = Buffer.from(iv);
  this._mode = mode;
  this._autopadding = true;
}

inherits(Cipher, Transform);

Cipher.prototype._update = function (data) {
  this._cache.add(data);
  var chunk;
  var thing;
  var out = [];

  while (chunk = this._cache.get()) {
    thing = this._mode.encrypt(this, chunk);
    out.push(thing);
  }

  return Buffer.concat(out);
};

var PADDING = Buffer.alloc(16, 0x10);

Cipher.prototype._final = function () {
  var chunk = this._cache.flush();
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk);
    this._cipher.scrub();
    return chunk;
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub();
    throw new Error('data not multiple of block length');
  }
};

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo;
  return this;
};

function Splitter() {
  this.cache = Buffer.allocUnsafe(0);
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data]);
};

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16);
    this.cache = this.cache.slice(16);
    return out;
  }
  return null;
};

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length;
  var padBuff = Buffer.allocUnsafe(len);

  var i = -1;
  while (++i < len) {
    padBuff.writeUInt8(len, i);
  }

  return Buffer.concat([this.cache, padBuff]);
};

function createCipheriv(suite, password, iv) {
  var config = MODES[suite.toLowerCase()];
  if (!config) throw new TypeError('invalid suite type');

  if (typeof password === 'string') password = Buffer.from(password);
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);

  if (typeof iv === 'string') iv = Buffer.from(iv);
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv);
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv);
  }

  return new Cipher(config.module, password, iv);
}

function createCipher(suite, password) {
  var config = MODES[suite.toLowerCase()];
  if (!config) throw new TypeError('invalid suite type');

  var keys = ebtk(password, false, config.key, config.iv);
  return createCipheriv(suite, keys.key, keys.iv);
}

exports.createCipheriv = createCipheriv;
exports.createCipher = createCipher;

/***/ }),

/***/ "cSWu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("Rt1F");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("7dSG");
exports.Duplex = __webpack_require__("DsFX");
exports.Transform = __webpack_require__("D1Va");
exports.PassThrough = __webpack_require__("f48b");

/***/ }),

/***/ "eCz2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");
var HashBase = __webpack_require__("yDvu");
var Buffer = __webpack_require__("X3l8").Buffer;

var ARRAY16 = new Array(16);

function MD5() {
  HashBase.call(this, 64);

  // state
  this._a = 0x67452301;
  this._b = 0xefcdab89;
  this._c = 0x98badcfe;
  this._d = 0x10325476;
}

inherits(MD5, HashBase);

MD5.prototype._update = function () {
  var M = ARRAY16;
  for (var i = 0; i < 16; ++i) {
    M[i] = this._block.readInt32LE(i * 4);
  }var a = this._a;
  var b = this._b;
  var c = this._c;
  var d = this._d;

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
  c = fnF(c, d, a, b, M[2], 0x242070db, 17);
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22);

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
  d = fnG(d, a, b, c, M[10], 0x02441453, 9);
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);

  this._a = this._a + a | 0;
  this._b = this._b + b | 0;
  this._c = this._c + c | 0;
  this._d = this._d + d | 0;
};

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80;
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64);
    this._update();
    this._blockOffset = 0;
  }

  this._block.fill(0, this._blockOffset, 56);
  this._block.writeUInt32LE(this._length[0], 56);
  this._block.writeUInt32LE(this._length[1], 60);
  this._update();

  // produce result
  var buffer = Buffer.allocUnsafe(16);
  buffer.writeInt32LE(this._a, 0);
  buffer.writeInt32LE(this._b, 4);
  buffer.writeInt32LE(this._c, 8);
  buffer.writeInt32LE(this._d, 12);
  return buffer;
};

function rotl(x, n) {
  return x << n | x >>> 32 - n;
}

function fnF(a, b, c, d, m, k, s) {
  return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}

function fnG(a, b, c, d, m, k, s) {
  return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}

function fnH(a, b, c, d, m, k, s) {
  return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}

function fnI(a, b, c, d, m, k, s) {
  return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}

module.exports = MD5;

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "f48b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("D1Va");

/*<replacement>*/
var util = __webpack_require__("jOgh");
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "fWB8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var SHA256 = __webpack_require__("Q48P");

function SHA224() {
  if (!(this instanceof SHA224)) return new SHA224();

  SHA256.call(this);
  this.h = [0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex') return utils.toHex32(this.h.slice(0, 7), 'big');else return utils.split32(this.h.slice(0, 7), 'big');
};

/***/ }),

/***/ "fxuI":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("jkjm");
var mgf = __webpack_require__("Cua8");
var xor = __webpack_require__("zOO0");
var BN = __webpack_require__("geuY");
var crt = __webpack_require__("jSRM");
var createHash = __webpack_require__("BVsN");
var withPublic = __webpack_require__("5QAX");
var Buffer = __webpack_require__("X3l8").Buffer;

module.exports = function privateDecrypt(privateKey, enc, reverse) {
  var padding;
  if (privateKey.padding) {
    padding = privateKey.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }

  var key = parseKeys(privateKey);
  var k = key.modulus.byteLength();
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error');
  }
  var msg;
  if (reverse) {
    msg = withPublic(new BN(enc), key);
  } else {
    msg = crt(enc, key);
  }
  var zBuffer = Buffer.alloc(k - msg.length);
  msg = Buffer.concat([zBuffer, msg], k);
  if (padding === 4) {
    return oaep(key, msg);
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    return msg;
  } else {
    throw new Error('unknown padding');
  }
};

function oaep(key, msg) {
  var k = key.modulus.byteLength();
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest();
  var hLen = iHash.length;
  if (msg[0] !== 0) {
    throw new Error('decryption error');
  }
  var maskedSeed = msg.slice(1, hLen + 1);
  var maskedDb = msg.slice(hLen + 1);
  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error');
  }
  var i = hLen;
  while (db[i] === 0) {
    i++;
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error');
  }
  return db.slice(i);
}

function pkcs1(key, msg, reverse) {
  var p1 = msg.slice(0, 2);
  var i = 2;
  var status = 0;
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++;
      break;
    }
  }
  var ps = msg.slice(2, i - 1);

  if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) {
    status++;
  }
  if (ps.length < 8) {
    status++;
  }
  if (status) {
    throw new Error('decryption error');
  }
  return msg.slice(i);
}
function compare(a, b) {
  a = Buffer.from(a);
  b = Buffer.from(b);
  var dif = 0;
  var len = a.length;
  if (a.length !== b.length) {
    dif++;
    len = Math.min(a.length, b.length);
  }
  var i = -1;
  while (++i < len) {
    dif += a[i] ^ b[i];
  }
  return dif;
}

/***/ }),

/***/ "geuY":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils

  function assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN(number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(2).Buffer;
  } catch (e) {}

  BN.isBN = function isBN(num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max(left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min(left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init(number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber(number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff, 1];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray(number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
        this.words[j] |= w << off & 0x3ffffff;
        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
        this.words[j] |= w << off & 0x3ffffff;
        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex(str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

        // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

        // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex(number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= w << off & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= w << off & 0x3ffffff;
      this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
    }
    this.strip();
  };

  function parseBase(str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

        // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

        // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase(number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = limbPow / base | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy(dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone() {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand(size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip() {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign() {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect() {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*
   var zeros = [];
  var groupSizes = [];
  var groupBases = [];
   var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }
   */

  var zeros = ['', '0', '00', '000', '0000', '00000', '000000', '0000000', '00000000', '000000000', '0000000000', '00000000000', '000000000000', '0000000000000', '00000000000000', '000000000000000', '0000000000000000', '00000000000000000', '000000000000000000', '0000000000000000000', '00000000000000000000', '000000000000000000000', '0000000000000000000000', '00000000000000000000000', '000000000000000000000000', '0000000000000000000000000'];

  var groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];

  var groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

  BN.prototype.toString = function toString(base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = ((w << off | carry) & 0xffffff).toString(16);
        carry = w >>> 24 - off & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber() {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + this.words[1] * 0x4000000;
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return this.negative !== 0 ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON() {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer(endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray(endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits(w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits(w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits(w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength() {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray(num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = bit / 26 | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits() {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength() {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos(width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos(width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg() {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg() {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg() {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor(num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or(num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor(num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand(num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and(num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand(num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor(num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor(num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor(num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn(width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn(width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn(bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = bit / 26 | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | 1 << wbit;
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd(num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

      // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
      // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add(num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub(num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

      // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub(num) {
    return this.clone().isub(num);
  };

  function smallMulTo(self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = self.length + num.length | 0;
    out.length = len;
    len = len - 1 | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = r / 0x4000000 | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += r / 0x4000000 | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo(self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = mid + Math.imul(ah0, bl0) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = mid + Math.imul(ah1, bl0) | 0;
    hi = Math.imul(ah1, bh0);
    lo = lo + Math.imul(al0, bl1) | 0;
    mid = mid + Math.imul(al0, bh1) | 0;
    mid = mid + Math.imul(ah0, bl1) | 0;
    hi = hi + Math.imul(ah0, bh1) | 0;
    var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = mid + Math.imul(ah2, bl0) | 0;
    hi = Math.imul(ah2, bh0);
    lo = lo + Math.imul(al1, bl1) | 0;
    mid = mid + Math.imul(al1, bh1) | 0;
    mid = mid + Math.imul(ah1, bl1) | 0;
    hi = hi + Math.imul(ah1, bh1) | 0;
    lo = lo + Math.imul(al0, bl2) | 0;
    mid = mid + Math.imul(al0, bh2) | 0;
    mid = mid + Math.imul(ah0, bl2) | 0;
    hi = hi + Math.imul(ah0, bh2) | 0;
    var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = mid + Math.imul(ah3, bl0) | 0;
    hi = Math.imul(ah3, bh0);
    lo = lo + Math.imul(al2, bl1) | 0;
    mid = mid + Math.imul(al2, bh1) | 0;
    mid = mid + Math.imul(ah2, bl1) | 0;
    hi = hi + Math.imul(ah2, bh1) | 0;
    lo = lo + Math.imul(al1, bl2) | 0;
    mid = mid + Math.imul(al1, bh2) | 0;
    mid = mid + Math.imul(ah1, bl2) | 0;
    hi = hi + Math.imul(ah1, bh2) | 0;
    lo = lo + Math.imul(al0, bl3) | 0;
    mid = mid + Math.imul(al0, bh3) | 0;
    mid = mid + Math.imul(ah0, bl3) | 0;
    hi = hi + Math.imul(ah0, bh3) | 0;
    var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = mid + Math.imul(ah4, bl0) | 0;
    hi = Math.imul(ah4, bh0);
    lo = lo + Math.imul(al3, bl1) | 0;
    mid = mid + Math.imul(al3, bh1) | 0;
    mid = mid + Math.imul(ah3, bl1) | 0;
    hi = hi + Math.imul(ah3, bh1) | 0;
    lo = lo + Math.imul(al2, bl2) | 0;
    mid = mid + Math.imul(al2, bh2) | 0;
    mid = mid + Math.imul(ah2, bl2) | 0;
    hi = hi + Math.imul(ah2, bh2) | 0;
    lo = lo + Math.imul(al1, bl3) | 0;
    mid = mid + Math.imul(al1, bh3) | 0;
    mid = mid + Math.imul(ah1, bl3) | 0;
    hi = hi + Math.imul(ah1, bh3) | 0;
    lo = lo + Math.imul(al0, bl4) | 0;
    mid = mid + Math.imul(al0, bh4) | 0;
    mid = mid + Math.imul(ah0, bl4) | 0;
    hi = hi + Math.imul(ah0, bh4) | 0;
    var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = mid + Math.imul(ah5, bl0) | 0;
    hi = Math.imul(ah5, bh0);
    lo = lo + Math.imul(al4, bl1) | 0;
    mid = mid + Math.imul(al4, bh1) | 0;
    mid = mid + Math.imul(ah4, bl1) | 0;
    hi = hi + Math.imul(ah4, bh1) | 0;
    lo = lo + Math.imul(al3, bl2) | 0;
    mid = mid + Math.imul(al3, bh2) | 0;
    mid = mid + Math.imul(ah3, bl2) | 0;
    hi = hi + Math.imul(ah3, bh2) | 0;
    lo = lo + Math.imul(al2, bl3) | 0;
    mid = mid + Math.imul(al2, bh3) | 0;
    mid = mid + Math.imul(ah2, bl3) | 0;
    hi = hi + Math.imul(ah2, bh3) | 0;
    lo = lo + Math.imul(al1, bl4) | 0;
    mid = mid + Math.imul(al1, bh4) | 0;
    mid = mid + Math.imul(ah1, bl4) | 0;
    hi = hi + Math.imul(ah1, bh4) | 0;
    lo = lo + Math.imul(al0, bl5) | 0;
    mid = mid + Math.imul(al0, bh5) | 0;
    mid = mid + Math.imul(ah0, bl5) | 0;
    hi = hi + Math.imul(ah0, bh5) | 0;
    var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = mid + Math.imul(ah6, bl0) | 0;
    hi = Math.imul(ah6, bh0);
    lo = lo + Math.imul(al5, bl1) | 0;
    mid = mid + Math.imul(al5, bh1) | 0;
    mid = mid + Math.imul(ah5, bl1) | 0;
    hi = hi + Math.imul(ah5, bh1) | 0;
    lo = lo + Math.imul(al4, bl2) | 0;
    mid = mid + Math.imul(al4, bh2) | 0;
    mid = mid + Math.imul(ah4, bl2) | 0;
    hi = hi + Math.imul(ah4, bh2) | 0;
    lo = lo + Math.imul(al3, bl3) | 0;
    mid = mid + Math.imul(al3, bh3) | 0;
    mid = mid + Math.imul(ah3, bl3) | 0;
    hi = hi + Math.imul(ah3, bh3) | 0;
    lo = lo + Math.imul(al2, bl4) | 0;
    mid = mid + Math.imul(al2, bh4) | 0;
    mid = mid + Math.imul(ah2, bl4) | 0;
    hi = hi + Math.imul(ah2, bh4) | 0;
    lo = lo + Math.imul(al1, bl5) | 0;
    mid = mid + Math.imul(al1, bh5) | 0;
    mid = mid + Math.imul(ah1, bl5) | 0;
    hi = hi + Math.imul(ah1, bh5) | 0;
    lo = lo + Math.imul(al0, bl6) | 0;
    mid = mid + Math.imul(al0, bh6) | 0;
    mid = mid + Math.imul(ah0, bl6) | 0;
    hi = hi + Math.imul(ah0, bh6) | 0;
    var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = mid + Math.imul(ah7, bl0) | 0;
    hi = Math.imul(ah7, bh0);
    lo = lo + Math.imul(al6, bl1) | 0;
    mid = mid + Math.imul(al6, bh1) | 0;
    mid = mid + Math.imul(ah6, bl1) | 0;
    hi = hi + Math.imul(ah6, bh1) | 0;
    lo = lo + Math.imul(al5, bl2) | 0;
    mid = mid + Math.imul(al5, bh2) | 0;
    mid = mid + Math.imul(ah5, bl2) | 0;
    hi = hi + Math.imul(ah5, bh2) | 0;
    lo = lo + Math.imul(al4, bl3) | 0;
    mid = mid + Math.imul(al4, bh3) | 0;
    mid = mid + Math.imul(ah4, bl3) | 0;
    hi = hi + Math.imul(ah4, bh3) | 0;
    lo = lo + Math.imul(al3, bl4) | 0;
    mid = mid + Math.imul(al3, bh4) | 0;
    mid = mid + Math.imul(ah3, bl4) | 0;
    hi = hi + Math.imul(ah3, bh4) | 0;
    lo = lo + Math.imul(al2, bl5) | 0;
    mid = mid + Math.imul(al2, bh5) | 0;
    mid = mid + Math.imul(ah2, bl5) | 0;
    hi = hi + Math.imul(ah2, bh5) | 0;
    lo = lo + Math.imul(al1, bl6) | 0;
    mid = mid + Math.imul(al1, bh6) | 0;
    mid = mid + Math.imul(ah1, bl6) | 0;
    hi = hi + Math.imul(ah1, bh6) | 0;
    lo = lo + Math.imul(al0, bl7) | 0;
    mid = mid + Math.imul(al0, bh7) | 0;
    mid = mid + Math.imul(ah0, bl7) | 0;
    hi = hi + Math.imul(ah0, bh7) | 0;
    var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = mid + Math.imul(ah8, bl0) | 0;
    hi = Math.imul(ah8, bh0);
    lo = lo + Math.imul(al7, bl1) | 0;
    mid = mid + Math.imul(al7, bh1) | 0;
    mid = mid + Math.imul(ah7, bl1) | 0;
    hi = hi + Math.imul(ah7, bh1) | 0;
    lo = lo + Math.imul(al6, bl2) | 0;
    mid = mid + Math.imul(al6, bh2) | 0;
    mid = mid + Math.imul(ah6, bl2) | 0;
    hi = hi + Math.imul(ah6, bh2) | 0;
    lo = lo + Math.imul(al5, bl3) | 0;
    mid = mid + Math.imul(al5, bh3) | 0;
    mid = mid + Math.imul(ah5, bl3) | 0;
    hi = hi + Math.imul(ah5, bh3) | 0;
    lo = lo + Math.imul(al4, bl4) | 0;
    mid = mid + Math.imul(al4, bh4) | 0;
    mid = mid + Math.imul(ah4, bl4) | 0;
    hi = hi + Math.imul(ah4, bh4) | 0;
    lo = lo + Math.imul(al3, bl5) | 0;
    mid = mid + Math.imul(al3, bh5) | 0;
    mid = mid + Math.imul(ah3, bl5) | 0;
    hi = hi + Math.imul(ah3, bh5) | 0;
    lo = lo + Math.imul(al2, bl6) | 0;
    mid = mid + Math.imul(al2, bh6) | 0;
    mid = mid + Math.imul(ah2, bl6) | 0;
    hi = hi + Math.imul(ah2, bh6) | 0;
    lo = lo + Math.imul(al1, bl7) | 0;
    mid = mid + Math.imul(al1, bh7) | 0;
    mid = mid + Math.imul(ah1, bl7) | 0;
    hi = hi + Math.imul(ah1, bh7) | 0;
    lo = lo + Math.imul(al0, bl8) | 0;
    mid = mid + Math.imul(al0, bh8) | 0;
    mid = mid + Math.imul(ah0, bl8) | 0;
    hi = hi + Math.imul(ah0, bh8) | 0;
    var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = mid + Math.imul(ah9, bl0) | 0;
    hi = Math.imul(ah9, bh0);
    lo = lo + Math.imul(al8, bl1) | 0;
    mid = mid + Math.imul(al8, bh1) | 0;
    mid = mid + Math.imul(ah8, bl1) | 0;
    hi = hi + Math.imul(ah8, bh1) | 0;
    lo = lo + Math.imul(al7, bl2) | 0;
    mid = mid + Math.imul(al7, bh2) | 0;
    mid = mid + Math.imul(ah7, bl2) | 0;
    hi = hi + Math.imul(ah7, bh2) | 0;
    lo = lo + Math.imul(al6, bl3) | 0;
    mid = mid + Math.imul(al6, bh3) | 0;
    mid = mid + Math.imul(ah6, bl3) | 0;
    hi = hi + Math.imul(ah6, bh3) | 0;
    lo = lo + Math.imul(al5, bl4) | 0;
    mid = mid + Math.imul(al5, bh4) | 0;
    mid = mid + Math.imul(ah5, bl4) | 0;
    hi = hi + Math.imul(ah5, bh4) | 0;
    lo = lo + Math.imul(al4, bl5) | 0;
    mid = mid + Math.imul(al4, bh5) | 0;
    mid = mid + Math.imul(ah4, bl5) | 0;
    hi = hi + Math.imul(ah4, bh5) | 0;
    lo = lo + Math.imul(al3, bl6) | 0;
    mid = mid + Math.imul(al3, bh6) | 0;
    mid = mid + Math.imul(ah3, bl6) | 0;
    hi = hi + Math.imul(ah3, bh6) | 0;
    lo = lo + Math.imul(al2, bl7) | 0;
    mid = mid + Math.imul(al2, bh7) | 0;
    mid = mid + Math.imul(ah2, bl7) | 0;
    hi = hi + Math.imul(ah2, bh7) | 0;
    lo = lo + Math.imul(al1, bl8) | 0;
    mid = mid + Math.imul(al1, bh8) | 0;
    mid = mid + Math.imul(ah1, bl8) | 0;
    hi = hi + Math.imul(ah1, bh8) | 0;
    lo = lo + Math.imul(al0, bl9) | 0;
    mid = mid + Math.imul(al0, bh9) | 0;
    mid = mid + Math.imul(ah0, bl9) | 0;
    hi = hi + Math.imul(ah0, bh9) | 0;
    var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = mid + Math.imul(ah9, bl1) | 0;
    hi = Math.imul(ah9, bh1);
    lo = lo + Math.imul(al8, bl2) | 0;
    mid = mid + Math.imul(al8, bh2) | 0;
    mid = mid + Math.imul(ah8, bl2) | 0;
    hi = hi + Math.imul(ah8, bh2) | 0;
    lo = lo + Math.imul(al7, bl3) | 0;
    mid = mid + Math.imul(al7, bh3) | 0;
    mid = mid + Math.imul(ah7, bl3) | 0;
    hi = hi + Math.imul(ah7, bh3) | 0;
    lo = lo + Math.imul(al6, bl4) | 0;
    mid = mid + Math.imul(al6, bh4) | 0;
    mid = mid + Math.imul(ah6, bl4) | 0;
    hi = hi + Math.imul(ah6, bh4) | 0;
    lo = lo + Math.imul(al5, bl5) | 0;
    mid = mid + Math.imul(al5, bh5) | 0;
    mid = mid + Math.imul(ah5, bl5) | 0;
    hi = hi + Math.imul(ah5, bh5) | 0;
    lo = lo + Math.imul(al4, bl6) | 0;
    mid = mid + Math.imul(al4, bh6) | 0;
    mid = mid + Math.imul(ah4, bl6) | 0;
    hi = hi + Math.imul(ah4, bh6) | 0;
    lo = lo + Math.imul(al3, bl7) | 0;
    mid = mid + Math.imul(al3, bh7) | 0;
    mid = mid + Math.imul(ah3, bl7) | 0;
    hi = hi + Math.imul(ah3, bh7) | 0;
    lo = lo + Math.imul(al2, bl8) | 0;
    mid = mid + Math.imul(al2, bh8) | 0;
    mid = mid + Math.imul(ah2, bl8) | 0;
    hi = hi + Math.imul(ah2, bh8) | 0;
    lo = lo + Math.imul(al1, bl9) | 0;
    mid = mid + Math.imul(al1, bh9) | 0;
    mid = mid + Math.imul(ah1, bl9) | 0;
    hi = hi + Math.imul(ah1, bh9) | 0;
    var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = mid + Math.imul(ah9, bl2) | 0;
    hi = Math.imul(ah9, bh2);
    lo = lo + Math.imul(al8, bl3) | 0;
    mid = mid + Math.imul(al8, bh3) | 0;
    mid = mid + Math.imul(ah8, bl3) | 0;
    hi = hi + Math.imul(ah8, bh3) | 0;
    lo = lo + Math.imul(al7, bl4) | 0;
    mid = mid + Math.imul(al7, bh4) | 0;
    mid = mid + Math.imul(ah7, bl4) | 0;
    hi = hi + Math.imul(ah7, bh4) | 0;
    lo = lo + Math.imul(al6, bl5) | 0;
    mid = mid + Math.imul(al6, bh5) | 0;
    mid = mid + Math.imul(ah6, bl5) | 0;
    hi = hi + Math.imul(ah6, bh5) | 0;
    lo = lo + Math.imul(al5, bl6) | 0;
    mid = mid + Math.imul(al5, bh6) | 0;
    mid = mid + Math.imul(ah5, bl6) | 0;
    hi = hi + Math.imul(ah5, bh6) | 0;
    lo = lo + Math.imul(al4, bl7) | 0;
    mid = mid + Math.imul(al4, bh7) | 0;
    mid = mid + Math.imul(ah4, bl7) | 0;
    hi = hi + Math.imul(ah4, bh7) | 0;
    lo = lo + Math.imul(al3, bl8) | 0;
    mid = mid + Math.imul(al3, bh8) | 0;
    mid = mid + Math.imul(ah3, bl8) | 0;
    hi = hi + Math.imul(ah3, bh8) | 0;
    lo = lo + Math.imul(al2, bl9) | 0;
    mid = mid + Math.imul(al2, bh9) | 0;
    mid = mid + Math.imul(ah2, bl9) | 0;
    hi = hi + Math.imul(ah2, bh9) | 0;
    var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = mid + Math.imul(ah9, bl3) | 0;
    hi = Math.imul(ah9, bh3);
    lo = lo + Math.imul(al8, bl4) | 0;
    mid = mid + Math.imul(al8, bh4) | 0;
    mid = mid + Math.imul(ah8, bl4) | 0;
    hi = hi + Math.imul(ah8, bh4) | 0;
    lo = lo + Math.imul(al7, bl5) | 0;
    mid = mid + Math.imul(al7, bh5) | 0;
    mid = mid + Math.imul(ah7, bl5) | 0;
    hi = hi + Math.imul(ah7, bh5) | 0;
    lo = lo + Math.imul(al6, bl6) | 0;
    mid = mid + Math.imul(al6, bh6) | 0;
    mid = mid + Math.imul(ah6, bl6) | 0;
    hi = hi + Math.imul(ah6, bh6) | 0;
    lo = lo + Math.imul(al5, bl7) | 0;
    mid = mid + Math.imul(al5, bh7) | 0;
    mid = mid + Math.imul(ah5, bl7) | 0;
    hi = hi + Math.imul(ah5, bh7) | 0;
    lo = lo + Math.imul(al4, bl8) | 0;
    mid = mid + Math.imul(al4, bh8) | 0;
    mid = mid + Math.imul(ah4, bl8) | 0;
    hi = hi + Math.imul(ah4, bh8) | 0;
    lo = lo + Math.imul(al3, bl9) | 0;
    mid = mid + Math.imul(al3, bh9) | 0;
    mid = mid + Math.imul(ah3, bl9) | 0;
    hi = hi + Math.imul(ah3, bh9) | 0;
    var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = mid + Math.imul(ah9, bl4) | 0;
    hi = Math.imul(ah9, bh4);
    lo = lo + Math.imul(al8, bl5) | 0;
    mid = mid + Math.imul(al8, bh5) | 0;
    mid = mid + Math.imul(ah8, bl5) | 0;
    hi = hi + Math.imul(ah8, bh5) | 0;
    lo = lo + Math.imul(al7, bl6) | 0;
    mid = mid + Math.imul(al7, bh6) | 0;
    mid = mid + Math.imul(ah7, bl6) | 0;
    hi = hi + Math.imul(ah7, bh6) | 0;
    lo = lo + Math.imul(al6, bl7) | 0;
    mid = mid + Math.imul(al6, bh7) | 0;
    mid = mid + Math.imul(ah6, bl7) | 0;
    hi = hi + Math.imul(ah6, bh7) | 0;
    lo = lo + Math.imul(al5, bl8) | 0;
    mid = mid + Math.imul(al5, bh8) | 0;
    mid = mid + Math.imul(ah5, bl8) | 0;
    hi = hi + Math.imul(ah5, bh8) | 0;
    lo = lo + Math.imul(al4, bl9) | 0;
    mid = mid + Math.imul(al4, bh9) | 0;
    mid = mid + Math.imul(ah4, bl9) | 0;
    hi = hi + Math.imul(ah4, bh9) | 0;
    var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = mid + Math.imul(ah9, bl5) | 0;
    hi = Math.imul(ah9, bh5);
    lo = lo + Math.imul(al8, bl6) | 0;
    mid = mid + Math.imul(al8, bh6) | 0;
    mid = mid + Math.imul(ah8, bl6) | 0;
    hi = hi + Math.imul(ah8, bh6) | 0;
    lo = lo + Math.imul(al7, bl7) | 0;
    mid = mid + Math.imul(al7, bh7) | 0;
    mid = mid + Math.imul(ah7, bl7) | 0;
    hi = hi + Math.imul(ah7, bh7) | 0;
    lo = lo + Math.imul(al6, bl8) | 0;
    mid = mid + Math.imul(al6, bh8) | 0;
    mid = mid + Math.imul(ah6, bl8) | 0;
    hi = hi + Math.imul(ah6, bh8) | 0;
    lo = lo + Math.imul(al5, bl9) | 0;
    mid = mid + Math.imul(al5, bh9) | 0;
    mid = mid + Math.imul(ah5, bl9) | 0;
    hi = hi + Math.imul(ah5, bh9) | 0;
    var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = mid + Math.imul(ah9, bl6) | 0;
    hi = Math.imul(ah9, bh6);
    lo = lo + Math.imul(al8, bl7) | 0;
    mid = mid + Math.imul(al8, bh7) | 0;
    mid = mid + Math.imul(ah8, bl7) | 0;
    hi = hi + Math.imul(ah8, bh7) | 0;
    lo = lo + Math.imul(al7, bl8) | 0;
    mid = mid + Math.imul(al7, bh8) | 0;
    mid = mid + Math.imul(ah7, bl8) | 0;
    hi = hi + Math.imul(ah7, bh8) | 0;
    lo = lo + Math.imul(al6, bl9) | 0;
    mid = mid + Math.imul(al6, bh9) | 0;
    mid = mid + Math.imul(ah6, bl9) | 0;
    hi = hi + Math.imul(ah6, bh9) | 0;
    var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = mid + Math.imul(ah9, bl7) | 0;
    hi = Math.imul(ah9, bh7);
    lo = lo + Math.imul(al8, bl8) | 0;
    mid = mid + Math.imul(al8, bh8) | 0;
    mid = mid + Math.imul(ah8, bl8) | 0;
    hi = hi + Math.imul(ah8, bh8) | 0;
    lo = lo + Math.imul(al7, bl9) | 0;
    mid = mid + Math.imul(al7, bh9) | 0;
    mid = mid + Math.imul(ah7, bl9) | 0;
    hi = hi + Math.imul(ah7, bh9) | 0;
    var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = mid + Math.imul(ah9, bl8) | 0;
    hi = Math.imul(ah9, bh8);
    lo = lo + Math.imul(al8, bl9) | 0;
    mid = mid + Math.imul(al8, bh9) | 0;
    mid = mid + Math.imul(ah8, bl9) | 0;
    hi = hi + Math.imul(ah8, bh9) | 0;
    var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = mid + Math.imul(ah9, bl9) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo(self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = ncarry + (r / 0x4000000 | 0) | 0;
        lo = lo + rword | 0;
        rword = lo & 0x3ffffff;
        ncarry = ncarry + (lo >>> 26) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo(self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo(num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM(x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT(N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin(x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << l - i - 1;
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b(ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff;carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff;carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub(N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp(x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul(num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf(num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul(num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += w / 0x4000000 | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln(num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr() {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr() {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow(num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln(bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = (this.words[i] | 0) - newCarry << r;
        this.words[i] = c | carry;
        carry = newCarry >>> 26 - r;
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln(bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn(bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - hint % 26) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = carry << 26 - r | word >>> r;
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn(bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln(bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln(bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn(bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn(bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn(bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn(bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn(bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn(num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn(num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn(num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs() {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs() {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - (right / 0x4000000 | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv(num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min(qj / bhi | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod(num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div(num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod(num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod(num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound(num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn(num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn(num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = w / num | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn(num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd(p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1) {}
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) {}
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp(p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1) {}
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) {}
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd(num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm(num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven() {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd() {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln(num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn(bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero() {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn(num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp(num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp(num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn(num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt(num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten(num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte(num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn(num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt(num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten(num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte(num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn(num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq(num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red(num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed(ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed() {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed(ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed(ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd(num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd(num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub(num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub(num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl(num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul(num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul(num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr() {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr() {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt() {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm() {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg() {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow(num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime(name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp() {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce(num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split(input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK(num) {
    return num.imul(this.k);
  };

  function K256() {
    MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split(input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK(num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + (lo / 0x4000000 | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224() {
    MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192() {
    MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519() {
    // 2 ^ 255 - 19
    MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK(num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime(name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red(m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1(a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2(a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red, 'red works only with red numbers');
  };

  Red.prototype.imod = function imod(a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg(a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add(a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd(a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub(a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub(a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl(a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul(a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul(a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr(a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr(a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt(a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm(a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow(a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = word >> j & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo(num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom(num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont(num) {
    return new Mont(num);
  };

  function Mont(m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - this.shift % 26;
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo(num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom(num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul(a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul(a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm(a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "gw8B":
/***/ (function(module, exports, __webpack_require__) {

var elliptic = __webpack_require__("lZ6o");
var BN = __webpack_require__("geuY");

module.exports = function createECDH(curve) {
  return new ECDH(curve);
};

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
};

aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;

function ECDH(curve) {
  this.curveType = aliases[curve];
  if (!this.curveType) {
    this.curveType = {
      name: curve
    };
  }
  this.curve = new elliptic.ec(this.curveType.name); // eslint-disable-line new-cap
  this.keys = void 0;
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair();
  return this.getPublicKey(enc, format);
};

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8';
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc);
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic();
  var out = otherPub.mul(this.keys.getPrivate()).getX();
  return formatReturnValue(out, enc, this.curveType.byteLength);
};

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true);
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7;
    } else {
      key[0] = 6;
    }
  }
  return formatReturnValue(key, enc);
};

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc);
};

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this.keys._importPublic(pub);
  return this;
};

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }

  var _priv = new BN(priv);
  _priv = _priv.toString(16);
  this.keys = this.curve.genKeyPair();
  this.keys._importPrivate(_priv);
  return this;
};

function formatReturnValue(bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray();
  }
  var buf = new Buffer(bn);
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length);
    zeros.fill(0);
    buf = Buffer.concat([zeros, buf]);
  }
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/***/ }),

/***/ "hQ80":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__("3PYz");
var elliptic = __webpack_require__("lZ6o");

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short') this.curve = new elliptic.curve.short(options);else if (options.type === 'edwards') this.curve = new elliptic.curve.edwards(options);else this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function get() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: ['188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012', '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811']
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: ['b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21', 'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34']
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: ['6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296', '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5']
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' + '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' + 'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: ['aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' + '5502f25d bf55296c 3a545e38 72760ab7', '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' + '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f']
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' + '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' + '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' + 'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' + 'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: ['000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' + '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' + 'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66', '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' + '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' + '3fad0761 353c7086 a272c240 88be9476 9fd16650']
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: ['9']
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: ['216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

  // 4/5
  '6666666666666666666666666666666666666666666666666666666666666658']
});

var pre;
try {
  pre = __webpack_require__("9bI3");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [{
    a: '3086d221a7d46bcde86c90e49284eb15',
    b: '-e4437ed6010e88286f547fa90abfe4c3'
  }, {
    a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
    b: '3086d221a7d46bcde86c90e49284eb15'
  }],

  gRed: false,
  g: ['79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798', '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8', pre]
});

/***/ }),

/***/ "hkfz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("geuY");
var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object') sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R)) this._R = sig.R;
  if (sig.S instanceof BN) this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

/***/ }),

/***/ "iLJX":
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__("reGU");
decoders.pem = __webpack_require__("vWx2");

/***/ }),

/***/ "iNQt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = value >>> 16 & 0xff;
  bytes[2 + off] = value >>> 8 & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= inR >>> j + i & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= inL >>> j + i & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= inR >>> j + i & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= inL >>> j + i & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= inR >>> j + i & 1;
      outL <<= 1;
      outL |= inL >>> j + i & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= inR >>> j + i & 1;
      outR <<= 1;
      outR |= inL >>> j + i & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= inR >> j + i & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= inL >> j + i & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= inR >> j + i & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= inR >> j + i & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= inL >> j + i & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= inL >> j + i & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return num << shift & 0xfffffff | num >>> 28 - shift;
};

var pc2table = [
// inL => outL
14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26,

// inR => outR
15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= inL >>> pc2table[i] & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= inR >>> pc2table[i] & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = (r & 1) << 5 | r >>> 27;
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= r >>> i & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= r >>> i & 0x3f;
    outR <<= 6;
  }
  outR |= (r & 0x1f) << 1 | r >>> 31;

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = inL >>> 18 - i * 6 & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = inR >>> 18 - i * 6 & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= num >>> permuteTable[i] & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size) {
    str = '0' + str;
  }var out = [];
  for (var i = 0; i < size; i += group) {
    out.push(str.slice(i, i + group));
  }return out.join(' ');
};

/***/ }),

/***/ "iP15":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate(fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config(name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "iTY7":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");
var Reporter = __webpack_require__("3UtB").Reporter;
var Buffer = __webpack_require__("63KW").Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);else return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function (item) {
      if (!(item instanceof EncoderBuffer)) item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out) out = new Buffer(this.length);
  if (!offset) offset = 0;

  if (this.length === 0) return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function (item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number') out[offset] = this.value;else if (typeof this.value === 'string') out.write(this.value, offset);else if (Buffer.isBuffer(this.value)) this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

/***/ }),

/***/ "jOgh":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return objectToString(e) === '[object Error]' || e instanceof Error;
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/***/ }),

/***/ "jSRM":
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__("geuY");
var randomBytes = __webpack_require__("rOku");
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus)).redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder: r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/***/ }),

/***/ "jkjm":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("19bf");
var aesid = __webpack_require__("8YCc");
var fixProc = __webpack_require__("7VT+");
var ciphers = __webpack_require__("tXf9");
var compat = __webpack_require__("/vd3");
var Buffer = __webpack_require__("X3l8").Buffer;
module.exports = parseKeys;

function parseKeys(buffer) {
  var password;
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase;
    buffer = buffer.key;
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer);
  }

  var stripped = fixProc(buffer, password);

  var type = stripped.tag;
  var data = stripped.data;
  var subtype, ndata;
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
    // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der');
      }
      subtype = ndata.algorithm.algorithm.join('.');
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey;
          return {
            type: 'ec',
            data: ndata
          };
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          };
        default:
          throw new Error('unknown key id ' + subtype);
      }
      throw new Error('unknown key type ' + type);
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der');
      data = decrypt(data, password);
    // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der');
      subtype = ndata.algorithm.algorithm.join('.');
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          };
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          };
        default:
          throw new Error('unknown key id ' + subtype);
      }
      throw new Error('unknown key type ' + type);
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der');
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der');
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      };
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der');
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      };
    default:
      throw new Error('unknown key type ' + type);
  }
}
parseKeys.signature = asn1.signature;
function decrypt(data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt;
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
  var iv = data.algorithm.decrypt.cipher.iv;
  var cipherText = data.subjectPrivateKey;
  var keylen = parseInt(algo.split('-')[1], 10) / 8;
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
  var cipher = ciphers.createDecipheriv(algo, key, iv);
  var out = [];
  out.push(cipher.update(cipherText));
  out.push(cipher.final());
  return Buffer.concat(out);
}

/***/ }),

/***/ "k2Sm":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;

function encryptByte(self, byteParam, decrypt) {
  var pad;
  var i = -1;
  var len = 8;
  var out = 0;
  var bit, value;
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev);
    bit = byteParam & 1 << 7 - i ? 0x80 : 0;
    value = pad[0] ^ bit;
    out += (value & 0x80) >> i % 8;
    self._prev = shiftIn(self._prev, decrypt ? bit : value);
  }
  return out;
}

function shiftIn(buffer, value) {
  var len = buffer.length;
  var i = -1;
  var out = Buffer.allocUnsafe(buffer.length);
  buffer = Buffer.concat([buffer, Buffer.from([value])]);

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
  }

  return out;
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length;
  var out = Buffer.allocUnsafe(len);
  var i = -1;

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt);
  }

  return out;
};

/***/ }),

/***/ "kJAH":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("KDHK");
var inherits = __webpack_require__("LC74");

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__("+W7P").runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
  } catch (e) {
    named = function named(entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

/***/ }),

/***/ "lQBd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__("KDHK");

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  });
});

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(this.key('type').objid(), this.key('value').any());
});

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(this.key('algorithm').use(AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue);
});

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName);
});

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  });
});

var Validity = asn.define('Validity', function () {
  this.seq().obj(this.key('notBefore').use(Time), this.key('notAfter').use(Time));
});

var Extension = asn.define('Extension', function () {
  this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(this.key('version').explicit(0).int().optional(), this.key('serialNumber').int(), this.key('signature').use(AlgorithmIdentifier), this.key('issuer').use(Name), this.key('validity').use(Validity), this.key('subject').use(Name), this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof(Extension).optional());
});

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(this.key('tbsCertificate').use(TBSCertificate), this.key('signatureAlgorithm').use(AlgorithmIdentifier), this.key('signatureValue').bitstr());
});

module.exports = X509Certificate;

/***/ }),

/***/ "lUSU":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("H2Pp");

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev);

  self._prev = self._cipher.encryptBlock(data);
  return self._prev;
};

exports.decrypt = function (self, block) {
  var pad = self._prev;

  self._prev = block;
  var out = self._cipher.decryptBlock(block);

  return xor(out, pad);
};

/***/ }),

/***/ "lXn8":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("LC74");
var Sha256 = __webpack_require__("zvjZ");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var W = new Array(64);

function Sha224() {
  this.init();

  this._w = W; // new Array(64)

  Hash.call(this, 64, 56);
}

inherits(Sha224, Sha256);

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8;
  this._b = 0x367cd507;
  this._c = 0x3070dd17;
  this._d = 0xf70e5939;
  this._e = 0xffc00b31;
  this._f = 0x68581511;
  this._g = 0x64f98fa7;
  this._h = 0xbefa4fa4;

  return this;
};

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28);

  H.writeInt32BE(this._a, 0);
  H.writeInt32BE(this._b, 4);
  H.writeInt32BE(this._c, 8);
  H.writeInt32BE(this._d, 12);
  H.writeInt32BE(this._e, 16);
  H.writeInt32BE(this._f, 20);
  H.writeInt32BE(this._g, 24);

  return H;
};

module.exports = Sha224;

/***/ }),

/***/ "lZ6o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__("KYqO").version;
elliptic.utils = __webpack_require__("TkWM");
elliptic.rand = __webpack_require__("txgm");
elliptic.curve = __webpack_require__("tRuz");
elliptic.curves = __webpack_require__("hQ80");

// Protocols
elliptic.ec = __webpack_require__("F11g");
elliptic.eddsa = __webpack_require__("+e0g");

/***/ }),

/***/ "nyV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++) {
    this.iv[i] = iv[i];
  }
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++) {
      iv[i] ^= inp[inOff + i];
    }superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++) {
      iv[i] = out[outOff + i];
    }
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++) {
      out[outOff + i] ^= iv[i];
    }for (var i = 0; i < this.blockSize; i++) {
      iv[i] = inp[inOff + i];
    }
  }
};

/***/ }),

/***/ "pEK1":
/***/ (function(module, exports) {

module.exports = exports = window.fetch;

// Needed for TypeScript and Webpack.
exports.default = window.fetch.bind(window);

exports.Headers = window.Headers;
exports.Request = window.Request;
exports.Response = window.Response;

/***/ }),

/***/ "pS+P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__("tRuz");
var BN = __webpack_require__("geuY");
var inherits = __webpack_require__("LC74");
var Base = curve.base;

var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity()) return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1)) {
    bits.push(t.andln(1));
  }for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

/***/ }),

/***/ "pYSm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens(b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;

  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;

  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

  for (var i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }

  return parts.join('');
}

/***/ }),

/***/ "pn+s":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__("ARY+");
var crt = __webpack_require__("jSRM");
var EC = __webpack_require__("lZ6o").ec;
var BN = __webpack_require__("geuY");
var parseKeys = __webpack_require__("jkjm");
var curves = __webpack_require__("QDfD");

function sign(hash, key, hashType, signType, tag) {
  var priv = parseKeys(key);
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    return ecSign(hash, priv);
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type');
    return dsaSign(hash, priv, hashType);
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
  }
  hash = Buffer.concat([tag, hash]);
  var len = priv.modulus.byteLength();
  var pad = [0, 1];
  while (hash.length + pad.length + 1 < len) {
    pad.push(0xff);
  }pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }var out = crt(pad, priv);
  return out;
}

function ecSign(hash, priv) {
  var curveId = curves[priv.curve.join('.')];
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));

  var curve = new EC(curveId);
  var key = curve.keyFromPrivate(priv.privateKey);
  var out = key.sign(hash);

  return new Buffer(out.toDER());
}

function dsaSign(hash, priv, algo) {
  var x = priv.params.priv_key;
  var p = priv.params.p;
  var q = priv.params.q;
  var g = priv.params.g;
  var r = new BN(0);
  var k;
  var H = bits2int(hash, q).mod(q);
  var s = false;
  var kv = getKey(x, q, hash, algo);
  while (s === false) {
    k = makeKey(q, kv, algo);
    r = makeR(g, k, p, q);
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
    if (s.cmpn(0) === 0) {
      s = false;
      r = new BN(0);
    }
  }
  return toDER(r, s);
}

function toDER(r, s) {
  r = r.toArray();
  s = s.toArray();

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r);
  if (s[0] & 0x80) s = [0].concat(s);

  var total = r.length + s.length + 4;
  var res = [0x30, total, 0x02, r.length];
  res = res.concat(r, [0x02, s.length], s);
  return new Buffer(res);
}

function getKey(x, q, hash, algo) {
  x = new Buffer(x.toArray());
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length);
    zeros.fill(0);
    x = Buffer.concat([zeros, x]);
  }
  var hlen = hash.length;
  var hbits = bits2octets(hash, q);
  var v = new Buffer(hlen);
  v.fill(1);
  var k = new Buffer(hlen);
  k.fill(0);
  k = createHmac(algo, k).update(v).update(new Buffer([0])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  k = createHmac(algo, k).update(v).update(new Buffer([1])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  return { k: k, v: v };
}

function bits2int(obits, q) {
  var bits = new BN(obits);
  var shift = (obits.length << 3) - q.bitLength();
  if (shift > 0) bits.ishrn(shift);
  return bits;
}

function bits2octets(bits, q) {
  bits = bits2int(bits, q);
  bits = bits.mod(q);
  var out = new Buffer(bits.toArray());
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length);
    zeros.fill(0);
    out = Buffer.concat([zeros, out]);
  }
  return out;
}

function makeKey(q, kv, algo) {
  var t;
  var k;

  do {
    t = new Buffer(0);

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
      t = Buffer.concat([t, kv.v]);
    }

    k = bits2int(t, q);
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([0])).digest();
    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
  } while (k.cmp(q) !== -1);

  return k;
}

function makeR(g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}

module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

/***/ }),

/***/ "ps4E":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("63KW").Buffer;

var asn1 = __webpack_require__("KDHK");
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([header, content]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8) {
    lenOctets++;
  }var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8) {
    header[i] = j & 0xff;
  }return this._createEncoderBuffer([header, content]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([str.unused | 0, str.data]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' + 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' + 'only latin upper and lower case letters, ' + 'digits, space, apostrophe, left and rigth ' + 'parenthesis, plus sign, comma, hyphen, ' + 'dot, slash, colon, equal sign, ' + 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values) return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++) {
      id[i] |= 0;
    }
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++) {
      id[i] |= 0;
    }
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' + 'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7) {
      size++;
    }
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0) {
      objid[offset--] = 0x80 | ident & 0x7f;
    }
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10) return '0' + num;else return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [two(date.getFullYear()), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), 'Z'].join('');
  } else if (tag === 'utctime') {
    str = [two(date.getFullYear() % 100), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), 'Z'].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values) return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0) size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0) out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80) return this._createEncoderBuffer(num);

  if (num < 0x100) return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8) {
    size++;
  }var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if (out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function') entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null) return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length) return false;

  for (i = 0; i < data.length; i++) {
    if (data[i] !== state.defaultBuffer[i]) return false;
  }return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof') tag = 'seq';else if (tag === 'setof') tag = 'set';

  if (der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;else return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive) res |= 0x20;

  res |= der.tagClassByName[cls || 'universal'] << 6;

  return res;
}

/***/ }),

/***/ "rOku":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

function oldBrowser() {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var Buffer = __webpack_require__("X3l8").Buffer;
var crypto = global.crypto || global.msCrypto;

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes;
} else {
  module.exports = oldBrowser;
}

function randomBytes(size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes');
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size);

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {
    // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes);
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer);

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes);
    });
  }

  return bytes;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "reGU":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");

var asn1 = __webpack_require__("KDHK");
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer)) data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty()) return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag)) return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag)) return decodedTag;

  var len = derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len)) return len;

  if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res)) return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag)) return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len)) return len;

    var res;
    if (tag.primitive || len !== null) res = buffer.skip(len);else res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res)) return res;

    if (tag.tagStr === 'end') break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd)) return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd) break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused)) return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' + 'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' + 'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80) identifiers.push(ident);

  var first = identifiers[0] / 40 | 0;
  var second = identifiers[0] % 40;

  if (relative) result = identifiers;else result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined) tmp = values[result.join('.')];
    if (tmp !== undefined) result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70) year = 2000 + year;else year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res)) return res;else return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values) res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function') entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag)) return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct)) return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len)) return len;

  // Indefinite form
  if (!primitive && len === 0x80) return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4) return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j)) return j;
    len |= j;
  }

  return len;
}

/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),

/***/ "tRuz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__("B6Bn");
curve.short = __webpack_require__("wrMp");
curve.mont = __webpack_require__("pS+P");
curve.edwards = __webpack_require__("24Y6");

/***/ }),

/***/ "tXf9":
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__("bSQl");
var deciphers = __webpack_require__("+jDU");
var modes = __webpack_require__("6ZSt");

function getCiphers() {
  return Object.keys(modes);
}

exports.createCipher = exports.Cipher = ciphers.createCipher;
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv;
exports.createDecipher = exports.Decipher = deciphers.createDecipher;
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

/***/ }),

/***/ "tpuU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg)) return msg.slice();
  if (!msg) return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++) {
      res[i] = msg[i] | 0;
    }return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0) msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2) {
      res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi) res.push(hi, lo);else res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1) return '0' + word;else return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    res += zero2(msg[i].toString(16));
  }return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex') return toHex(arr);else return arr;
};

/***/ }),

/***/ "txgm":
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r) r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes) return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++) {
    res[i] = this.rand.getByte();
  }return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

    // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function () {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(3);
    if (typeof crypto.randomBytes !== 'function') throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {}
}

/***/ }),

/***/ "uXl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("EBst");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ "vWx2":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("63KW").Buffer;

var DERDecoder = __webpack_require__("reGU");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null) continue;

    if (match[2] !== label) continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN') break;
      start = i;
    } else {
      if (match[1] !== 'END') break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

/***/ }),

/***/ "vugd":
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__("3UtB").Reporter;
var EncoderBuffer = __webpack_require__("3UtB").EncoderBuffer;
var DecoderBuffer = __webpack_require__("3UtB").DecoderBuffer;
var assert = __webpack_require__("08Lv");

// Supported tags
var tags = ['seq', 'seqof', 'set', 'setof', 'objid', 'bool', 'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc', 'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str', 'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'];

// Public methods list
var methods = ['key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice', 'any', 'contains'].concat(tags);

// Overrided methods list
var overrided = ['_peekTag', '_decodeTag', '_use', '_decodeStr', '_decodeObjid', '_decodeTime', '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList', '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime', '_encodeNull', '_encodeInt', '_encodeBool'];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = ['enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice', 'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit', 'implicit', 'contains'];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function (prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function (method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function (child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function (arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function (arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function (child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function (arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object) return arg;

      var res = {};
      Object.keys(arg).forEach(function (key) {
        if (key == (key | 0)) key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function (method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function (tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0) this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function (key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null) prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null) tag = state.explicit;else if (state.implicit !== null) tag = state.implicit;else if (state.tag !== null) tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null) this._decodeGeneric(state.tag, input, options);else this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present)) return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present) prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit)) return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any) var save = input.save();
      var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
      if (input.isError(body)) return body;

      if (state.any) result = input.raw(save);else input = body;
    }

    if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) result = result;else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);else result = this._decodeChoice(input, options);

    if (input.isError(result)) return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present) result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);else if (prevKey !== null) input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set') return null;
  if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);else if (tag === 'objid') return this._decodeObjid(input, null, null, options);else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);else if (tag === 'null_') return this._decodeNull(input, options);else if (tag === 'bool') return this._decodeBool(input, options);else if (tag === 'objDesc') return this._decodeStr(input, tag, options);else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function (key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value)) return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match) return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data) return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined) return;

  if (this._skipDefault(result, reporter, parent)) return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null) data = state['default'];else return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function (child) {
      if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);

      if (child._baseState.key === null) return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function (child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function (item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null) reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag)) return this._encodeStr(data, tag);else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);else if (tag === 'objid') return this._encodeObjid(data, null, null);else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);else if (tag === 'null_') return this._encodeNull();else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);else if (tag === 'bool') return this._encodeBool(data);else if (tag === 'objDesc') return this._encodeStr(data, tag);else throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return (/^[0-9 ]*$/.test(str)
  );
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return (/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str)
  );
};

/***/ }),

/***/ "vzCy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function () {

  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }var doError = type === 'error';

  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0) er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined) return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) {
    args.push(arguments[i]);
  }if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = this._events;
  if (events === undefined) return this;

  list = events[type];
  if (list === undefined) return this;

  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }

    if (list.length === 1) events[type] = list[0];

    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;

  events = this._events;
  if (events === undefined) return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }

  return this;
};

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined) return [];

  var evlistener = events[type];
  if (evlistener === undefined) return [];

  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

/***/ }),

/***/ "wrMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__("tRuz");
var elliptic = __webpack_require__("lZ6o");
var BN = __webpack_require__("geuY");
var inherits = __webpack_require__("LC74");
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function (vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [l1, l2];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [{ a: a1, b: b1 }, { a: a2, b: b2 }];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red) x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd) y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf) return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo) return;

  var pre = this.precomputed;
  if (pre && pre.beta) return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function endoMul(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed) return [this.x, this.y];

  return [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string') obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2]) return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [res].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [res].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity()) return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf) return p;

  // P + O = P
  if (p.inf) return this;

  // P + P = 2P
  if (this.eq(p)) return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p)) return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf) return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0) return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);else if (this.curve.endo) return this.curve._endoWnafMulAdd([this], [k]);else return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [this, p2];
  var coeffs = [k1, k2];
  if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [this, p2];
  var coeffs = [k1, k2];
  if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf) return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function negate(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf) return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red) this.x = this.x.toRed(this.curve.red);
  if (!this.y.red) this.y = this.y.toRed(this.curve.red);
  if (!this.z.red) this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity()) return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity()) return p;

  // P + O = P
  if (p.isInfinity()) return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity()) return p.toJ();

  // P + O = P
  if (p.isInfinity()) return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);else return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0) return this;
  if (this.isInfinity()) return this;
  if (!pow) return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++) {
      r = r.dbl();
    }return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow) jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity()) return this;

  if (this.curve.zeroA) return this._zeroDbl();else if (this.curve.threeA) return this._threeDbl();else return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA) return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine') return this.eq(p.toJ());

  if (this === p) return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0) return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0) return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0) return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity()) return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

/***/ }),

/***/ "x0Ha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "yDvu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__("X3l8").Buffer;
var Transform = __webpack_require__("9DG0").Transform;
var inherits = __webpack_require__("LC74");

function throwIfNotStringOrBuffer(val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer');
  }
}

function HashBase(blockSize) {
  Transform.call(this);

  this._block = Buffer.allocUnsafe(blockSize);
  this._blockSize = blockSize;
  this._blockOffset = 0;
  this._length = [0, 0, 0, 0];

  this._finalized = false;
}

inherits(HashBase, Transform);

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null;
  try {
    this.update(chunk, encoding);
  } catch (err) {
    error = err;
  }

  callback(error);
};

HashBase.prototype._flush = function (callback) {
  var error = null;
  try {
    this.push(this.digest());
  } catch (err) {
    error = err;
  }

  callback(error);
};

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data');
  if (this._finalized) throw new Error('Digest already called');
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

  // consume data
  var block = this._block;
  var offset = 0;
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) {
      block[i++] = data[offset++];
    }this._update();
    this._blockOffset = 0;
  }
  while (offset < data.length) {
    block[this._blockOffset++] = data[offset++];
  } // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry;
    carry = this._length[j] / 0x0100000000 | 0;
    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
  }

  return this;
};

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented');
};

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called');
  this._finalized = true;

  var digest = this._digest();
  if (encoding !== undefined) digest = digest.toString(encoding);

  // reset state
  this._block.fill(0);
  this._blockOffset = 0;
  for (var i = 0; i < 4; ++i) {
    this._length[i] = 0;
  }return digest;
};

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented');
};

module.exports = HashBase;

/***/ }),

/***/ "yMmo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("geuY");
var elliptic = __webpack_require__("lZ6o");
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv) this._importPrivate(options.priv, options.privEnc);
  if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair) return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair) return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity()) return { result: false, reason: 'Invalid public key' };
  if (!pub.validate()) return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity()) return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub) this.pub = this.ec.g.mul(this.priv);

  if (!enc) return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex') return this.priv.toString(16, 2);else return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

/***/ }),

/***/ "ypnx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
    case 0:
    case 1:
      return process.nextTick(fn);
    case 2:
      return process.nextTick(function afterTickOne() {
        fn.call(null, arg1);
      });
    case 3:
      return process.nextTick(function afterTickTwo() {
        fn.call(null, arg1, arg2);
      });
    case 4:
      return process.nextTick(function afterTickThree() {
        fn.call(null, arg1, arg2, arg3);
      });
    default:
      args = new Array(len - 1);
      i = 0;
      while (i < args.length) {
        args[i++] = arguments[i];
      }
      return process.nextTick(function afterTick() {
        fn.apply(null, args);
      });
  }
}

/***/ }),

/***/ "z+8S":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer;
var Transform = __webpack_require__("9DG0").Transform;
var StringDecoder = __webpack_require__("X4X3").StringDecoder;
var inherits = __webpack_require__("LC74");

function CipherBase(hashMode) {
  Transform.call(this);
  this.hashMode = typeof hashMode === 'string';
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest;
  } else {
    this.final = this._finalOrDigest;
  }
  if (this._final) {
    this.__final = this._final;
    this._final = null;
  }
  this._decoder = null;
  this._encoding = null;
}
inherits(CipherBase, Transform);

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc);
  }

  var outData = this._update(data);
  if (this.hashMode) return this;

  if (outputEnc) {
    outData = this._toString(outData, outputEnc);
  }

  return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
  var err;
  try {
    if (this.hashMode) {
      this._update(data);
    } else {
      this.push(this._update(data));
    }
  } catch (e) {
    err = e;
  } finally {
    next(err);
  }
};
CipherBase.prototype._flush = function (done) {
  var err;
  try {
    this.push(this.__final());
  } catch (e) {
    err = e;
  }

  done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0);
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true);
  }
  return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc);
    this._encoding = enc;
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings');

  var out = this._decoder.write(value);
  if (fin) {
    out += this._decoder.end();
  }

  return out;
};

module.exports = CipherBase;

/***/ }),

/***/ "zOO0":
/***/ (function(module, exports) {

module.exports = function xor(a, b) {
  var len = a.length;
  var i = -1;
  while (++i < len) {
    a[i] ^= b[i];
  }
  return a;
};

/***/ }),

/***/ "zvjZ":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("LC74");
var Hash = __webpack_require__("CzQx");
var Buffer = __webpack_require__("X3l8").Buffer;

var K = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];

var W = new Array(64);

function Sha256() {
  this.init();

  this._w = W; // new Array(64)

  Hash.call(this, 64, 56);
}

inherits(Sha256, Hash);

Sha256.prototype.init = function () {
  this._a = 0x6a09e667;
  this._b = 0xbb67ae85;
  this._c = 0x3c6ef372;
  this._d = 0xa54ff53a;
  this._e = 0x510e527f;
  this._f = 0x9b05688c;
  this._g = 0x1f83d9ab;
  this._h = 0x5be0cd19;

  return this;
};

function ch(x, y, z) {
  return z ^ x & (y ^ z);
}

function maj(x, y, z) {
  return x & y | z & (x | y);
}

function sigma0(x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}

function sigma1(x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}

function gamma0(x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}

function gamma1(x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}

Sha256.prototype._update = function (M) {
  var W = this._w;

  var a = this._a | 0;
  var b = this._b | 0;
  var c = this._c | 0;
  var d = this._d | 0;
  var e = this._e | 0;
  var f = this._f | 0;
  var g = this._g | 0;
  var h = this._h | 0;

  for (var i = 0; i < 16; ++i) {
    W[i] = M.readInt32BE(i * 4);
  }for (; i < 64; ++i) {
    W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
  }for (var j = 0; j < 64; ++j) {
    var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
    var T2 = sigma0(a) + maj(a, b, c) | 0;

    h = g;
    g = f;
    f = e;
    e = d + T1 | 0;
    d = c;
    c = b;
    b = a;
    a = T1 + T2 | 0;
  }

  this._a = a + this._a | 0;
  this._b = b + this._b | 0;
  this._c = c + this._c | 0;
  this._d = d + this._d | 0;
  this._e = e + this._e | 0;
  this._f = f + this._f | 0;
  this._g = g + this._g | 0;
  this._h = h + this._h | 0;
};

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32);

  H.writeInt32BE(this._a, 0);
  H.writeInt32BE(this._b, 4);
  H.writeInt32BE(this._c, 8);
  H.writeInt32BE(this._d, 12);
  H.writeInt32BE(this._e, 16);
  H.writeInt32BE(this._f, 20);
  H.writeInt32BE(this._g, 24);
  H.writeInt32BE(this._h, 28);

  return H;
};

module.exports = Sha256;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.ea105.js